
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefd83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefd83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("lU2dr", function(module, exports) {
module.exports = import("9Eg7W").then(()=>parcelRequire('hUwZG'));

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $f48ef6896881c1e3$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $f48ef6896881c1e3$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $f48ef6896881c1e3$var$__typeError("Cannot " + msg);
var $f48ef6896881c1e3$export$18a094aefa070634 = (obj, member, getter)=>($f48ef6896881c1e3$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $f48ef6896881c1e3$export$addf369becd23283 = (obj, member, value1)=>member.has(obj) ? $f48ef6896881c1e3$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
var $f48ef6896881c1e3$export$42432efe6614d3b4 = (obj, member, value1, setter)=>($f48ef6896881c1e3$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value1) : member.set(obj, value1), value1);
var $f48ef6896881c1e3$export$fa92d15b718fce20 = (obj, member, method)=>($f48ef6896881c1e3$var$__accessCheck(obj, member, "access private method"), method);
var $f48ef6896881c1e3$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $f48ef6896881c1e3$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $f48ef6896881c1e3$export$18a094aefa070634(obj, member, getter);
        }
    });




// src/timeoutManager.ts
var $f91dfb6f728f333f$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $f91dfb6f728f333f$var$_provider, $f91dfb6f728f333f$var$_providerCalled;
var $f91dfb6f728f333f$export$6336d90323f0ab52 = class {
    constructor(){
        // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
        // type at app boot; and if we leave that type, then any new timer provider
        // would need to support ReturnType<typeof setTimeout>, which is infeasible.
        //
        // We settle for type safety for the TimeoutProvider type, and accept that
        // this class is unsafe internally to allow for extension.
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f91dfb6f728f333f$var$_provider, $f91dfb6f728f333f$export$d235812f9125bf47);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f91dfb6f728f333f$var$_providerCalled, false);
    }
    setTimeoutProvider(provider) {
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f91dfb6f728f333f$var$_provider, provider);
    }
    setTimeout(callback, delay) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f91dfb6f728f333f$var$_provider).setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f91dfb6f728f333f$var$_provider).clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f91dfb6f728f333f$var$_provider).setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f91dfb6f728f333f$var$_provider).clearInterval(intervalId);
    }
};
$f91dfb6f728f333f$var$_provider = new WeakMap();
$f91dfb6f728f333f$var$_providerCalled = new WeakMap();
var $f91dfb6f728f333f$export$94a2700736e69372 = new $f91dfb6f728f333f$export$6336d90323f0ab52();
function $f91dfb6f728f333f$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


var $002159551d1c4551$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $002159551d1c4551$export$8793edee2d425525() {}
function $002159551d1c4551$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $002159551d1c4551$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $002159551d1c4551$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $002159551d1c4551$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $002159551d1c4551$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $002159551d1c4551$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $002159551d1c4551$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($002159551d1c4551$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $002159551d1c4551$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $002159551d1c4551$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $002159551d1c4551$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$002159551d1c4551$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $002159551d1c4551$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$002159551d1c4551$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
var $002159551d1c4551$var$hasOwn = Object.prototype.hasOwnProperty;
function $002159551d1c4551$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $002159551d1c4551$export$7a8558113332b71e(a) && $002159551d1c4551$export$7a8558113332b71e(b);
    if (!array && !($002159551d1c4551$export$53b83ca8eaab0383(a) && $002159551d1c4551$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $002159551d1c4551$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $002159551d1c4551$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $002159551d1c4551$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $002159551d1c4551$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $002159551d1c4551$export$53b83ca8eaab0383(o) {
    if (!$002159551d1c4551$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$002159551d1c4551$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $002159551d1c4551$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $002159551d1c4551$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $f91dfb6f728f333f$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
function $002159551d1c4551$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $002159551d1c4551$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $002159551d1c4551$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $002159551d1c4551$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $002159551d1c4551$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $002159551d1c4551$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol();
function $002159551d1c4551$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $002159551d1c4551$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $002159551d1c4551$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function $002159551d1c4551$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ?? (signal = getSignal());
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}








var $798266f99c432533$export$7c76da44185e6090 = (0, $f91dfb6f728f333f$export$5086591e51e32a18);
function $798266f99c432533$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $798266f99c432533$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $798266f99c432533$export$520687f44db6e1ab = $798266f99c432533$export$316a8efd03cd1458();





// src/subscribable.ts
var $46c0846a49a6d58e$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $1d15693d13279fb4$var$_focused, $1d15693d13279fb4$var$_cleanup, $1d15693d13279fb4$var$_setup;
var $1d15693d13279fb4$export$86f1af424b2ca4de = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $1d15693d13279fb4$var$_focused);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $1d15693d13279fb4$var$_cleanup);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $1d15693d13279fb4$var$_setup);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_setup, (onFocus)=>{
            if (!(0, $002159551d1c4551$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) this.setEventListener((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_setup, setup);
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused) !== focused;
        if (changed) {
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused) === "boolean") return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$1d15693d13279fb4$var$_focused = new WeakMap();
$1d15693d13279fb4$var$_cleanup = new WeakMap();
$1d15693d13279fb4$var$_setup = new WeakMap();
var $1d15693d13279fb4$export$6bf54661be5b02cf = new $1d15693d13279fb4$export$86f1af424b2ca4de();





var $9606ae1cfceeea19$var$_online, $9606ae1cfceeea19$var$_cleanup, $9606ae1cfceeea19$var$_setup;
var $9606ae1cfceeea19$export$58774fb55d5ff7fc = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_online, true);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_cleanup);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_setup);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_setup, (onOnline)=>{
            if (!(0, $002159551d1c4551$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) this.setEventListener((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_setup, setup);
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_online) !== online;
        if (changed) {
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_online);
    }
};
$9606ae1cfceeea19$var$_online = new WeakMap();
$9606ae1cfceeea19$var$_cleanup = new WeakMap();
$9606ae1cfceeea19$var$_setup = new WeakMap();
var $9606ae1cfceeea19$export$b113e788b2dd3fdc = new $9606ae1cfceeea19$export$58774fb55d5ff7fc();




function $5a619d4c2df9bf12$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $5a619d4c2df9bf12$export$216296c47a9d1275(promise) {
    var _a;
    let data;
    (_a = promise.then((result)=>{
        data = result;
        return result;
    }, (0, $002159551d1c4551$export$8793edee2d425525))) == null || _a.catch((0, $002159551d1c4551$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}



function $e19f6352d48643a1$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $e19f6352d48643a1$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline() : true;
}
var $e19f6352d48643a1$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $e19f6352d48643a1$export$986cc6445c1d323(value) {
    return value instanceof $e19f6352d48643a1$export$a8430ed4188f35a9;
}
function $e19f6352d48643a1$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $5a619d4c2df9bf12$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved()) {
            const error = new $e19f6352d48643a1$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_a = config.onCancel) == null || _a.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $1d15693d13279fb4$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$e19f6352d48643a1$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved()) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $002159551d1c4551$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $e19f6352d48643a1$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $002159551d1c4551$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}





var $1cb0c2534af8594c$var$_gcTimeout;
var $1cb0c2534af8594c$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $1cb0c2534af8594c$var$_gcTimeout);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $002159551d1c4551$export$e539f754e934e270)(this.gcTime)) (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1cb0c2534af8594c$var$_gcTimeout, (0, $f91dfb6f728f333f$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $002159551d1c4551$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1cb0c2534af8594c$var$_gcTimeout)) {
            (0, $f91dfb6f728f333f$export$94a2700736e69372).clearTimeout((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1cb0c2534af8594c$var$_gcTimeout));
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1cb0c2534af8594c$var$_gcTimeout, void 0);
        }
    }
};
$1cb0c2534af8594c$var$_gcTimeout = new WeakMap();


var $9dc680c629ca4c63$var$_initialState, $9dc680c629ca4c63$var$_revertState, $9dc680c629ca4c63$var$_cache, $9dc680c629ca4c63$var$_client, $9dc680c629ca4c63$var$_retryer, $9dc680c629ca4c63$var$_defaultOptions, $9dc680c629ca4c63$var$_abortSignalConsumed, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn;
var $9dc680c629ca4c63$export$62297b13309008b2 = class extends (0, $1cb0c2534af8594c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_Query_instances);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_initialState);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_revertState);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_cache);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_client);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_retryer);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_defaultOptions);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_abortSignalConsumed);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_client, config.client);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_cache, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_initialState, $9dc680c629ca4c63$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $9dc680c629ca4c63$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($9dc680c629ca4c63$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_initialState, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $002159551d1c4551$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $002159551d1c4551$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $002159551d1c4551$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $002159551d1c4551$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $002159551d1c4551$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) {
                    if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_abortSignalConsumed)) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) {
                (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).continueRetry();
                return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $002159551d1c4551$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_client),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_retryer, (0, $e19f6352d48643a1$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $e19f6352d48643a1$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_revertState),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            const data = await (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_f = (_e = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSuccess) == null || _f.call(_e, data, this);
            (_h = (_g = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _h.call(_g, data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $e19f6352d48643a1$export$a8430ed4188f35a9)) {
                if (error.silent) return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            (_j = (_i = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onError) == null || _j.call(_i, error, this);
            (_l = (_k = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _l.call(_k, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
};
$9dc680c629ca4c63$var$_initialState = new WeakMap();
$9dc680c629ca4c63$var$_revertState = new WeakMap();
$9dc680c629ca4c63$var$_cache = new WeakMap();
$9dc680c629ca4c63$var$_client = new WeakMap();
$9dc680c629ca4c63$var$_retryer = new WeakMap();
$9dc680c629ca4c63$var$_defaultOptions = new WeakMap();
$9dc680c629ca4c63$var$_abortSignalConsumed = new WeakMap();
$9dc680c629ca4c63$var$_Query_instances = new WeakSet();
$9dc680c629ca4c63$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$9dc680c629ca4c63$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    ...$9dc680c629ca4c63$var$successState(action.data, action.dataUpdatedAt),
                    dataUpdateCount: state.dataUpdateCount + 1,
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error",
                    // flag existing data as invalidated if we get a background error
                    // note that "no data" always means stale so we can set unconditionally here
                    isInvalidated: true
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $9dc680c629ca4c63$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $e19f6352d48643a1$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $9dc680c629ca4c63$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $9dc680c629ca4c63$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $c3b25629722ddda6$var$_queries;
var $c3b25629722ddda6$export$5dde0cd941da8468 = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $c3b25629722ddda6$var$_queries);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $c3b25629722ddda6$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $002159551d1c4551$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $9dc680c629ca4c63$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).has(query.queryHash)) {
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $002159551d1c4551$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $002159551d1c4551$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$c3b25629722ddda6$var$_queries = new WeakMap();








var $96f19558542b246f$var$_client, $96f19558542b246f$var$_observers, $96f19558542b246f$var$_mutationCache, $96f19558542b246f$var$_retryer, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn;
var $96f19558542b246f$export$17b8b19c814bcf56 = class extends (0, $1cb0c2534af8594c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_Mutation_instances);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_client);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_observers);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_mutationCache);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_retryer);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_client, config.client);
        this.mutationId = config.mutationId;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_mutationCache, config.mutationCache);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_observers, []);
        this.state = config.state || $96f19558542b246f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).includes(observer)) {
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_observers, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
        const onContinue = ()=>{
            (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_client),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_retryer, (0, $e19f6352d48643a1$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer).canStart();
        try {
            if (restored) onContinue();
            else {
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config.onMutate) await (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config.onMutate(variables, this, mutationFnContext);
                const context = await ((_b = (_a = this.options).onMutate) == null ? void 0 : _b.call(_a, variables, mutationFnContext));
                if (context !== this.state.context) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer).start();
            await ((_d = (_c = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSuccess) == null ? void 0 : _d.call(_c, data, variables, this.state.context, this, mutationFnContext));
            await ((_f = (_e = this.options).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, mutationFnContext));
            await ((_h = (_g = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _h.call(_g, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_j = (_i = this.options).onSettled) == null ? void 0 : _j.call(_i, data, null, variables, this.state.context, mutationFnContext));
            (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_l = (_k = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onError) == null ? void 0 : _l.call(_k, error, variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await ((_n = (_m = this.options).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await ((_p = (_o = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _p.call(_o, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await ((_r = (_q = this.options).onSettled) == null ? void 0 : _r.call(_q, void 0, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            throw error;
        } finally{
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).runNext(this);
        }
    }
};
$96f19558542b246f$var$_client = new WeakMap();
$96f19558542b246f$var$_observers = new WeakMap();
$96f19558542b246f$var$_mutationCache = new WeakMap();
$96f19558542b246f$var$_retryer = new WeakMap();
$96f19558542b246f$var$_Mutation_instances = new WeakSet();
$96f19558542b246f$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $96f19558542b246f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $faef27284cfa645e$var$_mutations, $faef27284cfa645e$var$_scopes, $faef27284cfa645e$var$_mutationId;
var $faef27284cfa645e$export$1fcfd9a244434844 = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $faef27284cfa645e$var$_mutations);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $faef27284cfa645e$var$_scopes);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $faef27284cfa645e$var$_mutationId);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_mutations, /* @__PURE__ */ new Set());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_scopes, /* @__PURE__ */ new Map());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $96f19558542b246f$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: ++(0, $f48ef6896881c1e3$export$b1fe7cbb4502036b)(this, $faef27284cfa645e$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).add(mutation);
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).delete(mutation)) {
            const scope = $faef27284cfa645e$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        var _a;
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope)) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).clear();
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $002159551d1c4551$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $002159551d1c4551$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $002159551d1c4551$export$8793edee2d425525)))));
    }
};
$faef27284cfa645e$var$_mutations = new WeakMap();
$faef27284cfa645e$var$_scopes = new WeakMap();
$faef27284cfa645e$var$_mutationId = new WeakMap();
function $faef27284cfa645e$var$scopeFor(mutation) {
    var _a;
    return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}







function $45a641ae9a292711$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $002159551d1c4551$export$83f813cd1f8a4973)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $002159551d1c4551$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $002159551d1c4551$export$8c6246b73dd61f4a) : (0, $002159551d1c4551$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $45a641ae9a292711$var$getPreviousPageParam : $45a641ae9a292711$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $45a641ae9a292711$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $45a641ae9a292711$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $45a641ae9a292711$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $45a641ae9a292711$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $45a641ae9a292711$var$getNextPageParam(options, data) != null;
}
function $45a641ae9a292711$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $45a641ae9a292711$var$getPreviousPageParam(options, data) != null;
}


var $f71a9ec256bb1e8c$var$_queryCache, $f71a9ec256bb1e8c$var$_mutationCache, $f71a9ec256bb1e8c$var$_defaultOptions, $f71a9ec256bb1e8c$var$_queryDefaults, $f71a9ec256bb1e8c$var$_mutationDefaults, $f71a9ec256bb1e8c$var$_mountCount, $f71a9ec256bb1e8c$var$_unsubscribeFocus, $f71a9ec256bb1e8c$var$_unsubscribeOnline;
var $f71a9ec256bb1e8c$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_queryCache);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mutationCache);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_defaultOptions);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_queryDefaults);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mutationDefaults);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mountCount);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_queryCache, config.queryCache || new (0, $c3b25629722ddda6$export$5dde0cd941da8468)());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mutationCache, config.mutationCache || new (0, $faef27284cfa645e$export$1fcfd9a244434844)());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_defaultOptions, config.defaultOptions || {});
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mountCount, 0);
    }
    mount() {
        (0, $f48ef6896881c1e3$export$b1fe7cbb4502036b)(this, $f71a9ec256bb1e8c$var$_mountCount)._++;
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 1) return;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, (0, $1d15693d13279fb4$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).onFocus();
            }
        }));
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $f48ef6896881c1e3$export$b1fe7cbb4502036b)(this, $f71a9ec256bb1e8c$var$_mountCount)._--;
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 0) return;
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, void 0);
        (_b = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $002159551d1c4551$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $002159551d1c4551$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $002159551d1c4551$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $45a641ae9a292711$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $45a641ae9a292711$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline()) return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
    }
    getMutationCache() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryDefaults).set((0, $002159551d1c4551$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $002159551d1c4551$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).set((0, $002159551d1c4551$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $002159551d1c4551$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $002159551d1c4551$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $002159551d1c4551$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).clear();
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).clear();
    }
};
$f71a9ec256bb1e8c$var$_queryCache = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationCache = new WeakMap();
$f71a9ec256bb1e8c$var$_defaultOptions = new WeakMap();
$f71a9ec256bb1e8c$var$_queryDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mountCount = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeFocus = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeOnline = new WeakMap();


var $acw62 = parcelRequire("acw62");

"use client";
var $aeeeb04cd6721116$export$da112d31b0149f31 = $acw62.createContext(void 0);
var $aeeeb04cd6721116$export$22e77b9572c4fded = (queryClient)=>{
    const client = $acw62.useContext($aeeeb04cd6721116$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $aeeeb04cd6721116$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($aeeeb04cd6721116$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


"use client";
function $f78c06b0b10efbae$export$625b2ff71316bcd3(filters, queryClient) {
    const client = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)(queryClient);
    const queryCache = client.getQueryCache();
    return $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>queryCache.subscribe((0, $798266f99c432533$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        queryCache
    ]), ()=>client.isFetching(filters), ()=>client.isFetching(filters));
}




var $acw62 = parcelRequire("acw62");

const $b44d252db018a0f5$var$menuLogo = "/objektvote-menu-logo.png";
const $b44d252db018a0f5$var$items = [
    {
        to: "/",
        label: "Dashboard",
        icon: "dashboard"
    },
    {
        to: "/resolutions",
        label: "Umlaufbeschl\xfcsse",
        icon: "resolutions"
    },
    {
        to: "/analog-scan",
        label: "QR Erfassung",
        icon: "scan"
    },
    {
        to: "/objects",
        label: "Objekte",
        icon: "objects"
    },
    {
        to: "/units",
        label: "Einheiten",
        icon: "units"
    },
    {
        to: "/owners",
        label: "Eigent\xfcmer",
        icon: "owners"
    },
    {
        to: "/assignments",
        label: "Zuordnungen",
        icon: "assignments"
    },
    {
        to: "/imports",
        label: "Datenabgleich | Import",
        icon: "imports"
    },
    {
        to: "/templates",
        label: "Vorlagen",
        icon: "templates"
    },
    {
        to: "/settings",
        label: "Einstellungen",
        icon: "settings"
    },
    {
        to: "/admin-users",
        label: "Benutzer & Rechte",
        icon: "users"
    },
    {
        to: "/platform-tenants",
        label: "SaaS-Mandanten",
        icon: "platform"
    },
    {
        to: "/audit",
        label: "Protokolle",
        icon: "audit"
    },
    {
        to: "/debug",
        label: "Debug",
        icon: "debug"
    }
];
const $b44d252db018a0f5$var$NavIcon = ({ icon: icon })=>{
    if (icon === "dashboard") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.5 10.2 12 4.5l7.5 5.7v8.8H14v-5.1h-4v5.1H4.5v-8.8Z",
            stroke: "currentColor",
            strokeWidth: "1.9",
            strokeLinejoin: "round"
        })
    });
    if (icon === "objects") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.9 8.2h14.2v10.9H4.9z",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (icon === "units") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.1",
                y: "4.8",
                width: "13.8",
                height: "14.8",
                rx: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.85"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.2 19.6v-2.9h5.6v2.9",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (icon === "owners") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9.1",
                cy: "9.1",
                r: "2.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "15.8",
                cy: "8.4",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (icon === "assignments") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "6.2",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "16.8",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.4 7.2h7.2M7.9 8.8l7.4 6.4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (icon === "resolutions") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.1 4.6h6.6l3.2 3.2v11.6H7.1z",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.7 4.8v3.1h3",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m9.4 14.1 2 2 4.2-5",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.7",
                cy: "17.8",
                r: "2.1",
                fill: "#fff",
                stroke: "currentColor",
                strokeWidth: "1.85"
            })
        ]
    });
    if (icon === "imports") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 5.3v8.8",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m8.8 11 3.2 3.2 3.2-3.2",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4.8",
                y: "15.8",
                width: "14.4",
                height: "3.8",
                rx: "1.4",
                stroke: "currentColor",
                strokeWidth: "1.8"
            })
        ]
    });
    if (icon === "scan") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.4",
                y: "5.4",
                width: "4.4",
                height: "4.4",
                rx: "0.7",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "14.2",
                y: "5.4",
                width: "4.4",
                height: "4.4",
                rx: "0.7",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.4",
                y: "14.2",
                width: "4.4",
                height: "4.4",
                rx: "0.7",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.2 14.2h2.2v2.2h-2.2zM17.4 14.2h1.2M14.2 17.4h1.2M17 17h1.6v1.6H17z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinejoin: "round",
                strokeLinecap: "round"
            })
        ]
    });
    if (icon === "audit") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.2 19.2h13.6M7.2 19.2V11M12 19.2V7.8M16.8 19.2v-5.4",
            stroke: "currentColor",
            strokeWidth: "1.8",
            strokeLinecap: "round"
        })
    });
    if (icon === "debug") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 2 5 13h6l-1 9 9-13h-6l1-7Z",
            stroke: "currentColor",
            strokeWidth: "1.8",
            strokeLinejoin: "round",
            strokeLinecap: "round"
        })
    });
    if (icon === "templates") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.8 8a1.8 1.8 0 0 1 1.8-1.8h4.2l1.5 1.7h5.1A1.8 1.8 0 0 1 19.2 9v8.2a1.8 1.8 0 0 1-1.8 1.8H6.6a1.8 1.8 0 0 1-1.8-1.8V8Z",
            stroke: "currentColor",
            strokeWidth: "1.8",
            strokeLinejoin: "round"
        })
    });
    if (icon === "settings") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 7h14M5 12h14M5 17h14",
                stroke: "currentColor",
                strokeWidth: "1.9",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9",
                cy: "7",
                r: "2",
                fill: "#fff",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "15",
                cy: "12",
                r: "2",
                fill: "#fff",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "11",
                cy: "17",
                r: "2",
                fill: "#fff",
                stroke: "currentColor",
                strokeWidth: "1.8"
            })
        ]
    });
    if (icon === "platform") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4",
                y: "5.2",
                width: "16",
                height: "11.6",
                rx: "2",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.2 19h5.6M12 16.8V19",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.2",
                y: "4.8",
                width: "13.6",
                height: "14.4",
                rx: "1.9",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.2 9.4h7.6M8.2 13h7.6M8.2 16.6h4.8",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
};
const $b44d252db018a0f5$var$groups = [
    {
        title: "\xdcbersicht",
        routes: [
            "/",
            "/resolutions",
            "/analog-scan"
        ]
    },
    {
        title: "Verwaltung",
        routes: [
            "/objects",
            "/units",
            "/owners",
            "/assignments"
        ]
    },
    {
        title: "Setup",
        routes: [
            "/imports",
            "/templates"
        ]
    },
    {
        title: "System",
        routes: [
            "/settings",
            "/admin-users",
            "/platform-tenants",
            "/audit",
            "/debug"
        ]
    }
];
const $b44d252db018a0f5$export$1ba59dacbcbf90fe = ({ mode: mode = "desktop", onNavigate: onNavigate, onClose: onClose, onLogout: onLogout, frameworkMode: frameworkMode = "classic", authUser: authUser, showPlatformMenu: showPlatformMenu = false, platformOnlyMode: platformOnlyMode = false, permissions: permissions })=>{
    const [accountMenuOpen, setAccountMenuOpen] = (0, $acw62.useState)(false);
    const [avatarLoadFailed, setAvatarLoadFailed] = (0, $acw62.useState)(false);
    const [accountHoverActive, setAccountHoverActive] = (0, $acw62.useState)(false);
    const year = new Date().getFullYear();
    const isMobile = mode === "mobile";
    const isFrameworkV2 = frameworkMode === "mockup_v2";
    const roleLabel = authUser?.permissionGroupName?.trim() ? authUser.permissionGroupName.trim() : authUser?.role === "superadmin" ? "Superadmin" : authUser?.role === "platform_admin" ? "Platform Admin" : authUser?.role === "platform_superadmin" ? "Platform Superadmin" : authUser?.role === "platform_ops" ? "Platform Ops" : authUser?.role === "sachbearbeitung" ? "Verwalter" : "Lesend";
    const initials = (0, $acw62.useMemo)(()=>{
        const source = String(authUser?.displayName ?? authUser?.username ?? "").trim();
        if (!source) return "--";
        const parts = source.split(/\s+/).filter(Boolean);
        if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
        return source.slice(0, 2).toUpperCase();
    }, [
        authUser?.displayName,
        authUser?.username
    ]);
    (0, $acw62.useEffect)(()=>{
        setAvatarLoadFailed(false);
    }, [
        authUser?.avatarUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!accountMenuOpen || accountHoverActive) return;
        const timeoutId = window.setTimeout(()=>setAccountMenuOpen(false), 5000);
        return ()=>window.clearTimeout(timeoutId);
    }, [
        accountMenuOpen,
        accountHoverActive
    ]);
    const visibleGroups = platformOnlyMode ? [
        {
            title: "Plattform",
            routes: [
                "/platform-tenants",
                "/admin-users",
                "/settings"
            ]
        }
    ] : $b44d252db018a0f5$var$groups;
    const routePermissionMap = {
        "/": "dashboard",
        "/resolutions": "resolutions",
        "/analog-scan": "qr_scan",
        "/objects": "objects",
        "/units": "units",
        "/owners": "owners",
        "/assignments": "assignments",
        "/imports": "imports",
        "/templates": "templates",
        "/settings": "settings",
        "/admin-users": "admin_users",
        "/platform-tenants": "platform_tenants",
        "/audit": "audit",
        "/debug": "debug"
    };
    const hasRoutePermission = (route)=>{
        const key = routePermissionMap[route];
        if (!key) return true;
        if (!permissions) return true;
        return permissions[key] !== false;
    };
    const platformMenuOrder = {
        "/platform-tenants": 1,
        "/admin-users": 2,
        "/settings": 3
    };
    const getGroupItems = (groupRoutes)=>$b44d252db018a0f5$var$items.filter((item)=>groupRoutes.includes(item.to)).filter((item)=>item.to === "/platform-tenants" ? showPlatformMenu : true).filter((item)=>hasRoutePermission(item.to)).filter((item)=>platformOnlyMode ? [
                "/platform-tenants",
                "/admin-users",
                "/settings"
            ].includes(item.to) : true).filter((item)=>platformOnlyMode ? showPlatformMenu : true).sort((a, b)=>{
            if (!platformOnlyMode) return 0;
            return (platformMenuOrder[a.to] ?? 999) - (platformMenuOrder[b.to] ?? 999);
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
        className: `sidebar ${isMobile ? "mobile-sidebar" : "desktop-sidebar"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sidebar-main",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sidebar-head",
                        children: isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "sidebar-close-btn",
                            onClick: onClose,
                            "aria-label": "Men\xfc schlie\xdfen",
                            children: "\xd7"
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sidebar-brand-slot",
                        "aria-label": "App Logo",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "sidebar-brand-logo",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: $b44d252db018a0f5$var$menuLogo,
                                alt: "ObjektVote Logo",
                                className: "sidebar-brand-logo-image"
                            })
                        })
                    }),
                    visibleGroups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "sidebar-group",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "sidebar-group-title",
                                    children: group.title
                                }),
                                getGroupItems(group.routes).map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                                        to: item.to,
                                        className: ({ isActive: isActive })=>`nav-link ${item.to === "/resolutions" ? "nav-link--resolutions-accent" : ""} ${platformOnlyMode && item.to === "/admin-users" ? "nav-link--platform-gap" : ""} ${isActive ? "active" : ""}`,
                                        onClick: ()=>{
                                            setAccountMenuOpen(false);
                                            onNavigate?.();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "nav-link-icon",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b44d252db018a0f5$var$NavIcon, {
                                                    icon: item.icon
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "nav-link-label",
                                                children: item.label
                                            })
                                        ]
                                    }, item.to))
                            ]
                        }, group.title))
                ]
            }),
            isFrameworkV2 && authUser ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sidebar-account",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `sidebar-account-card ${accountMenuOpen ? "open" : ""}`,
                    onMouseEnter: ()=>setAccountHoverActive(true),
                    onMouseLeave: ()=>setAccountHoverActive(false),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: `sidebar-account-trigger ${accountMenuOpen ? "open" : ""}`,
                            onClick: ()=>setAccountMenuOpen((value)=>!value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sidebar-account-avatar",
                                    children: authUser.avatarUrl && !avatarLoadFailed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: authUser.avatarUrl,
                                        alt: authUser.displayName,
                                        className: "sidebar-account-avatar-image",
                                        onError: ()=>setAvatarLoadFailed(true)
                                    }) : initials
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "sidebar-account-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "sidebar-account-name",
                                            children: authUser.displayName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "sidebar-account-role",
                                            children: roleLabel
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sidebar-account-chevron",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M6 8l4 4 4-4",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            ]
                        }),
                        accountMenuOpen && onLogout ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "sidebar-account-logout",
                            onClick: ()=>{
                                setAccountMenuOpen(false);
                                onLogout();
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sidebar-account-logout-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M8 4.5H5.8A1.8 1.8 0 0 0 4 6.3v7.4a1.8 1.8 0 0 0 1.8 1.8H8",
                                                stroke: "currentColor",
                                                strokeWidth: "1.7",
                                                strokeLinecap: "round"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M11 13.5 14.5 10 11 6.5",
                                                stroke: "currentColor",
                                                strokeWidth: "1.7",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M8.2 10h6.1",
                                                stroke: "currentColor",
                                                strokeWidth: "1.7",
                                                strokeLinecap: "round"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Abmelden"
                                })
                            ]
                        }) : null
                    ]
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sidebar-footer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: "https://immobilien-mainz.de",
                    target: "_blank",
                    rel: "noreferrer",
                    children: `Copyright ${year} Emig Immobilien`
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

const $401da7136ebd564e$var$TOKEN_KEY = "admin_auth_token";
const $401da7136ebd564e$export$38e1f53b76ec7fed = ()=>{
    if (typeof window === "undefined") return "";
    return localStorage.getItem($401da7136ebd564e$var$TOKEN_KEY) ?? "";
};
const $401da7136ebd564e$export$3c4602e16d9ace38 = (token)=>{
    if (typeof window === "undefined") return;
    if (!token) {
        localStorage.removeItem($401da7136ebd564e$var$TOKEN_KEY);
        return;
    }
    localStorage.setItem($401da7136ebd564e$var$TOKEN_KEY, token);
};
const $401da7136ebd564e$export$df5ba283a82ad80a = ()=>{
    if (typeof window === "undefined") return;
    localStorage.removeItem($401da7136ebd564e$var$TOKEN_KEY);
};


const $11320eb8d5d066e4$var$normalizeApiBase = (value)=>value.trim().replace(/\/+$/, "");
const $11320eb8d5d066e4$var$resolveApiBase = ()=>{
    const runtimeBase = globalThis.__APP_API_BASE_URL__;
    if (typeof runtimeBase === "string" && runtimeBase.trim()) return $11320eb8d5d066e4$var$normalizeApiBase(runtimeBase);
    if (typeof window !== "undefined" && window.location?.origin) {
        const { hostname: hostname, port: port, protocol: protocol } = window.location;
        if (port === "5173" || port === "5180") return `${protocol}//${hostname}:8080/api/v1`;
        return `${window.location.origin}/api/v1`;
    }
    return "/api/v1";
};
const $11320eb8d5d066e4$var$API_BASE = $11320eb8d5d066e4$var$resolveApiBase();
const $11320eb8d5d066e4$var$API_ORIGIN = /^https?:\/\//i.test($11320eb8d5d066e4$var$API_BASE) ? $11320eb8d5d066e4$var$API_BASE.replace(/\/api\/v1\/?$/, "") : "";
const $11320eb8d5d066e4$var$API_GET_ETAG_CACHE_LIMIT = 250;
const $11320eb8d5d066e4$var$apiGetEtagCache = new Map();
const $11320eb8d5d066e4$var$toApiFileUrl = (fileUrl)=>{
    const raw = (fileUrl ?? "").trim();
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw)) return raw;
    if (!$11320eb8d5d066e4$var$API_ORIGIN) return raw.startsWith("/") ? raw : `/${raw}`;
    return `${$11320eb8d5d066e4$var$API_ORIGIN}${raw.startsWith("/") ? "" : "/"}${raw}`;
};
const $11320eb8d5d066e4$var$normalizeAuthUserAvatar = (user)=>({
        ...user,
        avatarUrl: user.avatarUrl ? $11320eb8d5d066e4$var$toApiFileUrl(user.avatarUrl) : undefined
    });
const $11320eb8d5d066e4$var$buildHeaders = (contentType = true)=>{
    const token = (0, $401da7136ebd564e$export$38e1f53b76ec7fed)();
    const headers = {};
    if (contentType) headers["Content-Type"] = "application/json";
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
};
const $11320eb8d5d066e4$var$toSearchParams = (query = {})=>{
    const p = new URLSearchParams();
    Object.entries(query).forEach(([k, v])=>{
        if (v !== undefined && v !== "") p.set(k, String(v));
    });
    return p.toString();
};
const $11320eb8d5d066e4$var$setApiGetEtagCacheEntry = (url, etag, data)=>{
    if ($11320eb8d5d066e4$var$apiGetEtagCache.has(url)) $11320eb8d5d066e4$var$apiGetEtagCache.delete(url);
    $11320eb8d5d066e4$var$apiGetEtagCache.set(url, {
        etag: etag,
        data: data
    });
    if ($11320eb8d5d066e4$var$apiGetEtagCache.size <= $11320eb8d5d066e4$var$API_GET_ETAG_CACHE_LIMIT) return;
    const oldestKey = $11320eb8d5d066e4$var$apiGetEtagCache.keys().next().value;
    if (oldestKey) $11320eb8d5d066e4$var$apiGetEtagCache.delete(oldestKey);
};
async function $11320eb8d5d066e4$var$readErrorDetail(res) {
    try {
        const raw = (await res.text()).trim();
        if (!raw) return "";
        const tryParseJson = ()=>{
            try {
                return JSON.parse(raw);
            } catch  {
                return null;
            }
        };
        const payload = tryParseJson();
        if (payload && typeof payload === "object") {
            if (typeof payload.error === "string") return payload.error.trim();
            if (payload.error) {
                const messages = new Set();
                const collectMessages = (value)=>{
                    if (!value) return;
                    if (typeof value === "string") {
                        const trimmed = value.trim();
                        if (trimmed) messages.add(trimmed);
                        return;
                    }
                    if (Array.isArray(value)) {
                        value.forEach(collectMessages);
                        return;
                    }
                    if (typeof value === "object") Object.values(value).forEach(collectMessages);
                };
                collectMessages(payload.error);
                if (messages.size > 0) return Array.from(messages).join(" ");
            }
        }
        const plain = raw.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
        return plain.slice(0, 500);
    } catch  {
        return "";
    }
}
async function $11320eb8d5d066e4$var$buildApiErrorMessage(res) {
    const detail = (await $11320eb8d5d066e4$var$readErrorDetail(res)).trim();
    return detail || "Die Anfrage konnte nicht verarbeitet werden. Bitte erneut versuchen.";
}
async function $11320eb8d5d066e4$var$apiGet(path, query) {
    const qs = query ? $11320eb8d5d066e4$var$toSearchParams(query) : "";
    const url = `${$11320eb8d5d066e4$var$API_BASE}${path}${qs ? `?${qs}` : ""}`;
    const headers = $11320eb8d5d066e4$var$buildHeaders(false);
    const cached = $11320eb8d5d066e4$var$apiGetEtagCache.get(url);
    if (cached?.etag) headers["If-None-Match"] = cached.etag;
    const res = await fetch(url, {
        headers: headers
    });
    if (res.status === 304 && cached) return cached.data;
    if (!res.ok) throw new Error(await $11320eb8d5d066e4$var$buildApiErrorMessage(res));
    const payload = await res.json();
    const etag = String(res.headers.get("etag") ?? "").trim();
    if (etag) $11320eb8d5d066e4$var$setApiGetEtagCacheEntry(url, etag, payload);
    return payload;
}
async function $11320eb8d5d066e4$var$apiPost(path, body) {
    const res = await fetch(`${$11320eb8d5d066e4$var$API_BASE}${path}`, {
        method: "POST",
        headers: $11320eb8d5d066e4$var$buildHeaders(),
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $11320eb8d5d066e4$var$buildApiErrorMessage(res));
    return await res.json();
}
async function $11320eb8d5d066e4$var$apiPostBlob(path, body) {
    const res = await fetch(`${$11320eb8d5d066e4$var$API_BASE}${path}`, {
        method: "POST",
        headers: $11320eb8d5d066e4$var$buildHeaders(),
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $11320eb8d5d066e4$var$buildApiErrorMessage(res));
    return await res.blob();
}
async function $11320eb8d5d066e4$var$apiPut(path, body) {
    const res = await fetch(`${$11320eb8d5d066e4$var$API_BASE}${path}`, {
        method: "PUT",
        headers: $11320eb8d5d066e4$var$buildHeaders(),
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $11320eb8d5d066e4$var$buildApiErrorMessage(res));
    return await res.json();
}
async function $11320eb8d5d066e4$var$apiPatch(path, body) {
    const res = await fetch(`${$11320eb8d5d066e4$var$API_BASE}${path}`, {
        method: "PATCH",
        headers: $11320eb8d5d066e4$var$buildHeaders(),
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $11320eb8d5d066e4$var$buildApiErrorMessage(res));
    return await res.json();
}
async function $11320eb8d5d066e4$var$apiPostForm(path, formData) {
    const token = (0, $401da7136ebd564e$export$38e1f53b76ec7fed)();
    const headers = {
        "x-user-id": "frontend-user",
        "x-user-name": "Frontend User"
    };
    if (token) headers.Authorization = `Bearer ${token}`;
    const res = await fetch(`${$11320eb8d5d066e4$var$API_BASE}${path}`, {
        method: "POST",
        headers: headers,
        body: formData
    });
    if (!res.ok) throw new Error(await $11320eb8d5d066e4$var$buildApiErrorMessage(res));
    return await res.json();
}
async function $11320eb8d5d066e4$var$apiGetBlob(path) {
    const res = await fetch(`${$11320eb8d5d066e4$var$API_BASE}${path}`, {
        headers: $11320eb8d5d066e4$var$buildHeaders(false)
    });
    if (!res.ok) throw new Error(await $11320eb8d5d066e4$var$buildApiErrorMessage(res));
    return await res.blob();
}
async function $11320eb8d5d066e4$var$apiDelete(path) {
    const res = await fetch(`${$11320eb8d5d066e4$var$API_BASE}${path}`, {
        method: "DELETE",
        headers: $11320eb8d5d066e4$var$buildHeaders()
    });
    if (!res.ok) throw new Error(await $11320eb8d5d066e4$var$buildApiErrorMessage(res));
}
const $11320eb8d5d066e4$var$parseSseBlock = (raw)=>{
    const lines = raw.split(/\r?\n/);
    let event = "message";
    const dataLines = [];
    for (const line of lines){
        if (!line) continue;
        if (line.startsWith("event:")) {
            event = line.slice(6).trim() || "message";
            continue;
        }
        if (line.startsWith("data:")) dataLines.push(line.slice(5).trimStart());
    }
    if (!dataLines.length) return null;
    const rawData = dataLines.join("\n").trim();
    if (!rawData) return {
        event: event,
        data: null
    };
    try {
        return {
            event: event,
            data: JSON.parse(rawData)
        };
    } catch  {
        return {
            event: event,
            data: rawData
        };
    }
};
const $11320eb8d5d066e4$var$compactPermissionGroupState = (state)=>{
    const groups = state.groups.map((group)=>{
        const enabledPermissions = Object.fromEntries(Object.entries(group.permissions).filter(([, value])=>value === true));
        return {
            ...group,
            permissions: enabledPermissions
        };
    });
    const userAssignments = Object.fromEntries(Object.entries(state.userAssignments).map(([userId, assignment])=>{
        const groupIds = Array.isArray(assignment.groupIds) ? assignment.groupIds.filter(Boolean).slice(0, 1) : [];
        const relevantOverrides = Object.fromEntries(Object.entries(assignment.overrides).filter(([, value])=>value === "allow" || value === "deny"));
        if (!groupIds.length && !Object.keys(relevantOverrides).length) return null;
        return [
            userId,
            {
                groupIds: groupIds,
                overrides: relevantOverrides
            }
        ];
    }).filter((entry)=>Boolean(entry)));
    return {
        groups: groups,
        userAssignments: userAssignments
    };
};
const $11320eb8d5d066e4$export$644d8ea042df96a6 = {
    adminLogin: async (payload)=>{
        const res = await $11320eb8d5d066e4$var$apiPost("/auth/login", payload);
        return {
            ...res,
            user: $11320eb8d5d066e4$var$normalizeAuthUserAvatar(res.user)
        };
    },
    adminMe: async ()=>{
        const resRaw = await fetch(`${$11320eb8d5d066e4$var$API_BASE}/auth/me`, {
            headers: $11320eb8d5d066e4$var$buildHeaders(false)
        });
        if (!resRaw.ok) throw new Error(`API ${resRaw.status}: ${await $11320eb8d5d066e4$var$buildApiErrorMessage(resRaw)}`);
        const res = await resRaw.json();
        return {
            ...res,
            user: $11320eb8d5d066e4$var$normalizeAuthUserAvatar(res.user)
        };
    },
    adminHeartbeat: async ()=>{
        const res = await fetch(`${$11320eb8d5d066e4$var$API_BASE}/auth/heartbeat`, {
            method: "POST",
            headers: $11320eb8d5d066e4$var$buildHeaders()
        });
        if (!res.ok) throw new Error(`API ${res.status}: ${await $11320eb8d5d066e4$var$buildApiErrorMessage(res)}`);
    },
    adminLogout: ()=>$11320eb8d5d066e4$var$apiPost("/auth/logout", {}),
    adminUsers: async ()=>{
        const res = await $11320eb8d5d066e4$var$apiGet("/auth/users");
        return {
            ...res,
            data: (res.data ?? []).map((row)=>({
                    ...row,
                    avatarUrl: row.avatarUrl ? $11320eb8d5d066e4$var$toApiFileUrl(row.avatarUrl) : undefined
                }))
        };
    },
    rolePermissionMatrix: ()=>$11320eb8d5d066e4$var$apiGet("/auth/permissions/role-matrix"),
    updateRolePermissionMatrix: (matrix)=>$11320eb8d5d066e4$var$apiPatch("/auth/permissions/role-matrix", {
            matrix: matrix
        }),
    permissionGroups: ()=>$11320eb8d5d066e4$var$apiGet("/auth/permissions/groups"),
    updatePermissionGroups: (state)=>$11320eb8d5d066e4$var$apiPatch("/auth/permissions/groups", $11320eb8d5d066e4$var$compactPermissionGroupState(state)),
    objectScope: ()=>$11320eb8d5d066e4$var$apiGet("/auth/permissions/object-scope"),
    updateObjectScope: (state)=>$11320eb8d5d066e4$var$apiPatch("/auth/permissions/object-scope", state),
    createAdminUser: (payload)=>$11320eb8d5d066e4$var$apiPost("/auth/users", payload),
    updateAdminUser: (id, payload)=>$11320eb8d5d066e4$var$apiPatch(`/auth/users/${id}`, payload),
    uploadAdminUserAvatar: (id, file)=>{
        const formData = new FormData();
        formData.append("file", file);
        return $11320eb8d5d066e4$var$apiPostForm(`/auth/users/${id}/avatar`, formData);
    },
    deleteAdminUserAvatar: (id)=>$11320eb8d5d066e4$var$apiDelete(`/auth/users/${id}/avatar`),
    deleteAdminUser: (id)=>$11320eb8d5d066e4$var$apiDelete(`/auth/users/${id}`),
    tenants: ()=>$11320eb8d5d066e4$var$apiGet("/auth/tenants"),
    createTenant: (payload)=>$11320eb8d5d066e4$var$apiPost("/auth/tenants", payload),
    updateTenant: (slug, payload)=>$11320eb8d5d066e4$var$apiPatch(`/auth/tenants/${encodeURIComponent(slug)}`, payload),
    retryTenantProvisioning: (slug)=>$11320eb8d5d066e4$var$apiPost(`/auth/tenants/${encodeURIComponent(slug)}/provisioning/retry`, {}),
    deleteTenant: (slug)=>$11320eb8d5d066e4$var$apiDelete(`/auth/tenants/${encodeURIComponent(slug)}`),
    getTenantBilling: (slug)=>$11320eb8d5d066e4$var$apiGet(`/auth/tenants/${encodeURIComponent(slug)}/billing`),
    createTenantBillingCheckout: (slug)=>$11320eb8d5d066e4$var$apiPost(`/auth/tenants/${encodeURIComponent(slug)}/billing/checkout`, {}),
    createTenantBillingPortal: (slug)=>$11320eb8d5d066e4$var$apiPost(`/auth/tenants/${encodeURIComponent(slug)}/billing/portal`, {}),
    syncTenantBilling: (slug)=>$11320eb8d5d066e4$var$apiPost(`/auth/tenants/${encodeURIComponent(slug)}/billing/sync`, {}),
    getTenantFaciliooDebug: (slug)=>$11320eb8d5d066e4$var$apiGet(`/auth/tenants/${encodeURIComponent(slug)}/facilioo-debug`),
    updateTenantFaciliooDebug: (slug, payload)=>$11320eb8d5d066e4$var$apiPut(`/auth/tenants/${encodeURIComponent(slug)}/facilioo-debug`, payload),
    objects: (query)=>$11320eb8d5d066e4$var$apiGet("/objects", query),
    objectById: (id)=>$11320eb8d5d066e4$var$apiGet(`/objects/${id}`),
    objectSummary: (id)=>$11320eb8d5d066e4$var$apiGet(`/objects/${id}/summary`),
    units: (query)=>$11320eb8d5d066e4$var$apiGet("/units", query),
    owners: async (query)=>{
        const raw = await $11320eb8d5d066e4$var$apiGet("/owners", query);
        return {
            ...raw,
            data: raw.data.map((r)=>({
                    id: String(r.id),
                    objectId: String(r.objectId ?? ""),
                    objektnummer: String(r.objektnummer ?? ""),
                    objectRefs: Array.isArray(r.objectRefs) ? r.objectRefs.map((entry)=>({
                            id: String(entry.id ?? ""),
                            objektnummer: String(entry.objektnummer ?? ""),
                            status: entry.status ? String(entry.status) : undefined,
                            assignmentDetails: Array.isArray(entry.assignmentDetails) ? (entry.assignmentDetails ?? []).map((detail)=>({
                                    objektnummer: String(detail.objektnummer ?? ""),
                                    einheitsnummer: String(detail.einheitsnummer ?? ""),
                                    gueltigAb: detail.gueltigAb ? String(detail.gueltigAb) : undefined,
                                    gueltigBis: detail.gueltigBis ? String(detail.gueltigBis) : undefined,
                                    status: detail.status ? String(detail.status) : undefined
                                })) : undefined
                        })).filter((entry)=>!!entry.id && !!entry.objektnummer) : undefined,
                    eigentuemer_id: String(r.eigentuemer_id ?? ""),
                    anrede: r.anrede ? String(r.anrede) : undefined,
                    titel: r.titel ? String(r.titel) : undefined,
                    vorname: r.vorname ? String(r.vorname) : undefined,
                    name_1: r.name_1 ? String(r.name_1) : undefined,
                    name_2: r.name_2 ? String(r.name_2) : undefined,
                    name_3: r.name_3 ? String(r.name_3) : undefined,
                    briefanrede_1: r.briefanrede_1 ? String(r.briefanrede_1) : undefined,
                    briefanrede_2: r.briefanrede_2 ? String(r.briefanrede_2) : undefined,
                    strasse: r.strasse ? String(r.strasse) : undefined,
                    plz: r.plz ? String(r.plz) : undefined,
                    ort: r.ort ? String(r.ort) : undefined,
                    land_code: r.land_code ? String(r.land_code) : undefined,
                    land: r.land ? String(r.land) : undefined,
                    vollname: String(r.vollname ?? [
                        r.vorname ?? "",
                        [
                            r.name_1 ?? "",
                            r.name_2 ?? "",
                            r.name_3 ?? ""
                        ].filter(Boolean).join(" | ")
                    ].filter(Boolean).join(" ").trim()),
                    email: r.email ? String(r.email) : undefined,
                    telefon: r.telefon ? String(r.telefon) : undefined,
                    ist_analog: Boolean(r.ist_analog ?? !(r.email && String(r.email).trim())),
                    erreichbarkeit: Boolean(r.ist_analog ?? !(r.email && String(r.email).trim())) ? "analog" : "digital",
                    anzahl_einheiten: Number(r.anzahl_einheiten ?? 0),
                    gueltig_ab: r.gueltig_ab ? String(r.gueltig_ab) : undefined,
                    gueltig_bis: r.gueltig_bis ? String(r.gueltig_bis) : undefined,
                    status: String(r.status ?? "aktiv"),
                    letzte_aenderung: String(r.letzte_aenderung ?? r.updatedAt ?? "")
                }))
        };
    },
    assignments: async (query)=>{
        const raw = await $11320eb8d5d066e4$var$apiGet("/assignments", query);
        return {
            ...raw,
            data: raw.data.map((r)=>({
                    id: String(r.id),
                    objectId: String(r.objectId ?? ""),
                    unitId: String(r.unitId ?? ""),
                    ownerId: String(r.ownerId ?? ""),
                    objektnummer: String(r.objektnummer ?? ""),
                    einheitsnummer: String(r.einheitsnummer ?? ""),
                    eigentuemer_id: String(r.eigentuemer_id ?? ""),
                    eigentuemername: String(r.eigentuemername ?? ""),
                    eigentuemer_email: r.eigentuemer_email ? String(r.eigentuemer_email) : "",
                    einheit_stimmrecht: Number(r.einheit_stimmrecht ?? 0),
                    einheit_mea: r.einheit_mea !== undefined ? Number(r.einheit_mea) : undefined,
                    gueltig_ab: r.gueltig_ab ? String(r.gueltig_ab) : undefined,
                    gueltig_bis: r.gueltig_bis ? String(r.gueltig_bis) : undefined,
                    contractId: r.contractId ? String(r.contractId) : r.contract_id ? String(r.contract_id) : undefined,
                    contractTypeId: Number.isFinite(Number(r.contractTypeId)) ? Number(r.contractTypeId) : null,
                    isAuthorizedOwnerRecipient: Boolean(r.isAuthorizedOwnerRecipient),
                    rolle: r.rolle ? String(r.rolle) : null,
                    letzte_aenderung: r.letzte_aenderung ? String(r.letzte_aenderung) : undefined,
                    status: String(r.status ?? "aktiv")
                }))
        };
    },
    resolutions: (query)=>$11320eb8d5d066e4$var$apiGet("/resolutions", query),
    nextResolutionNumber: ()=>$11320eb8d5d066e4$var$apiGet("/resolutions/next-beschlussnummer"),
    resolutionById: (id)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}`),
    resolutionRecipients: (id, query)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/recipients`, query),
    resolutionVotes: (id)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/votes`),
    resolutionOwnerAccesses: (id)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/owner-accesses`),
    resolutionVoteLog: (id)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/vote-log`),
    resolutionDispatchLog: (id, query)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/dispatch-log`, query),
    validateFaciliooProcessForObject: (objectId, processRef)=>$11320eb8d5d066e4$var$apiPost("/resolutions/facilioo/validate-process", {
            objectId: objectId,
            processRef: processRef
        }),
    resolutionTriggerNotificationsLog: (id)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/trigger-notifications/log`),
    resolutionDemoDispatchStatus: (id, limit = 120)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/dispatch-demo/status`, {
            limit: limit
        }),
    startResolutionDemoDispatch: (id, payload)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/${id}/dispatch-demo/start`, payload),
    cancelResolutionDemoDispatch: (id, jobId)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/${id}/dispatch-demo/jobs/${jobId}/cancel`, {}),
    resolutionResult: (id)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/result`),
    resolutionKpis: (id)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/kpis`),
    subscribeResolutionEvents: (id, options = {})=>{
        const controller = new AbortController();
        let closed = false;
        const start = async ()=>{
            try {
                const res = await fetch(`${$11320eb8d5d066e4$var$API_BASE}/resolutions/${id}/events-stream`, {
                    method: "GET",
                    headers: {
                        ...$11320eb8d5d066e4$var$buildHeaders(false),
                        Accept: "text/event-stream"
                    },
                    signal: controller.signal
                });
                if (!res.ok) throw new Error(await $11320eb8d5d066e4$var$buildApiErrorMessage(res));
                if (!res.body) {
                    options.onClose?.();
                    return;
                }
                const reader = res.body.getReader();
                const decoder = new TextDecoder("utf-8");
                let buffer = "";
                while(!closed){
                    const chunk = await reader.read();
                    if (chunk.done) break;
                    buffer += decoder.decode(chunk.value, {
                        stream: true
                    });
                    const blocks = buffer.split(/\r?\n\r?\n/);
                    buffer = blocks.pop() ?? "";
                    for (const block of blocks){
                        const parsed = $11320eb8d5d066e4$var$parseSseBlock(block);
                        if (!parsed) continue;
                        options.onEvent?.(parsed.event, parsed.data);
                    }
                }
                options.onClose?.();
            } catch (error) {
                if (!controller.signal.aborted) options.onError?.(error instanceof Error ? error : new Error("SSE-Verbindung fehlgeschlagen."));
            }
        };
        start();
        return {
            close: ()=>{
                if (closed) return;
                closed = true;
                controller.abort();
                options.onClose?.();
            }
        };
    },
    resolutionDocuments: async (id)=>{
        const res = await $11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/documents`);
        return {
            ...res,
            data: (res.data ?? []).map((row)=>({
                    ...row,
                    fileUrl: $11320eb8d5d066e4$var$toApiFileUrl(row.fileUrl)
                }))
        };
    },
    resolutionFaciliooAttachments: (id)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/facilioo-attachments`),
    resolutionFaciliooFileTypesDebug: (id)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/${id}/facilioo-file-types-debug`),
    fetchResolutionFaciliooAttachmentBlob: (id, feedId, attachmentId, options)=>{
        const params = new URLSearchParams();
        if (options?.fileName) params.set("name", options.fileName);
        if (options?.fileExtension) params.set("ext", options.fileExtension);
        if (options?.mimeType) params.set("mime", options.mimeType);
        if (options?.download) params.set("download", "1");
        const query = params.toString();
        const path = `/resolutions/${encodeURIComponent(id)}/facilioo-attachments/${encodeURIComponent(feedId)}/${encodeURIComponent(attachmentId)}/file${query ? `?${query}` : ""}`;
        return $11320eb8d5d066e4$var$apiGetBlob(path);
    },
    importResolutionFaciliooAttachments: (id, items)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/${id}/facilioo-attachments/import`, {
            items: items
        }),
    uploadResolutionDocuments: (id, files)=>{
        const formData = new FormData();
        files.forEach((file)=>formData.append("files", file));
        return $11320eb8d5d066e4$var$apiPostForm(`/resolutions/${id}/documents`, formData);
    },
    uploadResolutionDocumentsToFacilioo: (id, documentIds)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/${id}/documents/facilioo-upload`, {
            documentIds: documentIds
        }),
    deleteResolutionDocument: (id, documentId)=>$11320eb8d5d066e4$var$apiDelete(`/resolutions/${id}/documents/${documentId}`),
    imports: (query)=>$11320eb8d5d066e4$var$apiGet("/imports", query),
    importById: (jobId)=>$11320eb8d5d066e4$var$apiGet(`/imports/${jobId}`),
    importErrors: (jobId)=>$11320eb8d5d066e4$var$apiGet(`/imports/${jobId}/errors`),
    validateImport: (jobId, mapping)=>$11320eb8d5d066e4$var$apiPost(`/imports/${jobId}/validate`, {
            mapping: mapping
        }),
    commitImport: (jobId, confirmedErrorIds = [])=>$11320eb8d5d066e4$var$apiPost(`/imports/${jobId}/commit`, {
            confirmedErrorIds: confirmedErrorIds
        }),
    uploadImportFile: (importType, file)=>{
        const formData = new FormData();
        formData.append("importType", importType);
        formData.append("file", file);
        return $11320eb8d5d066e4$var$apiPostForm("/imports/upload", formData);
    },
    uploadImportFromFacilioo: (importType)=>$11320eb8d5d066e4$var$apiPost("/imports/facilioo/upload", {
            importType: importType
        }),
    downloadImportTemplate: async (importType, format = "csv")=>{
        const blob = await $11320eb8d5d066e4$var$apiGetBlob(`/imports/templates/${importType}?format=${format}`);
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = `${importType}.${format}`;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    },
    auditLogs: (query)=>$11320eb8d5d066e4$var$apiGet("/audit-logs", query),
    faciliooSyncLogs: (query)=>$11320eb8d5d066e4$var$apiGet("/audit-logs/facilioo-sync", query),
    faciliooWebhookLogs: (query)=>$11320eb8d5d066e4$var$apiGet("/audit-logs/facilioo-webhooks", query),
    faciliooWebhookRejectLogs: (query)=>$11320eb8d5d066e4$var$apiGet("/audit-logs/facilioo-webhooks/rejects", query),
    voteProtocols: (query)=>$11320eb8d5d066e4$var$apiGet("/audit-logs/votes", query),
    createObject: (payload)=>$11320eb8d5d066e4$var$apiPost("/objects", payload),
    createUnit: (payload)=>$11320eb8d5d066e4$var$apiPost("/units", payload),
    createOwner: (payload)=>$11320eb8d5d066e4$var$apiPost("/owners", payload),
    createAssignment: (payload)=>$11320eb8d5d066e4$var$apiPost("/assignments", payload),
    createResolution: (payload)=>$11320eb8d5d066e4$var$apiPost("/resolutions", payload),
    updateObject: (id, payload)=>$11320eb8d5d066e4$var$apiPatch(`/objects/${id}`, payload),
    updateUnit: (id, payload)=>$11320eb8d5d066e4$var$apiPatch(`/units/${id}`, payload),
    updateOwner: (id, payload)=>$11320eb8d5d066e4$var$apiPatch(`/owners/${id}`, payload),
    updateAssignment: (id, payload)=>$11320eb8d5d066e4$var$apiPatch(`/assignments/${id}`, payload),
    updateResolution: (id, payload)=>$11320eb8d5d066e4$var$apiPatch(`/resolutions/${id}`, payload),
    startResolution: (id, payload)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/${id}/start`, payload ?? {}),
    stopResolution: (id, payload)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/${id}/stop`, payload ?? {}),
    deleteResolution: (id)=>$11320eb8d5d066e4$var$apiDelete(`/resolutions/${id}`),
    upsertResolutionVote: (id, payload)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/${id}/votes`, payload),
    ownerVotingLogin: (payload)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/owner-voting/login`, payload),
    ownerVotingAccess: (token)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/owner-voting/access/${token}`),
    ownerVotingResult: (token)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/owner-voting/access/${token}/result`),
    ownerVotingDocuments: async (token)=>{
        const res = await $11320eb8d5d066e4$var$apiGet(`/resolutions/owner-voting/access/${token}/documents`);
        return {
            ...res,
            data: (res.data ?? []).map((row)=>({
                    ...row,
                    fileUrl: $11320eb8d5d066e4$var$toApiFileUrl(row.fileUrl)
                }))
        };
    },
    ownerVotingSubmit: (token, payload)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/owner-voting/access/${token}/vote`, payload),
    analogScanAccess: (token)=>$11320eb8d5d066e4$var$apiGet(`/resolutions/analog-scan/${token}`),
    analogScanSubmit: (token, payload)=>$11320eb8d5d066e4$var$apiPost(`/resolutions/analog-scan/${token}/vote`, payload),
    deactivateObject: (id)=>$11320eb8d5d066e4$var$apiPatch(`/objects/${id}/deactivate`, {}),
    deactivateUnit: (id)=>$11320eb8d5d066e4$var$apiPatch(`/units/${id}/deactivate`, {}),
    deactivateOwner: (id)=>$11320eb8d5d066e4$var$apiPatch(`/owners/${id}/deactivate`, {}),
    deleteAssignment: (id)=>$11320eb8d5d066e4$var$apiDelete(`/assignments/${id}`),
    documentTemplates: async ()=>{
        const res = await $11320eb8d5d066e4$var$apiGet("/document-templates");
        return {
            ...res,
            letterheads: {
                digital: res.letterheads?.digital ? {
                    ...res.letterheads.digital,
                    fileUrl: res.letterheads.digital.fileUrl ? $11320eb8d5d066e4$var$toApiFileUrl(res.letterheads.digital.fileUrl) : undefined
                } : undefined,
                analog: res.letterheads?.analog ? {
                    ...res.letterheads.analog,
                    fileUrl: res.letterheads.analog.fileUrl ? $11320eb8d5d066e4$var$toApiFileUrl(res.letterheads.analog.fileUrl) : undefined
                } : undefined,
                digital_followup: res.letterheads?.digital_followup ? {
                    ...res.letterheads.digital_followup,
                    fileUrl: res.letterheads.digital_followup.fileUrl ? $11320eb8d5d066e4$var$toApiFileUrl(res.letterheads.digital_followup.fileUrl) : undefined
                } : undefined,
                analog_followup: res.letterheads?.analog_followup ? {
                    ...res.letterheads.analog_followup,
                    fileUrl: res.letterheads.analog_followup.fileUrl ? $11320eb8d5d066e4$var$toApiFileUrl(res.letterheads.analog_followup.fileUrl) : undefined
                } : undefined
            }
        };
    },
    updateDocumentTemplate: (key, payload)=>$11320eb8d5d066e4$var$apiPut(`/document-templates/${key}`, payload),
    previewDocumentTemplate: (payload)=>$11320eb8d5d066e4$var$apiPost("/document-templates/preview", payload),
    previewDocumentTemplateMail: (payload)=>$11320eb8d5d066e4$var$apiPost("/document-templates/preview-mail", payload),
    previewDocumentTemplatePdf: (payload)=>$11320eb8d5d066e4$var$apiPostBlob("/document-templates/preview-pdf", payload),
    sendDocumentTemplatePreviewMailTest: (payload)=>$11320eb8d5d066e4$var$apiPost("/document-templates/preview-mail/send-test", payload),
    generateDispatchDocuments: async (payload)=>{
        const res = await $11320eb8d5d066e4$var$apiPost("/document-templates/generate", payload);
        return {
            ...res,
            data: (res.data ?? []).map((row)=>({
                    ...row,
                    fileUrl: $11320eb8d5d066e4$var$toApiFileUrl(row.fileUrl)
                }))
        };
    },
    generatedDispatchDocuments: async (resolutionId)=>{
        const res = await $11320eb8d5d066e4$var$apiGet("/document-templates/generated", {
            resolutionId: resolutionId
        });
        return {
            ...res,
            data: (res.data ?? []).map((row)=>({
                    ...row,
                    fileUrl: $11320eb8d5d066e4$var$toApiFileUrl(row.fileUrl)
                }))
        };
    },
    downloadGeneratedDispatchZip: (resolutionId, eventType)=>{
        const params = new URLSearchParams({
            resolutionId: resolutionId,
            eventType: eventType
        });
        return $11320eb8d5d066e4$var$apiGetBlob(`/document-templates/generated/zip?${params.toString()}`);
    },
    retryGeneratedDispatchMail: (id, payload)=>$11320eb8d5d066e4$var$apiPost(`/document-templates/generated/${id}/retry-mail`, payload ?? {}),
    retryFailedGeneratedDispatchMails: (payload)=>$11320eb8d5d066e4$var$apiPost("/document-templates/generated/retry-failed", payload),
    uploadDocumentLetterhead: async (kanal, file)=>{
        const formData = new FormData();
        formData.append("file", file);
        const res = await $11320eb8d5d066e4$var$apiPostForm(`/document-templates/letterheads/${kanal}`, formData);
        return {
            ...res,
            fileUrl: $11320eb8d5d066e4$var$toApiFileUrl(res.fileUrl)
        };
    },
    deleteDocumentLetterhead: (kanal)=>$11320eb8d5d066e4$var$apiDelete(`/document-templates/letterheads/${kanal}`),
    updateDocumentLetterheadMargins: (kanal, payload)=>$11320eb8d5d066e4$var$apiPatch(`/document-templates/letterheads/${kanal}/margins`, payload),
    updateDocumentLetterheadFirstPageLayout: (kanal, payload)=>$11320eb8d5d066e4$var$apiPatch(`/document-templates/letterheads/${kanal}/first-page-layout`, payload),
    uiSettings: ()=>$11320eb8d5d066e4$var$apiGet("/settings"),
    uiBranding: ()=>$11320eb8d5d066e4$var$apiGet("/settings/public-branding"),
    getDemoRequestConfig: ()=>$11320eb8d5d066e4$var$apiGet("/public/demo-request/config"),
    submitDemoRequest: (payload)=>$11320eb8d5d066e4$var$apiPost("/public/demo-request", payload),
    saveUiSettings: (payload, options)=>$11320eb8d5d066e4$var$apiPut(options?.clearDemoDataOnDisable ? "/settings?clearDemoDataOnDisable=1" : "/settings", payload),
    disableAndClearDemoData: ()=>$11320eb8d5d066e4$var$apiPost("/settings/demo-data/disable-and-clear", {}),
    clearDataByType: (type)=>$11320eb8d5d066e4$var$apiPost("/settings/data/clear", {
            type: type
        }),
    testMailSettings: (recipientEmail, mail)=>$11320eb8d5d066e4$var$apiPost("/settings/mail/test", {
            recipientEmail: recipientEmail,
            mail: mail
        }),
    getMicrosoftMailStatus: ()=>$11320eb8d5d066e4$var$apiGet("/settings/mail/microsoft/status"),
    getMicrosoftMailFolders: (mailbox)=>{
        const params = new URLSearchParams();
        const mailboxValue = String(mailbox ?? "").trim();
        if (mailboxValue) params.set("mailbox", mailboxValue);
        const query = params.toString();
        return $11320eb8d5d066e4$var$apiGet(`/settings/mail/microsoft/folders${query ? `?${query}` : ""}`);
    },
    connectMicrosoftMail: (returnPath)=>$11320eb8d5d066e4$var$apiPost("/settings/mail/microsoft/connect", {
            returnPath: returnPath
        }),
    disconnectMicrosoftMail: ()=>$11320eb8d5d066e4$var$apiPost("/settings/mail/microsoft/disconnect", {}),
    testFaciliooConnection: ()=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/test", {}),
    getFaciliooDocumentGroups: ()=>$11320eb8d5d066e4$var$apiGet("/settings/facilioo/document-groups"),
    ensureFaciliooDocumentGroup: (payload)=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/document-groups/ensure", payload ?? {}),
    resetFaciliooDocumentGroup: ()=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/document-groups/reset", {}),
    getFaciliooWebhookTarget: ()=>$11320eb8d5d066e4$var$apiGet("/settings/facilioo/webhook-target"),
    regenerateFaciliooWebhookTargetKey: (name = "default")=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/webhook-target/regenerate", {
            name: name
        }),
    registerFaciliooWebhookTarget: (payload)=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/webhook-target/register", payload ?? {}),
    testFaciliooWebhookConnection: ()=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/webhook-target/connection-test", {}),
    pingFaciliooWebhookEndpoint: ()=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/webhook-target/ping", {}),
    probeFaciliooMasterData: ()=>$11320eb8d5d066e4$var$apiGet("/settings/facilioo/probe/master-data"),
    getFaciliooContractLive: (contractId)=>$11320eb8d5d066e4$var$apiGet(`/settings/facilioo/contracts/${encodeURIComponent(contractId)}/live`),
    resolveFaciliooProcess: (processRef, options)=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/processes/resolve", {
            processRef: processRef,
            ...options?.postFeedEntry ? {
                postFeedEntry: true
            } : {},
            ...options?.feedText?.trim() ? {
                feedText: options.feedText.trim()
            } : {}
        }),
    getFaciliooSyncStatus: ()=>$11320eb8d5d066e4$var$apiGet("/settings/facilioo/sync/status"),
    getPlatformServicesStatus: (options)=>{
        const params = new URLSearchParams();
        if (options?.includeMemoryDebug === false) params.set("includeMemoryDebug", "false");
        if (typeof options?.historyMinutes === "number" && Number.isFinite(options.historyMinutes) && options.historyMinutes > 0) params.set("historyMinutes", String(Math.max(1, Math.floor(options.historyMinutes))));
        const query = params.toString();
        return $11320eb8d5d066e4$var$apiGet(`/settings/services/status${query ? `?${query}` : ""}`);
    },
    checkPlatformServiceStatus: (service)=>$11320eb8d5d066e4$var$apiPost("/settings/services/check", {
            service: service
        }),
    notifyPlatformServiceStatus: (service)=>$11320eb8d5d066e4$var$apiPost("/settings/services/notify", {
            service: service
        }),
    getTenantTrialStatus: ()=>$11320eb8d5d066e4$var$apiGet("/settings/tenant-trial"),
    runFaciliooSyncNow: (objectNumber, debugAccountId, mode = "full")=>{
        const payload = {};
        if (objectNumber?.trim()) payload.objectNumber = objectNumber.trim();
        if (debugAccountId?.trim()) payload.debugAccountId = debugAccountId.trim();
        payload.mode = mode;
        return $11320eb8d5d066e4$var$apiPost("/settings/facilioo/sync/run", payload);
    },
    cancelFaciliooSync: ()=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/sync/cancel", {}),
    cleanupFaciliooMirrorUnits: (dryRun = false)=>$11320eb8d5d066e4$var$apiPost("/settings/facilioo/units/cleanup-mirrors", {
            dryRun: dryRun
        }),
    assignmentAnomalies: ()=>$11320eb8d5d066e4$var$apiGet("/dashboard/assignment-anomalies"),
    dashboardSummary: ()=>$11320eb8d5d066e4$var$apiGet("/dashboard/summary"),
    dashboard: async ()=>{
        const [openRes, failedImports, recent] = await Promise.all([
            $11320eb8d5d066e4$var$apiGet("/resolutions", {
                page: 1,
                pageSize: 1,
                status: "aktiv"
            }),
            $11320eb8d5d066e4$var$apiGet("/imports", {
                page: 1,
                pageSize: 1,
                status: "failed"
            }),
            $11320eb8d5d066e4$var$apiGet("/audit-logs", {
                page: 1,
                pageSize: 8
            })
        ]);
        return {
            offeneBeschluesse: openRes.meta.total,
            ueberfaellig: 0,
            fehlerhafteImporte: failedImports.meta.total,
            unvollstaendigeObjekte: 0,
            recent: recent.data
        };
    }
};


const $6ac43062ea7242e7$var$areaLabel = (area)=>{
    if (area === "resolutions") return "Beschl\xfcsse";
    if (area === "objects") return "Objekte";
    if (area === "units") return "Einheiten";
    return "Eigent\xfcmer";
};
const $6ac43062ea7242e7$var$AreaIcon = ({ area: area })=>{
    if (area === "resolutions") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5",
                y: "4",
                width: "14",
                height: "16",
                rx: "2",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 9h8M8 13h8M8 17h5",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (area === "objects") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 10 12 4l9 6v10H3z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 20v-6h6v6",
                stroke: "currentColor",
                strokeWidth: "1.8"
            })
        ]
    });
    if (area === "units") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 4h16v16H4z",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 4v16M4 12h16",
                stroke: "currentColor",
                strokeWidth: "1.8"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "8",
                r: "3.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 20a7 7 0 0 1 14 0",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
};
const $6ac43062ea7242e7$export$1ca1e38143dcc152 = ({ settings: settings, authUser: authUser, faciliooSyncBadge: faciliooSyncBadge, demoTrialBadgeLabel: demoTrialBadgeLabel, onLogout: onLogout, onOpenMenu: onOpenMenu })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const hasLogo = !!settings.logoDataUrl;
    const fallbackName = settings.management.firmenname?.trim();
    const isFrameworkV2 = settings.management.uiFramework === "mockup_v2";
    const [searchText, setSearchText] = (0, $acw62.useState)("");
    const [searchOpen, setSearchOpen] = (0, $acw62.useState)(false);
    const [searchLoading, setSearchLoading] = (0, $acw62.useState)(false);
    const [searchResults, setSearchResults] = (0, $acw62.useState)([]);
    const [searchHasMore, setSearchHasMore] = (0, $acw62.useState)(false);
    const [activeResultIndex, setActiveResultIndex] = (0, $acw62.useState)(0);
    const searchWrapRef = (0, $acw62.useRef)(null);
    const searchInputRef = (0, $acw62.useRef)(null);
    const requestSeqRef = (0, $acw62.useRef)(0);
    const roleLabel = authUser.permissionGroupName?.trim() ? authUser.permissionGroupName.trim() : authUser.role === "superadmin" ? "Superadmin" : authUser.role === "platform_admin" ? "Platform Admin" : authUser.role === "platform_superadmin" ? "Platform Superadmin" : authUser.role === "platform_ops" ? "Platform Ops" : authUser.role === "sachbearbeitung" ? "Sachbearbeitung" : "Lesend";
    const canSearchResolutions = authUser.permissions.resolutions !== false;
    const canSearchObjects = authUser.permissions.objects !== false;
    const canSearchUnits = authUser.permissions.units !== false;
    const canSearchOwners = authUser.permissions.owners !== false;
    (0, $acw62.useEffect)(()=>{
        if (!isFrameworkV2) return;
        const onKeyDown = (event)=>{
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "k") {
                event.preventDefault();
                event.stopPropagation();
                setSearchOpen(true);
                searchInputRef.current?.focus();
                searchInputRef.current?.select();
            }
            if (event.key === "Escape") setSearchOpen(false);
        };
        window.addEventListener("keydown", onKeyDown, {
            capture: true
        });
        return ()=>window.removeEventListener("keydown", onKeyDown, {
                capture: true
            });
    }, [
        isFrameworkV2
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isFrameworkV2) return;
        const onPointerDown = (event)=>{
            if (!searchWrapRef.current) return;
            const target = event.target;
            if (!target) return;
            if (!searchWrapRef.current.contains(target)) setSearchOpen(false);
        };
        window.addEventListener("mousedown", onPointerDown);
        return ()=>window.removeEventListener("mousedown", onPointerDown);
    }, [
        isFrameworkV2
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isFrameworkV2) return;
        const query = searchText.trim();
        if (query.length < 2) {
            setSearchLoading(false);
            setSearchResults([]);
            setSearchHasMore(false);
            setActiveResultIndex(0);
            return;
        }
        const reqId = ++requestSeqRef.current;
        const timerId = window.setTimeout(async ()=>{
            setSearchLoading(true);
            const safe = async (promise)=>{
                try {
                    return await promise;
                } catch  {
                    return null;
                }
            };
            const [resolutionsRes, objectsRes, unitsRes, ownersRes] = await Promise.all([
                canSearchResolutions ? safe((0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                    page: 1,
                    pageSize: 10,
                    search: query
                })) : Promise.resolve(null),
                canSearchObjects ? safe((0, $11320eb8d5d066e4$export$644d8ea042df96a6).objects({
                    page: 1,
                    pageSize: 10,
                    search: query
                })) : Promise.resolve(null),
                canSearchUnits ? safe((0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                    page: 1,
                    pageSize: 10,
                    search: query
                })) : Promise.resolve(null),
                canSearchOwners ? safe((0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                    page: 1,
                    pageSize: 10,
                    search: query
                })) : Promise.resolve(null)
            ]);
            if (requestSeqRef.current !== reqId) return;
            const nextResults = [
                ...(resolutionsRes?.data ?? []).map((row)=>({
                        id: `resolution-${row.id}`,
                        area: "resolutions",
                        title: row.titel,
                        subtitle: `${row.beschlussnummer} \xb7 ${row.objektnummer}`,
                        href: `/resolutions/${row.id}`
                    })),
                ...(objectsRes?.data ?? []).map((row)=>({
                        id: `object-${row.id}`,
                        area: "objects",
                        title: row.objektname,
                        subtitle: `${row.objektnummer} \xb7 ${row.strasse} ${row.plz} ${row.ort}`.trim(),
                        href: `/objects/${row.id}`
                    })),
                ...(unitsRes?.data ?? []).map((row)=>({
                        id: `unit-${row.id}`,
                        area: "units",
                        title: `${row.einheitsnummer} \xb7 ${row.bezeichnung}`,
                        subtitle: `${row.objektnummer} \xb7 ${row.einheitstyp}`,
                        href: `/units?search=${encodeURIComponent(row.einheitsnummer || row.bezeichnung)}`
                    })),
                ...(ownersRes?.data ?? []).map((row)=>({
                        id: `owner-${row.id}`,
                        area: "owners",
                        title: row.vollname || row.eigentuemer_id,
                        subtitle: `${row.eigentuemer_id} \xb7 ${row.objektnummer}`,
                        href: `/owners?search=${encodeURIComponent(row.eigentuemer_id || row.vollname)}`
                    }))
            ];
            const totalAvailable = Number(resolutionsRes?.meta?.total ?? 0) + Number(objectsRes?.meta?.total ?? 0) + Number(unitsRes?.meta?.total ?? 0) + Number(ownersRes?.meta?.total ?? 0);
            setSearchResults(nextResults.slice(0, 40));
            setSearchHasMore(totalAvailable > nextResults.length);
            setActiveResultIndex(0);
            setSearchLoading(false);
        }, 180);
        return ()=>window.clearTimeout(timerId);
    }, [
        canSearchObjects,
        canSearchOwners,
        canSearchResolutions,
        canSearchUnits,
        isFrameworkV2,
        searchText
    ]);
    const activeResult = (0, $acw62.useMemo)(()=>{
        if (!searchResults.length) return null;
        const safeIndex = Math.max(0, Math.min(activeResultIndex, searchResults.length - 1));
        return searchResults[safeIndex] ?? null;
    }, [
        activeResultIndex,
        searchResults
    ]);
    const demoTrialDaysLeft = (0, $acw62.useMemo)(()=>{
        const label = String(demoTrialBadgeLabel ?? "").trim();
        const match = label.match(/(\d+)\s*Tage?/i);
        if (!match) return null;
        const days = Number(match[1]);
        return Number.isFinite(days) ? days : null;
    }, [
        demoTrialBadgeLabel
    ]);
    const demoTrialToneClass = demoTrialDaysLeft !== null && demoTrialDaysLeft > 10 ? "is-ok" : "is-warn";
    const openSearchResult = (href)=>{
        navigate(href);
        setSearchOpen(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
        className: `topbar ${isFrameworkV2 ? "topbar--framework-v2" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "topbar-left",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: "topbar-menu-btn",
                        onClick: onOpenMenu,
                        "aria-label": "Men\xfc \xf6ffnen",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {})
                        ]
                    }),
                    !isFrameworkV2 && hasLogo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: settings.logoDataUrl,
                        alt: "Logo",
                        className: "topbar-logo"
                    }) : !isFrameworkV2 && fallbackName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: fallbackName
                    }) : null
                ]
            }),
            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "topbar-search-cluster",
                children: [
                    demoTrialBadgeLabel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `topbar-trial-badge-v2 ${demoTrialToneClass}`,
                        children: demoTrialBadgeLabel
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "topbar-search-wrap",
                        "aria-label": "Suche",
                        ref: searchWrapRef,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "topbar-search-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: "11",
                                            cy: "11",
                                            r: "6.5",
                                            stroke: "currentColor",
                                            strokeWidth: "1.9"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "m16 16 4.5 4.5",
                                            stroke: "currentColor",
                                            strokeWidth: "1.9",
                                            strokeLinecap: "round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                ref: searchInputRef,
                                className: "topbar-search-input",
                                placeholder: "Suche...",
                                value: searchText,
                                onFocus: ()=>setSearchOpen(true),
                                onChange: (event)=>{
                                    setSearchText(event.target.value);
                                    setSearchOpen(true);
                                },
                                onKeyDown: (event)=>{
                                    if (!searchOpen) return;
                                    if (event.key === "ArrowDown") {
                                        event.preventDefault();
                                        setActiveResultIndex((current)=>Math.min(current + 1, Math.max(0, searchResults.length - 1)));
                                    } else if (event.key === "ArrowUp") {
                                        event.preventDefault();
                                        setActiveResultIndex((current)=>Math.max(current - 1, 0));
                                    } else if (event.key === "Enter" && activeResult) {
                                        event.preventDefault();
                                        openSearchResult(activeResult.href);
                                    } else if (event.key === "Escape") {
                                        event.preventDefault();
                                        setSearchOpen(false);
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "topbar-search-shortcut",
                                children: "Ctrl K"
                            }),
                            searchOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "topbar-search-results",
                                role: "listbox",
                                "aria-label": "Suchergebnisse",
                                children: [
                                    !searchLoading && searchText.trim().length < 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "topbar-search-state",
                                        children: "Mindestens 2 Zeichen eingeben"
                                    }) : null,
                                    !searchLoading && searchText.trim().length >= 2 && searchResults.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "topbar-search-state",
                                        children: "Keine Treffer"
                                    }) : null,
                                    !searchLoading && searchResults.length > 0 ? searchResults.map((result, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            className: `topbar-search-result-item ${index === activeResultIndex ? "active" : ""}`,
                                            onMouseEnter: ()=>setActiveResultIndex(index),
                                            onClick: ()=>openSearchResult(result.href),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "topbar-search-result-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6ac43062ea7242e7$var$AreaIcon, {
                                                        area: result.area
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "topbar-search-result-copy",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: result.title
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                $6ac43062ea7242e7$var$areaLabel(result.area),
                                                                " \xb7 ",
                                                                result.subtitle
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, result.id)) : null,
                                    !searchLoading && searchText.trim().length >= 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "topbar-search-all-link",
                                        onClick: ()=>openSearchResult(`/search?q=${encodeURIComponent(searchText.trim())}`),
                                        children: searchHasMore ? "Alle Ergebnisse anzeigen" : "Zur Suchseite"
                                    }) : null
                                ]
                            }) : null
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "topbar-right",
                children: [
                    !isFrameworkV2 && faciliooSyncBadge ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge topbar-sync-badge ${faciliooSyncBadge.tone === "ok" ? "topbar-sync-badge-ok" : "topbar-sync-badge-error"}`,
                        children: faciliooSyncBadge.label
                    }) : null,
                    !isFrameworkV2 && demoTrialBadgeLabel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge topbar-trial-badge",
                        children: demoTrialBadgeLabel
                    }) : null,
                    !isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "topbar-user",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "topbar-user-name",
                                        children: authUser.displayName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "topbar-user-role",
                                        children: roleLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "btn topbar-logout-btn",
                                onClick: onLogout,
                                children: "Abmelden"
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};











var $3aefa839a50a34b3$var$_client, $3aefa839a50a34b3$var$_currentQuery, $3aefa839a50a34b3$var$_currentQueryInitialState, $3aefa839a50a34b3$var$_currentResult, $3aefa839a50a34b3$var$_currentResultState, $3aefa839a50a34b3$var$_currentResultOptions, $3aefa839a50a34b3$var$_currentThenable, $3aefa839a50a34b3$var$_selectError, $3aefa839a50a34b3$var$_selectFn, $3aefa839a50a34b3$var$_selectResult, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, $3aefa839a50a34b3$var$_staleTimeoutId, $3aefa839a50a34b3$var$_refetchIntervalId, $3aefa839a50a34b3$var$_currentRefetchInterval, $3aefa839a50a34b3$var$_trackedProps, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn, $3aefa839a50a34b3$var$updateStaleTimeout_fn, $3aefa839a50a34b3$var$computeRefetchInterval_fn, $3aefa839a50a34b3$var$updateRefetchInterval_fn, $3aefa839a50a34b3$var$updateTimers_fn, $3aefa839a50a34b3$var$clearStaleTimeout_fn, $3aefa839a50a34b3$var$clearRefetchInterval_fn, $3aefa839a50a34b3$var$updateQuery_fn, $3aefa839a50a34b3$var$notify_fn;
var $3aefa839a50a34b3$export$a06cf8c0066f0d4c = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_QueryObserver_instances);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_client);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentQuery);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentQueryInitialState);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResult);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResultState);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResultOptions);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentThenable);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectError);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectFn);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectResult);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_staleTimeoutId);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_refetchIntervalId);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentRefetchInterval);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_client, client);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentThenable, (0, $5a619d4c2df9bf12$export$d54630db02a12b72)());
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).addObserver(this);
            if ($3aefa839a50a34b3$var$shouldFetchOnMount((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options)) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
        this.options = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $3aefa839a50a34b3$var$shouldFetchOptionally((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
        this.updateResult();
        if (mounted && ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) || (0, $002159551d1c4551$export$cb3145f011bda3ac)(this.options.staleTime, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)))) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) || nextRefetchInterval !== (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval))) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), options);
        const result = this.createResult(query, options);
        if ($3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResult, result);
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked == null || onPropTracked(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable).status === "pending") (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        const prevResultState = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultState);
        const prevResultOptions = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $3aefa839a50a34b3$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $9dc680c629ca4c63$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $002159551d1c4551$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectFn)) data = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectResult);
            else try {
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectFn, options.select);
                data = options.select(data);
                data = (0, $002159551d1c4551$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectResult, data);
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
            } catch (selectError) {
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, selectError);
            }
        }
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectError)) {
            error = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectError);
            data = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $3aefa839a50a34b3$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable),
            isEnabled: (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const hasResultData = nextResult.data !== void 0;
            const isErrorWithoutData = nextResult.status === "error" && !hasResultData;
            const finalizeThenableIfPossible = (thenable)=>{
                if (isErrorWithoutData) thenable.reject(nextResult.error);
                else if (hasResultData) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentThenable, nextResult.promise = (0, $5a619d4c2df9bf12$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (isErrorWithoutData || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (!isErrorWithoutData || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        const nextResult = this.createResult((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultState).data !== void 0) (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery));
        if ((0, $002159551d1c4551$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$notify_fn).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
    }
};
$3aefa839a50a34b3$var$_client = new WeakMap();
$3aefa839a50a34b3$var$_currentQuery = new WeakMap();
$3aefa839a50a34b3$var$_currentQueryInitialState = new WeakMap();
$3aefa839a50a34b3$var$_currentResult = new WeakMap();
$3aefa839a50a34b3$var$_currentResultState = new WeakMap();
$3aefa839a50a34b3$var$_currentResultOptions = new WeakMap();
$3aefa839a50a34b3$var$_currentThenable = new WeakMap();
$3aefa839a50a34b3$var$_selectError = new WeakMap();
$3aefa839a50a34b3$var$_selectFn = new WeakMap();
$3aefa839a50a34b3$var$_selectResult = new WeakMap();
$3aefa839a50a34b3$var$_lastQueryWithDefinedData = new WeakMap();
$3aefa839a50a34b3$var$_staleTimeoutId = new WeakMap();
$3aefa839a50a34b3$var$_refetchIntervalId = new WeakMap();
$3aefa839a50a34b3$var$_currentRefetchInterval = new WeakMap();
$3aefa839a50a34b3$var$_trackedProps = new WeakMap();
$3aefa839a50a34b3$var$_QueryObserver_instances = new WeakSet();
$3aefa839a50a34b3$var$executeFetch_fn = function(fetchOptions) {
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
    let promise = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $002159551d1c4551$export$8793edee2d425525));
    return promise;
};
$3aefa839a50a34b3$var$updateStaleTimeout_fn = function() {
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $002159551d1c4551$export$cb3145f011bda3ac)(this.options.staleTime, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery));
    if ((0, $002159551d1c4551$export$6acf61af03e62db) || (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).isStale || !(0, $002159551d1c4551$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $002159551d1c4551$export$811b83d62bcf47f0)((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_staleTimeoutId, (0, $f91dfb6f728f333f$export$94a2700736e69372).setTimeout(()=>{
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$3aefa839a50a34b3$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$3aefa839a50a34b3$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentRefetchInterval, nextInterval);
    if ((0, $002159551d1c4551$export$6acf61af03e62db) || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) === false || !(0, $002159551d1c4551$export$e539f754e934e270)((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)) || (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval) === 0) return;
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_refetchIntervalId, (0, $f91dfb6f728f333f$export$94a2700736e69372).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $1d15693d13279fb4$export$6bf54661be5b02cf).isFocused()) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
    }, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)));
};
$3aefa839a50a34b3$var$updateTimers_fn = function() {
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this));
};
$3aefa839a50a34b3$var$clearStaleTimeout_fn = function() {
    if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_staleTimeoutId)) {
        (0, $f91dfb6f728f333f$export$94a2700736e69372).clearTimeout((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_staleTimeoutId));
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_staleTimeoutId, void 0);
    }
};
$3aefa839a50a34b3$var$clearRefetchInterval_fn = function() {
    if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_refetchIntervalId)) {
        (0, $f91dfb6f728f333f$export$94a2700736e69372).clearInterval((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_refetchIntervalId));
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_refetchIntervalId, void 0);
    }
};
$3aefa839a50a34b3$var$updateQuery_fn = function() {
    const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), this.options);
    if (query === (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) return;
    const prevQuery = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentQuery, query);
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$3aefa839a50a34b3$var$notify_fn = function(notifyOptions) {
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult));
        });
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            query: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) {
    return (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $3aefa839a50a34b3$var$shouldFetchOnMount(query, options) {
    return $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $3aefa839a50a34b3$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $3aefa839a50a34b3$var$shouldFetchOn(query, options, field) {
    if ((0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && (0, $002159551d1c4551$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $3aefa839a50a34b3$var$isStale(query, options);
    }
    return false;
}
function $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $3aefa839a50a34b3$var$isStale(query, options);
}
function $3aefa839a50a34b3$var$isStale(query, options) {
    return (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

"use client";
function $9f918c9537253956$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $9f918c9537253956$var$QueryErrorResetBoundaryContext = $acw62.createContext($9f918c9537253956$var$createValue());
var $9f918c9537253956$export$50dfac555130cafd = ()=>$acw62.useContext($9f918c9537253956$var$QueryErrorResetBoundaryContext);
var $9f918c9537253956$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$9f918c9537253956$var$createValue());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9f918c9537253956$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
var $00f18dc4257f8dfa$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = (query == null ? void 0 : query.state.error) && typeof options.throwOnError === "function" ? (0, $002159551d1c4551$export$2072f68e6c3507cf)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || options.experimental_prefetchInRender || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $00f18dc4257f8dfa$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $00f18dc4257f8dfa$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $002159551d1c4551$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $acw62 = parcelRequire("acw62");
"use client";
var $dfd30e3a705c285d$var$IsRestoringContext = $acw62.createContext(false);
var $dfd30e3a705c285d$export$4da0178d6b5f553 = ()=>$acw62.useContext($dfd30e3a705c285d$var$IsRestoringContext);
var $dfd30e3a705c285d$export$593807d4e94f9621 = $dfd30e3a705c285d$var$IsRestoringContext.Provider;


// src/suspense.ts
var $6de503da57e511b5$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $6de503da57e511b5$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $6de503da57e511b5$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $6de503da57e511b5$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $6de503da57e511b5$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $1fa9088b80b7d036$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d;
    const isRestoring = (0, $dfd30e3a705c285d$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $9f918c9537253956$export$50dfac555130cafd)();
    const client = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $6de503da57e511b5$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $00f18dc4257f8dfa$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary, query);
    (0, $00f18dc4257f8dfa$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $acw62.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $798266f99c432533$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $002159551d1c4551$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $6de503da57e511b5$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $6de503da57e511b5$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $00f18dc4257f8dfa$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $002159551d1c4551$export$6acf61af03e62db) && (0, $6de503da57e511b5$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $6de503da57e511b5$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        query == null ? void 0 : query.promise;
        promise == null || promise.catch((0, $002159551d1c4551$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $82072f1c97bcdd9c$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $1fa9088b80b7d036$export$fff0865807e996c5)(options, (0, $3aefa839a50a34b3$export$a06cf8c0066f0d4c), queryClient);
}



var $acw62 = parcelRequire("acw62");



const $5806306cf67ca7cd$var$STORAGE_KEY = "weg-ui-settings-v1";
const $5806306cf67ca7cd$export$b22b9e406c4481db = {
    management: {
        firmenname: "",
        uiFramework: "classic",
        faciliooEnabled: true,
        verwaltungsIdFacilioo: "",
        faciliooApiKey: "",
        faciliooDocumentGroupId: "",
        faciliooDocumentGroupName: "Umlaufbeschl\xfcsse",
        faciliooProcessFeedTypeId: "",
        faciliooProcessFeedSourceId: "",
        faciliooDataConnectionMode: "facilioo",
        faciliooStrasseTrennzeichen: "|",
        faciliooMeaAttributeNames: "MEA Objekt, MEA",
        faciliooStimmrechteAttributeNames: "Stimmrechte",
        faciliooAnredeMapping: "Frau: frau, fr, fr.; Herrn: herr, herrn, hr, hr.; Frau / Frau: frau/frau, frau und frau; Frau / Herrn: frau/herr, frau und herr, herr und frau; Herrn / Herrn: herr/herr, herr und herr; Eheleute: eheleute; Erbengemeinschaft: erbengemeinschaft; Eigent\xfcmergemeinschaft: eigentuemergemeinschaft, eigent\xfcmergemeinschaft; Firma: firma, gmbh, ag, kg, ug",
        faciliooAnredeKeyTable: [
            {
                definition: "Frau",
                mapping: "frau, fr, fr.",
                briefanrede_1: "Sehr geehrte Frau",
                briefanrede_2: ""
            },
            {
                definition: "Herrn",
                mapping: "herr, herrn, hr, hr.",
                briefanrede_1: "Sehr geehrter Herr",
                briefanrede_2: ""
            },
            {
                definition: "Frau / Frau",
                mapping: "frau/frau, frau und frau",
                briefanrede_1: "Sehr geehrte Frau",
                briefanrede_2: "Sehr geehrte Frau"
            },
            {
                definition: "Frau / Herrn",
                mapping: "frau/herr, frau/herrn, frau und herr, herr und frau",
                briefanrede_1: "Sehr geehrte Frau",
                briefanrede_2: "Sehr geehrter Herr"
            },
            {
                definition: "Herrn / Herrn",
                mapping: "herr/herr, herrn/herrn, herr und herr, herrn und herrn",
                briefanrede_1: "Sehr geehrter Herr",
                briefanrede_2: "Sehr geehrter Herr"
            },
            {
                definition: "Eheleute",
                mapping: "eheleute",
                briefanrede_1: "Sehr geehrte Frau",
                briefanrede_2: "Sehr geehrter Herr"
            },
            {
                definition: "Erbengemeinschaft",
                mapping: "erbengemeinschaft",
                briefanrede_1: "Sehr geehrte Damen und Herren",
                briefanrede_2: ""
            },
            {
                definition: "Eigent\xfcmergemeinschaft",
                mapping: "eigentuemergemeinschaft, eigent\xfcmergemeinschaft",
                briefanrede_1: "Sehr geehrte Damen und Herren",
                briefanrede_2: ""
            },
            {
                definition: "Firma",
                mapping: "firma, gmbh, ag, kg, ug",
                briefanrede_1: "Sehr geehrte Damen und Herren",
                briefanrede_2: ""
            }
        ],
        faciliooTitelKeywords: "dr, dr., prof, prof., dipl.-ing., dipl.-kfm.",
        faciliooTitelKeyTable: [
            {
                definition: "Dr.",
                mapping: "dr, dr."
            },
            {
                definition: "Prof.",
                mapping: "prof, prof."
            },
            {
                definition: "Dipl.-Ing.",
                mapping: "dipl.-ing., dipl ing, dipl-ing"
            },
            {
                definition: "Dipl.-Kfm.",
                mapping: "dipl.-kfm., dipl kfm, dipl-kfm"
            }
        ],
        faciliooOwnerImportScope: "current",
        faciliooObjectTypeFilter: "WEG",
        masterDataActionsVisible: false,
        demoDataEnabled: true,
        faciliooWebhookEnabled: true,
        faciliooLiveSyncEnabled: false,
        faciliooLiveSyncIntervalMinutes: 60,
        faciliooDebugModeEnabled: false,
        faciliooDebugModeExpiresAt: "",
        faciliooDeepProbeEnabled: false,
        faciliooDeepProbeExpiresAt: "",
        strasse: "",
        plz: "",
        ort: "",
        email: "",
        telefon: ""
    },
    mail: {
        provider: "microsoft_graph",
        fromName: "",
        fromEmail: "",
        replyToEmail: "",
        microsoftSharedMailboxEmail: "",
        microsoftNdrFolders: "",
        smtpHost: "",
        smtpPort: 0,
        smtpSecure: false,
        smtpUser: "",
        smtpPassword: "",
        brevoApiKey: "",
        testRecipientEmail: ""
    },
    reminders: {
        firstReminderDays: 7,
        secondReminderDays: 3
    },
    theme: {
        bg: "#f4faf9",
        surface: "#ffffff",
        headerBg: "#ffffff",
        line: "#d6e7e5",
        text: "#16333a",
        primary: "#0b7f89",
        listHeaderBg: "#0b7f89",
        listAlternateRowBg: "#0b7f89",
        gradientEnabled: true,
        gradientFrom: "#edf9f7",
        gradientTo: "#f2faf4",
        navBg: "#eef6f5",
        navText: "#1a4d55",
        navActive: "#0b7f89",
        navActiveText: "#ffffff",
        navBorder: "#c9dfdd"
    },
    ownerTheme: {
        bg: "#f6fbfa",
        surface: "#ffffff",
        line: "#d6e7e5",
        text: "#16333a",
        primary: "#0b7f89",
        gradientEnabled: true,
        gradientFrom: "#edf9f7",
        gradientTo: "#f7fcfa",
        adminLoginBackgroundImageEnabled: true,
        ownerLoginBackgroundImageEnabled: false,
        ownerPageBackgroundImageEnabled: false
    },
    logoDataUrl: undefined,
    ownerLogoDataUrl: undefined
};
const $5806306cf67ca7cd$var$sanitizeReminderDays = (value, fallback)=>{
    const parsed = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(parsed)) return fallback;
    const rounded = Math.round(parsed);
    if (rounded < 1) return 1;
    if (rounded > 365) return 365;
    return rounded;
};
const $5806306cf67ca7cd$var$sanitizeReminders = (input)=>{
    const first = $5806306cf67ca7cd$var$sanitizeReminderDays(input?.firstReminderDays, $5806306cf67ca7cd$export$b22b9e406c4481db.reminders.firstReminderDays);
    let second = $5806306cf67ca7cd$var$sanitizeReminderDays(input?.secondReminderDays, $5806306cf67ca7cd$export$b22b9e406c4481db.reminders.secondReminderDays);
    if (second >= first) second = Math.max(1, first - 1);
    return {
        firstReminderDays: first,
        secondReminderDays: second
    };
};
const $5806306cf67ca7cd$var$sanitizeMail = (input)=>{
    const smtpPortRaw = typeof input?.smtpPort === "number" ? input.smtpPort : Number(input?.smtpPort ?? $5806306cf67ca7cd$export$b22b9e406c4481db.mail.smtpPort);
    const smtpPort = Number.isFinite(smtpPortRaw) ? Math.max(0, Math.min(65535, Math.round(smtpPortRaw))) : $5806306cf67ca7cd$export$b22b9e406c4481db.mail.smtpPort;
    return {
        provider: input?.provider === "brevo_api" ? "brevo_api" : input?.provider === "smtp" ? "smtp" : "microsoft_graph",
        fromName: String(input?.fromName ?? ""),
        fromEmail: String(input?.fromEmail ?? ""),
        replyToEmail: String(input?.replyToEmail ?? ""),
        microsoftSharedMailboxEmail: String(input?.microsoftSharedMailboxEmail ?? ""),
        microsoftNdrFolders: String(input?.microsoftNdrFolders ?? ""),
        smtpHost: String(input?.smtpHost ?? ""),
        smtpPort: smtpPort,
        smtpSecure: Boolean(input?.smtpSecure),
        smtpUser: String(input?.smtpUser ?? ""),
        smtpPassword: String(input?.smtpPassword ?? ""),
        brevoApiKey: String(input?.brevoApiKey ?? ""),
        testRecipientEmail: String(input?.testRecipientEmail ?? "")
    };
};
const $5806306cf67ca7cd$var$normalizeHex = (value, fallback)=>{
    if (!value) return fallback;
    const v = value.trim();
    if (/^#[0-9a-fA-F]{6}$/.test(v)) return v.toLowerCase();
    if (/^#[0-9a-fA-F]{3}$/.test(v)) {
        const r = v[1];
        const g = v[2];
        const b = v[3];
        return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
    }
    return fallback;
};
const $5806306cf67ca7cd$var$hexToRgb = (hex)=>{
    const n = hex.replace("#", "");
    return [
        parseInt(n.slice(0, 2), 16),
        parseInt(n.slice(2, 4), 16),
        parseInt(n.slice(4, 6), 16)
    ];
};
const $5806306cf67ca7cd$var$luminance = (hex)=>{
    const [r, g, b] = $5806306cf67ca7cd$var$hexToRgb(hex).map((v)=>{
        const s = v / 255;
        return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const $5806306cf67ca7cd$var$contrastRatio = (a, b)=>{
    const l1 = $5806306cf67ca7cd$var$luminance(a);
    const l2 = $5806306cf67ca7cd$var$luminance(b);
    const light = Math.max(l1, l2);
    const dark = Math.min(l1, l2);
    return (light + 0.05) / (dark + 0.05);
};
const $5806306cf67ca7cd$var$sanitizeTheme = (theme)=>{
    const merged = {
        bg: $5806306cf67ca7cd$var$normalizeHex(theme?.bg, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.bg),
        surface: $5806306cf67ca7cd$var$normalizeHex(theme?.surface, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.surface),
        headerBg: $5806306cf67ca7cd$var$normalizeHex(theme?.headerBg, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.headerBg),
        line: $5806306cf67ca7cd$var$normalizeHex(theme?.line, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.line),
        text: $5806306cf67ca7cd$var$normalizeHex(theme?.text, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.text),
        primary: $5806306cf67ca7cd$var$normalizeHex(theme?.primary, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.primary),
        listHeaderBg: $5806306cf67ca7cd$var$normalizeHex(theme?.listHeaderBg, $5806306cf67ca7cd$var$normalizeHex(theme?.primary, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.listHeaderBg)),
        listAlternateRowBg: $5806306cf67ca7cd$var$normalizeHex(theme?.listAlternateRowBg, $5806306cf67ca7cd$var$normalizeHex(theme?.primary, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.listAlternateRowBg)),
        gradientEnabled: theme?.gradientEnabled ?? $5806306cf67ca7cd$export$b22b9e406c4481db.theme.gradientEnabled,
        gradientFrom: $5806306cf67ca7cd$var$normalizeHex(theme?.gradientFrom, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.gradientFrom),
        gradientTo: $5806306cf67ca7cd$var$normalizeHex(theme?.gradientTo, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.gradientTo),
        navBg: $5806306cf67ca7cd$var$normalizeHex(theme?.navBg, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.navBg),
        navText: $5806306cf67ca7cd$var$normalizeHex(theme?.navText, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.navText),
        navActive: $5806306cf67ca7cd$var$normalizeHex(theme?.navActive, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.navActive),
        navActiveText: $5806306cf67ca7cd$var$normalizeHex(theme?.navActiveText, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.navActiveText),
        navBorder: $5806306cf67ca7cd$var$normalizeHex(theme?.navBorder, $5806306cf67ca7cd$export$b22b9e406c4481db.theme.navBorder)
    };
    const mainContrast = $5806306cf67ca7cd$var$contrastRatio(merged.bg, merged.text);
    const navContrast = $5806306cf67ca7cd$var$contrastRatio(merged.navBg, merged.navText);
    const navActiveContrast = $5806306cf67ca7cd$var$contrastRatio(merged.navActive, merged.navActiveText);
    if (mainContrast < 2.8 || navContrast < 2.8 || navActiveContrast < 2.8) return {
        ...$5806306cf67ca7cd$export$b22b9e406c4481db.theme
    };
    return merged;
};
const $5806306cf67ca7cd$var$sanitizeOwnerTheme = (theme)=>{
    const merged = {
        bg: $5806306cf67ca7cd$var$normalizeHex(theme?.bg, $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.bg),
        surface: $5806306cf67ca7cd$var$normalizeHex(theme?.surface, $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.surface),
        line: $5806306cf67ca7cd$var$normalizeHex(theme?.line, $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.line),
        text: $5806306cf67ca7cd$var$normalizeHex(theme?.text, $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.text),
        primary: $5806306cf67ca7cd$var$normalizeHex(theme?.primary, $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.primary),
        gradientEnabled: theme?.gradientEnabled ?? $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.gradientEnabled,
        gradientFrom: $5806306cf67ca7cd$var$normalizeHex(theme?.gradientFrom, $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.gradientFrom),
        gradientTo: $5806306cf67ca7cd$var$normalizeHex(theme?.gradientTo, $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.gradientTo),
        adminLoginBackgroundImageEnabled: theme?.adminLoginBackgroundImageEnabled ?? $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.adminLoginBackgroundImageEnabled,
        ownerLoginBackgroundImageEnabled: theme?.ownerLoginBackgroundImageEnabled ?? $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.ownerLoginBackgroundImageEnabled,
        ownerPageBackgroundImageEnabled: theme?.ownerPageBackgroundImageEnabled ?? $5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme.ownerPageBackgroundImageEnabled
    };
    const ownerContrast = $5806306cf67ca7cd$var$contrastRatio(merged.bg, merged.text);
    if (ownerContrast < 2.8) return {
        ...$5806306cf67ca7cd$export$b22b9e406c4481db.ownerTheme
    };
    return merged;
};
const $5806306cf67ca7cd$export$cc8e577c185b57cb = ()=>{
    try {
        const resetViaUrl = globalThis.location?.search?.includes("reset-ui=1") ?? false;
        if (resetViaUrl) {
            globalThis.localStorage?.removeItem($5806306cf67ca7cd$var$STORAGE_KEY);
            return $5806306cf67ca7cd$export$b22b9e406c4481db;
        }
        const raw = globalThis.localStorage?.getItem($5806306cf67ca7cd$var$STORAGE_KEY);
        if (!raw) return $5806306cf67ca7cd$export$b22b9e406c4481db;
        const parsed = JSON.parse(raw);
        const mergedManagement = {
            ...$5806306cf67ca7cd$export$b22b9e406c4481db.management,
            ...parsed.management ?? {}
        };
        const faciliooDataConnectionMode = mergedManagement.faciliooDataConnectionMode === "manual" || mergedManagement.faciliooDataConnectionMode === "facilioo" ? mergedManagement.faciliooDataConnectionMode : $5806306cf67ca7cd$export$b22b9e406c4481db.management.faciliooDataConnectionMode;
        const faciliooOwnerImportScope = mergedManagement.faciliooOwnerImportScope === "all" || mergedManagement.faciliooOwnerImportScope === "current" ? mergedManagement.faciliooOwnerImportScope : $5806306cf67ca7cd$export$b22b9e406c4481db.management.faciliooOwnerImportScope;
        const faciliooObjectTypeFilter = String(mergedManagement.faciliooObjectTypeFilter ?? $5806306cf67ca7cd$export$b22b9e406c4481db.management.faciliooObjectTypeFilter);
        const uiFramework = mergedManagement.uiFramework === "mockup_v2" ? "mockup_v2" : "classic";
        return {
            management: {
                ...mergedManagement,
                uiFramework: uiFramework,
                faciliooDataConnectionMode: faciliooDataConnectionMode,
                faciliooOwnerImportScope: faciliooOwnerImportScope,
                faciliooObjectTypeFilter: faciliooObjectTypeFilter
            },
            mail: $5806306cf67ca7cd$var$sanitizeMail(parsed.mail),
            reminders: $5806306cf67ca7cd$var$sanitizeReminders(parsed.reminders),
            theme: $5806306cf67ca7cd$var$sanitizeTheme(parsed.theme),
            ownerTheme: $5806306cf67ca7cd$var$sanitizeOwnerTheme(parsed.ownerTheme),
            logoDataUrl: parsed.logoDataUrl || undefined,
            ownerLogoDataUrl: parsed.ownerLogoDataUrl || undefined,
            settingsUpdatedAt: typeof parsed.settingsUpdatedAt === "string" ? parsed.settingsUpdatedAt : undefined
        };
    } catch  {
        return $5806306cf67ca7cd$export$b22b9e406c4481db;
    }
};
const $5806306cf67ca7cd$export$4a377ad1c9fa8e6a = (settings)=>{
    globalThis.localStorage?.setItem($5806306cf67ca7cd$var$STORAGE_KEY, JSON.stringify(settings));
};



var $acw62 = parcelRequire("acw62");
const $acf0971746b2c487$var$ACTION_MENU_INTERACTIVE_SELECTOR = ".resolutions-v2-action-menu, .resolutions-v2-action-trigger, .resolutions-v2-action-wrap";
const $acf0971746b2c487$export$e623be24f54873a1 = (target)=>target instanceof Element && !!target.closest($acf0971746b2c487$var$ACTION_MENU_INTERACTIVE_SELECTOR);
const $acf0971746b2c487$export$ee4849fd8b850061 = ({ isOpen: isOpen, isHovered: isHovered, closeMenu: closeMenu, timeoutMs: timeoutMs = 3000 })=>{
    const closeMenuRef = (0, $acw62.useRef)(closeMenu);
    (0, $acw62.useEffect)(()=>{
        closeMenuRef.current = closeMenu;
    }, [
        closeMenu
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isOpen || isHovered) return;
        const timeoutId = window.setTimeout(()=>closeMenuRef.current(), timeoutMs);
        return ()=>window.clearTimeout(timeoutId);
    }, [
        isHovered,
        isOpen,
        timeoutMs
    ]);
};
const $acf0971746b2c487$export$847509c5c6223f45 = ({ openMenuId: openMenuId, setOpenMenuId: setOpenMenuId, menuWidth: menuWidth = 170 })=>{
    const [actionMenuPosition, setActionMenuPosition] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!openMenuId) return;
        const closeMenu = ()=>setOpenMenuId(null);
        window.addEventListener("resize", closeMenu);
        window.addEventListener("scroll", closeMenu, true);
        return ()=>{
            window.removeEventListener("resize", closeMenu);
            window.removeEventListener("scroll", closeMenu, true);
        };
    }, [
        openMenuId,
        setOpenMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openMenuId) setActionMenuPosition(null);
    }, [
        openMenuId
    ]);
    const openActionMenuAtTrigger = (menuId, trigger, menuHeight = 96)=>{
        const rect = trigger.getBoundingClientRect();
        const margin = 8;
        const left = Math.min(Math.max(margin, rect.right - menuWidth), Math.max(margin, window.innerWidth - menuWidth - margin));
        const belowTop = rect.bottom + 6;
        const aboveTop = rect.top - menuHeight - 6;
        const top = belowTop + menuHeight <= window.innerHeight - margin ? belowTop : Math.max(margin, aboveTop);
        setActionMenuPosition({
            left: left,
            top: top
        });
        setOpenMenuId(menuId);
    };
    return {
        actionMenuPosition: actionMenuPosition,
        openActionMenuAtTrigger: openActionMenuAtTrigger
    };
};


const $848f7c387707f0c9$var$numberFormat = new Intl.NumberFormat("de-DE", {
    maximumFractionDigits: 0
});
const $848f7c387707f0c9$var$percentFormat = new Intl.NumberFormat("de-DE", {
    maximumFractionDigits: 1
});
const $848f7c387707f0c9$var$formatDate = (value)=>{
    if (!value) return "-";
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return value;
    return `${match[3]}.${match[2]}.${match[1]}`;
};
const $848f7c387707f0c9$var$statusLabel = (status)=>{
    if (status === "aktiv") return "Laufend";
    if (status === "entwurf") return "Entwurf";
    return "Abgeschlossen";
};
const $848f7c387707f0c9$var$qualityToneLabel = (tone)=>{
    if (tone === "critical") return "Kritisch";
    if (tone === "warning") return "Hinweis";
    return "OK";
};
const $848f7c387707f0c9$var$qualityTargetHref = (item)=>{
    if (item.key === "units_without_assignment") return "/debug#assignment-anomalies-without";
    if (item.key === "multiple_assignments") return "/debug#assignment-anomalies-multiple";
    return item.href;
};
const $848f7c387707f0c9$var$DashboardIcon = ({ name: name })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "dashboard-v2-icon",
        "aria-hidden": "true",
        children: [
            name === "current" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.1 4.6h6.6l3.2 3.2v11.6H7.1z",
                        stroke: "currentColor",
                        strokeWidth: "1.85",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.7 4.8v3.1h3",
                        stroke: "currentColor",
                        strokeWidth: "1.85",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "m9.4 14.1 2 2 4.2-5",
                        stroke: "currentColor",
                        strokeWidth: "1.85",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "17.7",
                        cy: "17.8",
                        r: "2.1",
                        fill: "#fff",
                        stroke: "currentColor",
                        strokeWidth: "1.85"
                    })
                ]
            }) : null,
            name === "return" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.2 8.7a7 7 0 1 0 .5 8.2",
                        stroke: "currentColor",
                        strokeWidth: "1.9",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "m16.7 5.8 2.8 3-3 2.7",
                        stroke: "currentColor",
                        strokeWidth: "1.9",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : null,
            name === "deadline" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "7.4",
                        stroke: "currentColor",
                        strokeWidth: "1.8"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12 8v4.2l2.8 1.8",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : null,
            name === "quality" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12 4.5 19 8v5.2c0 3.4-2.8 5.6-7 6.8-4.2-1.2-7-3.4-7-6.8V8l7-3.5Z",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "m9 12.4 2 2 4.1-4.7",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : null,
            name === "chart" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5.5 18.5h13M7.2 18.5v-6.8M12 18.5V7M16.8 18.5v-9",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round"
                })
            }) : null,
            name === "check" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m6.4 12.6 3.5 3.5 7.8-8.4",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }) : null,
            name === "arrow" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M8 5.5 14.5 12 8 18.5",
                    stroke: "currentColor",
                    strokeWidth: "1.9",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }) : null,
            name === "vote" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.3 12.6 10 16.2 17.8 7.8",
                        stroke: "currentColor",
                        strokeWidth: "1.9",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5 19h14",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round"
                    })
                ]
            }) : null,
            name === "outcome" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8 20h8M12 16v4M7 5h10v4.8a5 5 0 0 1-10 0V5Z",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7 7H4.8v2.2A3.8 3.8 0 0 0 7 12.6M17 7h2.2v2.2a3.8 3.8 0 0 1-2.2 3.4",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : null,
            name === "quorum" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "8",
                        cy: "9",
                        r: "2.4",
                        stroke: "currentColor",
                        strokeWidth: "1.8"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "16",
                        cy: "9",
                        r: "2.4",
                        stroke: "currentColor",
                        strokeWidth: "1.8"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M4.8 18c.7-2.6 2.5-4 5.2-4M14 14c2.7 0 4.5 1.4 5.2 4",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round"
                    })
                ]
            }) : null,
            name === "list" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8 7h10M8 12h10M8 17h10",
                        stroke: "currentColor",
                        strokeWidth: "1.9",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5 7h.01M5 12h.01M5 17h.01",
                        stroke: "currentColor",
                        strokeWidth: "2.6",
                        strokeLinecap: "round"
                    })
                ]
            }) : null,
            name === "object" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.5 19V6.5h8V19M13.5 10h5V19",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.2 9h2.5M8.2 12h2.5M8.2 15h2.5",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round"
                    })
                ]
            }) : null,
            name === "status" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7 12h10M12 7v10",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "7",
                        stroke: "currentColor",
                        strokeWidth: "1.8"
                    })
                ]
            }) : null,
            name === "calendar" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6 8h12M8 5v3M16 5v3M6 6.5h12v12H6z",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }) : null,
            name === "trend" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5 16.5 9 12l3.3 3.1L18.8 7.5",
                        stroke: "currentColor",
                        strokeWidth: "1.9",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15 7.5h3.8v3.8",
                        stroke: "currentColor",
                        strokeWidth: "1.9",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : null,
            name === "action" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M9 5h10v10",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.5 5.5 8 16",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6 8v11h11",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : null
        ]
    });
const $848f7c387707f0c9$var$MetricLabel = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "dashboard-v2-metric-label",
        children: label
    });
const $848f7c387707f0c9$var$PanelTitle = ({ eyebrow: eyebrow, title: title, icon: icon })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "dashboard-v2-panel-title",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$DashboardIcon, {
                name: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "dashboard-v2-eyebrow",
                        children: eyebrow
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: title
                    })
                ]
            })
        ]
    });
const $848f7c387707f0c9$var$DashboardTableIcon = ({ name: name })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            name === "resolution" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.1 4.6h6.6l3.2 3.2v11.6H7.1z",
                        stroke: "currentColor",
                        strokeWidth: "1.85",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.7 4.8v3.1h3",
                        stroke: "currentColor",
                        strokeWidth: "1.85",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "m9.4 14.1 2 2 4.2-5",
                        stroke: "currentColor",
                        strokeWidth: "1.85",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "17.7",
                        cy: "17.8",
                        r: "2.1",
                        fill: "#fff",
                        stroke: "currentColor",
                        strokeWidth: "1.85"
                    })
                ]
            }) : null,
            name === "object" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M4.9 8.2h14.2v10.9H4.9z",
                        stroke: "currentColor",
                        strokeWidth: "1.8"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round"
                    })
                ]
            }) : null,
            name === "status" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 20 20",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "10",
                        cy: "10",
                        r: "5.9",
                        stroke: "currentColor",
                        strokeWidth: "1.7"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                        fill: "currentColor"
                    })
                ]
            }) : null,
            name === "calendar" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: "0 0 20 20",
                fill: "none",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M4.6 7.1h10.8M6.5 4.4v2.7M13.5 4.4v2.7M4.6 5.7h10.8v10H4.6z",
                    stroke: "currentColor",
                    strokeWidth: "1.7",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }) : null,
            name === "return" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 20 20",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15.2 7.2a5.8 5.8 0 1 0 .4 6.8",
                        stroke: "currentColor",
                        strokeWidth: "1.7",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "m14 4.7 2.3 2.5-2.5 2.3",
                        stroke: "currentColor",
                        strokeWidth: "1.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : null,
            name === "quorum" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 20 20",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "6.9",
                        cy: "7.6",
                        r: "2.1",
                        stroke: "currentColor",
                        strokeWidth: "1.7"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "13.1",
                        cy: "7.6",
                        r: "2.1",
                        stroke: "currentColor",
                        strokeWidth: "1.7"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M3.8 15.3c.6-2.2 2.2-3.4 4.4-3.4M11.8 11.9c2.2 0 3.8 1.2 4.4 3.4",
                        stroke: "currentColor",
                        strokeWidth: "1.7",
                        strokeLinecap: "round"
                    })
                ]
            }) : null,
            name === "actions" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 20 20",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "10",
                        cy: "5.3",
                        r: "1.4",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "10",
                        cy: "10",
                        r: "1.4",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "10",
                        cy: "14.7",
                        r: "1.4",
                        fill: "currentColor"
                    })
                ]
            }) : null
        ]
    });
const $848f7c387707f0c9$var$TableHeadLabel = ({ icon: icon, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "resolutions-v2-th-plain",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-icon",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$DashboardTableIcon, {
                    name: icon
                })
            }),
            children ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-label",
                children: children
            }) : null
        ]
    });
const $848f7c387707f0c9$var$QualitySymbol = ({ tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `dashboard-v2-quality-symbol dashboard-v2-quality-symbol--${tone}`,
        "aria-hidden": "true",
        children: tone === "critical" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12 7.2v6.1",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12 17h.01",
                    stroke: "currentColor",
                    strokeWidth: "2.6",
                    strokeLinecap: "round"
                })
            ]
        }) : tone === "warning" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12 10.7v5.7",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12 7.4h.01",
                    stroke: "currentColor",
                    strokeWidth: "2.6",
                    strokeLinecap: "round"
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m6.8 12.7 3.1 3.1 7.2-7.6",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
const $848f7c387707f0c9$var$KpiCard = ({ icon: icon, label: label, value: value, note: note, tone: tone = "neutral" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `dashboard-v2-kpi-card dashboard-v2-kpi-card--${tone}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$DashboardIcon, {
                name: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "dashboard-v2-kpi-copy",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: value
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "dashboard-v2-kpi-note",
                        children: note
                    })
                ]
            })
        ]
    });
const $848f7c387707f0c9$var$PercentBar = ({ items: items })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "dashboard-v2-segment-wrap",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dashboard-v2-segment-track",
                "aria-hidden": "true",
                children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: item.className,
                        style: {
                            width: `${Math.max(0, Math.min(100, item.value))}%`
                        }
                    }, item.label))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dashboard-v2-segment-legend",
                children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: item.className,
                                "aria-hidden": "true"
                            }),
                            item.label,
                            ": ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    $848f7c387707f0c9$var$percentFormat.format(item.value),
                                    " %"
                                ]
                            })
                        ]
                    }, item.label))
            })
        ]
    });
const $848f7c387707f0c9$var$ProgressBar = ({ value: value })=>{
    const progress = Math.max(0, Math.min(100, value));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "dashboard-v2-progress",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            style: {
                width: `${progress}%`
            }
        })
    });
};
const $848f7c387707f0c9$var$DeadlineLabel = ({ resolution: resolution })=>{
    if (resolution.status === "entwurf") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "dashboard-v2-deadline-neutral",
        children: "Noch nicht gestartet"
    });
    if (resolution.isCriticalAfterSecondReminder) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "dashboard-v2-deadline-critical",
        children: "Nach 2. Erinnerung"
    });
    if (!resolution.endedatum) return null;
    if (resolution.daysUntilEnd === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "dashboard-v2-deadline-neutral",
        children: $848f7c387707f0c9$var$formatDate(resolution.endedatum)
    });
    if (resolution.daysUntilEnd <= 3) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "dashboard-v2-deadline-warning",
        children: [
            resolution.daysUntilEnd,
            " Tage"
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "dashboard-v2-deadline-neutral",
        children: $848f7c387707f0c9$var$formatDate(resolution.endedatum)
    });
};
const $848f7c387707f0c9$export$fedd53519a0e2bce = ({ authUser: authUser })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { data: summary, isLoading: isLoading, isError: isError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "dashboard-summary-v2"
        ],
        queryFn: (0, $11320eb8d5d066e4$export$644d8ea042df96a6).dashboardSummary
    });
    const [openActionMenuId, setOpenActionMenuId] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const [qualityPermissionNotice, setQualityPermissionNotice] = (0, $acw62.useState)("");
    const [isCurrentResolutionsModalOpen, setIsCurrentResolutionsModalOpen] = (0, $acw62.useState)(false);
    const { actionMenuPosition: actionMenuPosition, openActionMenuAtTrigger: openActionMenuAtTrigger } = (0, $acf0971746b2c487$export$847509c5c6223f45)({
        openMenuId: openActionMenuId,
        setOpenMenuId: setOpenActionMenuId
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const handleMouseDown = (event)=>{
            if (!(0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) setOpenActionMenuId(null);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") setOpenActionMenuId(null);
        };
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("mousedown", handleMouseDown);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!openActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>setOpenActionMenuId(null)
    });
    const isFrameworkV2 = (0, $5806306cf67ca7cd$export$cc8e577c185b57cb)().management.uiFramework === "mockup_v2" || typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    if (!summary && isLoading) return null;
    if (!summary || isError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "panel dashboard-v2-loading",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: "Dashboard-Daten konnten nicht geladen werden."
        })
    });
    const voteItems = [
        {
            label: "Ja",
            value: summary.historicalMetrics.voteDistribution.ja,
            className: "dashboard-v2-segment--yes"
        },
        {
            label: "Nein",
            value: summary.historicalMetrics.voteDistribution.nein,
            className: "dashboard-v2-segment--no"
        },
        {
            label: "Enthaltung",
            value: summary.historicalMetrics.voteDistribution.enthaltung,
            className: "dashboard-v2-segment--abstain"
        }
    ];
    const completedOutcomeItems = [
        {
            label: "Angenommen",
            value: summary.historicalMetrics.completedOutcomes.angenommen,
            className: "dashboard-v2-segment--yes"
        },
        {
            label: "Abgelehnt",
            value: summary.historicalMetrics.completedOutcomes.abgelehnt,
            className: "dashboard-v2-segment--no"
        }
    ];
    const quorumItems = [
        {
            label: "Quorum erreicht",
            value: summary.historicalMetrics.quorumDistribution.erreicht,
            className: "dashboard-v2-segment--active"
        },
        {
            label: "Nicht erreicht",
            value: summary.historicalMetrics.quorumDistribution.nichtErreicht,
            className: "dashboard-v2-segment--no"
        }
    ];
    const criticalLabel = `${summary.kpis.criticalDeadlines} kritisch`;
    const displayedCurrentResolutions = summary.currentResolutions.slice(0, 2);
    const hasMoreCurrentResolutions = summary.currentResolutions.length > 2;
    const canOpenDebugQualityDetails = authUser.permissions.debug !== false;
    const handleQualityClick = (event, item)=>{
        const needsDebugAccess = item.key === "units_without_assignment" || item.key === "multiple_assignments";
        if (!needsDebugAccess) return;
        if (canOpenDebugQualityDetails) return;
        event.preventDefault();
        setQualityPermissionNotice("Bitte wenden Sie sich an den Administrator.");
    };
    const renderCurrentResolutionRows = (rows, context)=>rows.map((resolution)=>{
            const menuId = `${context}:${resolution.id}`;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                className: resolution.isCriticalAfterSecondReminder ? "is-critical" : "",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "dashboard-v2-resolution-cell",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: resolution.beschlussnummer
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dashboard-v2-cell-separator",
                                    children: "|"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: resolution.titel
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "dashboard-v2-object-cell",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: resolution.objektnummer
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dashboard-v2-cell-separator",
                                    children: "|"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: resolution.objektname || "-"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "dashboard-v2-current-table-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "dashboard-v2-center-body-cell",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `badge dashboard-v2-status-badge ${resolution.status === "aktiv" ? "aktiv" : "entwurf"}`,
                                children: $848f7c387707f0c9$var$statusLabel(resolution.status)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "dashboard-v2-current-table-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "dashboard-v2-center-body-cell",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$DeadlineLabel, {
                                resolution: resolution
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "dashboard-v2-current-table-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "dashboard-v2-return-cell",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        $848f7c387707f0c9$var$percentFormat.format(resolution.ruecklaufquote),
                                        " %"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$ProgressBar, {
                                    value: resolution.ruecklaufquote
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "resolutions-v2-action-wrap",
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "resolutions-v2-action-trigger",
                                    "aria-label": `Aktionen f\xfcr ${resolution.beschlussnummer}`,
                                    "aria-expanded": openActionMenuId === menuId,
                                    onMouseDown: (e)=>e.stopPropagation(),
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        if (openActionMenuId === menuId) {
                                            setOpenActionMenuId(null);
                                            return;
                                        }
                                        openActionMenuAtTrigger(menuId, e.currentTarget, 52);
                                    },
                                    children: "\u22EE"
                                }),
                                openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                    style: {
                                        left: actionMenuPosition.left,
                                        top: actionMenuPosition.top
                                    },
                                    onMouseDown: (e)=>e.stopPropagation(),
                                    onMouseEnter: ()=>setIsActionMenuHovered(true),
                                    onMouseLeave: ()=>setIsActionMenuHovered(false),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            setOpenActionMenuId(null);
                                            setIsCurrentResolutionsModalOpen(false);
                                            navigate(`/resolutions/${resolution.id}`);
                                        },
                                        children: "\xd6ffnen"
                                    })
                                }), document.body) : null
                            ]
                        })
                    })
                ]
            }, resolution.id);
        });
    const renderCurrentResolutionsTable = (rows, context)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "dashboard-v2-table-wrap",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                className: "dashboard-v2-current-table",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                className: "dashboard-v2-current-col-resolution"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                className: "dashboard-v2-current-col-object"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                className: "dashboard-v2-current-col-status"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                className: "dashboard-v2-current-col-deadline"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                className: "dashboard-v2-current-col-return"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                className: "dashboard-v2-current-col-actions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$TableHeadLabel, {
                                        icon: "resolution",
                                        children: "Beschluss"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$TableHeadLabel, {
                                        icon: "object",
                                        children: "Objekt"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "dashboard-v2-current-table-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "dashboard-v2-center-head-cell",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$TableHeadLabel, {
                                            icon: "status",
                                            children: "Status"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "dashboard-v2-current-table-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "dashboard-v2-center-head-cell",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$TableHeadLabel, {
                                            icon: "calendar",
                                            children: "Frist"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "dashboard-v2-current-table-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$TableHeadLabel, {
                                        icon: "return",
                                        children: "R\xfccklaufquote"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "resolutions-v2-actions-head",
                                    "aria-label": "Aktionen",
                                    title: "Aktionen",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$TableHeadLabel, {
                                        icon: "actions"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                        children: renderCurrentResolutionRows(rows, context)
                    })
                ]
            })
        });
    if (!isFrameworkV2) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "page-header panel",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            style: {
                                margin: 0
                            },
                            children: "Dashboard"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                            style: {
                                color: "#5a6875"
                            },
                            children: "Beschlusslage und Datenqualit\xe4t"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "kpi-grid",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kpi",
                        children: [
                            "Aktuelle Beschl\xfcsse",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: summary.kpis.currentResolutions
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kpi",
                        children: [
                            "R\xfccklauf gesamt",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    $848f7c387707f0c9$var$percentFormat.format(summary.kpis.totalReturnRate),
                                    " %"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kpi",
                        children: [
                            "Fristen im Blick",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: criticalLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kpi",
                        children: [
                            "Datenqualit\xe4t",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: summary.kpis.dataQualityIssues
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "dashboard-v2-page dashboard-v2-redesign",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "page-header panel resolutions-v2-page-header dashboard-v2-redesign-header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    className: "resolutions-v2-title",
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "resolutions-v2-title-icon",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M4.7 10.1 12 4.6l7.3 5.5v8.8h-5.1v-5h-4.4v5H4.7v-8.8Z",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M8 19h8",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "resolutions-v2-title-copy",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-main",
                                    children: "Dashboard"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-sub",
                                    children: "Beschlusslage und Datenqualit\xe4t"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "dashboard-v2-overview-grid",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "dashboard-v2-kpi-grid-redesign",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$KpiCard, {
                                icon: "current",
                                label: "Aktuelle Beschl\xfcsse",
                                value: $848f7c387707f0c9$var$numberFormat.format(summary.kpis.currentResolutions),
                                note: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "dashboard-v2-kpi-badge-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "dashboard-v2-kpi-note-badge dashboard-v2-kpi-note-badge--active",
                                            children: [
                                                $848f7c387707f0c9$var$numberFormat.format(summary.kpis.activeResolutions),
                                                " laufend"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "dashboard-v2-kpi-note-badge dashboard-v2-kpi-note-badge--draft",
                                            children: [
                                                $848f7c387707f0c9$var$numberFormat.format(summary.kpis.draftResolutions),
                                                " Entw\xfcrfe"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$KpiCard, {
                                icon: "return",
                                label: "R\xfccklauf gesamt",
                                value: `${$848f7c387707f0c9$var$percentFormat.format(summary.kpis.totalReturnRate)} %`,
                                note: "Durchschnitt aller Beschl\xfcsse"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$KpiCard, {
                                icon: "deadline",
                                label: "Fristen im Blick",
                                value: criticalLabel,
                                note: `Nach 2. Erinnerung ohne Quorum`,
                                tone: summary.kpis.criticalDeadlines > 0 ? "critical" : "ok"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$KpiCard, {
                                icon: "quality",
                                label: "Datenqualit\xe4t",
                                value: `${$848f7c387707f0c9$var$numberFormat.format(summary.kpis.dataQualityIssues)} Hinweise`,
                                note: "Vor Beschlussstart pr\xfcfen",
                                tone: summary.kpis.dataQualityIssues > 0 ? "warn" : "ok"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "panel dashboard-v2-analytics-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "dashboard-v2-panel-head",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$PanelTitle, {
                                    eyebrow: "Vergangenheit",
                                    title: "Beschlusslage",
                                    icon: "current"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "dashboard-v2-chart-stack",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "dashboard-v2-chart-title",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$MetricLabel, {
                                                        label: "Stimmenverteilung aller Beschl\xfcsse"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                        children: [
                                                            $848f7c387707f0c9$var$percentFormat.format(summary.historicalMetrics.averageReturnRate),
                                                            " % \xd8 R\xfccklauf"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$PercentBar, {
                                                items: voteItems
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "dashboard-v2-chart-title",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$MetricLabel, {
                                                        label: "Abgeschlossene Beschl\xfcsse"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Annahmequote"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$PercentBar, {
                                                items: completedOutcomeItems
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "dashboard-v2-chart-title",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$MetricLabel, {
                                                        label: "Quorum \xfcber alle Beschl\xfcsse"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Erreicht / nicht erreicht"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$PercentBar, {
                                                items: quorumItems
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "panel dashboard-v2-quality-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "dashboard-v2-panel-head",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$PanelTitle, {
                                    eyebrow: "Vor Beschlussstart",
                                    title: "Datenqualit\xe4t",
                                    icon: "quality"
                                })
                            }),
                            qualityPermissionNotice ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                role: "alert",
                                style: {
                                    marginBottom: 10,
                                    border: "1px solid #fecaca",
                                    borderRadius: 8,
                                    background: "#fff5f5",
                                    color: "#991b1b",
                                    fontWeight: 700,
                                    padding: "9px 11px"
                                },
                                children: qualityPermissionNotice
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "dashboard-v2-quality-list",
                                children: summary.dataQuality.map((item)=>{
                                    const isActionable = item.tone === "critical" || item.tone === "warning";
                                    const rowContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$QualitySymbol, {
                                                tone: item.tone
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "dashboard-v2-quality-main",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: item.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        children: item.count > 0 ? `${$848f7c387707f0c9$var$numberFormat.format(item.count)} Datens\xe4tze pr\xfcfen` : "Keine Auff\xe4lligkeiten"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `dashboard-v2-quality-badge dashboard-v2-quality-badge--${item.tone}`,
                                                children: $848f7c387707f0c9$var$qualityToneLabel(item.tone)
                                            }),
                                            isActionable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "dashboard-v2-quality-action",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$DashboardIcon, {
                                                    name: "arrow"
                                                })
                                            }) : null
                                        ]
                                    });
                                    if (!isActionable) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `dashboard-v2-quality-row dashboard-v2-quality-row--${item.tone}`,
                                        children: rowContent
                                    }, item.key);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: $848f7c387707f0c9$var$qualityTargetHref(item),
                                        className: `dashboard-v2-quality-row dashboard-v2-quality-row--action dashboard-v2-quality-row--${item.tone}`,
                                        onClick: (event)=>handleQualityClick(event, item),
                                        children: rowContent
                                    }, item.key);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel dashboard-v2-current-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "dashboard-v2-panel-head",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$PanelTitle, {
                            eyebrow: "Aktuell",
                            title: "Aktuelle, nicht abgeschlossene Beschl\xfcsse",
                            icon: "list"
                        })
                    }),
                    summary.currentResolutions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "dashboard-v2-empty-state",
                        children: "Keine laufenden oder im Entwurf befindlichen Beschl\xfcsse."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            renderCurrentResolutionsTable(displayedCurrentResolutions, "dashboard"),
                            hasMoreCurrentResolutions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "dashboard-v2-current-more",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setIsCurrentResolutionsModalOpen(true),
                                    children: "Weitere Beschl\xfcsse"
                                })
                            }) : null
                        ]
                    }),
                    isCurrentResolutionsModalOpen && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "modal-backdrop dashboard-v2-current-modal-backdrop",
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) {
                                setOpenActionMenuId(null);
                                setIsCurrentResolutionsModalOpen(false);
                            }
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "panel modal-card dashboard-v2-current-modal-card",
                            role: "dialog",
                            "aria-modal": "true",
                            "aria-label": "Alle aktuellen Beschl\xfcsse",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "dashboard-v2-current-modal-head",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($848f7c387707f0c9$var$PanelTitle, {
                                            eyebrow: "Aktuell",
                                            title: "Alle aktuellen Beschl\xfcsse",
                                            icon: "list"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "dashboard-v2-current-modal-close",
                                            "aria-label": "Fenster schlie\xdfen",
                                            onClick: ()=>{
                                                setOpenActionMenuId(null);
                                                setIsCurrentResolutionsModalOpen(false);
                                            },
                                            children: "\xd7"
                                        })
                                    ]
                                }),
                                renderCurrentResolutionsTable(summary.currentResolutions, "modal")
                            ]
                        })
                    }), document.body) : null
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");





var $8ecfcf98cb47c0ad$var$_client, $8ecfcf98cb47c0ad$var$_currentResult, $8ecfcf98cb47c0ad$var$_currentMutation, $8ecfcf98cb47c0ad$var$_mutateOptions, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$updateResult_fn, $8ecfcf98cb47c0ad$var$notify_fn;
var $8ecfcf98cb47c0ad$export$d3c1860ee66f291a = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_client);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_currentResult);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_currentMutation);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_mutateOptions);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).defaultMutationOptions(options);
        if (!(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $002159551d1c4551$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $002159551d1c4551$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentMutation, void 0);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_mutateOptions, options);
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentMutation, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().build((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client), this.options));
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).addObserver(this);
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).execute(variables);
    }
};
$8ecfcf98cb47c0ad$var$_client = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentResult = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentMutation = new WeakMap();
$8ecfcf98cb47c0ad$var$_mutateOptions = new WeakMap();
$8ecfcf98cb47c0ad$var$_MutationObserver_instances = new WeakSet();
$8ecfcf98cb47c0ad$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $96f19558542b246f$export$a1659b54bac3252a)();
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$8ecfcf98cb47c0ad$var$notify_fn = function(action) {
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult).variables;
            const onMutateResult = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult).context;
            const context = {
                client: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client),
                meta: this.options.meta,
                mutationKey: this.options.mutationKey
            };
            if ((action == null ? void 0 : action.type) === "success") {
                try {
                    (_b = (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    (_d = (_c = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            } else if ((action == null ? void 0 : action.type) === "error") {
                try {
                    (_f = (_e = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    (_h = (_g = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult));
        });
    });
};



"use client";
function $417dffbfea982a4c$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)(queryClient);
    const [observer] = $acw62.useState(()=>new (0, $8ecfcf98cb47c0ad$export$d3c1860ee66f291a)(client, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $798266f99c432533$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $002159551d1c4551$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $04ee75005957cfa3$export$f820a1ce9bd6ce21 = ({ open: open, title: title = "L\xf6schen best\xe4tigen", message: message, code: code, input: input, error: error, isPending: isPending, onClose: onClose, onInputChange: onInputChange, onErrorReset: onErrorReset, onConfirm: onConfirm, confirmLabel: confirmLabel = "L\xf6schen best\xe4tigen", pendingLabel: pendingLabel = "L\xf6sche..." })=>{
    const codeInputRefs = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const timer = setTimeout(()=>codeInputRefs.current[0]?.focus(), 0);
        return ()=>clearTimeout(timer);
    }, [
        open
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "modal-backdrop",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "panel modal-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    style: {
                        marginTop: 0,
                        marginBottom: 8
                    },
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    style: {
                        marginTop: 0
                    },
                    children: message
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    style: {
                        marginTop: 0
                    },
                    children: [
                        "Bitte gib zur Best\xe4tigung die folgende 4-stellige Sicherheitszahl ein:",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            style: {
                                marginLeft: 8
                            },
                            children: code
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            children: "Sicherheitszahl"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "security-code-grid",
                            children: input.map((digit, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    className: "security-code-input",
                                    inputMode: "numeric",
                                    maxLength: 1,
                                    value: digit,
                                    onChange: (e)=>{
                                        const nextDigit = e.target.value.replace(/\D/g, "").slice(-1);
                                        const nextInput = [
                                            ...input
                                        ];
                                        nextInput[index] = nextDigit;
                                        onInputChange(nextInput);
                                        onErrorReset?.();
                                        if (nextDigit && index < 3) codeInputRefs.current[index + 1]?.focus();
                                    },
                                    onKeyDown: (e)=>{
                                        if (e.key === "Backspace" && !input[index] && index > 0) codeInputRefs.current[index - 1]?.focus();
                                    },
                                    ref: (el)=>{
                                        codeInputRefs.current[index] = el;
                                    }
                                }, index))
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "error-text",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            disabled: isPending,
                            children: "Abbrechen"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onConfirm,
                            disabled: isPending,
                            children: isPending ? pendingLabel : confirmLabel
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");
const $b8c699f3967537fe$var$DATE_TIME_FORMATTER_DE = new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
});
const $b8c699f3967537fe$var$DATE_FIELD_KEY_PATTERN = /(createdat|updatedat|lastmodified|timestamp|letzte_aenderung|votereceivedat)/i;
const $b8c699f3967537fe$var$tryFormatDateTimeDE = (value)=>{
    if (typeof value !== "string") return null;
    const trimmed = value.trim();
    if (!trimmed) return null;
    const parsed = new Date(trimmed);
    if (Number.isNaN(parsed.getTime())) return null;
    return $b8c699f3967537fe$var$DATE_TIME_FORMATTER_DE.format(parsed);
};
const $b8c699f3967537fe$var$renderDefaultCellValue = (row, columnKey)=>{
    const raw = row[columnKey];
    const key = String(columnKey ?? "");
    if ($b8c699f3967537fe$var$DATE_FIELD_KEY_PATTERN.test(key)) {
        const formatted = $b8c699f3967537fe$var$tryFormatDateTimeDE(raw);
        if (formatted) return formatted;
    }
    return String(raw ?? "");
};
const $b8c699f3967537fe$var$ActionColumnIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "table-actions-head-icon",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "5.3",
                    r: "1.4",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "10",
                    r: "1.4",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "14.7",
                    r: "1.4",
                    fill: "currentColor"
                })
            ]
        })
    });
const $b8c699f3967537fe$var$isActionColumnKey = (key)=>String(key ?? "").toLowerCase() === "actions";
function $b8c699f3967537fe$export$26c4b03ab5e2b7eb({ columns: columns, rows: rows, total: total, page: page, pageSize: pageSize, onPageChange: onPageChange, bodyMaxHeight: bodyMaxHeight = 420, topContent: topContent }) {
    const totalPages = (0, $acw62.useMemo)(()=>Math.max(1, Math.ceil(total / pageSize)), [
        total,
        pageSize
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "panel",
        children: [
            topContent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginBottom: 10
                },
                children: topContent
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginBottom: 8,
                    fontSize: 12,
                    color: "#5a6875"
                },
                children: [
                    "Zeilen: ",
                    rows.length,
                    " / Gesamt: ",
                    total
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    overflowX: "auto",
                    overflowY: "visible",
                    maxHeight: bodyMaxHeight
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                children: columns.map((c)=>{
                                    const isActionColumn = $b8c699f3967537fe$var$isActionColumnKey(c.key);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: isActionColumn ? "table-actions-head-cell" : undefined,
                                        style: {
                                            textAlign: isActionColumn ? "center" : c.align ?? "left",
                                            width: isActionColumn ? c.width ?? 54 : c.width
                                        },
                                        "aria-label": isActionColumn ? "Aktionen" : undefined,
                                        title: isActionColumn ? "Aktionen" : undefined,
                                        children: isActionColumn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b8c699f3967537fe$var$ActionColumnIcon, {}) : c.label
                                    }, String(c.key));
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: rows.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: columns.map((c)=>{
                                        const isActionColumn = $b8c699f3967537fe$var$isActionColumnKey(c.key);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: isActionColumn ? "table-actions-cell" : undefined,
                                            style: {
                                                textAlign: isActionColumn ? "center" : c.align ?? "left",
                                                width: isActionColumn ? c.width ?? 54 : c.width
                                            },
                                            children: isActionColumn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "table-actions-cell-axis",
                                                children: c.render ? c.render(row) : $b8c699f3967537fe$var$renderDefaultCellValue(row, c.key)
                                            }) : c.render ? c.render(row) : $b8c699f3967537fe$var$renderDefaultCellValue(row, c.key)
                                        }, String(c.key));
                                    })
                                }, index))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: 10,
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>onPageChange(Math.max(1, page - 1)),
                        disabled: page <= 1,
                        children: "Zur\xfcck"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            fontSize: 13
                        },
                        children: [
                            "Seite ",
                            page,
                            " / ",
                            totalPages
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>onPageChange(Math.min(totalPages, page + 1)),
                        disabled: page >= totalPages,
                        children: "Weiter"
                    })
                ]
            })
        ]
    });
}



const $58e497c17bb81d81$var$formatNumberDE = (value)=>new Intl.NumberFormat("de-DE").format(value);
const $58e497c17bb81d81$export$d0dbe21c1273a9ae = ({ canCreate: canCreate = false, canUpdate: canUpdate = false, canDelete: canDelete = false })=>{
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [pageSize, setPageSize] = (0, $acw62.useState)(10);
    const [page, setPage] = (0, $acw62.useState)(1);
    const [search, setSearch] = (0, $acw62.useState)("");
    const [debouncedSearch, setDebouncedSearch] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("aktiv");
    const [digitalOnly, setDigitalOnly] = (0, $acw62.useState)("");
    const [sortBy, setSortBy] = (0, $acw62.useState)("objektnummer");
    const [sortDir, setSortDir] = (0, $acw62.useState)("asc");
    const [openActionMenuId, setOpenActionMenuId] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const [showCreate, setShowCreate] = (0, $acw62.useState)(false);
    const [createError, setCreateError] = (0, $acw62.useState)("");
    const [editError, setEditError] = (0, $acw62.useState)("");
    const [actionError, setActionError] = (0, $acw62.useState)("");
    const [deleteConfirm, setDeleteConfirm] = (0, $acw62.useState)(null);
    const [form, setForm] = (0, $acw62.useState)({
        objektnummer: "",
        objektname: "",
        strasse: "",
        strasse2: "",
        plz: "",
        ort: "",
        standard_stimmrechtsart: "",
        status: ""
    });
    const [editForm, setEditForm] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const handle = window.setTimeout(()=>setDebouncedSearch(search.trim()), 450);
        return ()=>window.clearTimeout(handle);
    }, [
        search
    ]);
    const { data: data, isError: isError, isFetching: isFetching } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "objects",
            page,
            pageSize,
            debouncedSearch,
            status,
            digitalOnly,
            sortBy,
            sortDir
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).objects({
                page: page,
                pageSize: pageSize,
                search: debouncedSearch,
                status: status || undefined,
                digitalOnly: digitalOnly || undefined,
                sortBy: sortBy,
                sortDir: sortDir
            }),
        placeholderData: (previousData)=>previousData,
        staleTime: 15000
    });
    const { data: activeResolutions } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "active-resolutions-lock"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: 1,
                pageSize: 500,
                status: "aktiv"
            })
    });
    const { data: uiSettings } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-objects"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings()
    });
    const faciliooEnabled = uiSettings?.management?.faciliooEnabled !== false;
    const { data: faciliooSyncStatus } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "facilioo-sync-status-objects"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).getFaciliooSyncStatus(),
        enabled: faciliooEnabled,
        staleTime: 30000
    });
    const lockedObjectIds = (0, $acw62.useMemo)(()=>new Set((activeResolutions?.data ?? []).map((r)=>r.objectId)), [
        activeResolutions?.data
    ]);
    (0, $acw62.useEffect)(()=>{
        setPage(1);
    }, [
        search,
        status,
        digitalOnly,
        sortBy,
        sortDir,
        pageSize
    ]);
    (0, $acw62.useEffect)(()=>{
        setOpenActionMenuId(null);
    }, [
        page,
        search,
        status,
        digitalOnly,
        sortBy,
        sortDir,
        showCreate,
        editForm
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = (event)=>{
            if (event && (0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            setOpenActionMenuId(null);
        };
        const handleEscape = (event)=>{
            if (event.key === "Escape") closeMenu();
        };
        window.addEventListener("mousedown", closeMenu);
        window.addEventListener("keydown", handleEscape);
        return ()=>{
            window.removeEventListener("mousedown", closeMenu);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!openActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>setOpenActionMenuId(null),
        timeoutMs: 3000
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) setIsActionMenuHovered(false);
    }, [
        openActionMenuId
    ]);
    const { actionMenuPosition: actionMenuPosition, openActionMenuAtTrigger: openActionMenuAtTrigger } = (0, $acf0971746b2c487$export$847509c5c6223f45)({
        openMenuId: openActionMenuId,
        setOpenMenuId: setOpenActionMenuId
    });
    (0, $acw62.useEffect)(()=>{
        // Nur korrigieren, wenn die Server-Meta wirklich geladen ist.
        // Sonst springt die UI beim Seitenwechsel kurz auf Seite 1 zurück.
        const total = data?.meta?.total;
        const serverPage = data?.meta?.page;
        if (typeof total !== "number" || typeof serverPage !== "number") return;
        if (serverPage !== page) return;
        const totalPages = Math.max(1, Math.ceil(total / pageSize));
        if (page > totalPages && (data?.data?.length ?? 0) === 0) setPage(totalPages);
    }, [
        data?.meta?.total,
        data?.meta?.page,
        data?.data?.length,
        page,
        pageSize
    ]);
    const createMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).createObject({
                objektnummer: form.objektnummer,
                objektname: form.objektname,
                strasse: form.strasse,
                strasse2: form.strasse2.trim() || undefined,
                plz: form.plz,
                ort: form.ort,
                standard_stimmrechtsart: form.standard_stimmrechtsart || undefined,
                status: form.status
            }),
        onSuccess: async ()=>{
            setCreateError("");
            setShowCreate(false);
            setForm({
                objektnummer: "",
                objektname: "",
                strasse: "",
                strasse2: "",
                plz: "",
                ort: "",
                standard_stimmrechtsart: "",
                status: ""
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "objects"
                ]
            });
            setPage(1);
        },
        onError: (error)=>setCreateError(error instanceof Error ? error.message : "Anlage fehlgeschlagen")
    });
    const editMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!editForm) throw new Error("Kein Datensatz ausgew\xe4hlt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateObject(editForm.id, {
                objektnummer: editForm.objektnummer,
                objektname: editForm.objektname,
                strasse: editForm.strasse,
                strasse2: editForm.strasse2.trim() || undefined,
                plz: editForm.plz,
                ort: editForm.ort,
                standard_stimmrechtsart: editForm.standard_stimmrechtsart || undefined,
                status: editForm.status
            });
        },
        onSuccess: async ()=>{
            setEditError("");
            setEditForm(null);
            await queryClient.invalidateQueries({
                queryKey: [
                    "objects"
                ]
            });
        },
        onError: (error)=>setEditError(error instanceof Error ? error.message : "Bearbeitung fehlgeschlagen")
    });
    const deleteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).deactivateObject(id),
        onSuccess: async ()=>{
            setDeleteConfirm(null);
            setActionError("");
            await queryClient.invalidateQueries({
                queryKey: [
                    "objects"
                ]
            });
        },
        onError: (error)=>setActionError(error instanceof Error ? error.message : "L\xf6schen fehlgeschlagen")
    });
    const toggleSort = (field)=>{
        if (sortBy === field) {
            setSortDir((prev)=>prev === "asc" ? "desc" : "asc");
            return;
        }
        setSortBy(field);
        setSortDir("asc");
    };
    const sortLabel = (field, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: ()=>toggleSort(field),
            style: {
                border: "none",
                background: "transparent",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                font: "inherit",
                color: "inherit",
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                gap: 6
            },
            title: sortBy === field ? `Sortierung: ${sortDir === "asc" ? "aufsteigend" : "absteigend"}` : "Sortierung aktivieren",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
                })
            ]
        });
    const columns = (0, $acw62.useMemo)(()=>[
            {
                key: "objektnummer",
                label: "Objekt\u2011Nr",
                align: "center",
                width: 92,
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: `/objects/${r.id}`,
                        className: "badge object-ref",
                        style: {
                            textDecoration: "none"
                        },
                        children: r.objektnummer
                    })
            },
            {
                key: "objektname",
                label: sortLabel("objektname", "Objektname"),
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8,
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: r.objektname
                            }),
                            Number(r.anzahl_nicht_digital_erreichbar ?? 0) === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "badge aktiv",
                                style: {
                                    fontSize: 11,
                                    padding: "2px 8px"
                                },
                                children: "100 % digital"
                            }) : null
                        ]
                    })
            },
            {
                key: "anzahl_einheiten",
                label: sortLabel("anzahl_einheiten", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Einheiten",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Objekt"
                    ]
                })),
                align: "center"
            },
            {
                key: "anzahl_eigentuemer",
                label: sortLabel("anzahl_eigentuemer", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Eigent\xfcmer im",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Objekt | K\xf6pfe"
                    ]
                })),
                align: "center"
            },
            {
                key: "anzahl_nicht_digital_erreichbar",
                label: sortLabel("anzahl_nicht_digital_erreichbar", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Nicht digital",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "erreichbar"
                    ]
                })),
                align: "center"
            },
            {
                key: "stimmrecht_summe",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Stimmrechte",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Objekt"
                    ]
                }),
                width: 154,
                align: "center",
                render: (r)=>{
                    const value = Number(r.stimmrecht_summe ?? 0);
                    return value > 0 ? value : "-";
                }
            },
            {
                key: "mea_summe",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "MEA",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Objekt"
                    ]
                }),
                width: 126,
                align: "center"
            },
            {
                key: "status",
                label: "Status",
                align: "center",
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge ${r.status}`,
                        children: r.status
                    })
            },
            {
                key: "actions",
                label: "Aktionen",
                render: (r)=>{
                    if (!canUpdate && !canDelete) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            color: "var(--text-soft)"
                        },
                        children: "-"
                    });
                    const locked = lockedObjectIds.has(r.id);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: 6,
                            alignItems: "center"
                        },
                        children: [
                            canUpdate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>openEditForm(r),
                                disabled: locked,
                                title: locked ? "Gesperrt wegen aktivem Umlaufbeschluss" : undefined,
                                children: "Bearbeiten"
                            }) : null,
                            canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    if (locked) {
                                        setActionError("Objekt ist wegen aktivem Umlaufbeschluss gesperrt.");
                                        return;
                                    }
                                    setDeleteConfirm({
                                        id: r.id,
                                        label: `${r.objektnummer} - ${r.objektname}`,
                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                        input: [
                                            "",
                                            "",
                                            "",
                                            ""
                                        ],
                                        error: ""
                                    });
                                },
                                disabled: locked || deleteMutation.isPending,
                                title: locked ? "L\xf6schen bei aktivem Umlaufbeschluss gesperrt" : undefined,
                                children: "L\xf6schen"
                            }) : null,
                            locked && (canUpdate || canDelete) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "lock-indicator",
                                title: "Gesperrt wegen aktivem Umlaufbeschluss",
                                children: "\uD83D\uDD12"
                            }) : null
                        ]
                    });
                }
            }
        ], [
        canDelete,
        canUpdate,
        deleteMutation.isPending,
        lockedObjectIds,
        sortBy,
        sortDir
    ]);
    const canCreateForm = form.objektnummer.trim() && form.objektname.trim() && form.strasse.trim() && form.plz.trim() && form.ort.trim() && form.status;
    const canEdit = editForm && editForm.objektnummer.trim() && editForm.objektname.trim() && editForm.strasse.trim() && editForm.plz.trim() && editForm.ort.trim();
    const isObjectFormActive = showCreate || Boolean(editForm);
    const hasNoObjects = (data?.meta?.total ?? 0) === 0 && !isFetching;
    const lastSyncFailed = faciliooEnabled && faciliooSyncStatus?.lastRun?.ok === false;
    const lastSyncTimestamp = faciliooSyncStatus?.lastRun?.finishedAt || faciliooSyncStatus?.lastRun?.startedAt;
    const rows = data?.data ?? [];
    const totalRows = data?.meta.total ?? 0;
    const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
    const isFrameworkV2 = uiSettings?.management?.uiFramework === "mockup_v2" || typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    const fixedViewportListLayout = isFrameworkV2 && !isObjectFormActive;
    const pageItems = (0, $acw62.useMemo)(()=>{
        if (totalPages <= 1) return [
            1
        ];
        const start = Math.max(1, page - 1);
        const end = Math.min(totalPages, start + 2);
        const adjustedStart = Math.max(1, end - 2);
        return Array.from({
            length: end - adjustedStart + 1
        }, (_, i)=>adjustedStart + i);
    }, [
        page,
        totalPages
    ]);
    const openEditForm = (row)=>{
        setEditForm({
            id: row.id,
            objektnummer: row.objektnummer,
            objektname: row.objektname,
            strasse: row.strasse,
            strasse2: row.strasse2 ?? "",
            plz: row.plz,
            ort: row.ort,
            standard_stimmrechtsart: row.standard_stimmrechtsart ?? "",
            status: row.status
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (!canUpdate) return;
        const navState = location.state;
        const targetId = navState?.editObjectId;
        if (!targetId || !rows.length) return;
        const match = rows.find((row)=>row.id === targetId);
        if (!match) return;
        openEditForm(match);
        window.history.replaceState({}, document.title);
    }, [
        canUpdate,
        location.state,
        rows
    ]);
    const resetListFilters = ()=>{
        setSearch("");
        setStatus("aktiv");
        setDigitalOnly("");
        setSortBy("objektnummer");
        setSortDir("asc");
        setPage(1);
    };
    const renderSortIndicator = (field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "resolutions-v2-sort-indicator",
            "aria-hidden": "true",
            children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
        });
    const renderV2SortHeader = (field, label, icon)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            className: "resolutions-v2-th-sort",
            onClick: ()=>toggleSort(field),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-icon",
                    "aria-hidden": "true",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-label",
                    children: label
                }),
                renderSortIndicator(field)
            ]
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: fixedViewportListLayout ? "resolutions-v2-page" : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `page-header panel ${isFrameworkV2 ? "resolutions-v2-page-header" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: isFrameworkV2 ? "resolutions-v2-title" : "",
                        style: {
                            margin: 0
                        },
                        children: [
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-title-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M4.9 8.2h14.2v10.9H4.9z",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round"
                                        })
                                    ]
                                })
                            }) : null,
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "resolutions-v2-title-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-main",
                                        children: "Objekte"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-sub",
                                        children: "\xdcbersicht aller Objekte und Basisdaten"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Objekte"
                            })
                        ]
                    }),
                    canCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: isFrameworkV2 ? "resolutions-v2-create-btn" : "",
                        onClick: ()=>setShowCreate((v)=>!v),
                        children: [
                            isFrameworkV2 && !showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-create-btn-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M10 4.2v11.6M4.2 10h11.6",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round"
                                    })
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: showCreate ? "Schlie\xdfen" : "Neues Objekt"
                            })
                        ]
                    }) : null
                ]
            }),
            canCreate && showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Objekt anlegen"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Objektnummer*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.objektnummer,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                objektnummer: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Objektname*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.objektname,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                objektname: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stra\xdfe*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.strasse,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                strasse: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stra\xdfe 2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.strasse2,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                strasse2: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "PLZ*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.plz,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                plz: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Ort*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.ort,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                ort: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Standard Stimmrechtsart"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.standard_stimmrechtsart,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                standard_stimmrechtsart: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Automatisch (aus Einheiten)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "kopf",
                                                children: "Kopfstimmen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "stimmrecht",
                                                children: "Stimmrecht"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "mea",
                                                children: "MEA"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Status*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.status,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                status: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Status w\xe4hlen*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !canCreateForm || createMutation.isPending,
                                onClick: ()=>createMutation.mutate(),
                                children: createMutation.isPending ? "Speichere..." : "Objekt speichern"
                            }),
                            createError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: createError
                            }) : null
                        ]
                    })
                ]
            }) : null,
            !showCreate && canUpdate && editForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Objekt bearbeiten"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Objektnummer*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.objektnummer,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                objektnummer: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Objektname*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.objektname,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                objektname: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stra\xdfe*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.strasse,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                strasse: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stra\xdfe 2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.strasse2,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                strasse2: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "PLZ*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.plz,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                plz: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Ort*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.ort,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                ort: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Standard Stimmrechtsart"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.standard_stimmrechtsart,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                standard_stimmrechtsart: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Automatisch (aus Einheiten)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "kopf",
                                                children: "Kopfstimmen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "stimmrecht",
                                                children: "Stimmrecht"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "mea",
                                                children: "MEA"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.status,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                status: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !canEdit || editMutation.isPending,
                                onClick: ()=>editMutation.mutate(),
                                children: editMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setEditForm(null),
                                children: "Abbrechen"
                            }),
                            editError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: editError
                            }) : null
                        ]
                    })
                ]
            }) : null,
            !isObjectFormActive && isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel",
                children: "Fehler beim Laden der Objekte."
            }) : null,
            !isObjectFormActive && isFetching && !isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel",
                children: "Objekte werden geladen..."
            }) : null,
            !isObjectFormActive && hasNoObjects && lastSyncFailed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel error-text",
                children: [
                    "Keine Objektdaten vorhanden. Der letzte Facilioo-Sync ist fehlgeschlagen",
                    lastSyncTimestamp ? ` (${new Date(lastSyncTimestamp).toLocaleString("de-DE")})` : "",
                    ". Bitte Facilioo-Verbindung pr\xfcfen und Sync erneut starten."
                ]
            }) : null,
            !isObjectFormActive && actionError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel error-text",
                children: actionError
            }) : null,
            !isObjectFormActive ? isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel resolutions-v2-list-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-filterbar",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-filter-fields",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "resolutions-v2-filter-input",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-filter-icon",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 20 20",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                            cx: "9",
                                                            cy: "9",
                                                            r: "5.6",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "m13.1 13.1 3.4 3.4",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                placeholder: "Suche...",
                                                value: search,
                                                onChange: (e)=>setSearch(e.target.value)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: status,
                                        onChange: (e)=>setStatus(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: digitalOnly,
                                        onChange: (e)=>setDigitalOnly(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Objekte"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "1",
                                                children: "Digitale Objekte"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "0",
                                                children: "Analoge Objekte"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                className: "resolutions-v2-reset-btn",
                                onClick: resetListFilters,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-reset-btn-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M5.1 6.3a6.3 6.3 0 1 1-1.3 6.8",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.7",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M4.9 3.9v3.4h3.4",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.7",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        })
                                    }),
                                    "Filter zur\xfccksetzen"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-row-count",
                        children: [
                            "Zeilen: ",
                            rows.length,
                            " / Gesamt: ",
                            totalRows
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "resolutions-v2-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "resolutions-v2-table objects-v2-table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "126px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "440px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "126px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "198px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "154px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "126px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "112px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "92px"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "resolutions-v2-th-plain",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-th-icon",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                viewBox: "0 0 20 20",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M6.2 5.2h7.6v9.6H6.2z",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.7"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M6.2 8.4h7.6M6.2 11.6h7.6M9.4 5.2v9.6M12.6 5.2v9.6",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.4"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-th-label",
                                                            children: "Objekt\u2011Nr"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: renderV2SortHeader("objektname", "Objektname", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 20 20",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M4.2 7.3h11.6v8.5H4.2z",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M6.8 4.7h6.4v2.6H6.8zM6.9 10.3h2.1M10.9 10.3H13M6.9 13.2h2.1M10.9 13.2H13",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7",
                                                            strokeLinecap: "round"
                                                        })
                                                    ]
                                                }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: renderV2SortHeader("anzahl_einheiten", "Einheiten", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 20 20",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                            x: "4",
                                                            y: "3.9",
                                                            width: "12",
                                                            height: "12.2",
                                                            rx: "1.6",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M7 7.4h2.1M10.9 7.4H13M7 10h2.1M10.9 10H13M7 12.6h2.1M10.9 12.6H13",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7",
                                                            strokeLinecap: "round"
                                                        })
                                                    ]
                                                }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: renderV2SortHeader("anzahl_eigentuemer", "Eigent\xfcmer", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 20 20",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                            cx: "7.2",
                                                            cy: "7",
                                                            r: "2",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                            cx: "12.8",
                                                            cy: "7",
                                                            r: "2",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M3.8 14.6a4.2 4.2 0 0 1 6.8 0M9.4 14.6a4.2 4.2 0 0 1 6.8 0",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7",
                                                            strokeLinecap: "round"
                                                        })
                                                    ]
                                                }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: renderV2SortHeader("anzahl_nicht_digital_erreichbar", "Nicht digital", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 20 20",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                            x: "5.4",
                                                            y: "2.8",
                                                            width: "9.2",
                                                            height: "14.4",
                                                            rx: "1.9",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M8.1 5.8h3.8M7.4 14.1l5.2-5.2",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7",
                                                            strokeLinecap: "round"
                                                        })
                                                    ]
                                                }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "resolutions-v2-th-plain",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-th-icon",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                viewBox: "0 0 20 20",
                                                                fill: "none",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M4.1 15.9h11.8M5.6 15.9V9.4M10 15.9V6.7M14.4 15.9V4.1",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.7",
                                                                    strokeLinecap: "round"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-th-label",
                                                            children: "Stimmrechte"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "resolutions-v2-th-plain",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-th-icon",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                viewBox: "0 0 20 20",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M10 3.7 15.3 6.8v6.4L10 16.3l-5.3-3.1V6.8L10 3.7Z",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.7",
                                                                        strokeLinejoin: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M10 3.7v12.6M4.7 6.8 10 10l5.3-3.2",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.7",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-th-label",
                                                            children: "MEA"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "resolutions-v2-th-plain",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-th-icon",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                viewBox: "0 0 20 20",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                        cx: "10",
                                                                        cy: "10",
                                                                        r: "5.9",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.7"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                                                                        fill: "currentColor"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-th-label",
                                                            children: "Status"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "resolutions-v2-actions-head",
                                                "aria-label": "Aktionen",
                                                title: "Aktionen",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "resolutions-v2-th-plain",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-th-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                            viewBox: "0 0 20 20",
                                                            fill: "none",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "10",
                                                                    cy: "5.3",
                                                                    r: "1.4",
                                                                    fill: "currentColor"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "10",
                                                                    cy: "10",
                                                                    r: "1.4",
                                                                    fill: "currentColor"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "10",
                                                                    cy: "14.7",
                                                                    r: "1.4",
                                                                    fill: "currentColor"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: rows.map((r)=>{
                                        const locked = lockedObjectIds.has(r.id);
                                        const menuId = r.id;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                        to: `/objects/${r.id}`,
                                                        className: "badge object-number",
                                                        style: {
                                                            textDecoration: "none"
                                                        },
                                                        children: r.objektnummer
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "resolutions-v2-object-cell",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 8,
                                                            flexWrap: "wrap"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: r.objektname
                                                            }),
                                                            Number(r.anzahl_nicht_digital_erreichbar ?? 0) === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "badge aktiv",
                                                                style: {
                                                                    fontSize: 11,
                                                                    padding: "2px 8px"
                                                                },
                                                                children: "100 % digital"
                                                            }) : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: r.anzahl_einheiten ?? "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: r.anzahl_eigentuemer ?? "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: r.anzahl_nicht_digital_erreichbar ?? "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: Number(r.stimmrecht_summe ?? 0) > 0 ? $58e497c17bb81d81$var$formatNumberDE(Number(r.stimmrecht_summe ?? 0)) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: Number(r.mea_summe ?? 0) > 0 ? $58e497c17bb81d81$var$formatNumberDE(Number(r.mea_summe ?? 0)) : "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `badge ${r.status}`,
                                                        children: r.status
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "resolutions-v2-action-wrap",
                                                        onClick: (e)=>e.stopPropagation(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "resolutions-v2-action-trigger",
                                                                "aria-label": `Aktionen f\xfcr Objekt ${r.objektnummer}`,
                                                                "aria-expanded": openActionMenuId === menuId,
                                                                onMouseDown: (e)=>e.stopPropagation(),
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    if (openActionMenuId === menuId) {
                                                                        setOpenActionMenuId(null);
                                                                        return;
                                                                    }
                                                                    openActionMenuAtTrigger(menuId, e.currentTarget, canUpdate && canDelete ? 96 : 52);
                                                                },
                                                                children: "\u22EE"
                                                            }),
                                                            openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                style: {
                                                                    left: actionMenuPosition.left,
                                                                    top: actionMenuPosition.top
                                                                },
                                                                onMouseDown: (e)=>e.stopPropagation(),
                                                                onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                children: [
                                                                    canUpdate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        disabled: locked,
                                                                        onClick: ()=>{
                                                                            if (locked) {
                                                                                setActionError("Objekt ist wegen aktivem Umlaufbeschluss gesperrt.");
                                                                                setOpenActionMenuId(null);
                                                                                return;
                                                                            }
                                                                            openEditForm(r);
                                                                            setOpenActionMenuId(null);
                                                                        },
                                                                        children: "Bearbeiten"
                                                                    }) : null,
                                                                    canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        disabled: locked || deleteMutation.isPending,
                                                                        onClick: ()=>{
                                                                            if (locked) {
                                                                                setActionError("Objekt ist wegen aktivem Umlaufbeschluss gesperrt.");
                                                                                setOpenActionMenuId(null);
                                                                                return;
                                                                            }
                                                                            setDeleteConfirm({
                                                                                id: r.id,
                                                                                label: `${r.objektnummer} - ${r.objektname}`,
                                                                                code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                input: [
                                                                                    "",
                                                                                    "",
                                                                                    "",
                                                                                    ""
                                                                                ],
                                                                                error: ""
                                                                            });
                                                                            setOpenActionMenuId(null);
                                                                        },
                                                                        children: "L\xf6schen"
                                                                    }) : null
                                                                ]
                                                            }), document.body) : null
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, r.id);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-pagination",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-page-size",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: String(pageSize),
                                    onChange: (e)=>{
                                        const next = Number(e.target.value);
                                        setPageSize(Number.isFinite(next) && next > 0 ? next : 10);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "10",
                                            children: "10 pro Seite"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "20",
                                            children: "20 pro Seite"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "50",
                                            children: "50 pro Seite"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-page-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "resolutions-v2-page-arrow",
                                        onClick: ()=>setPage((prev)=>Math.max(1, prev - 1)),
                                        disabled: page <= 1,
                                        children: "\u2039"
                                    }),
                                    pageItems.map((pageItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: `resolutions-v2-page-chip ${pageItem === page ? "active" : ""}`,
                                            onClick: ()=>setPage(pageItem),
                                            children: pageItem
                                        }, pageItem)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "resolutions-v2-page-arrow",
                                        onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                        disabled: page >= totalPages,
                                        children: "\u203A"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "resolutions-v2-page-info",
                                        children: [
                                            "Seite ",
                                            page,
                                            " von ",
                                            totalPages
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-page-next-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    className: "resolutions-v2-next-btn",
                                    onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                    disabled: page >= totalPages,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Weiter"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            children: "\u203A"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                columns: columns,
                rows: rows,
                total: totalRows,
                page: page,
                pageSize: pageSize,
                onPageChange: setPage,
                bodyMaxHeight: 560,
                topContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "filterbar",
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            placeholder: "Suche",
                            value: search,
                            onChange: (e)=>setSearch(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: digitalOnly,
                            onChange: (e)=>setDigitalOnly(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Alle Objekte"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "1",
                                    children: "Digitale Objekte"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "0",
                                    children: "Analoge Objekte"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: status,
                            onChange: (e)=>setStatus(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Alle Status"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "aktiv",
                                    children: "Aktiv"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "inaktiv",
                                    children: "Inaktiv"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                open: !!deleteConfirm,
                message: deleteConfirm ? `Objekt ${deleteConfirm.label} soll gel\xf6scht werden.` : "",
                code: deleteConfirm?.code ?? "",
                input: deleteConfirm?.input ?? [
                    "",
                    "",
                    "",
                    ""
                ],
                error: deleteConfirm?.error,
                isPending: deleteMutation.isPending,
                onClose: ()=>setDeleteConfirm(null),
                onInputChange: (next)=>{
                    if (!deleteConfirm) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        input: next
                    });
                },
                onErrorReset: ()=>{
                    if (!deleteConfirm || !deleteConfirm.error) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        error: ""
                    });
                },
                onConfirm: ()=>{
                    if (!deleteConfirm) return;
                    const enteredCode = deleteConfirm.input.join("");
                    if (enteredCode !== deleteConfirm.code) {
                        setDeleteConfirm({
                            ...deleteConfirm,
                            error: "Sicherheitscode falsch eingegeben."
                        });
                        return;
                    }
                    deleteMutation.mutate(deleteConfirm.id);
                }
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");






const $f336a13bdd60accb$export$4b74ea5d724dd45 = [
    "wohnung",
    "sonstiges",
    "gewerbeeinheit",
    "aufzug",
    "stellplatz",
    "fond",
    "allgemeines"
];
const $f336a13bdd60accb$var$LABELS = {
    wohnung: "Wohnung",
    sonstiges: "Sonstiges",
    gewerbeeinheit: "Gewerbeeinheit",
    aufzug: "Aufzug",
    stellplatz: "Stellplatz",
    fond: "Fond",
    allgemeines: "Allgemeines"
};
const $f336a13bdd60accb$export$a10aac408d86876b = (raw)=>{
    const key = String(raw ?? "").trim().toLowerCase();
    if (!key) return "-";
    return $f336a13bdd60accb$var$LABELS[key] ?? key.charAt(0).toUpperCase() + key.slice(1);
};


const $f18f15d2e4dddb8c$export$a178e7e76e7a8f20 = [
    {
        definition: "Frau",
        mapping: "frau, fr, fr.",
        briefanrede_1: "Sehr geehrte Frau",
        briefanrede_2: ""
    },
    {
        definition: "Herrn",
        mapping: "herr, herrn, hr, hr.",
        briefanrede_1: "Sehr geehrter Herr",
        briefanrede_2: ""
    },
    {
        definition: "Frau / Frau",
        mapping: "frau/frau, frau und frau",
        briefanrede_1: "Sehr geehrte Frau",
        briefanrede_2: "Sehr geehrte Frau"
    },
    {
        definition: "Frau / Herrn",
        mapping: "frau/herr, frau/herrn, frau und herr, herr und frau",
        briefanrede_1: "Sehr geehrte Frau",
        briefanrede_2: "Sehr geehrter Herr"
    },
    {
        definition: "Herrn / Herrn",
        mapping: "herr/herr, herrn/herrn, herr und herr, herrn und herrn",
        briefanrede_1: "Sehr geehrter Herr",
        briefanrede_2: "Sehr geehrter Herr"
    },
    {
        definition: "Eheleute",
        mapping: "eheleute",
        briefanrede_1: "Sehr geehrte Frau",
        briefanrede_2: "Sehr geehrter Herr"
    },
    {
        definition: "Erbengemeinschaft",
        mapping: "erbengemeinschaft",
        briefanrede_1: "Sehr geehrte Damen und Herren",
        briefanrede_2: ""
    },
    {
        definition: "Eigent\xfcmergemeinschaft",
        mapping: "eigentuemergemeinschaft, eigent\xfcmergemeinschaft",
        briefanrede_1: "Sehr geehrte Damen und Herren",
        briefanrede_2: ""
    },
    {
        definition: "Firma",
        mapping: "firma, gmbh, ag, kg, ug",
        briefanrede_1: "Sehr geehrte Damen und Herren",
        briefanrede_2: ""
    }
];
const $f18f15d2e4dddb8c$export$6b07ee08c668c83 = [
    {
        definition: "Dr.",
        mapping: "dr, dr."
    },
    {
        definition: "Prof.",
        mapping: "prof, prof."
    },
    {
        definition: "Prof. Dr.",
        mapping: "prof dr, prof. dr., prof. dr"
    },
    {
        definition: "Dipl.-Ing.",
        mapping: "dipl ing, dipl.-ing., dipl.-ing"
    },
    {
        definition: "Dipl.-Kfm.",
        mapping: "dipl kfm, dipl.-kfm., dipl.-kfm"
    }
];
const $f18f15d2e4dddb8c$export$4c70cb57ab25f03a = (management)=>{
    const rows = Array.isArray(management?.faciliooAnredeKeyTable) ? management.faciliooAnredeKeyTable : $f18f15d2e4dddb8c$export$a178e7e76e7a8f20;
    const options = rows.map((row)=>String(row?.definition ?? "").trim()).filter(Boolean);
    return Array.from(new Set(options.length ? options : $f18f15d2e4dddb8c$export$a178e7e76e7a8f20.map((row)=>row.definition)));
};
const $f18f15d2e4dddb8c$export$c5a09025020d6cf = (management)=>{
    const rows = Array.isArray(management?.faciliooTitelKeyTable) ? management.faciliooTitelKeyTable : $f18f15d2e4dddb8c$export$6b07ee08c668c83;
    const options = rows.map((row)=>String(row?.definition ?? "").trim()).filter(Boolean);
    return Array.from(new Set(options.length ? options : $f18f15d2e4dddb8c$export$6b07ee08c668c83.map((row)=>row.definition)));
};


const $d54f4a7473082e4a$var$hasAnyOwnerName = (name1, name2, name3)=>!!name1.trim() || !!name2.trim() || !!name3.trim();
const $d54f4a7473082e4a$var$unitListIcons = {
    search: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "5.8",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m13.2 13.2 4 4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    }),
    reset: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.2 6.3V3.9H2.8M4 4a6.4 6.4 0 1 1-1.4 7.5",
            stroke: "currentColor",
            strokeWidth: "1.7",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }),
    object: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.2 5.2h7.6v9.6H6.2z",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.2 8.4h7.6M6.2 11.6h7.6M9.4 5.2v9.6M12.6 5.2v9.6",
                stroke: "currentColor",
                strokeWidth: "1.4"
            })
        ]
    }),
    entrance: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.2 15.7h11.6M6 15.7V5.2h8v10.5",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 8h4M8 11h4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    }),
    location: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 17s5.2-4.7 5.2-9a5.2 5.2 0 0 0-10.4 0c0 4.3 5.2 9 5.2 9Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "8",
                r: "1.8",
                stroke: "currentColor",
                strokeWidth: "1.7"
            })
        ]
    }),
    type: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.3 5.5h11.4M4.3 10h11.4M4.3 14.5h11.4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.2 3.8v12.4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    }),
    votes: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.1 15.9h11.8M5.6 15.9V9.4M10 15.9V6.7M14.4 15.9V4.1",
            stroke: "currentColor",
            strokeWidth: "1.7",
            strokeLinecap: "round"
        })
    }),
    mea: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 3.7 15.3 6.8v6.4L10 16.3l-5.3-3.1V6.8L10 3.7Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 3.7v12.6M4.7 6.8 10 10l5.3-3.2",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }),
    status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "5.9",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                fill: "currentColor"
            })
        ]
    }),
    actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "5.3",
                r: "1.4",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "1.4",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "14.7",
                r: "1.4",
                fill: "currentColor"
            })
        ]
    }),
    ownerId: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "7.4",
                r: "2.5",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.2 15.9a4.8 4.8 0 0 1 9.6 0",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    })
};
const $d54f4a7473082e4a$var$plainUnitHeader = (label, icon)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "resolutions-v2-th-plain",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-icon",
                "aria-hidden": "true",
                children: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-label",
                children: label
            })
        ]
    });
const $d54f4a7473082e4a$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS = [
    {
        key: "resolution_started",
        label: "Info \xfcber Start des Beschlusses"
    },
    {
        key: "invitation_sent_success",
        label: "Info \xfcber erfolgreichen Versand der Einladung"
    },
    {
        key: "email_bounce_after_retries",
        label: "Info \xfcber E-Mail R\xfcckl\xe4ufer nach fehlgeschlagenen Retries"
    },
    {
        key: "analog_postal_action_required",
        label: "Hinweis bei analogen Eigent\xfcmern (postalischer Versand erforderlich)"
    },
    {
        key: "vote_with_comment",
        label: "Info bei Stimmabgabe mit Kommentar (inkl. Kommentarinhalt)"
    },
    {
        key: "reminder_sent",
        label: "Info \xfcber Versand von Erinnerungsschreiben (1/2) inkl. Empf\xe4nger"
    },
    {
        key: "each_vote_submitted",
        label: "Info \xfcber jede Stimmabgabe"
    },
    {
        key: "preliminary_result_locked",
        label: "Info bei vorl\xe4ufigem Endergebnis (Ergebnis kann nicht mehr kippen)"
    },
    {
        key: "resolution_finished_with_result",
        label: "Info \xfcber Ende des Beschlusses inkl. Ergebnis"
    }
];
const $d54f4a7473082e4a$var$defaultTriggerNotificationEvents = ()=>Object.fromEntries($d54f4a7473082e4a$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS.map((eventOption)=>[
            eventOption.key,
            false
        ]));
const $d54f4a7473082e4a$var$allTriggerNotificationEvents = ()=>Object.fromEntries($d54f4a7473082e4a$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS.map((eventOption)=>[
            eventOption.key,
            true
        ]));
const $d54f4a7473082e4a$var$mergeSelectedFiles = (previous, incoming, replace = false)=>{
    const base = replace ? [] : previous;
    const deduped = new Map();
    for (const file of base)deduped.set(`${file.name}__${file.size}__${file.lastModified}`, file);
    for (const file of incoming)deduped.set(`${file.name}__${file.size}__${file.lastModified}`, file);
    return Array.from(deduped.values());
};
const $d54f4a7473082e4a$var$normalizeTriggerNotificationEvents = (value)=>{
    const base = $d54f4a7473082e4a$var$defaultTriggerNotificationEvents();
    if (!value) return base;
    for (const [key, raw] of Object.entries(value)){
        if (!(key in base)) continue;
        base[key] = Boolean(raw);
    }
    return base;
};
const $d54f4a7473082e4a$var$getTodayDateKey = ()=>new Date().toISOString().slice(0, 10);
const $d54f4a7473082e4a$var$getDateFieldErrors = (startdatum, endedatum)=>{
    const today = $d54f4a7473082e4a$var$getTodayDateKey();
    const startError = startdatum && startdatum <= today ? "Startdatum muss in der Zukunft liegen" : null;
    const endError = startdatum && endedatum && endedatum <= startdatum ? "Enddatum muss nach dem Startdatum liegen" : null;
    return {
        startError: startError,
        endError: endError
    };
};
const $d54f4a7473082e4a$var$getDateRangeError = (startdatum, endedatum)=>{
    const errors = $d54f4a7473082e4a$var$getDateFieldErrors(startdatum, endedatum);
    return errors.startError ?? errors.endError;
};
const $d54f4a7473082e4a$var$formatDateDE = (value)=>{
    if (!value) return "-";
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? `${m[3]}.${m[2]}.${m[1]}` : value;
};
const $d54f4a7473082e4a$var$formatDateTimeDE = (value)=>{
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return new Intl.DateTimeFormat("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    }).format(parsed);
};
const $d54f4a7473082e4a$var$buildOwnerValidityTooltip = (owner)=>`EGT ab: ${$d54f4a7473082e4a$var$formatDateDE(owner.gueltig_ab)} | EGT bis: ${$d54f4a7473082e4a$var$formatDateDE(owner.gueltig_bis)}`;
const $d54f4a7473082e4a$var$buildAssignmentValidityTooltip = (assignment)=>`EGT ab: ${$d54f4a7473082e4a$var$formatDateDE(assignment.gueltig_ab)} | EGT bis: ${$d54f4a7473082e4a$var$formatDateDE(assignment.gueltig_bis)}`;
const $d54f4a7473082e4a$var$formatOwnerStatusLabel = (status)=>status === "keine_zuordnung" ? "keine Zuordnung" : status;
const $d54f4a7473082e4a$var$formatOwnerDisplayName = (owner)=>{
    if (!owner) return "-";
    const parts = [
        owner.anrede,
        owner.vorname,
        owner.name_1,
        owner.name_2,
        owner.name_3
    ].map((part)=>part?.trim()).filter(Boolean);
    return parts.length ? parts.join(" ") : "-";
};
const $d54f4a7473082e4a$var$formatOwnerLabelFallback = (value)=>{
    const raw = String(value ?? "").trim();
    if (!raw) return "-";
    return raw.replace(/^\s*\d+\s*-\s*/u, "").trim() || raw;
};
const $d54f4a7473082e4a$var$parseFacilioo = (value)=>{
    const trimmed = value.trim();
    if (!trimmed) return undefined;
    if (!/^\d{1,10}$/.test(trimmed)) throw new Error("Facilioo Vorgangsnummer muss 1 bis 10-stellig numerisch sein");
    return Number(trimmed);
};
const $d54f4a7473082e4a$var$normalizeValidationErrorMessage = (error)=>{
    const fallback = "Facilioo Vorgang konnte nicht validiert werden.";
    const raw = error instanceof Error ? error.message : fallback;
    return String(raw).replace(/^API\s+\d+\s*:?\s*/i, "").trim() || fallback;
};
const $d54f4a7473082e4a$var$formatResolutionStatus = (status)=>{
    if (status === "aktiv") return "l\xe4uft";
    if (status === "abgeschlossen") return "beendet";
    return "Entwurf";
};
const $d54f4a7473082e4a$var$formatStimmrechtsart = (value)=>{
    if (value === "kopf") return "K\xf6pfe";
    if (value === "mea") return "MEA";
    return "Stimmrecht";
};
const $d54f4a7473082e4a$var$hasConfiguredStimmrechte = (units)=>units.some((unit)=>Number(unit.stimmrecht ?? 0) > 0);
const $d54f4a7473082e4a$var$resolveDefaultStimmrechtsart = (objectDefault, hasStimmrechte)=>{
    if (objectDefault === "stimmrecht" && !hasStimmrechte) return "kopf";
    return objectDefault ?? (hasStimmrechte ? "stimmrecht" : "kopf");
};
const $d54f4a7473082e4a$var$formatQuorum = (value)=>{
    if (value === "qualifizierte_mehrheit") return "Qualifizierte Mehrheit (> 2/3 abgegeben)";
    if (value === "allstimmig") return "Allstimmig (100% Ja aller Stimmen)";
    return "Einfache Mehrheit (> 50% abgegeben)";
};
const $d54f4a7473082e4a$var$formatSelectionUnitNumber = (value)=>{
    const raw = String(value ?? "").trim();
    if (!raw) return "-";
    return /^\d+$/.test(raw) ? raw.padStart(4, "0") : raw;
};
const $d54f4a7473082e4a$var$isVorbeschlussRequired = (quorum)=>quorum !== "allstimmig";
const $d54f4a7473082e4a$var$getResolutionOutcome = (resolution)=>{
    if (resolution.status !== "abgeschlossen") return {
        label: "-"
    };
    return resolution.quorum_erfuellt ? {
        label: "Angenommen",
        tone: "success"
    } : {
        label: "Abgelehnt",
        tone: "danger"
    };
};
const $d54f4a7473082e4a$var$getResolutionOverviewOutcome = (resolution)=>{
    if (resolution.status === "abgeschlossen") return $d54f4a7473082e4a$var$getResolutionOutcome(resolution);
    if (resolution.status === "aktiv") {
        const totalVotes = resolution.anzahl_empfaenger_gesamt ?? resolution.stimmberechtigte_einheiten.length;
        return {
            label: `${resolution.abgegebene_stimmen} / ${totalVotes} abgestimmt`,
            tone: "neutral"
        };
    }
    return {
        label: "Noch nicht gestartet",
        tone: "neutral"
    };
};
const $d54f4a7473082e4a$var$buildUnitSelectionRows = (units, assignments, owners)=>{
    const ownerMap = new Map(owners.map((o)=>[
            o.id,
            $d54f4a7473082e4a$var$formatOwnerDisplayName(o)
        ]));
    return units.filter((u)=>u.status === "aktiv").map((unit)=>{
        const ownerLabels = assignments.filter((a)=>a.unitId === unit.id && a.status === "aktiv").map((a)=>ownerMap.get(a.ownerId) ?? $d54f4a7473082e4a$var$formatOwnerLabelFallback(a.eigentuemername)).filter(Boolean);
        return {
            unitId: unit.id,
            einheitsnummer: unit.einheitsnummer,
            bezeichnung: unit.bezeichnung || "-",
            einheitstyp: unit.einheitstyp || "-",
            aufgang: unit.aufgangName || "-",
            eigentuemerInfo: Array.from(new Set(ownerLabels)).join(" | ") || "-"
        };
    }).sort((a, b)=>a.einheitsnummer.localeCompare(b.einheitsnummer));
};
const $d54f4a7473082e4a$var$ObjectDetailIcon = ({ name: name })=>{
    if (name === "building") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.9 8.2h14.2v10.9H4.9z",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "resolution") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.1 4.6h6.6l3.2 3.2v11.6H7.1z",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.7 4.8v3.1h3",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m9.4 14.1 2 2 4.2-5",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.7",
                cy: "17.8",
                r: "2.1",
                fill: "#fff",
                stroke: "currentColor",
                strokeWidth: "1.85"
            })
        ]
    });
    if (name === "home") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.1",
                y: "4.8",
                width: "13.8",
                height: "14.8",
                rx: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.85"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.2 19.6v-2.9h5.6v2.9",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (name === "owners") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9.1",
                cy: "9.1",
                r: "2.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "15.8",
                cy: "8.4",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "assignments") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "6.2",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "16.8",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.4 7.2h7.2M7.9 8.8l7.4 6.4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "reachability") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.4",
                y: "2.8",
                width: "9.2",
                height: "14.4",
                rx: "1.9",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.1 5.8h3.8M7.4 14.1l5.2-5.2",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "pin") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 21s6-5.7 6-10.5a6 6 0 1 0-12 0C6 15.3 12 21 12 21Z",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "10.5",
                r: "2",
                stroke: "currentColor",
                strokeWidth: "1.8"
            })
        ]
    });
    if (name === "calendar") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4.8",
                y: "6.5",
                width: "14.4",
                height: "12.2",
                rx: "2",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.5 4.8v3M15.5 4.8v3M5.2 10.2h13.6",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "refresh") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.5 9.5a6.4 6.4 0 0 0-11.1-2L5.8 9.2M5.5 14.5a6.4 6.4 0 0 0 11.1 2l1.6-1.7",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.7 5.5v3.8h3.8M18.3 18.5v-3.8h-3.8",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (name === "user") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "8.8",
                r: "3",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.4 19.1a5.8 5.8 0 0 1 11.2 0",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "info") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "8",
                stroke: "currentColor",
                strokeWidth: "1.9"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 10.8v5.2M12 7.8h.01",
                stroke: "currentColor",
                strokeWidth: "2.1",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "edit") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m5.6 16.9-.7 2.9 2.9-.7 9.7-9.7-2.2-2.2-9.7 9.7Z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m14.4 8.1 2.2 2.2",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "chevron") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m8 10 4 4 4-4",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
    if (name === "plus") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5.5v13M5.5 12h13",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 12h14M12 5v14",
            stroke: "currentColor",
            strokeWidth: "1.9",
            strokeLinecap: "round"
        })
    });
};
const $d54f4a7473082e4a$export$de94004b3a43d77c = ({ canManageMasterDataActions: canManageMasterDataActions = false, canCreateResolutions: canCreateResolutions = false })=>{
    const { id: id = "" } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [tab, setTab] = (0, $acw62.useState)("uebersicht");
    const [search, setSearch] = (0, $acw62.useState)("");
    const [formError, setFormError] = (0, $acw62.useState)("");
    const [actionError, setActionError] = (0, $acw62.useState)("");
    const [deleteConfirm, setDeleteConfirm] = (0, $acw62.useState)(null);
    const [stopConfirm, setStopConfirm] = (0, $acw62.useState)(null);
    const [actionMenuPosition, setActionMenuPosition] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const [unitPage, setUnitPage] = (0, $acw62.useState)(1);
    const [unitPageSize, setUnitPageSize] = (0, $acw62.useState)(10);
    const [unitOpenActionMenuId, setUnitOpenActionMenuId] = (0, $acw62.useState)(null);
    const [unitSearch, setUnitSearch] = (0, $acw62.useState)("");
    const [unitAufgangFilter, setUnitAufgangFilter] = (0, $acw62.useState)("");
    const [unitStatus, setUnitStatus] = (0, $acw62.useState)("aktiv");
    const [unitTypeFilter, setUnitTypeFilter] = (0, $acw62.useState)("");
    const [unitSortBy, setUnitSortBy] = (0, $acw62.useState)("einheitsnummer");
    const [unitSortDir, setUnitSortDir] = (0, $acw62.useState)("asc");
    const [ownerPage, setOwnerPage] = (0, $acw62.useState)(1);
    const [ownerPageSize, setOwnerPageSize] = (0, $acw62.useState)(10);
    const [ownerOpenActionMenuId, setOwnerOpenActionMenuId] = (0, $acw62.useState)(null);
    const [ownerSearchFilter, setOwnerSearchFilter] = (0, $acw62.useState)("");
    const [ownerReachabilityFilter, setOwnerReachabilityFilter] = (0, $acw62.useState)("");
    const [ownerStatusFilter, setOwnerStatusFilter] = (0, $acw62.useState)("aktiv");
    const [assignmentPage, setAssignmentPage] = (0, $acw62.useState)(1);
    const [assignmentPageSize, setAssignmentPageSize] = (0, $acw62.useState)(10);
    const [assignmentOpenActionMenuId, setAssignmentOpenActionMenuId] = (0, $acw62.useState)(null);
    const [assignmentRecipientFilter, setAssignmentRecipientFilter] = (0, $acw62.useState)("");
    const [resolutionPage, setResolutionPage] = (0, $acw62.useState)(1);
    const [resolutionPageSize, setResolutionPageSize] = (0, $acw62.useState)(10);
    const [resolutionOpenActionMenuId, setResolutionOpenActionMenuId] = (0, $acw62.useState)(null);
    const [resolutionSearch, setResolutionSearch] = (0, $acw62.useState)("");
    const [resolutionStatusFilter, setResolutionStatusFilter] = (0, $acw62.useState)("");
    const [resolutionResultFilter, setResolutionResultFilter] = (0, $acw62.useState)("");
    const [resolutionSortBy, setResolutionSortBy] = (0, $acw62.useState)("beschlussnummer");
    const [resolutionSortDir, setResolutionSortDir] = (0, $acw62.useState)("asc");
    const [importPage, setImportPage] = (0, $acw62.useState)(1);
    const [auditPage, setAuditPage] = (0, $acw62.useState)(1);
    const [showCreateUnit, setShowCreateUnit] = (0, $acw62.useState)(false);
    const [showCreateOwner, setShowCreateOwner] = (0, $acw62.useState)(false);
    const [showCreateAssignment, setShowCreateAssignment] = (0, $acw62.useState)(false);
    const [showCreateResolution, setShowCreateResolution] = (0, $acw62.useState)(false);
    const [unitForm, setUnitForm] = (0, $acw62.useState)({
        einheitsnummer: "",
        bezeichnung: "",
        einheitstyp: "",
        stimmrecht: "",
        mea: "",
        status: ""
    });
    const [editUnitForm, setEditUnitForm] = (0, $acw62.useState)(null);
    const [ownerForm, setOwnerForm] = (0, $acw62.useState)({
        eigentuemer_id: "",
        anrede: "",
        titel: "",
        vorname: "",
        name_1: "",
        name_2: "",
        name_3: "",
        strasse: "",
        plz: "",
        ort: "",
        land_code: "",
        land: "",
        email: "",
        telefon: "",
        status: ""
    });
    const [editOwnerForm, setEditOwnerForm] = (0, $acw62.useState)(null);
    const [assignmentForm, setAssignmentForm] = (0, $acw62.useState)({
        unitId: "",
        ownerId: "",
        status: ""
    });
    const [editAssignmentForm, setEditAssignmentForm] = (0, $acw62.useState)(null);
    const [assignmentOwnerSearch, setAssignmentOwnerSearch] = (0, $acw62.useState)("");
    const [editAssignmentOwnerSearch, setEditAssignmentOwnerSearch] = (0, $acw62.useState)("");
    const [assignmentOnlyUnassigned, setAssignmentOnlyUnassigned] = (0, $acw62.useState)(false);
    const [editAssignmentOnlyUnassigned, setEditAssignmentOnlyUnassigned] = (0, $acw62.useState)(false);
    const [resolutionForm, setResolutionForm] = (0, $acw62.useState)({
        objectId: id,
        beschlussnummer: "",
        titel: "",
        startdatum: "",
        endedatum: "",
        stimmrechtsart: "kopf",
        quorum: "allstimmig",
        vorbeschluss_top: "",
        vorbeschluss_wev_datum: "",
        beschlusstext: "",
        facilioo_vorgangsnummer: "",
        dispatch_automation_enabled: false,
        trigger_notifications_enabled: false,
        trigger_notifications_channel: "facilioo",
        trigger_notifications_events: $d54f4a7473082e4a$var$defaultTriggerNotificationEvents(),
        stimmberechtigte_einheiten: []
    });
    const [editResolutionForm, setEditResolutionForm] = (0, $acw62.useState)(null);
    const [resolutionOwnerSearch, setResolutionOwnerSearch] = (0, $acw62.useState)("");
    const [resolutionUnitTypeFilter, setResolutionUnitTypeFilter] = (0, $acw62.useState)("");
    const [resolutionEntranceFilter, setResolutionEntranceFilter] = (0, $acw62.useState)("");
    const [createResolutionDocuments, setCreateResolutionDocuments] = (0, $acw62.useState)([]);
    const [createResolutionDocumentsDropActive, setCreateResolutionDocumentsDropActive] = (0, $acw62.useState)(false);
    const createResolutionDocumentsInputRef = (0, $acw62.useRef)(null);
    const [createFaciliooValidationPending, setCreateFaciliooValidationPending] = (0, $acw62.useState)(false);
    const [createFaciliooValidationError, setCreateFaciliooValidationError] = (0, $acw62.useState)("");
    const [createFaciliooProcessTitle, setCreateFaciliooProcessTitle] = (0, $acw62.useState)("");
    const [editResolutionOwnerSearch, setEditResolutionOwnerSearch] = (0, $acw62.useState)("");
    const [editResolutionUnitTypeFilter, setEditResolutionUnitTypeFilter] = (0, $acw62.useState)("");
    const [editResolutionEntranceFilter, setEditResolutionEntranceFilter] = (0, $acw62.useState)("");
    const [editFaciliooValidationPending, setEditFaciliooValidationPending] = (0, $acw62.useState)(false);
    const [editFaciliooValidationError, setEditFaciliooValidationError] = (0, $acw62.useState)("");
    const [editFaciliooProcessTitle, setEditFaciliooProcessTitle] = (0, $acw62.useState)("");
    const [initSelectionObjectId, setInitSelectionObjectId] = (0, $acw62.useState)("");
    const [initEditSelectionObjectId, setInitEditSelectionObjectId] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        const hasOpenMenu = !!unitOpenActionMenuId || !!ownerOpenActionMenuId || !!assignmentOpenActionMenuId || !!resolutionOpenActionMenuId;
        if (!hasOpenMenu) return;
        const closeMenus = (event)=>{
            if (event && (0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            setUnitOpenActionMenuId(null);
            setOwnerOpenActionMenuId(null);
            setAssignmentOpenActionMenuId(null);
            setResolutionOpenActionMenuId(null);
        };
        const handleEscape = (event)=>{
            if (event.key === "Escape") closeMenus();
        };
        window.addEventListener("mousedown", closeMenus);
        window.addEventListener("keydown", handleEscape);
        return ()=>{
            window.removeEventListener("mousedown", closeMenus);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        unitOpenActionMenuId,
        ownerOpenActionMenuId,
        assignmentOpenActionMenuId,
        resolutionOpenActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        const hasOpenMenu = !!unitOpenActionMenuId || !!ownerOpenActionMenuId || !!assignmentOpenActionMenuId || !!resolutionOpenActionMenuId;
        if (!hasOpenMenu) return;
        const closeMenus = ()=>{
            setUnitOpenActionMenuId(null);
            setOwnerOpenActionMenuId(null);
            setAssignmentOpenActionMenuId(null);
            setResolutionOpenActionMenuId(null);
        };
        window.addEventListener("resize", closeMenus);
        window.addEventListener("scroll", closeMenus, true);
        return ()=>{
            window.removeEventListener("resize", closeMenus);
            window.removeEventListener("scroll", closeMenus, true);
        };
    }, [
        unitOpenActionMenuId,
        ownerOpenActionMenuId,
        assignmentOpenActionMenuId,
        resolutionOpenActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!unitOpenActionMenuId || !!ownerOpenActionMenuId || !!assignmentOpenActionMenuId || !!resolutionOpenActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>{
            setUnitOpenActionMenuId(null);
            setOwnerOpenActionMenuId(null);
            setAssignmentOpenActionMenuId(null);
            setResolutionOpenActionMenuId(null);
        },
        timeoutMs: 3000
    });
    (0, $acw62.useEffect)(()=>{
        if (!unitOpenActionMenuId && !ownerOpenActionMenuId && !assignmentOpenActionMenuId && !resolutionOpenActionMenuId) {
            setActionMenuPosition(null);
            setIsActionMenuHovered(false);
        }
    }, [
        unitOpenActionMenuId,
        ownerOpenActionMenuId,
        assignmentOpenActionMenuId,
        resolutionOpenActionMenuId
    ]);
    const closeAllActionMenus = ()=>{
        setUnitOpenActionMenuId(null);
        setOwnerOpenActionMenuId(null);
        setAssignmentOpenActionMenuId(null);
        setResolutionOpenActionMenuId(null);
    };
    const openDetailActionMenu = (menuId, trigger, setOpenMenuId, menuHeight = 96)=>{
        const rect = trigger.getBoundingClientRect();
        const menuWidth = 170;
        const margin = 8;
        const left = Math.min(Math.max(margin, rect.right - menuWidth), Math.max(margin, window.innerWidth - menuWidth - margin));
        const belowTop = rect.bottom + 6;
        const aboveTop = rect.top - menuHeight - 6;
        const top = belowTop + menuHeight <= window.innerHeight - margin ? belowTop : Math.max(margin, aboveTop);
        closeAllActionMenus();
        setActionMenuPosition({
            left: left,
            top: top
        });
        setOpenMenuId(menuId);
    };
    const mergeCreateResolutionDocuments = (incoming, replace = false)=>{
        setCreateResolutionDocuments((prev)=>$d54f4a7473082e4a$var$mergeSelectedFiles(prev, incoming, replace));
    };
    const onCreateResolutionDocumentsDrop = (event)=>{
        event.preventDefault();
        setCreateResolutionDocumentsDropActive(false);
        mergeCreateResolutionDocuments(Array.from(event.dataTransfer.files ?? []), false);
    };
    const isUnitsTab = tab === "einheiten";
    const isOwnersTab = tab === "eigentuemer";
    const isAssignmentsTab = tab === "zuordnungen";
    const isResolutionsTab = tab === "umlaufbeschluesse";
    const isOverviewTab = tab === "uebersicht";
    const isImportTab = tab === "importe";
    const isAuditTab = tab === "protokoll";
    const needsResolutionSelectionData = isResolutionsTab || showCreateResolution || !!editResolutionForm;
    const needsOwnerOverviewAssignmentData = isOverviewTab || needsResolutionSelectionData;
    const { data: summary, isError: summaryError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-summary",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).objectSummary(id),
        enabled: !!id,
        retry: 1,
        staleTime: 30000
    });
    const { data: unitsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-units",
            id,
            unitPage,
            unitPageSize,
            unitSearch,
            unitAufgangFilter,
            unitTypeFilter,
            unitStatus,
            unitSortBy,
            unitSortDir
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: unitPage,
                pageSize: unitPageSize,
                limit: unitPageSize,
                objectId: id,
                search: unitSearch,
                aufgang: unitAufgangFilter || undefined,
                aufgangExact: !!unitAufgangFilter || undefined,
                status: unitStatus || undefined,
                einheitstyp: unitTypeFilter || undefined,
                sortBy: unitSortBy,
                sortDir: unitSortDir
            }),
        enabled: !!id && isUnitsTab
    });
    const { data: ownersData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-owners",
            id,
            ownerPage,
            ownerPageSize,
            ownerSearchFilter,
            ownerReachabilityFilter,
            ownerStatusFilter
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                page: ownerPage,
                pageSize: ownerPageSize,
                limit: ownerPageSize,
                objectId: id,
                search: ownerSearchFilter,
                erreichbarkeit: ownerReachabilityFilter || undefined,
                status: ownerStatusFilter || undefined
            }),
        enabled: !!id && isOwnersTab
    });
    const { data: assignmentsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-assignments",
            id,
            assignmentPage,
            assignmentPageSize,
            search,
            assignmentRecipientFilter
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).assignments({
                page: assignmentPage,
                pageSize: assignmentPageSize,
                limit: assignmentPageSize,
                objectId: id,
                search: search,
                recipientType: assignmentRecipientFilter || undefined
            }),
        enabled: !!id && isAssignmentsTab
    });
    const { data: resolutionsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-resolutions",
            id,
            resolutionPage,
            resolutionPageSize,
            resolutionSearch,
            resolutionStatusFilter,
            resolutionResultFilter,
            resolutionSortBy,
            resolutionSortDir
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: resolutionPage,
                pageSize: resolutionPageSize,
                limit: resolutionPageSize,
                objectId: id,
                search: resolutionSearch,
                status: resolutionStatusFilter || undefined,
                ergebnis: resolutionResultFilter || undefined,
                sortBy: resolutionSortBy,
                sortDir: resolutionSortDir
            }),
        enabled: !!id && isResolutionsTab
    });
    const { data: resolutionsOverviewData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-resolutions-overview",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: 1,
                pageSize: 5,
                objectId: id,
                lightweight: "1"
            }),
        enabled: !!id && isOverviewTab
    });
    const { data: completedResolutionsOverviewData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-resolutions-overview-count",
            id,
            "abgeschlossen"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: 1,
                pageSize: 1,
                objectId: id,
                status: "abgeschlossen",
                lightweight: "1"
            }),
        enabled: !!id && isOverviewTab
    });
    const { data: draftResolutionsOverviewData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-resolutions-overview-count",
            id,
            "entwurf"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: 1,
                pageSize: 1,
                objectId: id,
                status: "entwurf",
                lightweight: "1"
            }),
        enabled: !!id && isOverviewTab
    });
    const { data: unitsOverviewData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-units-overview",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: 1,
                pageSize: 2000,
                objectId: id
            }),
        enabled: !!id && isUnitsTab
    });
    const { data: wohnungUnitsOverviewData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-units-overview-count",
            id,
            "wohnung"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: 1,
                pageSize: 1,
                objectId: id,
                einheitstyp: "wohnung"
            }),
        enabled: !!id && isOverviewTab
    });
    const { data: stellplatzUnitsOverviewData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-units-overview-count",
            id,
            "stellplatz"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: 1,
                pageSize: 1,
                objectId: id,
                einheitstyp: "stellplatz"
            }),
        enabled: !!id && isOverviewTab
    });
    const { data: sonstigeUnitsOverviewData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-units-overview-count",
            id,
            "sonstiges"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: 1,
                pageSize: 1,
                objectId: id,
                einheitstyp: "sonstiges"
            }),
        enabled: !!id && isOverviewTab
    });
    const { data: ownersOverviewData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-owners-overview",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                page: 1,
                pageSize: 2000,
                objectId: id
            }),
        enabled: !!id && isAssignmentsTab
    });
    const { data: activeResolutionsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-active-resolutions-lock",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: 1,
                pageSize: 1,
                objectId: id,
                status: "aktiv",
                lightweight: "1"
            }),
        enabled: !!id && (isOverviewTab || canManageMasterDataActions)
    });
    const { data: importsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-imports",
            importPage
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).imports({
                page: importPage,
                pageSize: 25
            }),
        enabled: !!id && isImportTab
    });
    const { data: auditData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-audit",
            id,
            auditPage
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).auditLogs({
                page: auditPage,
                pageSize: 25,
                search: summary?.object.objektnummer
            }),
        enabled: !!id && isAuditTab && !!summary?.object.objektnummer
    });
    const { data: uiSettings } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-object-owner-anrede"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings(),
        staleTime: 60000
    });
    const { data: nextResolutionNumberData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolutions-next-beschlussnummer"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).nextResolutionNumber(),
        staleTime: 15000
    });
    const { data: unitsForSelectionData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-resolution-units-all",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: 1,
                pageSize: 1200,
                objectId: id,
                status: "aktiv"
            }),
        enabled: !!id && needsResolutionSelectionData
    });
    const { data: ownersForSelectionData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-resolution-owners-all",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                page: 1,
                pageSize: 2000,
                objectId: id,
                status: "aktiv"
            }),
        enabled: !!id && needsResolutionSelectionData
    });
    const { data: assignmentsForSelectionData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-resolution-assignments-all",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).assignments({
                page: 1,
                pageSize: 5000,
                objectId: id,
                status: "aktiv"
            }),
        enabled: !!id && needsOwnerOverviewAssignmentData
    });
    const needsAssignmentOwnerContext = isAssignmentsTab || showCreateAssignment || !!editAssignmentForm;
    const { data: ownerAssignmentsOverviewData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "owners-assignment-overview",
            "object-detail",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).assignments({
                page: 1,
                pageSize: 5000,
                objectId: id,
                status: "aktiv"
            }),
        enabled: !!id && needsAssignmentOwnerContext
    });
    const objectLocked = Number(activeResolutionsData?.meta?.total ?? activeResolutionsData?.data.length ?? 0) > 0;
    const anredeOptions = (0, $acw62.useMemo)(()=>(0, $f18f15d2e4dddb8c$export$4c70cb57ab25f03a)(uiSettings?.management), [
        uiSettings?.management
    ]);
    const titelOptions = (0, $acw62.useMemo)(()=>(0, $f18f15d2e4dddb8c$export$c5a09025020d6cf)(uiSettings?.management), [
        uiSettings?.management
    ]);
    const unitSelectionRows = (0, $acw62.useMemo)(()=>$d54f4a7473082e4a$var$buildUnitSelectionRows(unitsForSelectionData?.data ?? [], assignmentsForSelectionData?.data ?? [], ownersForSelectionData?.data ?? []), [
        assignmentsForSelectionData?.data,
        ownersForSelectionData?.data,
        unitsForSelectionData?.data
    ]);
    const objectHasStimmrechte = (0, $acw62.useMemo)(()=>$d54f4a7473082e4a$var$hasConfiguredStimmrechte(unitsForSelectionData?.data ?? []), [
        unitsForSelectionData?.data
    ]);
    const objectStandardStimmrechtsart = summary?.object.standard_stimmrechtsart;
    const objectCanUseStimmrecht = objectHasStimmrechte;
    const assignmentRefsByOwner = (0, $acw62.useMemo)(()=>{
        const map = new Map();
        for (const assignment of ownerAssignmentsOverviewData?.data ?? []){
            const list = map.get(assignment.ownerId) ?? [];
            list.push(`${assignment.objektnummer}/${assignment.einheitsnummer}`);
            map.set(assignment.ownerId, list);
        }
        return map;
    }, [
        ownerAssignmentsOverviewData?.data
    ]);
    const filteredAssignmentOwners = (0, $acw62.useMemo)(()=>{
        const rows = ownersForSelectionData?.data ?? [];
        const needle = assignmentOwnerSearch.trim().toLowerCase();
        const searched = !needle ? rows : rows.filter((owner)=>`${owner.eigentuemer_id} ${owner.vollname} ${owner.email ?? ""}`.toLowerCase().includes(needle));
        if (!assignmentOnlyUnassigned) return searched;
        return searched.filter((owner)=>(assignmentRefsByOwner.get(owner.id) ?? []).length === 0);
    }, [
        ownersForSelectionData?.data,
        assignmentOwnerSearch,
        assignmentOnlyUnassigned,
        assignmentRefsByOwner
    ]);
    const filteredEditAssignmentOwners = (0, $acw62.useMemo)(()=>{
        const rows = ownersForSelectionData?.data ?? [];
        const needle = editAssignmentOwnerSearch.trim().toLowerCase();
        const searched = !needle ? rows : rows.filter((owner)=>`${owner.eigentuemer_id} ${owner.vollname} ${owner.email ?? ""}`.toLowerCase().includes(needle));
        if (!editAssignmentOnlyUnassigned) return searched;
        return searched.filter((owner)=>(assignmentRefsByOwner.get(owner.id) ?? []).length === 0);
    }, [
        ownersForSelectionData?.data,
        editAssignmentOwnerSearch,
        editAssignmentOnlyUnassigned,
        assignmentRefsByOwner
    ]);
    const ownerDisplayById = (0, $acw62.useMemo)(()=>{
        const map = new Map();
        for (const owner of ownersOverviewData?.data ?? [])map.set(owner.id, $d54f4a7473082e4a$var$formatOwnerDisplayName(owner));
        return map;
    }, [
        ownersOverviewData?.data
    ]);
    const formatEinheitsnummer = (value)=>{
        const trimmed = String(value ?? "").trim();
        if (!trimmed) return "";
        return /^\d+$/.test(trimmed) ? trimmed.padStart(4, "0") : trimmed;
    };
    const formatNumberDE = (value)=>{
        const parsed = Number(value ?? 0);
        return Number.isFinite(parsed) ? new Intl.NumberFormat("de-DE", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(parsed) : "-";
    };
    const toggleUnitSort = (field)=>{
        if (unitSortBy === field) {
            setUnitSortDir((prev)=>prev === "asc" ? "desc" : "asc");
            return;
        }
        setUnitSortBy(field);
        setUnitSortDir("asc");
    };
    const renderUnitSortIndicator = (field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "resolutions-v2-sort-indicator",
            "aria-hidden": "true",
            children: unitSortBy === field ? unitSortDir === "asc" ? "?" : "?" : "?"
        });
    const renderUnitSortHeader = (field, label, icon)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            className: "resolutions-v2-th-sort",
            onClick: ()=>toggleUnitSort(field),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-icon",
                    "aria-hidden": "true",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-label",
                    children: label
                }),
                renderUnitSortIndicator(field)
            ]
        });
    const renderAssignmentOwnerSearchList = (rows, selectedOwnerId, onSelectOwner)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: "grid",
                gap: 6
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontSize: 12,
                        fontWeight: 600,
                        color: "var(--text-soft)"
                    },
                    children: "Suchergebnisse"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        border: "1px solid var(--line)",
                        borderRadius: 6,
                        minHeight: 140,
                        maxHeight: 240,
                        overflowY: "auto",
                        overflowX: "hidden",
                        background: "#fff"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        style: {
                            tableLayout: "fixed",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "11%"
                                            },
                                            children: "Eigent\xfcmer-ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "9%"
                                            },
                                            children: "Anrede"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "11%"
                                            },
                                            children: "Vorname"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "12%"
                                            },
                                            children: "Name 1"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "12%"
                                            },
                                            children: "Name 2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "12%"
                                            },
                                            children: "Name 3"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "16%"
                                            },
                                            children: "E-Mail"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "17%"
                                            },
                                            children: "Zuordnungen"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: rows.length ? rows.map((owner)=>{
                                    const selected = selectedOwnerId === owner.id;
                                    const refs = assignmentRefsByOwner.get(owner.id) ?? [];
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        onClick: ()=>onSelectOwner(owner.id),
                                        style: {
                                            cursor: "pointer",
                                            background: selected ? "var(--surface-muted)" : undefined
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.eigentuemer_id
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.anrede || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.vorname || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.name_1 || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.name_2 || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.name_3 || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.email || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    color: "var(--text-soft)",
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: refs.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: 4
                                                    },
                                                    children: [
                                                        refs.slice(0, 3).map((ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                style: {
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    padding: "2px 8px",
                                                                    borderRadius: 999,
                                                                    border: "1px solid #c9d1da",
                                                                    background: "#f2f4f7",
                                                                    color: "#344054",
                                                                    fontSize: 12,
                                                                    lineHeight: 1.2
                                                                },
                                                                children: ref
                                                            }, `${owner.id}-${ref}`)),
                                                        refs.length > 3 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            style: {
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                padding: "2px 8px",
                                                                borderRadius: 999,
                                                                border: "1px solid #c9d1da",
                                                                background: "#f2f4f7",
                                                                color: "#344054",
                                                                fontSize: 12,
                                                                lineHeight: 1.2
                                                            },
                                                            children: [
                                                                "+",
                                                                refs.length - 3
                                                            ]
                                                        }) : null
                                                    ]
                                                }) : "-"
                                            })
                                        ]
                                    }, owner.id);
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: 8,
                                        style: {
                                            color: "var(--text-soft)"
                                        },
                                        children: "Keine passenden Eigent\xfcmer gefunden."
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        });
    (0, $acw62.useEffect)(()=>{
        setUnitPage(1);
    }, [
        unitSearch,
        unitAufgangFilter,
        unitTypeFilter,
        unitStatus,
        unitSortBy,
        unitSortDir
    ]);
    (0, $acw62.useEffect)(()=>{
        setOwnerPage(1);
    }, [
        ownerSearchFilter,
        ownerReachabilityFilter,
        ownerStatusFilter
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!id || !unitSelectionRows.length) return;
        if (initSelectionObjectId === id) return;
        setResolutionForm((prev)=>({
                ...prev,
                objectId: id,
                stimmberechtigte_einheiten: unitSelectionRows.map((u)=>u.unitId)
            }));
        setInitSelectionObjectId(id);
    }, [
        id,
        initSelectionObjectId,
        unitSelectionRows
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!editResolutionForm || !unitSelectionRows.length) return;
        if (initEditSelectionObjectId === editResolutionForm.objectId) return;
        const selected = editResolutionForm.stimmberechtigte_einheiten.length ? editResolutionForm.stimmberechtigte_einheiten.filter((unitId)=>unitSelectionRows.some((u)=>u.unitId === unitId)) : unitSelectionRows.map((u)=>u.unitId);
        setEditResolutionForm({
            ...editResolutionForm,
            stimmberechtigte_einheiten: selected
        });
        setInitEditSelectionObjectId(editResolutionForm.objectId);
    }, [
        editResolutionForm,
        initEditSelectionObjectId,
        unitSelectionRows
    ]);
    const invalidateObjectTabs = async ()=>{
        await Promise.all([
            queryClient.invalidateQueries({
                queryKey: [
                    "object-summary",
                    id
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    "object-units",
                    id
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    "object-owners",
                    id
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    "object-assignments",
                    id
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    "object-resolutions",
                    id
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    "object-resolutions-overview",
                    id
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    "object-resolution-units-all",
                    id
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    "object-resolution-owners-all",
                    id
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    "object-resolution-assignments-all",
                    id
                ]
            }),
            queryClient.invalidateQueries({
                queryKey: [
                    "active-resolutions-lock"
                ]
            })
        ]);
    };
    const createUnitMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (objectLocked) throw new Error("Objekt ist wegen aktivem Umlaufbeschluss gesperrt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).createUnit({
                objectId: id,
                einheitsnummer: unitForm.einheitsnummer.trim(),
                bezeichnung: unitForm.bezeichnung.trim(),
                einheitstyp: unitForm.einheitstyp,
                stimmrecht: Number(unitForm.stimmrecht),
                mea: unitForm.mea ? Number(unitForm.mea) : undefined,
                status: unitForm.status
            });
        },
        onSuccess: async ()=>{
            setShowCreateUnit(false);
            setUnitForm({
                einheitsnummer: "",
                bezeichnung: "",
                einheitstyp: "",
                stimmrecht: "",
                mea: "",
                status: ""
            });
            setFormError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setFormError(error instanceof Error ? error.message : "Einheit konnte nicht angelegt werden")
    });
    const updateUnitMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!editUnitForm) throw new Error("Keine Einheit gew\xe4hlt");
            if (objectLocked) throw new Error("Objekt ist wegen aktivem Umlaufbeschluss gesperrt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateUnit(editUnitForm.id, {
                einheitsnummer: editUnitForm.einheitsnummer.trim(),
                bezeichnung: editUnitForm.bezeichnung.trim(),
                einheitstyp: editUnitForm.einheitstyp,
                stimmrecht: Number(editUnitForm.stimmrecht),
                mea: editUnitForm.mea ? Number(editUnitForm.mea) : undefined,
                status: editUnitForm.status
            });
        },
        onSuccess: async ()=>{
            setEditUnitForm(null);
            setFormError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setFormError(error instanceof Error ? error.message : "Einheit konnte nicht bearbeitet werden")
    });
    const createOwnerMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (objectLocked) throw new Error("Objekt ist wegen aktivem Umlaufbeschluss gesperrt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).createOwner({
                objectId: id,
                eigentuemer_id: ownerForm.eigentuemer_id.trim(),
                anrede: ownerForm.anrede.trim() || undefined,
                titel: ownerForm.titel.trim() || undefined,
                vorname: ownerForm.vorname.trim() || undefined,
                name_1: ownerForm.name_1.trim() || undefined,
                name_2: ownerForm.name_2.trim() || undefined,
                name_3: ownerForm.name_3.trim() || undefined,
                strasse: ownerForm.strasse.trim() || undefined,
                plz: ownerForm.plz.trim() || undefined,
                ort: ownerForm.ort.trim() || undefined,
                land_code: ownerForm.land_code.trim() || undefined,
                land: ownerForm.land.trim() || undefined,
                email: ownerForm.email.trim(),
                telefon: ownerForm.telefon.trim() || undefined,
                status: ownerForm.status
            });
        },
        onSuccess: async ()=>{
            setShowCreateOwner(false);
            setOwnerForm({
                eigentuemer_id: "",
                anrede: "",
                titel: "",
                vorname: "",
                name_1: "",
                name_2: "",
                name_3: "",
                strasse: "",
                plz: "",
                ort: "",
                land_code: "",
                land: "",
                email: "",
                telefon: "",
                status: ""
            });
            setFormError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setFormError(error instanceof Error ? error.message : "Eigent\xfcmer konnte nicht angelegt werden")
    });
    const updateOwnerMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!editOwnerForm) throw new Error("Kein Eigent\xfcmer gew\xe4hlt");
            if (objectLocked) throw new Error("Objekt ist wegen aktivem Umlaufbeschluss gesperrt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateOwner(editOwnerForm.id, {
                objectId: id,
                eigentuemer_id: editOwnerForm.eigentuemer_id.trim(),
                anrede: editOwnerForm.anrede.trim() || undefined,
                titel: editOwnerForm.titel.trim() || undefined,
                vorname: editOwnerForm.vorname.trim() || undefined,
                name_1: editOwnerForm.name_1.trim() || undefined,
                name_2: editOwnerForm.name_2.trim() || undefined,
                name_3: editOwnerForm.name_3.trim() || undefined,
                strasse: editOwnerForm.strasse.trim() || undefined,
                plz: editOwnerForm.plz.trim() || undefined,
                ort: editOwnerForm.ort.trim() || undefined,
                land_code: editOwnerForm.land_code.trim() || undefined,
                land: editOwnerForm.land.trim() || undefined,
                email: editOwnerForm.email.trim(),
                telefon: editOwnerForm.telefon.trim() || undefined,
                status: editOwnerForm.status
            });
        },
        onSuccess: async ()=>{
            setEditOwnerForm(null);
            setFormError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setFormError(error instanceof Error ? error.message : "Eigent\xfcmer konnte nicht bearbeitet werden")
    });
    const createAssignmentMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (objectLocked) throw new Error("Objekt ist wegen aktivem Umlaufbeschluss gesperrt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).createAssignment({
                objectId: id,
                unitId: assignmentForm.unitId,
                ownerId: assignmentForm.ownerId,
                status: assignmentForm.status
            });
        },
        onSuccess: async ()=>{
            setShowCreateAssignment(false);
            setAssignmentForm({
                unitId: "",
                ownerId: "",
                status: ""
            });
            setAssignmentOwnerSearch("");
            setFormError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setFormError(error instanceof Error ? error.message : "Zuordnung konnte nicht angelegt werden")
    });
    const updateAssignmentMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!editAssignmentForm) throw new Error("Keine Zuordnung gew\xe4hlt");
            if (objectLocked) throw new Error("Objekt ist wegen aktivem Umlaufbeschluss gesperrt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateAssignment(editAssignmentForm.id, {
                objectId: id,
                unitId: editAssignmentForm.unitId,
                ownerId: editAssignmentForm.ownerId,
                status: editAssignmentForm.status
            });
        },
        onSuccess: async ()=>{
            setEditAssignmentForm(null);
            setEditAssignmentOwnerSearch("");
            setFormError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setFormError(error instanceof Error ? error.message : "Zuordnung konnte nicht bearbeitet werden")
    });
    const createResolutionMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            const dateError = $d54f4a7473082e4a$var$getDateRangeError(resolutionForm.startdatum || undefined, resolutionForm.endedatum || undefined);
            if (dateError) throw new Error(dateError);
            const hasVorbeschlussTop = !!resolutionForm.vorbeschluss_top.trim();
            const hasVorbeschlussDate = !!resolutionForm.vorbeschluss_wev_datum;
            if (hasVorbeschlussTop !== hasVorbeschlussDate) throw new Error("TOP und Datum der WEV m\xfcssen gemeinsam bef\xfcllt werden.");
            if (!await validateCreateFaciliooProcess()) throw new Error("Facilioo Vorgang konnte nicht validiert werden.");
            if (resolutionForm.stimmberechtigte_einheiten.length === 0) throw new Error("Mindestens eine stimmberechtigte Einheit ausw\xe4hlen.");
            const created = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).createResolution({
                objectId: id,
                titel: resolutionForm.titel.trim(),
                startdatum: resolutionForm.startdatum || undefined,
                endedatum: resolutionForm.endedatum || undefined,
                stimmrechtsart: resolutionForm.stimmrechtsart,
                quorum: resolutionForm.quorum,
                vorbeschluss_top: resolutionForm.vorbeschluss_top.trim() || undefined,
                vorbeschluss_wev_datum: resolutionForm.vorbeschluss_wev_datum || undefined,
                stimmberechtigte_einheiten: resolutionForm.stimmberechtigte_einheiten,
                beschlusstext: resolutionForm.beschlusstext.trim(),
                facilioo_vorgangsnummer: $d54f4a7473082e4a$var$parseFacilioo(resolutionForm.facilioo_vorgangsnummer),
                dispatch_automation_enabled: resolutionForm.dispatch_automation_enabled,
                trigger_notifications_enabled: resolutionForm.trigger_notifications_enabled,
                trigger_notifications_channel: resolutionForm.trigger_notifications_channel,
                trigger_notifications_events: $d54f4a7473082e4a$var$normalizeTriggerNotificationEvents(resolutionForm.trigger_notifications_events)
            });
            if (createResolutionDocuments.length > 0) await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).uploadResolutionDocuments(created.id, createResolutionDocuments);
            return created;
        },
        onSuccess: async ()=>{
            setShowCreateResolution(false);
            setResolutionForm({
                objectId: id,
                beschlussnummer: "",
                titel: "",
                startdatum: "",
                endedatum: "",
                stimmrechtsart: $d54f4a7473082e4a$var$resolveDefaultStimmrechtsart(objectStandardStimmrechtsart, objectHasStimmrechte),
                quorum: "allstimmig",
                vorbeschluss_top: "",
                vorbeschluss_wev_datum: "",
                beschlusstext: "",
                facilioo_vorgangsnummer: "",
                dispatch_automation_enabled: false,
                trigger_notifications_enabled: false,
                trigger_notifications_channel: "facilioo",
                trigger_notifications_events: $d54f4a7473082e4a$var$defaultTriggerNotificationEvents(),
                stimmberechtigte_einheiten: unitSelectionRows.map((u)=>u.unitId)
            });
            setResolutionOwnerSearch("");
            setResolutionUnitTypeFilter("");
            setResolutionEntranceFilter("");
            setCreateResolutionDocuments([]);
            setCreateFaciliooValidationError("");
            setCreateFaciliooProcessTitle("");
            setFormError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setFormError(error instanceof Error ? error.message : "Umlaufbeschluss konnte nicht angelegt werden")
    });
    const updateResolutionMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (!editResolutionForm) throw new Error("Kein Beschluss gew\xe4hlt");
            const dateError = $d54f4a7473082e4a$var$getDateRangeError(editResolutionForm.startdatum || undefined, editResolutionForm.endedatum || undefined);
            if (dateError) throw new Error(dateError);
            const hasVorbeschlussTop = !!editResolutionForm.vorbeschluss_top.trim();
            const hasVorbeschlussDate = !!editResolutionForm.vorbeschluss_wev_datum;
            if (hasVorbeschlussTop !== hasVorbeschlussDate) throw new Error("TOP und Datum der WEV m\xfcssen gemeinsam bef\xfcllt werden.");
            if (!await validateEditFaciliooProcess()) throw new Error("Facilioo Vorgang konnte nicht validiert werden.");
            if (editResolutionForm.stimmberechtigte_einheiten.length === 0) throw new Error("Mindestens eine stimmberechtigte Einheit ausw\xe4hlen.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateResolution(editResolutionForm.id, {
                objectId: id,
                titel: editResolutionForm.titel.trim(),
                startdatum: editResolutionForm.startdatum || undefined,
                endedatum: editResolutionForm.endedatum || undefined,
                stimmrechtsart: editResolutionForm.stimmrechtsart,
                quorum: editResolutionForm.quorum,
                vorbeschluss_top: editResolutionForm.vorbeschluss_top.trim() || undefined,
                vorbeschluss_wev_datum: editResolutionForm.vorbeschluss_wev_datum || undefined,
                stimmberechtigte_einheiten: editResolutionForm.stimmberechtigte_einheiten,
                beschlusstext: editResolutionForm.beschlusstext.trim(),
                facilioo_vorgangsnummer: $d54f4a7473082e4a$var$parseFacilioo(editResolutionForm.facilioo_vorgangsnummer),
                dispatch_automation_enabled: editResolutionForm.dispatch_automation_enabled,
                trigger_notifications_enabled: editResolutionForm.trigger_notifications_enabled,
                trigger_notifications_channel: editResolutionForm.trigger_notifications_channel,
                trigger_notifications_events: $d54f4a7473082e4a$var$normalizeTriggerNotificationEvents(editResolutionForm.trigger_notifications_events)
            });
        },
        onSuccess: async ()=>{
            setEditResolutionForm(null);
            setEditResolutionOwnerSearch("");
            setEditResolutionUnitTypeFilter("");
            setEditResolutionEntranceFilter("");
            setEditFaciliooValidationError("");
            setEditFaciliooProcessTitle("");
            setFormError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setFormError(error instanceof Error ? error.message : "Umlaufbeschluss konnte nicht bearbeitet werden")
    });
    const startResolutionMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (rid)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).startResolution(rid),
        onSuccess: async ()=>{
            setActionError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setActionError(error instanceof Error ? error.message : "Start fehlgeschlagen")
    });
    const stopResolutionMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (rid)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).stopResolution(rid),
        onSuccess: async ()=>{
            setStopConfirm(null);
            setActionError("");
            await invalidateObjectTabs();
        },
        onError: (error)=>setActionError(error instanceof Error ? error.message : "Stop fehlgeschlagen")
    });
    const resolveDelete = async ()=>{
        if (!deleteConfirm) return;
        const [kind, entityId] = deleteConfirm.id.split(":", 2);
        try {
            if (kind !== "resolution" && objectLocked) throw new Error("Objekt ist wegen aktivem Umlaufbeschluss gesperrt");
            if (kind === "unit") await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).deactivateUnit(entityId);
            if (kind === "owner") await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).deactivateOwner(entityId);
            if (kind === "assignment") await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).deleteAssignment(entityId);
            if (kind === "resolution") await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).deleteResolution(entityId);
            setDeleteConfirm(null);
            setActionError("");
            await invalidateObjectTabs();
        } catch (error) {
            setActionError(error instanceof Error ? error.message : "L\xf6schen fehlgeschlagen");
        }
    };
    const getFilteredResolutionUnitIds = (rows, ownerSearch, unitTypeFilter, entranceFilter)=>{
        const needle = ownerSearch.trim().toLowerCase();
        return rows.filter((row)=>{
            const searchOk = !needle || row.eigentuemerInfo.toLowerCase().includes(needle) || row.einheitsnummer.toLowerCase().includes(needle);
            const typeOk = !unitTypeFilter || row.einheitstyp === unitTypeFilter;
            const entranceOk = !entranceFilter || row.aufgang === entranceFilter;
            return searchOk && typeOk && entranceOk;
        }).map((row)=>row.unitId);
    };
    const renderUnitSelector = (rows, selectedUnitIds, ownerSearch, setOwnerSearch, unitTypeFilter, setUnitTypeFilter, entranceFilter, setEntranceFilter, onToggleUnit, onSelectAll, onDeselectAll, onMarkFiltered, onDemarkFiltered)=>{
        const needle = ownerSearch.trim().toLowerCase();
        const filteredRows = rows.filter((row)=>{
            const unitNumberFormatted = $d54f4a7473082e4a$var$formatSelectionUnitNumber(row.einheitsnummer).toLowerCase();
            const searchOk = !needle || row.eigentuemerInfo.toLowerCase().includes(needle) || row.einheitsnummer.toLowerCase().includes(needle) || unitNumberFormatted.includes(needle);
            const typeOk = !unitTypeFilter || row.einheitstyp === unitTypeFilter;
            const entranceOk = !entranceFilter || row.aufgang === entranceFilter;
            return searchOk && typeOk && entranceOk;
        });
        const availableUnitTypes = Array.from(new Set(rows.map((row)=>row.einheitstyp))).sort((a, b)=>a.localeCompare(b));
        const availableEntrances = Array.from(new Set(rows.map((row)=>row.aufgang))).sort((a, b)=>a.localeCompare(b));
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "form-field form-field-wide resolution-selection-box",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "resolution-create-v2-section-head",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "resolution-create-v2-section-icon",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                name: "resolution"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            children: "Stimmberechtigte Eigent\xfcmer/Einheiten*"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "resolutions-v2-filterbar resolution-create-v2-unit-filterbar",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "resolutions-v2-filter-fields resolution-create-v2-filter-fields",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "resolutions-v2-filter-input resolution-create-v2-filter-input",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "resolutions-v2-filter-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 20 20",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        cx: "9",
                                                        cy: "9",
                                                        r: "5.8",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "m13.2 13.2 4 4",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            placeholder: "Eigent\xfcmer suchen (ID oder Name)",
                                            value: ownerSearch,
                                            onChange: (e)=>setOwnerSearch(e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: unitTypeFilter,
                                    onChange: (e)=>setUnitTypeFilter(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Alle Einheitstypen"
                                        }),
                                        availableUnitTypes.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: value,
                                                children: value
                                            }, value))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: entranceFilter,
                                    onChange: (e)=>setEntranceFilter(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Alle Aufg\xe4nge"
                                        }),
                                        availableEntrances.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: value,
                                                children: value
                                            }, value))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "resolution-create-v2-filter-actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onSelectAll,
                                    children: "Alle markieren"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onDeselectAll,
                                    children: "Alle demarkieren"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onMarkFiltered,
                                    disabled: !filteredRows.length,
                                    children: "Gefilterte markieren"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onDemarkFiltered,
                                    disabled: !filteredRows.length,
                                    children: "Gefilterte demarkieren"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "resolution-create-v2-table-wrap",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "resolution-create-v2-unit-table",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Aktiv"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Einheit"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Aufgang"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Lage"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Einheitstyp"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Eigent\xfcmer"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    filteredRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: selectedUnitIds.includes(row.unitId),
                                                        onChange: (e)=>onToggleUnit(row.unitId, e.target.checked)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    style: {
                                                        textAlign: "center"
                                                    },
                                                    children: $d54f4a7473082e4a$var$formatSelectionUnitNumber(row.einheitsnummer)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.aufgang
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.bezeichnung
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.einheitstyp
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: row.eigentuemerInfo
                                                })
                                            ]
                                        }, row.unitId)),
                                    !filteredRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: 6,
                                            children: "Keine passenden Einheiten gefunden."
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "resolution-create-v2-selection-count",
                    children: [
                        "Ausgew\xe4hlt: ",
                        selectedUnitIds.length,
                        " von ",
                        rows.length,
                        " Einheiten"
                    ]
                })
            ]
        });
    };
    const unitsRows = unitsData?.data ?? [];
    const unitTotalRows = unitsData?.meta.total ?? 0;
    const unitTotalPages = Math.max(1, Math.ceil(unitTotalRows / unitPageSize));
    const unitPageItems = (0, $acw62.useMemo)(()=>{
        const start = Math.max(1, unitPage - 2);
        const end = Math.min(unitTotalPages, start + 4);
        return Array.from({
            length: end - start + 1
        }, (_, i)=>start + i);
    }, [
        unitPage,
        unitTotalPages
    ]);
    const unitAufgangOptions = (0, $acw62.useMemo)(()=>{
        const source = unitsOverviewData?.data ?? [];
        return Array.from(new Set(source.map((u)=>(u.aufgangName || u.aufgangRef || "").trim()).filter(Boolean))).sort((a, b)=>a.localeCompare(b, "de"));
    }, [
        unitsOverviewData?.data
    ]);
    const ownersRows = ownersData?.data ?? [];
    const assignmentsRows = assignmentsData?.data ?? [];
    const resolutionsRows = resolutionsData?.data ?? [];
    const ownerTotalRows = ownersData?.meta.total ?? 0;
    const ownerTotalPages = Math.max(1, Math.ceil(ownerTotalRows / ownerPageSize));
    const ownerPageItems = (0, $acw62.useMemo)(()=>{
        const start = Math.max(1, ownerPage - 2);
        const end = Math.min(ownerTotalPages, start + 4);
        return Array.from({
            length: end - start + 1
        }, (_, i)=>start + i);
    }, [
        ownerPage,
        ownerTotalPages
    ]);
    const assignmentTotalRows = assignmentsData?.meta.total ?? 0;
    const assignmentTotalPages = Math.max(1, Math.ceil(assignmentTotalRows / assignmentPageSize));
    const assignmentPageItems = (0, $acw62.useMemo)(()=>{
        const start = Math.max(1, assignmentPage - 2);
        const end = Math.min(assignmentTotalPages, start + 4);
        return Array.from({
            length: end - start + 1
        }, (_, i)=>start + i);
    }, [
        assignmentPage,
        assignmentTotalPages
    ]);
    const resolutionTotalRows = resolutionsData?.meta.total ?? 0;
    const resolutionTotalPages = Math.max(1, Math.ceil(resolutionTotalRows / resolutionPageSize));
    const resolutionPageItems = (0, $acw62.useMemo)(()=>{
        const start = Math.max(1, resolutionPage - 2);
        const end = Math.min(resolutionTotalPages, start + 4);
        return Array.from({
            length: end - start + 1
        }, (_, i)=>start + i);
    }, [
        resolutionPage,
        resolutionTotalPages
    ]);
    const resolutionOverviewRows = resolutionsOverviewData?.data ?? [];
    const resolutionOverviewStats = {
        total: resolutionsOverviewData?.meta.total ?? 0,
        aktiv: activeResolutionsData?.meta.total ?? 0,
        abgeschlossen: completedResolutionsOverviewData?.meta.total ?? 0,
        entwurf: draftResolutionsOverviewData?.meta.total ?? 0
    };
    const latestResolutionOverviewRows = (0, $acw62.useMemo)(()=>{
        const toTime = (value)=>{
            if (!value) return 0;
            const parsed = new Date(value).getTime();
            return Number.isNaN(parsed) ? 0 : parsed;
        };
        return [
            ...resolutionOverviewRows
        ].sort((a, b)=>{
            const dateDiff = toTime(b.createdAt) - toTime(a.createdAt);
            if (dateDiff !== 0) return dateDiff;
            return b.beschlussnummer.localeCompare(a.beschlussnummer, "de", {
                numeric: true
            });
        }).slice(0, 5);
    }, [
        resolutionOverviewRows
    ]);
    const unitsOverviewTotal = summary?.stats.units ?? 0;
    const unitTypeOverviewBadges = [
        {
            label: "Wohnungen",
            count: wohnungUnitsOverviewData?.meta.total ?? 0
        },
        {
            label: "Stellpl\xe4tze",
            count: stellplatzUnitsOverviewData?.meta.total ?? 0
        },
        {
            label: "Sonstiges",
            count: sonstigeUnitsOverviewData?.meta.total ?? 0
        }
    ].filter((item)=>item.count > 0);
    const ownerOverviewStats = {
        total: summary?.stats.owners ?? 0,
        analog: summary?.stats.owners_analog ?? 0,
        digital: summary?.stats.owners_digital ?? Math.max((summary?.stats.owners ?? 0) - (summary?.stats.owners_analog ?? 0), 0)
    };
    const ownerOverviewAnalogPct = ownerOverviewStats.total > 0 ? ownerOverviewStats.analog / ownerOverviewStats.total * 100 : 0;
    const ownerOverviewDigitalPct = ownerOverviewStats.total > 0 ? ownerOverviewStats.digital / ownerOverviewStats.total * 100 : 0;
    const ownerOverviewDigitalPctLabel = ownerOverviewDigitalPct.toFixed(1).replace(".", ",");
    const ownerOverviewAnalogPctLabel = ownerOverviewAnalogPct.toFixed(1).replace(".", ",");
    const reachabilityRingPct = Math.max(0, Math.min(100, ownerOverviewDigitalPct));
    const reachabilityRingStyle = {
        "--reachability-pct": `${reachabilityRingPct}%`
    };
    const objectIsActive = summary?.object.status === "aktiv";
    const objectAddressLabel = (0, $acw62.useMemo)(()=>{
        const street = [
            summary?.object.strasse ?? "",
            summary?.object.strasse2 ?? ""
        ].filter(Boolean).join(" ").trim();
        const city = [
            summary?.object.plz ?? "",
            summary?.object.ort ?? ""
        ].filter(Boolean).join(" ").trim();
        return [
            street || "-",
            city
        ].filter(Boolean).join(" | ");
    }, [
        summary?.object.ort,
        summary?.object.plz,
        summary?.object.strasse,
        summary?.object.strasse2
    ]);
    const sumUnitStimmrecht = Number(unitsData?.meta.sumStimmrecht ?? unitsRows.reduce((sum, row)=>sum + (Number(row.stimmrecht) || 0), 0));
    const sumUnitMea = Number(unitsData?.meta.sumMea ?? unitsRows.reduce((sum, row)=>sum + (Number(row.mea) || 0), 0));
    const sumKopfstimmrecht = ownersRows.reduce((sum, row)=>sum + (row.status === "aktiv" ? 1 : 0), 0);
    const unitCanCreate = unitForm.einheitsnummer.trim() && unitForm.einheitstyp && unitForm.mea !== "" && Number(unitForm.mea) >= 0 && unitForm.status;
    const unitCanEdit = editUnitForm && editUnitForm.einheitsnummer.trim() && editUnitForm.einheitstyp && editUnitForm.mea !== "" && Number(editUnitForm.mea) >= 0;
    const ownerCanCreate = ownerForm.eigentuemer_id.trim() && $d54f4a7473082e4a$var$hasAnyOwnerName(ownerForm.name_1, ownerForm.name_2, ownerForm.name_3) && ownerForm.status;
    const ownerCanEdit = editOwnerForm && editOwnerForm.eigentuemer_id.trim() && $d54f4a7473082e4a$var$hasAnyOwnerName(editOwnerForm.name_1, editOwnerForm.name_2, editOwnerForm.name_3);
    const assignmentCanCreate = assignmentForm.unitId && assignmentForm.ownerId && assignmentForm.status;
    const assignmentCanEdit = editAssignmentForm && editAssignmentForm.unitId && editAssignmentForm.ownerId && editAssignmentForm.status;
    const resolutionDateErrors = $d54f4a7473082e4a$var$getDateFieldErrors(resolutionForm.startdatum || undefined, resolutionForm.endedatum || undefined);
    const editResolutionDateErrors = editResolutionForm ? $d54f4a7473082e4a$var$getDateFieldErrors(editResolutionForm.startdatum || undefined, editResolutionForm.endedatum || undefined) : {
        startError: null,
        endError: null
    };
    const resolutionHasVorbeschlussTop = !!resolutionForm.vorbeschluss_top.trim();
    const resolutionHasVorbeschlussDate = !!resolutionForm.vorbeschluss_wev_datum;
    const resolutionVorbeschlussPairValid = resolutionHasVorbeschlussTop === resolutionHasVorbeschlussDate;
    const resolutionVorbeschlussValid = resolutionVorbeschlussPairValid;
    const editResolutionHasVorbeschlussTop = !!editResolutionForm?.vorbeschluss_top.trim();
    const editResolutionHasVorbeschlussDate = !!editResolutionForm?.vorbeschluss_wev_datum;
    const editResolutionVorbeschlussPairValid = editResolutionHasVorbeschlussTop === editResolutionHasVorbeschlussDate;
    const editResolutionVorbeschlussValid = editResolutionVorbeschlussPairValid;
    const resolutionFaciliooRefFilled = !!resolutionForm.facilioo_vorgangsnummer.trim();
    const editResolutionFaciliooRefFilled = !!editResolutionForm?.facilioo_vorgangsnummer.trim();
    const resolutionFaciliooValid = !resolutionFaciliooRefFilled || !!createFaciliooProcessTitle && !createFaciliooValidationError;
    // Beim Bearbeiten nicht auf einen bereits geladenen Vorgangstitel warten.
    // Die Pflichtprüfung erfolgt beim Klick auf Speichern in validateEditFaciliooProcess().
    const editResolutionFaciliooValid = !editResolutionFaciliooRefFilled || !editFaciliooValidationError;
    const resolutionCanCreate = resolutionForm.titel.trim() && resolutionForm.beschlusstext.trim() && resolutionForm.stimmberechtigte_einheiten.length > 0 && !resolutionDateErrors.startError && !resolutionDateErrors.endError && resolutionVorbeschlussValid && resolutionFaciliooValid;
    const resolutionCanEdit = editResolutionForm && editResolutionForm.titel.trim() && editResolutionForm.beschlusstext.trim() && editResolutionForm.stimmberechtigte_einheiten.length > 0 && !editResolutionDateErrors.startError && !editResolutionDateErrors.endError && editResolutionVorbeschlussValid && editResolutionFaciliooValid;
    const resolutionNumberHint = "Wird systemseitig vergeben";
    const createResolutionNumber = nextResolutionNumberData?.beschlussnummer ?? "Wird beim Speichern vergeben";
    const objectDetailHasOpenForm = showCreateUnit || showCreateOwner || showCreateAssignment || showCreateResolution || !!editUnitForm || !!editOwnerForm || !!editAssignmentForm || !!editResolutionForm;
    const objectDetailPageClassName = tab === "uebersicht" || tab === "einheiten" || tab === "eigentuemer" || tab === "zuordnungen" || tab === "umlaufbeschluesse" ? `resolutions-v2-page object-detail-units-fit${objectDetailHasOpenForm ? " object-detail-form-open" : ""}` : undefined;
    const tabs = [
        {
            key: "uebersicht",
            label: "\xdcbersicht"
        },
        {
            key: "einheiten",
            label: "Einheiten"
        },
        {
            key: "eigentuemer",
            label: "Eigent\xfcmer"
        },
        {
            key: "zuordnungen",
            label: "Zuordnungen"
        },
        {
            key: "umlaufbeschluesse",
            label: "Umlaufbeschl\xfcsse"
        }
    ];
    const visibleTabs = tabs;
    (0, $acw62.useEffect)(()=>{
        setResolutionPage(1);
    }, [
        resolutionSearch,
        resolutionStatusFilter,
        resolutionResultFilter,
        resolutionSortBy,
        resolutionSortDir
    ]);
    (0, $acw62.useEffect)(()=>{
        if (resolutionForm.stimmrechtsart === "stimmrecht" && !objectCanUseStimmrecht) setResolutionForm((prev)=>({
                ...prev,
                stimmrechtsart: $d54f4a7473082e4a$var$resolveDefaultStimmrechtsart(objectStandardStimmrechtsart, objectHasStimmrechte)
            }));
    }, [
        resolutionForm.stimmrechtsart,
        objectCanUseStimmrecht,
        objectStandardStimmrechtsart,
        objectHasStimmrechte
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!showCreateResolution) return;
        setResolutionForm((prev)=>({
                ...prev,
                stimmrechtsart: $d54f4a7473082e4a$var$resolveDefaultStimmrechtsart(objectStandardStimmrechtsart, objectHasStimmrechte)
            }));
    }, [
        showCreateResolution,
        objectStandardStimmrechtsart,
        objectHasStimmrechte
    ]);
    (0, $acw62.useEffect)(()=>{
        if (editResolutionForm?.stimmrechtsart === "stimmrecht" && !objectCanUseStimmrecht) setEditResolutionForm((prev)=>prev ? {
                ...prev,
                stimmrechtsart: $d54f4a7473082e4a$var$resolveDefaultStimmrechtsart(objectStandardStimmrechtsart, objectHasStimmrechte)
            } : prev);
    }, [
        editResolutionForm?.stimmrechtsart,
        objectCanUseStimmrecht,
        objectStandardStimmrechtsart,
        objectHasStimmrechte
    ]);
    (0, $acw62.useEffect)(()=>{
        setCreateFaciliooValidationError("");
        setCreateFaciliooProcessTitle("");
    }, [
        resolutionForm.facilioo_vorgangsnummer,
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        setEditFaciliooValidationError("");
        setEditFaciliooProcessTitle("");
    }, [
        editResolutionForm?.facilioo_vorgangsnummer,
        editResolutionForm?.objectId
    ]);
    const validateCreateFaciliooProcess = async ()=>{
        const processRef = resolutionForm.facilioo_vorgangsnummer.trim();
        if (!processRef) {
            setCreateFaciliooValidationError("");
            setCreateFaciliooProcessTitle("");
            return true;
        }
        if (createFaciliooProcessTitle && !createFaciliooValidationError) return true;
        if (!id) {
            setCreateFaciliooValidationError("Objekt konnte nicht bestimmt werden.");
            setCreateFaciliooProcessTitle("");
            return false;
        }
        setCreateFaciliooValidationPending(true);
        setCreateFaciliooValidationError("");
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).validateFaciliooProcessForObject(id, processRef);
            const resolvedTitle = String(result.processTitle ?? "").trim();
            setCreateFaciliooProcessTitle(resolvedTitle || "(ohne Titel)");
            return true;
        } catch (error) {
            setCreateFaciliooProcessTitle("");
            setCreateFaciliooValidationError($d54f4a7473082e4a$var$normalizeValidationErrorMessage(error));
            return false;
        } finally{
            setCreateFaciliooValidationPending(false);
        }
    };
    const validateEditFaciliooProcess = async ()=>{
        const processRef = editResolutionForm?.facilioo_vorgangsnummer.trim() ?? "";
        if (!processRef) {
            setEditFaciliooValidationError("");
            setEditFaciliooProcessTitle("");
            return true;
        }
        if (editFaciliooProcessTitle && !editFaciliooValidationError) return true;
        const targetObjectId = editResolutionForm?.objectId || id;
        if (!targetObjectId) {
            setEditFaciliooValidationError("Objekt konnte nicht bestimmt werden.");
            setEditFaciliooProcessTitle("");
            return false;
        }
        setEditFaciliooValidationPending(true);
        setEditFaciliooValidationError("");
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).validateFaciliooProcessForObject(targetObjectId, processRef);
            const resolvedTitle = String(result.processTitle ?? "").trim();
            setEditFaciliooProcessTitle(resolvedTitle || "(ohne Titel)");
            return true;
        } catch (error) {
            setEditFaciliooProcessTitle("");
            setEditFaciliooValidationError($d54f4a7473082e4a$var$normalizeValidationErrorMessage(error));
            return false;
        } finally{
            setEditFaciliooValidationPending(false);
        }
    };
    const toggleResolutionSort = (field)=>{
        if (resolutionSortBy === field) {
            setResolutionSortDir((prev)=>prev === "asc" ? "desc" : "asc");
            return;
        }
        setResolutionSortBy(field);
        setResolutionSortDir("asc");
    };
    const resolutionSortLabel = (field, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: ()=>toggleResolutionSort(field),
            style: {
                border: "none",
                background: "transparent",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                font: "inherit",
                color: "inherit",
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                gap: 6
            },
            title: resolutionSortBy === field ? `Sortierung: ${resolutionSortDir === "asc" ? "aufsteigend" : "absteigend"}` : "Sortierung aktivieren",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: resolutionSortBy === field ? resolutionSortDir === "asc" ? "?" : "?" : "?"
                })
            ]
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: objectDetailPageClassName,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "page-header panel resolutions-v2-page-header object-detail-v2-header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "resolutions-v2-title object-detail-v2-title",
                        style: {
                            margin: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-title-icon object-detail-v2-head-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                    name: "building"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "resolutions-v2-title-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "resolutions-v2-title-main",
                                        children: [
                                            summary?.object.objektnummer ?? "-",
                                            " - ",
                                            summary?.object.objektname ?? "Objekt"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "resolutions-v2-title-sub",
                                        children: [
                                            summary?.object.strasse ?? "",
                                            summary?.object.strasse2 ? ` ${summary.object.strasse2}` : "",
                                            " | ",
                                            summary?.object.plz ?? "",
                                            " ",
                                            summary?.object.ort ?? ""
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "resolutions-v2-create-btn object-detail-v2-edit-btn",
                        onClick: ()=>navigate("/objects", {
                                state: {
                                    editObjectId: id
                                }
                            }),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-create-btn-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                    name: "edit"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Objekt bearbeiten"
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel object-tabbar object-tabbar-v2",
                children: visibleTabs.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `object-tabbtn object-tabbtn-v2 ${tab === t.key ? "active" : ""} ${t.key === "umlaufbeschluesse" ? "object-tabbtn--resolutions" : ""}`,
                        onClick: ()=>setTab(t.key),
                        children: t.label
                    }, t.key))
            }),
            tab === "uebersicht" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel object-overview-grid object-overview-grid-v2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "kpi object-overview-kpi-v2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "object-overview-kpi-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "resolution"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "object-overview-kpi-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Umlaufbeschl\xfcsse"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: resolutionOverviewStats.total
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "Gesamt"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "kpi-unit-type-badges",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "badge object-v2-pill-running",
                                                        children: [
                                                            "Laufend: ",
                                                            resolutionOverviewStats.aktiv
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "badge object-v2-pill-ended",
                                                        children: [
                                                            "Beendet: ",
                                                            resolutionOverviewStats.abgeschlossen
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "badge object-v2-pill-draft",
                                                        children: [
                                                            "Entw\xfcrfe: ",
                                                            resolutionOverviewStats.entwurf
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "kpi object-overview-kpi-v2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "object-overview-kpi-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "object-overview-kpi-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Einheiten"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: unitsOverviewTotal
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "Gesamt"
                                            }),
                                            unitTypeOverviewBadges.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "kpi-unit-type-badges",
                                                children: unitTypeOverviewBadges.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "badge object-v2-pill-gray",
                                                        children: [
                                                            item.label,
                                                            ": ",
                                                            item.count
                                                        ]
                                                    }, item.label))
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "kpi object-overview-kpi-v2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "object-overview-kpi-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "owners"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "object-overview-kpi-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Eigent\xfcmer"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: ownerOverviewStats.total
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "Gesamt"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "kpi-unit-type-badges",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "badge object-v2-pill-green",
                                                        children: [
                                                            "Digital erreichbar: ",
                                                            ownerOverviewStats.digital
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "badge object-v2-pill-ended",
                                                        children: [
                                                            "Nicht digital erreichbar: ",
                                                            ownerOverviewStats.analog
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel object-overview-detail-grid-v2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                className: "object-overview-detail-card-v2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "object-overview-card-title-v2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "object-overview-card-title-icon-v2",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                    name: "resolution"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Letzte 5 Umlaufbeschl\xfcsse"
                                            })
                                        ]
                                    }),
                                    latestResolutionOverviewRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "object-overview-resolution-list-v2",
                                        children: latestResolutionOverviewRows.map((resolution)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "object-overview-resolution-row-v2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `object-overview-resolution-icon-v2 object-overview-resolution-icon-v2--${resolution.status}`,
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "resolution"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "object-overview-resolution-main-v2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "object-overview-resolution-title-line-v2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        className: "object-overview-resolution-title-v2",
                                                                        to: `/resolutions/${resolution.id}`,
                                                                        title: resolution.titel,
                                                                        children: resolution.titel || "Ohne Titel"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `badge ${resolution.status}`,
                                                                        children: $d54f4a7473082e4a$var$formatResolutionStatus(resolution.status)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                children: [
                                                                    "Beschluss-Nr. ",
                                                                    resolution.beschlussnummer
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "object-overview-resolution-meta-v2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("time", {
                                                                children: $d54f4a7473082e4a$var$formatDateDE(resolution.endedatum ?? resolution.startdatum ?? resolution.createdAt)
                                                            }),
                                                            (()=>{
                                                                const outcome = $d54f4a7473082e4a$var$getResolutionOverviewOutcome(resolution);
                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: `object-overview-resolution-result-v2 object-overview-resolution-result-v2--${outcome.tone ?? "neutral"}`,
                                                                    children: [
                                                                        "Ergebnis: ",
                                                                        outcome.label
                                                                    ]
                                                                });
                                                            })()
                                                        ]
                                                    })
                                                ]
                                            }, resolution.id))
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "object-overview-resolution-empty-v2",
                                        children: "F\xfcr dieses Objekt liegen noch keine Umlaufbeschl\xfcsse vor."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                className: "object-overview-detail-card-v2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "object-overview-card-title-v2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "object-overview-card-title-icon-v2",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                    name: "building"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Objektinformationen"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "object-overview-info-list-v2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "object-overview-info-icon",
                                                        "aria-hidden": "true",
                                                        children: "#"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Objektnummer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: summary?.object.objektnummer ?? "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "object-overview-info-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "pin"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Adresse"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: objectAddressLabel
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "object-overview-info-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "building"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Objekttyp"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Wohnungseigent\xfcmergemeinschaft"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "object-overview-info-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "calendar"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Erstellt am"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                        children: [
                                                            $d54f4a7473082e4a$var$formatDateTimeDE(summary?.object.createdAt),
                                                            " Uhr"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "object-overview-info-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "refresh"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Zuletzt aktualisiert"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                        children: [
                                                            $d54f4a7473082e4a$var$formatDateTimeDE(summary?.object.updatedAt),
                                                            " Uhr"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                className: "object-overview-detail-card-v2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "object-overview-card-title-v2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "object-overview-card-title-icon-v2",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                    name: "reachability"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Digitale Erreichbarkeit"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "object-reachability-v2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "object-reachability-ring-v2",
                                                style: reachabilityRingStyle,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "object-reachability-ring-inner-v2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                            children: [
                                                                Math.round(reachabilityRingPct),
                                                                "%"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "digital erreichbar"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "object-reachability-legend-v2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "reachability-line reachability-line-digital",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "dot dot-digital"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Digital erreichbar"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                children: [
                                                                    ownerOverviewStats.digital,
                                                                    " Eigent\xfcmer"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                children: [
                                                                    ownerOverviewDigitalPctLabel,
                                                                    " %"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "reachability-line reachability-line-analog",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "dot dot-analog"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Nicht digital erreichbar"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                children: [
                                                                    ownerOverviewStats.analog,
                                                                    " Eigent\xfcmer"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                children: [
                                                                    ownerOverviewAnalogPctLabel,
                                                                    " %"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "reachability-total",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Gesamt"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    ownerOverviewStats.total,
                                                                    " Eigent\xfcmer"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "object-overview-footer-row-v2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `panel object-overview-footer-v2 v2-info-banner ${objectIsActive ? "object-overview-footer-v2--active" : "object-overview-footer-v2--inactive"}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "imports-sync-info-icon object-overview-footer-icon",
                                        "aria-hidden": "true",
                                        children: "i"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-sync-info-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: objectIsActive ? "Dieses Objekt ist aktiv" : "Dieses Objekt ist inaktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: objectIsActive ? "Sie k\xf6nnen Einheiten, Eigent\xfcmer und Umlaufbeschl\xfcsse verwalten sowie neue Abstimmungen erstellen." : "Dieses Objekt ist deaktiviert. Neue Umlaufbeschl\xfcsse k\xf6nnen nicht angelegt werden."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            canCreateResolutions && objectIsActive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: "resolutions-v2-create-btn object-overview-footer-create-btn",
                                onClick: ()=>{
                                    setTab("umlaufbeschluesse");
                                    setShowCreateResolution(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-create-btn-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "plus"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Umlaufbeschluss erstellen"
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }) : null,
            tab === "einheiten" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "page-header panel resolutions-v2-page-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "resolutions-v2-title",
                                style: {
                                    margin: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "resolutions-v2-title-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-title-main",
                                                children: "Einheiten"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-title-sub",
                                                children: "\xdcbersicht aller Einheiten und Nutzungsdaten"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: "resolutions-v2-create-btn",
                                onClick: ()=>setShowCreateUnit((v)=>!v),
                                disabled: objectLocked,
                                children: [
                                    !showCreateUnit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-create-btn-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "plus"
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: showCreateUnit ? "Schlie\xdfen" : "Neue Einheit"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    canManageMasterDataActions && showCreateUnit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form resolution-create-form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Einheitsnummer*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: unitForm.einheitsnummer,
                                                onChange: (e)=>setUnitForm({
                                                        ...unitForm,
                                                        einheitsnummer: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Lage"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: unitForm.bezeichnung,
                                                onChange: (e)=>setUnitForm({
                                                        ...unitForm,
                                                        bezeichnung: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Einheitstyp*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: unitForm.einheitstyp,
                                                onChange: (e)=>setUnitForm({
                                                        ...unitForm,
                                                        einheitstyp: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Einheitstyp w\xe4hlen*"
                                                    }),
                                                    (0, $f336a13bdd60accb$export$4b74ea5d724dd45).map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: value,
                                                            children: (0, $f336a13bdd60accb$export$a10aac408d86876b)(value)
                                                        }, value))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Stimmrecht"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: "0",
                                                step: "0.01",
                                                value: unitForm.stimmrecht,
                                                onChange: (e)=>setUnitForm({
                                                        ...unitForm,
                                                        stimmrecht: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "MEA*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: "0",
                                                step: "0.01",
                                                value: unitForm.mea,
                                                onChange: (e)=>setUnitForm({
                                                        ...unitForm,
                                                        mea: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Status*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: unitForm.status,
                                                onChange: (e)=>setUnitForm({
                                                        ...unitForm,
                                                        status: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Status w\xe4hlen*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "Aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "Inaktiv"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-actions",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    disabled: !unitCanCreate || createUnitMutation.isPending || objectLocked,
                                    onClick: ()=>createUnitMutation.mutate(),
                                    children: createUnitMutation.isPending ? "Speichere..." : "Einheit speichern"
                                })
                            })
                        ]
                    }) : null,
                    !showCreateUnit && canManageMasterDataActions && editUnitForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form resolution-create-form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Einheitsnummer*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editUnitForm.einheitsnummer,
                                                onChange: (e)=>setEditUnitForm({
                                                        ...editUnitForm,
                                                        einheitsnummer: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Lage"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editUnitForm.bezeichnung,
                                                onChange: (e)=>setEditUnitForm({
                                                        ...editUnitForm,
                                                        bezeichnung: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Einheitstyp*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                value: editUnitForm.einheitstyp,
                                                onChange: (e)=>setEditUnitForm({
                                                        ...editUnitForm,
                                                        einheitstyp: e.target.value
                                                    }),
                                                children: (0, $f336a13bdd60accb$export$4b74ea5d724dd45).map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: value,
                                                        children: (0, $f336a13bdd60accb$export$a10aac408d86876b)(value)
                                                    }, value))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Stimmrecht"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: "0",
                                                step: "0.01",
                                                value: editUnitForm.stimmrecht,
                                                onChange: (e)=>setEditUnitForm({
                                                        ...editUnitForm,
                                                        stimmrecht: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "MEA*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: "0",
                                                step: "0.01",
                                                value: editUnitForm.mea,
                                                onChange: (e)=>setEditUnitForm({
                                                        ...editUnitForm,
                                                        mea: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Status*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: editUnitForm.status,
                                                onChange: (e)=>setEditUnitForm({
                                                        ...editUnitForm,
                                                        status: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "Aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "Inaktiv"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: !unitCanEdit || updateUnitMutation.isPending || objectLocked,
                                        onClick: ()=>updateUnitMutation.mutate(),
                                        children: updateUnitMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>setEditUnitForm(null),
                                        children: "Abbrechen"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    !showCreateUnit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel resolutions-v2-list-panel object-detail-units-list-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-filterbar",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolutions-v2-filter-fields",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "resolutions-v2-filter-input",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-filter-icon",
                                                        "aria-hidden": "true",
                                                        children: $d54f4a7473082e4a$var$unitListIcons.search
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        placeholder: "Suche...",
                                                        value: unitSearch,
                                                        onChange: (e)=>setUnitSearch(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: unitAufgangFilter,
                                                onChange: (e)=>setUnitAufgangFilter(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Alle Aufg\xe4nge"
                                                    }),
                                                    unitAufgangOptions.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: value,
                                                            children: value
                                                        }, value))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: unitTypeFilter,
                                                onChange: (e)=>setUnitTypeFilter(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Alle Einheitstypen"
                                                    }),
                                                    (0, $f336a13bdd60accb$export$4b74ea5d724dd45).map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: value,
                                                            children: (0, $f336a13bdd60accb$export$a10aac408d86876b)(value)
                                                        }, value))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: unitStatus,
                                                onChange: (e)=>setUnitStatus(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Alle Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "Aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "Inaktiv"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "resolutions-v2-reset-btn",
                                        onClick: ()=>{
                                            setUnitSearch("");
                                            setUnitAufgangFilter("");
                                            setUnitTypeFilter("");
                                            setUnitStatus("aktiv");
                                            setUnitSortBy("einheitsnummer");
                                            setUnitSortDir("asc");
                                            setUnitPage(1);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-reset-btn-icon",
                                                "aria-hidden": "true",
                                                children: $d54f4a7473082e4a$var$unitListIcons.reset
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Filter zur\xfccksetzen"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-row-count",
                                children: [
                                    "Zeilen: ",
                                    unitsRows.length,
                                    " / Gesamt: ",
                                    unitTotalRows
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-table-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "resolutions-v2-table units-v2-table",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: renderUnitSortHeader("einheitsnummer", "Einheit-Nr", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "home"
                                                        }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Aufgang", $d54f4a7473082e4a$var$unitListIcons.entrance)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: renderUnitSortHeader("bezeichnung", "Lage", $d54f4a7473082e4a$var$unitListIcons.location)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Einheitstyp", $d54f4a7473082e4a$var$unitListIcons.type)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Stimmrecht", $d54f4a7473082e4a$var$unitListIcons.votes)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("MEA", $d54f4a7473082e4a$var$unitListIcons.mea)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Status", $d54f4a7473082e4a$var$unitListIcons.status)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "resolutions-v2-actions-head",
                                                        "aria-label": "Aktionen",
                                                        title: "Aktionen",
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("", $d54f4a7473082e4a$var$unitListIcons.actions)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: unitsRows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: formatEinheitsnummer(r.einheitsnummer)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: r.aufgangName || r.aufgangRef || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "resolutions-v2-object-cell",
                                                            children: r.bezeichnung || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: (0, $f336a13bdd60accb$export$a10aac408d86876b)(r.einheitstyp)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: formatNumberDE(r.stimmrecht)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: formatNumberDE(r.mea)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `badge ${r.status}`,
                                                                children: r.status
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: !canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                style: {
                                                                    color: "var(--text-soft)"
                                                                },
                                                                children: "-"
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "resolutions-v2-action-wrap",
                                                                onClick: (e)=>e.stopPropagation(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "resolutions-v2-action-trigger",
                                                                        "aria-label": `Aktionen f\xfcr Einheit ${r.einheitsnummer}`,
                                                                        "aria-expanded": unitOpenActionMenuId === r.id,
                                                                        onMouseDown: (e)=>e.stopPropagation(),
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            if (unitOpenActionMenuId === r.id) {
                                                                                setUnitOpenActionMenuId(null);
                                                                                return;
                                                                            }
                                                                            openDetailActionMenu(r.id, e.currentTarget, setUnitOpenActionMenuId, 96);
                                                                        },
                                                                        children: "\u22EE"
                                                                    }),
                                                                    unitOpenActionMenuId === r.id && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                        style: {
                                                                            left: actionMenuPosition.left,
                                                                            top: actionMenuPosition.top
                                                                        },
                                                                        onMouseDown: (e)=>e.stopPropagation(),
                                                                        onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                        onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                disabled: objectLocked,
                                                                                onClick: ()=>{
                                                                                    setEditUnitForm({
                                                                                        id: r.id,
                                                                                        einheitsnummer: r.einheitsnummer,
                                                                                        bezeichnung: r.bezeichnung,
                                                                                        einheitstyp: String(r.einheitstyp ?? "").trim().toLowerCase(),
                                                                                        stimmrecht: String(r.stimmrecht),
                                                                                        mea: r.mea !== undefined ? String(r.mea) : "",
                                                                                        status: r.status
                                                                                    });
                                                                                    setUnitOpenActionMenuId(null);
                                                                                },
                                                                                children: "Bearbeiten"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                disabled: objectLocked,
                                                                                onClick: ()=>{
                                                                                    setDeleteConfirm({
                                                                                        id: `unit:${r.id}`,
                                                                                        label: r.einheitsnummer,
                                                                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                        input: [
                                                                                            "",
                                                                                            "",
                                                                                            "",
                                                                                            ""
                                                                                        ],
                                                                                        error: ""
                                                                                    });
                                                                                    setUnitOpenActionMenuId(null);
                                                                                },
                                                                                children: "L\xf6schen"
                                                                            })
                                                                        ]
                                                                    }), document.body) : null
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, r.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-pagination",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolutions-v2-page-size",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: String(unitPageSize),
                                            onChange: (e)=>{
                                                setUnitPageSize(Number(e.target.value) || 10);
                                                setUnitPage(1);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "10",
                                                    children: "10 pro Seite"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "20",
                                                    children: "20 pro Seite"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "50",
                                                    children: "50 pro Seite"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolutions-v2-page-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "resolutions-v2-page-arrow",
                                                onClick: ()=>setUnitPage((prev)=>Math.max(1, prev - 1)),
                                                disabled: unitPage <= 1,
                                                children: "\u2039"
                                            }),
                                            unitPageItems.map((pageItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `resolutions-v2-page-chip ${pageItem === unitPage ? "active" : ""}`,
                                                    onClick: ()=>setUnitPage(pageItem),
                                                    children: pageItem
                                                }, pageItem)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "resolutions-v2-page-arrow",
                                                onClick: ()=>setUnitPage((prev)=>Math.min(unitTotalPages, prev + 1)),
                                                disabled: unitPage >= unitTotalPages,
                                                children: "\u203A"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "resolutions-v2-page-info",
                                                children: [
                                                    "Seite ",
                                                    unitPage,
                                                    " von ",
                                                    unitTotalPages
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolutions-v2-page-next-wrap",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            className: "resolutions-v2-next-btn",
                                            onClick: ()=>setUnitPage((prev)=>Math.min(unitTotalPages, prev + 1)),
                                            disabled: unitPage >= unitTotalPages,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Weiter"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: "\u203A"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    !showCreateUnit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Summe"
                            }),
                            " | Stimmrechte: ",
                            sumUnitStimmrecht.toFixed(2),
                            " | MEA: ",
                            sumUnitMea.toFixed(2)
                        ]
                    }) : null
                ]
            }) : null,
            tab === "eigentuemer" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "page-header panel resolutions-v2-page-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "resolutions-v2-title",
                                style: {
                                    margin: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "owners"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "resolutions-v2-title-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-title-main",
                                                children: "Eigent\xfcmer"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-title-sub",
                                                children: "\xdcbersicht aller Eigent\xfcmer dieses Objekts"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: "resolutions-v2-create-btn",
                                onClick: ()=>setShowCreateOwner((v)=>!v),
                                disabled: objectLocked,
                                children: [
                                    !showCreateOwner ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-create-btn-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "plus"
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: showCreateOwner ? "Schlie\xdfen" : "Neuer Eigent\xfcmer"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    canManageMasterDataActions && showCreateOwner ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form resolution-create-form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Eigent\xfcmer ID*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.eigentuemer_id,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        eigentuemer_id: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Anrede"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: ownerForm.anrede,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        anrede: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Anrede w\xe4hlen"
                                                    }),
                                                    anredeOptions.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: opt,
                                                            children: opt
                                                        }, opt))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Titel"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: ownerForm.titel,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        titel: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Titel w\xe4hlen"
                                                    }),
                                                    titelOptions.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: opt,
                                                            children: opt
                                                        }, opt))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Vorname"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.vorname,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        vorname: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Name 1*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.name_1,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        name_1: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Name 2"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.name_2,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        name_2: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Name 3"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.name_3,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        name_3: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Stra\xdfe / Postfach"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.strasse,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        strasse: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "PLZ"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.plz,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        plz: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Ort"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.ort,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        ort: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "L\xe4nder-Code"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.land_code,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        land_code: e.target.value.toUpperCase()
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Land"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.land,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        land: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "E-Mail"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.email,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        email: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Telefon"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: ownerForm.telefon,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        telefon: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Status*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: ownerForm.status,
                                                onChange: (e)=>setOwnerForm({
                                                        ...ownerForm,
                                                        status: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Status w\xe4hlen*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "Aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "Inaktiv"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-actions",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    disabled: !ownerCanCreate || createOwnerMutation.isPending || objectLocked,
                                    onClick: ()=>createOwnerMutation.mutate(),
                                    children: createOwnerMutation.isPending ? "Speichere..." : "Eigent\xfcmer speichern"
                                })
                            })
                        ]
                    }) : null,
                    !showCreateOwner && canManageMasterDataActions && editOwnerForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form resolution-create-form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Eigent\xfcmer ID*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.eigentuemer_id,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        eigentuemer_id: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Anrede"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: editOwnerForm.anrede,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        anrede: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Anrede w\xe4hlen"
                                                    }),
                                                    anredeOptions.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: opt,
                                                            children: opt
                                                        }, opt))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Titel"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: editOwnerForm.titel,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        titel: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Titel w\xe4hlen"
                                                    }),
                                                    titelOptions.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: opt,
                                                            children: opt
                                                        }, opt))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Vorname"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.vorname,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        vorname: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Name 1*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.name_1,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        name_1: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Name 2"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.name_2,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        name_2: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Name 3"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.name_3,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        name_3: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Stra\xdfe / Postfach"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.strasse,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        strasse: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "PLZ"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.plz,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        plz: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Ort"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.ort,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        ort: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "L\xe4nder-Code"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.land_code,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        land_code: e.target.value.toUpperCase()
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Land"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.land,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        land: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "E-Mail"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.email,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        email: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Telefon"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editOwnerForm.telefon,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        telefon: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Status*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: editOwnerForm.status,
                                                onChange: (e)=>setEditOwnerForm({
                                                        ...editOwnerForm,
                                                        status: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "Aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "Inaktiv"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: !ownerCanEdit || updateOwnerMutation.isPending || objectLocked,
                                        onClick: ()=>updateOwnerMutation.mutate(),
                                        children: updateOwnerMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>setEditOwnerForm(null),
                                        children: "Abbrechen"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    !showCreateOwner ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel resolutions-v2-list-panel object-detail-units-list-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-filterbar",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolutions-v2-filter-fields",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "resolutions-v2-filter-input",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-filter-icon",
                                                        "aria-hidden": "true",
                                                        children: $d54f4a7473082e4a$var$unitListIcons.search
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        placeholder: "Suche...",
                                                        value: ownerSearchFilter,
                                                        onChange: (e)=>setOwnerSearchFilter(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: ownerReachabilityFilter,
                                                onChange: (e)=>setOwnerReachabilityFilter(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Alle Erreichbarkeit"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "digital",
                                                        children: "Digital"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "analog",
                                                        children: "Analog"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: ownerStatusFilter,
                                                onChange: (e)=>setOwnerStatusFilter(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Alle Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "Aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "Inaktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "keine_zuordnung",
                                                        children: "Keine Zuordnung"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "resolutions-v2-reset-btn",
                                        onClick: ()=>{
                                            setOwnerSearchFilter("");
                                            setOwnerReachabilityFilter("");
                                            setOwnerStatusFilter("aktiv");
                                            setOwnerPage(1);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-reset-btn-icon",
                                                "aria-hidden": "true",
                                                children: $d54f4a7473082e4a$var$unitListIcons.reset
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Filter zur\xfccksetzen"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-row-count",
                                children: [
                                    "Zeilen: ",
                                    ownersRows.length,
                                    " / Gesamt: ",
                                    ownerTotalRows
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-table-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "resolutions-v2-table owners-v2-table",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "resolutions-v2-th-plain",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "resolutions-v2-th-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                cx: "10",
                                                                                cy: "7.4",
                                                                                r: "2.5",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M5.2 15.9a4.8 4.8 0 0 1 9.6 0",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7",
                                                                                strokeLinecap: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "resolutions-v2-th-label",
                                                                    children: "Eigent\xfcmer-ID"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Eigent\xfcmername", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "owners"
                                                        }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("E-Mail", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "edit"
                                                        }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Erreichbarkeit", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "reachability"
                                                        }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Status", $d54f4a7473082e4a$var$unitListIcons.status)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "resolutions-v2-actions-head",
                                                        "aria-label": "Aktionen",
                                                        title: "Aktionen",
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("", $d54f4a7473082e4a$var$unitListIcons.actions)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: ownersRows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: r.eigentuemer_id
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: [
                                                                r.anrede,
                                                                r.titel,
                                                                r.vorname,
                                                                r.name_1,
                                                                r.name_2,
                                                                r.name_3
                                                            ].map((part)=>String(part ?? "").trim()).filter(Boolean).join(" ") || r.vollname || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: r.email || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `badge ${r.ist_analog ? "erreichbar-analog" : "erreichbar-digital"}`,
                                                                children: r.ist_analog ? "analog" : "digital"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `badge ${r.status} quick-tooltip`,
                                                                "data-tooltip": $d54f4a7473082e4a$var$buildOwnerValidityTooltip(r),
                                                                tabIndex: 0,
                                                                children: $d54f4a7473082e4a$var$formatOwnerStatusLabel(r.status)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: !canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                style: {
                                                                    color: "var(--text-soft)"
                                                                },
                                                                children: "-"
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "resolutions-v2-action-wrap",
                                                                onClick: (e)=>e.stopPropagation(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "resolutions-v2-action-trigger",
                                                                        "aria-label": `Aktionen f\xfcr Eigent\xfcmer ${r.eigentuemer_id}`,
                                                                        "aria-expanded": ownerOpenActionMenuId === r.id,
                                                                        onMouseDown: (e)=>e.stopPropagation(),
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            if (ownerOpenActionMenuId === r.id) {
                                                                                setOwnerOpenActionMenuId(null);
                                                                                return;
                                                                            }
                                                                            openDetailActionMenu(r.id, e.currentTarget, setOwnerOpenActionMenuId, 96);
                                                                        },
                                                                        children: "\u22EE"
                                                                    }),
                                                                    ownerOpenActionMenuId === r.id && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                        style: {
                                                                            left: actionMenuPosition.left,
                                                                            top: actionMenuPosition.top
                                                                        },
                                                                        onMouseDown: (e)=>e.stopPropagation(),
                                                                        onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                        onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                disabled: objectLocked,
                                                                                onClick: ()=>{
                                                                                    setEditOwnerForm({
                                                                                        id: r.id,
                                                                                        eigentuemer_id: r.eigentuemer_id,
                                                                                        anrede: r.anrede ?? "",
                                                                                        titel: r.titel ?? "",
                                                                                        vorname: r.vorname ?? "",
                                                                                        name_1: r.name_1 ?? "",
                                                                                        name_2: r.name_2 ?? "",
                                                                                        name_3: r.name_3 ?? "",
                                                                                        strasse: r.strasse ?? "",
                                                                                        plz: r.plz ?? "",
                                                                                        ort: r.ort ?? "",
                                                                                        land_code: r.land_code ?? "",
                                                                                        land: r.land ?? "",
                                                                                        email: r.email ?? "",
                                                                                        telefon: r.telefon ?? "",
                                                                                        status: r.status === "inaktiv" ? "inaktiv" : "aktiv"
                                                                                    });
                                                                                    setOwnerOpenActionMenuId(null);
                                                                                },
                                                                                children: "Bearbeiten"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                disabled: objectLocked,
                                                                                onClick: ()=>{
                                                                                    setDeleteConfirm({
                                                                                        id: `owner:${r.id}`,
                                                                                        label: r.eigentuemer_id,
                                                                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                        input: [
                                                                                            "",
                                                                                            "",
                                                                                            "",
                                                                                            ""
                                                                                        ],
                                                                                        error: ""
                                                                                    });
                                                                                    setOwnerOpenActionMenuId(null);
                                                                                },
                                                                                children: "L\xf6schen"
                                                                            })
                                                                        ]
                                                                    }), document.body) : null
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, r.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-pagination",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolutions-v2-page-size",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: String(ownerPageSize),
                                            onChange: (e)=>{
                                                setOwnerPageSize(Number(e.target.value) || 10);
                                                setOwnerPage(1);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "10",
                                                    children: "10 pro Seite"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "20",
                                                    children: "20 pro Seite"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "50",
                                                    children: "50 pro Seite"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolutions-v2-page-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "resolutions-v2-page-arrow",
                                                onClick: ()=>setOwnerPage((prev)=>Math.max(1, prev - 1)),
                                                disabled: ownerPage <= 1,
                                                children: "\u2039"
                                            }),
                                            ownerPageItems.map((pageItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `resolutions-v2-page-chip ${pageItem === ownerPage ? "active" : ""}`,
                                                    onClick: ()=>setOwnerPage(pageItem),
                                                    children: pageItem
                                                }, pageItem)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "resolutions-v2-page-arrow",
                                                onClick: ()=>setOwnerPage((prev)=>Math.min(ownerTotalPages, prev + 1)),
                                                disabled: ownerPage >= ownerTotalPages,
                                                children: "\u203A"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "resolutions-v2-page-info",
                                                children: [
                                                    "Seite ",
                                                    ownerPage,
                                                    " von ",
                                                    ownerTotalPages
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolutions-v2-page-next-wrap",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            className: "resolutions-v2-next-btn",
                                            onClick: ()=>setOwnerPage((prev)=>Math.min(ownerTotalPages, prev + 1)),
                                            disabled: ownerPage >= ownerTotalPages,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Weiter"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: "\u203A"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    !showCreateOwner ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Summe"
                            }),
                            " | Kopfstimmrecht (nur aktive Eigent\xfcmer): ",
                            sumKopfstimmrecht
                        ]
                    }) : null
                ]
            }) : null,
            tab === "zuordnungen" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "page-header panel resolutions-v2-page-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "resolutions-v2-title",
                                style: {
                                    margin: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "assignments"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "resolutions-v2-title-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-title-main",
                                                children: "Zuordnungen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-title-sub",
                                                children: "\xdcbersicht aller Zuordnungen dieses Objekts"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: "resolutions-v2-create-btn",
                                onClick: ()=>setShowCreateAssignment((v)=>!v),
                                disabled: objectLocked,
                                children: [
                                    !showCreateAssignment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-create-btn-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "plus"
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: showCreateAssignment ? "Schlie\xdfen" : "Neue Zuordnung"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    canManageMasterDataActions && showCreateAssignment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form resolution-create-form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "grid",
                                    gridTemplateColumns: "minmax(260px, 1.6fr) minmax(180px, 1fr) minmax(180px, 1fr) minmax(140px, 0.7fr)",
                                    gap: 10,
                                    alignItems: "start"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Eigent\xfcmer*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                placeholder: "Eigent\xfcmer suchen (ID, Name, E-Mail)",
                                                value: assignmentOwnerSearch,
                                                onChange: (e)=>setAssignmentOwnerSearch(e.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                style: {
                                                    marginTop: 6,
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                    fontWeight: 500
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: assignmentOnlyUnassigned,
                                                        onChange: (e)=>setAssignmentOnlyUnassigned(e.target.checked)
                                                    }),
                                                    "Nur ohne Zuordnung"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Objekt*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: `${summary?.object.objektnummer ?? "-"} - ${summary?.object.objektname ?? "-"}`,
                                                disabled: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Einheit*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: assignmentForm.unitId,
                                                onChange: (e)=>setAssignmentForm({
                                                        ...assignmentForm,
                                                        unitId: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Einheit w\xe4hlen*"
                                                    }),
                                                    (unitsForSelectionData?.data ?? []).map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: u.id,
                                                            children: `${u.einheitsnummer} - ${u.bezeichnung || "-"}`
                                                        }, u.id))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Status*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: assignmentForm.status,
                                                onChange: (e)=>setAssignmentForm({
                                                        ...assignmentForm,
                                                        status: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Status w\xe4hlen*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "Aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "Inaktiv"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: 10
                                },
                                children: [
                                    renderAssignmentOwnerSearchList(filteredAssignmentOwners, assignmentForm.ownerId, (ownerId)=>setAssignmentForm({
                                            ...assignmentForm,
                                            ownerId: ownerId
                                        })),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                        style: {
                                            color: "var(--text-soft)"
                                        },
                                        children: [
                                            filteredAssignmentOwners.length,
                                            " Treffer"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-actions",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    disabled: !assignmentCanCreate || createAssignmentMutation.isPending || objectLocked,
                                    onClick: ()=>createAssignmentMutation.mutate(),
                                    children: createAssignmentMutation.isPending ? "Speichere..." : "Zuordnung speichern"
                                })
                            })
                        ]
                    }) : null,
                    canManageMasterDataActions && editAssignmentForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form resolution-create-form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "grid",
                                    gridTemplateColumns: "minmax(260px, 1.6fr) minmax(180px, 1fr) minmax(180px, 1fr) minmax(140px, 0.7fr)",
                                    gap: 10,
                                    alignItems: "start"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Eigent\xfcmer*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                placeholder: "Eigent\xfcmer suchen (ID, Name, E-Mail)",
                                                value: editAssignmentOwnerSearch,
                                                onChange: (e)=>setEditAssignmentOwnerSearch(e.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                style: {
                                                    marginTop: 6,
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                    fontWeight: 500
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: editAssignmentOnlyUnassigned,
                                                        onChange: (e)=>setEditAssignmentOnlyUnassigned(e.target.checked)
                                                    }),
                                                    "Nur ohne Zuordnung"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Objekt*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: `${summary?.object.objektnummer ?? "-"} - ${summary?.object.objektname ?? "-"}`,
                                                disabled: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Einheit*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: editAssignmentForm.unitId,
                                                onChange: (e)=>setEditAssignmentForm({
                                                        ...editAssignmentForm,
                                                        unitId: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Einheit w\xe4hlen*"
                                                    }),
                                                    (unitsForSelectionData?.data ?? []).map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: u.id,
                                                            children: `${u.einheitsnummer} - ${u.bezeichnung || "-"}`
                                                        }, u.id))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Status*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: editAssignmentForm.status,
                                                onChange: (e)=>setEditAssignmentForm({
                                                        ...editAssignmentForm,
                                                        status: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "Aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "Inaktiv"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: 10
                                },
                                children: [
                                    renderAssignmentOwnerSearchList(filteredEditAssignmentOwners, editAssignmentForm.ownerId, (ownerId)=>setEditAssignmentForm({
                                            ...editAssignmentForm,
                                            ownerId: ownerId
                                        })),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                        style: {
                                            color: "var(--text-soft)"
                                        },
                                        children: [
                                            filteredEditAssignmentOwners.length,
                                            " Treffer"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: !assignmentCanEdit || updateAssignmentMutation.isPending || objectLocked,
                                        onClick: ()=>updateAssignmentMutation.mutate(),
                                        children: updateAssignmentMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>{
                                            setEditAssignmentForm(null);
                                            setEditAssignmentOwnerSearch("");
                                        },
                                        children: "Abbrechen"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel resolutions-v2-list-panel object-detail-units-list-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-filterbar",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolutions-v2-filter-fields",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "resolutions-v2-filter-input",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-filter-icon",
                                                        "aria-hidden": "true",
                                                        children: $d54f4a7473082e4a$var$unitListIcons.search
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        placeholder: "Suche...",
                                                        value: search,
                                                        onChange: (e)=>setSearch(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: assignmentRecipientFilter,
                                                onChange: (e)=>setAssignmentRecipientFilter(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Alle"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "owner",
                                                        children: "Eigent\xfcmer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "authorized",
                                                        children: "Zustellungsbevollm\xe4chtigt"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "resolutions-v2-reset-btn",
                                        onClick: ()=>{
                                            setSearch("");
                                            setAssignmentRecipientFilter("");
                                            setAssignmentPage(1);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-reset-btn-icon",
                                                "aria-hidden": "true",
                                                children: $d54f4a7473082e4a$var$unitListIcons.reset
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Filter zur\xfccksetzen"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-row-count",
                                children: [
                                    "Zeilen: ",
                                    assignmentsRows.length,
                                    " / Gesamt: ",
                                    assignmentTotalRows
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-table-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "resolutions-v2-table assignments-v2-table",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Einheit-Nr", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "home"
                                                        }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "resolutions-v2-th-plain",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "resolutions-v2-th-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                cx: "10",
                                                                                cy: "7.4",
                                                                                r: "2.5",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M5.2 15.9a4.8 4.8 0 0 1 9.6 0",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7",
                                                                                strokeLinecap: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "resolutions-v2-th-label",
                                                                    children: "Eigent\xfcmer-ID"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Eigent\xfcmername", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "owners"
                                                        }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("E-Mail", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                                            name: "edit"
                                                        }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Stimmrecht", $d54f4a7473082e4a$var$unitListIcons.votes)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("MEA", $d54f4a7473082e4a$var$unitListIcons.mea)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("Status", $d54f4a7473082e4a$var$unitListIcons.status)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "resolutions-v2-actions-head",
                                                        "aria-label": "Aktionen",
                                                        title: "Aktionen",
                                                        children: $d54f4a7473082e4a$var$plainUnitHeader("", $d54f4a7473082e4a$var$unitListIcons.actions)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: assignmentsRows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: formatEinheitsnummer(r.einheitsnummer)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: r.eigentuemer_id
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                style: {
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    gap: 6,
                                                                    flexWrap: "wrap"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: ownerDisplayById.get(r.ownerId) ?? r.eigentuemername ?? "-"
                                                                    }),
                                                                    r.isAuthorizedOwnerRecipient ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "badge",
                                                                        children: "Zustellungsbevollm\xe4chtigt"
                                                                    }) : null
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: r.eigentuemer_email || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: Number(r.einheit_stimmrecht ?? 0) > 0 ? Number(r.einheit_stimmrecht ?? 0) : "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: Number(r.einheit_mea ?? 0) > 0 ? Number(r.einheit_mea ?? 0) : "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `badge ${r.status} quick-tooltip`,
                                                                "data-tooltip": $d54f4a7473082e4a$var$buildAssignmentValidityTooltip(r),
                                                                title: $d54f4a7473082e4a$var$buildAssignmentValidityTooltip(r),
                                                                tabIndex: 0,
                                                                children: r.status
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: !canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                style: {
                                                                    color: "var(--text-soft)"
                                                                },
                                                                children: "-"
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "resolutions-v2-action-wrap",
                                                                onClick: (e)=>e.stopPropagation(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "resolutions-v2-action-trigger",
                                                                        "aria-label": `Aktionen f\xfcr Zuordnung ${r.einheitsnummer}`,
                                                                        "aria-expanded": assignmentOpenActionMenuId === r.id,
                                                                        onMouseDown: (e)=>e.stopPropagation(),
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            if (assignmentOpenActionMenuId === r.id) {
                                                                                setAssignmentOpenActionMenuId(null);
                                                                                return;
                                                                            }
                                                                            openDetailActionMenu(r.id, e.currentTarget, setAssignmentOpenActionMenuId, 96);
                                                                        },
                                                                        children: "\u22EE"
                                                                    }),
                                                                    assignmentOpenActionMenuId === r.id && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                        style: {
                                                                            left: actionMenuPosition.left,
                                                                            top: actionMenuPosition.top
                                                                        },
                                                                        onMouseDown: (e)=>e.stopPropagation(),
                                                                        onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                        onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                disabled: objectLocked,
                                                                                onClick: ()=>{
                                                                                    setEditAssignmentOwnerSearch("");
                                                                                    setEditAssignmentForm({
                                                                                        id: r.id,
                                                                                        unitId: r.unitId,
                                                                                        ownerId: r.ownerId,
                                                                                        status: r.status
                                                                                    });
                                                                                    setAssignmentOpenActionMenuId(null);
                                                                                },
                                                                                children: "Bearbeiten"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                disabled: objectLocked,
                                                                                onClick: ()=>{
                                                                                    setDeleteConfirm({
                                                                                        id: `assignment:${r.id}`,
                                                                                        label: `${r.einheitsnummer} / ${r.eigentuemer_id}`,
                                                                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                        input: [
                                                                                            "",
                                                                                            "",
                                                                                            "",
                                                                                            ""
                                                                                        ],
                                                                                        error: ""
                                                                                    });
                                                                                    setAssignmentOpenActionMenuId(null);
                                                                                },
                                                                                children: "L\xf6schen"
                                                                            })
                                                                        ]
                                                                    }), document.body) : null
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, r.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-pagination",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolutions-v2-page-size",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: String(assignmentPageSize),
                                            onChange: (e)=>{
                                                setAssignmentPageSize(Number(e.target.value) || 10);
                                                setAssignmentPage(1);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "10",
                                                    children: "10 pro Seite"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "20",
                                                    children: "20 pro Seite"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "50",
                                                    children: "50 pro Seite"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolutions-v2-page-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "resolutions-v2-page-arrow",
                                                onClick: ()=>setAssignmentPage((prev)=>Math.max(1, prev - 1)),
                                                disabled: assignmentPage <= 1,
                                                children: "\u2039"
                                            }),
                                            assignmentPageItems.map((pageItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `resolutions-v2-page-chip ${pageItem === assignmentPage ? "active" : ""}`,
                                                    onClick: ()=>setAssignmentPage(pageItem),
                                                    children: pageItem
                                                }, pageItem)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "resolutions-v2-page-arrow",
                                                onClick: ()=>setAssignmentPage((prev)=>Math.min(assignmentTotalPages, prev + 1)),
                                                disabled: assignmentPage >= assignmentTotalPages,
                                                children: "\u203A"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "resolutions-v2-page-info",
                                                children: [
                                                    "Seite ",
                                                    assignmentPage,
                                                    " von ",
                                                    assignmentTotalPages
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolutions-v2-page-next-wrap",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            className: "resolutions-v2-next-btn",
                                            onClick: ()=>setAssignmentPage((prev)=>Math.min(assignmentTotalPages, prev + 1)),
                                            disabled: assignmentPage >= assignmentTotalPages,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Weiter"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: "\u203A"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            tab === "umlaufbeschluesse" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    !showCreateResolution && !editResolutionForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "page-header panel resolutions-v2-page-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "resolutions-v2-title",
                                style: {
                                    margin: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "resolution"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "resolutions-v2-title-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-title-main",
                                                children: "Umlaufbeschl\xfcsse"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-title-sub",
                                                children: "\xdcbersicht aller Umlaufbeschl\xfcsse dieses Objekts"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            canCreateResolutions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: "resolutions-v2-create-btn",
                                onClick: ()=>setShowCreateResolution(true),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-create-btn-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "plus"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Neuer Umlaufbeschluss"
                                    })
                                ]
                            }) : null
                        ]
                    }) : null,
                    canCreateResolutions && showCreateResolution ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form resolution-create-form resolution-create-form-v2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolution-create-v2-head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolution-create-v2-head-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "resolution"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolution-create-v2-head-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Umlaufbeschluss anlegen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Stammdaten, Dokumente und stimmberechtigte Einheiten erfassen"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolution-main-fields-box",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Objekt*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: `${summary?.object.objektnummer ?? "-"} - ${summary?.object.objektname ?? "-"}`,
                                                        disabled: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        children: [
                                                            "Beschlussnummer ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                style: {
                                                                    color: "var(--text-soft)",
                                                                    fontWeight: 400
                                                                },
                                                                children: resolutionNumberHint
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: createResolutionNumber,
                                                        disabled: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Facilioo Vorgangsnummer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "number",
                                                        min: 0,
                                                        max: 9999999999,
                                                        value: resolutionForm.facilioo_vorgangsnummer,
                                                        onChange: (e)=>setResolutionForm({
                                                                ...resolutionForm,
                                                                facilioo_vorgangsnummer: e.target.value
                                                            }),
                                                        onBlur: ()=>{
                                                            validateCreateFaciliooProcess();
                                                        }
                                                    }),
                                                    createFaciliooValidationPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: "Vorgang wird gepr\xfcft ..."
                                                    }) : null,
                                                    createFaciliooProcessTitle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: [
                                                            "Vorgangsbetreff: ",
                                                            createFaciliooProcessTitle
                                                        ]
                                                    }) : null,
                                                    createFaciliooValidationError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        className: "error-text",
                                                        children: createFaciliooValidationError
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Startdatum (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "date",
                                                        value: resolutionForm.startdatum,
                                                        onChange: (e)=>setResolutionForm({
                                                                ...resolutionForm,
                                                                startdatum: e.target.value
                                                            })
                                                    }),
                                                    resolutionDateErrors.startError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "error-text",
                                                        children: resolutionDateErrors.startError
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Enddatum (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "date",
                                                        value: resolutionForm.endedatum,
                                                        onChange: (e)=>setResolutionForm({
                                                                ...resolutionForm,
                                                                endedatum: e.target.value
                                                            })
                                                    }),
                                                    resolutionDateErrors.endError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "error-text",
                                                        children: resolutionDateErrors.endError
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Stimmrechtsart*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: resolutionForm.stimmrechtsart,
                                                        onChange: (e)=>setResolutionForm({
                                                                ...resolutionForm,
                                                                stimmrechtsart: e.target.value
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "kopf",
                                                                children: "Kopfstimmen"
                                                            }),
                                                            objectCanUseStimmrecht ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "stimmrecht",
                                                                children: "Stimmrecht"
                                                            }) : null,
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "mea",
                                                                children: "MEA"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Quorum*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: resolutionForm.quorum,
                                                        onChange: (e)=>{
                                                            const quorum = e.target.value;
                                                            setResolutionForm({
                                                                ...resolutionForm,
                                                                quorum: quorum,
                                                                ...quorum === "allstimmig" ? {
                                                                    vorbeschluss_top: "",
                                                                    vorbeschluss_wev_datum: ""
                                                                } : {}
                                                            });
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "allstimmig",
                                                                children: "Allstimmig"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "einfache_mehrheit",
                                                                children: "Einfache Mehrheit"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "qualifizierte_mehrheit",
                                                                children: "Qualifizierte Mehrheit"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Automatischen Versandprozess aktivieren"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "settings-switch-row",
                                                        style: {
                                                            marginBottom: 10
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "settings-toggle",
                                                            htmlFor: "object-resolution-create-dispatch-enabled",
                                                            "aria-label": "Automatischen Versandprozess aktivieren oder deaktivieren",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "object-resolution-create-dispatch-enabled",
                                                                    type: "checkbox",
                                                                    checked: resolutionForm.dispatch_automation_enabled,
                                                                    onChange: (e)=>setResolutionForm({
                                                                            ...resolutionForm,
                                                                            dispatch_automation_enabled: e.target.checked
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "settings-toggle-slider"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            $d54f4a7473082e4a$var$isVorbeschlussRequired(resolutionForm.quorum) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "TOP der WEV (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: resolutionForm.vorbeschluss_top,
                                                        onChange: (e)=>setResolutionForm({
                                                                ...resolutionForm,
                                                                vorbeschluss_top: e.target.value
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: "Tagesordnungspunkt des Vorbeschlusses, mit dem das abgesenkte Quorum beschlossen wurde."
                                                    })
                                                ]
                                            }) : null,
                                            $d54f4a7473082e4a$var$isVorbeschlussRequired(resolutionForm.quorum) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Datum der WEV (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "date",
                                                        value: resolutionForm.vorbeschluss_wev_datum,
                                                        onChange: (e)=>setResolutionForm({
                                                                ...resolutionForm,
                                                                vorbeschluss_wev_datum: e.target.value
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: "Datum der WEG-Versammlung des Vorbeschlusses."
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field form-field-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Ablauf Info's an Verwaltung senden"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "settings-switch-row",
                                                        style: {
                                                            marginBottom: 10
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "settings-toggle",
                                                            htmlFor: "object-resolution-create-trigger-enabled",
                                                            "aria-label": "Ablauf Infos an Verwaltung senden aktivieren oder deaktivieren",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "object-resolution-create-trigger-enabled",
                                                                    type: "checkbox",
                                                                    checked: resolutionForm.trigger_notifications_enabled,
                                                                    onChange: (e)=>setResolutionForm({
                                                                            ...resolutionForm,
                                                                            trigger_notifications_enabled: e.target.checked,
                                                                            trigger_notifications_channel: e.target.checked ? resolutionForm.trigger_notifications_channel : "facilioo"
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "settings-toggle-slider"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    resolutionForm.trigger_notifications_enabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "form-field",
                                                                style: {
                                                                    padding: 0,
                                                                    marginBottom: 10
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Versandkanal"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                        value: resolutionForm.trigger_notifications_channel,
                                                                        onChange: (e)=>setResolutionForm({
                                                                                ...resolutionForm,
                                                                                trigger_notifications_channel: e.target.value
                                                                            }),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "email",
                                                                                children: "E-Mail"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "facilioo",
                                                                                children: "Facilioo Vorgang"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    border: "1px solid var(--line)",
                                                                    borderRadius: 8,
                                                                    padding: 10
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            gap: 8,
                                                                            flexWrap: "wrap",
                                                                            marginBottom: 8
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                onClick: ()=>setResolutionForm({
                                                                                        ...resolutionForm,
                                                                                        trigger_notifications_events: $d54f4a7473082e4a$var$allTriggerNotificationEvents()
                                                                                    }),
                                                                                children: "Alles markieren"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                onClick: ()=>setResolutionForm({
                                                                                        ...resolutionForm,
                                                                                        trigger_notifications_events: $d54f4a7473082e4a$var$defaultTriggerNotificationEvents()
                                                                                    }),
                                                                                children: "Alle demarkieren"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    $d54f4a7473082e4a$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS.map((eventOption)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                            style: {
                                                                                display: "flex",
                                                                                gap: 8,
                                                                                alignItems: "center",
                                                                                marginBottom: 8
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: Boolean(resolutionForm.trigger_notifications_events[eventOption.key]),
                                                                                    onChange: (e)=>setResolutionForm({
                                                                                            ...resolutionForm,
                                                                                            trigger_notifications_events: {
                                                                                                ...resolutionForm.trigger_notifications_events,
                                                                                                [eventOption.key]: e.target.checked
                                                                                            }
                                                                                        })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: eventOption.label
                                                                                })
                                                                            ]
                                                                        }, eventOption.key))
                                                                ]
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field form-field-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Titel*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: resolutionForm.titel,
                                                        onChange: (e)=>setResolutionForm({
                                                                ...resolutionForm,
                                                                titel: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field form-field-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Beschlusstext*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                        rows: 8,
                                                        value: resolutionForm.beschlusstext,
                                                        onChange: (e)=>setResolutionForm({
                                                                ...resolutionForm,
                                                                beschlusstext: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            !resolutionVorbeschlussPairValid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "form-field form-field-wide",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "error-text",
                                                    children: "TOP und Datum der WEV m\xfcssen gemeinsam bef\xfcllt werden."
                                                })
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field form-field-wide resolution-upload-box",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Dokumente (optional)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: `resolution-document-dropzone${createResolutionDocumentsDropActive ? " is-drag-over" : ""}`,
                                                onDragOver: (e)=>{
                                                    e.preventDefault();
                                                    e.dataTransfer.dropEffect = "copy";
                                                    setCreateResolutionDocumentsDropActive(true);
                                                },
                                                onDragLeave: (e)=>{
                                                    e.preventDefault();
                                                    setCreateResolutionDocumentsDropActive(false);
                                                },
                                                onDrop: onCreateResolutionDocumentsDrop,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        ref: createResolutionDocumentsInputRef,
                                                        type: "file",
                                                        multiple: true,
                                                        accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png",
                                                        style: {
                                                            display: "none"
                                                        },
                                                        onChange: (e)=>mergeCreateResolutionDocuments(Array.from(e.target.files ?? []), true)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "resolution-document-dropzone-text",
                                                        children: "Dateien hier hineinziehen oder \xfcber den Button ausw\xe4hlen."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 10,
                                                    flexWrap: "wrap",
                                                    alignItems: "center",
                                                    marginTop: 10
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>createResolutionDocumentsInputRef.current?.click(),
                                                        children: "Dateien ausw\xe4hlen"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setCreateResolutionDocuments([]),
                                                        disabled: !createResolutionDocuments.length,
                                                        children: "Auswahl leeren"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            color: "var(--text-soft)",
                                                            fontSize: 12
                                                        },
                                                        children: createResolutionDocuments.length ? `${createResolutionDocuments.length} Datei(en) in der Liste` : "Keine Dateien ausgew\xe4hlt"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                style: {
                                                    color: "var(--text-soft)"
                                                },
                                                children: "Erlaubte Formate: PDF, DOC, DOCX, XLS, XLSX, JPG, JPEG, PNG. Maximal 20 Dateien pro Upload, maximal 20 MB je Datei."
                                            })
                                        ]
                                    }),
                                    renderUnitSelector(unitSelectionRows, resolutionForm.stimmberechtigte_einheiten, resolutionOwnerSearch, setResolutionOwnerSearch, resolutionUnitTypeFilter, setResolutionUnitTypeFilter, resolutionEntranceFilter, setResolutionEntranceFilter, (unitId, checked)=>setResolutionForm((prev)=>({
                                                ...prev,
                                                stimmberechtigte_einheiten: checked ? Array.from(new Set([
                                                    ...prev.stimmberechtigte_einheiten,
                                                    unitId
                                                ])) : prev.stimmberechtigte_einheiten.filter((v)=>v !== unitId)
                                            })), ()=>setResolutionForm((prev)=>({
                                                ...prev,
                                                stimmberechtigte_einheiten: unitSelectionRows.map((u)=>u.unitId)
                                            })), ()=>setResolutionForm((prev)=>({
                                                ...prev,
                                                stimmberechtigte_einheiten: []
                                            })), ()=>{
                                        const filteredIds = getFilteredResolutionUnitIds(unitSelectionRows, resolutionOwnerSearch, resolutionUnitTypeFilter, resolutionEntranceFilter);
                                        setResolutionForm((prev)=>({
                                                ...prev,
                                                stimmberechtigte_einheiten: Array.from(new Set([
                                                    ...prev.stimmberechtigte_einheiten,
                                                    ...filteredIds
                                                ]))
                                            }));
                                    }, ()=>{
                                        const filteredIds = getFilteredResolutionUnitIds(unitSelectionRows, resolutionOwnerSearch, resolutionUnitTypeFilter, resolutionEntranceFilter);
                                        setResolutionForm((prev)=>({
                                                ...prev,
                                                stimmberechtigte_einheiten: prev.stimmberechtigte_einheiten.filter((x)=>!filteredIds.includes(x))
                                            }));
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions resolution-create-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "resolution-primary-btn",
                                        disabled: !resolutionCanCreate || createResolutionMutation.isPending,
                                        onClick: ()=>createResolutionMutation.mutate(),
                                        children: createResolutionMutation.isPending ? "Speichere..." : "Umlaufbeschluss speichern"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "resolution-secondary-btn",
                                        onClick: ()=>{
                                            setResolutionForm({
                                                objectId: id,
                                                beschlussnummer: "",
                                                titel: "",
                                                startdatum: "",
                                                endedatum: "",
                                                stimmrechtsart: $d54f4a7473082e4a$var$resolveDefaultStimmrechtsart(objectStandardStimmrechtsart, objectHasStimmrechte),
                                                quorum: "allstimmig",
                                                vorbeschluss_top: "",
                                                vorbeschluss_wev_datum: "",
                                                beschlusstext: "",
                                                facilioo_vorgangsnummer: "",
                                                dispatch_automation_enabled: false,
                                                trigger_notifications_enabled: false,
                                                trigger_notifications_channel: "facilioo",
                                                trigger_notifications_events: $d54f4a7473082e4a$var$defaultTriggerNotificationEvents(),
                                                stimmberechtigte_einheiten: unitSelectionRows.map((u)=>u.unitId)
                                            });
                                            setResolutionOwnerSearch("");
                                            setResolutionUnitTypeFilter("");
                                            setResolutionEntranceFilter("");
                                            setCreateResolutionDocuments([]);
                                            setCreateFaciliooValidationError("");
                                            setCreateFaciliooProcessTitle("");
                                            setFormError("");
                                            setShowCreateResolution(false);
                                        },
                                        children: "Abbrechen"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    !showCreateResolution && canManageMasterDataActions && editResolutionForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form resolution-create-form resolution-create-form-v2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolution-create-v2-head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolution-create-v2-head-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d54f4a7473082e4a$var$ObjectDetailIcon, {
                                            name: "resolution"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolution-create-v2-head-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Umlaufbeschluss bearbeiten"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Stammdaten, Dokumente und stimmberechtigte Einheiten bearbeiten"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolution-main-fields-box",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Objekt*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: `${summary?.object.objektnummer ?? "-"} - ${summary?.object.objektname ?? "-"}`,
                                                        disabled: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        children: [
                                                            "Beschlussnummer ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                style: {
                                                                    color: "var(--text-soft)",
                                                                    fontWeight: 400
                                                                },
                                                                children: resolutionNumberHint
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: editResolutionForm.beschlussnummer,
                                                        disabled: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Facilioo Vorgangsnummer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "number",
                                                        min: 0,
                                                        max: 9999999999,
                                                        value: editResolutionForm.facilioo_vorgangsnummer,
                                                        onChange: (e)=>setEditResolutionForm({
                                                                ...editResolutionForm,
                                                                facilioo_vorgangsnummer: e.target.value
                                                            }),
                                                        onBlur: ()=>{
                                                            validateEditFaciliooProcess();
                                                        }
                                                    }),
                                                    editFaciliooValidationPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: "Vorgang wird gepr\xfcft ..."
                                                    }) : null,
                                                    editFaciliooProcessTitle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: [
                                                            "Vorgangsbetreff: ",
                                                            editFaciliooProcessTitle
                                                        ]
                                                    }) : null,
                                                    editFaciliooValidationError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        className: "error-text",
                                                        children: editFaciliooValidationError
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Startdatum"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "date",
                                                        value: editResolutionForm.startdatum,
                                                        onChange: (e)=>setEditResolutionForm({
                                                                ...editResolutionForm,
                                                                startdatum: e.target.value
                                                            })
                                                    }),
                                                    editResolutionDateErrors.startError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "error-text",
                                                        children: editResolutionDateErrors.startError
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Enddatum"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "date",
                                                        value: editResolutionForm.endedatum,
                                                        onChange: (e)=>setEditResolutionForm({
                                                                ...editResolutionForm,
                                                                endedatum: e.target.value
                                                            })
                                                    }),
                                                    editResolutionDateErrors.endError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "error-text",
                                                        children: editResolutionDateErrors.endError
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Stimmrechtsart*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: editResolutionForm.stimmrechtsart,
                                                        onChange: (e)=>setEditResolutionForm({
                                                                ...editResolutionForm,
                                                                stimmrechtsart: e.target.value
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "kopf",
                                                                children: "Kopfstimmen"
                                                            }),
                                                            objectCanUseStimmrecht ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "stimmrecht",
                                                                children: "Stimmrecht"
                                                            }) : null,
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "mea",
                                                                children: "MEA"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Quorum*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: editResolutionForm.quorum,
                                                        onChange: (e)=>{
                                                            const quorum = e.target.value;
                                                            setEditResolutionForm({
                                                                ...editResolutionForm,
                                                                quorum: quorum,
                                                                ...quorum === "allstimmig" ? {
                                                                    vorbeschluss_top: "",
                                                                    vorbeschluss_wev_datum: ""
                                                                } : {}
                                                            });
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "allstimmig",
                                                                children: "Allstimmig"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "einfache_mehrheit",
                                                                children: "Einfache Mehrheit"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "qualifizierte_mehrheit",
                                                                children: "Qualifizierte Mehrheit"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Automatischen Versandprozess aktivieren"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "settings-switch-row",
                                                        style: {
                                                            marginBottom: 10
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "settings-toggle",
                                                            htmlFor: "object-resolution-edit-dispatch-enabled",
                                                            "aria-label": "Automatischen Versandprozess aktivieren oder deaktivieren",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "object-resolution-edit-dispatch-enabled",
                                                                    type: "checkbox",
                                                                    checked: editResolutionForm.dispatch_automation_enabled,
                                                                    onChange: (e)=>setEditResolutionForm({
                                                                            ...editResolutionForm,
                                                                            dispatch_automation_enabled: e.target.checked
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "settings-toggle-slider"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            $d54f4a7473082e4a$var$isVorbeschlussRequired(editResolutionForm.quorum) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "TOP der WEV (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: editResolutionForm.vorbeschluss_top,
                                                        onChange: (e)=>setEditResolutionForm({
                                                                ...editResolutionForm,
                                                                vorbeschluss_top: e.target.value
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: "Tagesordnungspunkt des Vorbeschlusses, mit dem das abgesenkte Quorum beschlossen wurde."
                                                    })
                                                ]
                                            }) : null,
                                            $d54f4a7473082e4a$var$isVorbeschlussRequired(editResolutionForm.quorum) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Datum der WEV (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "date",
                                                        value: editResolutionForm.vorbeschluss_wev_datum,
                                                        onChange: (e)=>setEditResolutionForm({
                                                                ...editResolutionForm,
                                                                vorbeschluss_wev_datum: e.target.value
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: "Datum der WEG-Versammlung des Vorbeschlusses."
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field form-field-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Ablauf Info's an Verwaltung senden"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "settings-switch-row",
                                                        style: {
                                                            marginBottom: 10
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "settings-toggle",
                                                            htmlFor: "object-resolution-edit-trigger-enabled",
                                                            "aria-label": "Ablauf Infos an Verwaltung senden aktivieren oder deaktivieren",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "object-resolution-edit-trigger-enabled",
                                                                    type: "checkbox",
                                                                    checked: editResolutionForm.trigger_notifications_enabled,
                                                                    onChange: (e)=>setEditResolutionForm({
                                                                            ...editResolutionForm,
                                                                            trigger_notifications_enabled: e.target.checked,
                                                                            trigger_notifications_channel: e.target.checked ? editResolutionForm.trigger_notifications_channel : "facilioo"
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "settings-toggle-slider"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    editResolutionForm.trigger_notifications_enabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "form-field",
                                                                style: {
                                                                    padding: 0,
                                                                    marginBottom: 10
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Versandkanal"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                        value: editResolutionForm.trigger_notifications_channel,
                                                                        onChange: (e)=>setEditResolutionForm({
                                                                                ...editResolutionForm,
                                                                                trigger_notifications_channel: e.target.value
                                                                            }),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "email",
                                                                                children: "E-Mail"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "facilioo",
                                                                                children: "Facilioo Vorgang"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "resolution-trigger-events-box",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "resolution-trigger-events-actions",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                onClick: ()=>setEditResolutionForm({
                                                                                        ...editResolutionForm,
                                                                                        trigger_notifications_events: $d54f4a7473082e4a$var$allTriggerNotificationEvents()
                                                                                    }),
                                                                                children: "Alles markieren"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                onClick: ()=>setEditResolutionForm({
                                                                                        ...editResolutionForm,
                                                                                        trigger_notifications_events: $d54f4a7473082e4a$var$defaultTriggerNotificationEvents()
                                                                                    }),
                                                                                children: "Alle demarkieren"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "resolution-trigger-events-grid",
                                                                        children: $d54f4a7473082e4a$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS.map((eventOption)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                                className: "resolution-trigger-event-option",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                        type: "checkbox",
                                                                                        checked: Boolean(editResolutionForm.trigger_notifications_events[eventOption.key]),
                                                                                        onChange: (e)=>setEditResolutionForm({
                                                                                                ...editResolutionForm,
                                                                                                trigger_notifications_events: {
                                                                                                    ...editResolutionForm.trigger_notifications_events,
                                                                                                    [eventOption.key]: e.target.checked
                                                                                                }
                                                                                            })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        children: eventOption.label
                                                                                    })
                                                                                ]
                                                                            }, eventOption.key))
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field form-field-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Titel*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: editResolutionForm.titel,
                                                        onChange: (e)=>setEditResolutionForm({
                                                                ...editResolutionForm,
                                                                titel: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field form-field-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Beschlusstext*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                        rows: 8,
                                                        value: editResolutionForm.beschlusstext,
                                                        onChange: (e)=>setEditResolutionForm({
                                                                ...editResolutionForm,
                                                                beschlusstext: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            !editResolutionVorbeschlussPairValid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "form-field form-field-wide",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "error-text",
                                                    children: "TOP und Datum der WEV m\xfcssen gemeinsam bef\xfcllt werden."
                                                })
                                            }) : null
                                        ]
                                    }),
                                    renderUnitSelector(unitSelectionRows, editResolutionForm.stimmberechtigte_einheiten, editResolutionOwnerSearch, setEditResolutionOwnerSearch, editResolutionUnitTypeFilter, setEditResolutionUnitTypeFilter, editResolutionEntranceFilter, setEditResolutionEntranceFilter, (unitId, checked)=>setEditResolutionForm({
                                            ...editResolutionForm,
                                            stimmberechtigte_einheiten: checked ? Array.from(new Set([
                                                ...editResolutionForm.stimmberechtigte_einheiten,
                                                unitId
                                            ])) : editResolutionForm.stimmberechtigte_einheiten.filter((v)=>v !== unitId)
                                        }), ()=>setEditResolutionForm({
                                            ...editResolutionForm,
                                            stimmberechtigte_einheiten: unitSelectionRows.map((u)=>u.unitId)
                                        }), ()=>setEditResolutionForm({
                                            ...editResolutionForm,
                                            stimmberechtigte_einheiten: []
                                        }), ()=>{
                                        const filteredIds = getFilteredResolutionUnitIds(unitSelectionRows, editResolutionOwnerSearch, editResolutionUnitTypeFilter, editResolutionEntranceFilter);
                                        setEditResolutionForm({
                                            ...editResolutionForm,
                                            stimmberechtigte_einheiten: Array.from(new Set([
                                                ...editResolutionForm.stimmberechtigte_einheiten,
                                                ...filteredIds
                                            ]))
                                        });
                                    }, ()=>{
                                        const filteredIds = getFilteredResolutionUnitIds(unitSelectionRows, editResolutionOwnerSearch, editResolutionUnitTypeFilter, editResolutionEntranceFilter);
                                        setEditResolutionForm({
                                            ...editResolutionForm,
                                            stimmberechtigte_einheiten: editResolutionForm.stimmberechtigte_einheiten.filter((x)=>!filteredIds.includes(x))
                                        });
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions resolution-create-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "resolution-primary-btn",
                                        disabled: !resolutionCanEdit || updateResolutionMutation.isPending,
                                        onClick: ()=>updateResolutionMutation.mutate(),
                                        children: updateResolutionMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "resolution-secondary-btn",
                                        onClick: ()=>{
                                            setEditResolutionForm(null);
                                            setEditResolutionOwnerSearch("");
                                            setEditResolutionUnitTypeFilter("");
                                            setEditResolutionEntranceFilter("");
                                            setEditFaciliooValidationError("");
                                            setEditFaciliooProcessTitle("");
                                        },
                                        children: "Abbrechen"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    !showCreateResolution ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "panel resolutions-v2-list-panel object-detail-units-list-panel",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolutions-v2-filterbar",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "resolutions-v2-filter-fields",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "resolutions-v2-filter-input",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-filter-icon",
                                                            "aria-hidden": "true",
                                                            children: $d54f4a7473082e4a$var$unitListIcons.search
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            placeholder: "Suche...",
                                                            value: resolutionSearch,
                                                            onChange: (e)=>setResolutionSearch(e.target.value)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: resolutionStatusFilter,
                                                    onChange: (e)=>setResolutionStatusFilter(e.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "",
                                                            children: "Alle Status"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "entwurf",
                                                            children: "Entwurf"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "aktiv",
                                                            children: "L\xe4uft"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "abgeschlossen",
                                                            children: "Beendet"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: resolutionResultFilter,
                                                    onChange: (e)=>setResolutionResultFilter(e.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "",
                                                            children: "Alle Ergebnisse"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "angenommen",
                                                            children: "Angenommen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "abgelehnt",
                                                            children: "Abgelehnt"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "offen",
                                                            children: "Offen"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            className: "resolutions-v2-reset-btn",
                                            onClick: ()=>{
                                                setResolutionSearch("");
                                                setResolutionStatusFilter("");
                                                setResolutionResultFilter("");
                                                setResolutionSortBy("beschlussnummer");
                                                setResolutionSortDir("asc");
                                                setResolutionPage(1);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "resolutions-v2-reset-btn-icon",
                                                    "aria-hidden": "true",
                                                    children: $d54f4a7473082e4a$var$unitListIcons.reset
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Filter zur\xfccksetzen"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolutions-v2-row-count",
                                    children: [
                                        "Zeilen: ",
                                        resolutionsRows.length,
                                        " / Gesamt: ",
                                        resolutionTotalRows
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "resolutions-v2-table-wrap",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: "resolutions-v2-table object-detail-resolutions-v2-table",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                        className: "resolutions-v2-col-id"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                        className: "resolutions-v2-col-title"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                        className: "resolutions-v2-col-status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                        className: "resolutions-v2-col-runtime"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                        className: "resolutions-v2-col-remaining"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                        className: "resolutions-v2-col-response"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                        className: "resolutions-v2-col-result"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                        className: "resolutions-v2-col-actions"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                type: "button",
                                                                className: "resolutions-v2-th-sort",
                                                                onClick: ()=>{
                                                                    setResolutionSortBy("beschlussnummer");
                                                                    setResolutionSortDir((prev)=>resolutionSortBy === "beschlussnummer" && prev === "asc" ? "desc" : "asc");
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M5.2 3.8h6.5l2.9 2.9v8.6a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 15.3V5a1.2 1.2 0 0 1 1.2-1.2Z",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinejoin: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M11.7 3.9v2.8h2.8M6.7 9.2h5.9M6.7 12h5.9",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinecap: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-label",
                                                                        children: "Beschluss-ID"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                type: "button",
                                                                className: "resolutions-v2-th-sort",
                                                                onClick: ()=>{
                                                                    setResolutionSortBy("titel");
                                                                    setResolutionSortDir((prev)=>resolutionSortBy === "titel" && prev === "asc" ? "desc" : "asc");
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M5.2 3.8h6.5l2.9 2.9v8.6a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 15.3V5a1.2 1.2 0 0 1 1.2-1.2Z",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinejoin: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M6.8 9.4h6.1M6.8 12.2h5",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinecap: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-label",
                                                                        children: "Titel"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                type: "button",
                                                                className: "resolutions-v2-th-sort",
                                                                onClick: ()=>{
                                                                    setResolutionSortBy("status");
                                                                    setResolutionSortDir((prev)=>resolutionSortBy === "status" && prev === "asc" ? "desc" : "asc");
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                    cx: "10",
                                                                                    cy: "10",
                                                                                    r: "5.9",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                                                                                    fill: "currentColor"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-label",
                                                                        children: "Status"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "resolutions-v2-th-plain",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                    x: "4.3",
                                                                                    y: "5.6",
                                                                                    width: "11.4",
                                                                                    height: "10",
                                                                                    rx: "1.5",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M6.8 3.8v2.4M13.2 3.8v2.4M4.3 8.8h11.4",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinecap: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-label",
                                                                        children: "Laufzeit"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "resolutions-v2-th-plain",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                    cx: "10",
                                                                                    cy: "11",
                                                                                    r: "5.8",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M10 11V7.8M10 11l2.5 1.8M8 3.8h4M9 3.8v1.8M11 3.8v1.8",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-label",
                                                                        children: "Restlaufzeit"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                type: "button",
                                                                className: "resolutions-v2-th-sort",
                                                                onClick: ()=>{
                                                                    setResolutionSortBy("ruecklaufquote");
                                                                    setResolutionSortDir((prev)=>resolutionSortBy === "ruecklaufquote" && prev === "asc" ? "desc" : "asc");
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M15.2 7.2a5.8 5.8 0 1 0 .4 6.8",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinecap: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "m14 4.7 2.3 2.5-2.5 2.3",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-label",
                                                                        children: "R\xfccklaufquote"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "resolutions-v2-th-plain",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M6.2 4.8h7.6v1.3a3.8 3.8 0 0 1-7.6 0V4.8Z",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinejoin: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M8.2 10.2h3.6M10 10.2v2.6M7.6 15h4.8",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinecap: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M6.2 5.6H4.6A1.8 1.8 0 0 0 2.8 7.4v.2a2.6 2.6 0 0 0 2.6 2.6h.5M13.8 5.6h1.6a1.8 1.8 0 0 1 1.8 1.8v.2a2.6 2.6 0 0 1-2.6 2.6h-.5",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.7",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-th-label",
                                                                        children: "Ergebnis"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "resolutions-v2-actions-head",
                                                            "aria-label": "Aktionen",
                                                            title: "Aktionen",
                                                            children: $d54f4a7473082e4a$var$plainUnitHeader("", $d54f4a7473082e4a$var$unitListIcons.actions)
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                children: resolutionsRows.map((r)=>{
                                                    const isActive = r.status === "aktiv";
                                                    const canEdit = r.status === "entwurf";
                                                    const hasVotes = (r.abgegebene_stimmen ?? 0) > 0;
                                                    const outcome = $d54f4a7473082e4a$var$getResolutionOutcome(r);
                                                    const remainingDays = $d54f4a7473082e4a$var$getRemainingDays(r.endedatum);
                                                    const totalRecipients = Number(r.anzahl_empfaenger_gesamt ?? 0);
                                                    const submittedVotes = Number(r.abgegebene_stimmen ?? 0);
                                                    const responseRate = totalRecipients > 0 ? Math.max(0, Math.min(100, submittedVotes / totalRecipients * 100)) : Math.max(0, Math.min(100, Number(r.ruecklaufquote ?? 0)));
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                    className: "badge resolution-number",
                                                                    to: `/resolutions/${r.id}`,
                                                                    title: r.beschlussnummer,
                                                                    children: r.beschlussnummer
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "resolutions-v2-title-cell",
                                                                children: r.titel
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: `badge ${r.status}`,
                                                                    children: $d54f4a7473082e4a$var$formatResolutionStatus(r.status)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "resolutions-v2-date-range",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "resolutions-v2-date-item",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "resolutions-v2-date-item-icon",
                                                                                    "aria-hidden": "true",
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                                        viewBox: "0 0 16 16",
                                                                                        fill: "none",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                                d: "M3.4 3.6h9.2v8.8H3.4z",
                                                                                                stroke: "currentColor",
                                                                                                strokeWidth: "1.4"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                                d: "M5.2 2.5v2.1M10.8 2.5v2.1M3.4 6h9.2",
                                                                                                stroke: "currentColor",
                                                                                                strokeWidth: "1.4",
                                                                                                strokeLinecap: "round"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: $d54f4a7473082e4a$var$formatDateDE(r.startdatum)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "resolutions-v2-date-item",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "resolutions-v2-date-item-icon",
                                                                                    "aria-hidden": "true",
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                                        viewBox: "0 0 16 16",
                                                                                        fill: "none",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                                d: "M3.4 3.6h9.2v8.8H3.4z",
                                                                                                stroke: "currentColor",
                                                                                                strokeWidth: "1.4"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                                d: "M5.2 2.5v2.1M10.8 2.5v2.1M3.4 6h9.2",
                                                                                                stroke: "currentColor",
                                                                                                strokeWidth: "1.4",
                                                                                                strokeLinecap: "round"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                                d: "m5.6 9 1.4 1.4 3-3",
                                                                                                stroke: "currentColor",
                                                                                                strokeWidth: "1.4",
                                                                                                strokeLinecap: "round",
                                                                                                strokeLinejoin: "round"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: $d54f4a7473082e4a$var$formatDateDE(r.endedatum)
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: remainingDays === null ? "-" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "resolutions-v2-remaining-bullet",
                                                                    title: `${remainingDays} Tage`,
                                                                    children: remainingDays
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "resolutions-v2-progress-wrap",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            children: [
                                                                                responseRate.toFixed(2),
                                                                                " %"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "resolutions-v2-progress-track",
                                                                            "aria-hidden": "true",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "resolutions-v2-progress-fill",
                                                                                style: {
                                                                                    width: `${responseRate}%`
                                                                                }
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: outcome.tone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: `badge ergebnis-${outcome.tone === "success" ? "angenommen" : "abgelehnt"}`,
                                                                    children: outcome.label
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "badge ergebnis-neutral",
                                                                    children: outcome.label
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: !canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    style: {
                                                                        color: "var(--text-soft)"
                                                                    },
                                                                    children: "-"
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "resolutions-v2-action-wrap",
                                                                    onClick: (e)=>e.stopPropagation(),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            className: "resolutions-v2-action-trigger",
                                                                            "aria-label": `Aktionen f\xfcr Beschluss ${r.beschlussnummer}`,
                                                                            "aria-expanded": resolutionOpenActionMenuId === r.id,
                                                                            onMouseDown: (e)=>e.stopPropagation(),
                                                                            onClick: (e)=>{
                                                                                e.stopPropagation();
                                                                                if (resolutionOpenActionMenuId === r.id) {
                                                                                    setResolutionOpenActionMenuId(null);
                                                                                    return;
                                                                                }
                                                                                openDetailActionMenu(r.id, e.currentTarget, setResolutionOpenActionMenuId, 188);
                                                                            },
                                                                            children: "\u22EE"
                                                                        }),
                                                                        resolutionOpenActionMenuId === r.id && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                            style: {
                                                                                left: actionMenuPosition.left,
                                                                                top: actionMenuPosition.top
                                                                            },
                                                                            onMouseDown: (e)=>e.stopPropagation(),
                                                                            onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                            onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                    type: "button",
                                                                                    disabled: !canEdit,
                                                                                    onClick: ()=>{
                                                                                        if (!canEdit) {
                                                                                            setActionError("Nur Entw\xfcrfe k\xf6nnen bearbeitet werden. Laufende oder beendete Beschl\xfcsse sind gesperrt.");
                                                                                            return;
                                                                                        }
                                                                                        setEditFaciliooValidationError("");
                                                                                        setEditFaciliooProcessTitle("");
                                                                                        setEditResolutionForm({
                                                                                            id: r.id,
                                                                                            objectId: r.objectId,
                                                                                            beschlussnummer: r.beschlussnummer,
                                                                                            titel: r.titel,
                                                                                            startdatum: r.startdatum ?? "",
                                                                                            endedatum: r.endedatum ?? "",
                                                                                            stimmrechtsart: r.stimmrechtsart,
                                                                                            quorum: r.quorum,
                                                                                            vorbeschluss_top: r.vorbeschluss_top ?? "",
                                                                                            vorbeschluss_wev_datum: r.vorbeschluss_wev_datum ?? "",
                                                                                            beschlusstext: r.beschlusstext,
                                                                                            facilioo_vorgangsnummer: r.facilioo_vorgangsnummer ? String(r.facilioo_vorgangsnummer) : "",
                                                                                            dispatch_automation_enabled: r.dispatch_automation_enabled ?? false,
                                                                                            trigger_notifications_enabled: r.trigger_notifications_enabled ?? false,
                                                                                            trigger_notifications_channel: r.trigger_notifications_channel ?? "facilioo",
                                                                                            trigger_notifications_events: $d54f4a7473082e4a$var$normalizeTriggerNotificationEvents(r.trigger_notifications_events),
                                                                                            stimmberechtigte_einheiten: r.stimmberechtigte_einheiten ?? []
                                                                                        });
                                                                                        setResolutionOpenActionMenuId(null);
                                                                                    },
                                                                                    children: "Bearbeiten"
                                                                                }),
                                                                                r.status === "entwurf" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                    type: "button",
                                                                                    onClick: ()=>{
                                                                                        startResolutionMutation.mutate(r.id);
                                                                                        setResolutionOpenActionMenuId(null);
                                                                                    },
                                                                                    disabled: startResolutionMutation.isPending,
                                                                                    children: "Starten"
                                                                                }) : null,
                                                                                r.status === "aktiv" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                    type: "button",
                                                                                    onClick: ()=>{
                                                                                        setStopConfirm({
                                                                                            id: r.id,
                                                                                            label: r.beschlussnummer,
                                                                                            code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                            input: [
                                                                                                "",
                                                                                                "",
                                                                                                "",
                                                                                                ""
                                                                                            ],
                                                                                            error: ""
                                                                                        });
                                                                                        setResolutionOpenActionMenuId(null);
                                                                                    },
                                                                                    disabled: stopResolutionMutation.isPending,
                                                                                    children: "Stoppen"
                                                                                }) : null,
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                    type: "button",
                                                                                    disabled: isActive || hasVotes,
                                                                                    onClick: ()=>{
                                                                                        if (isActive) {
                                                                                            setActionError("Aktive Beschl\xfcsse k\xf6nnen nicht gel\xf6scht werden.");
                                                                                            return;
                                                                                        }
                                                                                        if (hasVotes) {
                                                                                            setActionError("Beschl\xfcsse mit Stimmabgaben k\xf6nnen nicht gel\xf6scht werden.");
                                                                                            return;
                                                                                        }
                                                                                        setDeleteConfirm({
                                                                                            id: `resolution:${r.id}`,
                                                                                            label: r.beschlussnummer,
                                                                                            code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                            input: [
                                                                                                "",
                                                                                                "",
                                                                                                "",
                                                                                                ""
                                                                                            ],
                                                                                            error: ""
                                                                                        });
                                                                                        setResolutionOpenActionMenuId(null);
                                                                                    },
                                                                                    children: "L\xf6schen"
                                                                                })
                                                                            ]
                                                                        }), document.body) : null
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, r.id);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolutions-v2-pagination",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "resolutions-v2-page-size",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: String(resolutionPageSize),
                                                onChange: (e)=>{
                                                    setResolutionPageSize(Number(e.target.value) || 10);
                                                    setResolutionPage(1);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "10",
                                                        children: "10 pro Seite"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "20",
                                                        children: "20 pro Seite"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "50",
                                                        children: "50 pro Seite"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "resolutions-v2-page-center",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "resolutions-v2-page-arrow",
                                                    onClick: ()=>setResolutionPage((prev)=>Math.max(1, prev - 1)),
                                                    disabled: resolutionPage <= 1,
                                                    children: "\u2039"
                                                }),
                                                resolutionPageItems.map((pageItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        className: `resolutions-v2-page-chip ${pageItem === resolutionPage ? "active" : ""}`,
                                                        onClick: ()=>setResolutionPage(pageItem),
                                                        children: pageItem
                                                    }, pageItem)),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "resolutions-v2-page-arrow",
                                                    onClick: ()=>setResolutionPage((prev)=>Math.min(resolutionTotalPages, prev + 1)),
                                                    disabled: resolutionPage >= resolutionTotalPages,
                                                    children: "\u203A"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "resolutions-v2-page-info",
                                                    children: [
                                                        "Seite ",
                                                        resolutionPage,
                                                        " von ",
                                                        resolutionTotalPages
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "resolutions-v2-page-next-wrap",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                className: "resolutions-v2-next-btn",
                                                onClick: ()=>setResolutionPage((prev)=>Math.min(resolutionTotalPages, prev + 1)),
                                                disabled: resolutionPage >= resolutionTotalPages,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Weiter"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        "aria-hidden": "true",
                                                        children: "\u203A"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : null
                ]
            }) : null,
            tab === "importe" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                columns: [
                    {
                        key: "import_typ",
                        label: "Importtyp"
                    },
                    {
                        key: "filename",
                        label: "Datei"
                    },
                    {
                        key: "status",
                        label: "Status"
                    },
                    {
                        key: "total_rows",
                        label: "Gesamtzeilen"
                    },
                    {
                        key: "valid_rows",
                        label: "Valide Zeilen"
                    },
                    {
                        key: "invalid_rows",
                        label: "Fehlerzeilen"
                    },
                    {
                        key: "createdAt",
                        label: "Zeitpunkt"
                    }
                ],
                rows: importsData?.data ?? [],
                total: importsData?.meta.total ?? 0,
                page: importPage,
                pageSize: 25,
                onPageChange: setImportPage
            }) : null,
            tab === "protokoll" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                columns: [
                    {
                        key: "createdAt",
                        label: "Zeitpunkt"
                    },
                    {
                        key: "actor_name",
                        label: "Benutzer"
                    },
                    {
                        key: "action",
                        label: "Aktion"
                    },
                    {
                        key: "entity_type",
                        label: "Datensatztyp"
                    },
                    {
                        key: "entity_id",
                        label: "Datensatz-ID"
                    },
                    {
                        key: "object_ref",
                        label: "Objektbezug"
                    }
                ],
                rows: auditData?.data ?? [],
                total: auditData?.meta.total ?? 0,
                page: auditPage,
                pageSize: 25,
                onPageChange: setAuditPage
            }) : null,
            formError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel error-text",
                children: formError
            }) : null,
            actionError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel error-text",
                children: actionError
            }) : null,
            summaryError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel error-text",
                children: "Objektdetailseite konnte nicht geladen werden."
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                open: !!deleteConfirm,
                message: deleteConfirm ? `${deleteConfirm.label} soll gel\xf6scht werden.` : "",
                code: deleteConfirm?.code ?? "",
                input: deleteConfirm?.input ?? [
                    "",
                    "",
                    "",
                    ""
                ],
                error: deleteConfirm?.error,
                isPending: false,
                onClose: ()=>setDeleteConfirm(null),
                onInputChange: (next)=>{
                    if (!deleteConfirm) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        input: next
                    });
                },
                onErrorReset: ()=>{
                    if (!deleteConfirm || !deleteConfirm.error) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        error: ""
                    });
                },
                onConfirm: ()=>{
                    if (!deleteConfirm) return;
                    if (deleteConfirm.input.join("") !== deleteConfirm.code) {
                        setDeleteConfirm({
                            ...deleteConfirm,
                            error: "Sicherheitscode falsch eingegeben."
                        });
                        return;
                    }
                    resolveDelete();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                open: !!stopConfirm,
                title: "Beschluss stoppen",
                message: stopConfirm ? `Beschluss ${stopConfirm.label} soll manuell gestoppt werden.` : "",
                code: stopConfirm?.code ?? "",
                input: stopConfirm?.input ?? [
                    "",
                    "",
                    "",
                    ""
                ],
                error: stopConfirm?.error,
                isPending: stopResolutionMutation.isPending,
                onClose: ()=>setStopConfirm(null),
                onInputChange: (next)=>{
                    if (!stopConfirm) return;
                    setStopConfirm({
                        ...stopConfirm,
                        input: next
                    });
                },
                onErrorReset: ()=>{
                    if (!stopConfirm || !stopConfirm.error) return;
                    setStopConfirm({
                        ...stopConfirm,
                        error: ""
                    });
                },
                confirmLabel: "Stoppen best\xe4tigen",
                pendingLabel: "Stoppe...",
                onConfirm: ()=>{
                    if (!stopConfirm) return;
                    if (stopConfirm.input.join("") !== stopConfirm.code) {
                        setStopConfirm({
                            ...stopConfirm,
                            error: "Sicherheitscode falsch eingegeben."
                        });
                        return;
                    }
                    stopResolutionMutation.mutate(stopConfirm.id);
                }
            })
        ]
    });
};
const $d54f4a7473082e4a$var$getRemainingDays = (endDate)=>{
    if (!endDate) return null;
    const match = endDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    const [, yearRaw, monthRaw, dayRaw] = match;
    const end = new Date(Number(yearRaw), Number(monthRaw) - 1, Number(dayRaw));
    if (Number.isNaN(end.getTime())) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const millisecondsPerDay = 86400000;
    const diffDays = Math.floor((end.getTime() - today.getTime()) / millisecondsPerDay) + 1;
    return Math.max(0, diffDays);
};





var $acw62 = parcelRequire("acw62");







const $811a329b29e8a5d6$var$formatNumberDE = (value)=>{
    const numeric = Number(value ?? 0);
    return Number.isFinite(numeric) && numeric > 0 ? new Intl.NumberFormat("de-DE").format(numeric) : "-";
};
const $811a329b29e8a5d6$var$unitBuildingIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    children: [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
            x: "5.1",
            y: "4.8",
            width: "13.8",
            height: "14.8",
            rx: "2.1",
            stroke: "currentColor",
            strokeWidth: "1.8"
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6",
            stroke: "currentColor",
            strokeWidth: "1.8",
            strokeLinecap: "round"
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.2 19.6v-2.9h5.6v2.9",
            stroke: "currentColor",
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
});
const $811a329b29e8a5d6$var$icons = {
    search: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "5.8",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m13.2 13.2 4 4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    }),
    reset: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.2 6.3V3.9H2.8M4 4a6.4 6.4 0 1 1-1.4 7.5",
            stroke: "currentColor",
            strokeWidth: "1.7",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }),
    object: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.2 5.2h7.6v9.6H6.2z",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.2 8.4h7.6M6.2 11.6h7.6M9.4 5.2v9.6M12.6 5.2v9.6",
                stroke: "currentColor",
                strokeWidth: "1.4"
            })
        ]
    }),
    entrance: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.2 15.7h11.6M6 15.7V5.2h8v10.5",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 8h4M8 11h4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    }),
    location: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 17s5.2-4.7 5.2-9a5.2 5.2 0 0 0-10.4 0c0 4.3 5.2 9 5.2 9Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "8",
                r: "1.8",
                stroke: "currentColor",
                strokeWidth: "1.7"
            })
        ]
    }),
    type: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.3 5.5h11.4M4.3 10h11.4M4.3 14.5h11.4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.2 3.8v12.4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    }),
    votes: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.1 15.9h11.8M5.6 15.9V9.4M10 15.9V6.7M14.4 15.9V4.1",
            stroke: "currentColor",
            strokeWidth: "1.7",
            strokeLinecap: "round"
        })
    }),
    mea: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 3.7 15.3 6.8v6.4L10 16.3l-5.3-3.1V6.8L10 3.7Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 3.7v12.6M4.7 6.8 10 10l5.3-3.2",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }),
    status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "5.9",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                fill: "currentColor"
            })
        ]
    }),
    date: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.2 3.8h6.5l2.9 2.9v8.6a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 15.3V5a1.2 1.2 0 0 1 1.2-1.2Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.8 9.4h6.1M6.8 12.2h5",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    }),
    actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "5.3",
                r: "1.4",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "1.4",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "14.7",
                r: "1.4",
                fill: "currentColor"
            })
        ]
    })
};
const $811a329b29e8a5d6$var$plainHeader = (label, icon)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "resolutions-v2-th-plain",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-icon",
                "aria-hidden": "true",
                children: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-label",
                children: label
            })
        ]
    });
const $811a329b29e8a5d6$export$d00028a8a5a54d8b = ({ canCreate: canCreate = false, canUpdate: canUpdate = false, canDelete: canDelete = false })=>{
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [pageSize, setPageSize] = (0, $acw62.useState)(10);
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const initialSearch = String(searchParams.get("search") ?? "").trim();
    const [page, setPage] = (0, $acw62.useState)(1);
    const [search, setSearch] = (0, $acw62.useState)(initialSearch);
    const [objectFilter, setObjectFilter] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("aktiv");
    const [unitTypeFilter, setUnitTypeFilter] = (0, $acw62.useState)("");
    const [sortBy, setSortBy] = (0, $acw62.useState)("objektnummer");
    const [sortDir, setSortDir] = (0, $acw62.useState)("asc");
    const [openActionMenuId, setOpenActionMenuId] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const [showCreate, setShowCreate] = (0, $acw62.useState)(false);
    const [createError, setCreateError] = (0, $acw62.useState)("");
    const [editError, setEditError] = (0, $acw62.useState)("");
    const [actionError, setActionError] = (0, $acw62.useState)("");
    const [deleteConfirm, setDeleteConfirm] = (0, $acw62.useState)(null);
    const [form, setForm] = (0, $acw62.useState)({
        objectId: "",
        einheitsnummer: "",
        bezeichnung: "",
        einheitstyp: "",
        stimmrecht: "",
        mea: "",
        status: ""
    });
    const [editForm, setEditForm] = (0, $acw62.useState)(null);
    const { data: data, isError: isError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "units",
            page,
            pageSize,
            search,
            objectFilter,
            unitTypeFilter,
            status,
            sortBy,
            sortDir
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: page,
                pageSize: pageSize,
                search: search,
                objectId: objectFilter || undefined,
                status: status || undefined,
                einheitstyp: unitTypeFilter || undefined,
                sortBy: sortBy,
                sortDir: sortDir
            }),
        placeholderData: (previousData)=>previousData,
        staleTime: 15000
    });
    const { data: objectsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "objects-select"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).objects({
                page: 1,
                pageSize: 200,
                sortBy: "objektnummer",
                sortDir: "asc"
            })
    });
    const { data: activeResolutions } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "active-resolutions-lock"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: 1,
                pageSize: 500,
                status: "aktiv"
            })
    });
    const { data: uiSettings } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-units"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings()
    });
    const lockedObjectIds = (0, $acw62.useMemo)(()=>new Set((activeResolutions?.data ?? []).map((r)=>r.objectId)), [
        activeResolutions?.data
    ]);
    const objectIdByObjektnummer = (0, $acw62.useMemo)(()=>new Map((objectsData?.data ?? []).map((o)=>[
                o.objektnummer,
                o.id
            ])), [
        objectsData?.data
    ]);
    (0, $acw62.useEffect)(()=>{
        setPage(1);
    }, [
        search,
        objectFilter,
        unitTypeFilter,
        status,
        sortBy,
        sortDir,
        pageSize
    ]);
    (0, $acw62.useEffect)(()=>{
        setOpenActionMenuId(null);
    }, [
        page,
        search,
        objectFilter,
        unitTypeFilter,
        status,
        sortBy,
        sortDir,
        showCreate,
        editForm
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = (event)=>{
            if (event && (0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            setOpenActionMenuId(null);
        };
        const handleEscape = (event)=>{
            if (event.key === "Escape") closeMenu();
        };
        window.addEventListener("mousedown", closeMenu);
        window.addEventListener("keydown", handleEscape);
        return ()=>{
            window.removeEventListener("mousedown", closeMenu);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!openActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>setOpenActionMenuId(null),
        timeoutMs: 3000
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) setIsActionMenuHovered(false);
    }, [
        openActionMenuId
    ]);
    const { actionMenuPosition: actionMenuPosition, openActionMenuAtTrigger: openActionMenuAtTrigger } = (0, $acf0971746b2c487$export$847509c5c6223f45)({
        openMenuId: openActionMenuId,
        setOpenMenuId: setOpenActionMenuId
    });
    const formatEinheitsnummer = (value)=>{
        const trimmed = String(value ?? "").trim();
        if (!trimmed) return "";
        return /^\d+$/.test(trimmed) ? trimmed.padStart(4, "0") : trimmed;
    };
    const createMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).createUnit({
                objectId: form.objectId,
                einheitsnummer: form.einheitsnummer.trim(),
                bezeichnung: form.bezeichnung.trim(),
                einheitstyp: form.einheitstyp,
                stimmrecht: Number(form.stimmrecht),
                mea: form.mea ? Number(form.mea) : undefined,
                status: form.status
            }),
        onSuccess: async ()=>{
            setCreateError("");
            setShowCreate(false);
            setForm({
                objectId: "",
                einheitsnummer: "",
                bezeichnung: "",
                einheitstyp: "",
                stimmrecht: "",
                mea: "",
                status: ""
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "units"
                ]
            });
            setPage(1);
        },
        onError: (error)=>setCreateError(error instanceof Error ? error.message : "Anlage fehlgeschlagen")
    });
    const editMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!editForm) throw new Error("Kein Datensatz ausgew\xe4hlt");
            if (lockedObjectIds.has(editForm.objectId)) throw new Error("Einheit ist wegen aktivem Umlaufbeschluss gesperrt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateUnit(editForm.id, {
                einheitsnummer: editForm.einheitsnummer.trim(),
                bezeichnung: editForm.bezeichnung.trim(),
                einheitstyp: editForm.einheitstyp,
                stimmrecht: Number(editForm.stimmrecht),
                mea: editForm.mea ? Number(editForm.mea) : undefined,
                status: editForm.status
            });
        },
        onSuccess: async ()=>{
            setEditError("");
            setEditForm(null);
            await queryClient.invalidateQueries({
                queryKey: [
                    "units"
                ]
            });
        },
        onError: (error)=>setEditError(error instanceof Error ? error.message : "Bearbeitung fehlgeschlagen")
    });
    const deleteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).deactivateUnit(id),
        onSuccess: async ()=>{
            setDeleteConfirm(null);
            setActionError("");
            await queryClient.invalidateQueries({
                queryKey: [
                    "units"
                ]
            });
        },
        onError: (error)=>setActionError(error instanceof Error ? error.message : "L\xf6schen fehlgeschlagen")
    });
    const toggleSort = (field)=>{
        if (sortBy === field) {
            setSortDir((prev)=>prev === "asc" ? "desc" : "asc");
            return;
        }
        setSortBy(field);
        setSortDir("asc");
    };
    const sortLabel = (field, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: ()=>toggleSort(field),
            style: {
                border: "none",
                background: "transparent",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                font: "inherit",
                color: "inherit",
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                gap: 6
            },
            title: sortBy === field ? `Sortierung: ${sortDir === "asc" ? "aufsteigend" : "absteigend"}` : "Sortierung aktivieren",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
                })
            ]
        });
    const rows = data?.data ?? [];
    const totalRows = data?.meta.total ?? 0;
    const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
    const isFrameworkV2 = uiSettings?.management?.uiFramework === "mockup_v2" || typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    const isUnitFormActive = showCreate || Boolean(editForm);
    const fixedViewportListLayout = isFrameworkV2 && !isUnitFormActive;
    const pageItems = (0, $acw62.useMemo)(()=>{
        if (totalPages <= 1) return [
            1
        ];
        const start = Math.max(1, page - 1);
        const end = Math.min(totalPages, start + 2);
        const adjustedStart = Math.max(1, end - 2);
        return Array.from({
            length: end - adjustedStart + 1
        }, (_, i)=>adjustedStart + i);
    }, [
        page,
        totalPages
    ]);
    const resetListFilters = ()=>{
        setSearch("");
        setObjectFilter("");
        setUnitTypeFilter("");
        setStatus("aktiv");
        setSortBy("objektnummer");
        setSortDir("asc");
        setPage(1);
    };
    const renderSortIndicator = (field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "resolutions-v2-sort-indicator",
            "aria-hidden": "true",
            children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
        });
    const renderV2SortHeader = (field, label, icon)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            className: "resolutions-v2-th-sort",
            onClick: ()=>toggleSort(field),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-icon",
                    "aria-hidden": "true",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-label",
                    children: label
                }),
                renderSortIndicator(field)
            ]
        });
    const openEditForm = (r)=>{
        setEditForm({
            id: r.id,
            objectId: objectIdByObjektnummer.get(r.objektnummer) ?? "",
            einheitsnummer: r.einheitsnummer,
            bezeichnung: r.bezeichnung,
            einheitstyp: String(r.einheitstyp ?? "").trim().toLowerCase(),
            stimmrecht: String(r.stimmrecht),
            mea: r.mea !== undefined ? String(r.mea) : "",
            status: r.status
        });
    };
    const requestDelete = (r)=>{
        const rowObjectId = objectIdByObjektnummer.get(r.objektnummer) ?? "";
        const locked = rowObjectId ? lockedObjectIds.has(rowObjectId) : false;
        if (locked) {
            setActionError("Einheit ist wegen aktivem Umlaufbeschluss gesperrt.");
            return;
        }
        setDeleteConfirm({
            id: r.id,
            label: `${r.objektnummer} / ${r.einheitsnummer}`,
            code: String(Math.floor(1000 + Math.random() * 9000)),
            input: [
                "",
                "",
                "",
                ""
            ],
            error: ""
        });
    };
    const columns = (0, $acw62.useMemo)(()=>[
            {
                key: "objektnummer",
                label: sortLabel("objektnummer", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            style: {
                                whiteSpace: "nowrap"
                            },
                            children: "Objekt-Nr"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "\xa0"
                    ]
                })),
                align: "center",
                width: 92,
                render: (r)=>{
                    const objectId = objectIdByObjektnummer.get(r.objektnummer);
                    return objectId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: `/objects/${objectId}`,
                        className: "badge object-ref",
                        style: {
                            textDecoration: "none"
                        },
                        children: r.objektnummer
                    }) : r.objektnummer;
                }
            },
            {
                key: "einheitsnummer",
                label: sortLabel("einheitsnummer", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Einheit-Nr.",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "\xa0"
                    ]
                })),
                align: "center",
                width: 96,
                render: (r)=>formatEinheitsnummer(r.einheitsnummer)
            },
            {
                key: "aufgang",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Aufgang",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "\xa0"
                    ]
                }),
                render: (r)=>r.aufgangName || r.aufgangRef || "-"
            },
            {
                key: "bezeichnung",
                label: sortLabel("bezeichnung", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Lage",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "\xa0"
                    ]
                }))
            },
            {
                key: "einheitstyp",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Einheitstyp",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "\xa0"
                    ]
                }),
                align: "center",
                render: (r)=>(0, $f336a13bdd60accb$export$a10aac408d86876b)(r.einheitstyp)
            },
            {
                key: "stimmrecht",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Stimmrecht",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "\xa0"
                    ]
                }),
                align: "center",
                render: (r)=>$811a329b29e8a5d6$var$formatNumberDE(r.stimmrecht)
            },
            {
                key: "mea",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "MEA",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "\xa0"
                    ]
                }),
                align: "center",
                render: (r)=>$811a329b29e8a5d6$var$formatNumberDE(r.mea)
            },
            {
                key: "status",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Status",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "\xa0"
                    ]
                }),
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge ${r.status}`,
                        children: r.status
                    })
            },
            {
                key: "actions",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Aktionen",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "\xa0"
                    ]
                }),
                render: (r)=>{
                    if (!canUpdate && !canDelete) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            color: "var(--text-soft)"
                        },
                        children: "-"
                    });
                    const rowObjectId = objectIdByObjektnummer.get(r.objektnummer) ?? "";
                    const locked = rowObjectId ? lockedObjectIds.has(rowObjectId) : false;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: 6,
                            alignItems: "center"
                        },
                        children: [
                            canUpdate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>openEditForm(r),
                                disabled: locked,
                                title: locked ? "Gesperrt wegen aktivem Umlaufbeschluss" : undefined,
                                children: "Bearbeiten"
                            }) : null,
                            canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>requestDelete(r),
                                disabled: locked || deleteMutation.isPending,
                                title: locked ? "L\xf6schen bei aktivem Umlaufbeschluss gesperrt" : undefined,
                                children: "L\xf6schen"
                            }) : null,
                            locked && (canUpdate || canDelete) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "lock-indicator",
                                title: "Gesperrt wegen aktivem Umlaufbeschluss",
                                children: "\uD83D\uDD12"
                            }) : null
                        ]
                    });
                }
            }
        ], [
        canDelete,
        canUpdate,
        deleteMutation.isPending,
        lockedObjectIds,
        objectIdByObjektnummer,
        sortBy,
        sortDir
    ]);
    const canCreateForm = form.objectId && form.einheitsnummer.trim() && form.einheitstyp && form.mea !== "" && Number(form.mea) >= 0 && form.status;
    const canEdit = editForm && editForm.einheitsnummer.trim() && editForm.einheitstyp && editForm.mea !== "" && Number(editForm.mea) >= 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: fixedViewportListLayout ? "resolutions-v2-page" : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `page-header panel ${isFrameworkV2 ? "resolutions-v2-page-header" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: isFrameworkV2 ? "resolutions-v2-title" : "",
                        style: {
                            margin: 0
                        },
                        children: [
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-title-icon",
                                "aria-hidden": "true",
                                children: $811a329b29e8a5d6$var$unitBuildingIcon
                            }) : null,
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "resolutions-v2-title-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-main",
                                        children: "Einheiten"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-sub",
                                        children: "\xdcbersicht aller Einheiten und Nutzungsdaten"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Einheiten"
                            })
                        ]
                    }),
                    canCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: isFrameworkV2 ? "resolutions-v2-create-btn" : "",
                        onClick: ()=>setShowCreate((v)=>!v),
                        children: [
                            isFrameworkV2 && !showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-create-btn-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M10 4.2v11.6M4.2 10h11.6",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round"
                                    })
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: showCreate ? "Schlie\xdfen" : "Neue Einheit"
                            })
                        ]
                    }) : null
                ]
            }),
            canCreate && showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Einheit anlegen"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Objekt*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.objectId,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                objectId: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Objekt w\xe4hlen*"
                                            }),
                                            (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: o.id,
                                                    children: `${o.objektnummer} - ${o.objektname}${lockedObjectIds.has(o.id) ? " (gesperrt)" : ""}`
                                                }, o.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Einheitsnummer*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.einheitsnummer,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                einheitsnummer: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Lage"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.bezeichnung,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                bezeichnung: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Einheitstyp*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.einheitstyp,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                einheitstyp: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Einheitstyp w\xe4hlen*"
                                            }),
                                            (0, $f336a13bdd60accb$export$4b74ea5d724dd45).map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: value,
                                                    children: (0, $f336a13bdd60accb$export$a10aac408d86876b)(value)
                                                }, value))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stimmrecht"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        step: "0.01",
                                        value: form.stimmrecht,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                stimmrecht: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "MEA*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        step: "0.01",
                                        value: form.mea,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                mea: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Status*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.status,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                status: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Status w\xe4hlen*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !canCreateForm || createMutation.isPending || lockedObjectIds.has(form.objectId),
                                title: lockedObjectIds.has(form.objectId) ? "Gesperrt wegen aktivem Umlaufbeschluss" : undefined,
                                onClick: ()=>createMutation.mutate(),
                                children: createMutation.isPending ? "Speichere..." : "Einheit speichern"
                            }),
                            createError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: createError
                            }) : null
                        ]
                    })
                ]
            }) : null,
            !showCreate && canUpdate && editForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Einheit bearbeiten"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Einheitsnummer*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.einheitsnummer,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                einheitsnummer: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Lage"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.bezeichnung,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                bezeichnung: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Einheitstyp*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: editForm.einheitstyp,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                einheitstyp: e.target.value
                                            }),
                                        children: (0, $f336a13bdd60accb$export$4b74ea5d724dd45).map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: value,
                                                children: (0, $f336a13bdd60accb$export$a10aac408d86876b)(value)
                                            }, value))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stimmrecht"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        step: "0.01",
                                        value: editForm.stimmrecht,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                stimmrecht: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "MEA*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        step: "0.01",
                                        value: editForm.mea,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                mea: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.status,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                status: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !canEdit || editMutation.isPending || (editForm ? lockedObjectIds.has(editForm.objectId) : false),
                                title: editForm && lockedObjectIds.has(editForm.objectId) ? "Gesperrt wegen aktivem Umlaufbeschluss" : undefined,
                                onClick: ()=>editMutation.mutate(),
                                children: editMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setEditForm(null),
                                children: "Abbrechen"
                            }),
                            editError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: editError
                            }) : null
                        ]
                    })
                ]
            }) : null,
            !isUnitFormActive && isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel",
                children: "Fehler beim Laden der Einheiten."
            }) : null,
            !isUnitFormActive && actionError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel error-text",
                children: actionError
            }) : null,
            !isUnitFormActive ? isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel resolutions-v2-list-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-filterbar",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-filter-fields",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "resolutions-v2-filter-input",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-filter-icon",
                                                "aria-hidden": "true",
                                                children: $811a329b29e8a5d6$var$icons.search
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                placeholder: "Suche...",
                                                value: search,
                                                onChange: (e)=>setSearch(e.target.value)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: objectFilter,
                                        onChange: (e)=>setObjectFilter(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Objekt-Nr"
                                            }),
                                            (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: o.id,
                                                    children: o.objektnummer
                                                }, o.id))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: unitTypeFilter,
                                        onChange: (e)=>setUnitTypeFilter(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Einheitstypen"
                                            }),
                                            (0, $f336a13bdd60accb$export$4b74ea5d724dd45).map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: value,
                                                    children: (0, $f336a13bdd60accb$export$a10aac408d86876b)(value)
                                                }, value))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: status,
                                        onChange: (e)=>setStatus(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                className: "resolutions-v2-reset-btn",
                                onClick: resetListFilters,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-reset-btn-icon",
                                        "aria-hidden": "true",
                                        children: $811a329b29e8a5d6$var$icons.reset
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Filter zur\xfccksetzen"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-row-count",
                        children: [
                            "Zeilen: ",
                            rows.length,
                            " / Gesamt: ",
                            totalRows
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "resolutions-v2-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "resolutions-v2-table units-v2-table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "92px"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: renderV2SortHeader("objektnummer", "Objekt-Nr", $811a329b29e8a5d6$var$icons.object)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: renderV2SortHeader("einheitsnummer", "Einheit-Nr", $811a329b29e8a5d6$var$unitBuildingIcon)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: $811a329b29e8a5d6$var$plainHeader("Aufgang", $811a329b29e8a5d6$var$icons.entrance)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: renderV2SortHeader("bezeichnung", "Lage", $811a329b29e8a5d6$var$icons.location)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: $811a329b29e8a5d6$var$plainHeader("Einheitstyp", $811a329b29e8a5d6$var$icons.type)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: $811a329b29e8a5d6$var$plainHeader("Stimmrecht", $811a329b29e8a5d6$var$icons.votes)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: $811a329b29e8a5d6$var$plainHeader("MEA", $811a329b29e8a5d6$var$icons.mea)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: $811a329b29e8a5d6$var$plainHeader("Status", $811a329b29e8a5d6$var$icons.status)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "resolutions-v2-actions-head",
                                                "aria-label": "Aktionen",
                                                title: "Aktionen",
                                                children: $811a329b29e8a5d6$var$plainHeader("", $811a329b29e8a5d6$var$icons.actions)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: rows.map((r)=>{
                                        const objectId = objectIdByObjektnummer.get(r.objektnummer);
                                        const locked = objectId ? lockedObjectIds.has(objectId) : false;
                                        const menuId = r.id;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: objectId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                        to: `/objects/${objectId}`,
                                                        className: "badge object-number",
                                                        style: {
                                                            textDecoration: "none"
                                                        },
                                                        children: r.objektnummer
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "badge object-number",
                                                        children: r.objektnummer
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: formatEinheitsnummer(r.einheitsnummer)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: r.aufgangName || r.aufgangRef || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "resolutions-v2-object-cell",
                                                    children: r.bezeichnung || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $f336a13bdd60accb$export$a10aac408d86876b)(r.einheitstyp)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $811a329b29e8a5d6$var$formatNumberDE(r.stimmrecht)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $811a329b29e8a5d6$var$formatNumberDE(r.mea)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `badge ${r.status}`,
                                                        children: r.status
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: !canUpdate && !canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: "-"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "resolutions-v2-action-wrap",
                                                        onClick: (e)=>e.stopPropagation(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "resolutions-v2-action-trigger",
                                                                "aria-label": `Aktionen f\xfcr Einheit ${r.einheitsnummer}`,
                                                                "aria-expanded": openActionMenuId === menuId,
                                                                onMouseDown: (e)=>e.stopPropagation(),
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    if (openActionMenuId === menuId) {
                                                                        setOpenActionMenuId(null);
                                                                        return;
                                                                    }
                                                                    openActionMenuAtTrigger(menuId, e.currentTarget);
                                                                },
                                                                children: "\u22EE"
                                                            }),
                                                            openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                style: {
                                                                    left: actionMenuPosition.left,
                                                                    top: actionMenuPosition.top
                                                                },
                                                                onMouseDown: (e)=>e.stopPropagation(),
                                                                onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                children: [
                                                                    canUpdate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        disabled: locked,
                                                                        onClick: ()=>{
                                                                            if (locked) {
                                                                                setActionError("Einheit ist wegen aktivem Umlaufbeschluss gesperrt.");
                                                                                setOpenActionMenuId(null);
                                                                                return;
                                                                            }
                                                                            openEditForm(r);
                                                                            setOpenActionMenuId(null);
                                                                        },
                                                                        children: "Bearbeiten"
                                                                    }) : null,
                                                                    canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        disabled: locked || deleteMutation.isPending,
                                                                        onClick: ()=>{
                                                                            requestDelete(r);
                                                                            setOpenActionMenuId(null);
                                                                        },
                                                                        children: "L\xf6schen"
                                                                    }) : null
                                                                ]
                                                            }), document.body) : null
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, r.id);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-pagination",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-page-size",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: String(pageSize),
                                    onChange: (e)=>setPageSize(Number(e.target.value) || 10),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "10",
                                            children: "10 pro Seite"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "20",
                                            children: "20 pro Seite"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "50",
                                            children: "50 pro Seite"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-page-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "resolutions-v2-page-arrow",
                                        onClick: ()=>setPage((prev)=>Math.max(1, prev - 1)),
                                        disabled: page <= 1,
                                        children: "\u2039"
                                    }),
                                    pageItems.map((pageItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: `resolutions-v2-page-chip ${pageItem === page ? "active" : ""}`,
                                            onClick: ()=>setPage(pageItem),
                                            children: pageItem
                                        }, pageItem)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "resolutions-v2-page-arrow",
                                        onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                        disabled: page >= totalPages,
                                        children: "\u203A"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "resolutions-v2-page-info",
                                        children: [
                                            "Seite ",
                                            page,
                                            " von ",
                                            totalPages
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-page-next-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    className: "resolutions-v2-next-btn",
                                    onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                    disabled: page >= totalPages,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Weiter"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            children: "\u203A"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                columns: columns,
                rows: rows,
                total: totalRows,
                page: page,
                pageSize: pageSize,
                onPageChange: setPage,
                bodyMaxHeight: 560,
                topContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "filterbar",
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            placeholder: "Suche",
                            value: search,
                            onChange: (e)=>setSearch(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: objectFilter,
                            onChange: (e)=>setObjectFilter(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Alle Objekt-Nr"
                                }),
                                (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: o.id,
                                        children: o.objektnummer
                                    }, o.id))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: unitTypeFilter,
                            onChange: (e)=>setUnitTypeFilter(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Alle Einheitstypen"
                                }),
                                (0, $f336a13bdd60accb$export$4b74ea5d724dd45).map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: value,
                                        children: (0, $f336a13bdd60accb$export$a10aac408d86876b)(value)
                                    }, value))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: status,
                            onChange: (e)=>setStatus(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Alle Status"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "aktiv",
                                    children: "Aktiv"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "inaktiv",
                                    children: "Inaktiv"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                open: !!deleteConfirm,
                message: deleteConfirm ? `Einheit ${deleteConfirm.label} soll gel\xf6scht werden.` : "",
                code: deleteConfirm?.code ?? "",
                input: deleteConfirm?.input ?? [
                    "",
                    "",
                    "",
                    ""
                ],
                error: deleteConfirm?.error,
                isPending: deleteMutation.isPending,
                onClose: ()=>setDeleteConfirm(null),
                onInputChange: (next)=>{
                    if (!deleteConfirm) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        input: next
                    });
                },
                onErrorReset: ()=>{
                    if (!deleteConfirm || !deleteConfirm.error) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        error: ""
                    });
                },
                onConfirm: ()=>{
                    if (!deleteConfirm) return;
                    const enteredCode = deleteConfirm.input.join("");
                    if (enteredCode !== deleteConfirm.code) {
                        setDeleteConfirm({
                            ...deleteConfirm,
                            error: "Sicherheitscode falsch eingegeben."
                        });
                        return;
                    }
                    deleteMutation.mutate(deleteConfirm.id);
                }
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");







const $f252d990203a12d3$var$hasAnyName = (name1, name2, name3)=>!!name1.trim() || !!name2.trim() || !!name3.trim();
const $f252d990203a12d3$var$formatDateDe = (value)=>{
    if (!value) return "-";
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[3]}.${m[2]}.${m[1]}` : value;
};
const $f252d990203a12d3$var$buildOwnerValidityTooltip = (owner, statusFilter)=>{
    const detailLines = (owner.objectRefs ?? []).flatMap((objectRef)=>(objectRef.assignmentDetails ?? []).filter((detail)=>{
            if (statusFilter === "aktiv") return detail.status === "aktiv";
            if (statusFilter === "inaktiv") return detail.status === "inaktiv";
            return true;
        }).map((detail)=>{
            const from = $f252d990203a12d3$var$formatDateDe(detail.gueltigAb);
            const to = $f252d990203a12d3$var$formatDateDe(detail.gueltigBis);
            return `Objekt ${detail.objektnummer} | Einheit ${detail.einheitsnummer} | EGT ab: ${from} | EGT bis: ${to}`;
        })).filter(Boolean);
    const uniqueLines = Array.from(new Set(detailLines));
    if (uniqueLines.length > 0) return uniqueLines.join("\n");
    return `EGT ab: ${$f252d990203a12d3$var$formatDateDe(owner.gueltig_ab)} | EGT bis: ${$f252d990203a12d3$var$formatDateDe(owner.gueltig_bis)}`;
};
const $f252d990203a12d3$var$formatOwnerStatusLabel = (status)=>status === "keine_zuordnung" ? "keine Zuordnung" : status;
const $f252d990203a12d3$var$parseReachabilityFilter = (value)=>value === "digital" || value === "analog" ? value : "";
const $f252d990203a12d3$var$buildOwnerDisplayName = (owner)=>{
    const parts = [
        owner.anrede,
        owner.titel,
        owner.vorname,
        owner.name_1,
        owner.name_2,
        owner.name_3
    ].map((value)=>(value ?? "").trim()).filter(Boolean);
    if (parts.length > 0) return parts.join(" ");
    return owner.vollname?.trim() || "-";
};
const $f252d990203a12d3$export$230e90f41af31f4f = ({ canCreate: canCreate = false, canUpdate: canUpdate = false, canDelete: canDelete = false })=>{
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const initialSearch = String(searchParams.get("search") ?? "").trim();
    const initialReachability = $f252d990203a12d3$var$parseReachabilityFilter(searchParams.get("reachability") ?? searchParams.get("erreichbarkeit"));
    const [pageSize, setPageSize] = (0, $acw62.useState)(10);
    const [page, setPage] = (0, $acw62.useState)(1);
    const [search, setSearch] = (0, $acw62.useState)(initialSearch);
    const [objectFilter, setObjectFilter] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("aktiv");
    const [reachability, setReachability] = (0, $acw62.useState)(initialReachability);
    const [sortBy, setSortBy] = (0, $acw62.useState)("objektnummer");
    const [sortDir, setSortDir] = (0, $acw62.useState)("asc");
    const [showCreate, setShowCreate] = (0, $acw62.useState)(false);
    const [openActionMenuId, setOpenActionMenuId] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const [createError, setCreateError] = (0, $acw62.useState)("");
    const [editError, setEditError] = (0, $acw62.useState)("");
    const [actionError, setActionError] = (0, $acw62.useState)("");
    const [deleteConfirm, setDeleteConfirm] = (0, $acw62.useState)(null);
    const [form, setForm] = (0, $acw62.useState)({
        objectId: "",
        eigentuemer_id: "",
        anrede: "",
        titel: "",
        vorname: "",
        name_1: "",
        name_2: "",
        name_3: "",
        strasse: "",
        plz: "",
        ort: "",
        land_code: "",
        land: "",
        email: "",
        telefon: "",
        status: ""
    });
    const [editForm, setEditForm] = (0, $acw62.useState)(null);
    const { data: data, isError: isError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "owners",
            page,
            pageSize,
            search,
            objectFilter,
            status,
            reachability,
            sortBy,
            sortDir
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                page: page,
                pageSize: pageSize,
                search: search,
                objectId: objectFilter || undefined,
                status: status || undefined,
                erreichbarkeit: reachability || undefined,
                sortBy: sortBy,
                sortDir: sortDir
            }),
        placeholderData: (previousData)=>previousData,
        staleTime: 15000
    });
    const { data: objectsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "objects-select"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).objects({
                page: 1,
                pageSize: 200,
                sortBy: "objektnummer",
                sortDir: "asc"
            })
    });
    const { data: activeResolutions } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "active-resolutions-lock"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: 1,
                pageSize: 500,
                status: "aktiv"
            })
    });
    const { data: uiSettings } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-owner-anrede"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings(),
        staleTime: 60000
    });
    const lockedObjectIds = (0, $acw62.useMemo)(()=>new Set((activeResolutions?.data ?? []).map((r)=>r.objectId)), [
        activeResolutions?.data
    ]);
    const anredeOptions = (0, $acw62.useMemo)(()=>(0, $f18f15d2e4dddb8c$export$4c70cb57ab25f03a)(uiSettings?.management), [
        uiSettings?.management
    ]);
    const titelOptions = (0, $acw62.useMemo)(()=>(0, $f18f15d2e4dddb8c$export$c5a09025020d6cf)(uiSettings?.management), [
        uiSettings?.management
    ]);
    const createMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).createOwner({
                eigentuemer_id: form.eigentuemer_id.trim(),
                anrede: form.anrede.trim() || undefined,
                titel: form.titel.trim() || undefined,
                vorname: form.vorname.trim() || undefined,
                name_1: form.name_1.trim() || undefined,
                name_2: form.name_2.trim() || undefined,
                name_3: form.name_3.trim() || undefined,
                strasse: form.strasse.trim() || undefined,
                plz: form.plz.trim() || undefined,
                ort: form.ort.trim() || undefined,
                land_code: form.land_code.trim() || undefined,
                land: form.land.trim() || undefined,
                email: form.email.trim(),
                telefon: form.telefon.trim() || undefined,
                status: form.status
            }),
        onSuccess: async ()=>{
            setCreateError("");
            setShowCreate(false);
            setForm({
                objectId: "",
                eigentuemer_id: "",
                anrede: "",
                titel: "",
                vorname: "",
                name_1: "",
                name_2: "",
                name_3: "",
                strasse: "",
                plz: "",
                ort: "",
                land_code: "",
                land: "",
                email: "",
                telefon: "",
                status: ""
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "owners"
                ]
            });
            setPage(1);
        },
        onError: (error)=>setCreateError(error instanceof Error ? error.message : "Anlage fehlgeschlagen")
    });
    const editMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!editForm) throw new Error("Kein Datensatz ausgew\xe4hlt");
            if (lockedObjectIds.has(editForm.objectId)) throw new Error("Eigent\xfcmer ist wegen aktivem Umlaufbeschluss gesperrt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateOwner(editForm.id, {
                objectId: editForm.objectId,
                eigentuemer_id: editForm.eigentuemer_id.trim(),
                anrede: editForm.anrede.trim() || undefined,
                titel: editForm.titel.trim() || undefined,
                vorname: editForm.vorname.trim() || undefined,
                name_1: editForm.name_1.trim() || undefined,
                name_2: editForm.name_2.trim() || undefined,
                name_3: editForm.name_3.trim() || undefined,
                strasse: editForm.strasse.trim() || undefined,
                plz: editForm.plz.trim() || undefined,
                ort: editForm.ort.trim() || undefined,
                land_code: editForm.land_code.trim() || undefined,
                land: editForm.land.trim() || undefined,
                email: editForm.email.trim(),
                telefon: editForm.telefon.trim() || undefined,
                status: editForm.status
            });
        },
        onSuccess: async ()=>{
            setEditError("");
            setEditForm(null);
            await queryClient.invalidateQueries({
                queryKey: [
                    "owners"
                ]
            });
        },
        onError: (error)=>setEditError(error instanceof Error ? error.message : "Bearbeitung fehlgeschlagen")
    });
    const deleteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).deactivateOwner(id),
        onSuccess: async ()=>{
            setDeleteConfirm(null);
            setActionError("");
            await queryClient.invalidateQueries({
                queryKey: [
                    "owners"
                ]
            });
        },
        onError: (error)=>setActionError(error instanceof Error ? error.message : "L\xf6schen fehlgeschlagen")
    });
    (0, $acw62.useEffect)(()=>{
        setPage(1);
    }, [
        search,
        objectFilter,
        status,
        reachability,
        sortBy,
        sortDir,
        pageSize
    ]);
    (0, $acw62.useEffect)(()=>{
        setOpenActionMenuId(null);
    }, [
        page,
        search,
        objectFilter,
        status,
        reachability,
        sortBy,
        sortDir,
        showCreate,
        editForm
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = (event)=>{
            if (event && (0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            setOpenActionMenuId(null);
        };
        const handleEscape = (event)=>{
            if (event.key === "Escape") closeMenu();
        };
        window.addEventListener("mousedown", closeMenu);
        window.addEventListener("keydown", handleEscape);
        return ()=>{
            window.removeEventListener("mousedown", closeMenu);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!openActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>setOpenActionMenuId(null),
        timeoutMs: 3000
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) setIsActionMenuHovered(false);
    }, [
        openActionMenuId
    ]);
    const { actionMenuPosition: actionMenuPosition, openActionMenuAtTrigger: openActionMenuAtTrigger } = (0, $acf0971746b2c487$export$847509c5c6223f45)({
        openMenuId: openActionMenuId,
        setOpenMenuId: setOpenActionMenuId
    });
    const toggleSort = (field)=>{
        if (sortBy === field) {
            setSortDir((prev)=>prev === "asc" ? "desc" : "asc");
            return;
        }
        setSortBy(field);
        setSortDir("asc");
    };
    const sortLabel = (field, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: ()=>toggleSort(field),
            style: {
                border: "none",
                background: "transparent",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                font: "inherit",
                color: "inherit",
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                gap: 6
            },
            title: sortBy === field ? `Sortierung: ${sortDir === "asc" ? "aufsteigend" : "absteigend"}` : "Sortierung aktivieren",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
                })
            ]
        });
    const columns = (0, $acw62.useMemo)(()=>[
            {
                key: "objekt_refs",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Eigent\xfcmer",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "in Objekt"
                    ]
                }),
                align: "center",
                width: 126,
                render: (r)=>{
                    const refs = (r.objectRefs ?? []).filter((entry)=>!!entry.id && !!entry.objektnummer);
                    const fallbackRef = r.objectId && r.objektnummer ? [
                        {
                            id: r.objectId,
                            objektnummer: r.objektnummer,
                            status: r.status === "aktiv" ? "aktiv" : "inaktiv",
                            assignmentDetails: []
                        }
                    ] : [];
                    const displayRefs = refs.length > 0 ? refs : fallbackRef;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            display: "inline-flex",
                            flexWrap: "wrap",
                            gap: 6,
                            justifyContent: "center"
                        },
                        children: displayRefs.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `/objects/${entry.id}`,
                                className: `badge object-ref ${entry.status === "inaktiv" ? "object-ref-inaktiv" : ""}`,
                                style: {
                                    textDecoration: "none"
                                },
                                children: entry.objektnummer
                            }, `${r.id}-${entry.id}`))
                    });
                }
            },
            {
                key: "eigentuemer_id",
                label: sortLabel("eigentuemer_id", "Eigent\xfcmer ID"),
                align: "center"
            },
            {
                key: "anrede",
                label: "Anrede"
            },
            {
                key: "titel",
                label: "Titel"
            },
            {
                key: "vorname",
                label: "Vorname"
            },
            {
                key: "name_1",
                label: sortLabel("vollname", "Name 1")
            },
            {
                key: "name_2",
                label: "Name 2"
            },
            {
                key: "name_3",
                label: "Name 3"
            },
            {
                key: "email",
                label: "E-Mail"
            },
            {
                key: "telefon",
                label: "Telefon"
            },
            {
                key: "erreichbarkeit",
                label: "Erreichbarkeit",
                align: "center",
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge ${r.ist_analog ? "erreichbar-analog" : "erreichbar-digital"}`,
                        children: r.ist_analog ? "analog" : "digital"
                    })
            },
            {
                key: "status",
                label: "Status",
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge ${r.status} quick-tooltip quick-tooltip-subtle quick-tooltip-multiline`,
                        "data-tooltip": $f252d990203a12d3$var$buildOwnerValidityTooltip(r, status),
                        tabIndex: 0,
                        children: $f252d990203a12d3$var$formatOwnerStatusLabel(r.status)
                    })
            },
            {
                key: "actions",
                label: "Aktionen",
                render: (r)=>{
                    if (!canUpdate && !canDelete) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            color: "var(--text-soft)"
                        },
                        children: "-"
                    });
                    const locked = lockedObjectIds.has(r.objectId);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: 6,
                            alignItems: "center"
                        },
                        children: [
                            canUpdate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setEditForm({
                                        id: r.id,
                                        objectId: r.objectId ?? "",
                                        eigentuemer_id: r.eigentuemer_id,
                                        anrede: r.anrede ?? "",
                                        titel: r.titel ?? "",
                                        vorname: r.vorname ?? "",
                                        name_1: r.name_1 ?? "",
                                        name_2: r.name_2 ?? "",
                                        name_3: r.name_3 ?? "",
                                        strasse: r.strasse ?? "",
                                        plz: r.plz ?? "",
                                        ort: r.ort ?? "",
                                        land_code: r.land_code ?? "",
                                        land: r.land ?? "",
                                        email: r.email ?? "",
                                        telefon: r.telefon ?? "",
                                        status: r.status === "inaktiv" ? "inaktiv" : "aktiv"
                                    }),
                                disabled: locked,
                                title: locked ? "Gesperrt wegen aktivem Umlaufbeschluss" : undefined,
                                children: "Bearbeiten"
                            }) : null,
                            canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    if (locked) {
                                        setActionError("Eigent\xfcmer ist wegen aktivem Umlaufbeschluss gesperrt.");
                                        return;
                                    }
                                    setDeleteConfirm({
                                        id: r.id,
                                        label: `${r.objektnummer} / ${r.eigentuemer_id}`,
                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                        input: [
                                            "",
                                            "",
                                            "",
                                            ""
                                        ],
                                        error: ""
                                    });
                                },
                                disabled: locked || deleteMutation.isPending,
                                title: locked ? "L\xf6schen bei aktivem Umlaufbeschluss gesperrt" : undefined,
                                children: "L\xf6schen"
                            }) : null,
                            locked && (canUpdate || canDelete) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "lock-indicator",
                                title: "Gesperrt wegen aktivem Umlaufbeschluss",
                                children: "\uD83D\uDD12"
                            }) : null
                        ]
                    });
                }
            }
        ], [
        canDelete,
        canUpdate,
        deleteMutation.isPending,
        lockedObjectIds,
        sortBy,
        sortDir
    ]);
    const canCreateForm = form.eigentuemer_id.trim() && $f252d990203a12d3$var$hasAnyName(form.name_1, form.name_2, form.name_3) && form.status;
    const canEdit = editForm && editForm.eigentuemer_id.trim() && $f252d990203a12d3$var$hasAnyName(editForm.name_1, editForm.name_2, editForm.name_3);
    const rows = data?.data ?? [];
    const totalRows = data?.meta.total ?? 0;
    const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
    const isFrameworkV2 = uiSettings?.management?.uiFramework === "mockup_v2" || typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    const fixedViewportListLayout = isFrameworkV2 && !showCreate && !editForm;
    const pageItems = (0, $acw62.useMemo)(()=>{
        if (totalPages <= 1) return [
            1
        ];
        const start = Math.max(1, page - 1);
        const end = Math.min(totalPages, start + 2);
        const adjustedStart = Math.max(1, end - 2);
        return Array.from({
            length: end - adjustedStart + 1
        }, (_, i)=>adjustedStart + i);
    }, [
        page,
        totalPages
    ]);
    const ownerTitleIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9.1",
                cy: "9.1",
                r: "2.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "15.8",
                cy: "8.4",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    const icons = {
        search: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "9",
                    cy: "9",
                    r: "5.8",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m13.2 13.2 4 4",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round"
                })
            ]
        }),
        reset: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.2 6.3V3.9H2.8M4 4a6.4 6.4 0 1 1-1.4 7.5",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        }),
        object: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6.2 5.2h7.6v9.6H6.2z",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6.2 8.4h7.6M6.2 11.6h7.6M9.4 5.2v9.6M12.6 5.2v9.6",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                })
            ]
        }),
        id: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "7.4",
                    r: "2.5",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5.2 15.9a4.8 4.8 0 0 1 9.6 0",
                    stroke: "currentColor",
                    strokeWidth: "1.7",
                    strokeLinecap: "round"
                })
            ]
        }),
        user: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "9.1",
                    cy: "9.1",
                    r: "2.5",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "15.8",
                    cy: "8.4",
                    r: "2.1",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round"
                })
            ]
        }),
        mail: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "3.8",
                    y: "5.2",
                    width: "12.4",
                    height: "9.6",
                    rx: "1.6",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m4.5 6 5.5 4.1L15.5 6",
                    stroke: "currentColor",
                    strokeWidth: "1.7",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        phone: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.4 3.8 4.8 5.4c-.8.8-.7 2.6.3 4.5 1 1.8 2.8 3.7 4.7 4.8 1.9 1.1 3.7 1.2 4.5.4l1.6-1.6-3-2.4-1.3 1.3c-.3.3-1 .1-1.9-.5-.8-.6-1.7-1.5-2.2-2.3-.6-.9-.8-1.6-.5-1.9l1.3-1.3-1.9-2.6Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        }),
        nonDigital: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "5.4",
                    y: "2.8",
                    width: "9.2",
                    height: "14.4",
                    rx: "1.9",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M8.1 5.8h3.8M7.4 14.1l5.2-5.2",
                    stroke: "currentColor",
                    strokeWidth: "1.7",
                    strokeLinecap: "round"
                })
            ]
        }),
        status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "10",
                    r: "5.9",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                    fill: "currentColor"
                })
            ]
        }),
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "5.3",
                    r: "1.4",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "10",
                    r: "1.4",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "14.7",
                    r: "1.4",
                    fill: "currentColor"
                })
            ]
        })
    };
    const plainHeader = (label, icon)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "resolutions-v2-th-plain",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-icon",
                    "aria-hidden": "true",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-label",
                    children: label
                })
            ]
        });
    const renderSortIndicator = (field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "resolutions-v2-sort-indicator",
            "aria-hidden": "true",
            children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
        });
    const renderV2SortHeader = (field, label, icon)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            className: "resolutions-v2-th-sort",
            onClick: ()=>toggleSort(field),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-icon",
                    "aria-hidden": "true",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-label",
                    children: label
                }),
                renderSortIndicator(field)
            ]
        });
    const resetListFilters = ()=>{
        setSearch("");
        setObjectFilter("");
        setReachability("");
        setStatus("aktiv");
        setSortBy("objektnummer");
        setSortDir("asc");
        setPage(1);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: fixedViewportListLayout ? "resolutions-v2-page" : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `page-header panel ${isFrameworkV2 ? "resolutions-v2-page-header" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: isFrameworkV2 ? "resolutions-v2-title" : "",
                        style: {
                            margin: 0
                        },
                        children: [
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-title-icon",
                                "aria-hidden": "true",
                                children: ownerTitleIcon
                            }) : null,
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "resolutions-v2-title-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-main",
                                        children: "Eigent\xfcmer"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-sub",
                                        children: "\xdcbersicht aller Eigent\xfcmer und Stammdaten"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Eigent\xfcmer"
                            })
                        ]
                    }),
                    canCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: isFrameworkV2 ? "resolutions-v2-create-btn" : "",
                        onClick: ()=>setShowCreate((v)=>!v),
                        children: [
                            isFrameworkV2 && !showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-create-btn-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M10 4.2v11.6M4.2 10h11.6",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round"
                                    })
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: showCreate ? "Schlie\xdfen" : "Neuer Eigent\xfcmer"
                            })
                        ]
                    }) : null
                ]
            }),
            canCreate && showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Eigent\xfcmer anlegen"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Eigent\xfcmer ID*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.eigentuemer_id,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                eigentuemer_id: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Anrede"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.anrede,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                anrede: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Anrede w\xe4hlen"
                                            }),
                                            anredeOptions.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: opt,
                                                    children: opt
                                                }, opt))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Titel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.titel,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                titel: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Titel w\xe4hlen"
                                            }),
                                            titelOptions.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: opt,
                                                    children: opt
                                                }, opt))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Vorname"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.vorname,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                vorname: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Name 1*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.name_1,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                name_1: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Name 2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.name_2,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                name_2: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Name 3"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.name_3,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                name_3: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stra\xdfe / Postfach"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.strasse,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                strasse: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "PLZ"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.plz,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                plz: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Ort"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.ort,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                ort: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "L\xe4nder-Code"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.land_code,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                land_code: e.target.value.toUpperCase()
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Land"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.land,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                land: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "E-Mail"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.email,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                email: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Telefon"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.telefon,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                telefon: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Status*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.status,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                status: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Status w\xe4hlen*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !canCreateForm || createMutation.isPending,
                                onClick: ()=>createMutation.mutate(),
                                children: createMutation.isPending ? "Speichere..." : "Eigent\xfcmer speichern"
                            }),
                            createError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: createError
                            }) : null
                        ]
                    })
                ]
            }) : null,
            !showCreate && canUpdate && editForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Eigent\xfcmer bearbeiten"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Eigent\xfcmer ID*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.eigentuemer_id,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                eigentuemer_id: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Anrede"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.anrede,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                anrede: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Anrede w\xe4hlen"
                                            }),
                                            anredeOptions.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: opt,
                                                    children: opt
                                                }, opt))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Titel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.titel,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                titel: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Titel w\xe4hlen"
                                            }),
                                            titelOptions.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: opt,
                                                    children: opt
                                                }, opt))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Vorname"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.vorname,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                vorname: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Name 1*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.name_1,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                name_1: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Name 2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.name_2,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                name_2: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Name 3"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.name_3,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                name_3: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stra\xdfe / Postfach"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.strasse,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                strasse: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "PLZ"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.plz,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                plz: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Ort"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.ort,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                ort: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "L\xe4nder-Code"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.land_code,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                land_code: e.target.value.toUpperCase()
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Land"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.land,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                land: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "E-Mail"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.email,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                email: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Telefon"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.telefon,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                telefon: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.status,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                status: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !canEdit || editMutation.isPending,
                                onClick: ()=>editMutation.mutate(),
                                children: editMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setEditForm(null),
                                children: "Abbrechen"
                            }),
                            editError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: editError
                            }) : null
                        ]
                    })
                ]
            }) : null,
            !showCreate && isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel",
                children: "Fehler beim Laden der Eigent\xfcmer."
            }) : null,
            !showCreate && actionError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel error-text",
                children: actionError
            }) : null,
            !showCreate ? isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel resolutions-v2-list-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-filterbar",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-filter-fields",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "resolutions-v2-filter-input",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-filter-icon",
                                                "aria-hidden": "true",
                                                children: icons.search
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                placeholder: "Suche...",
                                                value: search,
                                                onChange: (e)=>setSearch(e.target.value)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: objectFilter,
                                        onChange: (e)=>setObjectFilter(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Objekt-Nr"
                                            }),
                                            (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: o.id,
                                                    children: o.objektnummer
                                                }, o.id))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: reachability,
                                        onChange: (e)=>setReachability(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Erreichbarkeiten"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "digital",
                                                children: "Digital"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "analog",
                                                children: "Analog"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: status,
                                        onChange: (e)=>setStatus(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "keine_zuordnung",
                                                children: "Keine Zuordnung"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                className: "resolutions-v2-reset-btn",
                                onClick: resetListFilters,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-reset-btn-icon",
                                        "aria-hidden": "true",
                                        children: icons.reset
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Filter zur\xfccksetzen"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-row-count",
                        children: [
                            "Zeilen: ",
                            rows.length,
                            " / Gesamt: ",
                            totalRows
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "resolutions-v2-table-wrap",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "resolutions-v2-table owners-v2-table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "126px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "184px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "460px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "200px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "156px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "168px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "112px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "92px"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: plainHeader("Objekt-Nr", icons.object)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: renderV2SortHeader("eigentuemer_id", "Eigent\xfcmer-ID", icons.id)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: renderV2SortHeader("vollname", "Eigent\xfcmername", icons.user)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: plainHeader("E-Mail", icons.mail)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: plainHeader("Telefon", icons.phone)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: plainHeader("Erreichbarkeit", icons.nonDigital)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: plainHeader("Status", icons.status)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "resolutions-v2-actions-head",
                                                "aria-label": "Aktionen",
                                                title: "Aktionen",
                                                children: plainHeader("", icons.actions)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: rows.map((r)=>{
                                        const refs = (r.objectRefs ?? []).filter((entry)=>!!entry.id && !!entry.objektnummer);
                                        const fallbackRef = r.objectId && r.objektnummer ? [
                                            {
                                                id: r.objectId,
                                                objektnummer: r.objektnummer,
                                                status: r.status === "aktiv" ? "aktiv" : "inaktiv",
                                                assignmentDetails: []
                                            }
                                        ] : [];
                                        const displayRefs = refs.length > 0 ? refs : fallbackRef;
                                        const locked = lockedObjectIds.has(r.objectId);
                                        const menuId = r.id;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            display: "inline-flex",
                                                            flexWrap: "wrap",
                                                            gap: 6,
                                                            justifyContent: "center"
                                                        },
                                                        children: displayRefs.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                to: `/objects/${entry.id}`,
                                                                className: `badge object-ref ${entry.status === "inaktiv" ? "object-ref-inaktiv" : ""}`,
                                                                style: {
                                                                    textDecoration: "none"
                                                                },
                                                                children: entry.objektnummer
                                                            }, `${r.id}-${entry.id}`))
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: r.eigentuemer_id
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "resolutions-v2-object-cell",
                                                    children: $f252d990203a12d3$var$buildOwnerDisplayName(r)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "resolutions-v2-object-cell",
                                                    children: r.email || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "resolutions-v2-object-cell",
                                                    children: r.telefon || "-"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `badge ${r.ist_analog ? "erreichbar-analog" : "erreichbar-digital"}`,
                                                        children: r.ist_analog ? "analog" : "digital"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `badge ${r.status} quick-tooltip quick-tooltip-subtle quick-tooltip-multiline`,
                                                        "data-tooltip": $f252d990203a12d3$var$buildOwnerValidityTooltip(r, status),
                                                        tabIndex: 0,
                                                        children: $f252d990203a12d3$var$formatOwnerStatusLabel(r.status)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: !canUpdate && !canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: "-"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "resolutions-v2-action-wrap",
                                                        onClick: (e)=>e.stopPropagation(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "resolutions-v2-action-trigger",
                                                                "aria-label": `Aktionen f\xfcr Eigent\xfcmer ${r.eigentuemer_id}`,
                                                                "aria-expanded": openActionMenuId === menuId,
                                                                onMouseDown: (e)=>e.stopPropagation(),
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    if (openActionMenuId === menuId) {
                                                                        setOpenActionMenuId(null);
                                                                        return;
                                                                    }
                                                                    openActionMenuAtTrigger(menuId, e.currentTarget, canUpdate && canDelete ? 96 : 52);
                                                                },
                                                                children: "\u22EE"
                                                            }),
                                                            openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                style: {
                                                                    left: actionMenuPosition.left,
                                                                    top: actionMenuPosition.top
                                                                },
                                                                onMouseDown: (e)=>e.stopPropagation(),
                                                                onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                children: [
                                                                    canUpdate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        disabled: locked,
                                                                        onClick: ()=>{
                                                                            setEditForm({
                                                                                id: r.id,
                                                                                objectId: r.objectId ?? "",
                                                                                eigentuemer_id: r.eigentuemer_id,
                                                                                anrede: r.anrede ?? "",
                                                                                titel: r.titel ?? "",
                                                                                vorname: r.vorname ?? "",
                                                                                name_1: r.name_1 ?? "",
                                                                                name_2: r.name_2 ?? "",
                                                                                name_3: r.name_3 ?? "",
                                                                                strasse: r.strasse ?? "",
                                                                                plz: r.plz ?? "",
                                                                                ort: r.ort ?? "",
                                                                                land_code: r.land_code ?? "",
                                                                                land: r.land ?? "",
                                                                                email: r.email ?? "",
                                                                                telefon: r.telefon ?? "",
                                                                                status: r.status === "inaktiv" ? "inaktiv" : "aktiv"
                                                                            });
                                                                            setOpenActionMenuId(null);
                                                                        },
                                                                        children: "Bearbeiten"
                                                                    }) : null,
                                                                    canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        disabled: locked || deleteMutation.isPending,
                                                                        onClick: ()=>{
                                                                            if (locked) {
                                                                                setActionError("Eigent\xfcmer ist wegen aktivem Umlaufbeschluss gesperrt.");
                                                                                setOpenActionMenuId(null);
                                                                                return;
                                                                            }
                                                                            setDeleteConfirm({
                                                                                id: r.id,
                                                                                label: `${r.objektnummer} / ${r.eigentuemer_id}`,
                                                                                code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                input: [
                                                                                    "",
                                                                                    "",
                                                                                    "",
                                                                                    ""
                                                                                ],
                                                                                error: ""
                                                                            });
                                                                            setOpenActionMenuId(null);
                                                                        },
                                                                        children: "L\xf6schen"
                                                                    }) : null
                                                                ]
                                                            }), document.body) : null
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, r.id);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-pagination",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-page-size",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: String(pageSize),
                                    onChange: (e)=>setPageSize(Number(e.target.value) || 10),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "10",
                                            children: "10 pro Seite"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "20",
                                            children: "20 pro Seite"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "50",
                                            children: "50 pro Seite"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-page-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "resolutions-v2-page-arrow",
                                        onClick: ()=>setPage((prev)=>Math.max(1, prev - 1)),
                                        disabled: page <= 1,
                                        children: "\u2039"
                                    }),
                                    pageItems.map((pageItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: `resolutions-v2-page-chip ${pageItem === page ? "active" : ""}`,
                                            onClick: ()=>setPage(pageItem),
                                            children: pageItem
                                        }, pageItem)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "resolutions-v2-page-arrow",
                                        onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                        disabled: page >= totalPages,
                                        children: "\u203A"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "resolutions-v2-page-info",
                                        children: [
                                            "Seite ",
                                            page,
                                            " von ",
                                            totalPages
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-page-next-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    className: "resolutions-v2-next-btn",
                                    onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                    disabled: page >= totalPages,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Weiter"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            children: "\u203A"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                columns: columns,
                rows: rows,
                total: totalRows,
                page: page,
                pageSize: pageSize,
                onPageChange: setPage,
                bodyMaxHeight: 560,
                topContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "filterbar",
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            placeholder: "Suche",
                            value: search,
                            onChange: (e)=>setSearch(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: objectFilter,
                            onChange: (e)=>setObjectFilter(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Alle Objekt-Nr"
                                }),
                                (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: o.id,
                                        children: o.objektnummer
                                    }, o.id))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: reachability,
                            onChange: (e)=>setReachability(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Alle Erreichbarkeiten"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "digital",
                                    children: "Digital"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "analog",
                                    children: "Analog"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: status,
                            onChange: (e)=>setStatus(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Alle Status"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "aktiv",
                                    children: "Aktiv"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "inaktiv",
                                    children: "Inaktiv"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "keine_zuordnung",
                                    children: "Keine Zuordnung"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                open: !!deleteConfirm,
                message: deleteConfirm ? `Eigent\xfcmer ${deleteConfirm.label} soll gel\xf6scht werden.` : "",
                code: deleteConfirm?.code ?? "",
                input: deleteConfirm?.input ?? [
                    "",
                    "",
                    "",
                    ""
                ],
                error: deleteConfirm?.error,
                isPending: deleteMutation.isPending,
                onClose: ()=>setDeleteConfirm(null),
                onInputChange: (next)=>{
                    if (!deleteConfirm) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        input: next
                    });
                },
                onErrorReset: ()=>{
                    if (!deleteConfirm || !deleteConfirm.error) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        error: ""
                    });
                },
                onConfirm: ()=>{
                    if (!deleteConfirm) return;
                    const enteredCode = deleteConfirm.input.join("");
                    if (enteredCode !== deleteConfirm.code) {
                        setDeleteConfirm({
                            ...deleteConfirm,
                            error: "Sicherheitscode falsch eingegeben."
                        });
                        return;
                    }
                    deleteMutation.mutate(deleteConfirm.id);
                }
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");






const $5dea51850bf332cc$var$formatDateDE = (value)=>{
    if (!value) return "-";
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? `${m[3]}.${m[2]}.${m[1]}` : value;
};
const $5dea51850bf332cc$var$formatOwnerDisplayName = (owner)=>{
    if (!owner) return "-";
    const parts = [
        owner.anrede,
        owner.titel,
        owner.vorname,
        owner.name_1,
        owner.name_2,
        owner.name_3
    ].map((part)=>(part ?? "").trim()).filter(Boolean);
    if (parts.length > 0) return parts.join(" ");
    return owner.vollname?.trim() || "-";
};
const $5dea51850bf332cc$var$buildAssignmentValidityTooltip = (assignment)=>`EGT ab: ${$5dea51850bf332cc$var$formatDateDE(assignment.gueltig_ab)} | EGT bis: ${$5dea51850bf332cc$var$formatDateDE(assignment.gueltig_bis)}`;
const $5dea51850bf332cc$export$3d409ad957894c8e = ({ canCreate: canCreate = false, canUpdate: canUpdate = false, canDelete: canDelete = false })=>{
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [pageSize, setPageSize] = (0, $acw62.useState)(10);
    const [page, setPage] = (0, $acw62.useState)(1);
    const [search, setSearch] = (0, $acw62.useState)("");
    const [objectFilter, setObjectFilter] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)("aktiv");
    const [recipientType, setRecipientType] = (0, $acw62.useState)("");
    const [sortBy, setSortBy] = (0, $acw62.useState)("objektnummer");
    const [sortDir, setSortDir] = (0, $acw62.useState)("asc");
    const [showCreate, setShowCreate] = (0, $acw62.useState)(false);
    const [openActionMenuId, setOpenActionMenuId] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const [createError, setCreateError] = (0, $acw62.useState)("");
    const [editError, setEditError] = (0, $acw62.useState)("");
    const [actionError, setActionError] = (0, $acw62.useState)("");
    const [ownerSearchCreate, setOwnerSearchCreate] = (0, $acw62.useState)("");
    const [ownerSearchEdit, setOwnerSearchEdit] = (0, $acw62.useState)("");
    const [createOnlyUnassigned, setCreateOnlyUnassigned] = (0, $acw62.useState)(false);
    const [editOnlyUnassigned, setEditOnlyUnassigned] = (0, $acw62.useState)(false);
    const [deleteConfirm, setDeleteConfirm] = (0, $acw62.useState)(null);
    const [ownershipChange, setOwnershipChange] = (0, $acw62.useState)(null);
    const [form, setForm] = (0, $acw62.useState)({
        objectId: "",
        unitId: "",
        ownerId: "",
        status: "",
        gueltig_ab: "",
        gueltig_bis: ""
    });
    const [editForm, setEditForm] = (0, $acw62.useState)(null);
    const { data: data, isError: isError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "assignments",
            page,
            pageSize,
            search,
            objectFilter,
            status,
            recipientType,
            sortBy,
            sortDir
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).assignments({
                page: page,
                pageSize: pageSize,
                search: search,
                objectId: objectFilter || undefined,
                status: status || undefined,
                recipientType: recipientType || undefined,
                sortBy: sortBy,
                sortDir: sortDir
            }),
        placeholderData: (previousData)=>previousData,
        staleTime: 15000
    });
    const { data: objectsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "objects-select"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).objects({
                page: 1,
                pageSize: 200,
                sortBy: "objektnummer",
                sortDir: "asc"
            })
    });
    const { data: activeResolutions } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "active-resolutions-lock"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: 1,
                pageSize: 500,
                status: "aktiv"
            })
    });
    const { data: uiSettings } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-assignments"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings(),
        staleTime: 60000
    });
    const lockedObjectIds = (0, $acw62.useMemo)(()=>new Set((activeResolutions?.data ?? []).map((r)=>r.objectId)), [
        activeResolutions?.data
    ]);
    const { data: unitsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "units-select",
            form.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: 1,
                pageSize: 200,
                objectId: form.objectId,
                status: "aktiv"
            }),
        enabled: !!form.objectId
    });
    const { data: ownersData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "owners-select",
            form.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                page: 1,
                pageSize: 2000,
                objectId: form.objectId,
                status: "aktiv"
            }),
        enabled: !!form.objectId
    });
    const { data: editUnitsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "units-select-edit",
            editForm?.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: 1,
                pageSize: 200,
                objectId: editForm.objectId,
                status: "aktiv"
            }),
        enabled: !!editForm?.objectId
    });
    const { data: editOwnersData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "owners-select-edit",
            editForm?.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                page: 1,
                pageSize: 2000,
                objectId: editForm.objectId,
                status: "aktiv"
            }),
        enabled: !!editForm?.objectId
    });
    const { data: ownerAssignmentsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "owners-assignment-overview"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).assignments({
                page: 1,
                pageSize: 5000,
                status: "aktiv"
            })
    });
    const { data: ownersLookupData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "owners-lookup-all"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                page: 1,
                pageSize: 5000
            })
    });
    const assignmentRefsByOwner = (0, $acw62.useMemo)(()=>{
        const map = new Map();
        for (const assignment of ownerAssignmentsData?.data ?? []){
            const list = map.get(assignment.ownerId) ?? [];
            list.push(`${assignment.objektnummer}/${assignment.einheitsnummer}`);
            map.set(assignment.ownerId, list);
        }
        return map;
    }, [
        ownerAssignmentsData?.data
    ]);
    const filteredCreateOwners = (0, $acw62.useMemo)(()=>{
        const rows = ownersData?.data ?? [];
        const needle = ownerSearchCreate.trim().toLowerCase();
        const searched = !needle ? rows : rows.filter((owner)=>`${owner.eigentuemer_id} ${owner.vollname} ${owner.email ?? ""}`.toLowerCase().includes(needle));
        if (!createOnlyUnassigned) return searched;
        return searched.filter((owner)=>(assignmentRefsByOwner.get(owner.id) ?? []).length === 0);
    }, [
        ownersData?.data,
        ownerSearchCreate,
        createOnlyUnassigned,
        assignmentRefsByOwner
    ]);
    const filteredEditOwners = (0, $acw62.useMemo)(()=>{
        const rows = editOwnersData?.data ?? [];
        const needle = ownerSearchEdit.trim().toLowerCase();
        const searched = !needle ? rows : rows.filter((owner)=>`${owner.eigentuemer_id} ${owner.vollname} ${owner.email ?? ""}`.toLowerCase().includes(needle));
        if (!editOnlyUnassigned) return searched;
        return searched.filter((owner)=>(assignmentRefsByOwner.get(owner.id) ?? []).length === 0);
    }, [
        editOwnersData?.data,
        ownerSearchEdit,
        editOnlyUnassigned,
        assignmentRefsByOwner
    ]);
    const createMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (payload)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).createAssignment(payload),
        onSuccess: async ()=>{
            setCreateError("");
            setShowCreate(false);
            setOwnershipChange(null);
            setOwnerSearchCreate("");
            setForm({
                objectId: "",
                unitId: "",
                ownerId: "",
                status: "",
                gueltig_ab: "",
                gueltig_bis: ""
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "assignments"
                ]
            });
            setPage(1);
        },
        onError: (error)=>setCreateError(error instanceof Error ? error.message : "Anlage fehlgeschlagen")
    });
    const editMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!editForm) throw new Error("Kein Datensatz ausgew\xe4hlt");
            if (lockedObjectIds.has(editForm.objectId)) throw new Error("Zuordnung ist wegen aktivem Umlaufbeschluss gesperrt");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateAssignment(editForm.id, {
                objectId: editForm.objectId,
                unitId: editForm.unitId,
                ownerId: editForm.ownerId,
                status: editForm.status,
                gueltig_ab: editForm.gueltig_ab || undefined,
                gueltig_bis: editForm.gueltig_bis || undefined
            });
        },
        onSuccess: async ()=>{
            setEditError("");
            setEditForm(null);
            setOwnerSearchEdit("");
            await queryClient.invalidateQueries({
                queryKey: [
                    "assignments"
                ]
            });
        },
        onError: (error)=>setEditError(error instanceof Error ? error.message : "Bearbeitung fehlgeschlagen")
    });
    const deleteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).deleteAssignment(id),
        onSuccess: async ()=>{
            setDeleteConfirm(null);
            setActionError("");
            await queryClient.invalidateQueries({
                queryKey: [
                    "assignments"
                ]
            });
        },
        onError: (error)=>setActionError(error instanceof Error ? error.message : "L\xf6schen fehlgeschlagen")
    });
    (0, $acw62.useEffect)(()=>{
        setPage(1);
    }, [
        search,
        objectFilter,
        status,
        recipientType,
        sortBy,
        sortDir,
        pageSize
    ]);
    (0, $acw62.useEffect)(()=>{
        setOpenActionMenuId(null);
    }, [
        page,
        search,
        objectFilter,
        status,
        recipientType,
        sortBy,
        sortDir,
        showCreate,
        editForm
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = (event)=>{
            if (event && (0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            setOpenActionMenuId(null);
        };
        const handleEscape = (event)=>{
            if (event.key === "Escape") closeMenu();
        };
        window.addEventListener("mousedown", closeMenu);
        window.addEventListener("keydown", handleEscape);
        return ()=>{
            window.removeEventListener("mousedown", closeMenu);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!openActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>setOpenActionMenuId(null),
        timeoutMs: 3000
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) setIsActionMenuHovered(false);
    }, [
        openActionMenuId
    ]);
    const { actionMenuPosition: actionMenuPosition, openActionMenuAtTrigger: openActionMenuAtTrigger } = (0, $acf0971746b2c487$export$847509c5c6223f45)({
        openMenuId: openActionMenuId,
        setOpenMenuId: setOpenActionMenuId
    });
    const objectIdByObjektnummer = (0, $acw62.useMemo)(()=>new Map((objectsData?.data ?? []).map((o)=>[
                o.objektnummer,
                o.id
            ])), [
        objectsData?.data
    ]);
    const ownerDisplayById = (0, $acw62.useMemo)(()=>{
        const map = new Map();
        for (const owner of ownersLookupData?.data ?? [])map.set(owner.id, $5dea51850bf332cc$var$formatOwnerDisplayName(owner));
        return map;
    }, [
        ownersLookupData?.data
    ]);
    const formatEinheitsnummer = (value)=>{
        const trimmed = String(value ?? "").trim();
        if (!trimmed) return "";
        return /^\d+$/.test(trimmed) ? trimmed.padStart(4, "0") : trimmed;
    };
    const formatAssignmentNumber = (value)=>{
        const numeric = Number(value);
        return Number.isFinite(numeric) && numeric > 0 ? new Intl.NumberFormat("de-DE").format(numeric) : "-";
    };
    const formatAssignmentMea = (value)=>{
        const numeric = Number(value);
        return Number.isFinite(numeric) && numeric > 0 ? new Intl.NumberFormat("de-DE", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(numeric) : "-";
    };
    const toggleSort = (field)=>{
        if (sortBy === field) {
            setSortDir((prev)=>prev === "asc" ? "desc" : "asc");
            return;
        }
        setSortBy(field);
        setSortDir("asc");
    };
    const sortLabel = (field, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: ()=>toggleSort(field),
            style: {
                border: "none",
                background: "transparent",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                font: "inherit",
                color: "inherit",
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                gap: 6
            },
            title: sortBy === field ? `Sortierung: ${sortDir === "asc" ? "aufsteigend" : "absteigend"}` : "Sortierung aktivieren",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
                })
            ]
        });
    const columns = (0, $acw62.useMemo)(()=>[
            {
                key: "objektnummer",
                label: sortLabel("objektnummer", "Objekt\u2011Nr"),
                width: 92,
                align: "center",
                render: (r)=>{
                    const objectId = objectIdByObjektnummer.get(r.objektnummer);
                    return objectId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: `/objects/${objectId}`,
                        className: "badge object-ref",
                        style: {
                            textDecoration: "none"
                        },
                        children: r.objektnummer
                    }) : r.objektnummer;
                }
            },
            {
                key: "einheitsnummer",
                label: sortLabel("einheitsnummer", "Einheit\u2011Nr."),
                width: 96,
                align: "center",
                render: (r)=>formatEinheitsnummer(r.einheitsnummer)
            },
            {
                key: "eigentuemer_id",
                label: sortLabel("eigentuemer_id", "Eigent\xfcmer ID"),
                width: 184,
                align: "center"
            },
            {
                key: "eigentuemername",
                label: "Eigent\xfcmername",
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            ownerDisplayById.get(r.ownerId) ?? r.eigentuemername ?? "-",
                            r.isAuthorizedOwnerRecipient ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "badge",
                                style: {
                                    marginLeft: 8
                                },
                                children: "Zustellungsbevollm\xe4chtigt"
                            }) : null
                        ]
                    })
            },
            {
                key: "eigentuemer_email",
                label: "E-Mail",
                width: 220,
                render: (r)=>r.eigentuemer_email || "-"
            },
            {
                key: "einheit_stimmrecht",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Stimmrecht",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Einheit"
                    ]
                }),
                width: 126,
                align: "center",
                render: (r)=>formatAssignmentNumber(r.einheit_stimmrecht)
            },
            {
                key: "einheit_mea",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "MEA",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Einheit"
                    ]
                }),
                width: 126,
                align: "center",
                render: (r)=>formatAssignmentMea(r.einheit_mea)
            },
            {
                key: "status",
                label: "Status",
                width: 112,
                align: "center",
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge ${r.status} quick-tooltip`,
                        "data-tooltip": $5dea51850bf332cc$var$buildAssignmentValidityTooltip(r),
                        title: $5dea51850bf332cc$var$buildAssignmentValidityTooltip(r),
                        tabIndex: 0,
                        children: r.status
                    })
            },
            {
                key: "actions",
                label: "Aktionen",
                render: (r)=>{
                    if (!canUpdate && !canDelete) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            color: "var(--text-soft)"
                        },
                        children: "-"
                    });
                    const locked = lockedObjectIds.has(r.objectId);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: 6,
                            alignItems: "center"
                        },
                        children: [
                            canUpdate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    setEditForm({
                                        id: r.id,
                                        objectId: r.objectId,
                                        unitId: r.unitId,
                                        ownerId: r.ownerId,
                                        status: r.status,
                                        gueltig_ab: r.gueltig_ab ?? "",
                                        gueltig_bis: r.gueltig_bis ?? ""
                                    });
                                    setOwnerSearchEdit(`${r.eigentuemer_id} ${r.eigentuemername ?? ""}`.trim());
                                },
                                disabled: locked,
                                title: locked ? "Gesperrt wegen aktivem Umlaufbeschluss" : undefined,
                                children: "Bearbeiten"
                            }) : null,
                            canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    if (locked) {
                                        setActionError("Zuordnung ist wegen aktivem Umlaufbeschluss gesperrt.");
                                        return;
                                    }
                                    const activeAssignmentsForUnit = (ownerAssignmentsData?.data ?? []).filter((a)=>a.objectId === r.objectId && a.unitId === r.unitId && a.status === "aktiv" && a.id !== r.id);
                                    const removesLastActiveAssignment = r.status === "aktiv" && activeAssignmentsForUnit.length === 0;
                                    setDeleteConfirm({
                                        id: r.id,
                                        label: `${r.objektnummer} / ${r.einheitsnummer} / ${r.eigentuemer_id}`,
                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                        input: [
                                            "",
                                            "",
                                            "",
                                            ""
                                        ],
                                        error: "",
                                        warning: removesLastActiveAssignment ? "Achtung: Nach dem L\xf6schen bleibt auf dieser Einheit keine aktive Eigent\xfcmerzuordnung mehr bestehen." : undefined
                                    });
                                },
                                disabled: locked || deleteMutation.isPending,
                                title: locked ? "L\xf6schen bei aktivem Umlaufbeschluss gesperrt" : undefined,
                                children: "L\xf6schen"
                            }) : null,
                            locked && (canUpdate || canDelete) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "lock-indicator",
                                title: "Gesperrt wegen aktivem Umlaufbeschluss",
                                children: "\uD83D\uDD12"
                            }) : null
                        ]
                    });
                }
            }
        ], [
        canDelete,
        canUpdate,
        deleteMutation.isPending,
        lockedObjectIds,
        objectIdByObjektnummer,
        ownerDisplayById,
        sortBy,
        sortDir
    ]);
    const canCreateForm = form.objectId && form.unitId && form.ownerId && form.status;
    const canEdit = editForm && editForm.objectId && editForm.unitId && editForm.ownerId && editForm.status;
    const hideAssignmentsList = showCreate || !!editForm;
    const rows = data?.data ?? [];
    const totalRows = data?.meta.total ?? 0;
    const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
    const isFrameworkV2 = uiSettings?.management?.uiFramework === "mockup_v2" || typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    const fixedViewportListLayout = isFrameworkV2 && !hideAssignmentsList;
    const pageItems = (0, $acw62.useMemo)(()=>{
        if (totalPages <= 1) return [
            1
        ];
        const start = Math.max(1, page - 1);
        const end = Math.min(totalPages, start + 2);
        const adjustedStart = Math.max(1, end - 2);
        return Array.from({
            length: end - adjustedStart + 1
        }, (_, i)=>adjustedStart + i);
    }, [
        page,
        totalPages
    ]);
    const assignmentTitleIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "6.2",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "16.8",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.4 7.2h7.2M7.9 8.8l7.4 6.4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    const icons = {
        search: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "9",
                    cy: "9",
                    r: "5.8",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m13.2 13.2 4 4",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round"
                })
            ]
        }),
        reset: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.2 6.3V3.9H2.8M4 4a6.4 6.4 0 1 1-1.4 7.5",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        }),
        object: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6.2 5.2h7.6v9.6H6.2z",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6.2 8.4h7.6M6.2 11.6h7.6M9.4 5.2v9.6M12.6 5.2v9.6",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                })
            ]
        }),
        unit: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "5.1",
                    y: "4.8",
                    width: "13.8",
                    height: "14.8",
                    rx: "2.1",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M9.2 19.6v-2.9h5.6v2.9",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        owner: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "7.4",
                    r: "2.5",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5.2 15.9a4.8 4.8 0 0 1 9.6 0",
                    stroke: "currentColor",
                    strokeWidth: "1.7",
                    strokeLinecap: "round"
                })
            ]
        }),
        ownersGroup: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "9.1",
                    cy: "9.1",
                    r: "2.5",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "15.8",
                    cy: "8.4",
                    r: "2.1",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round"
                })
            ]
        }),
        email: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "3.4",
                    y: "5.1",
                    width: "13.2",
                    height: "9.8",
                    rx: "1.8",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m4.8 6.7 5.2 4.1 5.2-4.1",
                    stroke: "currentColor",
                    strokeWidth: "1.7",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        votes: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.1 15.9h11.8M5.6 15.9V9.4M10 15.9V6.7M14.4 15.9V4.1",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        }),
        mea: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M10 3.7 15.3 6.8v6.4L10 16.3l-5.3-3.1V6.8L10 3.7Z",
                    stroke: "currentColor",
                    strokeWidth: "1.7",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M10 3.7v12.6M4.7 6.8 10 10l5.3-3.2",
                    stroke: "currentColor",
                    strokeWidth: "1.7",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "10",
                    r: "5.9",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                    fill: "currentColor"
                })
            ]
        }),
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 20 20",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "5.3",
                    r: "1.4",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "10",
                    r: "1.4",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "10",
                    cy: "14.7",
                    r: "1.4",
                    fill: "currentColor"
                })
            ]
        })
    };
    const plainHeader = (label, icon)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "resolutions-v2-th-plain",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-icon",
                    "aria-hidden": "true",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-label",
                    children: label
                })
            ]
        });
    const renderSortIndicator = (field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "resolutions-v2-sort-indicator",
            "aria-hidden": "true",
            children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
        });
    const renderV2SortHeader = (field, label, icon)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            className: "resolutions-v2-th-sort",
            onClick: ()=>toggleSort(field),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-icon",
                    "aria-hidden": "true",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-label",
                    children: label
                }),
                renderSortIndicator(field)
            ]
        });
    const resetListFilters = ()=>{
        setSearch("");
        setObjectFilter("");
        setStatus("aktiv");
        setRecipientType("");
        setSortBy("objektnummer");
        setSortDir("asc");
        setPage(1);
    };
    const handleCreate = ()=>{
        const payload = {
            objectId: form.objectId,
            unitId: form.unitId,
            ownerId: form.ownerId,
            status: form.status,
            gueltig_ab: form.gueltig_ab || undefined,
            gueltig_bis: form.gueltig_bis || undefined
        };
        if (payload.status === "aktiv") {
            const activeForUnit = (ownerAssignmentsData?.data ?? []).find((a)=>a.objectId === payload.objectId && a.unitId === payload.unitId && a.status === "aktiv" && a.ownerId !== payload.ownerId);
            if (activeForUnit) {
                setOwnershipChange({
                    existing: activeForUnit,
                    vorgaengerGueltigBis: ""
                });
                setCreateError("");
                return;
            }
        }
        createMutation.mutate(payload);
    };
    const renderOwnerSearchList = (rows, selectedOwnerId, onSelectOwner, disabled)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: "grid",
                gap: 6
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontSize: 12,
                        fontWeight: 600,
                        color: "var(--text-soft)"
                    },
                    children: "Suchergebnisse"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        border: "1px solid var(--line)",
                        borderRadius: 6,
                        minHeight: 140,
                        maxHeight: 260,
                        overflowY: "auto",
                        overflowX: "hidden",
                        background: "#fff"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        style: {
                            tableLayout: "fixed",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "11%"
                                            },
                                            children: "Eigent\xfcmer-ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "9%"
                                            },
                                            children: "Anrede"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "11%"
                                            },
                                            children: "Vorname"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "12%"
                                            },
                                            children: "Name 1"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "12%"
                                            },
                                            children: "Name 2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "12%"
                                            },
                                            children: "Name 3"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "16%"
                                            },
                                            children: "E-Mail"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            style: {
                                                width: "17%"
                                            },
                                            children: "Zuordnungen"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: rows.length ? rows.map((owner)=>{
                                    const selected = selectedOwnerId === owner.id;
                                    const refs = assignmentRefsByOwner.get(owner.id) ?? [];
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        onClick: ()=>!disabled && onSelectOwner(owner.id),
                                        "aria-selected": selected,
                                        style: {
                                            cursor: disabled ? "not-allowed" : "pointer",
                                            opacity: disabled ? 0.65 : 1,
                                            background: selected ? "#e8f1ff" : undefined,
                                            boxShadow: selected ? "inset 0 0 0 2px #2f6fed" : undefined,
                                            fontWeight: selected ? 600 : 400
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: selected ? `Ausgew\xe4hlt: ${owner.eigentuemer_id}` : owner.eigentuemer_id
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.anrede || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.vorname || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.name_1 || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.name_2 || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.name_3 || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: owner.email || "-"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    color: "var(--text-soft)",
                                                    whiteSpace: "normal",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: refs.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: 4
                                                    },
                                                    children: [
                                                        refs.slice(0, 3).map((ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                style: {
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    padding: "2px 8px",
                                                                    borderRadius: 999,
                                                                    border: "1px solid #c9d1da",
                                                                    background: "#f2f4f7",
                                                                    color: "#344054",
                                                                    fontSize: 12,
                                                                    lineHeight: 1.2
                                                                },
                                                                children: ref
                                                            }, `${owner.id}-${ref}`)),
                                                        refs.length > 3 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            style: {
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                padding: "2px 8px",
                                                                borderRadius: 999,
                                                                border: "1px solid #c9d1da",
                                                                background: "#f2f4f7",
                                                                color: "#344054",
                                                                fontSize: 12,
                                                                lineHeight: 1.2
                                                            },
                                                            children: [
                                                                "+",
                                                                refs.length - 3
                                                            ]
                                                        }) : null
                                                    ]
                                                }) : "-"
                                            })
                                        ]
                                    }, owner.id);
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: 8,
                                        style: {
                                            color: "var(--text-soft)"
                                        },
                                        children: "Keine passenden Eigent\xfcmer gefunden."
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: fixedViewportListLayout ? "resolutions-v2-page" : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `page-header panel ${isFrameworkV2 ? "resolutions-v2-page-header" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: isFrameworkV2 ? "resolutions-v2-title" : "",
                        style: {
                            margin: 0
                        },
                        children: [
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-title-icon",
                                "aria-hidden": "true",
                                children: assignmentTitleIcon
                            }) : null,
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "resolutions-v2-title-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-main",
                                        children: "Zuordnungen"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-sub",
                                        children: "\xdcbersicht aller Eigent\xfcmer-Zuordnungen"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Zuordnungen"
                            })
                        ]
                    }),
                    canCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: isFrameworkV2 ? "resolutions-v2-create-btn" : "",
                        onClick: ()=>setShowCreate((v)=>!v),
                        children: [
                            isFrameworkV2 && !showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-create-btn-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M10 4.2v11.6M4.2 10h11.6",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round"
                                    })
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: showCreate ? "Schlie\xdfen" : "Neue Zuordnung"
                            })
                        ]
                    }) : null
                ]
            }),
            canCreate && showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Zuordnung anlegen"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "minmax(260px, 1.6fr) minmax(180px, 1fr) minmax(180px, 1fr) minmax(140px, 0.7fr) minmax(140px, 0.8fr) minmax(140px, 0.8fr)",
                            gap: 10,
                            alignItems: "start"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Eigent\xfcmer*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Eigent\xfcmer suchen (ID, Name, E-Mail)",
                                        value: ownerSearchCreate,
                                        onChange: (e)=>setOwnerSearchCreate(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        style: {
                                            marginTop: 6,
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 8,
                                            fontWeight: 500
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: createOnlyUnassigned,
                                                onChange: (e)=>setCreateOnlyUnassigned(e.target.checked)
                                            }),
                                            "Nur ohne Zuordnung"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Objekt*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.objectId,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                objectId: e.target.value,
                                                unitId: ""
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Objekt w\xe4hlen*"
                                            }),
                                            (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: o.id,
                                                    children: `${o.objektnummer} - ${o.objektname}${lockedObjectIds.has(o.id) ? " (gesperrt)" : ""}`
                                                }, o.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Einheit*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.unitId,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                unitId: e.target.value
                                            }),
                                        disabled: !form.objectId,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Einheit w\xe4hlen*"
                                            }),
                                            (unitsData?.data ?? []).map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: u.id,
                                                    children: `${u.einheitsnummer} - ${u.bezeichnung}`
                                                }, u.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Status*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: form.status,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                status: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Status w\xe4hlen*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Eigent\xfcmer ab"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "date",
                                        value: form.gueltig_ab,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                gueltig_ab: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Eigent\xfcmer bis"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "date",
                                        value: form.gueltig_bis,
                                        onChange: (e)=>setForm({
                                                ...form,
                                                gueltig_bis: e.target.value
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginTop: 10
                        },
                        children: [
                            renderOwnerSearchList(filteredCreateOwners, form.ownerId, (ownerId)=>setForm({
                                    ...form,
                                    ownerId: ownerId
                                }), false),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                style: {
                                    color: "var(--text-soft)"
                                },
                                children: [
                                    filteredCreateOwners.length,
                                    " Treffer"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !canCreateForm || createMutation.isPending || lockedObjectIds.has(form.objectId),
                                title: lockedObjectIds.has(form.objectId) ? "Gesperrt wegen aktivem Umlaufbeschluss" : undefined,
                                onClick: handleCreate,
                                children: createMutation.isPending ? "Speichere..." : "Zuordnung speichern"
                            }),
                            createError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: createError
                            }) : null
                        ]
                    })
                ]
            }) : null,
            ownershipChange ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Kollision erkannt: Eigentumswechsel?"
                    }),
                    (()=>{
                        const collisionOwner = (ownersData?.data ?? []).find((owner)=>owner.id === ownershipChange.existing.ownerId) ?? null;
                        const collisionOwnerName = collisionOwner ? $5dea51850bf332cc$var$formatOwnerDisplayName(collisionOwner) : ownershipChange.existing.eigentuemername || ownershipChange.existing.eigentuemer_id;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            style: {
                                marginTop: 0
                            },
                            children: [
                                "F\xfcr diese Einheit existiert bereits eine aktive Zuordnung (",
                                ownershipChange.existing.objektnummer,
                                "/",
                                ownershipChange.existing.einheitsnummer,
                                " an ",
                                collisionOwnerName,
                                "). Wenn es ein Eigentumswechsel ist, wird der bisherige Eigent\xfcmer auf inaktiv gesetzt. Optional k\xf6nnen Sie ein Bis-Datum angeben; dann startet die neue Zuordnung automatisch am Folgetag."
                            ]
                        });
                    })(),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-field",
                        style: {
                            maxWidth: 260
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Bisheriger Eigent\xfcmer bis (optional)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "date",
                                value: ownershipChange.vorgaengerGueltigBis,
                                onChange: (e)=>setOwnershipChange({
                                        ...ownershipChange,
                                        vorgaengerGueltigBis: e.target.value
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    createMutation.mutate({
                                        objectId: form.objectId,
                                        unitId: form.unitId,
                                        ownerId: form.ownerId,
                                        status: form.status,
                                        gueltig_ab: form.gueltig_ab || undefined,
                                        gueltig_bis: form.gueltig_bis || undefined,
                                        uebernahme_von_assignment_id: ownershipChange.existing.id,
                                        vorgaenger_gueltig_bis: ownershipChange.vorgaengerGueltigBis || undefined
                                    });
                                },
                                disabled: createMutation.isPending,
                                children: createMutation.isPending ? "\xdcbernehme..." : "Ja, Eigentumswechsel durchf\xfchren"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    setOwnershipChange(null);
                                },
                                disabled: createMutation.isPending,
                                children: "Abbrechen"
                            })
                        ]
                    })
                ]
            }) : null,
            canUpdate && editForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Zuordnung bearbeiten"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "minmax(260px, 1.6fr) minmax(180px, 1fr) minmax(180px, 1fr) minmax(140px, 0.7fr) minmax(140px, 0.8fr) minmax(140px, 0.8fr)",
                            gap: 10,
                            alignItems: "start"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Eigent\xfcmer*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Eigent\xfcmer suchen (ID, Name, E-Mail)",
                                        value: ownerSearchEdit,
                                        onChange: (e)=>setOwnerSearchEdit(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        style: {
                                            marginTop: 6,
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 8,
                                            fontWeight: 500
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: editOnlyUnassigned,
                                                onChange: (e)=>setEditOnlyUnassigned(e.target.checked)
                                            }),
                                            "Nur ohne Zuordnung"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Objekt*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.objectId,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                objectId: e.target.value,
                                                unitId: ""
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Objekt w\xe4hlen*"
                                            }),
                                            (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: o.id,
                                                    children: `${o.objektnummer} - ${o.objektname}${lockedObjectIds.has(o.id) ? " (gesperrt)" : ""}`
                                                }, o.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Einheit*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.unitId,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                unitId: e.target.value
                                            }),
                                        disabled: !editForm.objectId,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Einheit w\xe4hlen*"
                                            }),
                                            (editUnitsData?.data ?? []).map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: u.id,
                                                    children: `${u.einheitsnummer} - ${u.bezeichnung}`
                                                }, u.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Status*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.status,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                status: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Status w\xe4hlen*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "Aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "Inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Eigent\xfcmer ab"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "date",
                                        value: editForm.gueltig_ab,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                gueltig_ab: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Eigent\xfcmer bis"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "date",
                                        value: editForm.gueltig_bis,
                                        onChange: (e)=>setEditForm({
                                                ...editForm,
                                                gueltig_bis: e.target.value
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginTop: 10
                        },
                        children: [
                            renderOwnerSearchList(filteredEditOwners, editForm.ownerId, (ownerId)=>{
                                setEditForm({
                                    ...editForm,
                                    ownerId: ownerId
                                });
                                const selectedOwner = (editOwnersData?.data ?? []).find((owner)=>owner.id === ownerId);
                                if (selectedOwner) setOwnerSearchEdit(`${selectedOwner.eigentuemer_id} ${selectedOwner.vollname ?? ""}`.trim());
                            }, false),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                style: {
                                    color: "var(--text-soft)"
                                },
                                children: [
                                    filteredEditOwners.length,
                                    " Treffer"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !canEdit || editMutation.isPending || (editForm ? lockedObjectIds.has(editForm.objectId) : false),
                                title: editForm && lockedObjectIds.has(editForm.objectId) ? "Gesperrt wegen aktivem Umlaufbeschluss" : undefined,
                                onClick: ()=>editMutation.mutate(),
                                children: editMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setEditForm(null),
                                children: "Abbrechen"
                            }),
                            editError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: editError
                            }) : null
                        ]
                    })
                ]
            }) : null,
            !hideAssignmentsList ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "panel",
                        children: "Fehler beim Laden der Zuordnungen."
                    }) : null,
                    actionError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "panel error-text",
                        children: actionError
                    }) : null,
                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel resolutions-v2-list-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-filterbar",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolutions-v2-filter-fields",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "resolutions-v2-filter-input",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-filter-icon",
                                                        "aria-hidden": "true",
                                                        children: icons.search
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        placeholder: "Suche...",
                                                        value: search,
                                                        onChange: (e)=>setSearch(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: objectFilter,
                                                onChange: (e)=>setObjectFilter(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Alle Objekt-Nr"
                                                    }),
                                                    (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: o.id,
                                                            children: o.objektnummer
                                                        }, o.id))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: status,
                                                onChange: (e)=>setStatus(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Alle Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "Aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "Inaktiv"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: recipientType,
                                                onChange: (e)=>setRecipientType(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Alle"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "owner",
                                                        children: "Eigent\xfcmer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "authorized",
                                                        children: "Zustellungsbevollm\xe4chtigt"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "resolutions-v2-reset-btn",
                                        onClick: resetListFilters,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "resolutions-v2-reset-btn-icon",
                                                "aria-hidden": "true",
                                                children: icons.reset
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Filter zur\xfccksetzen"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-row-count",
                                children: [
                                    "Zeilen: ",
                                    rows.length,
                                    " / Gesamt: ",
                                    totalRows
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resolutions-v2-table-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "resolutions-v2-table assignments-v2-table",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                    style: {
                                                        width: "126px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                    style: {
                                                        width: "152px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                    style: {
                                                        width: "184px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                    style: {
                                                        width: "220px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                    style: {
                                                        width: "126px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                    style: {
                                                        width: "126px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                    style: {
                                                        width: "112px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                    style: {
                                                        width: "92px"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: renderV2SortHeader("objektnummer", "Objekt-Nr", icons.object)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: renderV2SortHeader("einheitsnummer", "Einheit-Nr", icons.unit)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: renderV2SortHeader("eigentuemer_id", "Eigent\xfcmer-ID", icons.owner)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: plainHeader("Eigent\xfcmername", icons.ownersGroup)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: plainHeader("E-Mail", icons.email)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: plainHeader("Stimmrecht", icons.votes)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: plainHeader("MEA", icons.mea)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: plainHeader("Status", icons.status)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "resolutions-v2-actions-head",
                                                        "aria-label": "Aktionen",
                                                        title: "Aktionen",
                                                        children: plainHeader("", icons.actions)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: rows.map((r)=>{
                                                const objectId = objectIdByObjektnummer.get(r.objektnummer);
                                                const locked = lockedObjectIds.has(r.objectId);
                                                const menuId = r.id;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: objectId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                to: `/objects/${objectId}`,
                                                                className: "badge object-number",
                                                                style: {
                                                                    textDecoration: "none"
                                                                },
                                                                children: r.objektnummer
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "badge object-number",
                                                                children: r.objektnummer
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: formatEinheitsnummer(r.einheitsnummer)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: r.eigentuemer_id
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "resolutions-v2-object-cell",
                                                            children: [
                                                                ownerDisplayById.get(r.ownerId) ?? r.eigentuemername ?? "-",
                                                                r.isAuthorizedOwnerRecipient ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "badge",
                                                                    style: {
                                                                        marginLeft: 8
                                                                    },
                                                                    children: "Zustellungsbevollm\xe4chtigt"
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: r.eigentuemer_email || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: formatAssignmentNumber(r.einheit_stimmrecht)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: formatAssignmentMea(r.einheit_mea)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `badge ${r.status} quick-tooltip`,
                                                                "data-tooltip": $5dea51850bf332cc$var$buildAssignmentValidityTooltip(r),
                                                                title: $5dea51850bf332cc$var$buildAssignmentValidityTooltip(r),
                                                                tabIndex: 0,
                                                                children: r.status
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: !canUpdate && !canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                style: {
                                                                    color: "var(--text-soft)"
                                                                },
                                                                children: "-"
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "resolutions-v2-action-wrap",
                                                                onClick: (e)=>e.stopPropagation(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "resolutions-v2-action-trigger",
                                                                        "aria-label": `Aktionen f\xfcr Zuordnung ${r.einheitsnummer}`,
                                                                        "aria-expanded": openActionMenuId === menuId,
                                                                        onMouseDown: (e)=>e.stopPropagation(),
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            if (openActionMenuId === menuId) {
                                                                                setOpenActionMenuId(null);
                                                                                return;
                                                                            }
                                                                            openActionMenuAtTrigger(menuId, e.currentTarget, canUpdate && canDelete ? 96 : 52);
                                                                        },
                                                                        children: "\u22EE"
                                                                    }),
                                                                    openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                        style: {
                                                                            left: actionMenuPosition.left,
                                                                            top: actionMenuPosition.top
                                                                        },
                                                                        onMouseDown: (e)=>e.stopPropagation(),
                                                                        onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                        onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                        children: [
                                                                            canUpdate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                disabled: locked,
                                                                                onClick: ()=>{
                                                                                    setEditForm({
                                                                                        id: r.id,
                                                                                        objectId: r.objectId,
                                                                                        unitId: r.unitId,
                                                                                        ownerId: r.ownerId,
                                                                                        status: r.status,
                                                                                        gueltig_ab: r.gueltig_ab ?? "",
                                                                                        gueltig_bis: r.gueltig_bis ?? ""
                                                                                    });
                                                                                    setOwnerSearchEdit(`${r.eigentuemer_id} ${r.eigentuemername ?? ""}`.trim());
                                                                                    setOpenActionMenuId(null);
                                                                                },
                                                                                children: "Bearbeiten"
                                                                            }) : null,
                                                                            canDelete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                disabled: locked || deleteMutation.isPending,
                                                                                onClick: ()=>{
                                                                                    if (locked) {
                                                                                        setActionError("Zuordnung ist wegen aktivem Umlaufbeschluss gesperrt.");
                                                                                        setOpenActionMenuId(null);
                                                                                        return;
                                                                                    }
                                                                                    const activeAssignmentsForUnit = (ownerAssignmentsData?.data ?? []).filter((a)=>a.objectId === r.objectId && a.unitId === r.unitId && a.status === "aktiv" && a.id !== r.id);
                                                                                    const removesLastActiveAssignment = r.status === "aktiv" && activeAssignmentsForUnit.length === 0;
                                                                                    setDeleteConfirm({
                                                                                        id: r.id,
                                                                                        label: `${r.objektnummer} / ${r.einheitsnummer} / ${r.eigentuemer_id}`,
                                                                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                        input: [
                                                                                            "",
                                                                                            "",
                                                                                            "",
                                                                                            ""
                                                                                        ],
                                                                                        error: "",
                                                                                        warning: removesLastActiveAssignment ? "Achtung: Nach dem L\xf6schen bleibt auf dieser Einheit keine aktive Eigent\xfcmerzuordnung mehr bestehen." : undefined
                                                                                    });
                                                                                    setOpenActionMenuId(null);
                                                                                },
                                                                                children: "L\xf6schen"
                                                                            }) : null
                                                                        ]
                                                                    }), document.body) : null
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, r.id);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-pagination",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolutions-v2-page-size",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: String(pageSize),
                                            onChange: (e)=>setPageSize(Number(e.target.value) || 10),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "10",
                                                    children: "10 pro Seite"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "20",
                                                    children: "20 pro Seite"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "50",
                                                    children: "50 pro Seite"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolutions-v2-page-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "resolutions-v2-page-arrow",
                                                onClick: ()=>setPage((prev)=>Math.max(1, prev - 1)),
                                                disabled: page <= 1,
                                                children: "\u2039"
                                            }),
                                            pageItems.map((pageItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `resolutions-v2-page-chip ${pageItem === page ? "active" : ""}`,
                                                    onClick: ()=>setPage(pageItem),
                                                    children: pageItem
                                                }, pageItem)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "resolutions-v2-page-arrow",
                                                onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                                disabled: page >= totalPages,
                                                children: "\u203A"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "resolutions-v2-page-info",
                                                children: [
                                                    "Seite ",
                                                    page,
                                                    " von ",
                                                    totalPages
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolutions-v2-page-next-wrap",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            className: "resolutions-v2-next-btn",
                                            onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                            disabled: page >= totalPages,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Weiter"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: "\u203A"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                        columns: columns,
                        rows: rows,
                        total: totalRows,
                        page: page,
                        pageSize: pageSize,
                        onPageChange: setPage,
                        bodyMaxHeight: 560,
                        topContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "filterbar",
                            style: {
                                margin: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    placeholder: "Suche",
                                    value: search,
                                    onChange: (e)=>setSearch(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: objectFilter,
                                    onChange: (e)=>setObjectFilter(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Alle Objekt-Nr"
                                        }),
                                        (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: o.id,
                                                children: o.objektnummer
                                            }, o.id))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: status,
                                    onChange: (e)=>setStatus(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Alle Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "aktiv",
                                            children: "Aktiv"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "inaktiv",
                                            children: "Inaktiv"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: recipientType,
                                    onChange: (e)=>setRecipientType(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Alle"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "owner",
                                            children: "Eigent\xfcmer"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "authorized",
                                            children: "Zustellungsbevollm\xe4chtigt"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                open: !!deleteConfirm,
                message: deleteConfirm ? `${deleteConfirm.warning ? `${deleteConfirm.warning} ` : ""}Zuordnung ${deleteConfirm.label} soll gel\xf6scht werden.` : "",
                code: deleteConfirm?.code ?? "",
                input: deleteConfirm?.input ?? [
                    "",
                    "",
                    "",
                    ""
                ],
                error: deleteConfirm?.error,
                isPending: deleteMutation.isPending,
                onClose: ()=>setDeleteConfirm(null),
                onInputChange: (next)=>{
                    if (!deleteConfirm) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        input: next
                    });
                },
                onErrorReset: ()=>{
                    if (!deleteConfirm || !deleteConfirm.error) return;
                    setDeleteConfirm({
                        ...deleteConfirm,
                        error: ""
                    });
                },
                onConfirm: ()=>{
                    if (!deleteConfirm) return;
                    const enteredCode = deleteConfirm.input.join("");
                    if (enteredCode !== deleteConfirm.code) {
                        setDeleteConfirm({
                            ...deleteConfirm,
                            error: "Sicherheitscode falsch eingegeben."
                        });
                        return;
                    }
                    deleteMutation.mutate(deleteConfirm.id);
                }
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



const $5bf5538ea9b06aa2$var$FACILIOO_SYNC_LOGO_DATA_URL = "data:image/png;base64,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";
const $5bf5538ea9b06aa2$var$REQUIRED_FIELDS = {
    objects: [
        "objektnummer",
        "objektname",
        "strasse",
        "plz",
        "ort",
        "status"
    ],
    units: [
        "objektnummer",
        "einheitsnummer",
        "einheitstyp",
        "mea",
        "status"
    ],
    owners: [
        "objektnummer",
        "eigentuemer_id",
        "name_1",
        "status"
    ],
    assignments: [
        "objektnummer",
        "einheitsnummer",
        "eigentuemer_id",
        "status"
    ]
};
const $5bf5538ea9b06aa2$var$importLabel = (value)=>{
    if (value === "objects") return "Objekte";
    if (value === "units") return "Einheiten";
    if (value === "owners") return "Eigent\xfcmer";
    return "Zuordnungen";
};
const $5bf5538ea9b06aa2$var$IMPORT_FIELD_LABELS = {
    objektnummer: "Objektnummer",
    objektname: "Objektname",
    strasse: "Strasse",
    plz: "PLZ",
    ort: "Ort",
    status: "Status",
    einheitsnummer: "Einheitsnummer",
    einheitstyp: "Einheitstyp",
    mea: "MEA",
    eigentuemer_id: "Eigent\xfcmer-ID",
    name_1: "Name 1"
};
const $5bf5538ea9b06aa2$var$importFieldLabel = (field)=>$5bf5538ea9b06aa2$var$IMPORT_FIELD_LABELS[field] ?? field;
const $5bf5538ea9b06aa2$var$extractCsvHeaders = (content)=>{
    const firstLine = content.split(/\r?\n/).map((line)=>line.trim()).find((line)=>line.length > 0);
    if (!firstLine) return [];
    const commaCount = (firstLine.match(/,/g) ?? []).length;
    const semicolonCount = (firstLine.match(/;/g) ?? []).length;
    const separator = semicolonCount > commaCount ? ";" : ",";
    return firstLine.split(separator).map((entry)=>entry.trim().replace(/^"(.*)"$/, "$1")).filter(Boolean);
};
const $5bf5538ea9b06aa2$var$normalizeMappingKey = (value)=>String(value ?? "").trim().toLowerCase().replace(/[\s_-]+/g, "");
const $5bf5538ea9b06aa2$var$createSuggestedMapping = (requiredFields, sourceColumns)=>{
    const normalizedColumnMap = new Map();
    sourceColumns.forEach((column)=>{
        const key = $5bf5538ea9b06aa2$var$normalizeMappingKey(column);
        if (!key) return;
        if (!normalizedColumnMap.has(key)) normalizedColumnMap.set(key, column);
    });
    return requiredFields.reduce((acc, field)=>{
        const exact = normalizedColumnMap.get($5bf5538ea9b06aa2$var$normalizeMappingKey(field));
        acc[field] = exact ?? "";
        return acc;
    }, {});
};
const $5bf5538ea9b06aa2$var$FACILIOO_LIVE_SYNC_INTERVAL_MINUTES = 1440;
const $5bf5538ea9b06aa2$var$FACILIOO_LIVE_SYNC_SCHEDULE_LABEL = "taeglich um 02:00";
const $5bf5538ea9b06aa2$var$statusLabel = (value)=>{
    if (value === "uploaded") return "Hochgeladen";
    if (value === "validated") return "Validiert";
    if (value === "failed") return "Fehlerhaft";
    return "Importiert";
};
const $5bf5538ea9b06aa2$var$statusBadgeClass = (value)=>{
    if (value === "uploaded") return "badge import-uploaded";
    if (value === "validated") return "badge import-validated";
    if (value === "failed") return "badge import-failed";
    return "badge import-imported";
};
const $5bf5538ea9b06aa2$var$FACILIOO_DATASET_ORDER = [
    {
        key: "objects",
        label: "Objekte",
        className: "is-objects"
    },
    {
        key: "units",
        label: "Einheiten",
        className: "is-units"
    },
    {
        key: "assignments",
        label: "Zuordnungen",
        className: "is-assignments"
    },
    {
        key: "owners",
        label: "Eigent\xfcmer",
        className: "is-owners"
    }
];
const $5bf5538ea9b06aa2$var$formatDateTimeDE = (value)=>{
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return "-";
    return parsed.toLocaleString("de-DE");
};
const $5bf5538ea9b06aa2$var$formatDurationLabel = (durationMs)=>{
    if (typeof durationMs !== "number" || !Number.isFinite(durationMs) || durationMs <= 0) return "-";
    const totalSeconds = Math.max(1, Math.round(durationMs / 1000));
    if (totalSeconds < 60) return `${totalSeconds}s`;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
};
const $5bf5538ea9b06aa2$var$toGermanValidationReason = (rawMessage)=>{
    const message = String(rawMessage ?? "").trim();
    if (!message) return "Validierung derzeit nicht m\xf6glich. Bitte sp\xe4ter erneut versuchen.";
    if (/502|bad gateway|gateway/i.test(message)) return "Validierung derzeit nicht m\xf6glich, weil der Server nicht erreichbar ist (Gateway-Fehler). Bitte sp\xe4ter erneut versuchen.";
    if (/failed to fetch|networkerror|netzwerk|connection|econn|timeout|timed out/i.test(message)) return "Validierung derzeit nicht m\xf6glich, weil keine stabile Verbindung zum Server besteht. Bitte Verbindung pr\xfcfen und erneut versuchen.";
    if (/importjob nicht gefunden/i.test(message)) return "Validierung nicht m\xf6glich: Der Importjob wurde nicht gefunden. Bitte Datei erneut hochladen.";
    if (/mapping|spaltenzuordnung|ungueltig|ungültig/i.test(message)) return "Validierung nicht m\xf6glich: Die Spaltenzuordnung ist unvollst\xe4ndig oder ung\xfcltig. Bitte Zuordnung pr\xfcfen.";
    return `Validierung derzeit nicht m\xf6glich: ${message}`;
};
const $5bf5538ea9b06aa2$var$renderImportsMenuIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 5.3v8.8",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m8.8 11 3.2 3.2 3.2-3.2",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4.8",
                y: "15.8",
                width: "14.4",
                height: "3.8",
                rx: "1.4",
                stroke: "currentColor",
                strokeWidth: "1.8"
            })
        ]
    });
const $5bf5538ea9b06aa2$var$renderDatasetSymbol = (key)=>{
    if (key === "objects") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.9 8.2h14.2v10.9H4.9z",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (key === "units") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.1",
                y: "4.8",
                width: "13.8",
                height: "14.8",
                rx: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.85"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.2 19.6v-2.9h5.6v2.9",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (key === "assignments") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "6.2",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "16.8",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.4 7.2h7.2M7.9 8.8l7.4 6.4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9.1",
                cy: "9.1",
                r: "2.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "15.8",
                cy: "8.4",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
};
const $5bf5538ea9b06aa2$var$renderManualImportTypeIcon = (type)=>{
    if (type === "objects") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.9 8.2h14.2v10.9H4.9z",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (type === "units") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.1",
                y: "4.8",
                width: "13.8",
                height: "14.8",
                rx: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.85"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.2 19.6v-2.9h5.6v2.9",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (type === "owners") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9.1",
                cy: "9.1",
                r: "2.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "15.8",
                cy: "8.4",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "6.2",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "16.8",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.8",
                cy: "7.2",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.4 7.2h7.2M7.9 8.8l7.4 6.4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
};
const $5bf5538ea9b06aa2$export$f02d1ece1b89c647 = ()=>{
    const qc = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const isFrameworkV2 = typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    const [importMode, setImportMode] = (0, $acw62.useState)("facilioo");
    const [manualImportType, setManualImportType] = (0, $acw62.useState)("objects");
    const [file, setFile] = (0, $acw62.useState)(null);
    const [job, setJob] = (0, $acw62.useState)(null);
    const [mapping, setMapping] = (0, $acw62.useState)({});
    const [validationErrors, setValidationErrors] = (0, $acw62.useState)([]);
    const [confirmedWarnings, setConfirmedWarnings] = (0, $acw62.useState)({});
    const [actionError, setActionError] = (0, $acw62.useState)("");
    const [faciliooTestStatus, setFaciliooTestStatus] = (0, $acw62.useState)(null);
    const [faciliooTestPending, setFaciliooTestPending] = (0, $acw62.useState)(false);
    const [faciliooMasterDataProbePending, setFaciliooMasterDataProbePending] = (0, $acw62.useState)(false);
    const [faciliooMasterDataProbe, setFaciliooMasterDataProbe] = (0, $acw62.useState)(null);
    const [faciliooMasterDataProbeError, setFaciliooMasterDataProbeError] = (0, $acw62.useState)(null);
    const [faciliooSyncStatusMessage, setFaciliooSyncStatusMessage] = (0, $acw62.useState)(null);
    const [faciliooSyncSnapshot, setFaciliooSyncSnapshot] = (0, $acw62.useState)(null);
    const [faciliooSyncPending, setFaciliooSyncPending] = (0, $acw62.useState)(false);
    const [faciliooSyncRunning, setFaciliooSyncRunning] = (0, $acw62.useState)(false);
    const [faciliooSyncCancelPending, setFaciliooSyncCancelPending] = (0, $acw62.useState)(false);
    const [faciliooTestObjectNumber, setFaciliooTestObjectNumber] = (0, $acw62.useState)("");
    const [faciliooDebugAccountId, setFaciliooDebugAccountId] = (0, $acw62.useState)("");
    const [faciliooDebugContractId, setFaciliooDebugContractId] = (0, $acw62.useState)("");
    const [faciliooDebugProcessRef, setFaciliooDebugProcessRef] = (0, $acw62.useState)("");
    const [faciliooProcessFeedTestEnabled, setFaciliooProcessFeedTestEnabled] = (0, $acw62.useState)(false);
    const [faciliooProcessFeedTestText, setFaciliooProcessFeedTestText] = (0, $acw62.useState)("");
    const [faciliooContractTestPending, setFaciliooContractTestPending] = (0, $acw62.useState)(false);
    const [faciliooContractTestResult, setFaciliooContractTestResult] = (0, $acw62.useState)(null);
    const [faciliooContractTestError, setFaciliooContractTestError] = (0, $acw62.useState)(null);
    const [faciliooProcessTestPending, setFaciliooProcessTestPending] = (0, $acw62.useState)(false);
    const [faciliooProcessTestResult, setFaciliooProcessTestResult] = (0, $acw62.useState)(null);
    const [faciliooProcessTestError, setFaciliooProcessTestError] = (0, $acw62.useState)(null);
    const [faciliooLiveSyncEnabled, setFaciliooLiveSyncEnabled] = (0, $acw62.useState)(false);
    const [faciliooControlStatus, setFaciliooControlStatus] = (0, $acw62.useState)(null);
    const [faciliooControlPending, setFaciliooControlPending] = (0, $acw62.useState)(false);
    const [faciliooMirrorCleanupPending, setFaciliooMirrorCleanupPending] = (0, $acw62.useState)(false);
    const [faciliooMirrorCleanupStatus, setFaciliooMirrorCleanupStatus] = (0, $acw62.useState)(null);
    const [manualFileDragActive, setManualFileDragActive] = (0, $acw62.useState)(false);
    const [manualSourceColumns, setManualSourceColumns] = (0, $acw62.useState)([]);
    const [validationFeedback, setValidationFeedback] = (0, $acw62.useState)(null);
    const manualFileInputRef = (0, $acw62.useRef)(null);
    const manualImportTypes = importMode === "facilioo" ? [
        "objects",
        "units",
        "owners"
    ] : [
        "objects",
        "units",
        "owners",
        "assignments"
    ];
    const manualFileInputId = "manual-import-file";
    const { data: uiSettings } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-facilioo-controls"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings()
    });
    const faciliooEnabled = uiSettings?.management?.faciliooEnabled !== false;
    const { data: latestFaciliooSyncLog } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "imports-facilioo-latest-actor"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).faciliooSyncLogs({
                page: 1,
                pageSize: 1
            }),
        enabled: faciliooEnabled
    });
    (0, $acw62.useEffect)(()=>{
        if (!uiSettings) return;
        if (!faciliooEnabled) setImportMode("manual");
        else setImportMode(uiSettings.management.faciliooDataConnectionMode === "manual" ? "manual" : "facilioo");
        setFaciliooLiveSyncEnabled(Boolean(uiSettings.management.faciliooLiveSyncEnabled));
    }, [
        faciliooEnabled,
        uiSettings
    ]);
    const initializeMapping = (type, sourceColumns = [])=>{
        const required = $5bf5538ea9b06aa2$var$REQUIRED_FIELDS[type];
        if (sourceColumns.length > 0) {
            setMapping($5bf5538ea9b06aa2$var$createSuggestedMapping(required, sourceColumns));
            return;
        }
        const initial = required.reduce((acc, field)=>{
            acc[field] = field;
            return acc;
        }, {});
        setMapping(initial);
    };
    const uploadMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!file) throw new Error("Bitte eine Datei ausw\xe4hlen.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).uploadImportFile(manualImportType, file);
        },
        onSuccess: async (uploaded)=>{
            setActionError("");
            setValidationFeedback(null);
            setJob(uploaded);
            initializeMapping(manualImportType, manualSourceColumns);
            setValidationErrors([]);
            setConfirmedWarnings({});
            await qc.invalidateQueries({
                queryKey: [
                    "imports"
                ]
            });
        },
        onError: (error)=>setActionError(error instanceof Error ? error.message : "Upload fehlgeschlagen")
    });
    const validateMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!job) throw new Error("Kein Importjob vorhanden.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).validateImport(job.id, mapping);
        },
        onSuccess: async (result)=>{
            setValidationErrors(result.errors);
            setConfirmedWarnings({});
            const blockingErrors = result.errors.filter((entry)=>!entry.overridable).length;
            if (blockingErrors > 0) setValidationFeedback({
                type: "error",
                text: `Validierung nicht m\xf6glich: ${blockingErrors} Fehler blockieren den Import. Bitte Fehlerliste pr\xfcfen.`
            });
            else if (result.errors.length > 0) setValidationFeedback({
                type: "warn",
                text: `Validierung mit Hinweisen: ${result.errors.length} Hinweis(e). Bitte pr\xfcfen und ggf. best\xe4tigen.`
            });
            else setValidationFeedback({
                type: "success",
                text: "Validierung erfolgreich. Import kann final ausgef\xfchrt werden."
            });
            setActionError("");
            const fresh = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).importById(result.jobId);
            setJob(fresh);
            await qc.invalidateQueries({
                queryKey: [
                    "imports"
                ]
            });
        },
        onError: (error)=>{
            const raw = error instanceof Error ? error.message : "";
            setValidationFeedback({
                type: "error",
                text: $5bf5538ea9b06aa2$var$toGermanValidationReason(raw)
            });
            setActionError("");
        }
    });
    const commitMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!job) throw new Error("Kein Importjob vorhanden.");
            const confirmedErrorIds = validationErrors.filter((error)=>error.overridable && confirmedWarnings[error.id]).map((error)=>error.id);
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).commitImport(job.id, confirmedErrorIds);
        },
        onSuccess: async ()=>{
            setActionError("");
            if (job) {
                const fresh = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).importById(job.id);
                setJob(fresh);
            }
            await qc.invalidateQueries({
                queryKey: [
                    "imports"
                ]
            });
            await qc.invalidateQueries({
                queryKey: [
                    "objects"
                ]
            });
            await qc.invalidateQueries({
                queryKey: [
                    "units"
                ]
            });
            await qc.invalidateQueries({
                queryKey: [
                    "owners"
                ]
            });
            await qc.invalidateQueries({
                queryKey: [
                    "assignments"
                ]
            });
        },
        onError: (error)=>setActionError(error instanceof Error ? error.message : "Import fehlgeschlagen")
    });
    const requiredFields = $5bf5538ea9b06aa2$var$REQUIRED_FIELDS[manualImportType];
    const mappingOptions = (0, $acw62.useMemo)(()=>{
        if (manualSourceColumns.length > 0) return Array.from(new Set(manualSourceColumns.map((column)=>String(column ?? "").trim()).filter(Boolean)));
        // Fallback (z.B. XLSX ohne lokale Header-Erkennung im Frontend).
        const values = new Set(requiredFields);
        requiredFields.forEach((field)=>{
            const mappedColumn = String(mapping[field] ?? "").trim();
            if (mappedColumn) values.add(mappedColumn);
        });
        return Array.from(values);
    }, [
        requiredFields,
        manualSourceColumns,
        mapping
    ]);
    const canUpload = Boolean(file) && !uploadMutation.isPending;
    const mappedRequiredColumns = requiredFields.map((field)=>String(mapping[field] ?? "").trim()).filter(Boolean);
    const missingRequiredMappings = requiredFields.filter((field)=>!String(mapping[field] ?? "").trim());
    const duplicateRequiredMappings = Array.from(mappedRequiredColumns.reduce((acc, value)=>{
        acc.set(value, (acc.get(value) ?? 0) + 1);
        return acc;
    }, new Map())).filter(([, count])=>count > 1).map(([column])=>column);
    const hasMappingConflict = missingRequiredMappings.length > 0 || duplicateRequiredMappings.length > 0;
    const mappingConflictText = missingRequiredMappings.length > 0 ? `Bitte Pflichtfelder zuordnen: ${missingRequiredMappings.map($5bf5538ea9b06aa2$var$importFieldLabel).join(", ")}.` : duplicateRequiredMappings.length > 0 ? `Bitte Mehrfachzuordnung korrigieren (gleiche Quellspalte mehrfach): ${duplicateRequiredMappings.join(", ")}.` : "";
    const canValidate = Boolean(job) && !validateMutation.isPending && !commitMutation.isPending && !hasMappingConflict;
    const pendingWarningConfirmations = validationErrors.filter((error)=>error.overridable && !confirmedWarnings[error.id]);
    const hasBlockingErrors = validationErrors.some((error)=>!error.overridable);
    const canCommit = Boolean(job && job.status === "validated" && Number(job.invalid_rows ?? 0) === 0) && !commitMutation.isPending && !hasBlockingErrors && pendingWarningConfirmations.length === 0;
    const validationSummary = (0, $acw62.useMemo)(()=>{
        if (!job) return null;
        return `Gesamt: ${job.total_rows} | Valide: ${job.valid_rows} | Fehler: ${job.invalid_rows}`;
    }, [
        job
    ]);
    const handleManualFileSelect = (fileList)=>{
        if (!fileList || fileList.length === 0) return;
        setFile(fileList[0] ?? null);
    };
    const handleDownloadManualFile = ()=>{
        if (!file) return;
        const url = URL.createObjectURL(file);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = file.name || "import-datei";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    };
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        const syncSourceColumns = async ()=>{
            if (!file) {
                setManualSourceColumns([]);
                return;
            }
            const lowerName = file.name.toLowerCase();
            const isCsv = lowerName.endsWith(".csv") || file.type === "text/csv";
            if (!isCsv) {
                setManualSourceColumns([]);
                return;
            }
            try {
                const text = await file.text();
                if (cancelled) return;
                setManualSourceColumns($5bf5538ea9b06aa2$var$extractCsvHeaders(text));
            } catch  {
                if (!cancelled) setManualSourceColumns([]);
            }
        };
        syncSourceColumns();
        return ()=>{
            cancelled = true;
        };
    }, [
        file
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!file) return;
        if (manualSourceColumns.length === 0) return;
        setMapping($5bf5538ea9b06aa2$var$createSuggestedMapping($5bf5538ea9b06aa2$var$REQUIRED_FIELDS[manualImportType], manualSourceColumns));
        setValidationFeedback(null);
    }, [
        file,
        manualImportType,
        manualSourceColumns
    ]);
    const refreshFaciliooSyncStatus = async ()=>{
        try {
            const status = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getFaciliooSyncStatus();
            setFaciliooSyncSnapshot(status);
            const syncIsRunning = Boolean(status.running || status.webhookRun?.running);
            setFaciliooSyncRunning(syncIsRunning);
            if (!syncIsRunning) {
                setFaciliooSyncPending(false);
                setFaciliooSyncCancelPending(false);
            }
            if (status.running && status.currentRun) {
                setFaciliooSyncStatusMessage(null);
                return;
            }
            if (!status.lastRun?.finishedAt) {
                setFaciliooSyncStatusMessage({
                    type: "info",
                    text: `Live-Sync ${status.enabled ? "aktiv" : "inaktiv"} (${$5bf5538ea9b06aa2$var$FACILIOO_LIVE_SYNC_SCHEDULE_LABEL}). Noch kein Lauf.`
                });
                return;
            }
            setFaciliooSyncStatusMessage(null);
        } catch (error) {
            const message = error instanceof Error ? error.message : "Sync-Status konnte nicht geladen werden";
            setFaciliooSyncStatusMessage({
                type: "error",
                text: message
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        refreshFaciliooSyncStatus();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!faciliooSyncRunning && !faciliooSyncPending) return;
        const timer = window.setInterval(()=>{
            refreshFaciliooSyncStatus();
        }, 5000);
        return ()=>window.clearInterval(timer);
    }, [
        faciliooSyncRunning,
        faciliooSyncPending
    ]);
    const runFaciliooTest = async ()=>{
        setFaciliooTestPending(true);
        setFaciliooTestStatus(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).testFaciliooConnection();
            setFaciliooTestStatus({
                type: "ok",
                text: `Verbindung erfolgreich. /my-requests erreichbar (${result.total} Eintr\xe4ge).`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Facilioo-Test fehlgeschlagen";
            setFaciliooTestStatus({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooTestPending(false);
        }
    };
    const runFaciliooMasterDataProbe = async ()=>{
        setFaciliooMasterDataProbePending(true);
        setFaciliooMasterDataProbeError(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).probeFaciliooMasterData();
            setFaciliooMasterDataProbe(result);
        } catch (error) {
            const message = error instanceof Error ? error.message : "Master-Data-Probe fehlgeschlagen";
            setFaciliooMasterDataProbeError(message);
            setFaciliooMasterDataProbe(null);
        } finally{
            setFaciliooMasterDataProbePending(false);
        }
    };
    const runFaciliooFullSyncNow = async ()=>{
        setFaciliooSyncPending(true);
        refreshFaciliooSyncStatus();
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).runFaciliooSyncNow(undefined, undefined, "full");
            setFaciliooSyncStatusMessage({
                type: "ok",
                text: result.message || "Facilioo Voll-Sync gestartet."
            });
            await refreshFaciliooSyncStatus();
        } catch (error) {
            const message = error instanceof Error ? error.message : "Voll-Sync fehlgeschlagen";
            setFaciliooSyncStatusMessage({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooSyncPending(false);
        }
    };
    const runFaciliooLiveUpdateNow = async ()=>{
        setFaciliooSyncPending(true);
        refreshFaciliooSyncStatus();
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).runFaciliooSyncNow(undefined, undefined, "live_update");
            setFaciliooSyncStatusMessage({
                type: "ok",
                text: result.message || "Facilioo Live-Update gestartet."
            });
            await refreshFaciliooSyncStatus();
        } catch (error) {
            const message = error instanceof Error ? error.message : "Live-Update fehlgeschlagen";
            setFaciliooSyncStatusMessage({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooSyncPending(false);
        }
    };
    const runFaciliooObjectSyncNow = async ()=>{
        const objectNumber = faciliooTestObjectNumber.trim();
        if (!objectNumber) {
            setFaciliooSyncStatusMessage({
                type: "error",
                text: "Bitte eine Objektnummer f\xfcr den Testlauf eingeben."
            });
            return;
        }
        setFaciliooSyncPending(true);
        refreshFaciliooSyncStatus();
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).runFaciliooSyncNow(objectNumber, undefined, "full");
            setFaciliooSyncStatusMessage({
                type: "ok",
                text: result.message || "Test-Synchronisierung gestartet."
            });
            await refreshFaciliooSyncStatus();
        } catch (error) {
            const message = error instanceof Error ? error.message : "Objekt-Synchronisierung fehlgeschlagen";
            setFaciliooSyncStatusMessage({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooSyncPending(false);
        }
    };
    const runFaciliooContactDebugSyncNow = async ()=>{
        const accountId = faciliooDebugAccountId.trim();
        if (!accountId) {
            setFaciliooSyncStatusMessage({
                type: "error",
                text: "Bitte eine Debug-Account-ID eingeben."
            });
            return;
        }
        setFaciliooSyncPending(true);
        refreshFaciliooSyncStatus();
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).runFaciliooSyncNow(undefined, accountId, "full");
            setFaciliooSyncStatusMessage({
                type: "ok",
                text: result.message || "Kontakt-Debug-Synchronisierung gestartet."
            });
            await refreshFaciliooSyncStatus();
        } catch (error) {
            const message = error instanceof Error ? error.message : "Kontakt-Debug fehlgeschlagen";
            setFaciliooSyncStatusMessage({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooSyncPending(false);
        }
    };
    const cancelFaciliooSyncNow = async ()=>{
        setFaciliooSyncCancelPending(true);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).cancelFaciliooSync();
            setFaciliooSyncStatusMessage({
                type: "ok",
                text: result.message || "Abbruch wurde angefordert."
            });
            await refreshFaciliooSyncStatus();
        } catch (error) {
            const message = error instanceof Error ? error.message : "Abbruch konnte nicht angefordert werden";
            setFaciliooSyncStatusMessage({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooSyncCancelPending(false);
        }
    };
    const runFaciliooContractDebug = async ()=>{
        const contractId = faciliooDebugContractId.trim();
        if (!contractId) {
            setFaciliooContractTestError("Bitte eine Contract-ID eingeben.");
            setFaciliooContractTestResult(null);
            return;
        }
        setFaciliooContractTestPending(true);
        setFaciliooContractTestError(null);
        setFaciliooContractTestResult(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getFaciliooContractLive(contractId);
            setFaciliooContractTestResult(result);
        } catch (error) {
            const message = error instanceof Error ? error.message : "Contract-Debug fehlgeschlagen";
            setFaciliooContractTestError(message);
        } finally{
            setFaciliooContractTestPending(false);
        }
    };
    const runFaciliooProcessDebug = async ()=>{
        const processRef = faciliooDebugProcessRef.trim();
        if (!processRef) {
            setFaciliooProcessTestError("Bitte eine Vorgangs-ID oder Vorgangsnummer eingeben.");
            setFaciliooProcessTestResult(null);
            return;
        }
        setFaciliooProcessTestPending(true);
        setFaciliooProcessTestError(null);
        setFaciliooProcessTestResult(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolveFaciliooProcess(processRef, {
                postFeedEntry: faciliooProcessFeedTestEnabled,
                feedText: faciliooProcessFeedTestEnabled ? faciliooProcessFeedTestText : undefined
            });
            setFaciliooProcessTestResult(result);
        } catch (error) {
            const message = error instanceof Error ? error.message : "Vorgangs-Debug fehlgeschlagen";
            setFaciliooProcessTestError(message);
        } finally{
            setFaciliooProcessTestPending(false);
        }
    };
    const saveFaciliooControls = async (nextLiveSyncEnabled = faciliooLiveSyncEnabled)=>{
        if (!uiSettings) return;
        setFaciliooControlPending(true);
        setFaciliooControlStatus(null);
        try {
            const payload = {
                ...uiSettings,
                management: {
                    ...uiSettings.management,
                    faciliooLiveSyncEnabled: nextLiveSyncEnabled,
                    faciliooLiveSyncIntervalMinutes: $5bf5538ea9b06aa2$var$FACILIOO_LIVE_SYNC_INTERVAL_MINUTES
                }
            };
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).saveUiSettings(payload);
            await qc.invalidateQueries({
                queryKey: [
                    "ui-settings-facilioo-controls"
                ]
            });
            setFaciliooControlStatus({
                type: "ok",
                text: "Facilioo Live-Sync-Einstellungen gespeichert."
            });
            await refreshFaciliooSyncStatus();
        } catch (error) {
            const message = error instanceof Error ? error.message : "Speichern fehlgeschlagen";
            setFaciliooControlStatus({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooControlPending(false);
        }
    };
    const saveDataConnectionMode = async (mode)=>{
        if (!uiSettings) return;
        const payload = {
            ...uiSettings,
            management: {
                ...uiSettings.management,
                faciliooDataConnectionMode: mode
            }
        };
        // Optimistisch lokal anwenden, damit Sidebar/Reiter sofort reagieren.
        (0, $5806306cf67ca7cd$export$4a377ad1c9fa8e6a)(payload);
        window.dispatchEvent(new Event("ui-settings-updated"));
        try {
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).saveUiSettings(payload);
            await qc.invalidateQueries({
                queryKey: [
                    "ui-settings-facilioo-controls"
                ]
            });
        } catch  {
        // Bei Backend-Fehler bleibt der lokale Modus aktiv; erneuter Save beim nächsten Wechsel.
        }
    };
    const handleImportModeChange = (mode)=>{
        if (mode === "facilioo" && !faciliooEnabled) return;
        setImportMode(mode);
        if (mode === "facilioo" && manualImportType === "assignments") setManualImportType("objects");
        saveDataConnectionMode(mode);
    };
    const handleFaciliooLiveSyncToggle = (enabled)=>{
        setFaciliooLiveSyncEnabled(enabled);
        saveFaciliooControls(enabled);
    };
    const runFaciliooMirrorCleanup = async (dryRun)=>{
        setFaciliooMirrorCleanupPending(true);
        setFaciliooMirrorCleanupStatus(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).cleanupFaciliooMirrorUnits(dryRun);
            if (dryRun) setFaciliooMirrorCleanupStatus({
                type: "ok",
                text: `Pr\xfcfung abgeschlossen. Gepr\xfcft: ${result.scanned}, Kandidaten: ${result.candidates}.`
            });
            else setFaciliooMirrorCleanupStatus({
                type: "ok",
                text: `Bereinigung abgeschlossen. Gepr\xfcft: ${result.scanned}, Gel\xf6scht: ${result.deleted}.`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Bereinigung fehlgeschlagen";
            setFaciliooMirrorCleanupStatus({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooMirrorCleanupPending(false);
        }
    };
    const getDatasetSyncState = (datasetKey)=>{
        const webhookRun = faciliooSyncSnapshot?.webhookRun;
        if (webhookRun?.running && webhookRun.datasetKeys?.includes(datasetKey)) return "running";
        const currentRun = faciliooSyncSnapshot?.currentRun;
        const phase = currentRun?.phase;
        if (!faciliooSyncSnapshot?.running || !phase) {
            if (faciliooSyncSnapshot?.lastRun?.ok) return "success";
            return "idle";
        }
        if (phase === "objects_fetch" || phase === "objects_upsert") return datasetKey === "objects" ? "running" : "idle";
        if (phase === "units_fetch" || phase === "units_upsert") {
            if (datasetKey === "objects") return "success";
            return datasetKey === "units" ? "running" : "idle";
        }
        if (phase === "assignments_fetch" || phase === "assignments_upsert") {
            if (datasetKey === "objects" || datasetKey === "units") return "success";
            return datasetKey === "assignments" ? "running" : "idle";
        }
        if (phase === "owners_fetch" || phase === "owners_upsert") {
            if (datasetKey === "objects" || datasetKey === "units" || datasetKey === "assignments") return "success";
            return datasetKey === "owners" ? "running" : "idle";
        }
        if (phase === "cleanup") return "success";
        if (phase === "cancel_requested") {
            if (datasetKey === "objects" && (currentRun.objects?.processed ?? 0) > 0) return "success";
            if (datasetKey === "units" && (currentRun.units?.processed ?? 0) > 0) return "success";
            if (datasetKey === "assignments" && (currentRun.assignments?.processed ?? 0) > 0) return "success";
            if (datasetKey === "owners" && (currentRun.owners?.processed ?? 0) > 0) return "success";
            return "running";
        }
        if (phase === "cancelled") {
            if (datasetKey === "objects" && (currentRun.objects?.processed ?? 0) > 0) return "success";
            if (datasetKey === "units" && (currentRun.units?.processed ?? 0) > 0) return "success";
            if (datasetKey === "assignments" && (currentRun.assignments?.processed ?? 0) > 0) return "success";
            if (datasetKey === "owners" && (currentRun.owners?.processed ?? 0) > 0) return "success";
            return "idle";
        }
        if (phase === "done") return "success";
        if (phase === "error") {
            if (datasetKey === "objects" && currentRun.objects.processed > 0) return "success";
            if (datasetKey === "units" && currentRun.units.processed > 0) return "success";
            if (datasetKey === "assignments" && (currentRun.assignments?.processed ?? 0) > 0) return "success";
            if (datasetKey === "owners" && (currentRun.owners?.processed ?? 0) > 0) return "success";
            return "idle";
        }
        return "idle";
    };
    const getDatasetProgress = (datasetKey)=>{
        const webhookRun = faciliooSyncSnapshot?.webhookRun;
        if (webhookRun?.running && webhookRun.datasetKeys?.includes(datasetKey)) {
            if (datasetKey === "owners") {
                const processed = Number(webhookRun.processed ?? 0);
                const total = Number(webhookRun.total ?? 0);
                const percent = total > 0 ? Math.max(0, Math.min(100, Math.round(processed / total * 100))) : 0;
                return {
                    processed: processed,
                    total: total,
                    percent: percent,
                    available: total > 0
                };
            }
            return {
                processed: 0,
                total: 0,
                percent: 0,
                available: false
            };
        }
        const currentRun = faciliooSyncSnapshot?.currentRun;
        if (!currentRun) return {
            processed: 0,
            total: 0,
            percent: 0,
            available: false
        };
        const progress = datasetKey === "objects" ? currentRun.objects : datasetKey === "units" ? currentRun.units : datasetKey === "assignments" ? currentRun.assignments : currentRun.owners;
        const processed = Number(progress?.processed ?? 0);
        const total = Number(progress?.total ?? 0);
        const percent = total > 0 ? Math.max(0, Math.min(100, Math.round(processed / total * 100))) : 0;
        return {
            processed: processed,
            total: total,
            percent: percent,
            available: total > 0
        };
    };
    const lastRun = faciliooSyncSnapshot?.lastRun ?? null;
    const lastRunWasOk = Boolean(lastRun?.ok);
    const lastRunStatusLabel = lastRunWasOk ? "OK" : "Fehler";
    const lastRunAtLabel = $5bf5538ea9b06aa2$var$formatDateTimeDE(lastRun?.finishedAt || lastRun?.startedAt);
    const lastRunDurationLabel = $5bf5538ea9b06aa2$var$formatDurationLabel(lastRun?.durationMs);
    const lastSuccessfulSyncLabel = $5bf5538ea9b06aa2$var$formatDateTimeDE(faciliooSyncSnapshot?.lastSuccessfulRun?.finishedAt);
    const latestSyncActor = String(latestFaciliooSyncLog?.data?.[0]?.actor_name ?? "").trim() || "-";
    const connectionLikelyHealthy = lastRunWasOk || (faciliooSyncSnapshot?.lastSuccessfulRun?.finishedAt ? true : false);
    const resolvedFaciliooApiEndpoint = String(uiSettings?.management?.faciliooApiKey ?? "").trim().length > 0 ? "https://api.facilioo.de" : "-";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: isFrameworkV2 ? "resolutions-v2-page imports-v2-page" : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `page-header panel ${isFrameworkV2 ? "resolutions-v2-page-header imports-v2-page-header" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: isFrameworkV2 ? "resolutions-v2-title" : "",
                        style: {
                            margin: 0
                        },
                        children: [
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-title-icon",
                                "aria-hidden": "true",
                                children: $5bf5538ea9b06aa2$var$renderImportsMenuIcon()
                            }) : null,
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "resolutions-v2-title-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-main",
                                        children: "Importe"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-sub",
                                        children: "Datenabgleich und Facilioo-Synchronisierung"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Importe"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `imports-mode-toggle ${isFrameworkV2 ? "imports-mode-toggle--v2" : ""}`,
                        role: "tablist",
                        "aria-label": "Datenabgleich-Modus",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: `${isFrameworkV2 ? "imports-v2-mode-button" : ""} ${importMode === "manual" ? "is-active" : ""}`.trim(),
                                onClick: ()=>handleImportModeChange("manual"),
                                children: "Manueller Datenabgleich"
                            }),
                            faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: `${isFrameworkV2 ? "imports-v2-mode-button" : ""} ${importMode === "facilioo" ? "is-active" : ""}`.trim(),
                                onClick: ()=>handleImportModeChange("facilioo"),
                                children: "Facilioo Datenanbindung"
                            }) : null
                        ]
                    })
                ]
            }),
            importMode === "manual" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form imports-create-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: isFrameworkV2 ? "imports-manual-section-title" : undefined,
                        style: {
                            marginTop: 0
                        },
                        children: "Manueller Datenabgleich"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "imports-flow",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `imports-type-toggle ${isFrameworkV2 ? "imports-manual-type-toggle-v2" : ""}`,
                                role: "tablist",
                                "aria-label": "Importtyp (manuell)",
                                children: manualImportTypes.map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        disabled: importMode !== "manual",
                                        className: `${manualImportType === type ? "is-active" : ""} ${isFrameworkV2 ? "imports-manual-type-btn-v2" : ""}`.trim(),
                                        onClick: ()=>{
                                            setManualImportType(type);
                                            initializeMapping(type);
                                        },
                                        children: [
                                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "imports-manual-type-icon-v2",
                                                children: $5bf5538ea9b06aa2$var$renderManualImportTypeIcon(type)
                                            }) : null,
                                            $5bf5538ea9b06aa2$var$importLabel(type)
                                        ]
                                    }, type))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `imports-sync-info-banner ${isFrameworkV2 ? "v2-info-banner imports-manual-intro-v2" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "imports-sync-info-icon",
                                        "aria-hidden": "true",
                                        children: "i"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-sync-info-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Manueller Datenabgleich"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Laden Sie Daten manuell \xfcber eine Excel- oder CSV-Datei hoch. Die Daten werden validiert und anschlie\xdfend in das System \xfcbernommen."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `form-field ${isFrameworkV2 ? "imports-manual-importtype-field-v2" : ""}`.trim(),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Importtyp"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: isFrameworkV2 ? "imports-manual-select-v2" : undefined,
                                                children: [
                                                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "imports-manual-select-icon-v2",
                                                        "aria-hidden": "true",
                                                        children: $5bf5538ea9b06aa2$var$renderManualImportTypeIcon(manualImportType)
                                                    }) : null,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: $5bf5538ea9b06aa2$var$importLabel(manualImportType),
                                                        disabled: true
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Vorlage"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: isFrameworkV2 ? "imports-manual-template-row-v2" : undefined,
                                                style: {
                                                    display: "flex",
                                                    gap: 8,
                                                    flexWrap: "wrap"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: isFrameworkV2 ? "imports-manual-template-btn-v2" : undefined,
                                                        disabled: importMode !== "manual",
                                                        onClick: async ()=>{
                                                            setActionError("");
                                                            try {
                                                                await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).downloadImportTemplate(manualImportType, "xlsx");
                                                            } catch (error) {
                                                                setActionError(error instanceof Error ? error.message : "Template-Download fehlgeschlagen");
                                                            }
                                                        },
                                                        children: [
                                                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-manual-template-icon-v2 is-excel",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M7 4.2h7.4l2.6 2.6v12.8a1.8 1.8 0 0 1-1.8 1.8H7a1.8 1.8 0 0 1-1.8-1.8V6A1.8 1.8 0 0 1 7 4.2Z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M14.4 4.2v2.7h2.6",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "m8.3 10.2 3.8 5.1M12.1 10.2l-3.8 5.1",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }) : null,
                                                            "Excel-Template (.xlsx)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: isFrameworkV2 ? "imports-manual-template-btn-v2" : undefined,
                                                        disabled: importMode !== "manual",
                                                        onClick: async ()=>{
                                                            setActionError("");
                                                            try {
                                                                await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).downloadImportTemplate(manualImportType, "csv");
                                                            } catch (error) {
                                                                setActionError(error instanceof Error ? error.message : "Template-Download fehlgeschlagen");
                                                            }
                                                        },
                                                        children: [
                                                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-manual-template-icon-v2 is-csv",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M7 4.2h7.4l2.6 2.6v12.8a1.8 1.8 0 0 1-1.8 1.8H7a1.8 1.8 0 0 1-1.8-1.8V6A1.8 1.8 0 0 1 7 4.2Z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M14.4 4.2v2.7h2.6",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M8.2 10.3h5.8M8.2 13.1h5.8M8.2 15.9h5.8",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }) : null,
                                                            "CSV-Template (.csv)"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field form-field-wide",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: isFrameworkV2 ? "imports-manual-file-wrap-v2" : undefined,
                                                children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        id: manualFileInputId,
                                                        ref: manualFileInputRef,
                                                        className: "imports-manual-file-input-v2",
                                                        type: "file",
                                                        accept: ".csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv",
                                                        disabled: importMode !== "manual",
                                                        onChange: (e)=>handleManualFileSelect(e.target.files)
                                                    })
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "file",
                                                    accept: ".csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv",
                                                    disabled: importMode !== "manual",
                                                    onChange: (e)=>handleManualFileSelect(e.target.files)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `${isFrameworkV2 ? "imports-manual-dropzone-v2" : "panel-inset"} ${manualFileDragActive ? "is-drag-active" : ""}`.trim(),
                                                role: "button",
                                                tabIndex: importMode !== "manual" ? -1 : 0,
                                                "aria-disabled": importMode !== "manual",
                                                onClick: ()=>{
                                                    if (importMode !== "manual") return;
                                                    manualFileInputRef.current?.click();
                                                },
                                                onKeyDown: (e)=>{
                                                    if (importMode !== "manual") return;
                                                    if (e.key !== "Enter" && e.key !== " ") return;
                                                    e.preventDefault();
                                                    manualFileInputRef.current?.click();
                                                },
                                                onDragOver: (e)=>{
                                                    if (importMode !== "manual") return;
                                                    e.preventDefault();
                                                    setManualFileDragActive(true);
                                                },
                                                onDragLeave: (e)=>{
                                                    if (importMode !== "manual") return;
                                                    e.preventDefault();
                                                    setManualFileDragActive(false);
                                                },
                                                onDrop: (e)=>{
                                                    if (importMode !== "manual") return;
                                                    e.preventDefault();
                                                    setManualFileDragActive(false);
                                                    handleManualFileSelect(e.dataTransfer?.files);
                                                },
                                                children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "imports-manual-dropzone-icon-v2",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M12 15.8V6.8",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.8",
                                                                        strokeLinecap: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "m8.4 10.2 3.6-3.6 3.6 3.6",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.8",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                        x: "5",
                                                                        y: "16.2",
                                                                        width: "14",
                                                                        height: "2.8",
                                                                        rx: "1.1",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.8"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "imports-manual-dropzone-copy-v2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-manual-dropzone-title-v2",
                                                                    children: "Datei hierhin ziehen und ablegen"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-manual-dropzone-sub-v2",
                                                                    children: "oder klicken, um eine Datei auszuw\xe4hlen (.csv, .xls, .xlsx)"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Datei hier ablegen oder klicken zum Ausw\xe4hlen."
                                                })
                                            }),
                                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "imports-manual-selected-file-v2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "imports-manual-selected-file-label-v2",
                                                        children: "Ausgew\xe4hlte Datei"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "imports-manual-file-name-v2",
                                                        children: file?.name ?? "Keine ausgew\xe4hlt"
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: isFrameworkV2 ? "imports-manual-notes-v2" : "panel-inset",
                                children: [
                                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-manual-notes-head-v2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "imports-sync-info-icon",
                                                "aria-hidden": "true",
                                                children: "i"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Hinweise"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Hinweise"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        className: "imports-manual-notes-list-v2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Erlaubte Dateiformate: .xlsx, .xls, .csv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Maximale Dateigr\xf6\xdfe: 25 MB"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Die erste Zeile der Datei muss \xdcberschriften enthalten."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Bestehende Datens\xe4tze werden anhand der eindeutigen Schl\xfcssel aktualisiert."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `form-actions ${isFrameworkV2 ? "imports-manual-upload-row-v2" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: isFrameworkV2 ? "imports-manual-upload-btn-v2" : undefined,
                                        disabled: importMode !== "manual" || !canUpload,
                                        onClick: ()=>uploadMutation.mutate(),
                                        children: [
                                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "imports-manual-upload-btn-icon-v2",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M12 15.8V6.8",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "m8.4 10.2 3.6-3.6 3.6 3.6",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                            x: "5",
                                                            y: "16.2",
                                                            width: "14",
                                                            height: "2.8",
                                                            rx: "1.1",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8"
                                                        })
                                                    ]
                                                })
                                            }) : null,
                                            uploadMutation.isPending ? "Lade hoch..." : "Upload starten"
                                        ]
                                    }),
                                    isFrameworkV2 && (importMode !== "manual" || !file) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        className: "imports-manual-upload-hint-v2",
                                        children: "Bitte w\xe4hlen Sie zuerst eine Datei aus."
                                    }) : null
                                ]
                            }),
                            job ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "imports-v2-job-card panel-inset",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "imports-v2-job-main",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "imports-v2-job-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M6.1 3.9h7l4.8 4.8v10.2a1.8 1.8 0 0 1-1.8 1.8H6.1a1.8 1.8 0 0 1-1.8-1.8V5.7a1.8 1.8 0 0 1 1.8-1.8Z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M13.1 3.9v4.9H18",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M8.1 11.1h6.2M8.1 14.2h6.2",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "imports-v2-job-copy",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                        children: "Aktueller Job"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "imports-v2-job-line",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                children: $5bf5538ea9b06aa2$var$importLabel(job.import_typ)
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "imports-v2-job-dot",
                                                                                children: "\u2022"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                children: [
                                                                                    "Datei: ",
                                                                                    job.filename
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "imports-v2-job-dot",
                                                                                children: "\u2022"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                children: "Status:"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "imports-v2-job-status-pill",
                                                                                children: $5bf5538ea9b06aa2$var$statusLabel(job.status)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "imports-v2-job-stats",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "imports-v2-job-stat is-total",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "imports-v2-job-stat-icon",
                                                                                        "aria-hidden": "true",
                                                                                        children: "\u2713"
                                                                                    }),
                                                                                    "Gesamt: ",
                                                                                    job.total_rows ?? 0
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "imports-v2-job-stat is-valid",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "imports-v2-job-stat-icon",
                                                                                        "aria-hidden": "true",
                                                                                        children: "i"
                                                                                    }),
                                                                                    "Valide: ",
                                                                                    job.valid_rows ?? 0
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "imports-v2-job-stat is-error",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "imports-v2-job-stat-icon",
                                                                                        "aria-hidden": "true",
                                                                                        children: "!"
                                                                                    }),
                                                                                    "Fehler: ",
                                                                                    job.invalid_rows ?? 0
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "imports-v2-job-download-btn",
                                                        onClick: handleDownloadManualFile,
                                                        disabled: !file,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-v2-job-download-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M12 4.6v9.1",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "m8.1 9.8 3.9 3.9 3.9-3.9",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M5.5 18.3h13",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            "Datei herunterladen"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "imports-v2-mapping-card panel-inset",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                        className: "imports-v2-mapping-title",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-v2-mapping-step-bullet",
                                                                "aria-hidden": "true",
                                                                children: "2"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Spaltenmapping"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "imports-v2-mapping-intro v2-info-banner",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-sync-info-icon",
                                                                "aria-hidden": "true",
                                                                children: "i"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-v2-mapping-intro-copy",
                                                                children: "Ordnen Sie die Spalten Ihrer Datei den passenden Feldern im System zu. Pflichtfelder sind erforderlich f\xfcr einen erfolgreichen Import."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "imports-v2-mapping-grid",
                                                        children: requiredFields.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "imports-v2-mapping-field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                        children: [
                                                                            $5bf5538ea9b06aa2$var$importFieldLabel(field),
                                                                            " ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "imports-v2-required-star",
                                                                                children: "*"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "imports-v2-mapping-select-wrap",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                                value: mappingOptions.includes(String(mapping[field] ?? "")) ? String(mapping[field] ?? "") : "",
                                                                                onChange: (e)=>{
                                                                                    setValidationFeedback(null);
                                                                                    setMapping((prev)=>({
                                                                                            ...prev,
                                                                                            [field]: e.target.value
                                                                                        }));
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                        value: "",
                                                                                        children: "Spalte ausw\xe4hlen"
                                                                                    }),
                                                                                    mappingOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                            value: option,
                                                                                            children: option
                                                                                        }, `${field}-${option}`))
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "imports-v2-mapping-select-chevron",
                                                                                "aria-hidden": "true",
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                    viewBox: "0 0 16 16",
                                                                                    fill: "none",
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "m4 6 4 4 4-4",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.8",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, field))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "imports-v2-mapping-actions",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                className: "imports-v2-mapping-validate-btn",
                                                                disabled: !canValidate,
                                                                onClick: ()=>validateMutation.mutate(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "imports-v2-mapping-action-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                    cx: "11.2",
                                                                                    cy: "11.2",
                                                                                    r: "6.6",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.8"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "m16.2 16.2 3.3 3.3",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.8",
                                                                                    strokeLinecap: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    validateMutation.isPending ? "Validiere..." : "Validieren"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                className: "imports-v2-mapping-commit-btn",
                                                                disabled: !canCommit,
                                                                onClick: ()=>commitMutation.mutate(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "imports-v2-mapping-action-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M8.1 6.7 17 12l-8.9 5.3V6.7Z",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        })
                                                                    }),
                                                                    commitMutation.isPending ? "Importiere..." : "Import final ausf\xfchren"
                                                                ]
                                                            }),
                                                            validationFeedback ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `imports-v2-mapping-feedback-inline ${validationFeedback.type === "error" ? "is-error" : validationFeedback.type === "warn" ? "is-warn" : "is-success"}`,
                                                                role: "status",
                                                                "aria-live": "polite",
                                                                children: validationFeedback.text
                                                            }) : hasMappingConflict ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-v2-mapping-feedback-inline is-warn",
                                                                role: "status",
                                                                "aria-live": "polite",
                                                                children: mappingConflictText
                                                            }) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "imports-v2-mapping-hint",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-v2-mapping-hint-icon",
                                                                "aria-hidden": "true",
                                                                children: "i"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "Hinweis"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: "Sie k\xf6nnen die Spaltenzuordnung vor der Validierung jederzeit anpassen. Nach der Validierung sehen Sie eine Vorschau der Daten sowie etwaige Fehler."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "panel-inset imports-job-summary",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Aktueller Job:"
                                                    }),
                                                    " ",
                                                    $5bf5538ea9b06aa2$var$importLabel(job.import_typ),
                                                    " | Datei: ",
                                                    job.filename,
                                                    " | Status:",
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: $5bf5538ea9b06aa2$var$statusBadgeClass(job.status),
                                                        children: $5bf5538ea9b06aa2$var$statusLabel(job.status)
                                                    }),
                                                    validationSummary ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            marginTop: 6,
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: validationSummary
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "imports-mapping-block",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        style: {
                                                            marginBottom: 8
                                                        },
                                                        children: "2) Spaltenmapping"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "imports-mapping-grid",
                                                        children: requiredFields.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "form-field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: field
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        value: mapping[field] ?? field,
                                                                        onChange: (e)=>{
                                                                            setValidationFeedback(null);
                                                                            setMapping((prev)=>({
                                                                                    ...prev,
                                                                                    [field]: e.target.value
                                                                                }));
                                                                        },
                                                                        placeholder: `Quellspalte f\xfcr ${field}`
                                                                    })
                                                                ]
                                                            }, field))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        disabled: !canValidate,
                                                        onClick: ()=>validateMutation.mutate(),
                                                        children: validateMutation.isPending ? "Validiere..." : "Validieren"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        disabled: !canCommit,
                                                        onClick: ()=>commitMutation.mutate(),
                                                        children: commitMutation.isPending ? "Importiere..." : "Import final ausf\xfchren"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    pendingWarningConfirmations.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        style: {
                                            color: "#b54708",
                                            fontWeight: 600
                                        },
                                        children: "Bitte best\xe4tige alle \xfcberschreibbaren Meldungen, damit der Import fortgesetzt werden kann."
                                    }) : null,
                                    validationErrors.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `panel-inset imports-validation-errors${isFrameworkV2 ? " imports-v2-errors-card" : ""}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: isFrameworkV2 ? "imports-v2-errors-title" : undefined,
                                                style: {
                                                    marginTop: 0
                                                },
                                                children: "Fehlerliste"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                className: "imports-validation-errors-table",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Zeile"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Feld"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Code"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Typ"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Best\xe4tigung"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Meldung"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                        children: validationErrors.map((error, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: error.rowNumber
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: error.field
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "imports-v2-errors-code-badge",
                                                                            children: error.code
                                                                        }) : error.code
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: `imports-v2-errors-type-badge ${error.overridable ? "is-warn" : "is-error"}`,
                                                                            children: error.overridable ? "Warnung" : "Fehler"
                                                                        }) : error.overridable ? "Warnung" : "Fehler"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: error.overridable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                            className: isFrameworkV2 ? "imports-v2-errors-confirm-label" : undefined,
                                                                            style: {
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                gap: 6
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: Boolean(confirmedWarnings[error.id]),
                                                                                    onChange: (e)=>setConfirmedWarnings((prev)=>({
                                                                                                ...prev,
                                                                                                [error.id]: e.target.checked
                                                                                            }))
                                                                                }),
                                                                                "\xdcberschreiben"
                                                                            ]
                                                                        }) : "-"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: error.message
                                                                    })
                                                                ]
                                                            }, `${error.rowNumber}-${error.field}-${index}`))
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : null
                                ]
                            }) : null,
                            actionError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: isFrameworkV2 ? "imports-v2-feedback-error" : "error-text",
                                children: actionError
                            }) : null
                        ]
                    })
                ]
            }) : null,
            faciliooEnabled && importMode === "facilioo" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form imports-create-form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "imports-facilioo-section-title",
                                style: {
                                    marginTop: 0
                                },
                                children: "Facilioo-Import"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "imports-flow",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "panel-inset imports-sync-visual-card",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "imports-sync-visual-header",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "imports-sync-visual-meta",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: faciliooSyncRunning ? "Facilioo-Synchronisierung l\xe4uft" : "Facilioo-Synchronisierung"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                className: "imports-sync-last-run-line",
                                                                children: [
                                                                    "Letzter Lauf:",
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `imports-v2-badge ${lastRunWasOk ? "is-ok" : "is-error"}`,
                                                                        children: lastRunStatusLabel
                                                                    }),
                                                                    " ",
                                                                    "| ",
                                                                    lastRunAtLabel,
                                                                    " | Dauer: ",
                                                                    lastRunDurationLabel
                                                                ]
                                                            }),
                                                            faciliooSyncSnapshot?.currentRun?.message && faciliooSyncSnapshot?.running ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                className: "imports-sync-running-text",
                                                                children: faciliooSyncSnapshot.currentRun.message
                                                            }) : null,
                                                            faciliooSyncSnapshot?.webhookRun ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                className: "imports-sync-running-text imports-sync-running-text--webhook",
                                                                children: faciliooSyncSnapshot.webhookRun.running ? `Webhook-Sync l\xe4uft (${(faciliooSyncSnapshot.webhookRun.entityNames ?? []).join(", ") || "-"}), Start: ${$5bf5538ea9b06aa2$var$formatDateTimeDE(faciliooSyncSnapshot.webhookRun.startedAt)}` : `Letzter Webhook-Sync: ${$5bf5538ea9b06aa2$var$formatDateTimeDE(faciliooSyncSnapshot.webhookRun.finishedAt || faciliooSyncSnapshot.webhookRun.startedAt)} | Dauer: ${$5bf5538ea9b06aa2$var$formatDurationLabel(faciliooSyncSnapshot.webhookRun.durationMs)}${faciliooSyncSnapshot.webhookRun.message ? ` | ${faciliooSyncSnapshot.webhookRun.message}` : ""}`
                                                            }) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "imports-sync-header-live-toggle",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-sync-header-live-label",
                                                                children: "Live-Sync"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                className: "result-visibility-switch imports-facilioo-switch",
                                                                "aria-label": "Facilioo Live-Sync umschalten",
                                                                title: `Live-Sync-Fallback laeuft ${$5bf5538ea9b06aa2$var$FACILIOO_LIVE_SYNC_SCHEDULE_LABEL}.`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        className: "result-visibility-input",
                                                                        type: "checkbox",
                                                                        checked: faciliooLiveSyncEnabled,
                                                                        disabled: importMode !== "facilioo" || !uiSettings || faciliooControlPending,
                                                                        onChange: (e)=>handleFaciliooLiveSyncToggle(e.target.checked)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `result-visibility-track ${faciliooLiveSyncEnabled ? "is-on" : ""}`,
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "result-visibility-thumb"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "result-visibility-state",
                                                                        children: faciliooLiveSyncEnabled ? "Aktiv" : "Inaktiv"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "imports-sync-tooltip-hint",
                                                                title: `Live-Sync-Fallback laeuft ${$5bf5538ea9b06aa2$var$FACILIOO_LIVE_SYNC_SCHEDULE_LABEL}.`,
                                                                "aria-label": "Intervall-Hinweis",
                                                                children: "i"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "imports-sync-dataset-grid",
                                                children: $5bf5538ea9b06aa2$var$FACILIOO_DATASET_ORDER.map((dataset)=>{
                                                    const stats = faciliooSyncSnapshot?.lastRun?.datasets?.[dataset.key];
                                                    const syncState = getDatasetSyncState(dataset.key);
                                                    const progress = getDatasetProgress(dataset.key);
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: `imports-sync-dataset-card ${dataset.className} ${syncState === "running" ? "is-active" : ""}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "imports-sync-dataset-card-header",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "imports-sync-dataset-title",
                                                                        children: dataset.label
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `imports-sync-dataset-gear ${syncState === "running" ? "is-running" : ""} ${syncState === "success" ? "is-success" : ""}`,
                                                                        "aria-hidden": "true",
                                                                        title: syncState === "running" ? `${dataset.label} wird synchronisiert` : syncState === "success" ? `${dataset.label} erfolgreich abgeschlossen` : `${dataset.label} wartet`,
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                            viewBox: "0 0 24 24",
                                                                            focusable: "false",
                                                                            "aria-hidden": "true",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                                                fill: "currentColor",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                        cx: "12",
                                                                                        cy: "12",
                                                                                        r: "5.4"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                        cx: "12",
                                                                                        cy: "12",
                                                                                        r: "2.3",
                                                                                        fill: "#ffffff"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.2",
                                                                                        y: "1.2",
                                                                                        width: "1.6",
                                                                                        height: "3.2",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.2",
                                                                                        y: "19.6",
                                                                                        width: "1.6",
                                                                                        height: "3.2",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "19.6",
                                                                                        y: "11.2",
                                                                                        width: "3.2",
                                                                                        height: "1.6",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "1.2",
                                                                                        y: "11.2",
                                                                                        width: "3.2",
                                                                                        height: "1.6",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.2",
                                                                                        y: "1.2",
                                                                                        width: "1.6",
                                                                                        height: "3.2",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(45 12 12)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.2",
                                                                                        y: "1.2",
                                                                                        width: "1.6",
                                                                                        height: "3.2",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(135 12 12)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.2",
                                                                                        y: "1.2",
                                                                                        width: "1.6",
                                                                                        height: "3.2",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(225 12 12)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.2",
                                                                                        y: "1.2",
                                                                                        width: "1.6",
                                                                                        height: "3.2",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(315 12 12)"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "imports-sync-dataset-body",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: `imports-sync-dataset-avatar ${dataset.className}`,
                                                                        "aria-hidden": "true",
                                                                        children: $5bf5538ea9b06aa2$var$renderDatasetSymbol(dataset.key)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "imports-sync-dataset-stats",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                children: [
                                                                                    "Geholt: ",
                                                                                    stats?.fetched ?? 0
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                children: [
                                                                                    "Neu: ",
                                                                                    stats?.created ?? 0
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                children: [
                                                                                    "Aktualisiert: ",
                                                                                    stats?.updated ?? 0
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                children: [
                                                                                    "Unver\xe4ndert: ",
                                                                                    stats?.unchanged ?? 0
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "imports-sync-dataset-footer",
                                                                children: faciliooSyncRunning ? progress.available ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "imports-sync-progress-wrap",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                            className: "imports-sync-progress-text",
                                                                            children: [
                                                                                "Fortschritt: ",
                                                                                progress.processed,
                                                                                "/",
                                                                                progress.total,
                                                                                " (",
                                                                                progress.percent,
                                                                                "%)"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "imports-sync-progress-bar",
                                                                            "aria-hidden": "true",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                style: {
                                                                                    width: `${progress.percent}%`
                                                                                }
                                                                            })
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                    className: "imports-sync-progress-text",
                                                                    children: syncState === "running" ? "Wird aktuell verarbeitet..." : "Wird im n\xe4chsten Schritt verarbeitet..."
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                    className: "imports-sync-progress-text",
                                                                    children: "-"
                                                                })
                                                            })
                                                        ]
                                                    }, dataset.key);
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "imports-sync-info-banner v2-info-banner",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "imports-sync-info-icon",
                                                        "aria-hidden": "true",
                                                        children: "i"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "imports-sync-info-copy",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Die Synchronisierung mit Facilioo l\xe4uft. Je nach Datenmenge kann der Vorgang mehrere Minuten dauern."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Sie k\xf6nnen diese Seite verlassen - die Synchronisierung l\xe4uft im Hintergrund weiter."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "imports-sync-controls-row",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "form-actions imports-facilioo-actions-row imports-facilioo-actions-row--bottom",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: "imports-sync-cta-button is-outline has-right-icon",
                                                            disabled: importMode !== "facilioo" || faciliooTestPending,
                                                            onClick: runFaciliooTest,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M20 12a8 8 0 1 1-2.34-5.66",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M20 4v4h-4",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-label",
                                                                    children: faciliooTestPending ? "Facilioo-Test l\xe4uft..." : "Facilioo-Verbindung testen"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-icon imports-sync-cta-icon-right",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M14 5h5v5",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M19 5 10 14",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M10 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: "imports-sync-cta-button is-primary is-sync-green has-right-icon",
                                                            disabled: importMode !== "facilioo" || faciliooSyncPending || faciliooSyncRunning,
                                                            onClick: runFaciliooLiveUpdateNow,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M20 12a8 8 0 1 1-2.34-5.66",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M20 4v4h-4",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-label",
                                                                    children: faciliooSyncRunning ? "Synchronisierung l\xe4uft..." : faciliooSyncPending ? "Live-Update startet..." : "Live-Update"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-icon imports-sync-cta-icon-right",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                                                fill: "currentColor",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                        cx: "12",
                                                                                        cy: "12",
                                                                                        r: "4.6"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "19.1",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "19.1",
                                                                                        y: "11.15",
                                                                                        width: "3.1",
                                                                                        height: "1.7",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "1.8",
                                                                                        y: "11.15",
                                                                                        width: "3.1",
                                                                                        height: "1.7",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(45 12 12)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(135 12 12)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(225 12 12)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(315 12 12)"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                cx: "12",
                                                                                cy: "12",
                                                                                r: "1.7",
                                                                                fill: "#ffffff"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: "imports-sync-cta-button is-primary is-sync-green has-right-icon",
                                                            disabled: importMode !== "facilioo" || faciliooSyncPending || faciliooSyncRunning,
                                                            onClick: runFaciliooFullSyncNow,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M20 12a8 8 0 1 1-2.34-5.66",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M20 4v4h-4",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-label",
                                                                    children: faciliooSyncRunning ? "Synchronisierung l\xe4uft..." : faciliooSyncPending ? "Voll-Sync startet..." : "Voll-Sync"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-icon imports-sync-cta-icon-right",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                                                fill: "currentColor",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                        cx: "12",
                                                                                        cy: "12",
                                                                                        r: "4.6"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "19.1",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "19.1",
                                                                                        y: "11.15",
                                                                                        width: "3.1",
                                                                                        height: "1.7",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "1.8",
                                                                                        y: "11.15",
                                                                                        width: "3.1",
                                                                                        height: "1.7",
                                                                                        rx: "0.5"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(45 12 12)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(135 12 12)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(225 12 12)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                                        x: "11.15",
                                                                                        y: "1.8",
                                                                                        width: "1.7",
                                                                                        height: "3.1",
                                                                                        rx: "0.5",
                                                                                        transform: "rotate(315 12 12)"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                cx: "12",
                                                                                cy: "12",
                                                                                r: "1.7",
                                                                                fill: "#ffffff"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: "imports-sync-cta-button is-danger",
                                                            disabled: importMode !== "facilioo" || !faciliooSyncRunning || faciliooSyncCancelPending,
                                                            onClick: cancelFaciliooSyncNow,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                cx: "12",
                                                                                cy: "12",
                                                                                r: "8",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M8.6 15.4 15.4 8.6",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "imports-sync-cta-label",
                                                                    children: faciliooSyncCancelPending ? "Abbruch wird angefordert..." : "Sync abbrechen"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    faciliooTestStatus && faciliooTestStatus.type === "error" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        style: {
                                            color: "#b42318",
                                            fontWeight: 600
                                        },
                                        children: faciliooTestStatus.text
                                    }) : null,
                                    faciliooSyncStatusMessage && faciliooSyncStatusMessage.type === "error" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        style: {
                                            color: "#b42318",
                                            fontWeight: 600
                                        },
                                        children: faciliooSyncStatusMessage.text
                                    }) : null,
                                    faciliooControlStatus && faciliooControlStatus.type === "error" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        style: {
                                            color: "#b42318",
                                            fontWeight: 600
                                        },
                                        children: faciliooControlStatus.text
                                    }) : null,
                                    faciliooMirrorCleanupStatus && faciliooMirrorCleanupStatus.type === "error" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        style: {
                                            color: "#b42318",
                                            fontWeight: 600
                                        },
                                        children: faciliooMirrorCleanupStatus.text
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "imports-sync-connection-kpi",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "imports-sync-connection-kpi-header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Facilioo-Verbindungsdetails"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "imports-sync-connection-kpi-chevron",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "m6 8 4 4 4-4",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "imports-sync-connection-kpi-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-sync-connection-kpi-item",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "Verbindungsstatus"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `imports-v2-badge ${connectionLikelyHealthy ? "is-ok" : "is-error"}`,
                                                children: connectionLikelyHealthy ? "Verbunden" : "Pr\xfcfen"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-sync-connection-kpi-item",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "Letzter erfolgreicher Sync"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: lastSuccessfulSyncLabel
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-sync-connection-kpi-item",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "API-Endpunkt"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: resolvedFaciliooApiEndpoint
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-sync-connection-kpi-item",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "Zuletzt synchronisiert von"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: latestSyncActor
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
};





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
const $6325038d4357e6f6$var$getMinEndDateKey = ()=>{
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d.toISOString().slice(0, 10);
};
const $6325038d4357e6f6$export$7aee19a40772c514 = ({ open: open, beschlussnummer: beschlussnummer, enddatum: enddatum, error: error, isPending: isPending, onClose: onClose, onEnddatumChange: onEnddatumChange, onConfirm: onConfirm })=>{
    const minDate = (0, $acw62.useMemo)(()=>$6325038d4357e6f6$var$getMinEndDateKey(), []);
    if (!open) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "modal-backdrop",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "panel modal-card start-resolution-modal",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "start-resolution-title",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "start-resolution-modal-head",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "start-resolution-modal-head-icon",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "3.5",
                                        y: "5",
                                        width: "17",
                                        height: "15.5",
                                        rx: "2.5",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M7.5 3.8v3M16.5 3.8v3M3.6 9h16.8",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: "8.3",
                                        cy: "12.6",
                                        r: "1.1",
                                        fill: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: "12",
                                        cy: "12.6",
                                        r: "1.1",
                                        fill: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: "15.7",
                                        cy: "12.6",
                                        r: "1.1",
                                        fill: "currentColor"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "start-resolution-modal-head-copy",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    id: "start-resolution-title",
                                    children: "Beschluss manuell starten"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "F\xfcr Beschluss ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: beschlussnummer
                                        }),
                                        " ist kein Enddatum gesetzt. Bitte Enddatum ausw\xe4hlen, bevor gestartet wird."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "form-field start-resolution-modal-field",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            children: "Enddatum*"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "start-resolution-modal-date-wrap",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    className: "table-field start-resolution-modal-date-input",
                                    type: "date",
                                    min: minDate,
                                    value: enddatum,
                                    onChange: (e)=>onEnddatumChange(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "start-resolution-modal-date-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                x: "4.5",
                                                y: "6.5",
                                                width: "15",
                                                height: "13",
                                                rx: "2.2",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M8 4.5v3M16 4.5v3M4.8 10h14.4",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "error-text start-resolution-modal-error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "form-actions start-resolution-modal-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "start-resolution-modal-cancel-btn",
                            onClick: onClose,
                            disabled: isPending,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "start-resolution-modal-btn-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M6 6l12 12M18 6L6 18",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round"
                                        })
                                    })
                                }),
                                "Abbrechen"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "start-resolution-modal-submit-btn",
                            onClick: onConfirm,
                            disabled: isPending,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "start-resolution-modal-btn-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M7 5.8v12.4L18 12 7 5.8Z",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                }),
                                isPending ? "Starte..." : "Starten"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




const $ca55c84b1bbe2a8d$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS = [
    {
        key: "resolution_started",
        label: "Info \xfcber Start des Beschlusses"
    },
    {
        key: "invitation_sent_success",
        label: "Info \xfcber erfolgreichen Versand der Einladung"
    },
    {
        key: "email_bounce_after_retries",
        label: "Info \xfcber E-Mail R\xfcckl\xe4ufer nach fehlgeschlagenen Retries"
    },
    {
        key: "analog_postal_action_required",
        label: "Hinweis bei analogen Eigent\xfcmern (postalischer Versand erforderlich)"
    },
    {
        key: "vote_with_comment",
        label: "Info bei Stimmabgabe mit Kommentar (inkl. Kommentarinhalt)"
    },
    {
        key: "reminder_sent",
        label: "Info \xfcber Versand von Erinnerungsschreiben (1/2) inkl. Empf\xe4nger"
    },
    {
        key: "each_vote_submitted",
        label: "Info \xfcber jede Stimmabgabe"
    },
    {
        key: "preliminary_result_locked",
        label: "Info bei vorl\xe4ufigem Endergebnis (Ergebnis kann nicht mehr kippen)"
    },
    {
        key: "resolution_finished_with_result",
        label: "Info \xfcber Ende des Beschlusses inkl. Ergebnis"
    }
];
const $ca55c84b1bbe2a8d$var$defaultTriggerNotificationEvents = ()=>Object.fromEntries($ca55c84b1bbe2a8d$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS.map((eventOption)=>[
            eventOption.key,
            false
        ]));
const $ca55c84b1bbe2a8d$var$allTriggerNotificationEvents = ()=>Object.fromEntries($ca55c84b1bbe2a8d$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS.map((eventOption)=>[
            eventOption.key,
            true
        ]));
const $ca55c84b1bbe2a8d$var$ResolutionMenuIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.1 4.6h6.6l3.2 3.2v11.6H7.1z",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.7 4.8v3.1h3",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m9.4 14.1 2 2 4.2-5",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.7",
                cy: "17.8",
                r: "2.1",
                fill: "#fff",
                stroke: "currentColor",
                strokeWidth: "1.85"
            })
        ]
    });
const $ca55c84b1bbe2a8d$var$ResolutionCreateSectionIcon = ({ name: name })=>{
    if (name === "resolution") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionMenuIcon, {});
    if (name === "upload") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.3 14.8h11.4a1.5 1.5 0 0 0 1.5-1.5V6.8a1.5 1.5 0 0 0-1.5-1.5H10L8.5 3.8H4.3a1.5 1.5 0 0 0-1.5 1.5v8a1.5 1.5 0 0 0 1.5 1.5Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 12.2V7.5M7.9 9.4 10 7.3l2.1 2.1",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (name === "search") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "8.9",
                cy: "8.9",
                r: "5.6",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m13 13 4 4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "select") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4.1",
                y: "4.1",
                width: "11.8",
                height: "11.8",
                rx: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m7.2 10.1 2 2 3.9-4.2",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (name === "unit") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.1",
                y: "4.1",
                width: "9.8",
                height: "11.8",
                rx: "1.8",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.4 7.5h2M10.8 7.5h2M7.4 10.5h2M10.8 10.5h2M8.1 15.9v-2.2h3.8v2.2",
                stroke: "currentColor",
                strokeWidth: "1.6",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "pin") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 17s4.8-4.6 4.8-8.1a4.8 4.8 0 1 0-9.6 0C5.2 12.4 10 17 10 17Z",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "8.9",
                r: "1.6",
                stroke: "currentColor",
                strokeWidth: "1.7"
            })
        ]
    });
    if (name === "home") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.4 8.7 10 4.4l5.6 4.3v6.8h-4.1v-3.8h-3v3.8H4.4V8.7Z",
            stroke: "currentColor",
            strokeWidth: "1.7",
            strokeLinejoin: "round"
        })
    });
    if (name === "owner") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "7.4",
                r: "2.5",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.2 15.9a4.8 4.8 0 0 1 9.6 0",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.2 3.8h6.5l2.9 2.9v8.6a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 15.3V5a1.2 1.2 0 0 1 1.2-1.2Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.8 9.4h6.1M6.8 12.2h5",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
};
const $ca55c84b1bbe2a8d$var$ResolutionCreateTableHeader = ({ label: label, icon: icon, center: center = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `resolutions-v2-th-plain${center ? " resolution-create-v2-th-center" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-icon",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateSectionIcon, {
                    name: icon
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-label",
                children: label
            })
        ]
    });
const $ca55c84b1bbe2a8d$var$mergeSelectedFiles = (previous, incoming, replace = false)=>{
    const base = replace ? [] : previous;
    const deduped = new Map();
    for (const file of base)deduped.set(`${file.name}__${file.size}__${file.lastModified}`, file);
    for (const file of incoming)deduped.set(`${file.name}__${file.size}__${file.lastModified}`, file);
    return Array.from(deduped.values());
};
const $ca55c84b1bbe2a8d$var$normalizeTriggerNotificationEvents = (value)=>{
    const base = $ca55c84b1bbe2a8d$var$defaultTriggerNotificationEvents();
    if (!value) return base;
    for (const [key, raw] of Object.entries(value)){
        if (!(key in base)) continue;
        base[key] = Boolean(raw);
    }
    return base;
};
const $ca55c84b1bbe2a8d$var$getDefaultTriggerNotificationChannel = (faciliooEnabled)=>faciliooEnabled ? "facilioo" : "email";
const $ca55c84b1bbe2a8d$var$buildEmptyResolutionForm = (faciliooEnabled)=>({
        objectId: "",
        beschlussnummer: "",
        titel: "",
        startdatum: "",
        endedatum: "",
        stimmrechtsart: "kopf",
        quorum: "allstimmig",
        vorbeschluss_top: "",
        vorbeschluss_wev_datum: "",
        beschlusstext: "",
        facilioo_vorgangsnummer: "",
        dispatch_automation_enabled: false,
        trigger_notifications_enabled: false,
        trigger_notifications_channel: $ca55c84b1bbe2a8d$var$getDefaultTriggerNotificationChannel(faciliooEnabled),
        trigger_notifications_events: $ca55c84b1bbe2a8d$var$defaultTriggerNotificationEvents(),
        stimmberechtigte_einheiten: []
    });
const $ca55c84b1bbe2a8d$var$isVorbeschlussRequired = (quorum)=>quorum !== "allstimmig";
const $ca55c84b1bbe2a8d$var$getTodayDateKey = ()=>new Date().toISOString().slice(0, 10);
const $ca55c84b1bbe2a8d$var$getDateFieldErrors = (startdatum, endedatum)=>{
    const today = $ca55c84b1bbe2a8d$var$getTodayDateKey();
    const startError = startdatum && startdatum <= today ? "Startdatum muss in der Zukunft liegen" : null;
    const endError = startdatum && endedatum && endedatum <= startdatum ? "Enddatum muss nach dem Startdatum liegen" : null;
    return {
        startError: startError,
        endError: endError
    };
};
const $ca55c84b1bbe2a8d$var$formatDateDE = (value)=>{
    if (!value) return "-";
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? `${m[3]}.${m[2]}.${m[1]}` : value;
};
const $ca55c84b1bbe2a8d$var$getRemainingDays = (endDate)=>{
    if (!endDate) return null;
    const match = endDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    const [, yearRaw, monthRaw, dayRaw] = match;
    const end = new Date(Number(yearRaw), Number(monthRaw) - 1, Number(dayRaw));
    if (Number.isNaN(end.getTime())) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const millisecondsPerDay = 86400000;
    const diffDays = Math.floor((end.getTime() - today.getTime()) / millisecondsPerDay) + 1;
    return Math.max(0, diffDays);
};
const $ca55c84b1bbe2a8d$var$parseFacilioo = (value)=>{
    const trimmed = value.trim();
    if (!trimmed) return undefined;
    if (!/^\d{1,10}$/.test(trimmed)) throw new Error("Facilioo Vorgangsnummer muss 1 bis 10-stellig numerisch sein");
    return Number(trimmed);
};
const $ca55c84b1bbe2a8d$var$formatStatus = (status)=>{
    if (status === "aktiv") return "l\xe4uft";
    if (status === "abgeschlossen") return "beendet";
    return "Entwurf";
};
const $ca55c84b1bbe2a8d$var$formatStimmrechtsart = (value)=>{
    if (value === "kopf") return "Kopfstimmen";
    if (value === "mea") return "MEA";
    return "Stimmrecht";
};
const $ca55c84b1bbe2a8d$var$formatQuorum = (value)=>{
    if (value === "qualifizierte_mehrheit") return "Qualifizierte Mehrheit";
    if (value === "allstimmig") return "Allstimmig";
    return "Einfache Mehrheit";
};
const $ca55c84b1bbe2a8d$var$formatSelectionUnitNumber = (value)=>{
    const raw = String(value ?? "").trim();
    if (!raw) return "-";
    return /^\d+$/.test(raw) ? raw.padStart(4, "0") : raw;
};
const $ca55c84b1bbe2a8d$var$formatOwnerDisplayName = (owner)=>{
    const parts = [
        String(owner.anrede ?? "").trim(),
        String(owner.vorname ?? "").trim(),
        String(owner.name_1 ?? "").trim(),
        String(owner.name_2 ?? "").trim(),
        String(owner.name_3 ?? "").trim()
    ].filter(Boolean);
    if (parts.length) return parts.join(" ");
    return String(owner.vollname ?? "").trim() || "-";
};
const $ca55c84b1bbe2a8d$var$formatOwnerLabelFallback = (value)=>{
    const raw = String(value ?? "").trim();
    if (!raw) return "-";
    return raw.replace(/^\s*\d+\s*-\s*/u, "").trim() || raw;
};
const $ca55c84b1bbe2a8d$var$normalizeValidationErrorMessage = (error)=>{
    const fallback = "Facilioo Vorgang konnte nicht validiert werden.";
    const raw = error instanceof Error ? error.message : fallback;
    return String(raw).replace(/^API\s+\d+\s*:?\s*/i, "").trim() || fallback;
};
const $ca55c84b1bbe2a8d$var$getOutcome = (r)=>{
    if (r.status !== "abgeschlossen") return {
        label: "-"
    };
    return r.quorum_erfuellt ? {
        label: "Angenommen",
        tone: "success"
    } : {
        label: "Abgelehnt",
        tone: "danger"
    };
};
const $ca55c84b1bbe2a8d$var$buildUnitSelectionRows = (units, assignments, owners)=>{
    const ownerMap = new Map(owners.map((o)=>[
            o.id,
            $ca55c84b1bbe2a8d$var$formatOwnerDisplayName(o)
        ]));
    return units.filter((u)=>u.status === "aktiv").map((unit)=>{
        const ownerLabels = assignments.filter((a)=>a.unitId === unit.id && a.status === "aktiv").map((a)=>ownerMap.get(a.ownerId) ?? $ca55c84b1bbe2a8d$var$formatOwnerLabelFallback(a.eigentuemername)).filter(Boolean);
        return {
            unitId: unit.id,
            einheitsnummer: unit.einheitsnummer,
            bezeichnung: unit.bezeichnung || "-",
            einheitstyp: unit.einheitstyp || "-",
            aufgang: unit.aufgangName || "-",
            eigentuemerInfo: Array.from(new Set(ownerLabels)).join(" | ") || "-"
        };
    }).sort((a, b)=>a.einheitsnummer.localeCompare(b.einheitsnummer));
};
const $ca55c84b1bbe2a8d$var$hasConfiguredStimmrechte = (units)=>units.some((unit)=>Number(unit.stimmrecht ?? 0) > 0);
const $ca55c84b1bbe2a8d$var$resolveDefaultStimmrechtsart = (objectDefault, hasStimmrechte)=>{
    if (objectDefault === "stimmrecht" && !hasStimmrechte) return "kopf";
    return objectDefault ?? (hasStimmrechte ? "stimmrecht" : "kopf");
};
const $ca55c84b1bbe2a8d$var$renderUnitSelector = (rows, selectedUnitIds, ownerSearch, setOwnerSearch, unitTypeFilter, setUnitTypeFilter, entranceFilter, setEntranceFilter, onToggleUnit, onSelectAll, onDeselectAll, onMarkFiltered, onDemarkFiltered, isFrameworkV2 = false)=>{
    const needle = ownerSearch.trim().toLowerCase();
    const filteredRows = rows.filter((row)=>{
        const unitNumberFormatted = $ca55c84b1bbe2a8d$var$formatSelectionUnitNumber(row.einheitsnummer).toLowerCase();
        const searchOk = !needle || row.eigentuemerInfo.toLowerCase().includes(needle) || row.einheitsnummer.toLowerCase().includes(needle) || unitNumberFormatted.includes(needle);
        const typeOk = !unitTypeFilter || row.einheitstyp === unitTypeFilter;
        const entranceOk = !entranceFilter || row.aufgang === entranceFilter;
        return searchOk && typeOk && entranceOk;
    });
    const availableUnitTypes = Array.from(new Set(rows.map((row)=>row.einheitstyp))).sort((a, b)=>a.localeCompare(b));
    const availableEntrances = Array.from(new Set(rows.map((row)=>row.aufgang))).sort((a, b)=>a.localeCompare(b));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "form-field form-field-wide resolution-selection-box",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: isFrameworkV2 ? "resolution-create-v2-section-head" : undefined,
                children: [
                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "resolution-create-v2-section-icon",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateSectionIcon, {
                            name: "select"
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        children: "Stimmberechtigte Eigent\xfcmer/Einheiten*"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: isFrameworkV2 ? "resolutions-v2-filterbar resolution-create-v2-unit-filterbar" : undefined,
                style: isFrameworkV2 ? undefined : {
                    display: "flex",
                    gap: 8,
                    flexWrap: "wrap",
                    marginBottom: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: isFrameworkV2 ? "resolutions-v2-filter-fields resolution-create-v2-filter-fields" : undefined,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: isFrameworkV2 ? "resolutions-v2-filter-input resolution-create-v2-filter-input" : undefined,
                                children: [
                                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-filter-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateSectionIcon, {
                                            name: "search"
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Eigent\xfcmer suchen (ID oder Name)",
                                        value: ownerSearch,
                                        onChange: (e)=>setOwnerSearch(e.target.value),
                                        style: isFrameworkV2 ? undefined : {
                                            minWidth: 280
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: unitTypeFilter,
                                onChange: (e)=>setUnitTypeFilter(e.target.value),
                                style: isFrameworkV2 ? undefined : {
                                    minWidth: 180
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Alle Einheitstypen"
                                    }),
                                    availableUnitTypes.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: value,
                                            children: value
                                        }, value))
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: entranceFilter,
                                onChange: (e)=>setEntranceFilter(e.target.value),
                                style: isFrameworkV2 ? undefined : {
                                    minWidth: 220
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Alle Aufg\xe4nge"
                                    }),
                                    availableEntrances.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: value,
                                            children: value
                                        }, value))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: isFrameworkV2 ? "resolution-create-v2-filter-actions" : undefined,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onSelectAll,
                                children: "Alle markieren"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onDeselectAll,
                                children: "Alle demarkieren"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onMarkFiltered,
                                disabled: !filteredRows.length,
                                children: "Gefilterte markieren"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onDemarkFiltered,
                                disabled: !filteredRows.length,
                                children: "Gefilterte demarkieren"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: isFrameworkV2 ? "resolution-create-v2-table-wrap" : undefined,
                style: isFrameworkV2 ? undefined : {
                    border: "1px solid var(--line)",
                    borderRadius: 6,
                    minHeight: 220,
                    height: 280,
                    resize: "vertical",
                    overflow: "auto"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: isFrameworkV2 ? "resolution-create-v2-unit-table" : undefined,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        style: {
                                            width: 60
                                        },
                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateTableHeader, {
                                            label: "Aktiv",
                                            icon: "select",
                                            center: true
                                        }) : "Aktiv"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        style: {
                                            textAlign: "center"
                                        },
                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateTableHeader, {
                                            label: "Einheit",
                                            icon: "unit",
                                            center: true
                                        }) : "Einheit"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateTableHeader, {
                                            label: "Aufgang",
                                            icon: "home"
                                        }) : "Aufgang"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateTableHeader, {
                                            label: "Lage",
                                            icon: "pin"
                                        }) : "Lage"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateTableHeader, {
                                            label: "Einheitstyp",
                                            icon: "form"
                                        }) : "Einheitstyp"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateTableHeader, {
                                            label: "Eigent\xfcmer",
                                            icon: "owner"
                                        }) : "Eigent\xfcmer"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                            children: [
                                filteredRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: selectedUnitIds.includes(row.unitId),
                                                    onChange: (e)=>onToggleUnit(row.unitId, e.target.checked)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: $ca55c84b1bbe2a8d$var$formatSelectionUnitNumber(row.einheitsnummer)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.aufgang
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.bezeichnung
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.einheitstyp
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: row.eigentuemerInfo
                                            })
                                        ]
                                    }, row.unitId)),
                                !filteredRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: 6,
                                        children: "Keine passenden Einheiten gefunden."
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: isFrameworkV2 ? "resolution-create-v2-selection-count" : undefined,
                style: isFrameworkV2 ? undefined : {
                    marginTop: 6,
                    color: "var(--text-soft)",
                    fontSize: 12
                },
                children: [
                    "Ausgew\xe4hlt: ",
                    selectedUnitIds.length,
                    " von ",
                    rows.length,
                    " Einheiten"
                ]
            })
        ]
    });
};
const $ca55c84b1bbe2a8d$export$db608687e7fe74cc = ({ canManageMasterDataActions: canManageMasterDataActions = false, canCreateResolutions: canCreateResolutions = false, canEditResolutions: canEditResolutions = false, canDeleteResolutions: canDeleteResolutions = false, canDeleteCompletedResolutions: canDeleteCompletedResolutions = false })=>{
    const canDeleteAnyResolution = canDeleteResolutions || canDeleteCompletedResolutions;
    const qc = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [pageSize, setPageSize] = (0, $acw62.useState)(10);
    const [page, setPage] = (0, $acw62.useState)(1);
    const [search, setSearch] = (0, $acw62.useState)("");
    const [debouncedSearch, setDebouncedSearch] = (0, $acw62.useState)("");
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)("");
    const [resultFilter, setResultFilter] = (0, $acw62.useState)("");
    const [sortBy, setSortBy] = (0, $acw62.useState)("objektnummer");
    const [sortDir, setSortDir] = (0, $acw62.useState)("asc");
    const [openActionMenuId, setOpenActionMenuId] = (0, $acw62.useState)(null);
    const [actionMenuPosition, setActionMenuPosition] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const [showCreate, setShowCreate] = (0, $acw62.useState)(false);
    const [createError, setCreateError] = (0, $acw62.useState)("");
    const [editError, setEditError] = (0, $acw62.useState)("");
    const [actionError, setActionError] = (0, $acw62.useState)("");
    const [deleteConfirm, setDeleteConfirm] = (0, $acw62.useState)(null);
    const [startConfirm, setStartConfirm] = (0, $acw62.useState)(null);
    const [stopConfirm, setStopConfirm] = (0, $acw62.useState)(null);
    const [editForm, setEditForm] = (0, $acw62.useState)(null);
    const [createOwnerSearch, setCreateOwnerSearch] = (0, $acw62.useState)("");
    const [createUnitTypeFilter, setCreateUnitTypeFilter] = (0, $acw62.useState)("");
    const [createEntranceFilter, setCreateEntranceFilter] = (0, $acw62.useState)("");
    const [createDocuments, setCreateDocuments] = (0, $acw62.useState)([]);
    const [createDocumentsDropActive, setCreateDocumentsDropActive] = (0, $acw62.useState)(false);
    const createDocumentsInputRef = (0, $acw62.useRef)(null);
    const [createFaciliooValidationPending, setCreateFaciliooValidationPending] = (0, $acw62.useState)(false);
    const [createFaciliooValidationError, setCreateFaciliooValidationError] = (0, $acw62.useState)("");
    const [createFaciliooProcessTitle, setCreateFaciliooProcessTitle] = (0, $acw62.useState)("");
    const [editOwnerSearch, setEditOwnerSearch] = (0, $acw62.useState)("");
    const [editUnitTypeFilter, setEditUnitTypeFilter] = (0, $acw62.useState)("");
    const [editEntranceFilter, setEditEntranceFilter] = (0, $acw62.useState)("");
    const [editFaciliooValidationPending, setEditFaciliooValidationPending] = (0, $acw62.useState)(false);
    const [editFaciliooValidationError, setEditFaciliooValidationError] = (0, $acw62.useState)("");
    const [editFaciliooProcessTitle, setEditFaciliooProcessTitle] = (0, $acw62.useState)("");
    const [pendingAutoSelectObjectId, setPendingAutoSelectObjectId] = (0, $acw62.useState)(null);
    const [form, setForm] = (0, $acw62.useState)($ca55c84b1bbe2a8d$var$buildEmptyResolutionForm(false));
    const mergeCreateDocuments = (incoming, replace = false)=>{
        setCreateDocuments((prev)=>$ca55c84b1bbe2a8d$var$mergeSelectedFiles(prev, incoming, replace));
    };
    const onCreateDocumentsDrop = (event)=>{
        event.preventDefault();
        setCreateDocumentsDropActive(false);
        mergeCreateDocuments(Array.from(event.dataTransfer.files ?? []), false);
    };
    (0, $acw62.useEffect)(()=>{
        const handle = window.setTimeout(()=>setDebouncedSearch(search.trim()), 450);
        return ()=>window.clearTimeout(handle);
    }, [
        search
    ]);
    const { data: data, isError: isError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolutions",
            page,
            pageSize,
            debouncedSearch,
            statusFilter,
            resultFilter,
            sortBy,
            sortDir
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                page: page,
                pageSize: pageSize,
                search: debouncedSearch,
                status: statusFilter || undefined,
                ergebnis: resultFilter || undefined,
                sortBy: sortBy === "restlaufzeit" ? "objektnummer" : sortBy,
                sortDir: sortDir
            }),
        placeholderData: (previousData)=>previousData,
        staleTime: 180000,
        gcTime: 1800000,
        refetchOnMount: false
    });
    const { data: objectsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "objects-select"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).objects({
                page: 1,
                pageSize: 200,
                status: "aktiv",
                sortBy: "objektnummer",
                sortDir: "asc"
            })
    });
    const { data: uiSettingsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-resolutions"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings()
    });
    const { data: nextResolutionNumberData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolutions-next-beschlussnummer"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).nextResolutionNumber(),
        staleTime: 15000
    });
    const { data: createUnitsData, isFetched: createUnitsFetched } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-create-units",
            form.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: 1,
                pageSize: 1200,
                objectId: form.objectId,
                status: "aktiv"
            }),
        enabled: showCreate && !!form.objectId,
        staleTime: 300000,
        refetchOnMount: false
    });
    const { data: createAssignmentsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-create-assignments",
            form.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).assignments({
                page: 1,
                pageSize: 2000,
                objectId: form.objectId,
                status: "aktiv"
            }),
        enabled: showCreate && !!form.objectId,
        staleTime: 300000,
        refetchOnMount: false
    });
    const { data: createOwnersData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-create-owners",
            form.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                page: 1,
                pageSize: 1200,
                objectId: form.objectId,
                status: "aktiv"
            }),
        enabled: showCreate && !!form.objectId,
        staleTime: 300000,
        refetchOnMount: false
    });
    const { data: editUnitsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-edit-units",
            editForm?.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                page: 1,
                pageSize: 1200,
                objectId: editForm.objectId,
                status: "aktiv"
            }),
        enabled: !!editForm?.objectId,
        staleTime: 300000,
        refetchOnMount: false
    });
    const { data: editAssignmentsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-edit-assignments",
            editForm?.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).assignments({
                page: 1,
                pageSize: 2000,
                objectId: editForm.objectId,
                status: "aktiv"
            }),
        enabled: !!editForm?.objectId,
        staleTime: 300000,
        refetchOnMount: false
    });
    const { data: editOwnersData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-edit-owners",
            editForm?.objectId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                page: 1,
                pageSize: 1200,
                objectId: editForm.objectId,
                status: "aktiv"
            }),
        enabled: !!editForm?.objectId,
        staleTime: 300000,
        refetchOnMount: false
    });
    const createUnitRows = (0, $acw62.useMemo)(()=>$ca55c84b1bbe2a8d$var$buildUnitSelectionRows(createUnitsData?.data ?? [], createAssignmentsData?.data ?? [], createOwnersData?.data ?? []), [
        createUnitsData?.data,
        createAssignmentsData?.data,
        createOwnersData?.data
    ]);
    const editUnitRows = (0, $acw62.useMemo)(()=>$ca55c84b1bbe2a8d$var$buildUnitSelectionRows(editUnitsData?.data ?? [], editAssignmentsData?.data ?? [], editOwnersData?.data ?? []), [
        editUnitsData?.data,
        editAssignmentsData?.data,
        editOwnersData?.data
    ]);
    const createHasStimmrechte = (0, $acw62.useMemo)(()=>$ca55c84b1bbe2a8d$var$hasConfiguredStimmrechte(createUnitsData?.data ?? []), [
        createUnitsData?.data
    ]);
    const editHasStimmrechte = (0, $acw62.useMemo)(()=>$ca55c84b1bbe2a8d$var$hasConfiguredStimmrechte(editUnitsData?.data ?? []), [
        editUnitsData?.data
    ]);
    const createObjectStandardStimmrechtsart = (0, $acw62.useMemo)(()=>(objectsData?.data ?? []).find((o)=>o.id === form.objectId)?.standard_stimmrechtsart, [
        objectsData?.data,
        form.objectId
    ]);
    const editObjectStandardStimmrechtsart = (0, $acw62.useMemo)(()=>(objectsData?.data ?? []).find((o)=>o.id === editForm?.objectId)?.standard_stimmrechtsart, [
        objectsData?.data,
        editForm?.objectId
    ]);
    const createCanUseStimmrecht = createHasStimmrechte;
    const editCanUseStimmrecht = editHasStimmrechte;
    const faciliooEnabled = uiSettingsData?.management?.faciliooEnabled !== false;
    const createDateErrors = $ca55c84b1bbe2a8d$var$getDateFieldErrors(form.startdatum, form.endedatum);
    const editDateErrors = $ca55c84b1bbe2a8d$var$getDateFieldErrors(editForm?.startdatum, editForm?.endedatum);
    const objectById = (0, $acw62.useMemo)(()=>{
        const map = new Map();
        for (const objectRow of objectsData?.data ?? [])map.set(objectRow.id, {
            objektnummer: objectRow.objektnummer,
            objektname: objectRow.objektname
        });
        return map;
    }, [
        objectsData?.data
    ]);
    const getFilteredResolutionUnitIds = (rows, ownerSearch, unitTypeFilter, entranceFilter)=>{
        const needle = ownerSearch.trim().toLowerCase();
        return rows.filter((row)=>{
            const searchOk = !needle || row.eigentuemerInfo.toLowerCase().includes(needle) || row.einheitsnummer.toLowerCase().includes(needle);
            const typeOk = !unitTypeFilter || row.einheitstyp === unitTypeFilter;
            const entranceOk = !entranceFilter || row.aufgang === entranceFilter;
            return searchOk && typeOk && entranceOk;
        }).map((row)=>row.unitId);
    };
    (0, $acw62.useEffect)(()=>{
        setPage(1);
    }, [
        search,
        statusFilter,
        resultFilter,
        sortBy,
        sortDir,
        pageSize
    ]);
    (0, $acw62.useEffect)(()=>{
        setOpenActionMenuId(null);
    }, [
        page,
        search,
        statusFilter,
        resultFilter,
        sortBy,
        sortDir,
        showCreate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = (event)=>{
            if (event && (0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            setOpenActionMenuId(null);
        };
        const handleEscape = (event)=>{
            if (event.key === "Escape") closeMenu();
        };
        window.addEventListener("mousedown", closeMenu);
        window.addEventListener("keydown", handleEscape);
        return ()=>{
            window.removeEventListener("mousedown", closeMenu);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = ()=>setOpenActionMenuId(null);
        window.addEventListener("resize", closeMenu);
        window.addEventListener("scroll", closeMenu, true);
        return ()=>{
            window.removeEventListener("resize", closeMenu);
            window.removeEventListener("scroll", closeMenu, true);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!openActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>setOpenActionMenuId(null),
        timeoutMs: 3000
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) {
            setActionMenuPosition(null);
            setIsActionMenuHovered(false);
        }
    }, [
        openActionMenuId
    ]);
    const openActionMenuAtTrigger = (menuId, trigger, menuHeight = 188)=>{
        const rect = trigger.getBoundingClientRect();
        const menuWidth = 170;
        const margin = 8;
        const left = Math.min(Math.max(margin, rect.right - menuWidth), Math.max(margin, window.innerWidth - menuWidth - margin));
        const belowTop = rect.bottom + 6;
        const aboveTop = rect.top - menuHeight - 6;
        const top = belowTop + menuHeight <= window.innerHeight - margin ? belowTop : Math.max(margin, aboveTop);
        setActionMenuPosition({
            left: left,
            top: top
        });
        setOpenActionMenuId(menuId);
    };
    (0, $acw62.useEffect)(()=>{
        if (!pendingAutoSelectObjectId) return;
        if (!createUnitsFetched) return;
        if (form.objectId !== pendingAutoSelectObjectId) return;
        setForm((prev)=>({
                ...prev,
                stimmrechtsart: $ca55c84b1bbe2a8d$var$resolveDefaultStimmrechtsart(createObjectStandardStimmrechtsart, createHasStimmrechte),
                stimmberechtigte_einheiten: createUnitRows.map((row)=>row.unitId)
            }));
        setPendingAutoSelectObjectId(null);
    }, [
        pendingAutoSelectObjectId,
        createUnitsFetched,
        form.objectId,
        createUnitRows,
        createHasStimmrechte,
        createObjectStandardStimmrechtsart
    ]);
    (0, $acw62.useEffect)(()=>{
        if (form.stimmrechtsart === "stimmrecht" && !createCanUseStimmrecht) setForm((prev)=>({
                ...prev,
                stimmrechtsart: $ca55c84b1bbe2a8d$var$resolveDefaultStimmrechtsart(createObjectStandardStimmrechtsart, createHasStimmrechte)
            }));
    }, [
        form.stimmrechtsart,
        createCanUseStimmrecht,
        createObjectStandardStimmrechtsart,
        createHasStimmrechte
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!editForm) return;
        if (editForm.stimmrechtsart === "stimmrecht" && !editCanUseStimmrecht) setEditForm((prev)=>prev ? {
                ...prev,
                stimmrechtsart: $ca55c84b1bbe2a8d$var$resolveDefaultStimmrechtsart(editObjectStandardStimmrechtsart, editHasStimmrechte)
            } : prev);
    }, [
        editForm,
        editCanUseStimmrecht,
        editObjectStandardStimmrechtsart,
        editHasStimmrechte
    ]);
    (0, $acw62.useEffect)(()=>{
        if (faciliooEnabled) return;
        setForm((prev)=>prev.trigger_notifications_channel === "facilioo" ? {
                ...prev,
                trigger_notifications_channel: "email"
            } : prev);
        setEditForm((prev)=>prev && prev.trigger_notifications_channel === "facilioo" ? {
                ...prev,
                trigger_notifications_channel: "email"
            } : prev);
    }, [
        faciliooEnabled
    ]);
    (0, $acw62.useEffect)(()=>{
        setCreateFaciliooValidationError("");
        setCreateFaciliooProcessTitle("");
    }, [
        form.objectId,
        form.facilioo_vorgangsnummer
    ]);
    (0, $acw62.useEffect)(()=>{
        setEditFaciliooValidationError("");
        setEditFaciliooProcessTitle("");
    }, [
        editForm?.objectId,
        editForm?.facilioo_vorgangsnummer
    ]);
    const createHasVorbeschlussTop = !!form.vorbeschluss_top.trim();
    const createHasVorbeschlussDate = !!form.vorbeschluss_wev_datum;
    const createVorbeschlussPairValid = createHasVorbeschlussTop === createHasVorbeschlussDate;
    const createVorbeschlussValid = createVorbeschlussPairValid;
    const editHasVorbeschlussTop = !!editForm?.vorbeschluss_top.trim();
    const editHasVorbeschlussDate = !!editForm?.vorbeschluss_wev_datum;
    const editVorbeschlussPairValid = editHasVorbeschlussTop === editHasVorbeschlussDate;
    const editVorbeschlussValid = editVorbeschlussPairValid;
    const createFaciliooRefFilled = !!form.facilioo_vorgangsnummer.trim();
    const editFaciliooRefFilled = !!editForm?.facilioo_vorgangsnummer.trim();
    const createFaciliooValid = !createFaciliooRefFilled || !!createFaciliooProcessTitle && !createFaciliooValidationError;
    // Beim Bearbeiten darf der Speichern-Button nicht blockieren, nur weil der
    // Vorgangstitel noch nicht vorab geladen wurde. Die finale Prüfung läuft in
    // `validateEditFaciliooProcess()` beim tatsächlichen Speichern.
    const editFaciliooValid = !editFaciliooRefFilled || !editFaciliooValidationError;
    const canCreate = !!(form.objectId && form.titel.trim() && form.beschlusstext.trim() && form.stimmberechtigte_einheiten.length && !createDateErrors.startError && !createDateErrors.endError && createVorbeschlussValid && createFaciliooValid);
    const canEdit = !!(editForm && editForm.objectId && editForm.titel.trim() && editForm.beschlusstext.trim() && editForm.stimmberechtigte_einheiten.length && !editDateErrors.startError && !editDateErrors.endError && editVorbeschlussValid && editFaciliooValid);
    const resolutionNumberHint = "Wird systemseitig vergeben";
    const createResolutionNumber = nextResolutionNumberData?.beschlussnummer ?? "Wird beim Speichern vergeben";
    const rawRows = data?.data ?? [];
    const rows = (0, $acw62.useMemo)(()=>{
        if (sortBy !== "restlaufzeit") return rawRows;
        const sorted = [
            ...rawRows
        ].sort((a, b)=>{
            const aDays = $ca55c84b1bbe2a8d$var$getRemainingDays(a.endedatum);
            const bDays = $ca55c84b1bbe2a8d$var$getRemainingDays(b.endedatum);
            if (aDays === null && bDays === null) return a.beschlussnummer.localeCompare(b.beschlussnummer, "de");
            if (aDays === null) return 1;
            if (bDays === null) return -1;
            if (aDays !== bDays) return aDays - bDays;
            return a.beschlussnummer.localeCompare(b.beschlussnummer, "de");
        });
        return sortDir === "asc" ? sorted : sorted.reverse();
    }, [
        rawRows,
        sortBy,
        sortDir
    ]);
    const totalRows = data?.meta.total ?? 0;
    const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
    (0, $acw62.useEffect)(()=>{
        if (!data) return;
        const nextPage = page + 1;
        if (nextPage > totalPages) return;
        qc.prefetchQuery({
            queryKey: [
                "resolutions",
                nextPage,
                pageSize,
                debouncedSearch,
                statusFilter,
                resultFilter,
                sortBy,
                sortDir
            ],
            queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                    page: nextPage,
                    pageSize: pageSize,
                    search: debouncedSearch,
                    status: statusFilter || undefined,
                    ergebnis: resultFilter || undefined,
                    sortBy: sortBy === "restlaufzeit" ? "objektnummer" : sortBy,
                    sortDir: sortDir
                }),
            staleTime: 180000
        });
    }, [
        data,
        page,
        totalPages,
        pageSize,
        debouncedSearch,
        statusFilter,
        resultFilter,
        sortBy,
        sortDir,
        qc
    ]);
    const isFrameworkV2 = uiSettingsData?.management?.uiFramework === "mockup_v2" || typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    const fixedViewportListLayout = isFrameworkV2 && !showCreate && !editForm;
    const pageItems = (0, $acw62.useMemo)(()=>{
        if (totalPages <= 1) return [
            1
        ];
        const start = Math.max(1, page - 1);
        const end = Math.min(totalPages, start + 2);
        const adjustedStart = Math.max(1, end - 2);
        return Array.from({
            length: end - adjustedStart + 1
        }, (_, i)=>adjustedStart + i);
    }, [
        page,
        totalPages
    ]);
    const resetListFilters = ()=>{
        setSearch("");
        setStatusFilter("");
        setResultFilter("");
        setSortBy("objektnummer");
        setSortDir("asc");
        setPage(1);
    };
    const renderSortIndicator = (field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "resolutions-v2-sort-indicator",
            "aria-hidden": "true",
            children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
        });
    const renderSortableHeaderText = (field, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "resolutions-v2-th-sort-copy",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "resolutions-v2-th-label",
                    children: label
                }),
                renderSortIndicator(field)
            ]
        });
    const validateCreateFaciliooProcess = async ()=>{
        const processRef = form.facilioo_vorgangsnummer.trim();
        if (!processRef) {
            setCreateFaciliooValidationError("");
            setCreateFaciliooProcessTitle("");
            return true;
        }
        if (createFaciliooProcessTitle && !createFaciliooValidationError) return true;
        if (!form.objectId) {
            setCreateFaciliooValidationError("Bitte zuerst ein Objekt ausw\xe4hlen.");
            setCreateFaciliooProcessTitle("");
            return false;
        }
        setCreateFaciliooValidationPending(true);
        setCreateFaciliooValidationError("");
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).validateFaciliooProcessForObject(form.objectId, processRef);
            const resolvedTitle = String(result.processTitle ?? "").trim();
            setCreateFaciliooProcessTitle(resolvedTitle || "(ohne Titel)");
            return true;
        } catch (error) {
            setCreateFaciliooProcessTitle("");
            setCreateFaciliooValidationError($ca55c84b1bbe2a8d$var$normalizeValidationErrorMessage(error));
            return false;
        } finally{
            setCreateFaciliooValidationPending(false);
        }
    };
    const validateEditFaciliooProcess = async ()=>{
        const processRef = editForm?.facilioo_vorgangsnummer.trim() ?? "";
        if (!processRef) {
            setEditFaciliooValidationError("");
            setEditFaciliooProcessTitle("");
            return true;
        }
        if (editFaciliooProcessTitle && !editFaciliooValidationError) return true;
        if (!editForm?.objectId) {
            setEditFaciliooValidationError("Bitte zuerst ein Objekt ausw\xe4hlen.");
            setEditFaciliooProcessTitle("");
            return false;
        }
        setEditFaciliooValidationPending(true);
        setEditFaciliooValidationError("");
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).validateFaciliooProcessForObject(editForm.objectId, processRef);
            const resolvedTitle = String(result.processTitle ?? "").trim();
            setEditFaciliooProcessTitle(resolvedTitle || "(ohne Titel)");
            return true;
        } catch (error) {
            setEditFaciliooProcessTitle("");
            setEditFaciliooValidationError($ca55c84b1bbe2a8d$var$normalizeValidationErrorMessage(error));
            return false;
        } finally{
            setEditFaciliooValidationPending(false);
        }
    };
    const createMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (!canCreateResolutions) throw new Error("Keine Berechtigung zum Anlegen von Umlaufbeschl\xfcssen.");
            if (!canCreate) throw new Error("Bitte alle Pflichtfelder ausf\xfcllen");
            if (!await validateCreateFaciliooProcess()) throw new Error("Facilioo Vorgang konnte nicht validiert werden.");
            const created = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).createResolution({
                objectId: form.objectId,
                titel: form.titel.trim(),
                startdatum: form.startdatum || undefined,
                endedatum: form.endedatum || undefined,
                beschlusstext: form.beschlusstext.trim(),
                facilioo_vorgangsnummer: faciliooEnabled ? $ca55c84b1bbe2a8d$var$parseFacilioo(form.facilioo_vorgangsnummer) : undefined,
                dispatch_automation_enabled: form.dispatch_automation_enabled,
                trigger_notifications_enabled: form.trigger_notifications_enabled,
                trigger_notifications_channel: form.trigger_notifications_channel,
                trigger_notifications_events: $ca55c84b1bbe2a8d$var$normalizeTriggerNotificationEvents(form.trigger_notifications_events),
                stimmrechtsart: form.stimmrechtsart,
                quorum: form.quorum,
                vorbeschluss_top: form.vorbeschluss_top.trim() || undefined,
                vorbeschluss_wev_datum: form.vorbeschluss_wev_datum || undefined,
                stimmberechtigte_einheiten: form.stimmberechtigte_einheiten
            });
            if (createDocuments.length > 0) await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).uploadResolutionDocuments(created.id, createDocuments);
            return created;
        },
        onSuccess: async ()=>{
            setShowCreate(false);
            setForm($ca55c84b1bbe2a8d$var$buildEmptyResolutionForm(faciliooEnabled));
            setCreateOwnerSearch("");
            setCreateUnitTypeFilter("");
            setCreateEntranceFilter("");
            setCreateDocuments([]);
            setCreateFaciliooValidationError("");
            setCreateFaciliooProcessTitle("");
            setCreateError("");
            await qc.invalidateQueries({
                queryKey: [
                    "resolutions"
                ]
            });
        },
        onError: (e)=>setCreateError(e instanceof Error ? e.message : "Umlaufbeschluss konnte nicht angelegt werden")
    });
    const editMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (!editForm || !canEdit) throw new Error("Bitte alle Pflichtfelder ausf\xfcllen");
            if (!await validateEditFaciliooProcess()) throw new Error("Facilioo Vorgang konnte nicht validiert werden.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateResolution(editForm.id, {
                objectId: editForm.objectId,
                titel: editForm.titel.trim(),
                startdatum: editForm.startdatum || undefined,
                endedatum: editForm.endedatum || undefined,
                beschlusstext: editForm.beschlusstext.trim(),
                facilioo_vorgangsnummer: faciliooEnabled ? $ca55c84b1bbe2a8d$var$parseFacilioo(editForm.facilioo_vorgangsnummer) : undefined,
                dispatch_automation_enabled: editForm.dispatch_automation_enabled,
                trigger_notifications_enabled: editForm.trigger_notifications_enabled,
                trigger_notifications_channel: editForm.trigger_notifications_channel,
                trigger_notifications_events: $ca55c84b1bbe2a8d$var$normalizeTriggerNotificationEvents(editForm.trigger_notifications_events),
                stimmrechtsart: editForm.stimmrechtsart,
                quorum: editForm.quorum,
                vorbeschluss_top: editForm.vorbeschluss_top.trim() || undefined,
                vorbeschluss_wev_datum: editForm.vorbeschluss_wev_datum || undefined,
                stimmberechtigte_einheiten: editForm.stimmberechtigte_einheiten
            });
        },
        onSuccess: async ()=>{
            setEditForm(null);
            setEditOwnerSearch("");
            setEditUnitTypeFilter("");
            setEditEntranceFilter("");
            setEditFaciliooValidationError("");
            setEditFaciliooProcessTitle("");
            setEditError("");
            await qc.invalidateQueries({
                queryKey: [
                    "resolutions"
                ]
            });
        },
        onError: (e)=>setEditError(e instanceof Error ? e.message : "Umlaufbeschluss konnte nicht bearbeitet werden")
    });
    const startMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (payload)=>{
            if (payload.endedatum) await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateResolution(payload.id, {
                endedatum: payload.endedatum
            });
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).startResolution(payload.id);
        },
        onSuccess: async ()=>{
            setStartConfirm(null);
            setActionError("");
            await qc.invalidateQueries({
                queryKey: [
                    "resolutions"
                ]
            });
        },
        onError: (e)=>setActionError(e instanceof Error ? e.message : "Starten fehlgeschlagen")
    });
    const stopMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).stopResolution(id),
        onSuccess: async ()=>{
            setStopConfirm(null);
            setActionError("");
            await qc.invalidateQueries({
                queryKey: [
                    "resolutions"
                ]
            });
        },
        onError: (e)=>setActionError(e instanceof Error ? e.message : "Stoppen fehlgeschlagen")
    });
    const deleteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).deleteResolution(id),
        onSuccess: async ()=>{
            setDeleteConfirm(null);
            setActionError("");
            await qc.invalidateQueries({
                queryKey: [
                    "resolutions"
                ]
            });
        },
        onError: (e)=>setActionError(e instanceof Error ? e.message : "L\xf6schen fehlgeschlagen")
    });
    const cancelCreate = ()=>{
        setForm($ca55c84b1bbe2a8d$var$buildEmptyResolutionForm(faciliooEnabled));
        setCreateOwnerSearch("");
        setCreateUnitTypeFilter("");
        setCreateEntranceFilter("");
        setCreateDocuments([]);
        setCreateFaciliooValidationError("");
        setCreateFaciliooProcessTitle("");
        setCreateError("");
        setShowCreate(false);
    };
    const toggleSort = (field)=>{
        if (sortBy === field) {
            setSortDir((prev)=>prev === "asc" ? "desc" : "asc");
            return;
        }
        setSortBy(field);
        setSortDir("asc");
    };
    const sortLabel = (field, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: ()=>toggleSort(field),
            style: {
                border: "none",
                background: "transparent",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                font: "inherit",
                color: "inherit",
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                gap: 6
            },
            title: sortBy === field ? `Sortierung: ${sortDir === "asc" ? "aufsteigend" : "absteigend"}` : "Sortierung aktivieren",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: sortBy === field ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
                })
            ]
        });
    const autoDispatchTooltip = "Automatischer Versandprozess aktiv";
    const columns = (0, $acw62.useMemo)(()=>[
            {
                key: "beschlussnummer",
                label: sortLabel("beschlussnummer", "Beschluss-ID"),
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "badge resolution-number",
                        to: `/resolutions/${r.id}`,
                        title: r.beschlussnummer,
                        children: r.beschlussnummer
                    })
            },
            {
                key: "objektnummer",
                label: sortLabel("objektnummer", "Objekt\u2011Nr"),
                width: 96,
                align: "center",
                render: (r)=>{
                    const resolvedObjectNumber = (r.objektnummer || objectById.get(r.objectId)?.objektnummer || "-").toString();
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "badge object-number",
                        to: `/objects/${r.objectId}`,
                        title: resolvedObjectNumber,
                        style: {
                            textDecoration: "none"
                        },
                        children: resolvedObjectNumber
                    });
                }
            },
            {
                key: "objektname",
                label: sortLabel("objektname", "Objektname"),
                render: (r)=>r.objektname || objectById.get(r.objectId)?.objektname || "-"
            },
            {
                key: "titel",
                label: sortLabel("titel", "Titel")
            },
            {
                key: "stimmrechtsart",
                label: "Stimmrechtsart",
                align: "center",
                render: (r)=>$ca55c84b1bbe2a8d$var$formatStimmrechtsart(r.stimmrechtsart)
            },
            {
                key: "quorum",
                label: "Quorum",
                width: 92,
                render: (r)=>$ca55c84b1bbe2a8d$var$formatQuorum(r.quorum)
            },
            {
                key: "status",
                label: sortLabel("status", "Status"),
                align: "center",
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "resolution-status-wrap",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `badge ${r.status}`,
                                children: $ca55c84b1bbe2a8d$var$formatStatus(r.status)
                            }),
                            r.dispatch_automation_enabled && r.status === "aktiv" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "dispatch-automation-indicator quick-tooltip",
                                "data-tooltip": autoDispatchTooltip,
                                "aria-label": autoDispatchTooltip,
                                tabIndex: 0,
                                children: "\u2699"
                            }) : null
                        ]
                    })
            },
            {
                key: "startdatum",
                label: "Startdatum",
                align: "center",
                render: (r)=>$ca55c84b1bbe2a8d$var$formatDateDE(r.startdatum)
            },
            {
                key: "endedatum",
                label: "Enddatum",
                align: "center",
                render: (r)=>$ca55c84b1bbe2a8d$var$formatDateDE(r.endedatum)
            },
            {
                key: "restlaufzeit",
                label: sortLabel("restlaufzeit", "Restlaufzeit"),
                align: "center",
                render: (r)=>{
                    const remainingDays = $ca55c84b1bbe2a8d$var$getRemainingDays(r.endedatum);
                    return remainingDays === null ? "-" : `${remainingDays} Tage`;
                }
            },
            {
                key: "ruecklaufquote",
                label: sortLabel("ruecklaufquote", "R\xfccklaufquote"),
                align: "center",
                render: (r)=>`${r.ruecklaufquote.toFixed(2)} %`
            },
            {
                key: "ergebnis",
                label: "Ergebnis",
                align: "center",
                render: (r)=>{
                    const o = $ca55c84b1bbe2a8d$var$getOutcome(r);
                    return o.tone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge ergebnis-${o.tone === "success" ? "angenommen" : "abgelehnt"}`,
                        children: o.label
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge ergebnis-neutral",
                        children: o.label
                    });
                }
            },
            {
                key: "actions",
                label: "Aktionen",
                render: (r)=>{
                    const isActive = r.status === "aktiv";
                    const isCompleted = r.status === "abgeschlossen";
                    const canEdit = r.status === "entwurf";
                    const hasVotes = (r.abgegebene_stimmen ?? 0) > 0;
                    const blockedByCompletedPermission = isCompleted && !canDeleteCompletedResolutions;
                    const canDeleteCompletedWithVotes = isCompleted && canDeleteCompletedResolutions;
                    const blockedByMissingDeletePermission = !isCompleted && !canDeleteResolutions;
                    const blockedByVotes = hasVotes && !canDeleteCompletedWithVotes;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: 8,
                            flexWrap: "wrap"
                        },
                        children: [
                            canEditResolutions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    if (!canEdit) {
                                        setActionError("Nur Entw\xfcrfe k\xf6nnen bearbeitet werden. Laufende oder beendete Beschl\xfcsse sind gesperrt.");
                                        return;
                                    }
                                    setEditOwnerSearch("");
                                    setEditUnitTypeFilter("");
                                    setEditEntranceFilter("");
                                    setEditForm({
                                        id: r.id,
                                        objectId: r.objectId,
                                        beschlussnummer: r.beschlussnummer,
                                        titel: r.titel,
                                        startdatum: r.startdatum ?? "",
                                        endedatum: r.endedatum ?? "",
                                        stimmrechtsart: r.stimmrechtsart,
                                        quorum: r.quorum,
                                        vorbeschluss_top: r.vorbeschluss_top ?? "",
                                        vorbeschluss_wev_datum: r.vorbeschluss_wev_datum ?? "",
                                        beschlusstext: r.beschlusstext,
                                        facilioo_vorgangsnummer: r.facilioo_vorgangsnummer ? String(r.facilioo_vorgangsnummer) : "",
                                        dispatch_automation_enabled: r.dispatch_automation_enabled ?? false,
                                        trigger_notifications_enabled: r.trigger_notifications_enabled ?? false,
                                        trigger_notifications_channel: r.trigger_notifications_channel ?? "email",
                                        trigger_notifications_events: $ca55c84b1bbe2a8d$var$normalizeTriggerNotificationEvents(r.trigger_notifications_events),
                                        stimmberechtigte_einheiten: r.stimmberechtigte_einheiten ?? []
                                    });
                                },
                                disabled: !canEdit,
                                children: "Bearbeiten"
                            }) : null,
                            r.status === "entwurf" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "resolution-action-btn resolution-start-btn",
                                onClick: ()=>{
                                    if (!r.endedatum) {
                                        setStartConfirm({
                                            id: r.id,
                                            beschlussnummer: r.beschlussnummer,
                                            endedatum: "",
                                            error: ""
                                        });
                                        return;
                                    }
                                    startMutation.mutate({
                                        id: r.id,
                                        endedatum: r.endedatum
                                    });
                                },
                                disabled: startMutation.isPending,
                                children: "Starten"
                            }) : null,
                            r.status === "aktiv" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "resolution-action-btn resolution-stop-btn",
                                onClick: ()=>setStopConfirm({
                                        id: r.id,
                                        beschlussnummer: r.beschlussnummer,
                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                        input: [
                                            "",
                                            "",
                                            "",
                                            ""
                                        ],
                                        error: ""
                                    }),
                                disabled: stopMutation.isPending,
                                children: "Stoppen"
                            }) : null,
                            canDeleteAnyResolution ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: isActive || blockedByMissingDeletePermission || blockedByVotes || blockedByCompletedPermission || deleteMutation.isPending,
                                onClick: ()=>{
                                    if (isActive) {
                                        setActionError("Aktive Beschl\xfcsse k\xf6nnen nicht gel\xf6scht werden.");
                                        return;
                                    }
                                    if (blockedByMissingDeletePermission) {
                                        setActionError("Keine Berechtigung zum L\xf6schen dieses Beschlusses.");
                                        return;
                                    }
                                    if (blockedByVotes) {
                                        setActionError("Beschl\xfcsse mit Stimmabgaben k\xf6nnen nicht gel\xf6scht werden.");
                                        return;
                                    }
                                    if (blockedByCompletedPermission) {
                                        setActionError("Keine Berechtigung zum L\xf6schen abgeschlossener Beschl\xfcsse.");
                                        return;
                                    }
                                    setDeleteConfirm({
                                        id: r.id,
                                        beschlussnummer: r.beschlussnummer,
                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                        input: [
                                            "",
                                            "",
                                            "",
                                            ""
                                        ],
                                        error: ""
                                    });
                                },
                                children: "L\xf6schen"
                            }) : null,
                            isActive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "lock-indicator",
                                title: "Aktiver Beschluss",
                                children: "\uD83D\uDD12"
                            }) : null
                        ]
                    });
                }
            }
        ], [
        autoDispatchTooltip,
        canDeleteAnyResolution,
        canDeleteCompletedResolutions,
        canDeleteResolutions,
        canEditResolutions,
        deleteMutation.isPending,
        objectById,
        sortBy,
        sortDir,
        startMutation.isPending,
        stopMutation.isPending
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: fixedViewportListLayout ? "resolutions-v2-page" : undefined,
            children: [
                !showCreate && !editForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: `page-header panel ${isFrameworkV2 ? "resolutions-v2-page-header" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            className: isFrameworkV2 ? "resolutions-v2-title" : "",
                            style: {
                                margin: 0
                            },
                            children: [
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionMenuIcon, {})
                                }) : null,
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "resolutions-v2-title-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "resolutions-v2-title-main",
                                            children: "Umlaufbeschl\xfcsse"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "resolutions-v2-title-sub",
                                            children: "\xdcbersicht aller Umlaufbeschl\xfcsse und Ergebnisse"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Umlaufbeschl\xfcsse"
                                })
                            ]
                        }),
                        canCreateResolutions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            className: isFrameworkV2 ? "resolutions-v2-create-btn" : "",
                            onClick: ()=>{
                                setForm($ca55c84b1bbe2a8d$var$buildEmptyResolutionForm(faciliooEnabled));
                                setCreateOwnerSearch("");
                                setCreateUnitTypeFilter("");
                                setCreateEntranceFilter("");
                                setCreateDocuments([]);
                                setCreateFaciliooValidationError("");
                                setCreateFaciliooProcessTitle("");
                                setCreateError("");
                                setShowCreate(true);
                            },
                            children: [
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-create-btn-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M10 4.2v11.6M4.2 10h11.6",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round"
                                        })
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Neuer Beschluss"
                                })
                            ]
                        }) : null
                    ]
                }) : null,
                canCreateResolutions && showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: `panel create-form resolution-create-form${isFrameworkV2 ? " resolution-create-form-v2" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: isFrameworkV2 ? "resolution-create-v2-head" : undefined,
                            children: [
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolution-create-v2-head-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateSectionIcon, {
                                        name: "resolution"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: isFrameworkV2 ? "resolution-create-v2-head-copy" : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            style: isFrameworkV2 ? undefined : {
                                                marginTop: 0
                                            },
                                            children: "Umlaufbeschluss anlegen"
                                        }),
                                        isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Stammdaten, Dokumente und stimmberechtigte Einheiten erfassen"
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-grid",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolution-main-fields-box",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Objekt*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: form.objectId,
                                                    onChange: (e)=>{
                                                        const objectId = e.target.value;
                                                        const objectDefault = (objectsData?.data ?? []).find((o)=>o.id === objectId)?.standard_stimmrechtsart;
                                                        setForm({
                                                            ...form,
                                                            objectId: objectId,
                                                            stimmrechtsart: objectDefault ?? "kopf",
                                                            stimmberechtigte_einheiten: []
                                                        });
                                                        setCreateOwnerSearch("");
                                                        setPendingAutoSelectObjectId(objectId || null);
                                                        setCreateFaciliooValidationError("");
                                                        setCreateFaciliooProcessTitle("");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "",
                                                            children: "Objekt w\xe4hlen*"
                                                        }),
                                                        (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: o.id,
                                                                children: `${o.objektnummer} - ${o.objektname}`
                                                            }, o.id))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    children: [
                                                        "Beschlussnummer ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            style: {
                                                                color: "var(--text-soft)",
                                                                fontWeight: 400
                                                            },
                                                            children: resolutionNumberHint
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    value: createResolutionNumber,
                                                    disabled: true
                                                })
                                            ]
                                        }),
                                        faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Facilioo Vorgangsnummer"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "number",
                                                    min: 0,
                                                    max: 9999999999,
                                                    value: form.facilioo_vorgangsnummer,
                                                    onChange: (e)=>setForm({
                                                            ...form,
                                                            facilioo_vorgangsnummer: e.target.value
                                                        }),
                                                    onBlur: ()=>{
                                                        validateCreateFaciliooProcess();
                                                    }
                                                }),
                                                createFaciliooValidationPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "var(--text-soft)"
                                                    },
                                                    children: "Vorgang wird gepr\xfcft ..."
                                                }) : null,
                                                createFaciliooProcessTitle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                    style: {
                                                        color: "var(--text-soft)"
                                                    },
                                                    children: [
                                                        "Vorgangsbetreff: ",
                                                        createFaciliooProcessTitle
                                                    ]
                                                }) : null,
                                                createFaciliooValidationError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    className: "error-text",
                                                    children: createFaciliooValidationError
                                                }) : null
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Startdatum (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "date",
                                                    value: form.startdatum,
                                                    onChange: (e)=>setForm({
                                                            ...form,
                                                            startdatum: e.target.value
                                                        })
                                                }),
                                                createDateErrors.startError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "error-text",
                                                    children: createDateErrors.startError
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Enddatum (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "date",
                                                    value: form.endedatum,
                                                    onChange: (e)=>setForm({
                                                            ...form,
                                                            endedatum: e.target.value
                                                        })
                                                }),
                                                createDateErrors.endError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "error-text",
                                                    children: createDateErrors.endError
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Stimmrechtsart*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: form.stimmrechtsart,
                                                    onChange: (e)=>setForm({
                                                            ...form,
                                                            stimmrechtsart: e.target.value
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "kopf",
                                                            children: "Kopfstimmen"
                                                        }),
                                                        createCanUseStimmrecht ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "stimmrecht",
                                                            children: "Stimmrecht"
                                                        }) : null,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "mea",
                                                            children: "MEA"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Quorum*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: form.quorum,
                                                    onChange: (e)=>{
                                                        const quorum = e.target.value;
                                                        setForm({
                                                            ...form,
                                                            quorum: quorum,
                                                            ...quorum === "allstimmig" ? {
                                                                vorbeschluss_top: "",
                                                                vorbeschluss_wev_datum: ""
                                                            } : {}
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "allstimmig",
                                                            children: "Allstimmig"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "einfache_mehrheit",
                                                            children: "Einfache Mehrheit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "qualifizierte_mehrheit",
                                                            children: "Qualifizierte Mehrheit"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Automatischen Versandprozess aktivieren"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "settings-switch-row",
                                                    style: {
                                                        marginBottom: 10
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        className: "settings-toggle",
                                                        htmlFor: "resolution-create-dispatch-enabled",
                                                        "aria-label": "Automatischen Versandprozess aktivieren oder deaktivieren",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                id: "resolution-create-dispatch-enabled",
                                                                type: "checkbox",
                                                                checked: form.dispatch_automation_enabled,
                                                                onChange: (e)=>setForm({
                                                                        ...form,
                                                                        dispatch_automation_enabled: e.target.checked
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "settings-toggle-slider"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        $ca55c84b1bbe2a8d$var$isVorbeschlussRequired(form.quorum) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "TOP der WEV (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    value: form.vorbeschluss_top,
                                                    onChange: (e)=>setForm({
                                                            ...form,
                                                            vorbeschluss_top: e.target.value
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "var(--text-soft)"
                                                    },
                                                    children: "Tagesordnungspunkt des Vorbeschlusses, mit dem das abgesenkte Quorum beschlossen wurde."
                                                })
                                            ]
                                        }) : null,
                                        $ca55c84b1bbe2a8d$var$isVorbeschlussRequired(form.quorum) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Datum der WEV (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "date",
                                                    value: form.vorbeschluss_wev_datum,
                                                    onChange: (e)=>setForm({
                                                            ...form,
                                                            vorbeschluss_wev_datum: e.target.value
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "var(--text-soft)"
                                                    },
                                                    children: "Datum der WEG-Versammlung des Vorbeschlusses."
                                                })
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field form-field-wide",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Ablauf Info's an Verwaltung senden"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "settings-switch-row",
                                                    style: {
                                                        marginBottom: 10
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        className: "settings-toggle",
                                                        htmlFor: "resolution-create-trigger-enabled",
                                                        "aria-label": "Ablauf Infos an Verwaltung senden aktivieren oder deaktivieren",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                id: "resolution-create-trigger-enabled",
                                                                type: "checkbox",
                                                                checked: form.trigger_notifications_enabled,
                                                                onChange: (e)=>setForm({
                                                                        ...form,
                                                                        trigger_notifications_enabled: e.target.checked
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "settings-toggle-slider"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                form.trigger_notifications_enabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "form-field",
                                                            style: {
                                                                padding: 0,
                                                                marginBottom: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    children: "Versandkanal"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    value: form.trigger_notifications_channel,
                                                                    onChange: (e)=>setForm({
                                                                            ...form,
                                                                            trigger_notifications_channel: e.target.value
                                                                        }),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "email",
                                                                            children: "E-Mail"
                                                                        }),
                                                                        faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "facilioo",
                                                                            children: "Facilioo Vorgang"
                                                                        }) : null
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "resolution-trigger-events-box",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "resolution-trigger-events-actions",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>setForm({
                                                                                    ...form,
                                                                                    trigger_notifications_events: $ca55c84b1bbe2a8d$var$allTriggerNotificationEvents()
                                                                                }),
                                                                            children: "Alles markieren"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>setForm({
                                                                                    ...form,
                                                                                    trigger_notifications_events: $ca55c84b1bbe2a8d$var$defaultTriggerNotificationEvents()
                                                                                }),
                                                                            children: "Alle demarkieren"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "resolution-trigger-events-grid",
                                                                    children: $ca55c84b1bbe2a8d$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS.map((eventOption)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                            className: "resolution-trigger-event-option",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: Boolean(form.trigger_notifications_events[eventOption.key]),
                                                                                    onChange: (e)=>setForm({
                                                                                            ...form,
                                                                                            trigger_notifications_events: {
                                                                                                ...form.trigger_notifications_events,
                                                                                                [eventOption.key]: e.target.checked
                                                                                            }
                                                                                        })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: eventOption.label
                                                                                })
                                                                            ]
                                                                        }, eventOption.key))
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field form-field-wide",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Titel*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    value: form.titel,
                                                    onChange: (e)=>setForm({
                                                            ...form,
                                                            titel: e.target.value
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field form-field-wide",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Beschlusstext*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                    rows: 8,
                                                    value: form.beschlusstext,
                                                    onChange: (e)=>setForm({
                                                            ...form,
                                                            beschlusstext: e.target.value
                                                        })
                                                })
                                            ]
                                        }),
                                        !createVorbeschlussPairValid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "form-field form-field-wide",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "error-text",
                                                children: "TOP und Datum der WEV m\xfcssen gemeinsam bef\xfcllt werden."
                                            })
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field form-field-wide resolution-upload-box",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: isFrameworkV2 ? "resolution-create-v2-section-head" : undefined,
                                            children: [
                                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "resolution-create-v2-section-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateSectionIcon, {
                                                        name: "upload"
                                                    })
                                                }) : null,
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Dokumente (optional)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: `resolution-document-dropzone${createDocumentsDropActive ? " is-drag-over" : ""}`,
                                            onDragOver: (e)=>{
                                                e.preventDefault();
                                                e.dataTransfer.dropEffect = "copy";
                                                setCreateDocumentsDropActive(true);
                                            },
                                            onDragLeave: (e)=>{
                                                e.preventDefault();
                                                setCreateDocumentsDropActive(false);
                                            },
                                            onDrop: onCreateDocumentsDrop,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    ref: createDocumentsInputRef,
                                                    type: "file",
                                                    multiple: true,
                                                    accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png",
                                                    style: {
                                                        display: "none"
                                                    },
                                                    onChange: (e)=>mergeCreateDocuments(Array.from(e.target.files ?? []), true)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "resolution-document-dropzone-text",
                                                    children: "Dateien hier hineinziehen oder \xfcber den Button ausw\xe4hlen."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 10,
                                                flexWrap: "wrap",
                                                alignItems: "center",
                                                marginTop: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>createDocumentsInputRef.current?.click(),
                                                    children: "Dateien ausw\xe4hlen"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setCreateDocuments([]),
                                                    disabled: !createDocuments.length,
                                                    children: "Auswahl leeren"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        color: "var(--text-soft)",
                                                        fontSize: 12
                                                    },
                                                    children: createDocuments.length ? `${createDocuments.length} Datei(en) in der Liste` : "Keine Dateien ausgew\xe4hlt"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            style: {
                                                color: "var(--text-soft)"
                                            },
                                            children: "Erlaubte Formate: PDF, DOC, DOCX, XLS, XLSX, JPG, JPEG, PNG. Maximal 20 Dateien pro Upload, maximal 20 MB je Datei."
                                        })
                                    ]
                                }),
                                $ca55c84b1bbe2a8d$var$renderUnitSelector(createUnitRows, form.stimmberechtigte_einheiten, createOwnerSearch, setCreateOwnerSearch, createUnitTypeFilter, setCreateUnitTypeFilter, createEntranceFilter, setCreateEntranceFilter, (unitId, checked)=>setForm({
                                        ...form,
                                        stimmberechtigte_einheiten: checked ? Array.from(new Set([
                                            ...form.stimmberechtigte_einheiten,
                                            unitId
                                        ])) : form.stimmberechtigte_einheiten.filter((v)=>v !== unitId)
                                    }), ()=>setForm({
                                        ...form,
                                        stimmberechtigte_einheiten: createUnitRows.map((u)=>u.unitId)
                                    }), ()=>setForm({
                                        ...form,
                                        stimmberechtigte_einheiten: []
                                    }), ()=>{
                                    const filteredIds = getFilteredResolutionUnitIds(createUnitRows, createOwnerSearch, createUnitTypeFilter, createEntranceFilter);
                                    setForm({
                                        ...form,
                                        stimmberechtigte_einheiten: Array.from(new Set([
                                            ...form.stimmberechtigte_einheiten,
                                            ...filteredIds
                                        ]))
                                    });
                                }, ()=>{
                                    const filteredIds = getFilteredResolutionUnitIds(createUnitRows, createOwnerSearch, createUnitTypeFilter, createEntranceFilter);
                                    setForm({
                                        ...form,
                                        stimmberechtigte_einheiten: form.stimmberechtigte_einheiten.filter((id)=>!filteredIds.includes(id))
                                    });
                                }, isFrameworkV2)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-actions resolution-create-actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "resolution-primary-btn",
                                    disabled: !canCreate || createMutation.isPending,
                                    onClick: ()=>createMutation.mutate(),
                                    children: createMutation.isPending ? "Speichere..." : "Umlaufbeschluss speichern"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "resolution-secondary-btn",
                                    onClick: cancelCreate,
                                    children: "Abbrechen"
                                }),
                                createError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "error-text",
                                    children: createError
                                }) : null
                            ]
                        })
                    ]
                }) : null,
                !showCreate && canEditResolutions && editForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: `panel create-form resolution-create-form${isFrameworkV2 ? " resolution-create-form-v2" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: isFrameworkV2 ? "resolution-create-v2-head" : undefined,
                            children: [
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolution-create-v2-head-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca55c84b1bbe2a8d$var$ResolutionCreateSectionIcon, {
                                        name: "resolution"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: isFrameworkV2 ? "resolution-create-v2-head-copy" : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            style: isFrameworkV2 ? undefined : {
                                                marginTop: 0
                                            },
                                            children: "Umlaufbeschluss bearbeiten"
                                        }),
                                        isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Stammdaten, Dokumente und stimmberechtigte Einheiten bearbeiten"
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-grid",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolution-main-fields-box",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Objekt*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: editForm.objectId,
                                                    onChange: (e)=>{
                                                        const objectId = e.target.value;
                                                        const objectDefault = (objectsData?.data ?? []).find((o)=>o.id === objectId)?.standard_stimmrechtsart;
                                                        setEditForm({
                                                            ...editForm,
                                                            objectId: objectId,
                                                            stimmrechtsart: objectDefault ?? editForm.stimmrechtsart,
                                                            stimmberechtigte_einheiten: []
                                                        });
                                                        setEditOwnerSearch("");
                                                        setEditFaciliooValidationError("");
                                                        setEditFaciliooProcessTitle("");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "",
                                                            children: "Objekt w\xe4hlen*"
                                                        }),
                                                        (objectsData?.data ?? []).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: o.id,
                                                                children: `${o.objektnummer} - ${o.objektname}`
                                                            }, o.id))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    children: [
                                                        "Beschlussnummer ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            style: {
                                                                color: "var(--text-soft)",
                                                                fontWeight: 400
                                                            },
                                                            children: resolutionNumberHint
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    value: editForm.beschlussnummer,
                                                    disabled: true
                                                })
                                            ]
                                        }),
                                        faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Facilioo Vorgangsnummer"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "number",
                                                    min: 0,
                                                    max: 9999999999,
                                                    value: editForm.facilioo_vorgangsnummer,
                                                    onChange: (e)=>setEditForm({
                                                            ...editForm,
                                                            facilioo_vorgangsnummer: e.target.value
                                                        }),
                                                    onBlur: ()=>{
                                                        validateEditFaciliooProcess();
                                                    }
                                                }),
                                                editFaciliooValidationPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "var(--text-soft)"
                                                    },
                                                    children: "Vorgang wird gepr\xfcft ..."
                                                }) : null,
                                                editFaciliooProcessTitle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                    style: {
                                                        color: "var(--text-soft)"
                                                    },
                                                    children: [
                                                        "Vorgangsbetreff: ",
                                                        editFaciliooProcessTitle
                                                    ]
                                                }) : null,
                                                editFaciliooValidationError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    className: "error-text",
                                                    children: editFaciliooValidationError
                                                }) : null
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Startdatum (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "date",
                                                    value: editForm.startdatum,
                                                    onChange: (e)=>setEditForm({
                                                            ...editForm,
                                                            startdatum: e.target.value
                                                        })
                                                }),
                                                editDateErrors.startError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "error-text",
                                                    children: editDateErrors.startError
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Enddatum (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "date",
                                                    value: editForm.endedatum,
                                                    onChange: (e)=>setEditForm({
                                                            ...editForm,
                                                            endedatum: e.target.value
                                                        })
                                                }),
                                                editDateErrors.endError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "error-text",
                                                    children: editDateErrors.endError
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Stimmrechtsart*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: editForm.stimmrechtsart,
                                                    onChange: (e)=>setEditForm({
                                                            ...editForm,
                                                            stimmrechtsart: e.target.value
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "kopf",
                                                            children: "Kopfstimmen"
                                                        }),
                                                        editCanUseStimmrecht ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "stimmrecht",
                                                            children: "Stimmrecht"
                                                        }) : null,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "mea",
                                                            children: "MEA"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Quorum*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: editForm.quorum,
                                                    onChange: (e)=>{
                                                        const quorum = e.target.value;
                                                        setEditForm({
                                                            ...editForm,
                                                            quorum: quorum,
                                                            ...quorum === "allstimmig" ? {
                                                                vorbeschluss_top: "",
                                                                vorbeschluss_wev_datum: ""
                                                            } : {}
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "allstimmig",
                                                            children: "Allstimmig"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "einfache_mehrheit",
                                                            children: "Einfache Mehrheit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "qualifizierte_mehrheit",
                                                            children: "Qualifizierte Mehrheit"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Automatischen Versandprozess aktivieren"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "settings-switch-row",
                                                    style: {
                                                        marginBottom: 10
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        className: "settings-toggle",
                                                        htmlFor: "resolution-edit-dispatch-enabled",
                                                        "aria-label": "Automatischen Versandprozess aktivieren oder deaktivieren",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                id: "resolution-edit-dispatch-enabled",
                                                                type: "checkbox",
                                                                checked: editForm.dispatch_automation_enabled,
                                                                onChange: (e)=>setEditForm({
                                                                        ...editForm,
                                                                        dispatch_automation_enabled: e.target.checked
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "settings-toggle-slider"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        $ca55c84b1bbe2a8d$var$isVorbeschlussRequired(editForm.quorum) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "TOP der WEV (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    value: editForm.vorbeschluss_top,
                                                    onChange: (e)=>setEditForm({
                                                            ...editForm,
                                                            vorbeschluss_top: e.target.value
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "var(--text-soft)"
                                                    },
                                                    children: "Tagesordnungspunkt des Vorbeschlusses, mit dem das abgesenkte Quorum beschlossen wurde."
                                                })
                                            ]
                                        }) : null,
                                        $ca55c84b1bbe2a8d$var$isVorbeschlussRequired(editForm.quorum) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Datum der WEV (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "date",
                                                    value: editForm.vorbeschluss_wev_datum,
                                                    onChange: (e)=>setEditForm({
                                                            ...editForm,
                                                            vorbeschluss_wev_datum: e.target.value
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "var(--text-soft)"
                                                    },
                                                    children: "Datum der WEG-Versammlung des Vorbeschlusses."
                                                })
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field form-field-wide",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Ablauf Info's an Verwaltung senden"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "settings-switch-row",
                                                    style: {
                                                        marginBottom: 10
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        className: "settings-toggle",
                                                        htmlFor: "resolution-edit-trigger-enabled",
                                                        "aria-label": "Ablauf Infos an Verwaltung senden aktivieren oder deaktivieren",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                id: "resolution-edit-trigger-enabled",
                                                                type: "checkbox",
                                                                checked: editForm.trigger_notifications_enabled,
                                                                onChange: (e)=>setEditForm({
                                                                        ...editForm,
                                                                        trigger_notifications_enabled: e.target.checked
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "settings-toggle-slider"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                editForm.trigger_notifications_enabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "form-field",
                                                            style: {
                                                                padding: 0,
                                                                marginBottom: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    children: "Versandkanal"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    value: editForm.trigger_notifications_channel,
                                                                    onChange: (e)=>setEditForm({
                                                                            ...editForm,
                                                                            trigger_notifications_channel: e.target.value
                                                                        }),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "email",
                                                                            children: "E-Mail"
                                                                        }),
                                                                        faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "facilioo",
                                                                            children: "Facilioo Vorgang"
                                                                        }) : null
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "resolution-trigger-events-box",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "resolution-trigger-events-actions",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>setEditForm({
                                                                                    ...editForm,
                                                                                    trigger_notifications_events: $ca55c84b1bbe2a8d$var$allTriggerNotificationEvents()
                                                                                }),
                                                                            children: "Alles markieren"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>setEditForm({
                                                                                    ...editForm,
                                                                                    trigger_notifications_events: $ca55c84b1bbe2a8d$var$defaultTriggerNotificationEvents()
                                                                                }),
                                                                            children: "Alle demarkieren"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "resolution-trigger-events-grid",
                                                                    children: $ca55c84b1bbe2a8d$var$TRIGGER_NOTIFICATION_EVENT_OPTIONS.map((eventOption)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                            className: "resolution-trigger-event-option",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: Boolean(editForm.trigger_notifications_events[eventOption.key]),
                                                                                    onChange: (e)=>setEditForm({
                                                                                            ...editForm,
                                                                                            trigger_notifications_events: {
                                                                                                ...editForm.trigger_notifications_events,
                                                                                                [eventOption.key]: e.target.checked
                                                                                            }
                                                                                        })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: eventOption.label
                                                                                })
                                                                            ]
                                                                        }, eventOption.key))
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field form-field-wide",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Titel*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    value: editForm.titel,
                                                    onChange: (e)=>setEditForm({
                                                            ...editForm,
                                                            titel: e.target.value
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field form-field-wide",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Beschlusstext*"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                    rows: 8,
                                                    value: editForm.beschlusstext,
                                                    onChange: (e)=>setEditForm({
                                                            ...editForm,
                                                            beschlusstext: e.target.value
                                                        })
                                                })
                                            ]
                                        }),
                                        !editVorbeschlussPairValid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "form-field form-field-wide",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "error-text",
                                                children: "TOP und Datum der WEV m\xfcssen gemeinsam bef\xfcllt werden."
                                            })
                                        }) : null
                                    ]
                                }),
                                $ca55c84b1bbe2a8d$var$renderUnitSelector(editUnitRows, editForm.stimmberechtigte_einheiten, editOwnerSearch, setEditOwnerSearch, editUnitTypeFilter, setEditUnitTypeFilter, editEntranceFilter, setEditEntranceFilter, (unitId, checked)=>setEditForm({
                                        ...editForm,
                                        stimmberechtigte_einheiten: checked ? Array.from(new Set([
                                            ...editForm.stimmberechtigte_einheiten,
                                            unitId
                                        ])) : editForm.stimmberechtigte_einheiten.filter((v)=>v !== unitId)
                                    }), ()=>setEditForm({
                                        ...editForm,
                                        stimmberechtigte_einheiten: editUnitRows.map((u)=>u.unitId)
                                    }), ()=>setEditForm({
                                        ...editForm,
                                        stimmberechtigte_einheiten: []
                                    }), ()=>{
                                    const filteredIds = getFilteredResolutionUnitIds(editUnitRows, editOwnerSearch, editUnitTypeFilter, editEntranceFilter);
                                    setEditForm({
                                        ...editForm,
                                        stimmberechtigte_einheiten: Array.from(new Set([
                                            ...editForm.stimmberechtigte_einheiten,
                                            ...filteredIds
                                        ]))
                                    });
                                }, ()=>{
                                    const filteredIds = getFilteredResolutionUnitIds(editUnitRows, editOwnerSearch, editUnitTypeFilter, editEntranceFilter);
                                    setEditForm({
                                        ...editForm,
                                        stimmberechtigte_einheiten: editForm.stimmberechtigte_einheiten.filter((id)=>!filteredIds.includes(id))
                                    });
                                }, isFrameworkV2)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-actions resolution-create-actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "resolution-primary-btn",
                                    disabled: !canEdit || editMutation.isPending,
                                    onClick: ()=>editMutation.mutate(),
                                    children: editMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "resolution-secondary-btn",
                                    onClick: ()=>{
                                        setEditForm(null);
                                        setEditFaciliooValidationError("");
                                        setEditFaciliooProcessTitle("");
                                    },
                                    children: "Abbrechen"
                                }),
                                editError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "error-text",
                                    children: editError
                                }) : null
                            ]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6325038d4357e6f6$export$7aee19a40772c514), {
                    open: !!startConfirm,
                    beschlussnummer: startConfirm?.beschlussnummer ?? "",
                    enddatum: startConfirm?.endedatum ?? "",
                    error: startConfirm?.error,
                    isPending: startMutation.isPending,
                    onClose: ()=>setStartConfirm(null),
                    onEnddatumChange: (value)=>startConfirm && setStartConfirm({
                            ...startConfirm,
                            endedatum: value,
                            error: ""
                        }),
                    onConfirm: ()=>{
                        if (!startConfirm) return;
                        const today = $ca55c84b1bbe2a8d$var$getTodayDateKey();
                        if (!startConfirm.endedatum) {
                            setStartConfirm({
                                ...startConfirm,
                                error: "Enddatum ist erforderlich."
                            });
                            return;
                        }
                        if (startConfirm.endedatum <= today) {
                            setStartConfirm({
                                ...startConfirm,
                                error: "Enddatum muss nach dem heutigen Startdatum liegen."
                            });
                            return;
                        }
                        startMutation.mutate({
                            id: startConfirm.id,
                            endedatum: startConfirm.endedatum
                        });
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                    open: !!stopConfirm,
                    title: "Beschluss stoppen",
                    message: stopConfirm ? `Beschluss ${stopConfirm.beschlussnummer} soll manuell gestoppt werden.` : "",
                    code: stopConfirm?.code ?? "",
                    input: stopConfirm?.input ?? [
                        "",
                        "",
                        "",
                        ""
                    ],
                    error: stopConfirm?.error,
                    isPending: stopMutation.isPending,
                    onClose: ()=>setStopConfirm(null),
                    onInputChange: (next)=>stopConfirm && setStopConfirm({
                            ...stopConfirm,
                            input: next
                        }),
                    onErrorReset: ()=>stopConfirm && stopConfirm.error && setStopConfirm({
                            ...stopConfirm,
                            error: ""
                        }),
                    confirmLabel: "Stoppen best\xe4tigen",
                    pendingLabel: "Stoppe...",
                    onConfirm: ()=>{
                        if (!stopConfirm) return;
                        if (stopConfirm.input.join("") !== stopConfirm.code) {
                            setStopConfirm({
                                ...stopConfirm,
                                error: "Sicherheitscode falsch eingegeben."
                            });
                            return;
                        }
                        stopMutation.mutate(stopConfirm.id);
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                    open: !!deleteConfirm,
                    message: deleteConfirm ? `Beschluss ${deleteConfirm.beschlussnummer} soll gel\xf6scht werden.` : "",
                    code: deleteConfirm?.code ?? "",
                    input: deleteConfirm?.input ?? [
                        "",
                        "",
                        "",
                        ""
                    ],
                    error: deleteConfirm?.error,
                    isPending: deleteMutation.isPending,
                    onClose: ()=>setDeleteConfirm(null),
                    onInputChange: (next)=>deleteConfirm && setDeleteConfirm({
                            ...deleteConfirm,
                            input: next
                        }),
                    onErrorReset: ()=>deleteConfirm && deleteConfirm.error && setDeleteConfirm({
                            ...deleteConfirm,
                            error: ""
                        }),
                    onConfirm: ()=>{
                        if (!deleteConfirm) return;
                        if (deleteConfirm.input.join("") !== deleteConfirm.code) {
                            setDeleteConfirm({
                                ...deleteConfirm,
                                error: "Sicherheitscode falsch eingegeben."
                            });
                            return;
                        }
                        deleteMutation.mutate(deleteConfirm.id);
                    }
                }),
                !showCreate && !editForm && actionError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                    className: "panel error-text",
                    children: actionError
                }) : null,
                !showCreate && !editForm && isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                    className: "panel",
                    children: "Fehler beim Laden der Umlaufbeschl\xfcsse."
                }) : null,
                !showCreate && !editForm ? isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "panel resolutions-v2-list-panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "resolutions-v2-filterbar",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolutions-v2-filter-fields",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: "resolutions-v2-filter-input",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "resolutions-v2-filter-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        viewBox: "0 0 20 20",
                                                        fill: "none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                cx: "9",
                                                                cy: "9",
                                                                r: "5.8",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "m13.2 13.2 4 4",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    placeholder: "Suche...",
                                                    value: search,
                                                    onChange: (e)=>setSearch(e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: statusFilter,
                                            onChange: (e)=>setStatusFilter(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Alle Status"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "entwurf",
                                                    children: "Entwurf"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "aktiv",
                                                    children: "L\xe4uft"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "abgeschlossen",
                                                    children: "Beendet"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: resultFilter,
                                            onChange: (e)=>setResultFilter(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Alle Ergebnisse"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "angenommen",
                                                    children: "Angenommen"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "abgelehnt",
                                                    children: "Abgelehnt"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "offen",
                                                    children: "Offen"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    className: "resolutions-v2-reset-btn",
                                    onClick: resetListFilters,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "resolutions-v2-reset-btn-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                viewBox: "0 0 20 20",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M5.2 6.3V3.9H2.8M4 4a6.4 6.4 0 1 1-1.4 7.5",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.7",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Filter zur\xfccksetzen"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "resolutions-v2-row-count",
                            children: [
                                "Zeilen: ",
                                rows.length,
                                " / Gesamt: ",
                                totalRows
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "resolutions-v2-table-wrap",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "resolutions-v2-table resolution-overview-v2-table",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                style: {
                                                    width: "154px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                style: {
                                                    width: "126px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                style: {
                                                    width: "360px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                style: {
                                                    width: "112px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                style: {
                                                    width: "172px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                style: {
                                                    width: "126px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                style: {
                                                    width: "198px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                style: {
                                                    width: "138px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                style: {
                                                    width: "92px"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "resolutions-v2-th-sort",
                                                        onClick: ()=>toggleSort("beschlussnummer"),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M5.2 3.8h6.5l2.9 2.9v8.6a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 15.3V5a1.2 1.2 0 0 1 1.2-1.2Z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M11.7 3.9v2.8h2.8M6.7 9.2h5.9M6.7 12h5.9",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            renderSortableHeaderText("beschlussnummer", "Beschluss-ID")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "resolutions-v2-th-sort",
                                                        onClick: ()=>toggleSort("objektnummer"),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M6.2 5.2h7.6v9.6H6.2z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M6.2 8.4h7.6M6.2 11.6h7.6M9.4 5.2v9.6M12.6 5.2v9.6",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.4"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            renderSortableHeaderText("objektnummer", "Objekt-Nr")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "resolutions-v2-th-sort",
                                                        onClick: ()=>toggleSort("objektname"),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M4.2 7.3h11.6v8.5H4.2z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M6.8 4.7h6.4v2.6H6.8zM6.9 10.3h2.1M10.9 10.3H13M6.9 13.2h2.1M10.9 13.2H13",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            renderSortableHeaderText("objektname", "Objektname")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "resolutions-v2-th-sort",
                                                        onClick: ()=>toggleSort("titel"),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M5.2 3.8h6.5l2.9 2.9v8.6a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 15.3V5a1.2 1.2 0 0 1 1.2-1.2Z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M6.8 9.4h6.1M6.8 12.2h5",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            renderSortableHeaderText("titel", "Titel")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "resolutions-v2-th-sort",
                                                        onClick: ()=>toggleSort("status"),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                            cx: "10",
                                                                            cy: "10",
                                                                            r: "5.9",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                                                                            fill: "currentColor"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            renderSortableHeaderText("status", "Status")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "resolutions-v2-th-plain",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                            x: "4.3",
                                                                            y: "5.6",
                                                                            width: "11.4",
                                                                            height: "10",
                                                                            rx: "1.5",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M6.8 3.8v2.4M13.2 3.8v2.4M4.3 8.8h11.4",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-label",
                                                                children: "Laufzeit"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "resolutions-v2-th-sort",
                                                        onClick: ()=>toggleSort("restlaufzeit"),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                            cx: "10",
                                                                            cy: "11",
                                                                            r: "5.8",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M10 11V7.8M10 11l2.5 1.8M8 3.8h4M9 3.8v1.8M11 3.8v1.8",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            renderSortableHeaderText("restlaufzeit", "Restlaufzeit")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "resolutions-v2-th-sort",
                                                        onClick: ()=>toggleSort("ruecklaufquote"),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M15.2 7.2a5.8 5.8 0 1 0 .4 6.8",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinecap: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "m14 4.7 2.3 2.5-2.5 2.3",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            renderSortableHeaderText("ruecklaufquote", "R\xfccklaufquote")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "resolutions-v2-th-plain",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-icon",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M6.2 4.8h7.6v1.3a3.8 3.8 0 0 1-7.6 0V4.8Z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M8.2 10.2h3.6M10 10.2v2.6M7.6 15h4.8",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinecap: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M6.2 5.6H4.6A1.8 1.8 0 0 0 2.8 7.4v.2a2.6 2.6 0 0 0 2.6 2.6h.5M13.8 5.6h1.6a1.8 1.8 0 0 1 1.8 1.8v.2a2.6 2.6 0 0 1-2.6 2.6h-.5",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "resolutions-v2-th-label",
                                                                children: "Ergebnis"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "resolutions-v2-actions-head",
                                                    "aria-label": "Aktionen",
                                                    title: "Aktionen",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-th-plain",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-th-icon",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                viewBox: "0 0 20 20",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                        cx: "10",
                                                                        cy: "5.3",
                                                                        r: "1.4",
                                                                        fill: "currentColor"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                        cx: "10",
                                                                        cy: "10",
                                                                        r: "1.4",
                                                                        fill: "currentColor"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                        cx: "10",
                                                                        cy: "14.7",
                                                                        r: "1.4",
                                                                        fill: "currentColor"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: rows.map((r)=>{
                                            const isActive = r.status === "aktiv";
                                            const isCompleted = r.status === "abgeschlossen";
                                            const canEdit = r.status === "entwurf";
                                            const hasVotes = (r.abgegebene_stimmen ?? 0) > 0;
                                            const blockedByCompletedPermission = isCompleted && !canDeleteCompletedResolutions;
                                            const canDeleteCompletedWithVotes = isCompleted && canDeleteCompletedResolutions;
                                            const blockedByMissingDeletePermission = !isCompleted && !canDeleteResolutions;
                                            const blockedByVotes = hasVotes && !canDeleteCompletedWithVotes;
                                            const outcome = $ca55c84b1bbe2a8d$var$getOutcome(r);
                                            const resolvedObjectNumber = (r.objektnummer || objectById.get(r.objectId)?.objektnummer || "-").toString();
                                            const progress = Math.max(0, Math.min(100, Number(r.ruecklaufquote ?? 0)));
                                            const remainingDays = $ca55c84b1bbe2a8d$var$getRemainingDays(r.endedatum);
                                            const menuId = r.id;
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            className: "badge resolution-number",
                                                            to: `/resolutions/${r.id}`,
                                                            title: r.beschlussnummer,
                                                            children: r.beschlussnummer
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            className: "badge object-number",
                                                            to: `/objects/${r.objectId}`,
                                                            title: resolvedObjectNumber,
                                                            style: {
                                                                textDecoration: "none"
                                                            },
                                                            children: resolvedObjectNumber
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "resolutions-v2-object-cell",
                                                        children: r.objektname || objectById.get(r.objectId)?.objektname || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "resolutions-v2-title-cell",
                                                        children: r.titel
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: `badge ${r.status}`,
                                                            children: $ca55c84b1bbe2a8d$var$formatStatus(r.status)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "resolutions-v2-date-range",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "resolutions-v2-date-item",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "resolutions-v2-date-item-icon",
                                                                            "aria-hidden": "true",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                                viewBox: "0 0 16 16",
                                                                                fill: "none",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "M3.4 3.6h9.2v8.8H3.4z",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.4"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "M5.2 2.5v2.1M10.8 2.5v2.1M3.4 6h9.2",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.4",
                                                                                        strokeLinecap: "round"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: $ca55c84b1bbe2a8d$var$formatDateDE(r.startdatum)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "resolutions-v2-date-item",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "resolutions-v2-date-item-icon",
                                                                            "aria-hidden": "true",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                                viewBox: "0 0 16 16",
                                                                                fill: "none",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "M3.4 3.6h9.2v8.8H3.4z",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.4"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "M5.2 2.5v2.1M10.8 2.5v2.1M3.4 6h9.2",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.4",
                                                                                        strokeLinecap: "round"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "m5.6 9 1.4 1.4 3-3",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.4",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: $ca55c84b1bbe2a8d$var$formatDateDE(r.endedatum)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: remainingDays === null ? "-" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-remaining-bullet",
                                                            title: `${remainingDays} Tage`,
                                                            children: remainingDays
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "resolutions-v2-progress-wrap",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    children: [
                                                                        progress.toFixed(2),
                                                                        " %"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "resolutions-v2-progress-track",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "resolutions-v2-progress-fill",
                                                                        style: {
                                                                            width: `${progress}%`
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: outcome.tone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: `badge ergebnis-${outcome.tone === "success" ? "angenommen" : "abgelehnt"}`,
                                                            children: outcome.label
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "badge ergebnis-neutral",
                                                            children: outcome.label
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "resolutions-v2-action-wrap",
                                                            onClick: (e)=>e.stopPropagation(),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "resolutions-v2-action-trigger",
                                                                    "aria-label": `Aktionen f\xfcr ${r.beschlussnummer}`,
                                                                    "aria-expanded": openActionMenuId === menuId,
                                                                    onMouseDown: (e)=>e.stopPropagation(),
                                                                    onClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        if (openActionMenuId === menuId) {
                                                                            setOpenActionMenuId(null);
                                                                            return;
                                                                        }
                                                                        openActionMenuAtTrigger(menuId, e.currentTarget);
                                                                    },
                                                                    children: "\u22EE"
                                                                }),
                                                                openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                    style: {
                                                                        left: actionMenuPosition.left,
                                                                        top: actionMenuPosition.top
                                                                    },
                                                                    onMouseDown: (e)=>e.stopPropagation(),
                                                                    onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                    onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                    children: [
                                                                        canEditResolutions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            disabled: !canEdit,
                                                                            onClick: ()=>{
                                                                                if (!canEdit) {
                                                                                    setActionError("Nur Entw\xfcrfe k\xf6nnen bearbeitet werden. Laufende oder beendete Beschl\xfcsse sind gesperrt.");
                                                                                    setOpenActionMenuId(null);
                                                                                    return;
                                                                                }
                                                                                setEditOwnerSearch("");
                                                                                setEditUnitTypeFilter("");
                                                                                setEditEntranceFilter("");
                                                                                setEditForm({
                                                                                    id: r.id,
                                                                                    objectId: r.objectId,
                                                                                    beschlussnummer: r.beschlussnummer,
                                                                                    titel: r.titel,
                                                                                    startdatum: r.startdatum ?? "",
                                                                                    endedatum: r.endedatum ?? "",
                                                                                    stimmrechtsart: r.stimmrechtsart,
                                                                                    quorum: r.quorum,
                                                                                    vorbeschluss_top: r.vorbeschluss_top ?? "",
                                                                                    vorbeschluss_wev_datum: r.vorbeschluss_wev_datum ?? "",
                                                                                    beschlusstext: r.beschlusstext,
                                                                                    facilioo_vorgangsnummer: r.facilioo_vorgangsnummer ? String(r.facilioo_vorgangsnummer) : "",
                                                                                    dispatch_automation_enabled: r.dispatch_automation_enabled ?? false,
                                                                                    trigger_notifications_enabled: r.trigger_notifications_enabled ?? false,
                                                                                    trigger_notifications_channel: r.trigger_notifications_channel ?? "email",
                                                                                    trigger_notifications_events: $ca55c84b1bbe2a8d$var$normalizeTriggerNotificationEvents(r.trigger_notifications_events),
                                                                                    stimmberechtigte_einheiten: r.stimmberechtigte_einheiten ?? []
                                                                                });
                                                                                setOpenActionMenuId(null);
                                                                            },
                                                                            children: "Bearbeiten"
                                                                        }) : null,
                                                                        r.status === "entwurf" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            disabled: startMutation.isPending,
                                                                            onClick: ()=>{
                                                                                if (!r.endedatum) setStartConfirm({
                                                                                    id: r.id,
                                                                                    beschlussnummer: r.beschlussnummer,
                                                                                    endedatum: "",
                                                                                    error: ""
                                                                                });
                                                                                else startMutation.mutate({
                                                                                    id: r.id,
                                                                                    endedatum: r.endedatum
                                                                                });
                                                                                setOpenActionMenuId(null);
                                                                            },
                                                                            children: "Starten"
                                                                        }) : null,
                                                                        r.status === "aktiv" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            disabled: stopMutation.isPending,
                                                                            onClick: ()=>{
                                                                                setStopConfirm({
                                                                                    id: r.id,
                                                                                    beschlussnummer: r.beschlussnummer,
                                                                                    code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                    input: [
                                                                                        "",
                                                                                        "",
                                                                                        "",
                                                                                        ""
                                                                                    ],
                                                                                    error: ""
                                                                                });
                                                                                setOpenActionMenuId(null);
                                                                            },
                                                                            children: "Stoppen"
                                                                        }) : null,
                                                                        canDeleteAnyResolution ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            disabled: isActive || blockedByMissingDeletePermission || blockedByVotes || blockedByCompletedPermission || deleteMutation.isPending,
                                                                            onClick: ()=>{
                                                                                if (isActive) {
                                                                                    setActionError("Aktive Beschl\xfcsse k\xf6nnen nicht gel\xf6scht werden.");
                                                                                    setOpenActionMenuId(null);
                                                                                    return;
                                                                                }
                                                                                if (blockedByMissingDeletePermission) {
                                                                                    setActionError("Keine Berechtigung zum L\xf6schen dieses Beschlusses.");
                                                                                    setOpenActionMenuId(null);
                                                                                    return;
                                                                                }
                                                                                if (blockedByVotes) {
                                                                                    setActionError("Beschl\xfcsse mit Stimmabgaben k\xf6nnen nicht gel\xf6scht werden.");
                                                                                    setOpenActionMenuId(null);
                                                                                    return;
                                                                                }
                                                                                if (blockedByCompletedPermission) {
                                                                                    setActionError("Keine Berechtigung zum L\xf6schen abgeschlossener Beschl\xfcsse.");
                                                                                    setOpenActionMenuId(null);
                                                                                    return;
                                                                                }
                                                                                setDeleteConfirm({
                                                                                    id: r.id,
                                                                                    beschlussnummer: r.beschlussnummer,
                                                                                    code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                    input: [
                                                                                        "",
                                                                                        "",
                                                                                        "",
                                                                                        ""
                                                                                    ],
                                                                                    error: ""
                                                                                });
                                                                                setOpenActionMenuId(null);
                                                                            },
                                                                            children: "L\xf6schen"
                                                                        }) : null
                                                                    ]
                                                                }), document.body) : null
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, r.id);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "resolutions-v2-pagination",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "resolutions-v2-page-size",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: String(pageSize),
                                        onChange: (e)=>{
                                            const next = Number(e.target.value);
                                            setPageSize(Number.isFinite(next) && next > 0 ? next : 10);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "10",
                                                children: "10 pro Seite"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "20",
                                                children: "20 pro Seite"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "50",
                                                children: "50 pro Seite"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolutions-v2-page-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "resolutions-v2-page-arrow",
                                            onClick: ()=>setPage((prev)=>Math.max(1, prev - 1)),
                                            disabled: page <= 1,
                                            children: "\u2039"
                                        }),
                                        pageItems.map((pageItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: `resolutions-v2-page-chip ${pageItem === page ? "active" : ""}`,
                                                onClick: ()=>setPage(pageItem),
                                                children: pageItem
                                            }, pageItem)),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "resolutions-v2-page-arrow",
                                            onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                            disabled: page >= totalPages,
                                            children: "\u203A"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "resolutions-v2-page-info",
                                            children: [
                                                "Seite ",
                                                page,
                                                " von ",
                                                totalPages
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "resolutions-v2-page-next-wrap",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "resolutions-v2-next-btn",
                                        onClick: ()=>setPage((prev)=>Math.min(totalPages, prev + 1)),
                                        disabled: page >= totalPages,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Weiter"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                "aria-hidden": "true",
                                                children: "\u203A"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                    columns: columns,
                    rows: rows,
                    total: totalRows,
                    page: page,
                    pageSize: pageSize,
                    onPageChange: setPage,
                    bodyMaxHeight: 560,
                    topContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "filterbar",
                        style: {
                            margin: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                placeholder: "Suche",
                                value: search,
                                onChange: (e)=>setSearch(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: statusFilter,
                                onChange: (e)=>setStatusFilter(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Alle Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "entwurf",
                                        children: "Entwurf"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "aktiv",
                                        children: "L\xe4uft"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "abgeschlossen",
                                        children: "Beendet"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: resultFilter,
                                onChange: (e)=>setResultFilter(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Alle Ergebnisse"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "angenommen",
                                        children: "Angenommen"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "abgelehnt",
                                        children: "Abgelehnt"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "offen",
                                        children: "Offen"
                                    })
                                ]
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const $e00dfe72bf271e0b$var$formatDateTimeDE = (value)=>{
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return new Intl.DateTimeFormat("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    }).format(d);
};
const $e00dfe72bf271e0b$var$eventLabel = (eventType)=>{
    if (eventType === "einladung_versendet") return "Einladung";
    if (eventType === "erinnerung_1_versendet") return "1. Erinnerung";
    if (eventType === "erinnerung_2_versendet") return "2. Erinnerung";
    return "Beschlussergebnis";
};
const $e00dfe72bf271e0b$var$generatedDocumentLabel = (row)=>{
    if (row.templateKey === "ballot_analog") return "Abstimmformular";
    if (row.templateKey === "invitation_digital" || row.templateKey === "invitation_analog") return "Einladung";
    if (row.templateKey === "reminder1_digital" || row.templateKey === "reminder1_analog") return "1. Erinnerung";
    if (row.templateKey === "reminder2_digital" || row.templateKey === "reminder2_analog") return "2. Erinnerung";
    if (row.templateKey === "result_digital" || row.templateKey === "result_analog") return "Beschlussergebnis";
    return $e00dfe72bf271e0b$var$eventLabel(row.eventType);
};
const $e00dfe72bf271e0b$var$templateEventLabel = (eventType)=>{
    if (eventType === "einladung_versendet") return "Einladung";
    if (eventType === "erinnerung_1_versendet") return "1. Erinnerung";
    if (eventType === "erinnerung_2_versendet") return "2. Erinnerung";
    if (eventType === "resolution_started") return "Beschluss gestartet";
    if (eventType === "invitation_sent_success") return "Einladung erfolgreich versendet";
    if (eventType === "email_bounce_after_retries") return "E-Mail-R\xfcckl\xe4ufer nach Retries";
    if (eventType === "analog_postal_action_required") return "Analoger Versand erforderlich";
    if (eventType === "vote_with_comment") return "Stimmabgabe mit Kommentar";
    if (eventType === "reminder_sent") return "Erinnerung versendet";
    if (eventType === "each_vote_submitted") return "Jede Stimmabgabe";
    if (eventType === "preliminary_result_locked") return "Vorl\xe4ufiges Endergebnis erreicht";
    if (eventType === "resolution_finished_with_result") return "Beschluss beendet";
    return "Beschlussergebnis";
};
const $e00dfe72bf271e0b$var$templateDisplayName = (row)=>{
    if (row.key === "ballot_analog") return "Abstimmformular analog";
    return row.name;
};
const $e00dfe72bf271e0b$var$isTriggerTemplateEvent = (eventType)=>{
    return eventType === "resolution_started" || eventType === "invitation_sent_success" || eventType === "email_bounce_after_retries" || eventType === "analog_postal_action_required" || eventType === "vote_with_comment" || eventType === "reminder_sent" || eventType === "each_vote_submitted" || eventType === "preliminary_result_locked" || eventType === "resolution_finished_with_result";
};
const $e00dfe72bf271e0b$var$isPdfFileName = (fileName)=>typeof fileName === "string" && fileName.trim().toLowerCase().endsWith(".pdf");
const $e00dfe72bf271e0b$var$digitalMailStatusLabel = (status)=>{
    if (status === "sent") return "Versendet";
    if (status === "failed") return "Fehlgeschlagen";
    if (status === "skipped") return "\xdcbersprungen";
    return "-";
};
const $e00dfe72bf271e0b$var$digitalMailStatusBadge = (status)=>{
    if (status === "sent") return "aktiv";
    if (status === "failed") return "ergebnis-abgelehnt";
    if (status === "skipped") return "vote-enthaltung";
    return "inaktiv";
};
const $e00dfe72bf271e0b$var$ShippingProcessTableIcon = ({ name: name })=>{
    if (name === "mail") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "3.8",
                y: "5.2",
                width: "12.4",
                height: "9.6",
                rx: "1.6",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m4.5 6 5.5 4.1L15.5 6",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (name === "date") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4.1",
                y: "5.2",
                width: "11.8",
                height: "10.2",
                rx: "1.7",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.2 3.8v3M12.8 3.8v3M4.8 8.5h10.4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "owner") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "7",
                r: "2.8",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.8 16c.8-2.8 2.7-4.1 5.2-4.1s4.4 1.3 5.2 4.1",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "status") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "5.9",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                fill: "currentColor"
            })
        ]
    });
    if (name === "size") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.5 14.5h11M5.2 11.2h9.6M6 7.9h8M6.8 4.6h6.4",
            stroke: "currentColor",
            strokeWidth: "1.7",
            strokeLinecap: "round"
        })
    });
    if (name === "action") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "4.8",
                r: "1.3",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "1.3",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "15.2",
                r: "1.3",
                fill: "currentColor"
            })
        ]
    });
    if (name === "key") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "7.2",
                cy: "10.1",
                r: "3.1",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.1 10.1h6M14 10.1v2M16 10.1v2",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "type") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.1 4.2h9.8v11.6H5.1z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.4 7.3h5.2M7.4 10h5.2M7.4 12.7h3.4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.2 3.8h6.5l2.9 2.9v8.6a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 15.3V5a1.2 1.2 0 0 1 1.2-1.2Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.8 9.4h6.1M6.8 12.2h5",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
};
const $e00dfe72bf271e0b$var$ShippingProcessTableHeader = ({ label: label, icon: icon, center: center = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `resolutions-v2-th-plain${center ? " resolution-detail-v2-th-center" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-icon",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableIcon, {
                    name: icon
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-label",
                children: label
            })
        ]
    });
const $e00dfe72bf271e0b$var$resolveEnhancedMailStatus = (row)=>{
    const failureClass = row.digitalMailNdrFailureClass;
    const enhancedCode = row.digitalMailNdrEnhancedStatusCode;
    const smtpCode = row.digitalMailNdrSmtpStatusCode;
    if (row.digitalMailStatus === "failed" && failureClass === "permanent") {
        const code = enhancedCode || smtpCode;
        return {
            badgeClass: "ergebnis-abgelehnt",
            label: code ? `Permanent (${code})` : "Permanent (NDR)",
            hint: row.digitalMailNdrReason || row.digitalMailError || "Unzustellbar laut NDR (5.x.x)."
        };
    }
    if (row.digitalMailStatus === "failed" && failureClass === "temporary") {
        const code = enhancedCode || smtpCode;
        return {
            badgeClass: "neutral",
            label: code ? `Tempor\xe4r (${code})` : "Tempor\xe4r",
            hint: row.digitalMailNdrReason || row.digitalMailError || "Tempor\xe4rer Zustellfehler laut NDR (4.x.x)."
        };
    }
    return {
        badgeClass: $e00dfe72bf271e0b$var$digitalMailStatusBadge(row.digitalMailStatus),
        label: $e00dfe72bf271e0b$var$digitalMailStatusLabel(row.digitalMailStatus),
        hint: row.digitalMailError || ""
    };
};
const $e00dfe72bf271e0b$var$DIGITAL_MAIL_MAX_ATTEMPTS = 3;
const $e00dfe72bf271e0b$var$normalizeEmail = (value)=>String(value ?? "").trim().toLowerCase();
const $e00dfe72bf271e0b$var$isValidEmailLike = (value)=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value ?? "").trim());
const $e00dfe72bf271e0b$var$getDispatchRowActivityAt = (row)=>row.digitalMailSentAt || row.digitalMailAttemptedAt || row.digitalMailNdrDetectedAt || row.createdAt || "";
const $e00dfe72bf271e0b$var$getDispatchRowDisplayTimestamp = (row)=>row.kanal === "digital" && row.templateKey !== "ballot_analog" ? row.digitalMailSentAt || row.digitalMailAttemptedAt || row.createdAt : row.createdAt;
const $e00dfe72bf271e0b$export$4be421681837eb26 = ({ resolutionId: resolutionId, hasDigitalRecipients: hasDigitalRecipients, hasAnalogRecipients: hasAnalogRecipients, digitalRecipientCount: digitalRecipientCount, analogRecipientCount: analogRecipientCount })=>{
    const qc = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [generateStatus, setGenerateStatus] = (0, $acw62.useState)(null);
    const [showShippingTemplates, setShowShippingTemplates] = (0, $acw62.useState)(false);
    const [showTriggerTemplates, setShowTriggerTemplates] = (0, $acw62.useState)(false);
    const [previewRow, setPreviewRow] = (0, $acw62.useState)(null);
    const [replaceAddressRow, setReplaceAddressRow] = (0, $acw62.useState)(null);
    const [previewTestRecipientEmail, setPreviewTestRecipientEmail] = (0, $acw62.useState)("");
    const [previewTestMailStatus, setPreviewTestMailStatus] = (0, $acw62.useState)(null);
    const [openActionMenuId, setOpenActionMenuId] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const { actionMenuPosition: actionMenuPosition, openActionMenuAtTrigger: openActionMenuAtTrigger } = (0, $acf0971746b2c487$export$847509c5c6223f45)({
        openMenuId: openActionMenuId,
        setOpenMenuId: setOpenActionMenuId,
        menuWidth: 190
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = (event)=>{
            if ((0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            setOpenActionMenuId(null);
        };
        document.addEventListener("mousedown", closeMenu);
        return ()=>document.removeEventListener("mousedown", closeMenu);
    }, [
        openActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) setIsActionMenuHovered(false);
    }, [
        openActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!openActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>setOpenActionMenuId(null)
    });
    const templatesQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "document-templates"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).documentTemplates(),
        enabled: Boolean(resolutionId)
    });
    const resolutionQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution",
            resolutionId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionById(resolutionId),
        enabled: Boolean(resolutionId)
    });
    const generatedDispatchQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "generated-dispatch",
            resolutionId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).generatedDispatchDocuments(resolutionId),
        enabled: Boolean(resolutionId),
        staleTime: 0,
        refetchOnMount: "always",
        refetchInterval: ()=>typeof document !== "undefined" && document.visibilityState === "visible" ? 60000 : false,
        refetchOnWindowFocus: false
    });
    const ownerAccessesQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-owner-accesses",
            resolutionId
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionOwnerAccesses(resolutionId),
        enabled: Boolean(resolutionId),
        staleTime: 0,
        refetchOnMount: "always",
        refetchOnWindowFocus: false
    });
    const generateDispatchMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (payload)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).generateDispatchDocuments({
                resolutionId: resolutionId,
                eventType: payload.eventType,
                sendDigital: payload.sendDigital
            }),
        onSuccess: async (result, payload)=>{
            await qc.invalidateQueries({
                queryKey: [
                    "generated-dispatch",
                    resolutionId
                ]
            });
            await qc.invalidateQueries({
                queryKey: [
                    "resolution-dispatch-log",
                    resolutionId
                ]
            });
            if (!payload.sendDigital) {
                setGenerateStatus({
                    type: "ok",
                    text: "Dokumente erzeugt."
                });
                return;
            }
            if (result.digitalMail) {
                if (result.digitalMail.failed > 0) setGenerateStatus({
                    type: "error",
                    text: `Dokumente erzeugt. Digitaler Versand: ${result.digitalMail.sent} versendet, ${result.digitalMail.failed} fehlgeschlagen.`
                });
                else if (result.digitalMail.total > 0) setGenerateStatus({
                    type: "ok",
                    text: `Dokumente erzeugt. Digitaler Versand erfolgreich (${result.digitalMail.sent} E-Mails).`
                });
                else setGenerateStatus({
                    type: "ok",
                    text: "Dokumente erzeugt."
                });
            } else setGenerateStatus({
                type: "ok",
                text: "Dokumente erzeugt."
            });
        }
    });
    const updateDispatchAutomationMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (enabled)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateResolution(resolutionId, {
                dispatch_automation_enabled: enabled
            }),
        onSuccess: async ()=>{
            await qc.invalidateQueries({
                queryKey: [
                    "resolution",
                    resolutionId
                ]
            });
            await qc.invalidateQueries({
                queryKey: [
                    "resolutions"
                ]
            });
        },
        onError: (error)=>{
            setGenerateStatus({
                type: "error",
                text: error instanceof Error ? error.message : "Automatik-Einstellung konnte nicht gespeichert werden."
            });
        }
    });
    const retryGeneratedMailMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (payload)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).retryGeneratedDispatchMail(payload.rowId, {
                resolutionId: resolutionId,
                eventType: payload.eventType,
                useCurrentOwnerEmail: payload.useCurrentOwnerEmail
            }),
        onSuccess: async (result)=>{
            await qc.invalidateQueries({
                queryKey: [
                    "generated-dispatch",
                    resolutionId
                ]
            });
            setReplaceAddressRow(null);
            setGenerateStatus({
                type: result.digitalMailStatus === "sent" ? "ok" : "error",
                text: result.digitalMailStatus === "sent" ? result.usedCurrentOwnerEmail && result.replacedDigitalMailTo ? `Adresse f\xfcr diesen Einzelversand von ${result.replacedDigitalMailTo} auf ${result.digitalMailTo ?? "aktuelle Adresse"} ersetzt und Mail versendet.` : `Mail an ${result.digitalMailTo ?? "Empf\xe4nger"} versendet.` : result.digitalMailError || "Mail konnte nicht versendet werden."
            });
        },
        onError: (error)=>{
            setGenerateStatus({
                type: "error",
                text: error instanceof Error ? error.message : "Erneuter Mailversand fehlgeschlagen."
            });
        }
    });
    const mailPreviewMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (row)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).previewDocumentTemplateMail({
                templateKey: row.templateKey,
                resolutionId: resolutionId,
                ownerId: row.ownerId,
                eventType: row.eventType
            }),
        onError: (error)=>{
            setGenerateStatus({
                type: "error",
                text: error instanceof Error ? error.message : "Mail-Vorschau konnte nicht geladen werden."
            });
        }
    });
    const sendPreviewTestMailMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (!previewRow) throw new Error("Keine Mail-Vorschau ausgew\xe4hlt.");
            const recipientEmail = previewTestRecipientEmail.trim();
            if (!recipientEmail) throw new Error("Bitte Empf\xe4nger-E-Mail f\xfcr die Testmail eingeben.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).sendDocumentTemplatePreviewMailTest({
                templateKey: previewRow.templateKey,
                resolutionId: resolutionId,
                ownerId: previewRow.ownerId,
                eventType: previewRow.eventType,
                recipientEmail: recipientEmail
            });
        },
        onSuccess: (result)=>{
            setPreviewTestMailStatus({
                type: "ok",
                text: `Testmail an ${result.recipientEmail} versendet${result.messageId ? ` (Message-ID: ${result.messageId})` : ""}.`
            });
        },
        onError: (error)=>{
            setPreviewTestMailStatus({
                type: "error",
                text: error instanceof Error ? error.message : "Testmail konnte nicht versendet werden."
            });
        }
    });
    const templateRows = templatesQuery.data?.templates ?? [];
    const generatedRows = generatedDispatchQuery.data?.data ?? [];
    const ownerAccessRows = ownerAccessesQuery.data?.data ?? [];
    const digitalGeneratedRows = generatedRows.filter((row)=>row.kanal === "digital" && row.templateKey !== "ballot_analog");
    const analogGeneratedRows = generatedRows.filter((row)=>row.kanal === "analog");
    const ownerLabelById = new Map(ownerAccessRows.map((row)=>[
            row.ownerId,
            row.eigentuemername
        ]));
    const ownerEmailById = new Map(ownerAccessRows.map((row)=>[
            row.ownerId,
            row.email
        ]));
    const digitalMailSummary = {
        total: digitalGeneratedRows.length,
        sent: digitalGeneratedRows.filter((row)=>row.digitalMailStatus === "sent").length,
        failed: digitalGeneratedRows.filter((row)=>row.digitalMailStatus === "failed").length,
        permanentFailed: digitalGeneratedRows.filter((row)=>row.digitalMailStatus === "failed" && row.digitalMailNdrFailureClass === "permanent").length,
        skipped: digitalGeneratedRows.filter((row)=>row.digitalMailStatus === "skipped").length,
        pendingRetry: digitalGeneratedRows.filter((row)=>row.digitalMailStatus === "failed" && (row.digitalMailRetries ?? 0) < $e00dfe72bf271e0b$var$DIGITAL_MAIL_MAX_ATTEMPTS).length,
        exhausted: digitalGeneratedRows.filter((row)=>row.digitalMailStatus === "failed" && (row.digitalMailRetries ?? 0) >= $e00dfe72bf271e0b$var$DIGITAL_MAIL_MAX_ATTEMPTS).length,
        nextRetryAt: digitalGeneratedRows.map((row)=>row.digitalMailNextRetryAt).filter((value)=>Boolean(value)).sort((a, b)=>a.localeCompare(b))[0] ?? null
    };
    const canGenerate = hasDigitalRecipients || hasAnalogRecipients;
    const channelLabel = hasDigitalRecipients && hasAnalogRecipients ? "digital + analog" : hasDigitalRecipients ? "digital" : hasAnalogRecipients ? "analog" : "keine Empf\xe4nger";
    const dispatchAutomationEnabled = Boolean(resolutionQuery.data?.dispatch_automation_enabled ?? false);
    const shippingTemplates = (0, $acw62.useMemo)(()=>templateRows.filter((row)=>{
            if ($e00dfe72bf271e0b$var$isTriggerTemplateEvent(row.eventType)) return false;
            if (row.kanal === "digital") return hasDigitalRecipients;
            return hasAnalogRecipients;
        }), [
        templateRows,
        hasDigitalRecipients,
        hasAnalogRecipients
    ]);
    const selectedTriggerEvents = (0, $acw62.useMemo)(()=>{
        const configured = resolutionQuery.data?.trigger_notifications_events;
        if (!configured || typeof configured !== "object") return null;
        return new Set(Object.entries(configured).filter(([, enabled])=>Boolean(enabled)).map(([eventType])=>eventType));
    }, [
        resolutionQuery.data?.trigger_notifications_events
    ]);
    const triggerTemplates = (0, $acw62.useMemo)(()=>templateRows.filter((row)=>{
            if (!$e00dfe72bf271e0b$var$isTriggerTemplateEvent(row.eventType)) return false;
            if (!selectedTriggerEvents) return true; // Fallback für Alt-Datensätze ohne Event-Konfiguration.
            return selectedTriggerEvents.has(row.eventType);
        }), [
        templateRows,
        selectedTriggerEvents
    ]);
    const triggerChannel = resolutionQuery.data?.trigger_notifications_channel === "facilioo" ? "facilioo" : "email";
    const triggerChannelLabel = triggerChannel === "facilioo" ? "Facilioo" : "Email";
    const eventButtons = [
        {
            eventType: "einladung_versendet",
            generateTitle: "Einladungspaket erzeugen",
            sendTitle: "Einladung versenden"
        },
        {
            eventType: "erinnerung_1_versendet",
            generateTitle: "1. Erinnerung erzeugen",
            sendTitle: "1. Erinnerung versenden"
        },
        {
            eventType: "erinnerung_2_versendet",
            generateTitle: "2. Erinnerung erzeugen",
            sendTitle: "2. Erinnerung versenden"
        },
        {
            eventType: "beschlussergebnis_versendet",
            generateTitle: "Ergebnispaket erzeugen",
            sendTitle: "Ergebnis versenden"
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel shipping-process-v2-main-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Versandprozess"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "panel-inset v2-info-banner shipping-process-automation-v2-info",
                        style: {
                            marginTop: 10
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "settings-switch-row",
                            style: {
                                marginBottom: 6
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "settings-toggle",
                                    title: "Automatischer Versandprozess",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: dispatchAutomationEnabled,
                                            disabled: updateDispatchAutomationMutation.isPending || resolutionQuery.isLoading,
                                            onChange: (e)=>{
                                                setGenerateStatus(null);
                                                updateDispatchAutomationMutation.mutate(Boolean(e.target.checked));
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "settings-toggle-slider"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Automatischer Versandprozess"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            children: dispatchAutomationEnabled ? "Automatik aktiv: Dokumente werden zum Termin erzeugt und E-Mails automatisch versendet." : "Automatik aus: Dokumente werden zum Termin erzeugt, der Versand erfolgt nur nach manueller Best\xe4tigung."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !dispatchAutomationEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "panel-inset shipping-process-v2-template-panel",
                                style: {
                                    marginTop: 10,
                                    background: "#ffffff"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginBottom: 8,
                                            gap: 8,
                                            flexWrap: "wrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    fontWeight: 700
                                                },
                                                children: [
                                                    "Verwendete Vorlagen (",
                                                    channelLabel,
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                style: {
                                                    marginLeft: "auto"
                                                },
                                                onClick: ()=>setShowShippingTemplates((prev)=>!prev),
                                                children: showShippingTemplates ? "Einklappen" : "Ausklappen"
                                            })
                                        ]
                                    }),
                                    showShippingTemplates ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolution-detail-v2-table-wrap shipping-process-v2-table-wrap",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "resolution-detail-v2-table resolution-detail-shipping-v2-table shipping-process-templates-v2-table",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                                    label: "Vorlage",
                                                                    icon: "document"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                                    label: "Kanal",
                                                                    icon: "mail",
                                                                    center: true
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                                    label: "Typ",
                                                                    icon: "type",
                                                                    center: true
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        shippingTemplates.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: $e00dfe72bf271e0b$var$templateDisplayName(row)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "badge kanal-grau",
                                                                            children: row.kanal
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: $e00dfe72bf271e0b$var$templateEventLabel(row.eventType)
                                                                    })
                                                                ]
                                                            }, row.key)),
                                                        !shippingTemplates.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: 3,
                                                                children: "Keine passenden Versand-Vorlagen f\xfcr die aktuelle Erreichbarkeit."
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "panel-inset shipping-process-v2-template-panel",
                                style: {
                                    marginTop: 10,
                                    background: "#ffffff"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginBottom: 8,
                                            gap: 8,
                                            flexWrap: "wrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontWeight: 700
                                                },
                                                children: "Trigger-Vorlagen (interne Verwaltungsnachrichten)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                style: {
                                                    marginLeft: "auto"
                                                },
                                                onClick: ()=>setShowTriggerTemplates((prev)=>!prev),
                                                children: showTriggerTemplates ? "Einklappen" : "Ausklappen"
                                            })
                                        ]
                                    }),
                                    showTriggerTemplates ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "resolution-detail-v2-table-wrap shipping-process-v2-table-wrap",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "resolution-detail-v2-table resolution-detail-shipping-v2-table shipping-process-templates-v2-table",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                                    label: "Vorlage",
                                                                    icon: "document"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                                    label: "Kanal",
                                                                    icon: "mail",
                                                                    center: true
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                                    label: "Typ",
                                                                    icon: "type",
                                                                    center: true
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        triggerTemplates.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: $e00dfe72bf271e0b$var$templateDisplayName(row)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "badge kanal-grau",
                                                                            children: triggerChannelLabel
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: $e00dfe72bf271e0b$var$templateEventLabel(row.eventType)
                                                                    })
                                                                ]
                                                            }, row.key)),
                                                        !triggerTemplates.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: 3,
                                                                children: "Keine Trigger-Vorlagen vorhanden."
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }) : null,
                    !dispatchAutomationEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "form-actions",
                        style: {
                            marginTop: 12,
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 8
                        },
                        children: eventButtons.map((btn)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: 8,
                                    alignItems: "center",
                                    flexWrap: "wrap"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: !canGenerate || generateDispatchMutation.isPending,
                                        onClick: ()=>{
                                            setGenerateStatus(null);
                                            generateDispatchMutation.mutate({
                                                eventType: btn.eventType,
                                                sendDigital: false
                                            });
                                        },
                                        title: canGenerate ? `Erzeugt ${$e00dfe72bf271e0b$var$eventLabel(btn.eventType)} f\xfcr ${channelLabel} (ohne E-Mail-Versand)` : "Keine Empf\xe4nger vorhanden",
                                        children: generateDispatchMutation.isPending ? "Erzeuge..." : btn.generateTitle
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: !canGenerate || generateDispatchMutation.isPending || !hasDigitalRecipients,
                                        onClick: ()=>{
                                            setGenerateStatus(null);
                                            generateDispatchMutation.mutate({
                                                eventType: btn.eventType,
                                                sendDigital: true
                                            });
                                        },
                                        title: hasDigitalRecipients ? `L\xf6st den digitalen Versand f\xfcr ${$e00dfe72bf271e0b$var$eventLabel(btn.eventType)} aus` : "Keine digitalen Empf\xe4nger vorhanden",
                                        children: generateDispatchMutation.isPending ? "Versende..." : btn.sendTitle
                                    })
                                ]
                            }, btn.eventType))
                    }) : null,
                    generateStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 10
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                            style: {
                                color: generateStatus.type === "ok" ? "#0f7b31" : "#b42318",
                                fontWeight: 600
                            },
                            children: generateStatus.text
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel shipping-process-v2-main-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Erzeugte Versanddokumente"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "panel-inset",
                        style: {
                            marginBottom: 10
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit,minmax(130px,1fr))",
                                gap: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "kpi",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Digital"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            className: "shipping-process-v2-kpi-lines",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "shipping-process-v2-kpi-line",
                                                    children: [
                                                        digitalRecipientCount,
                                                        " Zustelladressen"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "shipping-process-v2-kpi-line",
                                                    children: [
                                                        digitalMailSummary.sent,
                                                        " erfolgreich versendet"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "kpi",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Analog"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            className: "shipping-process-v2-kpi-lines",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "shipping-process-v2-kpi-line",
                                                    children: [
                                                        analogRecipientCount,
                                                        " Empf\xe4nger"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "shipping-process-v2-kpi-line",
                                                    children: [
                                                        analogGeneratedRows.length,
                                                        " Dokumente erzeugt"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `kpi shipping-process-v2-delivery-kpi shipping-process-v2-delivery-kpi--${digitalMailSummary.failed > 0 ? "error" : "ok"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Fehlgeschlagen"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: digitalMailSummary.failed
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `kpi shipping-process-v2-delivery-kpi shipping-process-v2-delivery-kpi--${digitalMailSummary.permanentFailed > 0 ? "error" : "ok"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Permanent (5.x.x)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: digitalMailSummary.permanentFailed
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "resolution-detail-v2-table-wrap shipping-process-v2-table-wrap",
                        style: {
                            maxHeight: 260
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "resolution-detail-v2-table resolution-detail-shipping-v2-table shipping-process-generated-v2-table",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                    label: "Zeitpunkt",
                                                    icon: "date"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                    label: "Eigent\xfcmer",
                                                    icon: "owner"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                    label: "Kanal",
                                                    icon: "mail",
                                                    center: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                    label: "E-Mail",
                                                    icon: "mail",
                                                    center: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                    label: "Mail-Status",
                                                    icon: "status",
                                                    center: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                    label: "Versuche",
                                                    icon: "key",
                                                    center: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                    label: "N\xe4chster Retry",
                                                    icon: "date",
                                                    center: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                    label: "Dokument",
                                                    icon: "document"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "resolutions-v2-actions-head shipping-process-v2-actions-head",
                                                "aria-label": "Aktionen",
                                                title: "Aktionen",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e00dfe72bf271e0b$var$ShippingProcessTableHeader, {
                                                    label: "Aktionen",
                                                    icon: "action",
                                                    center: true
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        generatedRows.map((row)=>{
                                            const menuId = `shipping-${row.id}`;
                                            const canOpenPdf = $e00dfe72bf271e0b$var$isPdfFileName(row.fileName);
                                            const canPreviewMail = row.kanal === "digital" && row.templateKey !== "ballot_analog";
                                            const currentOwnerEmail = ownerEmailById.get(row.ownerId);
                                            const hasCurrentOwnerEmailReplacement = $e00dfe72bf271e0b$var$isValidEmailLike(currentOwnerEmail) && $e00dfe72bf271e0b$var$normalizeEmail(currentOwnerEmail) !== $e00dfe72bf271e0b$var$normalizeEmail(row.digitalMailTo);
                                            const rowActivityAt = $e00dfe72bf271e0b$var$getDispatchRowActivityAt(row);
                                            const hasLaterSuccessfulDeliveryProof = generatedRows.some((candidate)=>candidate.id !== row.id && candidate.ownerId === row.ownerId && candidate.kanal === "digital" && candidate.templateKey !== "ballot_analog" && candidate.digitalMailStatus === "sent" && $e00dfe72bf271e0b$var$normalizeEmail(candidate.digitalMailTo) === $e00dfe72bf271e0b$var$normalizeEmail(row.digitalMailTo) && (!rowActivityAt || $e00dfe72bf271e0b$var$getDispatchRowActivityAt(candidate).localeCompare(rowActivityAt) >= 0));
                                            const canSendMail = canPreviewMail && (row.digitalMailNdrFailureClass !== "permanent" || hasCurrentOwnerEmailReplacement || hasLaterSuccessfulDeliveryProof);
                                            const hasActions = canOpenPdf || canPreviewMail || canSendMail;
                                            const sendMailLabel = hasCurrentOwnerEmailReplacement ? "Mit aktueller Adresse senden" : row.digitalMailStatus === "sent" ? "Erneut versenden" : row.digitalMailStatus === "failed" ? "Mail erneut versenden" : "Mail versenden";
                                            const actionMenuHeight = 12 + [
                                                canOpenPdf,
                                                canPreviewMail,
                                                canSendMail
                                            ].filter(Boolean).length * 42;
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $e00dfe72bf271e0b$var$formatDateTimeDE($e00dfe72bf271e0b$var$getDispatchRowDisplayTimestamp(row))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: row.eigentuemerName || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "badge kanal-grau",
                                                            children: row.kanal
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: row.digitalMailTo || "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: (()=>{
                                                            const statusInfo = $e00dfe72bf271e0b$var$resolveEnhancedMailStatus(row);
                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `badge ${statusInfo.badgeClass}`,
                                                                title: statusInfo.hint || undefined,
                                                                children: statusInfo.label
                                                            });
                                                        })()
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: row.kanal === "digital" && row.templateKey !== "ballot_analog" ? `${row.digitalMailRetries ?? 0} / ${$e00dfe72bf271e0b$var$DIGITAL_MAIL_MAX_ATTEMPTS}` : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: row.digitalMailNextRetryAt ? $e00dfe72bf271e0b$var$formatDateTimeDE(row.digitalMailNextRetryAt) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: $e00dfe72bf271e0b$var$generatedDocumentLabel(row)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "shipping-process-v2-actions-cell",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "resolutions-v2-action-wrap",
                                                            onClick: (e)=>e.stopPropagation(),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "resolutions-v2-action-trigger",
                                                                    "aria-label": `Aktionen f\xfcr ${$e00dfe72bf271e0b$var$generatedDocumentLabel(row)} von ${row.eigentuemerName || "Eigent\xfcmer"}`,
                                                                    "aria-expanded": openActionMenuId === menuId,
                                                                    disabled: !hasActions,
                                                                    onMouseDown: (e)=>e.stopPropagation(),
                                                                    onClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        if (!hasActions) return;
                                                                        if (openActionMenuId === menuId) {
                                                                            setOpenActionMenuId(null);
                                                                            return;
                                                                        }
                                                                        openActionMenuAtTrigger(menuId, e.currentTarget, actionMenuHeight);
                                                                    },
                                                                    children: "\u22EE"
                                                                }),
                                                                openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                    style: {
                                                                        left: actionMenuPosition.left,
                                                                        top: actionMenuPosition.top
                                                                    },
                                                                    onMouseDown: (e)=>e.stopPropagation(),
                                                                    onMouseEnter: ()=>setIsActionMenuHovered(true),
                                                                    onMouseLeave: ()=>setIsActionMenuHovered(false),
                                                                    children: [
                                                                        canOpenPdf ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                            href: row.fileUrl,
                                                                            target: "_blank",
                                                                            rel: "noreferrer",
                                                                            onClick: ()=>setOpenActionMenuId(null),
                                                                            children: "PDF \xf6ffnen"
                                                                        }) : null,
                                                                        canPreviewMail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>{
                                                                                setPreviewRow(row);
                                                                                setPreviewTestRecipientEmail(row.digitalMailTo ?? "");
                                                                                setPreviewTestMailStatus(null);
                                                                                mailPreviewMutation.mutate(row);
                                                                                setOpenActionMenuId(null);
                                                                            },
                                                                            disabled: mailPreviewMutation.isPending,
                                                                            title: `Vorschau f\xfcr ${ownerLabelById.get(row.ownerId) ?? row.eigentuemerName}`,
                                                                            children: mailPreviewMutation.isPending && previewRow?.id === row.id ? "Lade..." : "Mail-Vorschau"
                                                                        }) : null,
                                                                        canSendMail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            disabled: retryGeneratedMailMutation.isPending,
                                                                            onClick: ()=>{
                                                                                setGenerateStatus(null);
                                                                                if (hasCurrentOwnerEmailReplacement) setReplaceAddressRow(row);
                                                                                else retryGeneratedMailMutation.mutate({
                                                                                    rowId: row.id,
                                                                                    eventType: row.eventType
                                                                                });
                                                                                setOpenActionMenuId(null);
                                                                            },
                                                                            title: hasCurrentOwnerEmailReplacement ? `Aktuelle Adresse ${currentOwnerEmail} f\xfcr diesen Einzelversand verwenden` : hasLaterSuccessfulDeliveryProof ? "Erneuter Versand m\xf6glich, da diese Adresse sp\xe4ter erfolgreich zugestellt wurde." : row.digitalMailError || "E-Mail erneut versenden",
                                                                            children: retryGeneratedMailMutation.isPending ? "Sende..." : sendMailLabel
                                                                        }) : null
                                                                    ]
                                                                }), document.body) : null
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, row.id);
                                        }),
                                        !generatedRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: 9,
                                                children: "Noch keine erzeugten Versanddokumente."
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            replaceAddressRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-backdrop",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "panel modal-card shipping-process-address-confirm-modal",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            style: {
                                marginTop: 0,
                                marginBottom: 8
                            },
                            children: "Aktuelle E-Mail-Adresse verwenden?"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "F\xfcr dieses Versanddokument ist ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: replaceAddressRow.digitalMailTo || "-"
                                }),
                                " gespeichert. In den Stammdaten steht aktuell ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: ownerEmailById.get(replaceAddressRow.ownerId) || "-"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Soll die Adresse nur f\xfcr diesen Einzelversand ersetzt und die Mail danach versendet werden?"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-actions",
                            style: {
                                marginTop: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "resolution-primary-btn",
                                    disabled: retryGeneratedMailMutation.isPending,
                                    onClick: ()=>{
                                        setGenerateStatus(null);
                                        retryGeneratedMailMutation.mutate({
                                            rowId: replaceAddressRow.id,
                                            eventType: replaceAddressRow.eventType,
                                            useCurrentOwnerEmail: true
                                        });
                                    },
                                    children: retryGeneratedMailMutation.isPending ? "Sende..." : "Mit aktueller Adresse senden"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    disabled: retryGeneratedMailMutation.isPending || replaceAddressRow.digitalMailNdrFailureClass === "permanent",
                                    title: replaceAddressRow.digitalMailNdrFailureClass === "permanent" ? "Bei permanentem Zustellfehler nur mit aktueller Adresse m\xf6glich." : undefined,
                                    onClick: ()=>{
                                        setGenerateStatus(null);
                                        retryGeneratedMailMutation.mutate({
                                            rowId: replaceAddressRow.id,
                                            eventType: replaceAddressRow.eventType
                                        });
                                    },
                                    children: "Mit gespeicherter Adresse senden"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setReplaceAddressRow(null),
                                    disabled: retryGeneratedMailMutation.isPending,
                                    children: "Abbrechen"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            previewRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-backdrop",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "panel modal-card",
                    style: {
                        width: "min(1400px, 98vw)",
                        maxWidth: 1400,
                        maxHeight: "94vh",
                        overflow: "auto"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                            style: {
                                marginTop: 0,
                                marginBottom: 8
                            },
                            children: [
                                "Mail-Vorschau: ",
                                ownerLabelById.get(previewRow.ownerId) ?? previewRow.eigentuemerName
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                            style: {
                                color: "var(--text-soft)"
                            },
                            children: [
                                "Beschluss ",
                                previewRow.beschlussnummer,
                                " | Objekt ",
                                previewRow.objektnummer,
                                " | Vorlage ",
                                previewRow.templateKey
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                marginTop: 10
                            },
                            children: mailPreviewMutation.isPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "Lade Vorschau..."
                            }) : mailPreviewMutation.data ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                title: `Mail-Vorschau ${previewRow.id}`,
                                srcDoc: mailPreviewMutation.data.html,
                                style: {
                                    width: "100%",
                                    height: "80vh",
                                    border: "1px solid var(--line)",
                                    borderRadius: 6,
                                    background: "#fff"
                                }
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "error-text",
                                children: "Vorschau konnte nicht geladen werden."
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "panel-inset",
                            style: {
                                marginTop: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontWeight: 700,
                                        marginBottom: 8
                                    },
                                    children: "Testmail senden"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        gap: 8,
                                        alignItems: "center",
                                        flexWrap: "wrap"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "email",
                                            className: "table-field",
                                            value: previewTestRecipientEmail,
                                            onChange: (e)=>setPreviewTestRecipientEmail(e.target.value),
                                            placeholder: "empf\xe4nger@beispiel.de",
                                            style: {
                                                width: "min(280px, 100%)",
                                                flex: "0 0 auto"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>{
                                                setPreviewTestMailStatus(null);
                                                sendPreviewTestMailMutation.mutate();
                                            },
                                            disabled: sendPreviewTestMailMutation.isPending || !previewRow || !mailPreviewMutation.data,
                                            children: sendPreviewTestMailMutation.isPending ? "Sende Testmail..." : "Testmail senden"
                                        })
                                    ]
                                }),
                                previewTestMailStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                    style: {
                                        display: "block",
                                        marginTop: 8,
                                        color: previewTestMailStatus.type === "ok" ? "#0f7b31" : "#b42318",
                                        fontWeight: 600
                                    },
                                    children: previewTestMailStatus.text
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-actions",
                            style: {
                                marginTop: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>mailPreviewMutation.mutate(previewRow),
                                    disabled: mailPreviewMutation.isPending,
                                    children: mailPreviewMutation.isPending ? "Aktualisiere..." : "Vorschau aktualisieren"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        setPreviewRow(null);
                                        setPreviewTestMailStatus(null);
                                    },
                                    children: "Schlie\xdfen"
                                })
                            ]
                        })
                    ]
                })
            }) : null
        ]
    });
};



var $845661e1cd923dd3$import_meta = Object.assign(Object.create(null), {
    url: "file:///src/pages/ResolutionDetailPage.tsx"
});
const $845661e1cd923dd3$var$DIGITAL_MAIL_MAX_ATTEMPTS = 3;
const $845661e1cd923dd3$var$normalizeEmail = (value)=>String(value ?? "").trim().toLowerCase();
const $845661e1cd923dd3$var$isValidEmailLike = (value)=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value ?? "").trim());
const $845661e1cd923dd3$var$getGeneratedDispatchRowActivityAt = (row)=>row.digitalMailSentAt || row.digitalMailAttemptedAt || row.digitalMailNdrDetectedAt || row.createdAt || "";
const $845661e1cd923dd3$var$isGeneratedDispatchRowForOwner = (row, ownerId)=>{
    const normalizedOwnerId = String(ownerId ?? "").trim();
    if (!normalizedOwnerId) return false;
    return String(row.eigentuemerId ?? "").trim() === normalizedOwnerId || String(row.ownerId ?? "").trim() === normalizedOwnerId;
};
const $845661e1cd923dd3$var$RECIPIENT_TABLE_ROW_HEIGHT = 44;
const $845661e1cd923dd3$var$RECIPIENT_TABLE_OVERSCAN = 10;
const $845661e1cd923dd3$var$VOTE_TABLE_ROW_HEIGHT = 72;
const $845661e1cd923dd3$var$VOTE_TABLE_OVERSCAN = 8;
const $845661e1cd923dd3$var$RECIPIENT_PAGE_SIZE = 100;
const $845661e1cd923dd3$var$RECIPIENT_BULK_PAGE_SIZE = 5000;
const $845661e1cd923dd3$var$RESULT_VOTE_ROW_COUNT_OPTIONS = [
    10,
    25,
    50,
    100
];
const $845661e1cd923dd3$var$RESOLUTION_SSE_ENABLED = String(globalThis.__APP_RESOLUTION_SSE_ENABLED__ ?? $845661e1cd923dd3$import_meta.env?.VITE_RESOLUTION_SSE_ENABLED ?? "true").trim().toLowerCase() === "true";
const $845661e1cd923dd3$var$tabs = [
    {
        key: "stammdaten",
        label: "\xdcbersicht"
    },
    {
        key: "beschlusstext",
        label: "Beschluss"
    },
    {
        key: "empfaenger",
        label: "Empf\xe4nger"
    },
    {
        key: "stimmen",
        label: "Abstimmung"
    },
    {
        key: "versand",
        label: "Versandprozess"
    },
    {
        key: "ergebnis",
        label: "Ergebnis"
    },
    {
        key: "dokumente",
        label: "Dokumente"
    },
    {
        key: "facilioo_dokumente",
        label: "Facilioo-Dokumente"
    }
];
const $845661e1cd923dd3$var$getTodayDateKey = ()=>new Date().toISOString().slice(0, 10);
const $845661e1cd923dd3$var$formatDateDE = (value)=>{
    if (!value) return "-";
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? `${m[3]}.${m[2]}.${m[1]}` : value;
};
const $845661e1cd923dd3$var$formatDateTimeDE = (value)=>{
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return new Intl.DateTimeFormat("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    }).format(d);
};
const $845661e1cd923dd3$var$MOJIBAKE_PATTERN = /(Ã.|Â.|â.|ð.|�)/;
const $845661e1cd923dd3$var$normalizeMojibake = (value)=>{
    const raw = String(value ?? "");
    if (!raw) return "";
    let next = raw;
    for(let i = 0; i < 3; i += 1){
        if (!$845661e1cd923dd3$var$MOJIBAKE_PATTERN.test(next)) break;
        try {
            const bytes = Uint8Array.from(next, (char)=>char.charCodeAt(0) & 0xff);
            const decoded = new TextDecoder("utf-8").decode(bytes);
            if (!decoded || decoded === next) break;
            next = decoded;
        } catch  {
            break;
        }
    }
    return next.replace(/Eigent(?:Ã¼|Ãœ|ÃƒÂ¼|[ՈՕ]¼|¼)mer/g, "Eigent\xfcmer").replace(/Stimm(?:Ã¤|Ã„|ÃƒÂ¤|[ՈՕ]¤|¤)nderung/g, "Stimm\xe4nderung").replace(/ung(?:Ã¼|Ãœ|ÃƒÂ¼|[ՈՕ]¼|¼)ltig/g, "ung\xfcltig");
};
const $845661e1cd923dd3$var$formatFileSize = (sizeBytes)=>{
    if (!Number.isFinite(sizeBytes) || sizeBytes <= 0) return "-";
    if (sizeBytes < 1024) return `${Math.round(sizeBytes)} B`;
    if (sizeBytes < 1048576) return `${(sizeBytes / 1024).toFixed(1)} KB`;
    return `${(sizeBytes / 1048576).toFixed(2)} MB`;
};
const $845661e1cd923dd3$var$resolveFileTypeLabel = (row)=>{
    const fromFaciliooType = String(row.fileTypeLabel ?? "").trim();
    if (fromFaciliooType) return fromFaciliooType;
    const fromFaciliooExtension = String(row.fileExtension ?? "").trim();
    if (fromFaciliooExtension) return fromFaciliooExtension.toUpperCase();
    const name = String(row.originalFilename || row.internalFilename || "").trim().toLowerCase();
    const dotIndex = name.lastIndexOf(".");
    if (dotIndex >= 0 && dotIndex < name.length - 1) return name.slice(dotIndex + 1).toUpperCase();
    if (Number.isFinite(Number(row.typeId))) return `Typ ${Number(row.typeId)}`;
    return "-";
};
const $845661e1cd923dd3$var$resolveAttachmentFilename = (row)=>{
    const base = String(row.originalFilename || row.internalFilename || "").trim() || `Anhang_${row.attachmentId}`;
    const ext = String(row.fileExtension ?? "").trim().replace(/^\./, "");
    if (!ext) return base;
    if (new RegExp(`\\.${ext}$`, "i").test(base)) return base;
    return `${base}.${ext}`;
};
const $845661e1cd923dd3$var$isPreviewableFaciliooAttachment = (row)=>{
    const mime = String(row.mimeType ?? "").trim().toLowerCase();
    if (mime === "application/pdf" || mime.startsWith("image/")) return true;
    const extFromType = String(row.fileExtension ?? "").trim().toLowerCase().replace(/^\./, "");
    if ([
        "pdf",
        "png",
        "jpg",
        "jpeg",
        "gif",
        "webp",
        "svg"
    ].includes(extFromType)) return true;
    const resolvedName = $845661e1cd923dd3$var$resolveAttachmentFilename(row).toLowerCase();
    return [
        ".pdf",
        ".png",
        ".jpg",
        ".jpeg",
        ".gif",
        ".webp",
        ".svg"
    ].some((suffix)=>resolvedName.endsWith(suffix));
};
const $845661e1cd923dd3$var$formatStatus = (status)=>{
    if (status === "aktiv") return "l\xe4uft";
    if (status === "abgeschlossen") return "beendet";
    return "Entwurf";
};
const $845661e1cd923dd3$var$formatQuorum = (value)=>{
    if (value === "qualifizierte_mehrheit") return "Qualifizierte Mehrheit";
    if (value === "allstimmig") return "Allstimmig";
    return "Einfache Mehrheit";
};
const $845661e1cd923dd3$var$formatStimmrechtsart = (value)=>{
    if (value === "kopf") return "Kopfstimmen";
    if (value === "mea") return "MEA";
    return "Stimmrecht";
};
const $845661e1cd923dd3$var$formatTriggerDeliveryStatus = (status)=>{
    const normalized = String(status ?? "").trim().toLowerCase();
    if (normalized === "sent" || normalized === "delivered") return "Versendet";
    if (normalized === "failed") return "Fehlgeschlagen";
    if (normalized === "queued" || normalized === "pending") return "In Warteschlange";
    if (normalized === "retrying") return "Wiederholung l\xe4uft";
    if (normalized === "processing") return "In Bearbeitung";
    if (normalized === "skipped") return "\xdcbersprungen";
    if (normalized === "cancelled" || normalized === "canceled") return "Abgebrochen";
    if (!normalized) return "-";
    return status ?? "-";
};
const $845661e1cd923dd3$var$formatTriggerEventType = (eventType)=>{
    const normalized = String(eventType ?? "").trim().toLowerCase();
    if (normalized === "resolution_started") return "Beschluss gestartet";
    if (normalized === "invitation_sent_success") return "Einladung erfolgreich versendet";
    if (normalized === "reminder_sent") return "Erinnerung versendet";
    if (normalized === "each_vote_submitted") return "Stimmabgabe eingegangen";
    if (normalized === "vote_with_comment") return "Stimmabgabe mit Kommentar";
    if (normalized === "preliminary_result_locked") return "Vorl\xe4ufiges Endergebnis erreicht";
    if (normalized === "resolution_finished_with_result") return "Beschluss beendet";
    if (normalized === "email_bounce_after_retries") return "E-Mail-R\xfcckl\xe4ufer nach Retries";
    if (normalized === "analog_postal_action_required") return "Analoger Versand erforderlich";
    if (normalized === "delivery_retries_exhausted") return "E-Mail-R\xfcckl\xe4ufer nach Retries";
    if (normalized === "analog_dispatch_required") return "Analoger Versand erforderlich";
    if (!normalized) return "-";
    return eventType ?? "-";
};
const $845661e1cd923dd3$var$formatTriggerChannel = (channel)=>{
    const normalized = String(channel ?? "").trim().toLowerCase();
    if (normalized === "email") return "E-Mail";
    if (normalized === "facilioo") return "Facilioo";
    if (!normalized) return "-";
    return channel ?? "-";
};
const $845661e1cd923dd3$var$getRemainingDaysForActiveResolution = (status, endedatum)=>{
    if (!endedatum) return "-";
    const match = endedatum.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return "-";
    const end = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffMs = end.getTime() - today.getTime();
    if (status !== "aktiv") return "0";
    const days = Math.floor(diffMs / 86400000) + 1;
    if (days <= 0) return "0";
    return String(days);
};
const $845661e1cd923dd3$var$formatVoteValue = (value)=>{
    if (value === "ja") return "Ja";
    if (value === "nein") return "Nein";
    if (value === "enthaltung") return "Enthaltung";
    return "Offen";
};
const $845661e1cd923dd3$var$formatUnitNumberForResult = (value)=>{
    const raw = String(value ?? "").trim();
    if (!raw) return "-";
    if (/^\d+$/.test(raw)) return raw.padStart(4, "0");
    return raw;
};
const $845661e1cd923dd3$var$formatVoteEventType = (value)=>{
    const normalized = $845661e1cd923dd3$var$normalizeMojibake(value);
    if (normalized === "stimm\xe4nderung") return "Stimm\xe4nderung";
    if (normalized === "erstmalige_stimmabgabe") return "Erstabgabe";
    return normalized || "-";
};
const $845661e1cd923dd3$var$formatSubmissionChannel = (value)=>{
    const normalized = $845661e1cd923dd3$var$normalizeMojibake(value);
    if (normalized === "admin_console") return "Admin-Konsole";
    if (normalized === "owner_link") return "Eigent\xfcmer-Link";
    if (normalized === "owner_login") return "Eigent\xfcmer-Login";
    if (normalized === "system_dispatch") return "Systemversand";
    return normalized || "-";
};
const $845661e1cd923dd3$var$ResolutionKpiIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.1 4.6h6.6l3.2 3.2v11.6H7.1z",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.7 4.8v3.1h3",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m9.4 14.1 2 2 4.2-5",
                stroke: "currentColor",
                strokeWidth: "1.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17.7",
                cy: "17.8",
                r: "2.1",
                fill: "#fff",
                stroke: "currentColor",
                strokeWidth: "1.85"
            })
        ]
    });
const $845661e1cd923dd3$var$RemainingTimeIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "11",
                r: "5.8",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 11V7.8M10 11l2.5 1.8M8 3.8h4M9 3.8v1.8M11 3.8v1.8",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const $845661e1cd923dd3$var$OwnerNameIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9.1",
                cy: "9.1",
                r: "2.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "15.8",
                cy: "8.4",
                r: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
const $845661e1cd923dd3$var$ReachabilityIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.4",
                y: "2.8",
                width: "9.2",
                height: "14.4",
                rx: "1.9",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.1 5.8h3.8M7.4 14.1l5.2-5.2",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
const $845661e1cd923dd3$var$ReturnRateIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.2 7.2a5.8 5.8 0 1 0 .4 6.8",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m14 4.7 2.3 2.5-2.5 2.3",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const $845661e1cd923dd3$var$ResultIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.2 4.8h7.6v1.3a3.8 3.8 0 0 1-7.6 0V4.8Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.2 10.2h3.6M10 10.2v2.6M7.6 15h4.8",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.2 5.6H4.6A1.8 1.8 0 0 0 2.8 7.4v.2a2.6 2.6 0 0 0 2.6 2.6h.5M13.8 5.6h1.6a1.8 1.8 0 0 1 1.8 1.8v.2a2.6 2.6 0 0 1-2.6 2.6h-.5",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const $845661e1cd923dd3$var$ResultOutcomeIcon = ({ rejected: rejected })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: rejected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 7 17 17M17 7 7 17",
            stroke: "currentColor",
            strokeWidth: "2.2",
            strokeLinecap: "round"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m5 12 4.2 4.2L19 6.6",
            stroke: "currentColor",
            strokeWidth: "2.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const $845661e1cd923dd3$var$QuorumOutcomeIcon = ({ fulfilled: fulfilled })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: fulfilled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M7.2 10.2h-2a1.4 1.4 0 0 0-1.4 1.4v6.5a1.4 1.4 0 0 0 1.4 1.4h2V10.2Z",
                    stroke: "currentColor",
                    strokeWidth: "1.9",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M7.2 10.2l4.1-6.1c.8-1.2 2.7-.6 2.7.9v3.1h4.4a2 2 0 0 1 1.9 2.5l-1.5 6.7a2.8 2.8 0 0 1-2.7 2.2H7.2",
                    stroke: "currentColor",
                    strokeWidth: "1.9",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M7.2 13.8h-2a1.4 1.4 0 0 1-1.4-1.4V5.9a1.4 1.4 0 0 1 1.4-1.4h2v9.3Z",
                    stroke: "currentColor",
                    strokeWidth: "1.9",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M7.2 13.8l4.1 6.1c.8 1.2 2.7.6 2.7-.9v-3.1h4.4a2 2 0 0 0 1.9-2.5l-1.5-6.7a2.8 2.8 0 0 0-2.7-2.2H7.2",
                    stroke: "currentColor",
                    strokeWidth: "1.9",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
const $845661e1cd923dd3$var$ResolutionDetailTableIcon = ({ name: name })=>{
    if (name === "search") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "5.8",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m13.2 13.2 4 4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "owner") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "7.4",
                r: "2.5",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.2 15.9a4.8 4.8 0 0 1 9.6 0",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "ownerName") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$OwnerNameIcon, {});
    if (name === "reachability") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ReachabilityIcon, {});
    if (name === "vote") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResultIcon, {});
    if (name === "date") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4.2",
                y: "5.1",
                width: "11.6",
                height: "10.7",
                rx: "1.8",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.2 3.8v3M12.8 3.8v3M4.8 8.4h10.4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "comment") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.5 5.1h11v7.1a1.7 1.7 0 0 1-1.7 1.7H8.5l-3.2 2.4v-2.4h-.8a1.7 1.7 0 0 1-1.7-1.7V6.8a1.7 1.7 0 0 1 1.7-1.7Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.4 8.2h7.1M6.4 11h4.8",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "action") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "4.8",
                r: "1.3",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "1.3",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "15.2",
                r: "1.3",
                fill: "currentColor"
            })
        ]
    });
    if (name === "select") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4.1",
                y: "4.1",
                width: "11.8",
                height: "11.8",
                rx: "2.1",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m7.2 10.1 2 2 3.9-4.2",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (name === "size") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.5 14.5h11M5.2 11.2h9.6M6 7.9h8M6.8 4.6h6.4",
            stroke: "currentColor",
            strokeWidth: "1.7",
            strokeLinecap: "round"
        })
    });
    if (name === "type") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.1 4.2h9.8v11.6H5.1z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.4 7.3h5.2M7.4 10h5.2M7.4 12.7h3.4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "mail") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "3.8",
                y: "5.2",
                width: "12.4",
                height: "9.6",
                rx: "1.6",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m4.5 6 5.5 4.1L15.5 6",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (name === "key") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "7.2",
                cy: "10.1",
                r: "3.1",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.1 10.1h6M14 10.1v2M16 10.1v2",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "link") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.3 11.7a3.1 3.1 0 0 0 4.4 0l2.2-2.2a3.1 3.1 0 0 0-4.4-4.4L9.2 6.4",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.7 8.3a3.1 3.1 0 0 0-4.4 0L5.1 10.5a3.1 3.1 0 0 0 4.4 4.4l1.3-1.3",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "status") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "5.9",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m10 7.2 1.8 2.5L10 12.8 8.2 9.7 10 7.2Z",
                fill: "currentColor"
            })
        ]
    });
    if (name === "unit") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.1",
                y: "4.1",
                width: "9.8",
                height: "11.8",
                rx: "1.8",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.4 7.5h2M10.8 7.5h2M7.4 10.5h2M10.8 10.5h2M8.1 15.9v-2.2h3.8v2.2",
                stroke: "currentColor",
                strokeWidth: "1.6",
                strokeLinecap: "round"
            })
        ]
    });
    if (name === "home") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.4 8.7 10 4.4l5.6 4.3v6.8h-4.1v-3.8h-3v3.8H4.4V8.7Z",
            stroke: "currentColor",
            strokeWidth: "1.7",
            strokeLinejoin: "round"
        })
    });
    if (name === "pin") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 17s4.8-4.6 4.8-8.1a4.8 4.8 0 1 0-9.6 0C5.2 12.4 10 17 10 17Z",
                stroke: "currentColor",
                strokeWidth: "1.7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "8.9",
                r: "1.6",
                stroke: "currentColor",
                strokeWidth: "1.7"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.2 3.8h6.5l2.9 2.9v8.6a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 15.3V5a1.2 1.2 0 0 1 1.2-1.2Z",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.8 9.4h6.1M6.8 12.2h5",
                stroke: "currentColor",
                strokeWidth: "1.7",
                strokeLinecap: "round"
            })
        ]
    });
};
const $845661e1cd923dd3$var$ResolutionDetailTableHeader = ({ label: label, icon: icon, center: center = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `resolutions-v2-th-plain${center ? " resolution-detail-v2-th-center" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-icon",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableIcon, {
                    name: icon
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-th-label",
                children: label
            })
        ]
    });
const $845661e1cd923dd3$var$formatAuthMode = (value, authUserName)=>{
    const normalized = $845661e1cd923dd3$var$normalizeMojibake(value);
    const normalizedUserName = $845661e1cd923dd3$var$normalizeMojibake(authUserName);
    if (normalized === "admin_session") return normalizedUserName ? `Admin-Session (${normalizedUserName})` : "Admin-Session";
    if (normalized === "beschluss_link") return "Beschluss-Link";
    if (normalized === "beschluss_id_passwort") return "Beschluss-ID + Passwort";
    return normalized || "-";
};
const $845661e1cd923dd3$var$formatAuthUser = (name, id)=>{
    const normalizedName = $845661e1cd923dd3$var$normalizeMojibake(name).trim();
    const normalizedId = $845661e1cd923dd3$var$normalizeMojibake(id).trim();
    if (normalizedName && normalizedId) return `${normalizedName} (${normalizedId})`;
    if (normalizedName) return normalizedName;
    if (normalizedId) return normalizedId;
    return "-";
};
const $845661e1cd923dd3$var$formatShare = (value, total)=>{
    if (total <= 0) return "0,0";
    return (value / total * 100).toFixed(1).replace(".", ",");
};
const $845661e1cd923dd3$var$copyTextToClipboard = async (text)=>{
    try {
        if (globalThis.navigator?.clipboard?.writeText && globalThis.isSecureContext) {
            await globalThis.navigator.clipboard.writeText(text);
            return true;
        }
    } catch  {
    // fallback below
    }
    try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, ta.value.length);
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        return ok;
    } catch  {
        return false;
    }
};
const $845661e1cd923dd3$var$createCommandIdempotencyKey = (prefix)=>`${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
const $845661e1cd923dd3$var$formatDispatchType = (value)=>{
    if (value === "einladung_versendet") return "Einladung zur Abstimmung";
    if (value === "erinnerung_1_versendet") return "1. Erinnerung";
    if (value === "erinnerung_2_versendet") return "2. Erinnerung";
    if (value === "beschlussergebnis_versendet") return "Beschlussergebnis";
    return value;
};
const $845661e1cd923dd3$var$mergeDispatchLogRows = (existing, incoming)=>{
    const byId = new Map();
    for (const row of existing)byId.set(row.id, row);
    for (const row of incoming)byId.set(row.id, row);
    return [
        ...byId.values()
    ].sort((a, b)=>b.timestamp.localeCompare(a.timestamp));
};
const $845661e1cd923dd3$var$dispatchEventOrder = [
    "einladung_versendet",
    "erinnerung_1_versendet",
    "erinnerung_2_versendet",
    "beschlussergebnis_versendet"
];
const $845661e1cd923dd3$var$formatDispatchUiStatus = (status)=>{
    if (status === "versendet") return "Versendet";
    if (status === "fehlgeschlagen") return "Fehlgeschlagen";
    if (status === "uebersprungen") return "\xdcbersprungen";
    if (status === "vorgemerkt") return "Vorgemerkt";
    if (status === "abgestimmt") return "Abgestimmt";
    return "Ausstehend";
};
const $845661e1cd923dd3$var$getDispatchUiStatusBadgeClass = (status)=>{
    if (status === "versendet") return "aktiv";
    if (status === "ausstehend" || status === "fehlgeschlagen") return "inaktiv";
    return "keine_zuordnung";
};
const $845661e1cd923dd3$var$isPreviewableDocument = (doc)=>{
    const mime = (doc.mimeType ?? "").toLowerCase();
    return mime === "application/pdf" || mime.startsWith("image/");
};
const $845661e1cd923dd3$var$buildVoteLogCsv = (rows, resolveOwnerName)=>{
    const header = [
        "Zeitpunkt",
        "Ereignis",
        "IP",
        "Kanal",
        "Authentifizierung",
        "Authentifiziert durch",
        "Eigent\xfcmer",
        "Stimme",
        "Ge\xe4ndert"
    ];
    const body = rows.map((log)=>{
        const changed = Array.isArray(log.changed_assignments) ? log.changed_assignments : [];
        const changedLabel = changed.length ? changed.map((c)=>`${c.previousVoteValue ?? "offen"} -> ${c.nextVoteValue ?? "offen"}`).join(", ") : "-";
        return [
            log.timestamp ? $845661e1cd923dd3$var$formatDateTimeDE(log.timestamp) : "-",
            $845661e1cd923dd3$var$formatVoteEventType(log.vote_event_type),
            $845661e1cd923dd3$var$normalizeMojibake(String(log.client_ip ?? "-")),
            $845661e1cd923dd3$var$formatSubmissionChannel(log.submission_channel),
            $845661e1cd923dd3$var$formatAuthMode(log.auth_mode, log.auth_user_name ?? log.actor_name),
            $845661e1cd923dd3$var$formatAuthUser(log.auth_user_name, log.auth_user_id),
            resolveOwnerName(log.owner_id),
            log.vote_value ? $845661e1cd923dd3$var$formatVoteValue(log.vote_value) : "-",
            $845661e1cd923dd3$var$normalizeMojibake(changedLabel)
        ];
    });
    const escapeCsv = (value)=>`"${value.replace(/"/g, '""')}"`;
    return [
        header,
        ...body
    ].map((row)=>row.map((cell)=>escapeCsv(String(cell))).join(";")).join("\n");
};
const $845661e1cd923dd3$var$outcomeBadge = (status, quorumErfuellt)=>{
    if (status !== "abgeschlossen") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge ergebnis-neutral",
        children: "-"
    });
    if (quorumErfuellt) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge ergebnis-angenommen",
        children: "Angenommen"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge ergebnis-abgelehnt",
        children: "Abgelehnt"
    });
};
const $845661e1cd923dd3$var$VoteDonutChart = ({ ja: ja, nein: nein, enthaltung: enthaltung })=>{
    const bewerteteSumme = Math.max(ja + nein, 0);
    const gesamtMitEnthaltung = Math.max(ja + nein + enthaltung, 0);
    const jaPct = bewerteteSumme > 0 ? ja / bewerteteSumme * 100 : 0;
    const neinPct = bewerteteSumme > 0 ? nein / bewerteteSumme * 100 : 0;
    const yesColor = "color-mix(in srgb, color-mix(in srgb, #eefaf3 90%, #1f8a51 10%) 95%, transparent 5%)";
    const noColor = "color-mix(in srgb, color-mix(in srgb, #fff7f7 90%, #d34848 10%) 95%, transparent 5%)";
    const abstainColor = "color-mix(in srgb, color-mix(in srgb, #fff8df 86%, #d99a00 14%) 95%, transparent 5%)";
    const jaSegment = gesamtMitEnthaltung > 0 ? ja / gesamtMitEnthaltung * 100 : 0;
    const neinSegment = gesamtMitEnthaltung > 0 ? nein / gesamtMitEnthaltung * 100 : 0;
    const p1 = jaSegment;
    const p2 = jaSegment + neinSegment;
    const gradient = gesamtMitEnthaltung > 0 ? `conic-gradient(${yesColor} 0% ${p1}%, ${noColor} ${p1}% ${p2}%, ${abstainColor} ${p2}% 100%)` : "conic-gradient(#e5e9ee 0% 100%)";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: "flex",
            gap: 14,
            alignItems: "center",
            flexWrap: "wrap"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "result-vote-donut-v2",
                "aria-label": "Stimmen Kreisdiagramm",
                title: "Stimmenverteilung",
                style: {
                    width: 170,
                    height: 170,
                    borderRadius: "50%",
                    background: gradient,
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "result-vote-donut-inner-v2",
                    style: {
                        position: "absolute",
                        inset: 42,
                        borderRadius: "50%",
                        background: "var(--surface)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        color: "var(--text-soft)",
                        textAlign: "center",
                        padding: 6,
                        whiteSpace: "pre-line"
                    },
                    children: gesamtMitEnthaltung > 0 ? `${gesamtMitEnthaltung}` + "\nStimmen" : "Keine\nStimmen"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "grid",
                    gap: 6,
                    minWidth: 190
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "120px auto",
                            alignItems: "center",
                            columnGap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            background: yesColor
                                        }
                                    }),
                                    "Ja"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    ja.toFixed(2),
                                    " (",
                                    jaPct.toFixed(1),
                                    " %)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "120px auto",
                            alignItems: "center",
                            columnGap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            background: noColor
                                        }
                                    }),
                                    "Nein"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    nein.toFixed(2),
                                    " (",
                                    neinPct.toFixed(1),
                                    " %)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "120px auto",
                            alignItems: "center",
                            columnGap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            background: abstainColor
                                        }
                                    }),
                                    "Enthaltung"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    enthaltung.toFixed(2),
                                    " (ohne Bewertung)"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $845661e1cd923dd3$var$getReachabilityBadge = (erreichbarkeit, temporaryAnalog)=>{
    if (temporaryAnalog) return {
        label: "tempor\xe4r analog",
        className: "erreichbar-temp-analog"
    };
    if (erreichbarkeit === "analog") return {
        label: "analog",
        className: "erreichbar-analog"
    };
    return {
        label: "digital",
        className: "erreichbar-digital"
    };
};
const $845661e1cd923dd3$export$e24676f9cd8ae6eb = ({ canManageMasterDataActions: canManageMasterDataActions = false })=>{
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const qc = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [tab, setTab] = (0, $acw62.useState)("stammdaten");
    const [searchEmpfaenger, setSearchEmpfaenger] = (0, $acw62.useState)("");
    const [searchStimmen, setSearchStimmen] = (0, $acw62.useState)("");
    const [filterStimmenErreichbarkeit, setFilterStimmenErreichbarkeit] = (0, $acw62.useState)("alle");
    const [filterStimmenverhalten, setFilterStimmenverhalten] = (0, $acw62.useState)("alle");
    const [searchVersand, setSearchVersand] = (0, $acw62.useState)("");
    const [searchErgebnis, setSearchErgebnis] = (0, $acw62.useState)("");
    const [searchZugangsdaten, setSearchZugangsdaten] = (0, $acw62.useState)("");
    const [searchDokumente, setSearchDokumente] = (0, $acw62.useState)("");
    const [searchFaciliooDokumente, setSearchFaciliooDokumente] = (0, $acw62.useState)("");
    const [isResultVotesModalOpen, setIsResultVotesModalOpen] = (0, $acw62.useState)(false);
    const [resultVotesRowCount, setResultVotesRowCount] = (0, $acw62.useState)(25);
    const [empfaengerPage, setEmpfaengerPage] = (0, $acw62.useState)(1);
    const [stimmenPage, setStimmenPage] = (0, $acw62.useState)(1);
    const [actionError, setActionError] = (0, $acw62.useState)("");
    const [draftVotes, setDraftVotes] = (0, $acw62.useState)({});
    const [draftComments, setDraftComments] = (0, $acw62.useState)({});
    const [voteChangeConfirm, setVoteChangeConfirm] = (0, $acw62.useState)(null);
    const [startConfirm, setStartConfirm] = (0, $acw62.useState)(null);
    const [stopConfirm, setStopConfirm] = (0, $acw62.useState)(null);
    const [documentDeleteConfirm, setDocumentDeleteConfirm] = (0, $acw62.useState)(null);
    const [isVoteLogModalOpen, setIsVoteLogModalOpen] = (0, $acw62.useState)(false);
    const [voteOpenActionMenuId, setVoteOpenActionMenuId] = (0, $acw62.useState)(null);
    const [isVoteActionMenuHovered, setIsVoteActionMenuHovered] = (0, $acw62.useState)(false);
    const [documentOpenActionMenuId, setDocumentOpenActionMenuId] = (0, $acw62.useState)(null);
    const [isDocumentActionMenuHovered, setIsDocumentActionMenuHovered] = (0, $acw62.useState)(false);
    const [faciliooOpenActionMenuId, setFaciliooOpenActionMenuId] = (0, $acw62.useState)(null);
    const [isFaciliooActionMenuHovered, setIsFaciliooActionMenuHovered] = (0, $acw62.useState)(false);
    const [actionMenuPosition, setActionMenuPosition] = (0, $acw62.useState)(null);
    const [copiedDirectLinkId, setCopiedDirectLinkId] = (0, $acw62.useState)(null);
    const [ownerEinzelstimmabgabeSichtbar, setOwnerEinzelstimmabgabeSichtbar] = (0, $acw62.useState)(false);
    const [documentFiles, setDocumentFiles] = (0, $acw62.useState)([]);
    const [documentError, setDocumentError] = (0, $acw62.useState)("");
    const [documentInfo, setDocumentInfo] = (0, $acw62.useState)("");
    const [selectedDocumentIds, setSelectedDocumentIds] = (0, $acw62.useState)([]);
    const [faciliooDocumentError, setFaciliooDocumentError] = (0, $acw62.useState)("");
    const [showFileTypesDebug, setShowFileTypesDebug] = (0, $acw62.useState)(false);
    const [selectedFaciliooAttachmentKeys, setSelectedFaciliooAttachmentKeys] = (0, $acw62.useState)([]);
    const [previewDocument, setPreviewDocument] = (0, $acw62.useState)(null);
    const [previewFaciliooDocument, setPreviewFaciliooDocument] = (0, $acw62.useState)(null);
    const [documentDropActive, setDocumentDropActive] = (0, $acw62.useState)(false);
    const documentInputRef = (0, $acw62.useRef)(null);
    const READ_STALE_TIME_MS = 20000;
    const LOG_STALE_TIME_MS = 10000;
    const resolutionQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionById(id),
        enabled: !!id,
        staleTime: READ_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const resolution = resolutionQuery.data;
    const quorumKpiHinweis = (0, $acw62.useMemo)(()=>{
        if (!resolution) return "";
        if (resolution.quorum === "allstimmig") return "";
        if (!resolution.vorbeschluss_top || !resolution.vorbeschluss_wev_datum) return "";
        return `Abweichendes Quorum gegen\xfcber Allstimmigkeit auf Basis des Vorbeschlusses unter TOP ${resolution.vorbeschluss_top} der WEV vom ${$845661e1cd923dd3$var$formatDateDE(resolution.vorbeschluss_wev_datum)}.`;
    }, [
        resolution
    ]);
    (0, $acw62.useEffect)(()=>{
        setOwnerEinzelstimmabgabeSichtbar(Boolean(resolution?.owner_einzelstimmabgabe_sichtbar));
    }, [
        resolution?.owner_einzelstimmabgabe_sichtbar
    ]);
    const resultQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-result",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionResult(id),
        enabled: !!id && (tab === "stimmen" || tab === "ergebnis"),
        staleTime: READ_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const kpiQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-kpis",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionKpis(id),
        enabled: !!id && (tab === "stammdaten" || tab === "stimmen" || tab === "ergebnis"),
        staleTime: READ_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const expectedResolutionUpdatedAt = kpiQuery.data?.updatedAt ?? resolution?.updatedAt;
    const resultKpiTitle = (0, $acw62.useMemo)(()=>{
        if (resolution?.status === "abgeschlossen") return "Endergebnis";
        if (resultQuery.data?.break_even?.isLocked || kpiQuery.data?.break_even?.isLocked) return "Vorl\xe4ufiges Endergebnis";
        return "Laufende Stimmauswertung";
    }, [
        kpiQuery.data?.break_even?.isLocked,
        resolution?.status,
        resultQuery.data?.break_even?.isLocked
    ]);
    const resultKpiValue = (0, $acw62.useMemo)(()=>{
        const raw = resultQuery.data?.ergebnis ?? kpiQuery.data?.ergebnis ?? "-";
        if ((resolution?.status === "abgeschlossen" || resultQuery.data?.break_even?.isLocked || kpiQuery.data?.break_even?.isLocked) && /^vorläufig\s+/i.test(raw)) return raw.replace(/^vorläufig\s+/i, "");
        return raw;
    }, [
        kpiQuery.data?.break_even?.isLocked,
        kpiQuery.data?.ergebnis,
        resolution?.status,
        resultQuery.data?.break_even?.isLocked,
        resultQuery.data?.ergebnis
    ]);
    const showResultBreakEvenNote = resolution?.status === "aktiv" && Boolean(resultQuery.data?.break_even?.isLocked || kpiQuery.data?.break_even?.isLocked);
    const resultKpiValueText = String(resultKpiValue ?? "").toLowerCase();
    const resultKpiTone = resultKpiValueText.includes("angenommen") ? "ok" : resultKpiValueText.includes("abgelehnt") ? "fail" : "neutral";
    const resultQuorumFulfilled = Boolean(kpiQuery.data?.quorumErfuellt ?? resultQuery.data?.quorumErfuellt);
    const resultReturnSubmitted = Number.isFinite(Number(resultQuery.data?.stimmen.abgegeben)) ? Number(resultQuery.data?.stimmen.abgegeben ?? 0) : 0;
    const resultReturnOpen = Number.isFinite(Number(resultQuery.data?.stimmen.offen)) ? Number(resultQuery.data?.stimmen.offen ?? 0) : 0;
    const resultReturnTotal = Number.isFinite(Number(resultQuery.data?.stimmen.gesamt)) ? Number(resultQuery.data?.stimmen.gesamt ?? 0) : Math.max(resultReturnSubmitted + resultReturnOpen, 0);
    const resultReturnSubmittedPct = resultReturnTotal > 0 ? resultReturnSubmitted / resultReturnTotal * 100 : 0;
    const resultReturnOpenPct = resultReturnTotal > 0 ? resultReturnOpen / resultReturnTotal * 100 : 0;
    const resultReturnBarStyle = {
        "--result-return-submitted": `${Math.max(0, Math.min(100, resultReturnSubmittedPct))}%`,
        "--result-return-open": `${Math.max(0, Math.min(100, resultReturnOpenPct))}%`
    };
    const voteLogQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-vote-log",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionVoteLog(id),
        enabled: !!id && tab === "stimmen",
        staleTime: LOG_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const needsRecipientDataset = tab === "empfaenger" || tab === "stimmen" || tab === "versand" || tab === "ergebnis";
    const dispatchLogQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-dispatch-log",
            id
        ],
        queryFn: async ()=>{
            const queryKey = [
                "resolution-dispatch-log",
                id
            ];
            const previous = qc.getQueryData(queryKey);
            const cursor = previous?.data?.[0]?.timestamp;
            const response = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionDispatchLog(id, cursor ? {
                cursor: cursor
            } : undefined);
            if (!cursor) return response;
            return {
                ...response,
                data: $845661e1cd923dd3$var$mergeDispatchLogRows(previous?.data ?? [], response.data ?? [])
            };
        },
        enabled: !!id && tab === "versand",
        staleTime: LOG_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const triggerNotificationLogQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-trigger-notifications-log",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionTriggerNotificationsLog(id),
        enabled: !!id && tab === "versand",
        staleTime: LOG_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const generatedDispatchQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "generated-dispatch",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).generatedDispatchDocuments(id),
        enabled: !!id && needsRecipientDataset,
        staleTime: LOG_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const recipientQueryParams = (0, $acw62.useMemo)(()=>{
        if (tab === "empfaenger") return {
            page: empfaengerPage,
            pageSize: $845661e1cd923dd3$var$RECIPIENT_PAGE_SIZE,
            search: searchEmpfaenger.trim() || undefined
        };
        if (tab === "stimmen") return {
            page: stimmenPage,
            pageSize: $845661e1cd923dd3$var$RECIPIENT_PAGE_SIZE,
            search: searchStimmen.trim() || undefined,
            erreichbarkeit: filterStimmenErreichbarkeit === "alle" ? undefined : filterStimmenErreichbarkeit,
            voteValue: filterStimmenverhalten === "alle" ? undefined : filterStimmenverhalten
        };
        return {
            page: 1,
            pageSize: $845661e1cd923dd3$var$RECIPIENT_BULK_PAGE_SIZE
        };
    }, [
        empfaengerPage,
        filterStimmenErreichbarkeit,
        filterStimmenverhalten,
        searchEmpfaenger,
        searchStimmen,
        stimmenPage,
        tab
    ]);
    const recipientsQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-recipients",
            id,
            tab,
            recipientQueryParams.page,
            recipientQueryParams.pageSize,
            recipientQueryParams.search ?? "",
            recipientQueryParams.erreichbarkeit ?? "",
            recipientQueryParams.voteValue ?? ""
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionRecipients(id, recipientQueryParams),
        enabled: !!id && needsRecipientDataset,
        staleTime: READ_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const documentsQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-documents",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionDocuments(id),
        enabled: !!id && (tab === "dokumente" || tab === "facilioo_dokumente"),
        staleTime: READ_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const faciliooAttachmentsQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-facilioo-attachments",
            id,
            resolution?.facilioo_vorgangsnummer
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionFaciliooAttachments(id),
        enabled: !!id && !!resolution?.facilioo_vorgangsnummer && tab === "facilioo_dokumente",
        staleTime: READ_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const faciliooFileTypesDebugQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-facilioo-file-types-debug",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionFaciliooFileTypesDebug(id),
        enabled: !!id && showFileTypesDebug
    });
    const ownerAccessesQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "resolution-owner-accesses",
            id
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutionOwnerAccesses(id),
        enabled: !!id && tab === "empfaenger",
        staleTime: READ_STALE_TIME_MS,
        placeholderData: (previousData)=>previousData,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const startMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (payload)=>{
            const expectedUpdatedAt = expectedResolutionUpdatedAt;
            let effectiveUpdatedAt = expectedUpdatedAt;
            if (payload.endedatum) {
                const updated = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateResolution(payload.resolutionId, {
                    endedatum: payload.endedatum
                });
                effectiveUpdatedAt = updated.updatedAt;
            }
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).startResolution(payload.resolutionId, {
                expectedUpdatedAt: effectiveUpdatedAt,
                idempotency_key: $845661e1cd923dd3$var$createCommandIdempotencyKey("start")
            });
        },
        onSuccess: async (updatedResolution)=>{
            setStartConfirm(null);
            setActionError("");
            const resolutionId = id;
            qc.setQueryData([
                "resolution",
                resolutionId
            ], updatedResolution);
            await Promise.all([
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-result",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-kpis",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-dispatch-log",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-trigger-notifications-log",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "generated-dispatch",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-owner-accesses",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolutions"
                    ]
                })
            ]);
            // Versanddaten entstehen teils asynchron nach dem Start.
            // Kurzer Burst-Refresh sorgt für sofort sichtbare Änderungen im Versandprozess.
            if (tab === "versand") {
                const delayedRefetch = (delayMs)=>globalThis.setTimeout(()=>{
                        Promise.all([
                            qc.refetchQueries({
                                queryKey: [
                                    "resolution",
                                    resolutionId
                                ],
                                type: "active"
                            }),
                            qc.refetchQueries({
                                queryKey: [
                                    "resolution-result",
                                    resolutionId
                                ],
                                type: "active"
                            }),
                            qc.refetchQueries({
                                queryKey: [
                                    "resolution-kpis",
                                    resolutionId
                                ],
                                type: "active"
                            }),
                            qc.refetchQueries({
                                queryKey: [
                                    "resolution-dispatch-log",
                                    resolutionId
                                ],
                                type: "active"
                            }),
                            qc.refetchQueries({
                                queryKey: [
                                    "resolution-trigger-notifications-log",
                                    resolutionId
                                ],
                                type: "active"
                            }),
                            qc.refetchQueries({
                                queryKey: [
                                    "generated-dispatch",
                                    resolutionId
                                ],
                                type: "active"
                            })
                        ]);
                    }, delayMs);
                delayedRefetch(2000);
                delayedRefetch(6000);
            }
        },
        onError: (e)=>setActionError(e instanceof Error ? e.message : "Beschluss konnte nicht gestartet werden")
    });
    const stopMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (resolutionId)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).stopResolution(resolutionId, {
                expectedUpdatedAt: expectedResolutionUpdatedAt,
                idempotency_key: $845661e1cd923dd3$var$createCommandIdempotencyKey("stop")
            }),
        onSuccess: async (updatedResolution)=>{
            setStopConfirm(null);
            setActionError("");
            const resolutionId = id;
            qc.setQueryData([
                "resolution",
                resolutionId
            ], updatedResolution);
            await Promise.all([
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-result",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-kpis",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-dispatch-log",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-trigger-notifications-log",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "generated-dispatch",
                        resolutionId
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolutions"
                    ]
                })
            ]);
        },
        onError: (e)=>setActionError(e instanceof Error ? e.message : "Beschluss konnte nicht gestoppt werden")
    });
    const ownerResultVisibilityMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (visible)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateResolution(id, {
                owner_einzelstimmabgabe_sichtbar: visible
            }),
        onSuccess: async (updatedResolution)=>{
            setActionError("");
            qc.setQueryData([
                "resolution",
                id
            ], updatedResolution);
            await Promise.all([
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-result",
                        id
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-kpis",
                        id
                    ]
                })
            ]);
        },
        onError: (e)=>setActionError(e instanceof Error ? e.message : "Einstellung konnte nicht gespeichert werden")
    });
    const documentUploadMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (!id) throw new Error("Ung\xfcltige Beschluss-ID");
            if (!documentFiles.length) throw new Error("Bitte mindestens eine Datei ausw\xe4hlen.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).uploadResolutionDocuments(id, documentFiles);
        },
        onSuccess: async ()=>{
            setDocumentError("");
            setDocumentInfo("");
            setDocumentFiles([]);
            await qc.invalidateQueries({
                queryKey: [
                    "resolution-documents",
                    id
                ]
            });
        },
        onError: (e)=>setDocumentError(e instanceof Error ? e.message : "Dokumente konnten nicht hochgeladen werden")
    });
    const mergeDocumentFiles = (incoming, replace = false)=>{
        setDocumentFiles((prev)=>{
            const base = replace ? [] : prev;
            const deduped = new Map();
            for (const file of base)deduped.set(`${file.name}__${file.size}__${file.lastModified}`, file);
            for (const file of incoming)deduped.set(`${file.name}__${file.size}__${file.lastModified}`, file);
            return Array.from(deduped.values());
        });
    };
    const onDocumentDrop = (event)=>{
        event.preventDefault();
        setDocumentDropActive(false);
        mergeDocumentFiles(Array.from(event.dataTransfer.files ?? []), false);
    };
    const documentDeleteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (documentId)=>{
            if (!id) throw new Error("Ung\xfcltige Beschluss-ID");
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).deleteResolutionDocument(id, documentId);
        },
        onSuccess: async ()=>{
            setDocumentError("");
            setDocumentInfo("");
            await qc.invalidateQueries({
                queryKey: [
                    "resolution-documents",
                    id
                ]
            });
        },
        onError: (e)=>setDocumentError(e instanceof Error ? e.message : "Dokument konnte nicht gel\xf6scht werden")
    });
    const uploadDocumentsToFaciliooMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (!id) throw new Error("Ung\xfcltige Beschluss-ID");
            const fallbackAllIds = documentRows.map((doc)=>doc.id).filter(Boolean);
            const documentIds = selectedDocumentIds.length ? selectedDocumentIds : fallbackAllIds;
            if (!documentIds.length) throw new Error("Es sind keine Dokumente in der Liste vorhanden.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).uploadResolutionDocumentsToFacilioo(id, documentIds);
        },
        onSuccess: async (result)=>{
            setDocumentError("");
            setDocumentInfo(`Zu Facilioo \xfcbertragen: ${result.uploadedCount}. \xdcbersprungen: ${result.skippedCount}.`);
            setSelectedDocumentIds([]);
            await Promise.all([
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-documents",
                        id
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-facilioo-attachments",
                        id
                    ]
                })
            ]);
        },
        onError: (e)=>{
            setDocumentInfo("");
            setDocumentError(e instanceof Error ? e.message : "Dokumente konnten nicht zu Facilioo \xfcbertragen werden.");
        }
    });
    const importFaciliooAttachmentsMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (mode = "selected")=>{
            if (!id) throw new Error("Ung\xfcltige Beschluss-ID");
            const rows = faciliooAttachmentsQuery.data?.data ?? [];
            const selectedRows = mode === "all" ? rows : rows.filter((row)=>selectedFaciliooAttachmentKeys.includes(`${row.feedId}:${row.attachmentId}`));
            if (!selectedRows.length) throw new Error(mode === "all" ? "Keine Facilioo-Dokumente zum Neu-Laden verf\xfcgbar." : "Bitte mindestens ein Facilioo-Dokument ausw\xe4hlen.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).importResolutionFaciliooAttachments(id, selectedRows.map((row)=>({
                    feedId: row.feedId,
                    attachmentId: row.attachmentId,
                    originalFilename: $845661e1cd923dd3$var$resolveAttachmentFilename(row)
                })));
        },
        onSuccess: async ()=>{
            setFaciliooDocumentError("");
            setSelectedFaciliooAttachmentKeys([]);
            await Promise.all([
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-documents",
                        id
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-facilioo-attachments",
                        id
                    ]
                })
            ]);
        },
        onError: (e)=>setFaciliooDocumentError(e instanceof Error ? e.message : "Facilioo-Dokumente konnten nicht importiert werden")
    });
    const previewFaciliooAttachmentMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (row)=>{
            if (!id) throw new Error("Ung\xfcltige Beschluss-ID");
            const resolvedName = $845661e1cd923dd3$var$resolveAttachmentFilename(row);
            const blob = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).fetchResolutionFaciliooAttachmentBlob(id, row.feedId, row.attachmentId, {
                fileName: resolvedName,
                fileExtension: row.fileExtension ?? undefined,
                mimeType: row.mimeType ?? undefined,
                download: false
            });
            return {
                name: resolvedName,
                url: URL.createObjectURL(blob),
                previewable: $845661e1cd923dd3$var$isPreviewableFaciliooAttachment(row)
            };
        },
        onSuccess: (payload)=>{
            setFaciliooDocumentError("");
            setPreviewFaciliooDocument((prev)=>{
                if (prev?.url) URL.revokeObjectURL(prev.url);
                return payload;
            });
        },
        onError: (e)=>setFaciliooDocumentError(e instanceof Error ? e.message : "Vorschau konnte nicht geladen werden")
    });
    const voteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (payload)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).upsertResolutionVote(id, {
                ...payload,
                expectedUpdatedAt: expectedResolutionUpdatedAt
            }),
        onMutate: async (payload)=>{
            if (!id) return {};
            await qc.cancelQueries({
                queryKey: [
                    "resolution-recipients",
                    id
                ]
            });
            const previousRecipientQueries = qc.getQueriesData({
                queryKey: [
                    "resolution-recipients",
                    id
                ]
            });
            const now = new Date().toISOString();
            for (const [queryKey, previousRecipients] of previousRecipientQueries){
                if (!previousRecipients) continue;
                const ownerId = previousRecipients.data.find((row)=>row.assignmentId === payload.assignmentId)?.eigentuemerId;
                if (ownerId) {
                    const nextData = previousRecipients.data.map((row)=>row.eigentuemerId === ownerId ? {
                            ...row,
                            voteValue: payload.voteValue,
                            comment: payload.comment,
                            voteReceivedAt: now
                        } : row);
                    qc.setQueryData(queryKey, {
                        ...previousRecipients,
                        data: nextData
                    });
                }
            }
            return {
                previousRecipientQueries: previousRecipientQueries
            };
        },
        onSuccess: async ()=>{
            setActionError("");
            setVoteChangeConfirm(null);
            await Promise.all([
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-recipients",
                        id
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution",
                        id
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-result",
                        id
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-kpis",
                        id
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolution-vote-log",
                        id
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        "resolutions"
                    ]
                })
            ]);
        },
        onError: (e, _payload, context)=>{
            if (id && context?.previousRecipientQueries) for (const [queryKey, previousRecipients] of context.previousRecipientQueries)qc.setQueryData(queryKey, previousRecipients);
            setActionError(e instanceof Error ? e.message : "Stimme konnte nicht gespeichert werden");
        }
    });
    const generatedDispatchRows = generatedDispatchQuery.data?.data ?? [];
    const temporaryAnalogOwnerIds = (0, $acw62.useMemo)(()=>{
        const currentEmailByOwnerId = new Map();
        for (const row of recipientsQuery.data?.data ?? []){
            const ownerId = String(row.eigentuemerId ?? "").trim();
            const email = String(row.email ?? "").trim();
            if (ownerId && $845661e1cd923dd3$var$isValidEmailLike(email)) currentEmailByOwnerId.set(ownerId, email);
        }
        const set = new Set();
        for (const row of generatedDispatchRows){
            const ownerId = String(row.ownerId ?? "").trim();
            const eigentuemerId = String(row.eigentuemerId ?? "").trim();
            if (!ownerId && !eigentuemerId) continue;
            if (row.kanal !== "digital") continue;
            if (row.templateKey === "ballot_analog") continue;
            const currentEmail = currentEmailByOwnerId.get(eigentuemerId);
            const currentEmailNormalized = $845661e1cd923dd3$var$normalizeEmail(currentEmail);
            const rowMailTo = String(row.digitalMailTo ?? "").trim();
            const rowMailToNormalized = $845661e1cd923dd3$var$normalizeEmail(rowMailTo);
            const failureAppliesToStaleEmail = $845661e1cd923dd3$var$isValidEmailLike(currentEmail) && $845661e1cd923dd3$var$isValidEmailLike(rowMailTo) && $845661e1cd923dd3$var$normalizeEmail(currentEmail) !== rowMailToNormalized;
            if (failureAppliesToStaleEmail) continue;
            const hasSuccessfulCurrentEmailDeliveryProof = Boolean(currentEmailNormalized) && generatedDispatchRows.some((candidate)=>$845661e1cd923dd3$var$isGeneratedDispatchRowForOwner(candidate, eigentuemerId) && candidate.kanal === "digital" && candidate.templateKey !== "ballot_analog" && candidate.digitalMailStatus === "sent" && $845661e1cd923dd3$var$normalizeEmail(candidate.digitalMailTo) === currentEmailNormalized);
            const permanentByCode = /^5\./.test(String(row.digitalMailNdrEnhancedStatusCode ?? "").trim()) || /^5\d{2}$/.test(String(row.digitalMailNdrSmtpStatusCode ?? "").trim());
            const exhaustedTemporary = row.digitalMailStatus === "failed" && !permanentByCode && row.digitalMailNdrFailureClass !== "permanent" && (row.digitalMailRetries ?? 0) >= $845661e1cd923dd3$var$DIGITAL_MAIL_MAX_ATTEMPTS;
            const rowActivityAt = $845661e1cd923dd3$var$getGeneratedDispatchRowActivityAt(row);
            const hasLaterSuccessfulDeliveryProof = Boolean(rowMailToNormalized) && generatedDispatchRows.some((candidate)=>{
                const sameOwner = $845661e1cd923dd3$var$isGeneratedDispatchRowForOwner(candidate, eigentuemerId) || $845661e1cd923dd3$var$isGeneratedDispatchRowForOwner(candidate, ownerId);
                if (!sameOwner) return false;
                if (candidate.id === row.id) return false;
                if (candidate.kanal !== "digital") return false;
                if (candidate.templateKey === "ballot_analog") return false;
                if (candidate.digitalMailStatus !== "sent") return false;
                if ($845661e1cd923dd3$var$normalizeEmail(candidate.digitalMailTo) !== rowMailToNormalized) return false;
                const candidateActivityAt = $845661e1cd923dd3$var$getGeneratedDispatchRowActivityAt(candidate);
                return !rowActivityAt || !candidateActivityAt || candidateActivityAt.localeCompare(rowActivityAt) >= 0;
            });
            if (!hasSuccessfulCurrentEmailDeliveryProof && !hasLaterSuccessfulDeliveryProof && (row.temporaryAnalogRequiredAt || row.temporaryAnalogConvertedAt || row.digitalMailNdrFailureClass === "permanent" || permanentByCode || exhaustedTemporary)) {
                if (ownerId) set.add(ownerId);
                if (eigentuemerId) set.add(eigentuemerId);
            }
        }
        return set;
    }, [
        generatedDispatchRows,
        recipientsQuery.data?.data
    ]);
    const restoredDigitalOwnerIds = (0, $acw62.useMemo)(()=>{
        const set = new Set();
        for (const recipient of recipientsQuery.data?.data ?? []){
            const eigentuemerId = String(recipient.eigentuemerId ?? "").trim();
            const email = String(recipient.email ?? "").trim();
            const normalizedEmail = $845661e1cd923dd3$var$normalizeEmail(email);
            if (!eigentuemerId || !$845661e1cd923dd3$var$isValidEmailLike(email)) continue;
            const hasSuccessfulCurrentEmailDeliveryProof = generatedDispatchRows.some((candidate)=>$845661e1cd923dd3$var$isGeneratedDispatchRowForOwner(candidate, eigentuemerId) && candidate.kanal === "digital" && candidate.templateKey !== "ballot_analog" && candidate.digitalMailStatus === "sent" && $845661e1cd923dd3$var$normalizeEmail(candidate.digitalMailTo) === normalizedEmail);
            if (hasSuccessfulCurrentEmailDeliveryProof) set.add(eigentuemerId);
        }
        return set;
    }, [
        generatedDispatchRows,
        recipientsQuery.data?.data
    ]);
    const recipientRows = (0, $acw62.useMemo)(()=>{
        const rows = recipientsQuery.data?.data ?? [];
        if (!rows.length) return [];
        return rows.map((row)=>{
            const isForcedAnalog = temporaryAnalogOwnerIds.has(row.eigentuemerId);
            const isRestoredDigital = restoredDigitalOwnerIds.has(row.eigentuemerId);
            return {
                ...row,
                erreichbarkeit: isForcedAnalog ? "analog" : isRestoredDigital ? "digital" : row.erreichbarkeit,
                temporaryAnalog: isForcedAnalog ? true : undefined
            };
        });
    }, [
        recipientsQuery.data?.data,
        restoredDigitalOwnerIds,
        temporaryAnalogOwnerIds
    ]);
    const filteredRecipientRowsEmpfaenger = (0, $acw62.useMemo)(()=>{
        if (tab === "empfaenger") return recipientRows;
        const needle = searchEmpfaenger.trim().toLowerCase();
        if (!needle) return recipientRows;
        return recipientRows.filter((r)=>[
                r.einheitsnummer,
                r.lage,
                r.eigentuemerId,
                r.eigentuemerName,
                r.email ?? "",
                r.erreichbarkeit
            ].join(" ").toLowerCase().includes(needle));
    }, [
        recipientRows,
        searchEmpfaenger,
        tab
    ]);
    const [recipientTableScrollTop, setRecipientTableScrollTop] = (0, $acw62.useState)(0);
    const recipientViewportHeight = 500;
    const recipientVisibleRange = (0, $acw62.useMemo)(()=>{
        const total = filteredRecipientRowsEmpfaenger.length;
        if (!total) return {
            start: 0,
            end: 0
        };
        const rawStart = Math.floor(recipientTableScrollTop / $845661e1cd923dd3$var$RECIPIENT_TABLE_ROW_HEIGHT);
        const start = Math.max(rawStart - $845661e1cd923dd3$var$RECIPIENT_TABLE_OVERSCAN, 0);
        const visibleCount = Math.ceil(recipientViewportHeight / $845661e1cd923dd3$var$RECIPIENT_TABLE_ROW_HEIGHT) + $845661e1cd923dd3$var$RECIPIENT_TABLE_OVERSCAN * 2;
        const end = Math.min(start + visibleCount, total);
        return {
            start: start,
            end: end
        };
    }, [
        filteredRecipientRowsEmpfaenger.length,
        recipientTableScrollTop
    ]);
    const visibleRecipientRowsEmpfaenger = (0, $acw62.useMemo)(()=>filteredRecipientRowsEmpfaenger.slice(recipientVisibleRange.start, recipientVisibleRange.end), [
        filteredRecipientRowsEmpfaenger,
        recipientVisibleRange.end,
        recipientVisibleRange.start
    ]);
    const recipientTopSpacerHeight = recipientVisibleRange.start * $845661e1cd923dd3$var$RECIPIENT_TABLE_ROW_HEIGHT;
    const recipientBottomSpacerHeight = Math.max((filteredRecipientRowsEmpfaenger.length - recipientVisibleRange.end) * $845661e1cd923dd3$var$RECIPIENT_TABLE_ROW_HEIGHT, 0);
    const filteredRecipientRowsStimmen = (0, $acw62.useMemo)(()=>{
        if (tab === "stimmen") return recipientRows;
        const needle = searchStimmen.trim().toLowerCase();
        return recipientRows.filter((r)=>{
            const matchesText = !needle || [
                r.einheitsnummer,
                r.lage,
                r.eigentuemerId,
                r.eigentuemerName,
                r.email ?? "",
                r.erreichbarkeit
            ].join(" ").toLowerCase().includes(needle);
            const matchesErreichbarkeit = filterStimmenErreichbarkeit === "alle" || r.erreichbarkeit === filterStimmenErreichbarkeit;
            const matchesStimmverhalten = filterStimmenverhalten === "alle" || r.voteValue === filterStimmenverhalten;
            return matchesText && matchesErreichbarkeit && matchesStimmverhalten;
        });
    }, [
        filterStimmenErreichbarkeit,
        filterStimmenverhalten,
        recipientRows,
        searchStimmen,
        tab
    ]);
    const [voteTableScrollTop, setVoteTableScrollTop] = (0, $acw62.useState)(0);
    const voteViewportHeight = 520;
    const voteVisibleRange = (0, $acw62.useMemo)(()=>{
        const total = filteredRecipientRowsStimmen.length;
        if (!total) return {
            start: 0,
            end: 0
        };
        const rawStart = Math.floor(voteTableScrollTop / $845661e1cd923dd3$var$VOTE_TABLE_ROW_HEIGHT);
        const start = Math.max(rawStart - $845661e1cd923dd3$var$VOTE_TABLE_OVERSCAN, 0);
        const visibleCount = Math.ceil(voteViewportHeight / $845661e1cd923dd3$var$VOTE_TABLE_ROW_HEIGHT) + $845661e1cd923dd3$var$VOTE_TABLE_OVERSCAN * 2;
        const end = Math.min(start + visibleCount, total);
        return {
            start: start,
            end: end
        };
    }, [
        filteredRecipientRowsStimmen.length,
        voteTableScrollTop
    ]);
    const visibleRecipientRowsStimmen = (0, $acw62.useMemo)(()=>filteredRecipientRowsStimmen.slice(voteVisibleRange.start, voteVisibleRange.end), [
        filteredRecipientRowsStimmen,
        voteVisibleRange.end,
        voteVisibleRange.start
    ]);
    const voteTopSpacerHeight = voteVisibleRange.start * $845661e1cd923dd3$var$VOTE_TABLE_ROW_HEIGHT;
    const voteBottomSpacerHeight = Math.max((filteredRecipientRowsStimmen.length - voteVisibleRange.end) * $845661e1cd923dd3$var$VOTE_TABLE_ROW_HEIGHT, 0);
    const recipientMetaTotal = recipientsQuery.data?.meta.total ?? recipientRows.length;
    const empfaengerTotalPages = Math.max(Math.ceil(recipientMetaTotal / $845661e1cd923dd3$var$RECIPIENT_PAGE_SIZE), 1);
    const stimmenTotalPages = Math.max(Math.ceil(recipientMetaTotal / $845661e1cd923dd3$var$RECIPIENT_PAGE_SIZE), 1);
    const filteredRecipientRowsErgebnis = (0, $acw62.useMemo)(()=>{
        const needle = searchErgebnis.trim().toLowerCase();
        if (!needle) return recipientRows;
        return recipientRows.filter((r)=>[
                r.einheitsnummer,
                r.lage,
                r.eigentuemerId,
                r.eigentuemerName,
                r.email ?? "",
                r.voteValue,
                r.comment ?? ""
            ].join(" ").toLowerCase().includes(needle));
    }, [
        recipientRows,
        searchErgebnis
    ]);
    const visibleRecipientRowsErgebnis = (0, $acw62.useMemo)(()=>{
        if (resultVotesRowCount === "all") return filteredRecipientRowsErgebnis;
        return filteredRecipientRowsErgebnis.slice(0, resultVotesRowCount);
    }, [
        filteredRecipientRowsErgebnis,
        resultVotesRowCount
    ]);
    const versandEmpfaengerRows = (0, $acw62.useMemo)(()=>{
        const byOwner = new Map();
        for (const r of recipientRows){
            const existing = byOwner.get(r.eigentuemerId);
            if (!existing) byOwner.set(r.eigentuemerId, {
                eigentuemerId: r.eigentuemerId,
                eigentuemerName: r.eigentuemerName,
                erreichbarkeit: r.erreichbarkeit,
                temporaryAnalog: Boolean(r.temporaryAnalog),
                einheiten: new Set([
                    r.einheitsnummer
                ]),
                emails: new Set(r.email?.trim() ? [
                    r.email.trim()
                ] : []),
                hasSubmittedVote: r.voteValue !== "offen"
            });
            else {
                existing.einheiten.add(r.einheitsnummer);
                if (r.temporaryAnalog) existing.temporaryAnalog = true;
                if (r.email?.trim()) existing.emails.add(r.email.trim());
                if (r.voteValue !== "offen") existing.hasSubmittedVote = true;
            }
        }
        const rows = [
            ...byOwner.values()
        ].map((row)=>({
                eigentuemerId: row.eigentuemerId,
                eigentuemerName: row.eigentuemerName,
                erreichbarkeit: row.erreichbarkeit,
                temporaryAnalog: Boolean(row.temporaryAnalog),
                hasSubmittedVote: row.hasSubmittedVote,
                einheitenLabel: [
                    ...row.einheiten
                ].sort((a, b)=>a.localeCompare(b, "de")).map((value)=>$845661e1cd923dd3$var$formatUnitNumberForResult(value)).join(" | "),
                emailLabel: [
                    ...row.emails
                ].sort((a, b)=>a.localeCompare(b, "de")).join(" | ")
            }));
        const needle = searchVersand.trim().toLowerCase();
        if (!needle) return rows;
        return rows.filter((row)=>[
                row.eigentuemerId,
                row.eigentuemerName,
                row.erreichbarkeit,
                row.temporaryAnalog ? "tempor\xe4r analog" : "",
                row.einheitenLabel,
                row.emailLabel
            ].join(" ").toLowerCase().includes(needle));
    }, [
        recipientRows,
        searchVersand
    ]);
    const versandEmpfaengerByOwnerId = (0, $acw62.useMemo)(()=>new Map(versandEmpfaengerRows.map((row)=>[
                row.eigentuemerId,
                row
            ])), [
        versandEmpfaengerRows
    ]);
    const digitalCount = recipientRows.filter((r)=>r.erreichbarkeit === "digital").length;
    const analogCount = recipientRows.filter((r)=>r.erreichbarkeit === "analog").length;
    const recipientTotal = digitalCount + analogCount;
    const overviewRecipientDigital = Number.isFinite(Number(kpiQuery.data?.recipient?.digital)) ? Number(kpiQuery.data?.recipient?.digital ?? 0) : Number.isFinite(Number(resolution?.anzahl_digital_empfaenger)) ? Number(resolution?.anzahl_digital_empfaenger ?? 0) : digitalCount;
    const overviewRecipientAnalog = Number.isFinite(Number(kpiQuery.data?.recipient?.analog)) ? Number(kpiQuery.data?.recipient?.analog ?? 0) : Number.isFinite(Number(resolution?.anzahl_analog_empfaenger)) ? Number(resolution?.anzahl_analog_empfaenger ?? 0) : analogCount;
    const overviewRecipientTotal = Math.max(Number.isFinite(Number(kpiQuery.data?.recipient?.gesamt)) ? Number(kpiQuery.data?.recipient?.gesamt ?? 0) : Number.isFinite(Number(resolution?.anzahl_empfaenger_gesamt)) ? Number(resolution?.anzahl_empfaenger_gesamt ?? 0) : overviewRecipientDigital + overviewRecipientAnalog, 0);
    const overviewAbgegebeneStimmen = Number.isFinite(Number(kpiQuery.data?.abgegebene_stimmen)) ? Number(kpiQuery.data?.abgegebene_stimmen ?? 0) : Number.isFinite(Number(resultQuery.data?.stimmen?.abgegeben)) ? Number(resultQuery.data?.stimmen?.abgegeben ?? 0) : resolution?.abgegebene_stimmen ?? 0;
    const overviewRuecklaufquote = Number.isFinite(Number(kpiQuery.data?.ruecklaufquote)) ? Number(kpiQuery.data?.ruecklaufquote ?? 0) : overviewRecipientTotal > 0 ? overviewAbgegebeneStimmen / overviewRecipientTotal * 100 : 0;
    const overviewStimmberechtigteEinheiten = resultQuery.data?.stimmberechtigte_einheiten?.length ?? resolution?.stimmberechtigte_einheiten.length ?? 0;
    const voteLogRows = voteLogQuery.data?.data ?? [];
    const ownerNameById = (0, $acw62.useMemo)(()=>{
        const map = new Map();
        for (const row of recipientRows)map.set(row.eigentuemerId, row.eigentuemerName);
        return map;
    }, [
        recipientRows
    ]);
    const resolveVoteLogOwnerName = (ownerId)=>{
        if (!ownerId) return "-";
        return $845661e1cd923dd3$var$normalizeMojibake(ownerNameById.get(ownerId) ?? ownerId);
    };
    const dispatchLogRows = dispatchLogQuery.data?.data ?? [];
    const triggerNotificationLogRows = triggerNotificationLogQuery.data?.data ?? [];
    const uiSettings = (0, $5806306cf67ca7cd$export$cc8e577c185b57cb)();
    const isFrameworkV2 = uiSettings.management.uiFramework === "mockup_v2";
    const getPlannedDispatchDate = (eventType)=>{
        if (!resolution?.endedatum) return undefined;
        const match = resolution.endedatum.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return undefined;
        const baseDate = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
        if (Number.isNaN(baseDate.getTime())) return undefined;
        const planned = new Date(baseDate);
        if (eventType === "erinnerung_1_versendet") planned.setDate(planned.getDate() - uiSettings.reminders.firstReminderDays);
        if (eventType === "erinnerung_2_versendet") planned.setDate(planned.getDate() - uiSettings.reminders.secondReminderDays);
        if (eventType === "beschlussergebnis_versendet") return resolution.endedatum;
        if (eventType === "einladung_versendet") return undefined;
        const y = planned.getFullYear();
        const m = String(planned.getMonth() + 1).padStart(2, "0");
        const d = String(planned.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    };
    const dispatchRows = $845661e1cd923dd3$var$dispatchEventOrder.map((eventType)=>{
        const event = dispatchLogRows.find((row)=>row.eventType === eventType);
        const generatedEventRows = generatedDispatchRows.filter((row)=>row.eventType === eventType);
        const generatedPdfCount = generatedEventRows.filter((row)=>Boolean(row.fileName && row.relativePath)).length;
        const deliverableRows = generatedEventRows.filter((row)=>row.templateKey !== "ballot_analog");
        const digitalRows = deliverableRows.filter((row)=>row.kanal === "digital");
        const analogRows = deliverableRows.filter((row)=>row.kanal === "analog");
        const hasGeneratedSent = digitalRows.some((row)=>row.digitalMailStatus === "sent");
        const hasAnalogPrepared = analogRows.some((row)=>Boolean(row.fileName && row.relativePath));
        const hasGeneratedFailed = digitalRows.some((row)=>row.digitalMailStatus === "failed");
        const hasGeneratedSkipped = digitalRows.length > 0 && digitalRows.every((row)=>row.digitalMailStatus === "skipped");
        const latestGeneratedAt = generatedEventRows.map((row)=>row.digitalMailSentAt).filter((v)=>Boolean(v)).sort((a, b)=>b.localeCompare(a))[0];
        const status = hasGeneratedSent || digitalRows.length === 0 && hasAnalogPrepared ? "versendet" : hasGeneratedFailed ? "fehlgeschlagen" : hasGeneratedSkipped ? "uebersprungen" : event ? "vorgemerkt" : "ausstehend";
        return {
            eventType: eventType,
            label: $845661e1cd923dd3$var$formatDispatchType(eventType),
            status: status,
            timestamp: latestGeneratedAt,
            plannedDate: getPlannedDispatchDate(eventType),
            generatedPdfCount: generatedPdfCount
        };
    });
    const renderDispatchBadge = (eventType, erreichbarkeit, eigentuemerId)=>{
        if (erreichbarkeit === "analog") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "badge inaktiv",
            children: "Nicht digital"
        });
        const ownerSentRows = generatedDispatchRows.filter((row)=>row.eventType === eventType && row.kanal === "digital" && $845661e1cd923dd3$var$isGeneratedDispatchRowForOwner(row, eigentuemerId) && row.digitalMailStatus === "sent");
        const ownerSent = ownerSentRows.length > 0;
        const ownerDigitalRows = generatedDispatchRows.filter((row)=>row.eventType === eventType && row.kanal === "digital" && $845661e1cd923dd3$var$isGeneratedDispatchRowForOwner(row, eigentuemerId) && row.templateKey !== "ballot_analog");
        const latestOwnerSent = ownerSentRows.slice().sort((a, b)=>(b.digitalMailSentAt || b.digitalMailAttemptedAt || b.createdAt).localeCompare(a.digitalMailSentAt || a.digitalMailAttemptedAt || a.createdAt))[0];
        const isReminderEvent = eventType === "erinnerung_1_versendet" || eventType === "erinnerung_2_versendet";
        const hasSubmittedVote = versandEmpfaengerByOwnerId.get(String(eigentuemerId ?? ""))?.hasSubmittedVote === true;
        const ownerStatus = ownerSent ? "versendet" : ownerDigitalRows.some((row)=>row.digitalMailStatus === "failed") ? "fehlgeschlagen" : ownerDigitalRows.length > 0 && ownerDigitalRows.every((row)=>row.digitalMailStatus === "skipped") ? "uebersprungen" : isReminderEvent && hasSubmittedVote && dispatchLogRows.some((row)=>row.eventType === eventType) ? "abgestimmt" : dispatchLogRows.some((row)=>row.eventType === eventType) ? "vorgemerkt" : "ausstehend";
        const sentAt = latestOwnerSent?.digitalMailSentAt || latestOwnerSent?.digitalMailAttemptedAt;
        const targetEmail = latestOwnerSent?.digitalMailTo || versandEmpfaengerByOwnerId.get(String(eigentuemerId ?? ""))?.emailLabel || "-";
        const title = ownerSent ? `Versendet am: ${$845661e1cd923dd3$var$formatDateTimeDE(sentAt)}\nZiel-E-Mail: ${targetEmail}` : ownerDigitalRows[0]?.digitalMailError ? ownerDigitalRows[0].digitalMailError : ownerStatus === "abgestimmt" ? "Nicht versendet, da bereits eine Stimme abgegeben wurde." : undefined;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: `badge ${$845661e1cd923dd3$var$getDispatchUiStatusBadgeClass(ownerStatus)}`,
            title: title,
            children: $845661e1cd923dd3$var$formatDispatchUiStatus(ownerStatus)
        });
    };
    const ownerAccessRows = ownerAccessesQuery.data?.data ?? [];
    const documentRows = documentsQuery.data?.data ?? [];
    const faciliooAttachmentRows = faciliooAttachmentsQuery.data?.data ?? [];
    const faciliooFileTypeRows = faciliooFileTypesDebugQuery.data?.data ?? [];
    (0, $acw62.useEffect)(()=>{
        const allowed = new Set(faciliooAttachmentRows.map((row)=>`${row.feedId}:${row.attachmentId}`));
        setSelectedFaciliooAttachmentKeys((prev)=>prev.filter((key)=>allowed.has(key)));
    }, [
        faciliooAttachmentRows
    ]);
    (0, $acw62.useEffect)(()=>{
        const allowed = new Set(documentRows.map((row)=>row.id));
        setSelectedDocumentIds((prev)=>prev.filter((id)=>allowed.has(id)));
    }, [
        documentRows
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (previewFaciliooDocument?.url) URL.revokeObjectURL(previewFaciliooDocument.url);
        };
    }, [
        previewFaciliooDocument?.url
    ]);
    const ownerAccessByEigentuemerId = new Map();
    for (const row of ownerAccessRows)if (!ownerAccessByEigentuemerId.has(row.eigentuemer_id)) ownerAccessByEigentuemerId.set(row.eigentuemer_id, row);
    const filteredOwnerAccessRows = (0, $acw62.useMemo)(()=>{
        const needle = searchZugangsdaten.trim().toLowerCase();
        if (!needle) return ownerAccessRows;
        return ownerAccessRows.filter((row)=>[
                row.eigentuemer_id,
                row.eigentuemername,
                row.email ?? "",
                row.status,
                row.aktuelle_stimme,
                row.zugangspasswort ?? row.einmalpasswort
            ].join(" ").toLowerCase().includes(needle));
    }, [
        ownerAccessRows,
        searchZugangsdaten
    ]);
    const filteredDocumentRows = (0, $acw62.useMemo)(()=>{
        const needle = searchDokumente.trim().toLowerCase();
        if (!needle) return documentRows;
        return documentRows.filter((doc)=>[
                doc.originalName,
                doc.uploadedByName,
                $845661e1cd923dd3$var$formatDateTimeDE(doc.uploadedAt),
                `${(doc.size / 1024).toFixed(1)} KB`
            ].join(" ").toLowerCase().includes(needle));
    }, [
        documentRows,
        searchDokumente
    ]);
    const filteredFaciliooAttachmentRows = (0, $acw62.useMemo)(()=>{
        const needle = searchFaciliooDokumente.trim().toLowerCase();
        if (!needle) return faciliooAttachmentRows;
        return faciliooAttachmentRows.filter((row)=>{
            const fileSizeBytes = Number.isFinite(Number(row.filesizeKb)) ? Number(row.filesizeKb) * 1024 : 0;
            return [
                row.originalFilename || `Anhang ${row.attachmentId}`,
                $845661e1cd923dd3$var$resolveFileTypeLabel(row),
                $845661e1cd923dd3$var$formatFileSize(fileSizeBytes),
                $845661e1cd923dd3$var$formatDateTimeDE(row.lastModifiedAt ?? row.createdAt ?? undefined),
                row.feedId,
                row.attachmentId
            ].join(" ").toLowerCase().includes(needle);
        });
    }, [
        faciliooAttachmentRows,
        searchFaciliooDokumente
    ]);
    const triggerDownload = (content, fileName, mimeType)=>{
        const blob = new Blob([
            content
        ], {
            type: mimeType
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    };
    const downloadBlob = (blob, fileName)=>{
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    };
    const handleDownloadDispatchZip = async (eventType)=>{
        if (!id) return;
        try {
            setActionError("");
            const blob = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).downloadGeneratedDispatchZip(id, eventType);
            const safeBeschlussnummer = String(resolution?.beschlussnummer ?? "beschluss").replace(/[^A-Za-z0-9_-]+/g, "_");
            const fileName = `Versand_${safeBeschlussnummer}_${eventType}.zip`;
            downloadBlob(blob, fileName);
        } catch (error) {
            setActionError(error instanceof Error ? error.message : "ZIP-Download fehlgeschlagen.");
        }
    };
    const buildLogFileName = (extension)=>{
        const beschlussnummer = (resolution?.beschlussnummer ?? "unbekannt").replace(/[^A-Za-z0-9_-]/g, "_");
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");
        const hh = String(now.getHours()).padStart(2, "0");
        const min = String(now.getMinutes()).padStart(2, "0");
        const stamp = `${yyyy}-${mm}-${dd}_${hh}-${min}`;
        return `Log_${beschlussnummer}_${stamp}.${extension}`;
    };
    const handleDownloadVoteLogJson = ()=>{
        const fileName = buildLogFileName("json");
        const enrichedRows = voteLogRows.map((row)=>({
                ...row,
                owner_display_name: resolveVoteLogOwnerName(row.owner_id)
            }));
        triggerDownload(JSON.stringify(enrichedRows, null, 2), fileName, "application/json;charset=utf-8");
    };
    const handleDownloadVoteLogCsv = ()=>{
        const fileName = buildLogFileName("csv");
        triggerDownload($845661e1cd923dd3$var$buildVoteLogCsv(voteLogRows, resolveVoteLogOwnerName), fileName, "text/csv;charset=utf-8");
    };
    const buildOwnerAccessCsv = (rows)=>{
        const header = [
            "Eigent\xfcmer ID",
            "Eigent\xfcmer",
            "E-Mail",
            "Zugangspasswort",
            "Direktlink",
            "Status",
            "Aktuelle Stimme"
        ];
        const body = rows.map((row)=>[
                row.eigentuemer_id,
                row.eigentuemername,
                row.email ?? "",
                row.zugangspasswort ?? row.einmalpasswort,
                `${window.location.origin}${row.direct_path}`,
                row.status,
                row.aktuelle_stimme
            ]);
        const escapeCsv = (value)=>`"${String(value).replace(/"/g, '""')}"`;
        return [
            header,
            ...body
        ].map((row)=>row.map((cell)=>escapeCsv(String(cell))).join(";")).join("\n");
    };
    const handleDownloadOwnerAccessCsv = ()=>{
        const fileName = `Zugangsdaten_${(resolution?.beschlussnummer ?? "unbekannt").replace(/[^A-Za-z0-9_-]/g, "_")}.csv`;
        triggerDownload(buildOwnerAccessCsv(ownerAccessRows), fileName, "text/csv;charset=utf-8");
    };
    const openVoteLogModal = async ()=>{
        await voteLogQuery.refetch();
        setIsVoteLogModalOpen(true);
    };
    const isLoading = resolutionQuery.isLoading || kpiQuery.isLoading || resultQuery.isLoading || recipientsQuery.isLoading || ownerAccessesQuery.isLoading || dispatchLogQuery.isLoading || triggerNotificationLogQuery.isLoading || generatedDispatchQuery.isLoading;
    const hasFaciliooProcessLink = Boolean(String(resolution?.facilioo_vorgangsnummer ?? "").trim());
    const visibleTabs = (0, $acw62.useMemo)(()=>$845661e1cd923dd3$var$tabs.filter((entry)=>entry.key !== "facilioo_dokumente" || hasFaciliooProcessLink), [
        hasFaciliooProcessLink
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!hasFaciliooProcessLink && tab === "facilioo_dokumente") setTab("stammdaten");
    }, [
        hasFaciliooProcessLink,
        tab
    ]);
    const liveSyncEnabled = $845661e1cd923dd3$var$RESOLUTION_SSE_ENABLED && (tab === "stammdaten" || tab === "stimmen" || tab === "versand" || tab === "ergebnis");
    (0, $acw62.useEffect)(()=>{
        if (!id || !liveSyncEnabled) return;
        const stream = (0, $11320eb8d5d066e4$export$644d8ea042df96a6).subscribeResolutionEvents(id, {
            onEvent: (eventName)=>{
                if (eventName !== "resolution-updated") return;
                qc.invalidateQueries({
                    queryKey: [
                        "resolution",
                        id
                    ]
                });
                if (tab === "stammdaten" || tab === "stimmen" || tab === "ergebnis") {
                    qc.invalidateQueries({
                        queryKey: [
                            "resolution-kpis",
                            id
                        ]
                    });
                    qc.invalidateQueries({
                        queryKey: [
                            "resolution-result",
                            id
                        ]
                    });
                }
                if (tab === "stimmen") {
                    qc.invalidateQueries({
                        queryKey: [
                            "resolution-vote-log",
                            id
                        ]
                    });
                    qc.invalidateQueries({
                        queryKey: [
                            "resolution-recipients",
                            id
                        ]
                    });
                }
                if (tab === "versand") {
                    qc.invalidateQueries({
                        queryKey: [
                            "resolution-dispatch-log",
                            id
                        ]
                    });
                    qc.invalidateQueries({
                        queryKey: [
                            "resolution-trigger-notifications-log",
                            id
                        ]
                    });
                    qc.invalidateQueries({
                        queryKey: [
                            "generated-dispatch",
                            id
                        ]
                    });
                }
            }
        });
        return ()=>stream.close();
    }, [
        id,
        liveSyncEnabled,
        qc,
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        setRecipientTableScrollTop(0);
    }, [
        searchEmpfaenger,
        tab,
        filteredRecipientRowsEmpfaenger.length
    ]);
    (0, $acw62.useEffect)(()=>{
        setVoteTableScrollTop(0);
    }, [
        searchStimmen,
        filterStimmenErreichbarkeit,
        filterStimmenverhalten,
        tab,
        filteredRecipientRowsStimmen.length
    ]);
    (0, $acw62.useEffect)(()=>{
        setEmpfaengerPage(1);
    }, [
        searchEmpfaenger,
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        setStimmenPage(1);
    }, [
        filterStimmenErreichbarkeit,
        filterStimmenverhalten,
        searchStimmen,
        tab
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!voteOpenActionMenuId,
        isHovered: isVoteActionMenuHovered,
        closeMenu: ()=>setVoteOpenActionMenuId(null)
    });
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!documentOpenActionMenuId,
        isHovered: isDocumentActionMenuHovered,
        closeMenu: ()=>setDocumentOpenActionMenuId(null)
    });
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!faciliooOpenActionMenuId,
        isHovered: isFaciliooActionMenuHovered,
        closeMenu: ()=>setFaciliooOpenActionMenuId(null)
    });
    (0, $acw62.useEffect)(()=>{
        if (!voteOpenActionMenuId) setIsVoteActionMenuHovered(false);
    }, [
        voteOpenActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!documentOpenActionMenuId) setIsDocumentActionMenuHovered(false);
    }, [
        documentOpenActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!faciliooOpenActionMenuId) setIsFaciliooActionMenuHovered(false);
    }, [
        faciliooOpenActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!voteOpenActionMenuId && !documentOpenActionMenuId && !faciliooOpenActionMenuId) setActionMenuPosition(null);
    }, [
        documentOpenActionMenuId,
        faciliooOpenActionMenuId,
        voteOpenActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        const hasOpenMenu = !!voteOpenActionMenuId || !!documentOpenActionMenuId || !!faciliooOpenActionMenuId;
        if (!hasOpenMenu) return;
        const closeAllActionMenus = ()=>{
            setVoteOpenActionMenuId(null);
            setDocumentOpenActionMenuId(null);
            setFaciliooOpenActionMenuId(null);
        };
        const handlePointerDown = (event)=>{
            if ((0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            closeAllActionMenus();
        };
        const handleEscape = (event)=>{
            if (event.key === "Escape") closeAllActionMenus();
        };
        window.addEventListener("mousedown", handlePointerDown);
        window.addEventListener("keydown", handleEscape);
        window.addEventListener("scroll", closeAllActionMenus, true);
        window.addEventListener("resize", closeAllActionMenus);
        return ()=>{
            window.removeEventListener("mousedown", handlePointerDown);
            window.removeEventListener("keydown", handleEscape);
            window.removeEventListener("scroll", closeAllActionMenus, true);
            window.removeEventListener("resize", closeAllActionMenus);
        };
    }, [
        documentOpenActionMenuId,
        faciliooOpenActionMenuId,
        voteOpenActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        setVoteOpenActionMenuId(null);
        setDocumentOpenActionMenuId(null);
        setFaciliooOpenActionMenuId(null);
    }, [
        filterStimmenErreichbarkeit,
        filterStimmenverhalten,
        searchStimmen,
        stimmenPage,
        tab
    ]);
    const openFloatingActionMenu = (menuId, trigger, setOpenMenuId, menuHeight = 112)=>{
        const rect = trigger.getBoundingClientRect();
        const menuWidth = 170;
        const margin = 8;
        const left = Math.min(Math.max(margin, rect.right - menuWidth), Math.max(margin, window.innerWidth - menuWidth - margin));
        const belowTop = rect.bottom + 6;
        const aboveTop = rect.top - menuHeight - 6;
        const top = belowTop + menuHeight <= window.innerHeight - margin ? belowTop : Math.max(margin, aboveTop);
        setActionMenuPosition({
            left: left,
            top: top
        });
        setVoteOpenActionMenuId(null);
        setDocumentOpenActionMenuId(null);
        setFaciliooOpenActionMenuId(null);
        setOpenMenuId(menuId);
    };
    if (!id) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "panel",
        children: "Ung\xfcltige Beschluss-ID."
    });
    if (resolutionQuery.isError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "panel",
        children: "Umlaufbeschluss konnte nicht geladen werden."
    });
    if (!resolution) return isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "resolution-detail-v2-page"
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "panel",
        children: "Lade Umlaufbeschluss..."
    });
    const canCaptureVotes = resolution.status !== "entwurf";
    const autoDispatchTooltip = "Automatischer Versandprozess aktiv";
    const overviewKpiItems = [
        {
            label: "Stimmrechtsart",
            value: $845661e1cd923dd3$var$formatStimmrechtsart(resolution.stimmrechtsart),
            secondaryLabel: "Quorum",
            secondaryValue: $845661e1cd923dd3$var$formatQuorum(resolution.quorum),
            secondaryNote: quorumKpiHinweis,
            variant: "combined"
        },
        {
            label: "Restlaufzeit (Tage)",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$RemainingTimeIcon, {}),
            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "resolutions-v2-remaining-bullet resolution-detail-remaining-bullet-v2",
                children: $845661e1cd923dd3$var$getRemainingDaysForActiveResolution(resolution.status, resolution.endedatum)
            }),
            variant: "remaining"
        },
        {
            label: "Facilioo Vorgangsnummer",
            value: resolution.facilioo_vorgangsnummer ?? "-",
            variant: "facilioo"
        }
    ];
    const overviewResponsePct = Math.max(0, Math.min(100, overviewRuecklaufquote));
    const overviewOpenVotes = Math.max(overviewRecipientTotal - overviewAbgegebeneStimmen, 0);
    const overviewDigitalPct = overviewRecipientTotal > 0 ? overviewRecipientDigital / overviewRecipientTotal * 100 : 0;
    const overviewResponseRingStyle = {
        "--resolution-response-pct": `${overviewResponsePct}%`
    };
    const overviewRecipientRingStyle = {
        "--resolution-recipient-digital-pct": `${Math.max(0, Math.min(100, overviewDigitalPct))}%`
    };
    const overviewVoteSource = kpiQuery.data?.stimmen ?? resultQuery.data?.stimmen;
    const overviewVoteJa = Number.isFinite(Number(overviewVoteSource?.ja)) ? Number(overviewVoteSource?.ja ?? 0) : 0;
    const overviewVoteNein = Number.isFinite(Number(overviewVoteSource?.nein)) ? Number(overviewVoteSource?.nein ?? 0) : 0;
    const overviewVoteEnthaltung = Number.isFinite(Number(overviewVoteSource?.enthaltung)) ? Number(overviewVoteSource?.enthaltung ?? 0) : 0;
    const overviewVoteSourceTotal = Number.isFinite(Number(overviewVoteSource?.gesamt)) ? Number(overviewVoteSource?.gesamt ?? 0) : 0;
    const overviewVoteTotal = overviewVoteSourceTotal > 0 ? overviewVoteSourceTotal : Math.max(overviewVoteJa + overviewVoteNein + overviewVoteEnthaltung, overviewRecipientTotal, 0);
    const overviewVoteOffen = Number.isFinite(Number(overviewVoteSource?.offen)) ? Number(overviewVoteSource?.offen ?? 0) : Math.max(overviewVoteTotal - overviewVoteJa - overviewVoteNein - overviewVoteEnthaltung, 0);
    const getVoteSegmentWidth = (value)=>overviewVoteTotal > 0 ? `${Math.max(value / overviewVoteTotal * 100, value > 0 ? 4 : 0)}%` : "0%";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: isFrameworkV2 ? "resolution-detail-v2-page" : undefined,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: `panel page-header${isFrameworkV2 ? " resolution-detail-v2-header" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    className: isFrameworkV2 ? "resolution-detail-v2-title" : "",
                                    style: isFrameworkV2 ? undefined : {
                                        margin: 0,
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 8
                                    },
                                    children: [
                                        isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "resolutions-v2-title-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionKpiIcon, {})
                                        }) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: isFrameworkV2 ? "resolution-detail-v2-title-copy" : undefined,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: isFrameworkV2 ? "resolution-detail-v2-title-main" : undefined,
                                                    children: resolution.beschlussnummer
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: isFrameworkV2 ? "resolution-detail-v2-title-sub" : undefined,
                                                    children: resolution.titel
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: isFrameworkV2 ? "resolution-detail-v2-meta" : undefined,
                                    style: isFrameworkV2 ? undefined : {
                                        marginTop: 6,
                                        color: "var(--text-soft)",
                                        display: "flex",
                                        gap: 10,
                                        flexWrap: "wrap"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "Objekt: ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: `/objects/${resolution.objectId}`,
                                                    children: [
                                                        resolution.objektnummer,
                                                        " / ",
                                                        resolution.objektname
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "Startdatum: ",
                                                $845661e1cd923dd3$var$formatDateDE(resolution.startdatum)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "Enddatum: ",
                                                $845661e1cd923dd3$var$formatDateDE(resolution.endedatum)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: isFrameworkV2 ? "resolution-detail-v2-actions" : undefined,
                            style: {
                                display: "flex",
                                gap: 8,
                                alignItems: "center",
                                flexWrap: "wrap"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `badge ${resolution.status}`,
                                    children: $845661e1cd923dd3$var$formatStatus(resolution.status)
                                }),
                                resolution.dispatch_automation_enabled && resolution.status === "aktiv" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dispatch-automation-indicator quick-tooltip",
                                    "data-tooltip": autoDispatchTooltip,
                                    "aria-label": autoDispatchTooltip,
                                    tabIndex: 0,
                                    children: "\u2699"
                                }) : null,
                                $845661e1cd923dd3$var$outcomeBadge(resolution.status, kpiQuery.data?.quorumErfuellt ?? resultQuery.data?.quorumErfuellt),
                                resolution.status === "entwurf" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "resolution-action-btn resolution-start-btn",
                                    disabled: startMutation.isPending,
                                    onClick: ()=>{
                                        if (!resolution.endedatum) {
                                            setStartConfirm({
                                                beschlussnummer: resolution.beschlussnummer,
                                                endedatum: "",
                                                error: ""
                                            });
                                            return;
                                        }
                                        startMutation.mutate({
                                            resolutionId: resolution.id,
                                            endedatum: resolution.endedatum
                                        });
                                    },
                                    children: "Starten"
                                }) : null,
                                resolution.status === "aktiv" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "resolution-action-btn resolution-stop-btn",
                                    disabled: stopMutation.isPending,
                                    onClick: ()=>setStopConfirm({
                                            resolutionId: resolution.id,
                                            beschlussnummer: resolution.beschlussnummer,
                                            code: String(Math.floor(1000 + Math.random() * 9000)),
                                            input: [
                                                "",
                                                "",
                                                "",
                                                ""
                                            ],
                                            error: ""
                                        }),
                                    children: "Stoppen"
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/resolutions",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: isFrameworkV2 ? "resolution-detail-v2-secondary-btn" : undefined,
                                        children: "Zur Liste"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                    className: isFrameworkV2 ? "object-tabbar object-tabbar-v2" : "panel object-tabbar",
                    style: isFrameworkV2 ? undefined : {
                        paddingTop: 14,
                        paddingBottom: 10
                    },
                    children: visibleTabs.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: `object-tabbtn${isFrameworkV2 ? " object-tabbtn-v2" : ""}${tab === t.key ? " active" : ""}`,
                            onClick: ()=>setTab(t.key),
                            children: t.label
                        }, t.key))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6325038d4357e6f6$export$7aee19a40772c514), {
                    open: !!startConfirm,
                    beschlussnummer: startConfirm?.beschlussnummer ?? "",
                    enddatum: startConfirm?.endedatum ?? "",
                    error: startConfirm?.error,
                    isPending: startMutation.isPending,
                    onClose: ()=>setStartConfirm(null),
                    onEnddatumChange: (value)=>startConfirm && setStartConfirm({
                            ...startConfirm,
                            endedatum: value,
                            error: ""
                        }),
                    onConfirm: ()=>{
                        if (!startConfirm) return;
                        const today = $845661e1cd923dd3$var$getTodayDateKey();
                        if (!startConfirm.endedatum) {
                            setStartConfirm({
                                ...startConfirm,
                                error: "Enddatum ist erforderlich."
                            });
                            return;
                        }
                        if (startConfirm.endedatum <= today) {
                            setStartConfirm({
                                ...startConfirm,
                                error: "Enddatum muss nach dem heutigen Startdatum liegen."
                            });
                            return;
                        }
                        startMutation.mutate({
                            resolutionId: resolution.id,
                            endedatum: startConfirm.endedatum
                        });
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                    open: !!stopConfirm,
                    title: "Beschluss stoppen",
                    message: stopConfirm ? `Beschluss ${stopConfirm.beschlussnummer} soll manuell gestoppt werden.` : "",
                    code: stopConfirm?.code ?? "",
                    input: stopConfirm?.input ?? [
                        "",
                        "",
                        "",
                        ""
                    ],
                    error: stopConfirm?.error,
                    isPending: stopMutation.isPending,
                    onClose: ()=>setStopConfirm(null),
                    onInputChange: (next)=>stopConfirm && setStopConfirm({
                            ...stopConfirm,
                            input: next
                        }),
                    onErrorReset: ()=>stopConfirm?.error && setStopConfirm({
                            ...stopConfirm,
                            error: ""
                        }),
                    confirmLabel: "Stoppen best\xe4tigen",
                    pendingLabel: "Stoppe...",
                    onConfirm: ()=>{
                        if (!stopConfirm) return;
                        if (stopConfirm.input.join("") !== stopConfirm.code) {
                            setStopConfirm({
                                ...stopConfirm,
                                error: "Sicherheitscode falsch eingegeben."
                            });
                            return;
                        }
                        stopMutation.mutate(stopConfirm.resolutionId);
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                    open: !!voteChangeConfirm,
                    title: "Stimmabgabe \xe4ndern",
                    message: voteChangeConfirm ? `Die Stimmabgabe von ${voteChangeConfirm.eigentuemerLabel} soll ge\xe4ndert werden.` : "",
                    code: voteChangeConfirm?.code ?? "",
                    input: voteChangeConfirm?.input ?? [
                        "",
                        "",
                        "",
                        ""
                    ],
                    error: voteChangeConfirm?.error,
                    isPending: voteMutation.isPending,
                    onClose: ()=>setVoteChangeConfirm(null),
                    onInputChange: (next)=>voteChangeConfirm && setVoteChangeConfirm({
                            ...voteChangeConfirm,
                            input: next
                        }),
                    onErrorReset: ()=>voteChangeConfirm?.error && setVoteChangeConfirm({
                            ...voteChangeConfirm,
                            error: ""
                        }),
                    confirmLabel: "Abstimmung \xe4ndern",
                    pendingLabel: "\xc4ndere...",
                    onConfirm: ()=>{
                        if (!voteChangeConfirm) return;
                        if (voteChangeConfirm.input.join("") !== voteChangeConfirm.code) {
                            setVoteChangeConfirm({
                                ...voteChangeConfirm,
                                error: "Sicherheitscode falsch eingegeben."
                            });
                            return;
                        }
                        voteMutation.mutate({
                            assignmentId: voteChangeConfirm.assignmentId,
                            voteValue: voteChangeConfirm.voteValue,
                            comment: voteChangeConfirm.comment
                        });
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                    open: !!documentDeleteConfirm,
                    title: "Dokument l\xf6schen",
                    message: documentDeleteConfirm ? `Dokument "${documentDeleteConfirm.documentName}" wirklich l\xf6schen?` : "",
                    code: documentDeleteConfirm?.code ?? "",
                    input: documentDeleteConfirm?.input ?? [
                        "",
                        "",
                        "",
                        ""
                    ],
                    error: documentDeleteConfirm?.error,
                    isPending: documentDeleteMutation.isPending,
                    onClose: ()=>setDocumentDeleteConfirm(null),
                    onInputChange: (next)=>documentDeleteConfirm && setDocumentDeleteConfirm({
                            ...documentDeleteConfirm,
                            input: next
                        }),
                    onErrorReset: ()=>documentDeleteConfirm?.error && setDocumentDeleteConfirm({
                            ...documentDeleteConfirm,
                            error: ""
                        }),
                    confirmLabel: "L\xf6schen best\xe4tigen",
                    pendingLabel: "L\xf6sche...",
                    onConfirm: ()=>{
                        if (!documentDeleteConfirm) return;
                        if (documentDeleteConfirm.input.join("") !== documentDeleteConfirm.code) {
                            setDocumentDeleteConfirm({
                                ...documentDeleteConfirm,
                                error: "Sicherheitscode falsch eingegeben."
                            });
                            return;
                        }
                        documentDeleteMutation.mutate(documentDeleteConfirm.documentId, {
                            onSuccess: ()=>setDocumentDeleteConfirm(null)
                        });
                    }
                }),
                isVoteLogModalOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "modal-backdrop",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel modal-card",
                        style: {
                            width: "min(1100px, 96vw)",
                            maxWidth: 1100
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 8
                                },
                                children: "Logdatei"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                style: {
                                    marginTop: 0,
                                    color: "var(--text-soft)"
                                },
                                children: [
                                    "Protokollierte Stimmabgaben und Stimm\xe4nderungen f\xfcr ",
                                    resolution.beschlussnummer,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions",
                                style: {
                                    justifyContent: "flex-start",
                                    marginBottom: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: handleDownloadVoteLogJson,
                                        children: "Download JSON"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: handleDownloadVoteLogCsv,
                                        children: "Download CSV"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    overflowX: "auto",
                                    maxHeight: "55vh",
                                    marginBottom: 10
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: "Zeitpunkt"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Ereignis"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "IP"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Kanal"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Authentifizierung"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Authentifiziert durch"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Eigent\xfcmer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Stimme"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Ge\xe4ndert"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                voteLogRows.map((log, idx)=>{
                                                    const changed = Array.isArray(log.changed_assignments) ? log.changed_assignments : [];
                                                    const changedLabel = changed.length ? changed.map((c)=>`${c.previousVoteValue ?? "offen"} -> ${c.nextVoteValue ?? "offen"}`).join(", ") : "-";
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                style: {
                                                                    textAlign: "center",
                                                                    whiteSpace: "nowrap"
                                                                },
                                                                children: $845661e1cd923dd3$var$formatDateTimeDE(log.timestamp)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: $845661e1cd923dd3$var$formatVoteEventType(log.vote_event_type)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: log.client_ip ?? "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: $845661e1cd923dd3$var$formatSubmissionChannel(log.submission_channel)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: $845661e1cd923dd3$var$formatAuthMode(log.auth_mode, log.auth_user_name ?? log.actor_name)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: $845661e1cd923dd3$var$formatAuthUser(log.auth_user_name, log.auth_user_id)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: resolveVoteLogOwnerName(log.owner_id)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: log.vote_value ? $845661e1cd923dd3$var$formatVoteValue(log.vote_value) : "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: changedLabel
                                                            })
                                                        ]
                                                    }, `vote-log-modal-${String(log.timestamp ?? "")}-${idx}`);
                                                }),
                                                !voteLogRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        colSpan: 9,
                                                        children: "Keine Logeintr\xe4ge vorhanden."
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-actions",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setIsVoteLogModalOpen(false),
                                    children: "Schlie\xdfen"
                                })
                            })
                        ]
                    })
                }) : null,
                isResultVotesModalOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "modal-backdrop",
                    onMouseDown: (event)=>{
                        if (event.target === event.currentTarget) setIsResultVotesModalOpen(false);
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel modal-card result-votes-modal-card",
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-labelledby": "result-votes-modal-title",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "result-votes-modal-head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                id: "result-votes-modal-title",
                                                style: {
                                                    marginTop: 0,
                                                    marginBottom: 6
                                                },
                                                children: "Einzelstimmen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                style: {
                                                    marginTop: 0,
                                                    color: "var(--text-soft)"
                                                },
                                                children: [
                                                    "Einzelstimmabgaben f\xfcr ",
                                                    resolution.beschlussnummer,
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setIsResultVotesModalOpen(false),
                                        "aria-label": "Overlay schlie\xdfen",
                                        children: "Schlie\xdfen"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: isFrameworkV2 ? "resolutions-v2-filterbar resolution-detail-v2-filterbar result-votes-modal-toolbar" : "filterbar result-votes-modal-toolbar",
                                style: isFrameworkV2 ? undefined : {
                                    marginBottom: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: isFrameworkV2 ? "resolutions-v2-filter-fields result-votes-modal-fields" : "result-votes-modal-fields",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: isFrameworkV2 ? "resolutions-v2-filter-input resolution-detail-v2-filter-input" : undefined,
                                                children: [
                                                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-filter-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableIcon, {
                                                            name: "search"
                                                        })
                                                    }) : null,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        className: isFrameworkV2 ? undefined : "table-field",
                                                        placeholder: "Suche...",
                                                        value: searchErgebnis,
                                                        onChange: (e)=>setSearchErgebnis(e.target.value),
                                                        style: isFrameworkV2 ? undefined : {
                                                            minWidth: 320
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "result-votes-row-count-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Zeilen"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: isFrameworkV2 ? undefined : "table-field",
                                                        value: String(resultVotesRowCount),
                                                        onChange: (e)=>{
                                                            const next = e.target.value;
                                                            setResultVotesRowCount(next === "all" ? "all" : Number(next));
                                                        },
                                                        children: [
                                                            $845661e1cd923dd3$var$RESULT_VOTE_ROW_COUNT_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: option,
                                                                    children: option
                                                                }, option)),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "all",
                                                                children: "Alle"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: isFrameworkV2 ? "resolutions-v2-row-count resolution-detail-v2-row-count result-votes-modal-count" : "result-votes-modal-count",
                                        children: [
                                            visibleRecipientRowsErgebnis.length,
                                            " von ",
                                            filteredRecipientRowsErgebnis.length,
                                            " Treffern"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "result-votes-modal-spacer",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: isFrameworkV2 ? "resolutions-v2-table-wrap resolution-detail-v2-table-wrap result-votes-modal-table-wrap" : "result-votes-modal-table-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: isFrameworkV2 ? "resolution-detail-v2-table resolution-detail-result-v2-table" : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Einheit",
                                                            icon: "unit",
                                                            center: true
                                                        }) : "Einheit"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Eigent\xfcmer",
                                                            icon: "ownerName"
                                                        }) : "Eigent\xfcmer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Stimmverhalten",
                                                            icon: "vote",
                                                            center: true
                                                        }) : "Stimmverhalten"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Letzte \xc4nderung am",
                                                            icon: "date",
                                                            center: true
                                                        }) : "Letzte \xc4nderung am"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Kommentar",
                                                            icon: "comment"
                                                        }) : "Kommentar"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                visibleRecipientRowsErgebnis.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: $845661e1cd923dd3$var$formatUnitNumberForResult(r.einheitsnummer)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: r.eigentuemerName
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: `badge ${r.voteValue === "ja" ? "vote-ja" : r.voteValue === "nein" ? "vote-nein" : r.voteValue === "enthaltung" ? "vote-enthaltung" : "vote-offen"}`,
                                                                    children: $845661e1cd923dd3$var$formatVoteValue(r.voteValue)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: $845661e1cd923dd3$var$formatDateTimeDE(r.voteReceivedAt)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: r.comment || "-"
                                                            })
                                                        ]
                                                    }, `result-modal-${r.assignmentId}`)),
                                                !filteredRecipientRowsErgebnis.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        colSpan: 5,
                                                        children: "Keine stimmberechtigten Einheiten gefunden."
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }) : null,
                actionError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                    className: "panel error-text",
                    children: actionError
                }) : null,
                isLoading ? isFrameworkV2 ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                    className: "panel",
                    children: "Daten werden geladen..."
                }) : null,
                tab === "stammdaten" ? isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            className: "object-overview-grid object-overview-grid-v2 resolution-detail-overview-grid-v2",
                            children: overviewKpiItems.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `kpi object-overview-kpi-v2 resolution-detail-kpi-v2${item.variant ? ` resolution-detail-kpi-v2--${item.variant}` : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "object-overview-kpi-icon",
                                            "aria-hidden": "true",
                                            children: item.icon ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionKpiIcon, {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "object-overview-kpi-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "resolution-detail-kpi-part-v2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: item.label
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: item.value
                                                        }),
                                                        item.note ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            children: item.note
                                                        }) : null
                                                    ]
                                                }),
                                                item.secondaryLabel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "resolution-detail-kpi-part-v2 resolution-detail-kpi-part-v2--secondary",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: item.secondaryLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: item.secondaryValue
                                                        }),
                                                        item.secondaryNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            children: item.secondaryNote
                                                        }) : null
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                }, item.label))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "object-overview-detail-grid-v2 resolution-detail-diagram-grid-v2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                    className: "object-overview-detail-card-v2 resolution-detail-diagram-card-v2 resolution-detail-diagram-card-v2--return",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                            className: "object-overview-card-title-v2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "object-overview-card-title-icon-v2",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ReturnRateIcon, {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "R\xfccklaufquote"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "object-reachability-v2 resolution-detail-donut-layout-v2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "object-reachability-ring-v2 resolution-detail-donut-v2 resolution-detail-donut-v2--response",
                                                    style: overviewResponseRingStyle,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "object-reachability-ring-inner-v2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    Math.round(overviewResponsePct),
                                                                    "%"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "abgegeben"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "object-reachability-legend-v2 resolution-detail-legend-v2 resolution-detail-return-legend-v2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "resolution-detail-return-legend-main-v2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--green",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "dot dot-digital"
                                                                        }),
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: "Abgegeben"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                            children: [
                                                                                overviewAbgegebeneStimmen,
                                                                                " Stimmen"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                            children: [
                                                                                $845661e1cd923dd3$var$formatShare(overviewAbgegebeneStimmen, overviewRecipientTotal),
                                                                                " %"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--red",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "dot dot-analog"
                                                                        }),
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: "Offen"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                            children: [
                                                                                overviewOpenVotes,
                                                                                " Stimmen"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                            children: [
                                                                                $845661e1cd923dd3$var$formatShare(overviewOpenVotes, overviewRecipientTotal),
                                                                                " %"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "reachability-total",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: "Gesamt"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                            children: [
                                                                                overviewRecipientTotal,
                                                                                " Empf\xe4nger"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "reachability-total resolution-detail-authorized-units-v2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Stimmberechtigte Einheiten"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: overviewStimmberechtigteEinheiten
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                    className: "object-overview-detail-card-v2 resolution-detail-diagram-card-v2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                            className: "object-overview-card-title-v2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "object-overview-card-title-icon-v2",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ReachabilityIcon, {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Empf\xe4ngerkan\xe4le"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "object-reachability-v2 resolution-detail-donut-layout-v2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "object-reachability-ring-v2 resolution-detail-donut-v2 resolution-detail-donut-v2--recipients",
                                                    style: overviewRecipientRingStyle,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "object-reachability-ring-inner-v2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    Math.round(overviewDigitalPct),
                                                                    "%"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "digital"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "object-reachability-legend-v2 resolution-detail-legend-v2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--green",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "dot dot-digital"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Digital"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                    children: [
                                                                        overviewRecipientDigital,
                                                                        " Empf\xe4nger"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                    children: [
                                                                        $845661e1cd923dd3$var$formatShare(overviewRecipientDigital, overviewRecipientTotal),
                                                                        " %"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--red",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "dot dot-analog"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Analog"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                    children: [
                                                                        overviewRecipientAnalog,
                                                                        " Empf\xe4nger"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                    children: [
                                                                        $845661e1cd923dd3$var$formatShare(overviewRecipientAnalog, overviewRecipientTotal),
                                                                        " %"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "reachability-total",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Gesamt"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                    children: [
                                                                        overviewRecipientTotal,
                                                                        " Empf\xe4nger"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                    className: "object-overview-detail-card-v2 resolution-detail-diagram-card-v2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                            className: "object-overview-card-title-v2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "object-overview-card-title-icon-v2",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResultIcon, {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Stimmenbild"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "resolution-detail-vote-chart-v2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "resolution-detail-vote-track-v2",
                                                    "aria-hidden": "true",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolution-detail-vote-segment-v2 resolution-detail-vote-segment-v2--yes",
                                                            style: {
                                                                width: getVoteSegmentWidth(overviewVoteJa)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolution-detail-vote-segment-v2 resolution-detail-vote-segment-v2--no",
                                                            style: {
                                                                width: getVoteSegmentWidth(overviewVoteNein)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolution-detail-vote-segment-v2 resolution-detail-vote-segment-v2--abstain",
                                                            style: {
                                                                width: getVoteSegmentWidth(overviewVoteEnthaltung)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolution-detail-vote-segment-v2 resolution-detail-vote-segment-v2--open",
                                                            style: {
                                                                width: getVoteSegmentWidth(overviewVoteOffen)
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "object-reachability-legend-v2 resolution-detail-legend-v2 resolution-detail-vote-legend-v2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--green",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "dot dot-digital"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Ja"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                    children: [
                                                                        overviewVoteJa,
                                                                        " Stimmen"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                    children: [
                                                                        $845661e1cd923dd3$var$formatShare(overviewVoteJa, overviewVoteTotal),
                                                                        " %"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--red",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "dot dot-analog"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Nein"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                    children: [
                                                                        overviewVoteNein,
                                                                        " Stimmen"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                    children: [
                                                                        $845661e1cd923dd3$var$formatShare(overviewVoteNein, overviewVoteTotal),
                                                                        " %"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--yellow",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "dot dot-digital"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Enthaltung"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                    children: [
                                                                        overviewVoteEnthaltung,
                                                                        " Stimmen"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                    children: [
                                                                        $845661e1cd923dd3$var$formatShare(overviewVoteEnthaltung, overviewVoteTotal),
                                                                        " %"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--neutral",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "dot dot-analog"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Offen"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                    children: [
                                                                        overviewVoteOffen,
                                                                        " Stimmen"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                    children: [
                                                                        $845661e1cd923dd3$var$formatShare(overviewVoteOffen, overviewVoteTotal),
                                                                        " %"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "reachability-total resolution-detail-vote-total-v2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Gesamt"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                            children: [
                                                                overviewVoteTotal,
                                                                " Stimmen"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                    className: "panel",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "object-overview-grid",
                        children: overviewKpiItems.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "kpi",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: item.label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        style: {
                                            fontSize: 18
                                        },
                                        children: item.value
                                    }),
                                    item.note ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginTop: 6,
                                            fontSize: 12,
                                            lineHeight: 1.35,
                                            color: "var(--text-soft)"
                                        },
                                        children: item.note
                                    }) : null
                                ]
                            }, item.label))
                    })
                }) : null,
                tab === "beschlusstext" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: isFrameworkV2 ? "panel resolution-detail-v2-content-card" : "panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                marginBottom: 18,
                                fontWeight: 700,
                                fontSize: "1.28em"
                            },
                            children: resolution.titel
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                marginBottom: 6,
                                fontWeight: 700
                            },
                            children: "Beschlussantrag:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                whiteSpace: "pre-wrap"
                            },
                            children: resolution.beschlusstext
                        })
                    ]
                }) : null,
                tab === "empfaenger" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "panel resolution-detail-v2-list-panel",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: 10,
                                        marginBottom: 8,
                                        flexWrap: "wrap"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            style: {
                                                margin: 0
                                            },
                                            children: "Zugangsdaten je Eigent\xfcmer"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: handleDownloadOwnerAccessCsv,
                                            children: "CSV exportieren"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                    className: isFrameworkV2 ? "resolutions-v2-filterbar resolution-detail-v2-filterbar" : "filterbar",
                                    style: isFrameworkV2 ? undefined : {
                                        marginBottom: 10
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: isFrameworkV2 ? "resolutions-v2-filter-fields" : undefined,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: isFrameworkV2 ? "resolutions-v2-filter-input resolution-detail-v2-filter-input" : undefined,
                                            children: [
                                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "resolutions-v2-filter-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableIcon, {
                                                        name: "search"
                                                    })
                                                }) : null,
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: isFrameworkV2 ? undefined : "table-field",
                                                    placeholder: "Suche...",
                                                    value: searchZugangsdaten,
                                                    onChange: (e)=>setSearchZugangsdaten(e.target.value),
                                                    style: isFrameworkV2 ? undefined : {
                                                        minWidth: 360
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                }),
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolutions-v2-row-count resolution-detail-v2-row-count",
                                    children: [
                                        "Treffer: ",
                                        filteredOwnerAccessRows.length,
                                        " / ",
                                        ownerAccessRows.length
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: isFrameworkV2 ? "resolutions-v2-table-wrap resolution-detail-v2-table-wrap" : undefined,
                                    style: isFrameworkV2 ? undefined : {
                                        overflowX: "auto"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: isFrameworkV2 ? "resolution-detail-v2-table resolution-detail-access-v2-table" : undefined,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "owner",
                                                                label: "Eigent\xfcmer ID"
                                                            }) : "Eigent\xfcmer ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "ownerName",
                                                                label: "Eigent\xfcmer"
                                                            }) : "Eigent\xfcmer"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "mail",
                                                                label: "E-Mail"
                                                            }) : "E-Mail"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "key",
                                                                label: "Zugangspasswort",
                                                                center: true
                                                            }) : "Zugangspasswort"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "link",
                                                                label: "Direktlink",
                                                                center: true
                                                            }) : "Direktlink"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "status",
                                                                label: "Passwort",
                                                                center: true
                                                            }) : "Passwort"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    filteredOwnerAccessRows.map((row)=>{
                                                        const directLink = `${window.location.origin}${row.direct_path}`;
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: row.eigentuemer_id
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: row.eigentuemername
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: row.email ?? "-"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: row.zugangspasswort ?? row.einmalpasswort
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: async ()=>{
                                                                            const copied = await $845661e1cd923dd3$var$copyTextToClipboard(directLink);
                                                                            if (copied) {
                                                                                setCopiedDirectLinkId(row.id);
                                                                                globalThis.setTimeout(()=>setCopiedDirectLinkId((prev)=>prev === row.id ? null : prev), 1400);
                                                                                return;
                                                                            }
                                                                            setActionError("Direktlink konnte nicht automatisch kopiert werden. Bitte manuell kopieren.");
                                                                        },
                                                                        title: directLink,
                                                                        children: copiedDirectLinkId === row.id ? "Kopiert" : "Link kopieren"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `badge ${row.status === "aktiv" ? "aktiv" : "inaktiv"}`,
                                                                        children: row.status === "aktiv" ? "unbenutzt" : row.status
                                                                    })
                                                                })
                                                            ]
                                                        }, row.id);
                                                    }),
                                                    !filteredOwnerAccessRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 6,
                                                            children: "Keine Zugangsdaten vorhanden."
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "panel resolution-detail-v2-list-panel",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    style: {
                                        margin: "0 0 8px 0"
                                    },
                                    children: "Abstimmungsberechtigte Einheiten"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                    className: isFrameworkV2 ? "resolutions-v2-filterbar resolution-detail-v2-filterbar" : "filterbar",
                                    style: isFrameworkV2 ? undefined : {
                                        marginBottom: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: isFrameworkV2 ? "resolutions-v2-filter-fields" : undefined,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: isFrameworkV2 ? "resolutions-v2-filter-input resolution-detail-v2-filter-input" : undefined,
                                                children: [
                                                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-filter-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableIcon, {
                                                            name: "search"
                                                        })
                                                    }) : null,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        className: isFrameworkV2 ? undefined : "table-field",
                                                        placeholder: "Suche...",
                                                        value: searchEmpfaenger,
                                                        onChange: (e)=>setSearchEmpfaenger(e.target.value),
                                                        style: isFrameworkV2 ? undefined : {
                                                            minWidth: 360
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: isFrameworkV2 ? "resolution-detail-v2-filter-actions" : undefined,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    style: {
                                                        alignSelf: "center",
                                                        color: "var(--text-soft)",
                                                        fontSize: 12
                                                    },
                                                    children: [
                                                        "Seite ",
                                                        empfaengerPage,
                                                        " / ",
                                                        empfaengerTotalPages
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setEmpfaengerPage((prev)=>Math.max(prev - 1, 1)),
                                                    disabled: empfaengerPage <= 1,
                                                    children: "Zur\xfcck"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setEmpfaengerPage((prev)=>Math.min(prev + 1, empfaengerTotalPages)),
                                                    disabled: empfaengerPage >= empfaengerTotalPages,
                                                    children: "Weiter"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolutions-v2-row-count resolution-detail-v2-row-count",
                                    children: [
                                        "Treffer gesamt: ",
                                        recipientMetaTotal
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: isFrameworkV2 ? "resolutions-v2-table-wrap resolution-detail-v2-table-wrap" : undefined,
                                    style: isFrameworkV2 ? {
                                        maxHeight: recipientViewportHeight
                                    } : {
                                        overflowX: "auto",
                                        maxHeight: recipientViewportHeight
                                    },
                                    onScroll: (event)=>setRecipientTableScrollTop(event.currentTarget.scrollTop),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: isFrameworkV2 ? "resolution-detail-v2-table resolution-detail-recipients-v2-table" : undefined,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "unit",
                                                                label: "Einheit",
                                                                center: true
                                                            }) : "Einheit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "pin",
                                                                label: "Lage"
                                                            }) : "Lage"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "home",
                                                                label: "Typ"
                                                            }) : "Typ"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "owner",
                                                                label: "Eigent\xfcmer ID",
                                                                center: true
                                                            }) : "Eigent\xfcmer ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "ownerName",
                                                                label: "Eigent\xfcmer"
                                                            }) : "Eigent\xfcmer"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "reachability",
                                                                label: "Erreichbarkeit",
                                                                center: true
                                                            }) : "Erreichbarkeit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "key",
                                                                label: "Stimmrecht",
                                                                center: true
                                                            }) : "Stimmrecht"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                icon: "text",
                                                                label: "MEA",
                                                                center: true
                                                            }) : "MEA"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    recipientTopSpacerHeight > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 8,
                                                            style: {
                                                                height: recipientTopSpacerHeight,
                                                                padding: 0,
                                                                border: 0
                                                            }
                                                        })
                                                    }) : null,
                                                    visibleRecipientRowsEmpfaenger.map((r)=>{
                                                        const reachabilityBadge = $845661e1cd923dd3$var$getReachabilityBadge(r.erreichbarkeit, r.temporaryAnalog);
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: $845661e1cd923dd3$var$formatUnitNumberForResult(r.einheitsnummer)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: r.lage
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: r.einheitstyp
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: r.eigentuemerId
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: r.eigentuemerName
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `badge ${reachabilityBadge.className}`,
                                                                        children: reachabilityBadge.label
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: r.stimmrecht
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: r.mea ?? "-"
                                                                })
                                                            ]
                                                        }, r.assignmentId);
                                                    }),
                                                    recipientBottomSpacerHeight > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 8,
                                                            style: {
                                                                height: recipientBottomSpacerHeight,
                                                                padding: 0,
                                                                border: 0
                                                            }
                                                        })
                                                    }) : null,
                                                    !filteredRecipientRowsEmpfaenger.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 8,
                                                            children: "Keine Empf\xe4nger gefunden."
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }) : null,
                tab === "stimmen" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            className: "panel",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "kpi-grid",
                                style: {
                                    marginBottom: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "kpi",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Digital erreichbar"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                children: [
                                                    digitalCount,
                                                    " (",
                                                    $845661e1cd923dd3$var$formatShare(digitalCount, recipientTotal),
                                                    " %)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "kpi",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Analog erreichbar"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                children: [
                                                    analogCount,
                                                    " (",
                                                    $845661e1cd923dd3$var$formatShare(analogCount, recipientTotal),
                                                    " %)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "kpi",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Stimmen eingegangen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: filteredRecipientRowsStimmen.filter((r)=>r.voteValue !== "offen").length
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "kpi",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Ausstehende Abstimmungen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: filteredRecipientRowsStimmen.filter((r)=>r.voteValue === "offen").length
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: isFrameworkV2 ? "panel resolution-detail-v2-list-panel" : "panel",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                    className: isFrameworkV2 ? "resolutions-v2-filterbar resolution-detail-v2-filterbar" : "filterbar",
                                    style: isFrameworkV2 ? undefined : {
                                        marginBottom: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: isFrameworkV2 ? "resolutions-v2-filter-fields" : undefined,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: isFrameworkV2 ? "resolutions-v2-filter-input resolution-detail-v2-filter-input" : undefined,
                                                    children: [
                                                        isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "resolutions-v2-filter-icon",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableIcon, {
                                                                name: "search"
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: isFrameworkV2 ? undefined : "table-field",
                                                            placeholder: "Suche...",
                                                            value: searchStimmen,
                                                            onChange: (e)=>setSearchStimmen(e.target.value),
                                                            style: isFrameworkV2 ? undefined : {
                                                                minWidth: 320
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    className: isFrameworkV2 ? undefined : "table-field",
                                                    value: filterStimmenErreichbarkeit,
                                                    onChange: (e)=>setFilterStimmenErreichbarkeit(e.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "alle",
                                                            children: "Erreichbarkeit: Alle"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "digital",
                                                            children: "Erreichbarkeit: digital"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "analog",
                                                            children: "Erreichbarkeit: analog"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    className: isFrameworkV2 ? undefined : "table-field",
                                                    value: filterStimmenverhalten,
                                                    onChange: (e)=>setFilterStimmenverhalten(e.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "alle",
                                                            children: "Stimmverhalten: Alle"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "offen",
                                                            children: "Stimmverhalten: Offen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "ja",
                                                            children: "Stimmverhalten: Ja"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "nein",
                                                            children: "Stimmverhalten: Nein"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "enthaltung",
                                                            children: "Stimmverhalten: Enthaltung"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: isFrameworkV2 ? "resolution-detail-v2-filter-actions" : undefined,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    style: {
                                                        alignSelf: "center",
                                                        color: "var(--text-soft)",
                                                        fontSize: 12
                                                    },
                                                    children: [
                                                        "Seite ",
                                                        stimmenPage,
                                                        " / ",
                                                        stimmenTotalPages
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setStimmenPage((prev)=>Math.max(prev - 1, 1)),
                                                    disabled: stimmenPage <= 1,
                                                    children: "Zur\xfcck"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setStimmenPage((prev)=>Math.min(prev + 1, stimmenTotalPages)),
                                                    disabled: stimmenPage >= stimmenTotalPages,
                                                    children: "Weiter"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolutions-v2-row-count resolution-detail-v2-row-count",
                                    children: [
                                        "Treffer gesamt: ",
                                        recipientMetaTotal
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        marginBottom: 8,
                                        color: "var(--text-soft)",
                                        fontSize: 12
                                    },
                                    children: "Eine Stimmabgabe gilt immer einheitlich f\xfcr alle stimmberechtigten Einheiten desselben Eigent\xfcmers."
                                }),
                                !canCaptureVotes ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "error-text",
                                    style: {
                                        marginBottom: 8
                                    },
                                    children: "Stimmen k\xf6nnen erst ab Start des Beschlusses erfasst werden."
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: isFrameworkV2 ? "resolutions-v2-table-wrap resolution-detail-v2-table-wrap" : undefined,
                                    style: isFrameworkV2 ? {
                                        maxHeight: voteViewportHeight
                                    } : {
                                        overflowX: "auto",
                                        maxHeight: voteViewportHeight
                                    },
                                    onScroll: (event)=>setVoteTableScrollTop(event.currentTarget.scrollTop),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: isFrameworkV2 ? "resolution-detail-v2-table resolution-detail-votes-v2-table" : undefined,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Einheit",
                                                                icon: "unit",
                                                                center: true
                                                            }) : "Einheit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Eigent\xfcmer",
                                                                icon: "ownerName"
                                                            }) : "Eigent\xfcmer"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Erreichbarkeit",
                                                                icon: "reachability",
                                                                center: true
                                                            }) : "Erreichbarkeit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Stimmverhalten",
                                                                icon: "status",
                                                                center: true
                                                            }) : "Stimmverhalten"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Letzte \xc4nderung am",
                                                                icon: "date",
                                                                center: true
                                                            }) : "Letzte \xc4nderung am"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Stimmabgabe",
                                                                icon: "vote",
                                                                center: true
                                                            }) : "Stimmabgabe"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Kommentar",
                                                                icon: "comment"
                                                            }) : "Kommentar"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: isFrameworkV2 ? "resolutions-v2-actions-head" : undefined,
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Aktion",
                                                                icon: "action",
                                                                center: true
                                                            }) : "Aktion"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    voteTopSpacerHeight > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 8,
                                                            style: {
                                                                height: voteTopSpacerHeight,
                                                                padding: 0,
                                                                border: 0
                                                            }
                                                        })
                                                    }) : null,
                                                    visibleRecipientRowsStimmen.map((r)=>{
                                                        const selectedVote = draftVotes[r.assignmentId] ?? r.voteValue;
                                                        const selectedComment = draftComments[r.assignmentId] ?? r.comment ?? "";
                                                        const hasExistingVote = !!r.voteReceivedAt || r.voteValue !== "offen";
                                                        const reachabilityBadge = $845661e1cd923dd3$var$getReachabilityBadge(r.erreichbarkeit, r.temporaryAnalog);
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: $845661e1cd923dd3$var$formatUnitNumberForResult(r.einheitsnummer)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: r.eigentuemerName
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `badge ${reachabilityBadge.className}`,
                                                                        children: reachabilityBadge.label
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `badge ${r.voteValue === "ja" ? "vote-ja" : r.voteValue === "nein" ? "vote-nein" : r.voteValue === "enthaltung" ? "vote-enthaltung" : "vote-offen"}`,
                                                                        children: $845661e1cd923dd3$var$formatVoteValue(r.voteValue)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: $845661e1cd923dd3$var$formatDateTimeDE(r.voteReceivedAt)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "vote-choice-group",
                                                                        role: "group",
                                                                        "aria-label": "Stimmabgabe ausw\xe4hlen",
                                                                        style: {
                                                                            justifyContent: "center"
                                                                        },
                                                                        children: [
                                                                            "ja",
                                                                            "nein",
                                                                            "enthaltung"
                                                                        ].map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                className: `vote-choice-btn ${selectedVote === value ? "is-active" : ""} vote-choice-${value}`,
                                                                                disabled: !canCaptureVotes,
                                                                                onClick: ()=>setDraftVotes((old)=>({
                                                                                            ...old,
                                                                                            [r.assignmentId]: value
                                                                                        })),
                                                                                children: value === "enthaltung" ? "Enth." : $845661e1cd923dd3$var$formatVoteValue(value)
                                                                            }, value))
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        minWidth: 240,
                                                                        maxWidth: 320
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        className: "table-field",
                                                                        placeholder: "Kommentar",
                                                                        value: selectedComment,
                                                                        onChange: (e)=>setDraftComments((old)=>({
                                                                                    ...old,
                                                                                    [r.assignmentId]: e.target.value
                                                                                })),
                                                                        disabled: !canCaptureVotes,
                                                                        style: {
                                                                            width: "100%"
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "resolutions-v2-action-wrap",
                                                                        onClick: (e)=>e.stopPropagation(),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                className: "resolutions-v2-action-trigger",
                                                                                onClick: (e)=>{
                                                                                    e.stopPropagation();
                                                                                    if (voteOpenActionMenuId === r.assignmentId) {
                                                                                        setVoteOpenActionMenuId(null);
                                                                                        return;
                                                                                    }
                                                                                    openFloatingActionMenu(r.assignmentId, e.currentTarget, setVoteOpenActionMenuId, 58);
                                                                                },
                                                                                "aria-label": "Aktionen \xf6ffnen",
                                                                                "aria-expanded": voteOpenActionMenuId === r.assignmentId,
                                                                                children: "\u22EE"
                                                                            }),
                                                                            voteOpenActionMenuId === r.assignmentId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                                style: {
                                                                                    left: actionMenuPosition.left,
                                                                                    top: actionMenuPosition.top
                                                                                },
                                                                                onMouseEnter: ()=>setIsVoteActionMenuHovered(true),
                                                                                onMouseLeave: ()=>setIsVoteActionMenuHovered(false),
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                    type: "button",
                                                                                    disabled: !canCaptureVotes || voteMutation.isPending || selectedVote === "offen",
                                                                                    onClick: ()=>{
                                                                                        const payload = {
                                                                                            assignmentId: r.assignmentId,
                                                                                            voteValue: selectedVote,
                                                                                            comment: selectedComment.trim() ? selectedComment.trim() : undefined
                                                                                        };
                                                                                        if (!hasExistingVote) {
                                                                                            voteMutation.mutate(payload);
                                                                                            setVoteOpenActionMenuId(null);
                                                                                            return;
                                                                                        }
                                                                                        setVoteChangeConfirm({
                                                                                            assignmentId: payload.assignmentId,
                                                                                            eigentuemerLabel: r.eigentuemerName,
                                                                                            code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                            input: [
                                                                                                "",
                                                                                                "",
                                                                                                "",
                                                                                                ""
                                                                                            ],
                                                                                            error: "",
                                                                                            voteValue: payload.voteValue,
                                                                                            comment: payload.comment
                                                                                        });
                                                                                        setVoteOpenActionMenuId(null);
                                                                                    },
                                                                                    children: hasExistingVote ? "\xc4ndern" : "Speichern"
                                                                                })
                                                                            }), document.body) : null
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        className: hasExistingVote ? "vote-action-btn vote-change-btn" : "vote-action-btn vote-save-btn",
                                                                        disabled: !canCaptureVotes || voteMutation.isPending || selectedVote === "offen",
                                                                        onClick: ()=>{
                                                                            const payload = {
                                                                                assignmentId: r.assignmentId,
                                                                                voteValue: selectedVote,
                                                                                comment: selectedComment.trim() ? selectedComment.trim() : undefined
                                                                            };
                                                                            if (!hasExistingVote) {
                                                                                voteMutation.mutate(payload);
                                                                                return;
                                                                            }
                                                                            setVoteChangeConfirm({
                                                                                assignmentId: payload.assignmentId,
                                                                                eigentuemerLabel: r.eigentuemerName,
                                                                                code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                input: [
                                                                                    "",
                                                                                    "",
                                                                                    "",
                                                                                    ""
                                                                                ],
                                                                                error: "",
                                                                                voteValue: payload.voteValue,
                                                                                comment: payload.comment
                                                                            });
                                                                        },
                                                                        children: hasExistingVote ? "\xc4ndern" : "Speichern"
                                                                    })
                                                                })
                                                            ]
                                                        }, r.assignmentId);
                                                    }),
                                                    voteBottomSpacerHeight > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 8,
                                                            style: {
                                                                height: voteBottomSpacerHeight,
                                                                padding: 0,
                                                                border: 0
                                                            }
                                                        })
                                                    }) : null,
                                                    !filteredRecipientRowsStimmen.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 8,
                                                            children: "Keine Eintr\xe4ge gefunden."
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }) : null,
                tab === "versand" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e00dfe72bf271e0b$export$4be421681837eb26), {
                            resolutionId: id,
                            hasDigitalRecipients: digitalCount > 0,
                            hasAnalogRecipients: analogCount > 0,
                            digitalRecipientCount: digitalCount,
                            analogRecipientCount: analogCount
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "panel",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    style: {
                                        marginTop: 0
                                    },
                                    children: "Trigger-Protokoll (mit Zustellnachweis)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: isFrameworkV2 ? "resolution-detail-v2-table-wrap" : undefined,
                                    style: isFrameworkV2 ? {
                                        maxHeight: 360
                                    } : {
                                        overflowX: "auto",
                                        maxHeight: 360
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: isFrameworkV2 ? "resolution-detail-v2-table resolution-detail-shipping-v2-table resolution-detail-shipping-trigger-log-v2-table" : undefined,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Zeit",
                                                                icon: "date"
                                                            }) : "Zeit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Trigger",
                                                                icon: "status"
                                                            }) : "Trigger"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Kanal",
                                                                icon: "mail",
                                                                center: true
                                                            }) : "Kanal"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Status",
                                                                icon: "status"
                                                            }) : "Status"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "HTTP",
                                                                icon: "key",
                                                                center: true
                                                            }) : "HTTP"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Endpoint",
                                                                icon: "link",
                                                                center: true
                                                            }) : "Endpoint"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Versuche",
                                                                icon: "key",
                                                                center: true
                                                            }) : "Versuche"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Nachricht",
                                                                icon: "comment"
                                                            }) : "Nachricht"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    triggerNotificationLogRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: $845661e1cd923dd3$var$formatDateTimeDE(row.deliveredAt || row.updatedAt || row.createdAt)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: $845661e1cd923dd3$var$formatTriggerEventType(row.eventType)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "badge erreichbar-digital",
                                                                        children: $845661e1cd923dd3$var$formatTriggerChannel(row.channel)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `badge ${row.status === "sent" ? "aktiv" : row.status === "failed" ? "inaktiv" : "neutral"}`,
                                                                        children: $845661e1cd923dd3$var$formatTriggerDeliveryStatus(row.status)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: typeof row.deliveryHttpStatus === "number" ? row.deliveryHttpStatus : row.status === "sent" && row.channel === "facilioo" ? "ohne Nachweis" : "-"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                                                        children: row.deliveryEndpoint || "-"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: [
                                                                        row.attempts,
                                                                        " / ",
                                                                        row.maxAttempts
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: row.lastError || row.messageId || "-"
                                                                })
                                                            ]
                                                        }, `trigger-log-${row.id}`)),
                                                    !triggerNotificationLogRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 8,
                                                            children: "Keine Trigger-Eintr\xe4ge vorhanden."
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            className: "panel",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: isFrameworkV2 ? "resolution-detail-v2-table-wrap" : undefined,
                                style: isFrameworkV2 ? undefined : {
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: isFrameworkV2 ? "resolution-detail-v2-table resolution-detail-shipping-v2-table resolution-detail-shipping-status-v2-table" : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Versandstatus",
                                                            icon: "status"
                                                        }) : "Versandstatus"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Status",
                                                            icon: "status",
                                                            center: true
                                                        }) : "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Versendet am",
                                                            icon: "date",
                                                            center: true
                                                        }) : "Versendet am"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Vorgemerkter Termin",
                                                            icon: "date",
                                                            center: true
                                                        }) : "Vorgemerkter Termin"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                            label: "Dokumente (ZIP)",
                                                            icon: "document",
                                                            center: true
                                                        }) : "Dokumente (ZIP)"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: dispatchRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: row.label
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `badge ${$845661e1cd923dd3$var$getDispatchUiStatusBadgeClass(row.status)}`,
                                                                children: $845661e1cd923dd3$var$formatDispatchUiStatus(row.status)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: $845661e1cd923dd3$var$formatDateTimeDE(row.timestamp)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: $845661e1cd923dd3$var$formatDateDE(row.plannedDate)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>void handleDownloadDispatchZip(row.eventType),
                                                                disabled: row.generatedPdfCount <= 0,
                                                                title: row.generatedPdfCount > 0 ? `ZIP herunterladen (${row.generatedPdfCount} PDF)` : "Keine erzeugten PDF-Dokumente f\xfcr diesen Versandtyp vorhanden",
                                                                children: "ZIP laden"
                                                            })
                                                        })
                                                    ]
                                                }, row.eventType))
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "panel",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                    className: isFrameworkV2 ? "resolutions-v2-filterbar resolution-detail-v2-filterbar" : "filterbar",
                                    style: isFrameworkV2 ? undefined : {
                                        marginBottom: 10
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: isFrameworkV2 ? "resolutions-v2-filter-fields" : undefined,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: isFrameworkV2 ? "resolutions-v2-filter-input resolution-detail-v2-filter-input" : undefined,
                                            children: [
                                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "resolutions-v2-filter-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableIcon, {
                                                        name: "search"
                                                    })
                                                }) : null,
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: isFrameworkV2 ? undefined : "table-field",
                                                    placeholder: "Suche...",
                                                    value: searchVersand,
                                                    onChange: (e)=>setSearchVersand(e.target.value),
                                                    style: isFrameworkV2 ? undefined : {
                                                        minWidth: 360
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                }),
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "resolutions-v2-row-count resolution-detail-v2-row-count",
                                    "aria-hidden": "true",
                                    children: "\u00a0"
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: isFrameworkV2 ? "resolution-detail-v2-table-wrap" : undefined,
                                    style: isFrameworkV2 ? {
                                        maxHeight: 460
                                    } : {
                                        overflowX: "auto",
                                        maxHeight: 460
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: isFrameworkV2 ? "resolution-detail-v2-table resolution-detail-shipping-v2-table resolution-detail-shipping-recipients-v2-table" : undefined,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Empf\xe4nger",
                                                                icon: "ownerName"
                                                            }) : "Empf\xe4nger"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Einheit",
                                                                icon: "unit",
                                                                center: true
                                                            }) : "Einheit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Erreichbarkeit",
                                                                icon: "reachability",
                                                                center: true
                                                            }) : "Erreichbarkeit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Einladung",
                                                                icon: "mail",
                                                                center: true
                                                            }) : "Einladung"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Erinnerung 1",
                                                                icon: "mail",
                                                                center: true
                                                            }) : "Erinnerung 1"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Erinnerung 2",
                                                                icon: "mail",
                                                                center: true
                                                            }) : "Erinnerung 2"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Ergebnisversand",
                                                                icon: "mail",
                                                                center: true
                                                            }) : "Ergebnisversand"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    versandEmpfaengerRows.map((r)=>{
                                                        const reachabilityBadge = $845661e1cd923dd3$var$getReachabilityBadge(r.erreichbarkeit, r.temporaryAnalog);
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: r.eigentuemerName
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: r.einheitenLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `badge ${reachabilityBadge.className}`,
                                                                        children: reachabilityBadge.label
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: renderDispatchBadge("einladung_versendet", r.erreichbarkeit, r.eigentuemerId)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: renderDispatchBadge("erinnerung_1_versendet", r.erreichbarkeit, r.eigentuemerId)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: renderDispatchBadge("erinnerung_2_versendet", r.erreichbarkeit, r.eigentuemerId)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: renderDispatchBadge("beschlussergebnis_versendet", r.erreichbarkeit, r.eigentuemerId)
                                                                })
                                                            ]
                                                        }, `versand-${r.eigentuemerId}`);
                                                    }),
                                                    !versandEmpfaengerRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 7,
                                                            children: "Keine Eintr\xe4ge gefunden."
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }) : null,
                tab === "ergebnis" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "result-top-layout",
                            style: {
                                marginBottom: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                    className: "panel-inset result-chart-box",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "result-chart-header",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: openVoteLogModal,
                                                children: "Logdatei \xf6ffnen"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$VoteDonutChart, {
                                            ja: Number(resultQuery.data?.stimmen.ja ?? 0),
                                            nein: Number(resultQuery.data?.stimmen.nein ?? 0),
                                            enthaltung: Number(resultQuery.data?.stimmen.enthaltung ?? 0)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                    className: "result-kpi-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "kpi object-overview-kpi-v2 result-kpi-card-v2 result-kpi-card-v2--return-bar",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "object-overview-kpi-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ReturnRateIcon, {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "object-overview-kpi-copy result-return-kpi-copy-v2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "R\xfccklaufquote"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "result-return-kpi-body-v2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "result-return-kpi-track-v2",
                                                                    style: resultReturnBarStyle,
                                                                    "aria-hidden": "true",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "result-return-kpi-segment-v2 result-return-kpi-segment-v2--submitted"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "result-return-kpi-segment-v2 result-return-kpi-segment-v2--open"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "result-return-kpi-legend-v2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--green",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "dot dot-digital"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                    children: "Abgegeben"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                                    children: [
                                                                                        resultReturnSubmitted,
                                                                                        " Stimmen"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                                    children: [
                                                                                        $845661e1cd923dd3$var$formatShare(resultReturnSubmitted, resultReturnTotal),
                                                                                        " %"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "reachability-line resolution-detail-legend-line resolution-detail-legend-line--neutral",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "dot dot-neutral"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                    children: "Offen"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                                    children: [
                                                                                        resultReturnOpen,
                                                                                        " Stimmen"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                                                                    children: [
                                                                                        $845661e1cd923dd3$var$formatShare(resultReturnOpen, resultReturnTotal),
                                                                                        " %"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "reachability-total result-return-kpi-total-v2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "Gesamt"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                                    children: [
                                                                                        resultReturnTotal,
                                                                                        " Stimmen"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: `kpi object-overview-kpi-v2 result-kpi-card-v2 result-kpi-card-v2--quorum result-kpi-card-v2--quorum-${resultQuorumFulfilled ? "ok" : "fail"}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "result-kpi-quorum-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$QuorumOutcomeIcon, {
                                                        fulfilled: resultQuorumFulfilled
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "object-overview-kpi-copy",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Quorum erf\xfcllt"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: resultQuorumFulfilled ? "Ja" : "Nein"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: `kpi object-overview-kpi-v2 result-kpi-card-v2 result-kpi-card-v2--compact result-kpi-card-v2--outcome result-kpi-card-v2--${resultKpiTone}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "result-kpi-outcome-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResultOutcomeIcon, {
                                                        rejected: resultKpiTone === "fail"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "object-overview-kpi-copy",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: resultKpiTitle
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: resultKpiValue
                                                        }),
                                                        showResultBreakEvenNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            className: "result-kpi-note-v2",
                                                            children: "Aus den offenen Stimmen kann sich keine Ver\xe4nderung des Gesamtergebnisses mehr ergeben."
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                    className: "result-kpi-calculation-note-v2",
                                                    children: [
                                                        "Berechnung auf Basis der Stimmrechtsart ",
                                                        $845661e1cd923dd3$var$formatStimmrechtsart(resolution.stimmrechtsart),
                                                        " und Quorum ",
                                                        $845661e1cd923dd3$var$formatQuorum(resolution.quorum),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "panel result-votes-launch-panel",
                            style: {
                                marginBottom: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "result-votes-launch-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: "Einzelstimmen"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                recipientRows.length,
                                                " stimmberechtigte Einheiten. Die Liste wird im Overlayfenster ge\xf6ffnet."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: isFrameworkV2 ? "resolution-detail-v2-secondary-btn" : undefined,
                                    onClick: ()=>setIsResultVotesModalOpen(true),
                                    children: "Einzelstimmen \xf6ffnen"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            className: "panel-inset result-visibility-card v2-info-banner",
                            style: {
                                marginBottom: 10
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "result-visibility-header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "result-visibility-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "result-visibility-title",
                                                children: "Anzeige Einzelstimmabgabe"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "result-visibility-text",
                                                children: "Aktiv: Auf der Eigent\xfcmer-Ergebnisseite wird die Liste mit Einzelstimmen angezeigt. Aus: Es wird nur das Gesamtergebnis angezeigt."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "result-visibility-switch",
                                        "aria-label": "Einzelstimmabgabe auf Eigent\xfcmer-Ergebnisseite anzeigen",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "result-visibility-input",
                                                type: "checkbox",
                                                checked: ownerEinzelstimmabgabeSichtbar,
                                                disabled: ownerResultVisibilityMutation.isPending,
                                                onChange: async (e)=>{
                                                    const next = e.target.checked;
                                                    setOwnerEinzelstimmabgabeSichtbar(next);
                                                    await ownerResultVisibilityMutation.mutateAsync(next);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `result-visibility-track ${ownerEinzelstimmabgabeSichtbar ? "is-on" : ""}`,
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "result-visibility-thumb"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `badge ${ownerEinzelstimmabgabeSichtbar ? "aktiv" : "ergebnis-neutral"}`,
                                                children: ownerEinzelstimmabgabeSichtbar ? "Sichtbar" : "Ausgeblendet"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }) : null,
                tab === "dokumente" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "panel",
                    style: {
                        display: "grid",
                        gap: 12
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "panel",
                            style: {
                                margin: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `resolution-document-dropzone${documentDropActive ? " is-drag-over" : ""}`,
                                    onDragOver: (e)=>{
                                        e.preventDefault();
                                        e.dataTransfer.dropEffect = "copy";
                                        setDocumentDropActive(true);
                                    },
                                    onDragLeave: (e)=>{
                                        e.preventDefault();
                                        setDocumentDropActive(false);
                                    },
                                    onDrop: onDocumentDrop,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            ref: documentInputRef,
                                            type: "file",
                                            multiple: true,
                                            accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png",
                                            style: {
                                                display: "none"
                                            },
                                            onChange: (e)=>mergeDocumentFiles(Array.from(e.target.files ?? []), true)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "resolution-document-dropzone-text",
                                            children: "Dateien hier hineinziehen oder \xfcber den Button ausw\xe4hlen."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        gap: 10,
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        marginTop: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>documentInputRef.current?.click(),
                                            disabled: documentUploadMutation.isPending,
                                            children: "Dateien ausw\xe4hlen"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>documentUploadMutation.mutate(),
                                            disabled: !documentFiles.length || documentUploadMutation.isPending,
                                            children: documentUploadMutation.isPending ? "Lade hoch..." : "Dokumente hochladen"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setSelectedDocumentIds(documentRows.map((doc)=>doc.id)),
                                            disabled: !documentRows.length || uploadDocumentsToFaciliooMutation.isPending,
                                            children: "Alle markieren"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setSelectedDocumentIds([]),
                                            disabled: !selectedDocumentIds.length || uploadDocumentsToFaciliooMutation.isPending,
                                            children: "Alle demarkieren"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>uploadDocumentsToFaciliooMutation.mutate(),
                                            disabled: !resolution?.facilioo_vorgangsnummer || !selectedDocumentIds.length || uploadDocumentsToFaciliooMutation.isPending,
                                            children: uploadDocumentsToFaciliooMutation.isPending ? "\xdcbertrage..." : "Markierte zu Facilioo \xfcbertragen"
                                        }),
                                        documentFiles.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                color: "var(--text-soft)",
                                                fontSize: 12
                                            },
                                            children: `${documentFiles.length} neue lokale Datei(en) zum Hochladen ausgew\xe4hlt`
                                        }) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                color: "var(--text-soft)",
                                                fontSize: 12
                                            },
                                            children: selectedDocumentIds.length ? `${selectedDocumentIds.length} Dokument(e) f\xfcr Facilioo markiert` : `${documentRows.length} Dokument(e) in der Liste`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        marginTop: 6,
                                        color: "var(--text-soft)",
                                        fontSize: 12
                                    },
                                    children: "Erlaubte Formate: PDF, DOC, DOCX, XLS, XLSX, JPG, JPEG, PNG. Maximal 20 Dateien pro Upload, maximal 20 MB je Datei."
                                }),
                                !resolution?.facilioo_vorgangsnummer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        marginTop: 6,
                                        color: "var(--text-soft)",
                                        fontSize: 12
                                    },
                                    children: "F\xfcr die \xdcbertragung zu Facilioo muss am Beschluss eine Facilioo Vorgangsnummer hinterlegt sein."
                                }) : null,
                                documentInfo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        marginTop: 8,
                                        color: "var(--text-soft)",
                                        fontSize: 12
                                    },
                                    children: documentInfo
                                }) : null,
                                documentError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "error-text",
                                    style: {
                                        marginTop: 8
                                    },
                                    children: documentError
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: isFrameworkV2 ? "panel resolution-detail-v2-list-panel resolution-detail-documents-v2-panel" : "panel",
                            style: isFrameworkV2 ? undefined : {
                                margin: 0
                            },
                            children: [
                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "resolutions-v2-row-count resolution-detail-v2-row-count",
                                    children: [
                                        "Dokumente: ",
                                        filteredDocumentRows.length,
                                        filteredDocumentRows.length !== documentRows.length ? ` / ${documentRows.length}` : ""
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                    className: isFrameworkV2 ? "resolutions-v2-filterbar resolution-detail-v2-filterbar" : "filterbar",
                                    style: isFrameworkV2 ? undefined : {
                                        marginBottom: 10
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: isFrameworkV2 ? "resolutions-v2-filter-fields" : undefined,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: isFrameworkV2 ? "resolutions-v2-filter-input resolution-detail-v2-filter-input" : undefined,
                                            children: [
                                                isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "resolutions-v2-filter-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableIcon, {
                                                        name: "search"
                                                    })
                                                }) : null,
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: isFrameworkV2 ? undefined : "table-field",
                                                    placeholder: "Suche...",
                                                    value: searchDokumente,
                                                    onChange: (e)=>setSearchDokumente(e.target.value),
                                                    style: isFrameworkV2 ? undefined : {
                                                        minWidth: 320
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: isFrameworkV2 ? "resolution-detail-v2-table-wrap" : undefined,
                                    style: isFrameworkV2 ? undefined : {
                                        overflowX: "auto"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: isFrameworkV2 ? "resolution-detail-v2-table resolution-detail-documents-v2-table" : undefined,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                width: 78,
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Aktiv",
                                                                icon: "select",
                                                                center: true
                                                            }) : "Aktiv"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Dateiname",
                                                                icon: "document"
                                                            }) : "Dateiname"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Gr\xf6\xdfe",
                                                                icon: "size",
                                                                center: true
                                                            }) : "Gr\xf6\xdfe"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Hochgeladen am",
                                                                icon: "date",
                                                                center: true
                                                            }) : "Hochgeladen am"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "Hochgeladen von",
                                                                icon: "owner"
                                                            }) : "Hochgeladen von"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            "aria-label": "Aktion",
                                                            children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                label: "",
                                                                icon: "action",
                                                                center: true
                                                            }) : "Aktion"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    filteredDocumentRows.map((doc)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: selectedDocumentIds.includes(doc.id),
                                                                        onChange: (e)=>setSelectedDocumentIds((prev)=>e.target.checked ? Array.from(new Set([
                                                                                    ...prev,
                                                                                    doc.id
                                                                                ])) : prev.filter((id)=>id !== doc.id))
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: doc.originalName
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: [
                                                                        (doc.size / 1024).toFixed(1),
                                                                        " KB"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: $845661e1cd923dd3$var$formatDateTimeDE(doc.uploadedAt)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: doc.uploadedByName
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    style: isFrameworkV2 ? {
                                                                        textAlign: "center"
                                                                    } : {
                                                                        textAlign: "center",
                                                                        display: "flex",
                                                                        gap: 8,
                                                                        justifyContent: "center"
                                                                    },
                                                                    children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "resolutions-v2-action-wrap",
                                                                        onClick: (e)=>e.stopPropagation(),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                className: "resolutions-v2-action-trigger",
                                                                                onClick: (e)=>{
                                                                                    e.stopPropagation();
                                                                                    if (documentOpenActionMenuId === doc.id) {
                                                                                        setDocumentOpenActionMenuId(null);
                                                                                        return;
                                                                                    }
                                                                                    openFloatingActionMenu(doc.id, e.currentTarget, setDocumentOpenActionMenuId, canManageMasterDataActions ? 96 : 52);
                                                                                },
                                                                                "aria-label": "Aktionen \xf6ffnen",
                                                                                "aria-expanded": documentOpenActionMenuId === doc.id,
                                                                                children: "\u22EE"
                                                                            }),
                                                                            documentOpenActionMenuId === doc.id && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                                style: {
                                                                                    left: actionMenuPosition.left,
                                                                                    top: actionMenuPosition.top
                                                                                },
                                                                                onMouseEnter: ()=>setIsDocumentActionMenuHovered(true),
                                                                                onMouseLeave: ()=>setIsDocumentActionMenuHovered(false),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                        type: "button",
                                                                                        onClick: ()=>{
                                                                                            setPreviewDocument(doc);
                                                                                            setDocumentOpenActionMenuId(null);
                                                                                        },
                                                                                        children: "\xd6ffnen"
                                                                                    }),
                                                                                    canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                        type: "button",
                                                                                        disabled: documentDeleteMutation.isPending,
                                                                                        onClick: ()=>{
                                                                                            setDocumentDeleteConfirm({
                                                                                                documentId: doc.id,
                                                                                                documentName: doc.originalName,
                                                                                                code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                                input: [
                                                                                                    "",
                                                                                                    "",
                                                                                                    "",
                                                                                                    ""
                                                                                                ],
                                                                                                error: ""
                                                                                            });
                                                                                            setDocumentOpenActionMenuId(null);
                                                                                        },
                                                                                        children: "L\xf6schen"
                                                                                    }) : null
                                                                                ]
                                                                            }), document.body) : null
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                onClick: ()=>setPreviewDocument(doc),
                                                                                children: "\xd6ffnen"
                                                                            }),
                                                                            canManageMasterDataActions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                disabled: documentDeleteMutation.isPending,
                                                                                onClick: ()=>{
                                                                                    setDocumentDeleteConfirm({
                                                                                        documentId: doc.id,
                                                                                        documentName: doc.originalName,
                                                                                        code: String(Math.floor(1000 + Math.random() * 9000)),
                                                                                        input: [
                                                                                            "",
                                                                                            "",
                                                                                            "",
                                                                                            ""
                                                                                        ],
                                                                                        error: ""
                                                                                    });
                                                                                },
                                                                                children: "L\xf6schen"
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }, doc.id)),
                                                    !filteredDocumentRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            colSpan: 6,
                                                            children: documentRows.length ? "Keine Dokumente gefunden." : "F\xfcr diesen Umlaufbeschluss sind aktuell keine Dokumente hinterlegt."
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        previewDocument ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "modal-backdrop",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "panel modal-card",
                                style: {
                                    width: "min(1400px, 98vw)",
                                    maxWidth: 1400,
                                    maxHeight: "94vh",
                                    overflow: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        style: {
                                            marginTop: 0,
                                            marginBottom: 8
                                        },
                                        children: previewDocument.originalName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginBottom: 10
                                        },
                                        children: $845661e1cd923dd3$var$isPreviewableDocument(previewDocument) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                            title: previewDocument.originalName,
                                            src: previewDocument.fileUrl,
                                            style: {
                                                width: "100%",
                                                height: "80vh",
                                                border: "1px solid var(--line)",
                                                borderRadius: 6
                                            }
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                color: "var(--text-soft)"
                                            },
                                            children: "F\xfcr diesen Dateityp ist keine Browser-Vorschau verf\xfcgbar."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-actions",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: previewDocument.fileUrl,
                                                download: previewDocument.originalName,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    children: "Download"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setPreviewDocument(null),
                                                children: "Schlie\xdfen"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : null
                    ]
                }) : null,
                tab === "facilioo_dokumente" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                    className: "panel",
                    style: {
                        display: "grid",
                        gap: 12
                    },
                    children: !resolution?.facilioo_vorgangsnummer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            color: "var(--text-soft)"
                        },
                        children: "F\xfcr diesen Umlaufbeschluss ist keine Facilioo Vorgangsnummer hinterlegt."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "panel",
                                style: {
                                    margin: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 8,
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setSelectedFaciliooAttachmentKeys(faciliooAttachmentRows.map((row)=>`${row.feedId}:${row.attachmentId}`)),
                                                disabled: !faciliooAttachmentRows.length || importFaciliooAttachmentsMutation.isPending,
                                                children: "Alle markieren"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setSelectedFaciliooAttachmentKeys([]),
                                                disabled: !selectedFaciliooAttachmentKeys.length || importFaciliooAttachmentsMutation.isPending,
                                                children: "Alle demarkieren"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>importFaciliooAttachmentsMutation.mutate("selected"),
                                                disabled: !selectedFaciliooAttachmentKeys.length || importFaciliooAttachmentsMutation.isPending,
                                                children: importFaciliooAttachmentsMutation.isPending ? "Importiere..." : "Ausgew\xe4hlte importieren"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>importFaciliooAttachmentsMutation.mutate("all"),
                                                disabled: !faciliooAttachmentRows.length || importFaciliooAttachmentsMutation.isPending,
                                                children: importFaciliooAttachmentsMutation.isPending ? "Lade neu..." : "Alle neu aus Facilioo laden"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                style: {
                                                    color: "var(--text-soft)",
                                                    fontSize: 12
                                                },
                                                children: [
                                                    selectedFaciliooAttachmentKeys.length,
                                                    " ausgew\xe4hlt"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setShowFileTypesDebug((prev)=>!prev),
                                                disabled: importFaciliooAttachmentsMutation.isPending,
                                                children: showFileTypesDebug ? "File-Typen Debug ausblenden" : "File-Typen Debug anzeigen"
                                            })
                                        ]
                                    }),
                                    faciliooDocumentError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "error-text",
                                        style: {
                                            marginTop: 8
                                        },
                                        children: faciliooDocumentError
                                    }) : null
                                ]
                            }),
                            showFileTypesDebug ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "panel",
                                style: {
                                    margin: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        style: {
                                            marginTop: 0,
                                            marginBottom: 8
                                        },
                                        children: "Debug: Facilioo File-Typen"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            color: "var(--text-soft)",
                                            fontSize: 12,
                                            marginBottom: 8
                                        },
                                        children: [
                                            "Gesamt: ",
                                            faciliooFileTypesDebugQuery.data?.total ?? 0
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            overflowX: "auto",
                                            maxHeight: 320
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: "ID"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: "Endung"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: "Beschreibung"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: "MIME"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        faciliooFileTypesDebugQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: 4,
                                                                children: "File-Typen werden geladen ..."
                                                            })
                                                        }) : null,
                                                        faciliooFileTypeRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: row.id
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: row.fileExtension ? row.fileExtension.toUpperCase() : "-"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: row.description || "-"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: row.mimeType || "-"
                                                                    })
                                                                ]
                                                            }, row.id)),
                                                        !faciliooFileTypesDebugQuery.isLoading && !faciliooFileTypeRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: 4,
                                                                children: "Keine File-Typen gefunden."
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: isFrameworkV2 ? "panel resolution-detail-v2-list-panel resolution-detail-documents-v2-panel" : "panel",
                                style: isFrameworkV2 ? undefined : {
                                    margin: 0
                                },
                                children: [
                                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "resolutions-v2-row-count resolution-detail-v2-row-count",
                                        children: [
                                            "Facilioo-Dokumente: ",
                                            filteredFaciliooAttachmentRows.length,
                                            filteredFaciliooAttachmentRows.length !== faciliooAttachmentRows.length ? ` / ${faciliooAttachmentRows.length}` : ""
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                        className: isFrameworkV2 ? "resolutions-v2-filterbar resolution-detail-v2-filterbar" : "filterbar",
                                        style: isFrameworkV2 ? undefined : {
                                            marginBottom: 10
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: isFrameworkV2 ? "resolutions-v2-filter-fields" : undefined,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: isFrameworkV2 ? "resolutions-v2-filter-input resolution-detail-v2-filter-input" : undefined,
                                                children: [
                                                    isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-filter-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableIcon, {
                                                            name: "search"
                                                        })
                                                    }) : null,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        className: isFrameworkV2 ? undefined : "table-field",
                                                        placeholder: "Suche...",
                                                        value: searchFaciliooDokumente,
                                                        onChange: (e)=>setSearchFaciliooDokumente(e.target.value),
                                                        style: isFrameworkV2 ? undefined : {
                                                            minWidth: 320
                                                        }
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: isFrameworkV2 ? "resolution-detail-v2-table-wrap" : undefined,
                                        style: isFrameworkV2 ? undefined : {
                                            overflowX: "auto"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: isFrameworkV2 ? "resolution-detail-v2-table resolution-detail-facilioo-documents-v2-table" : undefined,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    width: 78,
                                                                    textAlign: "center"
                                                                },
                                                                children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                    label: "Aktiv",
                                                                    icon: "select",
                                                                    center: true
                                                                }) : "Aktiv"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                    label: "Dateiname",
                                                                    icon: "document"
                                                                }) : "Dateiname"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                    label: "Dateiart",
                                                                    icon: "type",
                                                                    center: true
                                                                }) : "Dateiart"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                    label: "Gr\xf6\xdfe",
                                                                    icon: "size",
                                                                    center: true
                                                                }) : "Gr\xf6\xdfe"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                    label: "Ge\xe4ndert am",
                                                                    icon: "date",
                                                                    center: true
                                                                }) : "Ge\xe4ndert am"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                    label: "Feed-ID",
                                                                    icon: "key",
                                                                    center: true
                                                                }) : "Feed-ID"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                "aria-label": "Aktion",
                                                                children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($845661e1cd923dd3$var$ResolutionDetailTableHeader, {
                                                                    label: "",
                                                                    icon: "action",
                                                                    center: true
                                                                }) : "Aktion"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        faciliooAttachmentsQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: 7,
                                                                children: "Facilioo-Dokumente werden geladen ..."
                                                            })
                                                        }) : null,
                                                        filteredFaciliooAttachmentRows.map((row)=>{
                                                            const key = `${row.feedId}:${row.attachmentId}`;
                                                            const checked = selectedFaciliooAttachmentKeys.includes(key);
                                                            const fileSizeBytes = Number.isFinite(Number(row.filesizeKb)) ? Number(row.filesizeKb) * 1024 : 0;
                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "checkbox",
                                                                            checked: checked,
                                                                            onChange: (e)=>setSelectedFaciliooAttachmentKeys((prev)=>e.target.checked ? Array.from(new Set([
                                                                                        ...prev,
                                                                                        key
                                                                                    ])) : prev.filter((entry)=>entry !== key))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: row.originalFilename || `Anhang ${row.attachmentId}`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: $845661e1cd923dd3$var$resolveFileTypeLabel(row)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: $845661e1cd923dd3$var$formatFileSize(fileSizeBytes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: $845661e1cd923dd3$var$formatDateTimeDE(row.lastModifiedAt ?? row.createdAt ?? undefined)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: row.feedId
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "resolutions-v2-action-wrap",
                                                                            onClick: (e)=>e.stopPropagation(),
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                    type: "button",
                                                                                    className: "resolutions-v2-action-trigger",
                                                                                    onClick: (e)=>{
                                                                                        e.stopPropagation();
                                                                                        if (faciliooOpenActionMenuId === key) {
                                                                                            setFaciliooOpenActionMenuId(null);
                                                                                            return;
                                                                                        }
                                                                                        openFloatingActionMenu(key, e.currentTarget, setFaciliooOpenActionMenuId, 52);
                                                                                    },
                                                                                    "aria-label": "Aktionen \xf6ffnen",
                                                                                    "aria-expanded": faciliooOpenActionMenuId === key,
                                                                                    children: "\u22EE"
                                                                                }),
                                                                                faciliooOpenActionMenuId === key && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                                                                    style: {
                                                                                        left: actionMenuPosition.left,
                                                                                        top: actionMenuPosition.top
                                                                                    },
                                                                                    onMouseEnter: ()=>setIsFaciliooActionMenuHovered(true),
                                                                                    onMouseLeave: ()=>setIsFaciliooActionMenuHovered(false),
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                        type: "button",
                                                                                        onClick: ()=>{
                                                                                            previewFaciliooAttachmentMutation.mutate(row);
                                                                                            setFaciliooOpenActionMenuId(null);
                                                                                        },
                                                                                        disabled: previewFaciliooAttachmentMutation.isPending,
                                                                                        children: "Vorschau"
                                                                                    })
                                                                                }), document.body) : null
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>previewFaciliooAttachmentMutation.mutate(row),
                                                                            disabled: previewFaciliooAttachmentMutation.isPending,
                                                                            children: "Vorschau"
                                                                        })
                                                                    })
                                                                ]
                                                            }, key);
                                                        }),
                                                        !faciliooAttachmentsQuery.isLoading && !filteredFaciliooAttachmentRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: 7,
                                                                children: faciliooAttachmentRows.length ? "Keine Facilioo-Dokumente gefunden." : "F\xfcr diesen Facilioo-Vorgang wurden keine Anh\xe4nge gefunden."
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }) : null,
                previewFaciliooDocument ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "modal-backdrop",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel modal-card",
                        style: {
                            width: "min(1400px, 98vw)",
                            maxWidth: 1400,
                            maxHeight: "94vh",
                            overflow: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 8
                                },
                                children: previewFaciliooDocument.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginBottom: 10
                                },
                                children: previewFaciliooDocument.previewable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                    title: previewFaciliooDocument.name,
                                    src: previewFaciliooDocument.url,
                                    style: {
                                        width: "100%",
                                        height: "80vh",
                                        border: "1px solid var(--line)",
                                        borderRadius: 6
                                    }
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        border: "1px solid var(--line)",
                                        borderRadius: 6,
                                        padding: 12
                                    },
                                    children: "F\xfcr diesen Dateityp ist keine Browser-Vorschau verf\xfcgbar. Bitte \xfcber den Download-Button \xf6ffnen."
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: previewFaciliooDocument.url,
                                        download: previewFaciliooDocument.name,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            children: "Download"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            if (previewFaciliooDocument.url) URL.revokeObjectURL(previewFaciliooDocument.url);
                                            setPreviewFaciliooDocument(null);
                                        },
                                        children: "Schlie\xdfen"
                                    })
                                ]
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");



const $e1acc214bd4b3153$var$CameraIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.5 7.5 10 5h4l1.5 2.5H18a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9.5a2 2 0 0 1 2-2h2.5Z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 10.25a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.25 10h.01"
            })
        ]
    });
const $e1acc214bd4b3153$var$QrCodeIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 5h5v5H5z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 5h5v5h-5z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 14h5v5H5z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 14h2.5v2.5H14z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.5 14v2.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 19h2.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 19h.01"
            })
        ]
    });
const $e1acc214bd4b3153$var$UploadIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 16V5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m7.5 9.5 4.5-4.5 4.5 4.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 15.5a4 4 0 0 0 1 7.5h10a4 4 0 0 0 1-7.5"
            })
        ]
    });
const $e1acc214bd4b3153$var$ScanFrameIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 4H5a1 1 0 0 0-1 1v3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 4h3a1 1 0 0 1 1 1v3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 16v3a1 1 0 0 1-1 1h-3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 20H5a1 1 0 0 1-1-1v-3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 12h6"
            })
        ]
    });
const $e1acc214bd4b3153$var$unknownQrCodeMessage = "Der gescannte QR-Code ist nicht bekannt. Bitte pr\xfcfen Sie, ob der Code zu einem analogen R\xfcckl\xe4ufer dieses Mandanten geh\xf6rt.";
const $e1acc214bd4b3153$var$formatDateTime = (value)=>{
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return new Intl.DateTimeFormat("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    }).format(d);
};
const $e1acc214bd4b3153$var$readTokenFromScanText = (value)=>{
    const raw = String(value ?? "").trim();
    if (!raw) return "";
    const extractTokenCandidate = (input)=>{
        const cleaned = String(input ?? "").replace(/[),;]+$/g, "").trim();
        if (!cleaned) return "";
        const decoded = (()=>{
            try {
                return decodeURIComponent(cleaned);
            } catch  {
                return cleaned;
            }
        })();
        const fromQuery = decoded.match(/[?&](?:token|t)=([^&#\s]+)/i)?.[1] ?? cleaned.match(/[?&](?:token|t)=([^&#\s]+)/i)?.[1] ?? "";
        if (fromQuery) return fromQuery.trim();
        const fromAnalogPath = decoded.match(/(?:^|\/)analog-scan\/([^/?#\s]+)/i)?.[1] ?? cleaned.match(/(?:^|\/)analog-scan\/([^/?#\s]+)/i)?.[1] ?? "";
        if (fromAnalogPath) return fromAnalogPath.trim();
        const fromOwnerPath = decoded.match(/(?:^|\/)owner-vote\/([^/?#\s]+)/i)?.[1] ?? cleaned.match(/(?:^|\/)owner-vote\/([^/?#\s]+)/i)?.[1] ?? "";
        if (fromOwnerPath) return fromOwnerPath.trim();
        return decoded.trim();
    };
    try {
        const asUrl = new URL(raw);
        const fromQuery = (asUrl.searchParams.get("token") ?? asUrl.searchParams.get("t") ?? "").trim();
        if (fromQuery) return fromQuery;
        const parts = asUrl.pathname.split("/").filter(Boolean);
        const analogIndex = parts.findIndex((p)=>p === "analog-scan");
        if (analogIndex >= 0 && parts[analogIndex + 1]) return parts[analogIndex + 1];
        const ownerVoteIndex = parts.findIndex((p)=>p === "owner-vote");
        if (ownerVoteIndex >= 0 && parts[ownerVoteIndex + 1]) return parts[ownerVoteIndex + 1];
        return extractTokenCandidate(raw);
    } catch  {
        return extractTokenCandidate(raw);
    }
};


const $e1acc214bd4b3153$export$8774c44f3870fe7b = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { token: token } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [voteValue, setVoteValue] = (0, $acw62.useState)("ja");
    const [comment, setComment] = (0, $acw62.useState)("");
    const [savedMessage, setSavedMessage] = (0, $acw62.useState)("");
    const [scannerError, setScannerError] = (0, $acw62.useState)("");
    const [scannerRunning, setScannerRunning] = (0, $acw62.useState)(false);
    const [scannerMode, setScannerMode] = (0, $acw62.useState)(null);
    const [imageScanRunning, setImageScanRunning] = (0, $acw62.useState)(false);
    const [uploadDragging, setUploadDragging] = (0, $acw62.useState)(false);
    const [supportsScanner, setSupportsScanner] = (0, $acw62.useState)(false);
    const scannerTimerRef = (0, $acw62.useRef)(null);
    const streamRef = (0, $acw62.useRef)(null);
    const videoRef = (0, $acw62.useRef)(null);
    const canvasRef = (0, $acw62.useRef)(null);
    const jsQrRef = (0, $acw62.useRef)(null);
    const scanNavigationPendingRef = (0, $acw62.useRef)(false);
    const unknownQrPauseUntilRef = (0, $acw62.useRef)(0);
    const effectiveToken = (0, $acw62.useMemo)(()=>String(token ?? "").trim(), [
        token
    ]);
    (0, $acw62.useEffect)(()=>{
        const hasCamera = typeof navigator !== "undefined" && !!navigator.mediaDevices?.getUserMedia;
        setSupportsScanner(hasCamera);
    }, []);
    const stopScanner = ()=>{
        setScannerRunning(false);
        setScannerMode(null);
        setScannerError("");
        unknownQrPauseUntilRef.current = 0;
        if (scannerTimerRef.current) {
            window.clearInterval(scannerTimerRef.current);
            scannerTimerRef.current = null;
        }
        if (streamRef.current) {
            for (const track of streamRef.current.getTracks())track.stop();
            streamRef.current = null;
        }
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>stopScanner();
    }, []);
    const openKnownScanToken = async (parsedToken)=>{
        const cleanToken = String(parsedToken ?? "").trim();
        if (!cleanToken || scanNavigationPendingRef.current) return false;
        scanNavigationPendingRef.current = true;
        try {
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).analogScanAccess(cleanToken);
            setScannerError("");
            stopScanner();
            navigate(`/analog-scan/${encodeURIComponent(cleanToken)}`);
            return true;
        } catch  {
            setScannerError($e1acc214bd4b3153$var$unknownQrCodeMessage);
            unknownQrPauseUntilRef.current = Date.now() + 3000;
            navigate("/analog-scan", {
                replace: true
            });
            return false;
        } finally{
            scanNavigationPendingRef.current = false;
        }
    };
    const startScanner = async ()=>{
        if (!supportsScanner) return;
        setScannerError("");
        setSavedMessage("");
        stopScanner();
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: {
                        ideal: "environment"
                    }
                },
                audio: false
            });
            streamRef.current = stream;
            const videoEl = videoRef.current;
            if (!videoEl) {
                stopScanner();
                return;
            }
            videoEl.srcObject = stream;
            await videoEl.play();
            setScannerRunning(true);
            const DetectorCtor = window.BarcodeDetector;
            if (DetectorCtor) {
                setScannerMode("native");
                const detector = new DetectorCtor({
                    formats: [
                        "qr_code"
                    ]
                });
                scannerTimerRef.current = window.setInterval(async ()=>{
                    try {
                        if (!videoRef.current) return;
                        const codes = await detector.detect(videoRef.current);
                        const firstRaw = String(codes?.[0]?.rawValue ?? "").trim();
                        if (!firstRaw) return;
                        if (Date.now() < unknownQrPauseUntilRef.current) return;
                        const parsedToken = $e1acc214bd4b3153$var$readTokenFromScanText(firstRaw);
                        if (!parsedToken) return;
                        await openKnownScanToken(parsedToken);
                    } catch  {
                    // temporary decode errors are expected while camera adjusts
                    }
                }, 600);
                return;
            }
            setScannerMode("compat");
            if (!jsQrRef.current) {
                const jsQrModule = await (parcelRequire("lU2dr"));
                jsQrRef.current = jsQrModule.default ?? null;
            }
            if (!jsQrRef.current) throw new Error("Kompatibilit\xe4ts-Scanner konnte nicht geladen werden.");
            scannerTimerRef.current = window.setInterval(()=>{
                try {
                    const video = videoRef.current;
                    if (!video || video.videoWidth <= 1 || video.videoHeight <= 1) return;
                    const canvas = canvasRef.current ?? document.createElement("canvas");
                    canvasRef.current = canvas;
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const ctx = canvas.getContext("2d", {
                        willReadFrequently: true
                    });
                    if (!ctx) return;
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const result = jsQrRef.current?.(imageData.data, imageData.width, imageData.height);
                    const parsedToken = $e1acc214bd4b3153$var$readTokenFromScanText(String(result?.data ?? ""));
                    if (!parsedToken) return;
                    if (Date.now() < unknownQrPauseUntilRef.current) return;
                    openKnownScanToken(parsedToken);
                } catch  {
                // temporary decode errors are expected while camera adjusts
                }
            }, 500);
        } catch (error) {
            stopScanner();
            setScannerError(error instanceof Error ? error.message : "Kamera konnte nicht gestartet werden.");
        }
    };
    const accessQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "analog-scan-access",
            effectiveToken
        ],
        enabled: Boolean(effectiveToken),
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).analogScanAccess(effectiveToken),
        retry: false
    });
    (0, $acw62.useEffect)(()=>{
        if (!effectiveToken || !accessQuery.isError) return;
        setScannerError($e1acc214bd4b3153$var$unknownQrCodeMessage);
        navigate("/analog-scan", {
            replace: true
        });
    }, [
        accessQuery.isError,
        effectiveToken,
        navigate
    ]);
    const hasExistingVote = Boolean(accessQuery.data?.current_vote) && String(accessQuery.data?.current_vote?.voteValue ?? "offen") !== "offen";
    const submitMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).analogScanSubmit(effectiveToken, {
                voteValue: voteValue,
                comment: comment.trim() ? comment.trim() : undefined
            }),
        onSuccess: async ()=>{
            setSavedMessage(hasExistingVote ? "Stimm\xe4nderung wurde erfolgreich erfasst." : "Stimme wurde erfolgreich erfasst.");
            await accessQuery.refetch();
        },
        onError: (error)=>{
            setSavedMessage(error instanceof Error ? error.message : "Stimme konnte nicht gespeichert werden.");
        }
    });
    const scanQrFromImage = async (file)=>{
        setScannerError("");
        setSavedMessage("");
        setImageScanRunning(true);
        try {
            const DetectorCtor = window.BarcodeDetector;
            const imageBitmap = await createImageBitmap(file);
            let parsedToken = "";
            if (DetectorCtor) {
                const detector = new DetectorCtor({
                    formats: [
                        "qr_code"
                    ]
                });
                const codes = await detector.detect(imageBitmap);
                parsedToken = $e1acc214bd4b3153$var$readTokenFromScanText(String(codes?.[0]?.rawValue ?? ""));
            }
            if (!parsedToken) {
                if (!jsQrRef.current) {
                    const jsQrModule = await (parcelRequire("lU2dr"));
                    jsQrRef.current = jsQrModule.default ?? null;
                }
                if (!jsQrRef.current) throw new Error("Bild-Scan wird in diesem Browser nicht unterst\xfctzt.");
                const canvas = canvasRef.current ?? document.createElement("canvas");
                canvasRef.current = canvas;
                canvas.width = imageBitmap.width;
                canvas.height = imageBitmap.height;
                const ctx = canvas.getContext("2d", {
                    willReadFrequently: true
                });
                if (!ctx) throw new Error("Bild konnte nicht verarbeitet werden.");
                ctx.drawImage(imageBitmap, 0, 0);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const result = jsQrRef.current(imageData.data, imageData.width, imageData.height);
                parsedToken = $e1acc214bd4b3153$var$readTokenFromScanText(String(result?.data ?? ""));
            }
            if (!parsedToken) throw new Error("Kein QR-Code erkannt. Bitte Foto erneut aufnehmen.");
            await openKnownScanToken(parsedToken);
        } catch (error) {
            setScannerError(error instanceof Error ? error.message : "QR-Bild konnte nicht ausgewertet werden.");
        } finally{
            setImageScanRunning(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `owner-vote-shell analog-scan-shell${scannerRunning ? " analog-scan-shell--scanner-running" : ""}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "owner-vote-card analog-scan-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                    className: "analog-scan-v2-header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "analog-scan-v2-title-bullet",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1acc214bd4b3153$var$QrCodeIcon, {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "analog-scan-v2-title",
                                    children: "Analoge R\xfcckl\xe4ufer erfassen (QR)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "analog-scan-v2-subline",
                                    children: "QR-Code vom analogen Umlaufbeschluss scannen."
                                })
                            ]
                        })
                    ]
                }),
                !effectiveToken ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "analog-scan-v2-panel",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "analog-scan-v2-row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "analog-scan-v2-row-icon",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1acc214bd4b3153$var$CameraIcon, {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "analog-scan-v2-row-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "analog-scan-v2-row-main",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Kamera-Scan"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "QR-Code mit der Kamera scannen."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "analog-scan-v2-badge-row",
                                            children: [
                                                !supportsScanner ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "analog-scan-v2-badge is-unavailable",
                                                    children: "Scanner im Browser nicht verf\xfcgbar"
                                                }) : null,
                                                scannerRunning && scannerMode === "compat" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "analog-scan-v2-badge is-active",
                                                    children: "Kompatibilit\xe4tsmodus (iOS)"
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "analog-scan-v2-row-action",
                                    children: !scannerRunning ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "analog-scan-v2-primary-btn",
                                        disabled: !supportsScanner,
                                        onClick: ()=>void startScanner(),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1acc214bd4b3153$var$ScanFrameIcon, {}),
                                            "Scanner starten"
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "analog-scan-v2-secondary-btn",
                                        onClick: stopScanner,
                                        children: "Scanner stoppen"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("video", {
                                    ref: videoRef,
                                    className: "analog-scan-v2-video",
                                    style: {
                                        display: scannerRunning ? "block" : "none"
                                    },
                                    playsInline: true,
                                    muted: true
                                }),
                                scannerError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "error-text analog-scan-v2-message",
                                    children: scannerError
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "analog-scan-v2-row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "analog-scan-v2-row-icon",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1acc214bd4b3153$var$UploadIcon, {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "analog-scan-v2-row-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "analog-scan-v2-row-main",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Foto-Upload"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        "F\xfcr Browser ohne Live-Scanner (z. B. iPhone Safari):",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                        "QR fotografieren und Bild hier ausw\xe4hlen."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "analog-scan-v2-upload-wrap",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "analog-scan-v2-file-btn",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1acc214bd4b3153$var$UploadIcon, {}),
                                                        "Datei ausw\xe4hlen",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "file",
                                                            className: "analog-scan-file-input analog-scan-v2-file-native",
                                                            accept: "image/*",
                                                            capture: "environment",
                                                            disabled: imageScanRunning,
                                                            onChange: (e)=>{
                                                                const file = e.target.files?.[0];
                                                                if (file) scanQrFromImage(file);
                                                                e.currentTarget.value = "";
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "analog-scan-v2-file-state",
                                                    children: "Keine ausgew\xe4hlt"
                                                })
                                            ]
                                        }),
                                        imageScanRunning ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "analog-scan-v2-badge is-active",
                                            children: "Bild wird ausgewertet..."
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `analog-scan-v2-dropzone${uploadDragging ? " is-dragging" : ""}${imageScanRunning ? " is-disabled" : ""}`,
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-label": "QR-Bild per Drag and Drop hochladen",
                                    onDragEnter: (e)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (!imageScanRunning) setUploadDragging(true);
                                    },
                                    onDragOver: (e)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (!imageScanRunning) setUploadDragging(true);
                                    },
                                    onDragLeave: (e)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (e.currentTarget.contains(e.relatedTarget)) return;
                                        setUploadDragging(false);
                                    },
                                    onDrop: (e)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setUploadDragging(false);
                                        if (imageScanRunning) return;
                                        const file = Array.from(e.dataTransfer.files).find((item)=>item.type.startsWith("image/"));
                                        if (file) scanQrFromImage(file);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1acc214bd4b3153$var$UploadIcon, {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Bild hier ablegen"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : null,
                effectiveToken ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "analog-scan-grid",
                    children: [
                        accessQuery.isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "error-text",
                            children: accessQuery.error instanceof Error ? accessQuery.error.message : "Scan-Token konnte nicht geladen werden."
                        }) : null,
                        accessQuery.data ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                    className: "owner-vote-action-box analog-scan-box",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "grid",
                                            gap: 6
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Beschluss:"
                                                    }),
                                                    " ",
                                                    accessQuery.data.resolution.beschlussnummer,
                                                    " | ",
                                                    accessQuery.data.resolution.titel
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Objekt:"
                                                    }),
                                                    " ",
                                                    accessQuery.data.resolution.objektnummer,
                                                    " | ",
                                                    accessQuery.data.resolution.objektname
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Eigent\xfcmer:"
                                                    }),
                                                    " ",
                                                    accessQuery.data.owner.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Einheiten:"
                                                    }),
                                                    " ",
                                                    accessQuery.data.assignments.map((row)=>row.einheitsnummer.padStart(4, "0")).join(" | ") || "-"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Aktuelle Stimme:"
                                                    }),
                                                    " ",
                                                    accessQuery.data.current_vote ? accessQuery.data.current_vote.voteValue : "offen",
                                                    accessQuery.data.current_vote?.voteReceivedAt ? ` (erfasst am ${$e1acc214bd4b3153$var$formatDateTime(accessQuery.data.current_vote.voteReceivedAt)})` : ""
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                    className: "owner-vote-action-box analog-scan-box",
                                    children: [
                                        hasExistingVote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "analog-scan-change-hint",
                                            children: [
                                                "F\xfcr diesen R\xfcckl\xe4ufer wurde bereits eine Stimme erfasst. Wenn Sie jetzt speichern, wird eine ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Stimm\xe4nderung"
                                                }),
                                                " protokolliert."
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Stimmabgabe"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "owner-vote-options analog-scan-options",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: `owner-vote-option owner-vote-option-ja${voteValue === "ja" ? " is-active" : ""}`,
                                                            onClick: ()=>setVoteValue("ja"),
                                                            children: "Ja"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: `owner-vote-option owner-vote-option-nein${voteValue === "nein" ? " is-active" : ""}`,
                                                            onClick: ()=>setVoteValue("nein"),
                                                            children: "Nein"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: `owner-vote-option owner-vote-option-enthaltung${voteValue === "enthaltung" ? " is-active" : ""}`,
                                                            onClick: ()=>setVoteValue("enthaltung"),
                                                            children: "Enthaltung"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field owner-vote-comment-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Kommentar (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                    className: "table-field",
                                                    rows: 4,
                                                    value: comment,
                                                    onChange: (e)=>setComment(e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 8,
                                                flexWrap: "wrap",
                                                marginTop: 12
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `owner-vote-submit-btn ${voteValue === "ja" ? "owner-vote-submit-ja" : voteValue === "nein" ? "owner-vote-submit-nein" : "owner-vote-submit-enthaltung"}`,
                                                    disabled: submitMutation.isPending,
                                                    onClick: ()=>submitMutation.mutate(),
                                                    children: submitMutation.isPending ? "Speichere..." : hasExistingVote ? "Stimm\xe4nderung speichern" : "Stimme speichern"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>{
                                                        navigate("/analog-scan");
                                                        setSavedMessage("");
                                                    },
                                                    children: "Neuer Scan"
                                                })
                                            ]
                                        }),
                                        savedMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                marginTop: 10
                                            },
                                            className: savedMessage.toLowerCase().includes("erfolgreich") ? "success-text" : "error-text",
                                            children: savedMessage
                                        }) : null
                                    ]
                                })
                            ]
                        }) : null
                    ]
                }) : null
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");


const $35849a2ba082badf$var$faciliooSyncStatusLabel = (action)=>$35849a2ba082badf$var$toText(action).endsWith("_failed") ? "Fehler" : "OK";
const $35849a2ba082badf$var$faciliooSyncTrigger = (action)=>{
    const normalized = $35849a2ba082badf$var$toText(action);
    if (normalized.includes("_auto_")) return "Automatisch";
    if (normalized.includes("_manual_")) return "Manuell";
    return "Unbekannt";
};
const $35849a2ba082badf$var$toRecord = (value)=>value && typeof value === "object" && !Array.isArray(value) ? value : null;
const $35849a2ba082badf$var$isRecord = (value)=>value !== null && typeof value === "object" && !Array.isArray(value);
const $35849a2ba082badf$var$toNumber = (value)=>{
    if (typeof value === "number" && Number.isFinite(value)) return value;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};
const $35849a2ba082badf$var$toText = (value)=>String(value ?? "").trim();
const $35849a2ba082badf$var$toListText = (value)=>{
    if (!Array.isArray(value)) return "-";
    const items = value.map((entry)=>$35849a2ba082badf$var$toText(entry)).filter(Boolean);
    if (items.length === 0) return "-";
    if (items.length <= 2) return items.join(" | ");
    return `${items.slice(0, 2).join(" | ")} (+${items.length - 2})`;
};
const $35849a2ba082badf$var$formatDurationLabel = (durationMs)=>{
    if (typeof durationMs !== "number" || !Number.isFinite(durationMs) || durationMs <= 0) return "-";
    const totalSeconds = Math.max(1, Math.round(durationMs / 1000));
    if (totalSeconds < 60) return `${totalSeconds}s`;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
};
const $35849a2ba082badf$var$AssignmentAnomalyDebugList = ({ id: id, title: title, units: units, csvFilenamePrefix: csvFilenamePrefix, emptyText: emptyText, ignoredInfoCount: ignoredInfoCount = 0, hint: hint })=>{
    const [search, setSearch] = (0, $acw62.useState)("");
    const [objectFilter, setObjectFilter] = (0, $acw62.useState)("");
    const [unitTypeFilter, setUnitTypeFilter] = (0, $acw62.useState)("");
    const [sortBy, setSortBy] = (0, $acw62.useState)("objektnummer");
    const [sortDir, setSortDir] = (0, $acw62.useState)("asc");
    const normalizeDebugText = (value)=>String(value ?? "").trim();
    const objectFilterOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(units.map((unit)=>normalizeDebugText(unit.objektnummer)).filter(Boolean))).sort((a, b)=>a.localeCompare(b, "de", {
                numeric: true
            })), [
        units
    ]);
    const unitTypeFilterOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(units.map((unit)=>normalizeDebugText(unit.einheitstyp)).filter(Boolean))).sort((a, b)=>a.localeCompare(b, "de", {
                numeric: true
            })), [
        units
    ]);
    const filteredUnits = (0, $acw62.useMemo)(()=>{
        const needle = search.trim().toLowerCase();
        const filtered = units.filter((unit)=>{
            const objectOk = !objectFilter || normalizeDebugText(unit.objektnummer) === objectFilter;
            const typeOk = !unitTypeFilter || normalizeDebugText(unit.einheitstyp) === unitTypeFilter;
            const searchOk = !needle || [
                unit.objektnummer,
                unit.einheitsnummer,
                unit.einheitstyp,
                unit.bezeichnung
            ].map((value)=>normalizeDebugText(value)).filter(Boolean).join(" ").toLowerCase().includes(needle);
            return objectOk && typeOk && searchOk;
        });
        const cmp = (a, b)=>normalizeDebugText(a).localeCompare(normalizeDebugText(b), "de", {
                numeric: true,
                sensitivity: "base"
            });
        filtered.sort((left, right)=>{
            let result = 0;
            if (sortBy === "einheitsnummer") result = cmp(left.einheitsnummer, right.einheitsnummer);
            else if (sortBy === "einheitstyp") result = cmp(left.einheitstyp, right.einheitstyp);
            else result = cmp(left.objektnummer, right.objektnummer);
            if (result === 0) result = cmp(left.einheitsnummer, right.einheitsnummer);
            return sortDir === "desc" ? -result : result;
        });
        return filtered;
    }, [
        objectFilter,
        search,
        sortBy,
        sortDir,
        unitTypeFilter,
        units
    ]);
    const toggleSort = (field)=>{
        if (sortBy === field) {
            setSortDir((prev)=>prev === "asc" ? "desc" : "asc");
            return;
        }
        setSortBy(field);
        setSortDir("asc");
    };
    const exportData = (0, $acw62.useMemo)(()=>{
        const headers = [
            "Objekt-Nr",
            "Einheit-Nr",
            "Art der Einheit",
            "Lage / Bezeichnung",
            "Hinweis"
        ];
        const rows = filteredUnits.map((unit)=>[
                unit.objektnummer,
                /^\d+$/.test(String(unit.einheitsnummer ?? "").trim()) ? String(unit.einheitsnummer).padStart(4, "0") : unit.einheitsnummer || "-",
                unit.einheitstyp || "-",
                unit.bezeichnung || "-",
                hint(unit)
            ]);
        const timestamp = new Date().toISOString().slice(0, 10);
        return {
            headers: headers,
            rows: rows,
            csvFilename: `${csvFilenamePrefix}-${timestamp}.csv`
        };
    }, [
        csvFilenamePrefix,
        filteredUnits,
        hint
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        id: id,
        style: {
            marginTop: 16,
            scrollMarginTop: 24
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                style: {
                    margin: "0 0 8px"
                },
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "filterbar",
                style: {
                    marginTop: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        placeholder: "Suche (Objekt, Einheit, Art, Lage)",
                        value: search,
                        onChange: (event)=>setSearch(event.target.value)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: objectFilter,
                        onChange: (event)=>setObjectFilter(event.target.value),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                children: "Alle Objekte"
                            }),
                            objectFilterOptions.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: value,
                                    children: value
                                }, value))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: unitTypeFilter,
                        onChange: (event)=>setUnitTypeFilter(event.target.value),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                children: "Alle Arten"
                            }),
                            unitTypeFilterOptions.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: value,
                                    children: value
                                }, value))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>$35849a2ba082badf$var$downloadCsv(exportData.csvFilename, exportData.headers, exportData.rows),
                        disabled: exportData.rows.length === 0,
                        children: "CSV Export"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: 8,
                    fontSize: 12,
                    color: "#5a6875"
                },
                children: [
                    "Zeilen: ",
                    filteredUnits.length,
                    " / Gesamt relevant: ",
                    units.length,
                    ignoredInfoCount ? ` | Sonstiges/Info nicht kritisch: ${ignoredInfoCount}` : ""
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: 12,
                    border: "1px solid var(--line)",
                    borderRadius: 6,
                    maxHeight: 360,
                    overflow: "auto"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>toggleSort("objektnummer"),
                                            style: {
                                                border: "none",
                                                background: "transparent",
                                                font: "inherit",
                                                cursor: "pointer",
                                                fontWeight: 700,
                                                width: "100%",
                                                textAlign: "center"
                                            },
                                            children: [
                                                "Objekt-Nr. ",
                                                sortBy === "objektnummer" ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>toggleSort("einheitsnummer"),
                                            style: {
                                                border: "none",
                                                background: "transparent",
                                                font: "inherit",
                                                cursor: "pointer",
                                                fontWeight: 700,
                                                width: "100%",
                                                textAlign: "center"
                                            },
                                            children: [
                                                "Einheit-Nr. ",
                                                sortBy === "einheitsnummer" ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>toggleSort("einheitstyp"),
                                            style: {
                                                border: "none",
                                                background: "transparent",
                                                font: "inherit",
                                                cursor: "pointer",
                                                fontWeight: 700,
                                                width: "100%",
                                                textAlign: "center"
                                            },
                                            children: [
                                                "Art der Einheit ",
                                                sortBy === "einheitstyp" ? sortDir === "asc" ? "\u2191" : "\u2193" : "\u2195"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Lage / Bezeichnung"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Hinweis"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: filteredUnits.length ? filteredUnits.map((unit)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: "badge object-number",
                                                to: `/objects?search=${encodeURIComponent(unit.objektnummer)}`,
                                                title: `Objekt ${unit.objektnummer}`,
                                                children: unit.objektnummer
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: /^\d+$/.test(String(unit.einheitsnummer ?? "").trim()) ? String(unit.einheitsnummer).padStart(4, "0") : unit.einheitsnummer || "-"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: unit.einheitstyp || "-"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: unit.bezeichnung || "-"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: hint(unit) || "-"
                                        })
                                    ]
                                }, unit.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    colSpan: 5,
                                    children: emptyText
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $35849a2ba082badf$var$toRecordList = (value)=>Array.isArray(value) ? value.filter((entry)=>!!entry && typeof entry === "object" && !Array.isArray(entry)) : [];
const $35849a2ba082badf$var$escapeCsv = (value)=>{
    const text = String(value ?? "");
    if (/[;"\n\r]/.test(text)) return `"${text.replace(/"/g, "\"\"")}"`;
    return text;
};
const $35849a2ba082badf$var$downloadCsv = (filename, headers, rows)=>{
    const csv = [
        headers.map($35849a2ba082badf$var$escapeCsv).join(";"),
        ...rows.map((row)=>row.map($35849a2ba082badf$var$escapeCsv).join(";"))
    ].join("\n");
    const blob = new Blob([
        csv
    ], {
        type: "text/csv;charset=utf-8;"
    });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
};
const $35849a2ba082badf$var$buildMissingOwnerContactList = (value)=>{
    const source = $35849a2ba082badf$var$toRecordList(value);
    if (!source.length) return [];
    const grouped = new Map();
    for (const row of source){
        const partyId = $35849a2ba082badf$var$toText(row.ownerPartyId) || $35849a2ba082badf$var$toText(row.partyId) || "(ohne Party-ID)";
        const key = partyId;
        const current = grouped.get(key) ?? (()=>{
            const created = {
                partyId: partyId,
                objectNumbers: new Set(),
                unitNumbers: new Set(),
                ownerNames: new Set(),
                contractIds: new Set(),
                partyContactStatus: $35849a2ba082badf$var$toText(row.partyContactStatus) || "-",
                accountResolutionStatus: $35849a2ba082badf$var$toText(row.accountResolutionStatus) || "-"
            };
            grouped.set(key, created);
            return created;
        })();
        const objectNumber = $35849a2ba082badf$var$toText(row.objektnummer);
        const unitNumberRaw = $35849a2ba082badf$var$toText(row.einheitsnummer) || $35849a2ba082badf$var$toText(row.unitNumber);
        const unitIdRaw = $35849a2ba082badf$var$toText(row.unitId);
        const unitNumber = unitNumberRaw || (unitIdRaw ? `ID:${unitIdRaw}` : "");
        const ownerName = $35849a2ba082badf$var$toText(row.eigentuemername) || $35849a2ba082badf$var$toText(row.ownerName) || $35849a2ba082badf$var$toText(row.name1) || $35849a2ba082badf$var$toText(row.name_1) || $35849a2ba082badf$var$toText(row.fullName) || $35849a2ba082badf$var$toText(row.primaryName);
        const contractId = $35849a2ba082badf$var$toText(row.ownerContractId);
        if (objectNumber) current.objectNumbers.add(objectNumber);
        if (unitNumber) current.unitNumbers.add(unitNumber);
        if (ownerName) current.ownerNames.add(ownerName);
        if (contractId) current.contractIds.add(contractId);
    }
    return Array.from(grouped.values()).map((entry)=>({
            partyId: entry.partyId,
            objectNumbers: Array.from(entry.objectNumbers),
            unitNumbers: Array.from(entry.unitNumbers),
            ownerNames: Array.from(entry.ownerNames),
            contractIds: Array.from(entry.contractIds),
            partyContactStatus: entry.partyContactStatus,
            accountResolutionStatus: entry.accountResolutionStatus
        })).sort((a, b)=>a.partyId.localeCompare(b.partyId, "de-DE"));
};
const $35849a2ba082badf$var$buildAssignmentAnomalyNoActiveList = (value)=>{
    if (!Array.isArray(value)) return [];
    return value.map((entry)=>$35849a2ba082badf$var$toText(entry)).filter(Boolean).map((entry)=>{
        const [obj, unit] = entry.split("/");
        return {
            objektnummer: $35849a2ba082badf$var$toText(obj) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(unit) || "-"
        };
    }).sort((a, b)=>`${a.objektnummer}/${a.einheitsnummer}`.localeCompare(`${b.objektnummer}/${b.einheitsnummer}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$buildAssignmentAnomalyNoActiveReasonList = (value)=>{
    if (!Array.isArray(value)) return [];
    return value.map((entry)=>$35849a2ba082badf$var$toText(entry)).filter(Boolean).map((entry)=>{
        const [reason, countRaw] = entry.split("=");
        return {
            reason: $35849a2ba082badf$var$toText(reason) || "-",
            count: Number(countRaw) || 0
        };
    }).sort((a, b)=>b.count - a.count);
};
const $35849a2ba082badf$var$buildAssignmentAnomalyNoActiveDetailList = (value)=>{
    if (!Array.isArray(value)) return [];
    return value.map((entry)=>$35849a2ba082badf$var$toText(entry)).filter(Boolean).map((entry)=>{
        const [left, right] = entry.split("->");
        const leftTrim = $35849a2ba082badf$var$toText(left);
        const rightTrim = $35849a2ba082badf$var$toText(right);
        const [obj, unit] = leftTrim.split("/");
        return {
            objektnummer: $35849a2ba082badf$var$toText(obj) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(unit) || "-",
            details: rightTrim || "-"
        };
    }).sort((a, b)=>`${a.objektnummer}/${a.einheitsnummer}`.localeCompare(`${b.objektnummer}/${b.einheitsnummer}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$buildAssignmentAnomalyNoActiveContractProbeList = (value)=>{
    const source = $35849a2ba082badf$var$toRecordList(value);
    if (!source.length) return [];
    return source.map((row)=>({
            objektnummer: $35849a2ba082badf$var$toText(row.objektnummer) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(row.einheitsnummer) || "-",
            eigentuemerId: $35849a2ba082badf$var$toText(row.eigentuemerId) || "-",
            eigentuemername: $35849a2ba082badf$var$toText(row.eigentuemername) || "-",
            assignmentId: $35849a2ba082badf$var$toText(row.assignmentId) || "-",
            gueltigAb: $35849a2ba082badf$var$toText(row.gueltigAb) || "-",
            gueltigBis: $35849a2ba082badf$var$toText(row.gueltigBis) || "-",
            status: $35849a2ba082badf$var$toText(row.status) || "-",
            reason: $35849a2ba082badf$var$toText(row.reason) || "-"
        })).sort((a, b)=>`${a.objektnummer}/${a.einheitsnummer}/${a.assignmentId}`.localeCompare(`${b.objektnummer}/${b.einheitsnummer}/${b.assignmentId}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$buildFocusUnitContractProbeList = (value)=>{
    const source = $35849a2ba082badf$var$toRecordList(value);
    if (!source.length) return [];
    return source.map((row)=>({
            objektnummer: $35849a2ba082badf$var$toText(row.objektnummer) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(row.einheitsnummer) || "-",
            apiUnitId: $35849a2ba082badf$var$toText(row.apiUnitId) || "-",
            contractId: $35849a2ba082badf$var$toText(row.contractId) || "-",
            partyId: $35849a2ba082badf$var$toText(row.partyId) || "-",
            eigentuemer: $35849a2ba082badf$var$toText(row.eigentuemer) || "-",
            type: $35849a2ba082badf$var$toText(row.type) || "-",
            isArchived: $35849a2ba082badf$var$toText(row.isArchived) || "-",
            isCurrent: $35849a2ba082badf$var$toText(row.isCurrent) || "-",
            gueltigAb: $35849a2ba082badf$var$toText(row.gueltigAb) || "-",
            gueltigBis: $35849a2ba082badf$var$toText(row.gueltigBis) || "-",
            activeByWindow: $35849a2ba082badf$var$toText(row.activeByWindow) || "-",
            activeByLegacy: $35849a2ba082badf$var$toText(row.activeByLegacy) || "-",
            status: $35849a2ba082badf$var$toText(row.status) || "-",
            hinweis: $35849a2ba082badf$var$toText(row.hinweis) || "-"
        })).sort((a, b)=>`${a.objektnummer}/${a.einheitsnummer}/${a.apiUnitId}/${a.contractId}`.localeCompare(`${b.objektnummer}/${b.einheitsnummer}/${b.apiUnitId}/${b.contractId}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$buildFocusObjectContractMatrixList = (value)=>{
    const source = $35849a2ba082badf$var$toRecordList(value);
    if (!source.length) return [];
    return source.map((row)=>({
            objektnummer: $35849a2ba082badf$var$toText(row.objektnummer) || "-",
            apiUnitId: $35849a2ba082badf$var$toText(row.apiUnitId) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(row.einheitsnummer) || "-",
            aufgangRef: $35849a2ba082badf$var$toText(row.aufgangRef) || "-",
            aufgangName: $35849a2ba082badf$var$toText(row.aufgangName) || "-",
            status: $35849a2ba082badf$var$toText(row.status) || "-",
            einheitstyp: $35849a2ba082badf$var$toText(row.einheitstyp) || "-",
            bezeichnung: $35849a2ba082badf$var$toText(row.bezeichnung) || "-",
            contractRows: $35849a2ba082badf$var$toNumber(row.contractRows) ?? 0,
            ownerType3Rows: $35849a2ba082badf$var$toNumber(row.ownerType3Rows) ?? 0,
            activeOwnerRows: $35849a2ba082badf$var$toNumber(row.activeOwnerRows) ?? 0,
            earliestFrom: $35849a2ba082badf$var$toText(row.earliestFrom) || "-",
            latestTo: $35849a2ba082badf$var$toText(row.latestTo) || "-",
            fetchStatus: $35849a2ba082badf$var$toText(row.fetchStatus) || "-",
            fetchWarning: $35849a2ba082badf$var$toText(row.fetchWarning) || "-"
        })).sort((a, b)=>`${a.einheitsnummer}/${a.aufgangRef}/${a.apiUnitId}`.localeCompare(`${b.einheitsnummer}/${b.aufgangRef}/${b.apiUnitId}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$buildFocusUnitContractTypeSweepProbeList = (value)=>{
    const source = $35849a2ba082badf$var$toRecordList(value);
    if (!source.length) return [];
    return source.map((row)=>({
            objektnummer: $35849a2ba082badf$var$toText(row.objektnummer) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(row.einheitsnummer) || "-",
            apiUnitId: $35849a2ba082badf$var$toText(row.apiUnitId) || "-",
            typeFilter: $35849a2ba082badf$var$toText(row.typeFilter) || "-",
            queryKey: $35849a2ba082badf$var$toText(row.queryKey) || "-",
            endpoint: $35849a2ba082badf$var$toText(row.endpoint) || "-",
            status: $35849a2ba082badf$var$toText(row.status) || "-",
            rawRows: $35849a2ba082badf$var$toText(row.rawRows) || "-",
            mappedRows: $35849a2ba082badf$var$toText(row.mappedRows) || "-",
            ownerType3Rows: $35849a2ba082badf$var$toText(row.ownerType3Rows) || "-",
            activeOwnerRows: $35849a2ba082badf$var$toText(row.activeOwnerRows) || "-",
            earliestOwnerFrom: $35849a2ba082badf$var$toText(row.earliestOwnerFrom) || "-",
            latestOwnerTo: $35849a2ba082badf$var$toText(row.latestOwnerTo) || "-",
            isLatestOwnerToPast: $35849a2ba082badf$var$toText(row.isLatestOwnerToPast) || "-",
            hasNext: $35849a2ba082badf$var$toText(row.hasNext) || "-",
            sampleContractIds: $35849a2ba082badf$var$toText(row.sampleContractIds) || "-",
            hint: $35849a2ba082badf$var$toText(row.hint) || "-"
        })).sort((a, b)=>`${a.typeFilter}/${a.queryKey}/${a.apiUnitId}`.localeCompare(`${b.typeFilter}/${b.queryKey}/${b.apiUnitId}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$buildFocusUnitOwnershipProbeList = (value)=>{
    const source = $35849a2ba082badf$var$toRecordList(value);
    if (!source.length) return [];
    return source.map((row)=>({
            objektnummer: $35849a2ba082badf$var$toText(row.objektnummer) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(row.einheitsnummer) || "-",
            apiUnitId: $35849a2ba082badf$var$toText(row.apiUnitId) || "-",
            propertyId: $35849a2ba082badf$var$toText(row.propertyId) || "-",
            endpoint: $35849a2ba082badf$var$toText(row.endpoint) || "-",
            status: $35849a2ba082badf$var$toText(row.status) || "-",
            payloadRows: $35849a2ba082badf$var$toText(row.payloadRows) || "-",
            embeddedRows: $35849a2ba082badf$var$toText(row.embeddedRows) || "-",
            sourceRows: $35849a2ba082badf$var$toText(row.sourceRows) || "-",
            matchedRows: $35849a2ba082badf$var$toText(row.matchedRows) || "-",
            matchedKeySample: $35849a2ba082badf$var$toText(row.matchedKeySample) || "-",
            matchedSample: $35849a2ba082badf$var$toText(row.matchedSample) || "-",
            hint: $35849a2ba082badf$var$toText(row.hint) || "-"
        })).sort((a, b)=>`${a.propertyId}/${a.apiUnitId}/${a.endpoint}`.localeCompare(`${b.propertyId}/${b.apiUnitId}/${b.endpoint}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$buildFocusOwnerUnitProbeList = (value)=>{
    const source = $35849a2ba082badf$var$toRecordList(value);
    if (!source.length) return [];
    return source.map((row)=>({
            partyId: $35849a2ba082badf$var$toText(row.partyId) || "-",
            eigentuemer: $35849a2ba082badf$var$toText(row.eigentuemer) || "-",
            objektnummer: $35849a2ba082badf$var$toText(row.objektnummer) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(row.einheitsnummer) || "-",
            apiUnitId: $35849a2ba082badf$var$toText(row.apiUnitId) || "-",
            propertyId: $35849a2ba082badf$var$toText(row.propertyId) || "-",
            contractId: $35849a2ba082badf$var$toText(row.contractId) || "-",
            type: $35849a2ba082badf$var$toText(row.type) || "-",
            isArchived: $35849a2ba082badf$var$toText(row.isArchived) || "-",
            isCurrent: $35849a2ba082badf$var$toText(row.isCurrent) || "-",
            gueltigAb: $35849a2ba082badf$var$toText(row.gueltigAb) || "-",
            gueltigBis: $35849a2ba082badf$var$toText(row.gueltigBis) || "-",
            activeByWindow: $35849a2ba082badf$var$toText(row.activeByWindow) || "-",
            activeByLegacy: $35849a2ba082badf$var$toText(row.activeByLegacy) || "-",
            status: $35849a2ba082badf$var$toText(row.status) || "-",
            hinweis: $35849a2ba082badf$var$toText(row.hinweis) || "-"
        })).sort((a, b)=>`${a.status}/${a.objektnummer}/${a.einheitsnummer}/${a.contractId}`.localeCompare(`${b.status}/${b.objektnummer}/${b.einheitsnummer}/${b.contractId}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$buildAssignmentAnomalyMultiActiveList = (value)=>{
    if (!Array.isArray(value)) return [];
    return value.map((entry)=>$35849a2ba082badf$var$toText(entry)).filter(Boolean).map((entry)=>{
        const [left, right] = entry.split("->");
        const leftTrim = $35849a2ba082badf$var$toText(left);
        const rightTrim = $35849a2ba082badf$var$toText(right);
        const [obj, unit] = leftTrim.split("/");
        return {
            objektnummer: $35849a2ba082badf$var$toText(obj) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(unit) || "-",
            activeOwnersSummary: rightTrim || "-"
        };
    }).sort((a, b)=>`${a.objektnummer}/${a.einheitsnummer}`.localeCompare(`${b.objektnummer}/${b.einheitsnummer}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$buildObjectUnitConsistencyList = (value)=>{
    const source = $35849a2ba082badf$var$toRecordList(value);
    if (!source.length) return [];
    return source.map((row)=>({
            objektnummer: $35849a2ba082badf$var$toText(row.objektnummer) || "-",
            einheitsnummer: $35849a2ba082badf$var$toText(row.einheitsnummer) || "-"
        })).sort((a, b)=>`${a.objektnummer}/${a.einheitsnummer}`.localeCompare(`${b.objektnummer}/${b.einheitsnummer}`, "de-DE", {
            numeric: true,
            sensitivity: "base"
        }));
};
const $35849a2ba082badf$var$debugTitleIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M13 2 5 13h6l-1 9 9-13h-6l1-7Z",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinejoin: "round",
        strokeLinecap: "round"
    })
});
const $35849a2ba082badf$var$renderFaciliooDebug = (row)=>{
    const changes = $35849a2ba082badf$var$toRecord(row.changes_json);
    const syncErrorMessage = $35849a2ba082badf$var$toText(changes?.error);
    const debug = $35849a2ba082badf$var$toRecord(changes?.debug);
    if (!debug) {
        if (!syncErrorMessage) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            style: {
                opacity: 0.7
            },
            children: "-"
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                color: "#b42318",
                fontWeight: 600
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "Abbruchgrund:"
                }),
                " ",
                syncErrorMessage
            ]
        });
    }
    const owners = $35849a2ba082badf$var$toRecord(debug.owners);
    const ownerProbes = $35849a2ba082badf$var$toRecord(owners?.probes);
    const missingOwnerContactList = $35849a2ba082badf$var$buildMissingOwnerContactList(ownerProbes?.noContactSamples);
    const assignmentAnomalyNoActiveList = $35849a2ba082badf$var$buildAssignmentAnomalyNoActiveList(owners?.assignmentAnomalyNoActiveProbe);
    const assignmentAnomalyNoActiveReasonList = $35849a2ba082badf$var$buildAssignmentAnomalyNoActiveReasonList(owners?.assignmentAnomalyNoActiveReasonSummary);
    const assignmentAnomalyNoActiveDetailList = $35849a2ba082badf$var$buildAssignmentAnomalyNoActiveDetailList(owners?.assignmentAnomalyNoActiveDetailProbe);
    const assignmentAnomalyNoActiveContractProbeList = $35849a2ba082badf$var$buildAssignmentAnomalyNoActiveContractProbeList(owners?.assignmentAnomalyNoActiveContractProbe);
    const focusUnitContractProbeList = $35849a2ba082badf$var$buildFocusUnitContractProbeList(owners?.focusUnitContractProbe);
    const focusUnitContractTypeSweepProbeList = $35849a2ba082badf$var$buildFocusUnitContractTypeSweepProbeList(owners?.focusUnitContractTypeSweepProbe);
    const focusUnitOwnershipProbeList = $35849a2ba082badf$var$buildFocusUnitOwnershipProbeList(owners?.focusUnitOwnershipProbe);
    const focusOwnerUnitProbeList = $35849a2ba082badf$var$buildFocusOwnerUnitProbeList(owners?.focusOwnerUnitProbe);
    const focusObjectContractMatrixList = $35849a2ba082badf$var$buildFocusObjectContractMatrixList(owners?.focusObjectContractMatrixProbe);
    const focusUnitProbeConfig = $35849a2ba082badf$var$toRecord(owners?.focusUnitProbeConfig);
    const focusOwnerUnitProbeConfig = $35849a2ba082badf$var$toRecord(owners?.focusOwnerUnitProbeConfig);
    const assignmentAnomalyMultiActiveList = $35849a2ba082badf$var$buildAssignmentAnomalyMultiActiveList(owners?.assignmentAnomalyMultiActiveProbe);
    const units = $35849a2ba082badf$var$toRecord(debug.units);
    const unitConsistency = $35849a2ba082badf$var$toRecord(units?.consistency);
    const objectUnitConsistencyList = $35849a2ba082badf$var$buildObjectUnitConsistencyList(unitConsistency?.objectUnitConsistencyProbe);
    const unitSkips = $35849a2ba082badf$var$toRecord(debug.unitSkips);
    const progress = $35849a2ba082badf$var$toRecord(debug.progress);
    const errorMeta = $35849a2ba082badf$var$toRecord(debug.error);
    const errorReason = $35849a2ba082badf$var$toText(errorMeta?.reason);
    const errorTarget = $35849a2ba082badf$var$toText(errorMeta?.target);
    const errorTimeoutMs = $35849a2ba082badf$var$toNumber(errorMeta?.timeoutMs);
    const errorAttempt = $35849a2ba082badf$var$toNumber(errorMeta?.attempt);
    const errorMaxAttempts = $35849a2ba082badf$var$toNumber(errorMeta?.maxAttempts);
    const errorOriginalMessage = $35849a2ba082badf$var$toText(errorMeta?.originalMessage);
    const unresolved = $35849a2ba082badf$var$toNumber(owners?.unresolvedAccountId);
    const noContacts = $35849a2ba082badf$var$toNumber(owners?.withoutUsableContacts);
    const accountViaMap = $35849a2ba082badf$var$toNumber(owners?.accountResolvedViaMap);
    const accountViaParty = $35849a2ba082badf$var$toNumber(owners?.accountResolvedViaParty);
    const accountDirect = $35849a2ba082badf$var$toNumber(owners?.accountResolvedDirect);
    const unitWarn = $35849a2ba082badf$var$toText(units?.warning);
    const unitDiag = $35849a2ba082badf$var$toText(units?.diagnostics);
    const skipNoObject = $35849a2ba082badf$var$toNumber(unitSkips?.noObjectNumber);
    const skipNoUnit = $35849a2ba082badf$var$toNumber(unitSkips?.noUnitNumber);
    const phase = $35849a2ba082badf$var$toText(debug.phase);
    const progressMsg = $35849a2ba082badf$var$toText(progress?.message);
    const trigger = $35849a2ba082badf$var$toText(debug.trigger);
    const durationMs = $35849a2ba082badf$var$toNumber(debug.durationMs);
    const mirrorCleanup = $35849a2ba082badf$var$toRecord(debug.mirrorCleanup);
    const inApp = $35849a2ba082badf$var$toRecord(debug.inApp);
    const inAppObjects = $35849a2ba082badf$var$toRecord(inApp?.objects);
    const inAppUnits = $35849a2ba082badf$var$toRecord(inApp?.units);
    const contactDebug = $35849a2ba082badf$var$toText(debug.contactDebug);
    const debugSectionStyle = {
        marginTop: 14,
        paddingTop: 10,
        borderTop: "1px solid var(--line)"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
        style: {
            width: "100%",
            minWidth: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                style: {
                    cursor: "pointer",
                    fontWeight: 600,
                    display: "block",
                    width: "100%"
                },
                children: `Eigent\xfcmer ohne Account: ${unresolved ?? 0}, ohne Kontaktdaten: ${noContacts ?? 0}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "grid",
                    gap: 4,
                    marginTop: 8,
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Trigger:"
                            }),
                            " ",
                            trigger || "-",
                            durationMs !== null ? ` | Dauer: ${Math.round(durationMs / 1000)} s` : ""
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Eigent\xfcmer:"
                            }),
                            " ",
                            `ohneAccount=${unresolved ?? 0}, ohneKontaktdaten=${noContacts ?? 0}, direkt=${accountDirect ?? 0}, viaParty=${accountViaParty ?? 0}, viaMap=${accountViaMap ?? 0}`
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Einheiten-Skips:"
                            }),
                            " ",
                            `ohneObjektNr=${skipNoObject ?? 0}, ohneEinheitsNr=${skipNoUnit ?? 0}`
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Sync-Phase:"
                            }),
                            " ",
                            phase || "-",
                            " ",
                            progressMsg ? `| ${progressMsg}` : ""
                        ]
                    }),
                    syncErrorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            color: "#b42318",
                            fontWeight: 600
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Abbruchgrund:"
                            }),
                            " ",
                            syncErrorMessage,
                            errorReason ? ` | Typ: ${errorReason}` : "",
                            errorTimeoutMs !== null ? ` | Timeout: ${Math.round(errorTimeoutMs / 1000)}s` : "",
                            errorAttempt !== null && errorMaxAttempts !== null ? ` | Versuch: ${errorAttempt}/${errorMaxAttempts}` : "",
                            errorTarget ? ` | Endpoint: ${errorTarget}` : "",
                            errorOriginalMessage ? ` | Original: ${errorOriginalMessage}` : ""
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Units-Warnung:"
                            }),
                            " ",
                            unitWarn || "-"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Units-Diagnose:"
                            }),
                            " ",
                            unitDiag || "-"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Objekt/Einheit-Konsistenz:"
                            }),
                            " ",
                            `inaktiveObjekte=${$35849a2ba082badf$var$toNumber(unitConsistency?.inactiveObjectsTotal) ?? 0}, aktivInInaktivemObjekt(vorKaskade)=${$35849a2ba082badf$var$toNumber(unitConsistency?.activeUnitsInInactiveObjectsBefore) ?? 0}, perKaskadeInaktiv=${$35849a2ba082badf$var$toNumber(unitConsistency?.cascadeToInactive) ?? 0}`
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Probes:"
                            }),
                            " ",
                            `accountIds=${$35849a2ba082badf$var$toListText(ownerProbes?.accountIdProbe)}, noAccount=${$35849a2ba082badf$var$toListText(ownerProbes?.noAccountWarnings)}, contactFehler=${$35849a2ba082badf$var$toListText(ownerProbes?.accountContactWarnings)}`
                        ]
                    }),
                    missingOwnerContactList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Fehlende Eigent\xfcmer-Kontaktdaten (separate Liste):"
                            }),
                            " ",
                            `${missingOwnerContactList.length} eindeutige Party-ID(s)`,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 860
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Party-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Eigent\xfcmername"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt(e)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit(en)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Contract-ID(s)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Party-Kontakt"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Account-Aufl\xf6sung"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: missingOwnerContactList.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.partyId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.ownerNames.length ? entry.ownerNames.join(" | ") : "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objectNumbers.length ? entry.objectNumbers.join(", ") : "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.unitNumbers.length ? entry.unitNumbers.join(", ") : "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.contractIds.length ? entry.contractIds.join(", ") : "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.partyContactStatus || "-"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.accountResolutionStatus || "-"
                                                        })
                                                    ]
                                                }, entry.partyId))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    assignmentAnomalyNoActiveList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Zuordnungs-Anomalien: Einheiten ohne aktive Zuordnung (separate Liste):"
                            }),
                            " ",
                            `${assignmentAnomalyNoActiveList.length} Einheiten`,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-zuordnungsanomalie-ohne-aktiv-${row.id}.csv`, [
                                            "Objekt-Nr",
                                            "Einheit-Nr"
                                        ], assignmentAnomalyNoActiveList.map((entry)=>[
                                                entry.objektnummer,
                                                entry.einheitsnummer
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 360
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: assignmentAnomalyNoActiveList.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        })
                                                    ]
                                                }, `${entry.objektnummer}/${entry.einheitsnummer}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    assignmentAnomalyNoActiveReasonList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Zuordnungs-Anomalien ohne aktive Zuordnung: Gr\xfcnde"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-zuordnungsanomalie-ohne-aktiv-gruende-${row.id}.csv`, [
                                            "Grund",
                                            "Anzahl"
                                        ], assignmentAnomalyNoActiveReasonList.map((entry)=>[
                                                entry.reason,
                                                entry.count
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 360
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Grund"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Anzahl"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: assignmentAnomalyNoActiveReasonList.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.reason
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.count
                                                        })
                                                    ]
                                                }, entry.reason))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    assignmentAnomalyNoActiveDetailList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Zuordnungs-Anomalien ohne aktive Zuordnung: Detailprobe"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-zuordnungsanomalie-ohne-aktiv-detail-${row.id}.csv`, [
                                            "Objekt-Nr",
                                            "Einheit-Nr",
                                            "Details"
                                        ], assignmentAnomalyNoActiveDetailList.map((entry)=>[
                                                entry.objektnummer,
                                                entry.einheitsnummer,
                                                entry.details
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 980
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Details"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: assignmentAnomalyNoActiveDetailList.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.details
                                                        })
                                                    ]
                                                }, `${entry.objektnummer}/${entry.einheitsnummer}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    assignmentAnomalyNoActiveContractProbeList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Zuordnungs-Anomalien ohne aktive Zuordnung: Vertragskandidaten"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-zuordnungsanomalie-ohne-aktiv-vertragskandidaten-${row.id}.csv`, [
                                            "Objekt-Nr",
                                            "Einheit-Nr",
                                            "Eigent\xfcmer-ID",
                                            "Eigent\xfcmername",
                                            "Zuordnung-ID",
                                            "G\xfcltig ab",
                                            "G\xfcltig bis",
                                            "Status",
                                            "Grund"
                                        ], assignmentAnomalyNoActiveContractProbeList.map((entry)=>[
                                                entry.objektnummer,
                                                entry.einheitsnummer,
                                                entry.eigentuemerId,
                                                entry.eigentuemername,
                                                entry.assignmentId,
                                                entry.gueltigAb,
                                                entry.gueltigBis,
                                                entry.status,
                                                entry.reason
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 1120
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Eigent\xfcmer-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Eigent\xfcmer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Zuordnung-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "G\xfcltig ab"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "G\xfcltig bis"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Grund"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: assignmentAnomalyNoActiveContractProbeList.map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.eigentuemerId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.eigentuemername
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.assignmentId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.gueltigAb
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.gueltigBis
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.status
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.reason
                                                        })
                                                    ]
                                                }, `${entry.objektnummer}/${entry.einheitsnummer}/${entry.assignmentId}/${entry.eigentuemerId}/${index}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    focusUnitContractTypeSweepProbeList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "Fokus-Einheit Contract-Type-Sweep (",
                                    `${$35849a2ba082badf$var$toText(focusUnitProbeConfig?.objektnummer) || "0013"}/${$35849a2ba082badf$var$toText(focusUnitProbeConfig?.einheitsnummer) || "2"}`,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-fokus-einheit-type-sweep-${row.id}.csv`, [
                                            "Objekt-Nr",
                                            "Einheit-Nr",
                                            "API Unit-ID",
                                            "Type-Filter",
                                            "Query-Key",
                                            "Endpoint",
                                            "Status",
                                            "Raw Rows",
                                            "Mapped Rows",
                                            "Owner Typ 3",
                                            "Active Owner",
                                            "Earliest Owner From",
                                            "Latest Owner To",
                                            "Latest Owner To in Vergangenheit",
                                            "hasNext",
                                            "Sample Contract IDs",
                                            "Hinweis"
                                        ], focusUnitContractTypeSweepProbeList.map((entry)=>[
                                                entry.objektnummer,
                                                entry.einheitsnummer,
                                                entry.apiUnitId,
                                                entry.typeFilter,
                                                entry.queryKey,
                                                entry.endpoint,
                                                entry.status,
                                                entry.rawRows,
                                                entry.mappedRows,
                                                entry.ownerType3Rows,
                                                entry.activeOwnerRows,
                                                entry.earliestOwnerFrom,
                                                entry.latestOwnerTo,
                                                entry.isLatestOwnerToPast,
                                                entry.hasNext,
                                                entry.sampleContractIds,
                                                entry.hint
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 1750
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "API Unit-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Type-Filter"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Query-Key"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Endpoint"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Raw"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Mapped"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Owner Typ 3"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Active Owner"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Earliest"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Latest"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Latest Past"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "hasNext"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Sample Contract IDs"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Hinweis"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: focusUnitContractTypeSweepProbeList.map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.apiUnitId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.typeFilter
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.queryKey
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.endpoint
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.status
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.rawRows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.mappedRows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.ownerType3Rows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.activeOwnerRows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.earliestOwnerFrom
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.latestOwnerTo
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.isLatestOwnerToPast
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.hasNext
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.sampleContractIds
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.hint
                                                        })
                                                    ]
                                                }, `${entry.apiUnitId}/${entry.typeFilter}/${entry.queryKey}/${index}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    focusUnitOwnershipProbeList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "Fokus-Einheit Ownership-Endpoints (",
                                    `${$35849a2ba082badf$var$toText(focusUnitProbeConfig?.objektnummer) || "0013"}/${$35849a2ba082badf$var$toText(focusUnitProbeConfig?.einheitsnummer) || "2"}`,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-fokus-einheit-ownership-endpoints-${row.id}.csv`, [
                                            "Objekt-Nr",
                                            "Einheit-Nr",
                                            "API Unit-ID",
                                            "Property-ID",
                                            "Endpoint",
                                            "Status",
                                            "Payload Rows",
                                            "Embedded Rows",
                                            "Source Rows",
                                            "Matched Rows",
                                            "Matched Key Sample",
                                            "Matched Sample",
                                            "Hinweis"
                                        ], focusUnitOwnershipProbeList.map((entry)=>[
                                                entry.objektnummer,
                                                entry.einheitsnummer,
                                                entry.apiUnitId,
                                                entry.propertyId,
                                                entry.endpoint,
                                                entry.status,
                                                entry.payloadRows,
                                                entry.embeddedRows,
                                                entry.sourceRows,
                                                entry.matchedRows,
                                                entry.matchedKeySample,
                                                entry.matchedSample,
                                                entry.hint
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 1750
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "API Unit-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Property-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Endpoint"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Payload"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Embedded"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Source"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Matched"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Matched Key Sample"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Matched Sample"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Hinweis"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: focusUnitOwnershipProbeList.map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.apiUnitId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.propertyId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.endpoint
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.status
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.payloadRows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.embeddedRows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.sourceRows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.matchedRows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.matchedKeySample
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.matchedSample
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.hint
                                                        })
                                                    ]
                                                }, `${entry.propertyId}/${entry.apiUnitId}/${entry.endpoint}/${index}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    focusOwnerUnitProbeList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "Fokus-Eigent\xfcmer Units (",
                                    `${$35849a2ba082badf$var$toText(focusOwnerUnitProbeConfig?.partyId) || "788388"}${$35849a2ba082badf$var$toText(focusOwnerUnitProbeConfig?.objektnummer) ? ` | Objekt ${$35849a2ba082badf$var$toText(focusOwnerUnitProbeConfig?.objektnummer)}` : ""}`,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-fokus-eigentuemer-units-${row.id}.csv`, [
                                            "Party-ID",
                                            "Eigent\xfcmer",
                                            "Objekt-Nr",
                                            "Einheit-Nr",
                                            "API Unit-ID",
                                            "Property-ID",
                                            "Contract-ID",
                                            "Typ",
                                            "isArchived",
                                            "isCurrent",
                                            "G\xfcltig ab",
                                            "G\xfcltig bis",
                                            "Aktiv (Fenster)",
                                            "Aktiv (Legacy)",
                                            "Status",
                                            "Hinweis"
                                        ], focusOwnerUnitProbeList.map((entry)=>[
                                                entry.partyId,
                                                entry.eigentuemer,
                                                entry.objektnummer,
                                                entry.einheitsnummer,
                                                entry.apiUnitId,
                                                entry.propertyId,
                                                entry.contractId,
                                                entry.type,
                                                entry.isArchived,
                                                entry.isCurrent,
                                                entry.gueltigAb,
                                                entry.gueltigBis,
                                                entry.activeByWindow,
                                                entry.activeByLegacy,
                                                entry.status,
                                                entry.hinweis
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 1700
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Party-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Eigent\xfcmer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "API Unit-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Property-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Contract-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Typ"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "isArchived"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "isCurrent"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "G\xfcltig ab"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "G\xfcltig bis"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Aktiv (Fenster)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Aktiv (Legacy)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Hinweis"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: focusOwnerUnitProbeList.map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.partyId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.eigentuemer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.apiUnitId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.propertyId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.contractId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.type
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.isArchived
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.isCurrent
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.gueltigAb
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.gueltigBis
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.activeByWindow
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.activeByLegacy
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.status
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.hinweis
                                                        })
                                                    ]
                                                }, `${entry.status}/${entry.partyId}/${entry.objektnummer}/${entry.einheitsnummer}/${entry.contractId}/${index}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    focusUnitContractProbeList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "Fokus-Einheit Vertragsprobe (",
                                    `${$35849a2ba082badf$var$toText(focusUnitProbeConfig?.objektnummer) || "0013"}/${$35849a2ba082badf$var$toText(focusUnitProbeConfig?.einheitsnummer) || "2"}`,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-fokus-einheit-vertragsprobe-${row.id}.csv`, [
                                            "Objekt-Nr",
                                            "Einheit-Nr",
                                            "API Unit-ID",
                                            "Contract-ID",
                                            "Party-ID",
                                            "Eigent\xfcmer",
                                            "Typ",
                                            "isArchived",
                                            "isCurrent",
                                            "G\xfcltig ab",
                                            "G\xfcltig bis",
                                            "Aktiv (Fenster)",
                                            "Aktiv (Legacy)",
                                            "Status",
                                            "Hinweis"
                                        ], focusUnitContractProbeList.map((entry)=>[
                                                entry.objektnummer,
                                                entry.einheitsnummer,
                                                entry.apiUnitId,
                                                entry.contractId,
                                                entry.partyId,
                                                entry.eigentuemer,
                                                entry.type,
                                                entry.isArchived,
                                                entry.isCurrent,
                                                entry.gueltigAb,
                                                entry.gueltigBis,
                                                entry.activeByWindow,
                                                entry.activeByLegacy,
                                                entry.status,
                                                entry.hinweis
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 1480
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "API Unit-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Contract-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Party-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Eigent\xfcmer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Typ"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "isArchived"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "isCurrent"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "G\xfcltig ab"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "G\xfcltig bis"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Aktiv (Fenster)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Aktiv (Legacy)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Hinweis"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: focusUnitContractProbeList.map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.apiUnitId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.contractId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.partyId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.eigentuemer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.type
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.isArchived
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.isCurrent
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.gueltigAb
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.gueltigBis
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.activeByWindow
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.activeByLegacy
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.status
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.hinweis
                                                        })
                                                    ]
                                                }, `${entry.objektnummer}/${entry.einheitsnummer}/${entry.apiUnitId}/${entry.contractId}/${entry.partyId}/${index}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    focusObjectContractMatrixList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "Fokus-Objekt Unit-/Vertragsmatrix (",
                                    `${$35849a2ba082badf$var$toText(focusUnitProbeConfig?.objektnummer) || "0013"}`,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-fokus-objekt-vertragsmatrix-${row.id}.csv`, [
                                            "Objekt-Nr",
                                            "API Unit-ID",
                                            "Einheit-Nr",
                                            "Aufgang-Ref",
                                            "Aufgang-Name",
                                            "Status",
                                            "Einheitstyp",
                                            "Bezeichnung",
                                            "Vertr\xe4ge gesamt",
                                            "Owner-Vertr\xe4ge (Typ 3)",
                                            "Aktive Owner-Vertr\xe4ge",
                                            "Fr\xfchestes von",
                                            "Sp\xe4testes bis",
                                            "Fetch-Status",
                                            "Fetch-Warnung"
                                        ], focusObjectContractMatrixList.map((entry)=>[
                                                entry.objektnummer,
                                                entry.apiUnitId,
                                                entry.einheitsnummer,
                                                entry.aufgangRef,
                                                entry.aufgangName,
                                                entry.status,
                                                entry.einheitstyp,
                                                entry.bezeichnung,
                                                entry.contractRows,
                                                entry.ownerType3Rows,
                                                entry.activeOwnerRows,
                                                entry.earliestFrom,
                                                entry.latestTo,
                                                entry.fetchStatus,
                                                entry.fetchWarning
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 1600
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "API Unit-ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Aufgang-Ref"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Aufgang-Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheitstyp"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Bezeichnung"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Vertr\xe4ge gesamt"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Owner-Vertr\xe4ge (Typ 3)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Aktive Owner-Vertr\xe4ge"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Fr\xfchestes von"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Sp\xe4testes bis"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Fetch-Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Fetch-Warnung"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: focusObjectContractMatrixList.map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.apiUnitId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.aufgangRef
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.aufgangName
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.status
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitstyp
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.bezeichnung
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.contractRows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.ownerType3Rows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.activeOwnerRows
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.earliestFrom
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.latestTo
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.fetchStatus
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.fetchWarning
                                                        })
                                                    ]
                                                }, `${entry.apiUnitId}/${entry.einheitsnummer}/${entry.aufgangRef}/${index}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    assignmentAnomalyMultiActiveList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Zuordnungs-Anomalien: Einheiten mit mehrfach aktiver Zuordnung (separate Liste):"
                            }),
                            " ",
                            `${assignmentAnomalyMultiActiveList.length} Einheiten`,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>$35849a2ba082badf$var$downloadCsv(`debug-zuordnungsanomalie-mehrfach-aktiv-${row.id}.csv`, [
                                            "Objekt-Nr",
                                            "Einheit-Nr",
                                            "Aktive Eigent\xfcmer"
                                        ], assignmentAnomalyMultiActiveList.map((entry)=>[
                                                entry.objektnummer,
                                                entry.einheitsnummer,
                                                entry.activeOwnersSummary
                                            ])),
                                    children: "CSV Export"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 980
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Aktive Eigent\xfcmer"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: assignmentAnomalyMultiActiveList.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.activeOwnersSummary
                                                        })
                                                    ]
                                                }, `${entry.objektnummer}/${entry.einheitsnummer}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    objectUnitConsistencyList.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: debugSectionStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Objekt/Einheit-Anomalien (separate Liste):"
                            }),
                            " ",
                            `${objectUnitConsistencyList.length} Einheiten (vor Kaskade aktiv in inaktivem Objekt)`,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    style: {
                                        minWidth: 360
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Objekt-Nr"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Einheit-Nr"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: objectUnitConsistencyList.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.objektnummer
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: entry.einheitsnummer
                                                        })
                                                    ]
                                                }, `${entry.objektnummer}/${entry.einheitsnummer}`))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Mirror-Cleanup:"
                            }),
                            " ",
                            `Kandidaten=${$35849a2ba082badf$var$toNumber(mirrorCleanup?.candidates) ?? 0}, gel\xf6scht=${$35849a2ba082badf$var$toNumber(mirrorCleanup?.deleted) ?? 0}`
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "In App:"
                            }),
                            " ",
                            `Objekte ${$35849a2ba082badf$var$toNumber(inAppObjects?.active) ?? 0}/${$35849a2ba082badf$var$toNumber(inAppObjects?.total) ?? 0}, Einheiten ${$35849a2ba082badf$var$toNumber(inAppUnits?.active) ?? 0}/${$35849a2ba082badf$var$toNumber(inAppUnits?.total) ?? 0}`
                        ]
                    }),
                    contactDebug ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Kontakt-Debug:"
                            }),
                            " ",
                            contactDebug
                        ]
                    }) : null
                ]
            })
        ]
    });
};
const $35849a2ba082badf$var$AuditPageContent = ()=>{
    const isFrameworkV2 = typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    const [syncPage, setSyncPage] = (0, $acw62.useState)(1);
    const [syncStatusFilter, setSyncStatusFilter] = (0, $acw62.useState)("all");
    const [syncTriggerFilter, setSyncTriggerFilter] = (0, $acw62.useState)("all");
    const [faciliooDebugAccountId, setFaciliooDebugAccountId] = (0, $acw62.useState)("");
    const [faciliooDebugContractId, setFaciliooDebugContractId] = (0, $acw62.useState)("");
    const [faciliooDebugProcessRef, setFaciliooDebugProcessRef] = (0, $acw62.useState)("");
    const [faciliooProcessFeedTestEnabled, setFaciliooProcessFeedTestEnabled] = (0, $acw62.useState)(false);
    const [faciliooProcessFeedTestText, setFaciliooProcessFeedTestText] = (0, $acw62.useState)("");
    const [faciliooMasterDataProbePending, setFaciliooMasterDataProbePending] = (0, $acw62.useState)(false);
    const [faciliooMasterDataProbe, setFaciliooMasterDataProbe] = (0, $acw62.useState)(null);
    const [faciliooMasterDataProbeError, setFaciliooMasterDataProbeError] = (0, $acw62.useState)(null);
    const [faciliooContractTestPending, setFaciliooContractTestPending] = (0, $acw62.useState)(false);
    const [faciliooContractTestResult, setFaciliooContractTestResult] = (0, $acw62.useState)(null);
    const [faciliooContractTestError, setFaciliooContractTestError] = (0, $acw62.useState)(null);
    const [faciliooProcessTestPending, setFaciliooProcessTestPending] = (0, $acw62.useState)(false);
    const [faciliooProcessTestResult, setFaciliooProcessTestResult] = (0, $acw62.useState)(null);
    const [faciliooProcessTestError, setFaciliooProcessTestError] = (0, $acw62.useState)(null);
    const [faciliooDebugStatus, setFaciliooDebugStatus] = (0, $acw62.useState)(null);
    const { data: uiSettings } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-audit"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings()
    });
    const faciliooEnabled = uiSettings?.management?.faciliooEnabled !== false;
    const { data: faciliooSyncStatusData, error: faciliooSyncStatusError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "facilioo-sync-status-debug-page"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).getFaciliooSyncStatus(),
        enabled: faciliooEnabled,
        staleTime: 60000,
        refetchInterval: 60000,
        retry: false,
        throwOnError: false
    });
    const { data: assignmentAnomalies, error: assignmentAnomaliesError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "debug-assignment-anomalies"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).assignmentAnomalies(),
        retry: false,
        throwOnError: false
    });
    const unitsWithoutActiveAssignment = (0, $acw62.useMemo)(()=>assignmentAnomalies?.unitsWithoutActiveAssignment ?? [], [
        assignmentAnomalies?.unitsWithoutActiveAssignment
    ]);
    const unitsWithMultipleActiveAssignments = (0, $acw62.useMemo)(()=>assignmentAnomalies?.unitsWithMultipleActiveAssignments ?? [], [
        assignmentAnomalies?.unitsWithMultipleActiveAssignments
    ]);
    const lastRun = faciliooSyncStatusData?.lastRun;
    const lastRunLabel = lastRun?.finishedAt || lastRun?.startedAt ? new Date(lastRun.finishedAt || lastRun.startedAt || "").toLocaleString("de-DE") : "-";
    const datasetStats = [
        {
            key: "objects",
            label: "Objekte",
            stats: lastRun?.datasets?.objects
        },
        {
            key: "units",
            label: "Einheiten",
            stats: lastRun?.datasets?.units
        },
        {
            key: "owners",
            label: "Eigent\xfcmer",
            stats: lastRun?.datasets?.owners
        },
        {
            key: "assignments",
            label: "Zuordnungen",
            stats: lastRun?.datasets?.assignments
        }
    ];
    const { data: faciliooSyncData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "facilioo-sync-audit-page",
            syncPage,
            syncStatusFilter,
            syncTriggerFilter
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).faciliooSyncLogs({
                page: syncPage,
                pageSize: 25,
                status: syncStatusFilter === "all" ? undefined : syncStatusFilter,
                trigger: syncTriggerFilter === "all" ? undefined : syncTriggerFilter
            }),
        enabled: faciliooEnabled
    });
    const syncRows = (0, $acw62.useMemo)(()=>Array.isArray(faciliooSyncData?.data) ? faciliooSyncData.data.filter($35849a2ba082badf$var$isRecord) : [], [
        faciliooSyncData?.data
    ]);
    const syncTotal = faciliooSyncData?.meta.total ?? 0;
    const syncPageSize = faciliooSyncData?.meta.pageSize ?? 25;
    const syncTotalPages = Math.max(1, Math.ceil(syncTotal / syncPageSize));
    const runFaciliooMasterDataProbe = async ()=>{
        setFaciliooMasterDataProbePending(true);
        setFaciliooMasterDataProbeError(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).probeFaciliooMasterData();
            setFaciliooMasterDataProbe(result);
        } catch (error) {
            setFaciliooMasterDataProbe(null);
            setFaciliooMasterDataProbeError(error instanceof Error ? error.message : "Master-Data-Probe fehlgeschlagen");
        } finally{
            setFaciliooMasterDataProbePending(false);
        }
    };
    const runFaciliooContactDebugSyncNow = async ()=>{
        const accountId = faciliooDebugAccountId.trim();
        if (!accountId) {
            setFaciliooDebugStatus({
                type: "error",
                text: "Bitte eine Debug-Account-ID eingeben."
            });
            return;
        }
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).runFaciliooSyncNow(undefined, accountId);
            setFaciliooDebugStatus({
                type: "ok",
                text: result.message || "Kontakt-Debug-Sync gestartet."
            });
        } catch (error) {
            setFaciliooDebugStatus({
                type: "error",
                text: error instanceof Error ? error.message : "Kontakt-Debug-Sync fehlgeschlagen."
            });
        }
    };
    const runFaciliooContractDebug = async ()=>{
        const contractId = faciliooDebugContractId.trim();
        if (!contractId) {
            setFaciliooContractTestError("Bitte eine Contract-ID eingeben.");
            setFaciliooContractTestResult(null);
            return;
        }
        setFaciliooContractTestPending(true);
        setFaciliooContractTestError(null);
        setFaciliooContractTestResult(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getFaciliooContractLive(contractId);
            setFaciliooContractTestResult(result);
        } catch (error) {
            setFaciliooContractTestError(error instanceof Error ? error.message : "Contract-Debug fehlgeschlagen");
        } finally{
            setFaciliooContractTestPending(false);
        }
    };
    const runFaciliooProcessDebug = async ()=>{
        const processRef = faciliooDebugProcessRef.trim();
        if (!processRef) {
            setFaciliooProcessTestError("Bitte eine Vorgangs-ID oder Vorgangsnummer eingeben.");
            setFaciliooProcessTestResult(null);
            return;
        }
        setFaciliooProcessTestPending(true);
        setFaciliooProcessTestError(null);
        setFaciliooProcessTestResult(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolveFaciliooProcess(processRef, {
                postFeedEntry: faciliooProcessFeedTestEnabled,
                feedText: faciliooProcessFeedTestText.trim() || undefined
            });
            setFaciliooProcessTestResult(result);
        } catch (error) {
            setFaciliooProcessTestError(error instanceof Error ? error.message : "Vorgangs-Debug fehlgeschlagen");
        } finally{
            setFaciliooProcessTestPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: isFrameworkV2 ? "resolutions-v2-page debug-v2-page" : undefined,
        children: [
            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "page-header panel resolutions-v2-page-header debug-v2-page-header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    className: "resolutions-v2-title",
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "resolutions-v2-title-icon",
                            "aria-hidden": "true",
                            children: $35849a2ba082badf$var$debugTitleIcon
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "resolutions-v2-title-copy",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-main",
                                    children: "Debug"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-sub",
                                    children: "Facilioo-Datenstand, Diagnosewerkzeuge und Synchronisationsdetails"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel debug-v2-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        style: {
                            marginTop: 0
                        },
                        children: "Debug | Facilioo Datenstand"
                    }),
                    faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "kpi-grid",
                                style: {
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "kpi",
                                        children: [
                                            "Facilioo Live-Sync",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: faciliooSyncStatusData?.enabled ? "Aktiv" : "Inaktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                style: {
                                                    color: "#5a6875"
                                                },
                                                children: [
                                                    "Letzter Lauf: ",
                                                    lastRunLabel
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "kpi",
                                        children: [
                                            "Einheiten ohne aktive Zuordnung",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: unitsWithoutActiveAssignment.length
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                style: {
                                                    color: "#5a6875"
                                                },
                                                children: [
                                                    "Gesamt relevant: ",
                                                    unitsWithoutActiveAssignment.length,
                                                    assignmentAnomalies?.ignoredUnitsWithoutActiveAssignment.length ? ` | Sonstiges/Info: ${assignmentAnomalies.ignoredUnitsWithoutActiveAssignment.length}` : ""
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "kpi",
                                        children: [
                                            "Mehrfach aktive Zuordnungen",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: unitsWithMultipleActiveAssignments.length
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                style: {
                                                    color: "#5a6875"
                                                },
                                                children: [
                                                    "Gesamt relevant: ",
                                                    unitsWithMultipleActiveAssignments.length
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginBottom: 10
                                },
                                children: datasetStats.map((dataset)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "badge",
                                        style: {
                                            marginRight: 8,
                                            marginBottom: 8
                                        },
                                        children: [
                                            dataset.label,
                                            ": geholt ",
                                            dataset.stats?.fetched ?? 0,
                                            ", neu ",
                                            dataset.stats?.created ?? 0,
                                            ", aktualisiert ",
                                            dataset.stats?.updated ?? 0
                                        ]
                                    }, dataset.key))
                            }),
                            faciliooSyncStatusError || assignmentAnomaliesError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginBottom: 8
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                    style: {
                                        color: "#b42318",
                                        fontWeight: 600
                                    },
                                    children: [
                                        "Debug-Daten konnten teilweise nicht geladen werden:",
                                        ` ${faciliooSyncStatusError instanceof Error ? faciliooSyncStatusError.message : ""}`,
                                        ` ${assignmentAnomaliesError instanceof Error ? assignmentAnomaliesError.message : ""}`
                                    ]
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($35849a2ba082badf$var$AssignmentAnomalyDebugList, {
                                id: "assignment-anomalies-without",
                                title: "Einheiten ohne aktive Zuordnung",
                                units: unitsWithoutActiveAssignment,
                                csvFilenamePrefix: "debug-einheiten-ohne-aktive-zuordnung",
                                emptyText: "Keine Einheiten ohne aktive Zuordnung f\xfcr die aktuelle Suche/Filter gefunden.",
                                ignoredInfoCount: assignmentAnomalies?.ignoredUnitsWithoutActiveAssignment.length ?? 0,
                                hint: (unit)=>String(unit.einheitstyp ?? "").trim().toLowerCase() === "sonstiges" ? "Typ Sonstiges: in der Regel ohne Eigent\xfcmerzuordnung fachlich korrekt." : "-"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($35849a2ba082badf$var$AssignmentAnomalyDebugList, {
                                id: "assignment-anomalies-multiple",
                                title: "Einheiten mit mehrfach aktiver Zuordnung",
                                units: unitsWithMultipleActiveAssignments,
                                csvFilenamePrefix: "debug-einheiten-mit-mehrfach-aktiver-zuordnung",
                                emptyText: "Keine Einheiten mit mehrfach aktiver Zuordnung f\xfcr die aktuelle Suche/Filter gefunden.",
                                hint: (unit)=>`Aktive Zuordnungen: ${unit.activeAssignmentCount}`
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                        style: {
                            color: "#5a6875"
                        },
                        children: "Facilioo ist derzeit global deaktiviert."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form debug-v2-section debug-v2-tools-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        style: {
                            marginTop: 0
                        },
                        children: "Debug | Facilioo"
                    }),
                    faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "panel-inset",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Debug-Account-ID (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    value: faciliooDebugAccountId,
                                                    placeholder: "z. B. 789448",
                                                    onChange: (e)=>setFaciliooDebugAccountId(e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Debug-Contract-ID (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    value: faciliooDebugContractId,
                                                    placeholder: "z. B. 5764878",
                                                    onChange: (e)=>setFaciliooDebugContractId(e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field form-field-wide",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Debug-Vorgang (ID/Nummer)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    value: faciliooDebugProcessRef,
                                                    placeholder: "z. B. 123456 oder 9876543210",
                                                    onChange: (e)=>setFaciliooDebugProcessRef(e.target.value)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "result-visibility-switch imports-facilioo-switch",
                                                    "aria-label": "Feed-Testeintrag in Vorgangsverlauf schreiben",
                                                    style: {
                                                        marginTop: 8
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: "result-visibility-input",
                                                            type: "checkbox",
                                                            checked: faciliooProcessFeedTestEnabled,
                                                            onChange: (e)=>setFaciliooProcessFeedTestEnabled(e.target.checked)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: `result-visibility-track ${faciliooProcessFeedTestEnabled ? "is-on" : ""}`,
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "result-visibility-thumb"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Feed-Testeintrag schreiben"
                                                        })
                                                    ]
                                                }),
                                                faciliooProcessFeedTestEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                    value: faciliooProcessFeedTestText,
                                                    placeholder: "Optionaler Feed-Text (leer = automatisch erzeugter Debug-Text)",
                                                    onChange: (e)=>setFaciliooProcessFeedTestText(e.target.value),
                                                    rows: 3,
                                                    style: {
                                                        width: "100%",
                                                        marginTop: 8,
                                                        resize: "vertical"
                                                    }
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions imports-facilioo-actions-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: faciliooMasterDataProbePending,
                                        onClick: runFaciliooMasterDataProbe,
                                        children: faciliooMasterDataProbePending ? "Objekte/Einheiten werden gez\xe4hlt..." : "Objekte/Einheiten z\xe4hlen"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: runFaciliooContactDebugSyncNow,
                                        children: "Kontakt-Debug (Account)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: faciliooContractTestPending,
                                        onClick: runFaciliooContractDebug,
                                        children: faciliooContractTestPending ? "Contract-Debug l\xe4uft..." : "Contract-Debug (Facilioo)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: faciliooProcessTestPending,
                                        onClick: runFaciliooProcessDebug,
                                        children: faciliooProcessTestPending ? "Vorgangs-Debug l\xe4uft..." : "Vorgangs-Debug (Facilioo)"
                                    })
                                ]
                            }),
                            faciliooDebugStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                style: {
                                    color: faciliooDebugStatus.type === "ok" ? "#0f7b31" : "#b42318",
                                    fontWeight: 600
                                },
                                children: faciliooDebugStatus.text
                            }) : null,
                            faciliooMasterDataProbeError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                style: {
                                    color: "#b42318",
                                    fontWeight: 600
                                },
                                children: faciliooMasterDataProbeError
                            }) : null,
                            faciliooMasterDataProbe ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "panel-inset",
                                style: {
                                    marginTop: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Facilioo Master-Data Probe"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            marginTop: 6,
                                            fontSize: 13
                                        },
                                        children: [
                                            "Modus: ",
                                            faciliooMasterDataProbe.mode === "count" ? "Count" : "Full",
                                            " | Dauer: ",
                                            $35849a2ba082badf$var$formatDurationLabel(faciliooMasterDataProbe.durationMs)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            marginTop: 4,
                                            fontSize: 13
                                        },
                                        children: [
                                            "Objekte: ",
                                            faciliooMasterDataProbe.objects.totalCount,
                                            " | Einheiten: ",
                                            faciliooMasterDataProbe.units.totalCount
                                        ]
                                    })
                                ]
                            }) : null,
                            faciliooContractTestError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                style: {
                                    color: "#b42318",
                                    fontWeight: 600
                                },
                                children: faciliooContractTestError
                            }) : null,
                            faciliooContractTestResult ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "panel-inset",
                                style: {
                                    marginTop: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Contract-Debug Ergebnis"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                        style: {
                                            marginTop: 8,
                                            whiteSpace: "pre-wrap"
                                        },
                                        children: JSON.stringify(faciliooContractTestResult, null, 2)
                                    })
                                ]
                            }) : null,
                            faciliooProcessTestError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                style: {
                                    color: "#b42318",
                                    fontWeight: 600
                                },
                                children: faciliooProcessTestError
                            }) : null,
                            faciliooProcessTestResult ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "panel-inset",
                                style: {
                                    marginTop: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Vorgangs-Debug Ergebnis"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                        style: {
                                            marginTop: 8,
                                            whiteSpace: "pre-wrap"
                                        },
                                        children: JSON.stringify(faciliooProcessTestResult, null, 2)
                                    })
                                ]
                            }) : null
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                        style: {
                            color: "#5a6875"
                        },
                        children: "Facilioo ist derzeit global deaktiviert."
                    })
                ]
            }),
            faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel debug-v2-section debug-v2-sync-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        style: {
                            marginTop: 0
                        },
                        children: "Debug | Facilioo Synchronisationen"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: 16,
                            alignItems: "center",
                            marginBottom: 10,
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "imports-type-toggle",
                                role: "tablist",
                                "aria-label": "Filter Status",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: syncStatusFilter === "all" ? "is-active" : "",
                                        onClick: ()=>{
                                            setSyncStatusFilter("all");
                                            setSyncPage(1);
                                        },
                                        children: "Alle Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: syncStatusFilter === "ok" ? "is-active" : "",
                                        onClick: ()=>{
                                            setSyncStatusFilter("ok");
                                            setSyncPage(1);
                                        },
                                        children: "OK"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: syncStatusFilter === "error" ? "is-active" : "",
                                        onClick: ()=>{
                                            setSyncStatusFilter("error");
                                            setSyncPage(1);
                                        },
                                        children: "Fehler"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "imports-type-toggle",
                                role: "tablist",
                                "aria-label": "Filter Ausf\xfchrung",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: syncTriggerFilter === "all" ? "is-active" : "",
                                        onClick: ()=>{
                                            setSyncTriggerFilter("all");
                                            setSyncPage(1);
                                        },
                                        children: "Alle L\xe4ufe"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: syncTriggerFilter === "manual" ? "is-active" : "",
                                        onClick: ()=>{
                                            setSyncTriggerFilter("manual");
                                            setSyncPage(1);
                                        },
                                        children: "Manuell"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: syncTriggerFilter === "auto" ? "is-active" : "",
                                        onClick: ()=>{
                                            setSyncTriggerFilter("auto");
                                            setSyncPage(1);
                                        },
                                        children: "Automatisch"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginBottom: 8,
                            fontSize: 12,
                            color: "#5a6875"
                        },
                        children: [
                            "Zeilen: ",
                            syncRows.length,
                            " / Gesamt: ",
                            syncTotal
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            overflowX: "auto",
                            overflowY: "visible",
                            maxHeight: 420
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    width: 140
                                                },
                                                children: "Zeitpunkt"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    width: 90
                                                },
                                                children: "Ausf\xfchrung"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    width: 74
                                                },
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    width: 130
                                                },
                                                children: "Benutzer/System"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                style: {
                                                    width: 90
                                                },
                                                children: "Lauf-ID"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: syncRows.reduce((acc, row)=>{
                                        const safeRow = $35849a2ba082badf$var$isRecord(row) ? row : {};
                                        const action = $35849a2ba082badf$var$toText(safeRow.action);
                                        const rowId = $35849a2ba082badf$var$toText(safeRow.id) || `${$35849a2ba082badf$var$toText(safeRow.createdAt)}-${action}-${$35849a2ba082badf$var$toText(safeRow.entity_id)}`;
                                        acc.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $35849a2ba082badf$var$toText(safeRow.createdAt)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $35849a2ba082badf$var$faciliooSyncTrigger(action)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: action.endsWith("_failed") ? "badge import-failed" : "badge import-imported",
                                                        children: $35849a2ba082badf$var$faciliooSyncStatusLabel(action)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $35849a2ba082badf$var$toText(safeRow.actor_name)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $35849a2ba082badf$var$toText(safeRow.entity_id)
                                                })
                                            ]
                                        }, `main-${rowId}`), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: 5,
                                                style: {
                                                    paddingTop: 0
                                                },
                                                children: $35849a2ba082badf$var$renderFaciliooDebug(row)
                                            })
                                        }, `debug-${rowId}`));
                                        return acc;
                                    }, [])
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginTop: 10,
                            display: "flex",
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setSyncPage(Math.max(1, syncPage - 1)),
                                disabled: syncPage <= 1,
                                children: "Zur\xfcck"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    fontSize: 13
                                },
                                children: [
                                    "Seite ",
                                    syncPage,
                                    " / ",
                                    syncTotalPages
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>setSyncPage(Math.min(syncTotalPages, syncPage + 1)),
                                disabled: syncPage >= syncTotalPages,
                                children: "Weiter"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel debug-v2-section debug-v2-sync-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        style: {
                            marginTop: 0
                        },
                        children: "Debug | Facilioo Synchronisationen"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                        style: {
                            color: "#5a6875"
                        },
                        children: "Facilioo ist derzeit global deaktiviert. Daher werden keine Synchronisations-Logs angezeigt."
                    })
                ]
            })
        ]
    });
};
const $35849a2ba082badf$export$a85d3c0b6e100dd4 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($35849a2ba082badf$var$AuditPageContent, {});





var $acw62 = parcelRequire("acw62");



const $aa5cd7096308004a$var$importLabel = (value)=>{
    if (value === "objects") return "Objekte";
    if (value === "units") return "Einheiten";
    if (value === "owners") return "Eigent\xfcmer";
    return "Zuordnungen";
};
const $aa5cd7096308004a$var$statusLabel = (value)=>{
    if (value === "uploaded") return "Hochgeladen";
    if (value === "validated") return "Validiert";
    if (value === "failed") return "Fehlerhaft";
    return "Importiert";
};
const $aa5cd7096308004a$var$statusBadgeClass = (value)=>{
    if (value === "uploaded") return "badge import-uploaded";
    if (value === "validated") return "badge import-validated";
    if (value === "failed") return "badge import-failed";
    return "badge import-imported";
};
const $aa5cd7096308004a$var$importSourceLabel = (row)=>row.filename?.toLowerCase().startsWith("facilioo-") ? "Facilioo-Dateiimport" : "Manueller Dateiimport";
const $aa5cd7096308004a$var$faciliooSyncStatus = (action)=>action.endsWith("_failed") ? "Fehler" : "OK";
const $aa5cd7096308004a$var$faciliooSyncTrigger = (action)=>{
    if (action.includes("_auto_")) return "Automatisch";
    if (action.includes("_manual_")) return "Manuell";
    return "Unbekannt";
};
const $aa5cd7096308004a$var$faciliooWebhookStatus = (row)=>{
    if (row.db_state === "processed" || row.db_processed === true) return "Processed";
    if (row.db_state === "processing") return "Processing";
    if (row.db_state === "queued") return "Queued";
    if (row.action.endsWith("_deduplicated")) return "Deduplicated";
    return "Queued";
};
const $aa5cd7096308004a$var$faciliooWebhookStatusBadgeClass = (row)=>{
    if (row.db_state === "processed" || row.db_processed === true) return "badge import-imported";
    if (row.db_state === "processing") return "badge import-validated";
    if (row.db_state === "queued") return "badge import-uploaded";
    if (row.action.endsWith("_deduplicated")) return "badge import-validated";
    return "badge import-uploaded";
};
const $aa5cd7096308004a$var$readWebhookChange = (row, key)=>{
    if (!row.changes_json || typeof row.changes_json !== "object") return "-";
    const value = row.changes_json[key];
    if (value === undefined || value === null) return "-";
    const text = String(value).trim();
    return text || "-";
};
const $aa5cd7096308004a$var$webhookDbStatusLabel = (row)=>{
    const reasonRaw = String(row.db_error_message ?? "").trim();
    const reason = reasonRaw.toLowerCase();
    const blockedReasonLabel = reason === "blocked_by_sync_running" ? "blockiert: anderer Sync l\xe4uft" : reason === "blocked_by_webhook_disabled" ? "blockiert: Webhook deaktiviert" : reason === "blocked_by_missing_facilioo_api_key" ? "blockiert: API-Key fehlt" : "";
    if (row.db_state === "processed" || row.db_processed === true) return "Ja";
    if (row.db_state === "queued") return blockedReasonLabel ? `Nein (queued, ${blockedReasonLabel})` : "Nein (queued)";
    if (row.db_state === "processing") return "Nein (processing)";
    return "-";
};
const $aa5cd7096308004a$var$normalizeMojibake = (value)=>{
    const text = String(value ?? "");
    return text.replace(/ÃƒÂ¤/g, "\xe4").replace(/ÃƒÂ„/g, "\xc4").replace(/ÃƒÂ¶/g, "\xf6").replace(/ÃƒÂ–/g, "\xd6").replace(/ÃƒÂ¼/g, "\xfc").replace(/ÃƒÂœ/g, "\xdc").replace(/ÃƒÂŸ/g, "\xdf").replace(/Ã¤/g, "\xe4").replace(/Ã„/g, "\xc4").replace(/Ã¶/g, "\xf6").replace(/Ã–/g, "\xd6").replace(/Ã¼/g, "\xfc").replace(/Ãœ/g, "\xdc").replace(/ÃŸ/g, "\xdf").replace(/Â/g, "").replace(/â€“/g, "\u2013").replace(/â€”/g, "\u2014").replace(/â€ž/g, "\u201E").replace(/â€œ/g, "\u201C");
};
const $aa5cd7096308004a$var$extractUnitNumbers = (value)=>{
    const text = String(value ?? "").trim();
    if (!text) return "-";
    const parts = text.split("|").map((part)=>part.trim()).filter(Boolean);
    const units = parts.map((part)=>{
        const slashMatch = part.match(/\/\s*([0-9]{1,6})\b/);
        if (slashMatch?.[1]) return slashMatch[1];
        const plainNumber = part.match(/\b([0-9]{1,6})\b/);
        return plainNumber?.[1] ?? "";
    }).filter(Boolean).map((unit)=>/^\d+$/.test(unit) ? unit.padStart(4, "0") : unit);
    return units.length ? Array.from(new Set(units)).join(" | ") : "-";
};
const $aa5cd7096308004a$var$voteBadgeLabel = (value)=>{
    const v = String(value ?? "").trim().toLowerCase();
    if (v === "ja") return "Ja";
    if (v === "nein") return "Nein";
    if (v === "enthaltung") return "Enthaltung";
    if (v === "offen") return "Offen";
    return $aa5cd7096308004a$var$normalizeMojibake(value || "-");
};
const $aa5cd7096308004a$var$voteBadgeClass = (value)=>{
    const v = String(value ?? "").trim().toLowerCase();
    if (v === "ja") return "badge vote-ja";
    if (v === "nein") return "badge vote-nein";
    if (v === "enthaltung") return "badge vote-enthaltung";
    if (v === "offen") return "badge vote-offen";
    return "badge";
};
const $aa5cd7096308004a$var$formatVoteEventType = (value)=>{
    const raw = $aa5cd7096308004a$var$normalizeMojibake(value).trim();
    if (!raw) return "-";
    const normalized = raw.replace(/_/g, " ").replace(/\s+/g, " ").trim().toLowerCase();
    if (normalized === "stimm\xe4nderung" || normalized === "stimmanderung") return "Stimm\xe4nderung";
    if (normalized === "erstmalige stimmabgabe") return "Erstmalige Stimmabgabe";
    return normalized.split(" ").map((word)=>word ? word.charAt(0).toUpperCase() + word.slice(1) : "").join(" ");
};
const $aa5cd7096308004a$var$logsTitleIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M5.2 19.2h13.6M7.2 19.2V11M12 19.2V7.8M16.8 19.2v-5.4",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round"
    })
});
const $aa5cd7096308004a$export$85b22fb52492fe14 = ()=>{
    const isFrameworkV2 = typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    const [auditPage, setAuditPage] = (0, $acw62.useState)(1);
    const [importPage, setImportPage] = (0, $acw62.useState)(1);
    const [syncPage, setSyncPage] = (0, $acw62.useState)(1);
    const [webhookPage, setWebhookPage] = (0, $acw62.useState)(1);
    const [webhookRejectPage, setWebhookRejectPage] = (0, $acw62.useState)(1);
    const [votePage, setVotePage] = (0, $acw62.useState)(1);
    const [syncStatusFilter, setSyncStatusFilter] = (0, $acw62.useState)("all");
    const [syncTriggerFilter, setSyncTriggerFilter] = (0, $acw62.useState)("all");
    const [webhookStatusFilter, setWebhookStatusFilter] = (0, $acw62.useState)("all");
    const [webhookRejectStatusFilter, setWebhookRejectStatusFilter] = (0, $acw62.useState)("all");
    const [voteSearch, setVoteSearch] = (0, $acw62.useState)("");
    const [voteResolutionFilter, setVoteResolutionFilter] = (0, $acw62.useState)("");
    const [voteObjectFilter, setVoteObjectFilter] = (0, $acw62.useState)("");
    const [voteUnitFilter, setVoteUnitFilter] = (0, $acw62.useState)("");
    const [voteOwnerFilter, setVoteOwnerFilter] = (0, $acw62.useState)("");
    const [voteValueFilter, setVoteValueFilter] = (0, $acw62.useState)("all");
    const [voteSortBy, setVoteSortBy] = (0, $acw62.useState)("timestamp");
    const [voteSortDir, setVoteSortDir] = (0, $acw62.useState)("desc");
    const [collapsedSections, setCollapsedSections] = (0, $acw62.useState)({
        voteGlobal: true,
        voteQrRecent: true,
        imports: true,
        faciliooSync: true,
        faciliooWebhookQueue: true,
        faciliooWebhookRejects: true,
        audit: true
    });
    const toggleSection = (key)=>{
        setCollapsedSections((prev)=>({
                ...prev,
                [key]: !prev[key]
            }));
    };
    const { data: uiSettings } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-logs"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings()
    });
    const faciliooEnabled = uiSettings?.management?.faciliooEnabled !== false;
    const { data: auditData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "logs-audit-rows",
            auditPage
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).auditLogs({
                page: auditPage,
                pageSize: 50
            })
    });
    const { data: importsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "logs-imports",
            importPage
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).imports({
                page: importPage,
                pageSize: 25
            })
    });
    const { data: faciliooSyncData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "logs-facilioo-sync",
            syncPage,
            syncStatusFilter,
            syncTriggerFilter
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).faciliooSyncLogs({
                page: syncPage,
                pageSize: 25,
                status: syncStatusFilter === "all" ? undefined : syncStatusFilter,
                trigger: syncTriggerFilter === "all" ? undefined : syncTriggerFilter
            }),
        enabled: faciliooEnabled
    });
    const { data: faciliooWebhookData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "logs-facilioo-webhooks",
            webhookPage,
            webhookStatusFilter
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).faciliooWebhookLogs({
                page: webhookPage,
                pageSize: 25,
                status: webhookStatusFilter === "all" ? undefined : webhookStatusFilter
            }),
        enabled: faciliooEnabled
    });
    const { data: faciliooWebhookRejectData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "logs-facilioo-webhook-rejects",
            webhookRejectPage,
            webhookRejectStatusFilter
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).faciliooWebhookRejectLogs({
                page: webhookRejectPage,
                pageSize: 25,
                status: webhookRejectStatusFilter === "all" ? undefined : webhookRejectStatusFilter
            }),
        enabled: faciliooEnabled
    });
    const { data: voteProtocolData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "logs-vote-protocol",
            votePage,
            voteSearch,
            voteResolutionFilter,
            voteObjectFilter,
            voteUnitFilter,
            voteOwnerFilter,
            voteValueFilter,
            voteSortBy,
            voteSortDir
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).voteProtocols({
                page: votePage,
                pageSize: 25,
                search: voteSearch.trim() || undefined,
                resolutionId: voteResolutionFilter.trim() || undefined,
                objectRef: voteObjectFilter.trim() || undefined,
                unit: voteUnitFilter.trim() || undefined,
                owner: voteOwnerFilter.trim() || undefined,
                voteValue: voteValueFilter === "all" ? undefined : voteValueFilter,
                sortBy: voteSortBy,
                sortDir: voteSortDir
            })
    });
    const { data: qrRecentData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "logs-vote-protocol-qr-recent"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).voteProtocols({
                page: 1,
                pageSize: 10,
                sortBy: "timestamp",
                sortDir: "desc",
                submissionChannel: "analog_scan"
            })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: isFrameworkV2 ? "resolutions-v2-page logs-v2-page" : undefined,
        children: [
            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "page-header panel resolutions-v2-page-header logs-v2-page-header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    className: "resolutions-v2-title",
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "resolutions-v2-title-icon",
                            "aria-hidden": "true",
                            children: $aa5cd7096308004a$var$logsTitleIcon
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "resolutions-v2-title-copy",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-main",
                                    children: "Protokolle"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-sub",
                                    children: "Stimmabgaben, Importe und Systemereignisse"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel logs-v2-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "logs-v2-section-head",
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "Stimmabgabe-Protokoll (Global)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>toggleSection("voteGlobal"),
                                "aria-expanded": !collapsedSections.voteGlobal,
                                children: collapsedSections.voteGlobal ? "Ausklappen" : "Einklappen"
                            })
                        ]
                    }),
                    !collapsedSections.voteGlobal ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "panel logs-v2-subsection",
                                style: {
                                    marginBottom: 12,
                                    marginTop: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "logs-v2-section-head",
                                        style: {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                style: {
                                                    marginTop: 0,
                                                    marginBottom: 0
                                                },
                                                children: "Zuletzt per QR erfasst"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>toggleSection("voteQrRecent"),
                                                "aria-expanded": !collapsedSections.voteQrRecent,
                                                children: collapsedSections.voteQrRecent ? "Ausklappen" : "Einklappen"
                                            })
                                        ]
                                    }),
                                    !collapsedSections.voteQrRecent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginTop: 8
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                                            columns: [
                                                {
                                                    key: "timestamp",
                                                    label: "Zeitpunkt"
                                                },
                                                {
                                                    key: "beschlussnummer",
                                                    label: "Beschluss",
                                                    align: "center",
                                                    render: (row)=>{
                                                        const label = row.beschlussnummer || row.resolution_id || "-";
                                                        if (row.resolution_id) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            className: "badge resolution-number",
                                                            to: `/resolutions/${row.resolution_id}`,
                                                            title: $aa5cd7096308004a$var$normalizeMojibake(label),
                                                            children: $aa5cd7096308004a$var$normalizeMojibake(label)
                                                        });
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "badge resolution-number",
                                                            children: $aa5cd7096308004a$var$normalizeMojibake(label)
                                                        });
                                                    }
                                                },
                                                {
                                                    key: "objektnummer",
                                                    label: "Objekt",
                                                    align: "center",
                                                    render: (row)=>{
                                                        const objectNumber = $aa5cd7096308004a$var$normalizeMojibake(row.objektnummer || "-");
                                                        if (objectNumber !== "-") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            className: "badge object-number",
                                                            to: `/objects?search=${encodeURIComponent(objectNumber)}`,
                                                            title: objectNumber,
                                                            children: objectNumber
                                                        });
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "badge object-number",
                                                            children: "-"
                                                        });
                                                    }
                                                },
                                                {
                                                    key: "owner_fullname",
                                                    label: "Eigent\xfcmer",
                                                    render: (row)=>$aa5cd7096308004a$var$normalizeMojibake(row.owner_fullname || row.eigentuemer_id || "-")
                                                },
                                                {
                                                    key: "vote_value",
                                                    label: "Stimmabgabe",
                                                    align: "center",
                                                    render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: $aa5cd7096308004a$var$voteBadgeClass(row.vote_value),
                                                            children: $aa5cd7096308004a$var$voteBadgeLabel(row.vote_value)
                                                        })
                                                },
                                                {
                                                    key: "auth_user_name",
                                                    label: "Erfasst von",
                                                    render: (row)=>$aa5cd7096308004a$var$normalizeMojibake(row.auth_user_name || "-")
                                                },
                                                {
                                                    key: "client_ip",
                                                    label: "IP"
                                                }
                                            ],
                                            rows: qrRecentData?.data ?? [],
                                            total: (qrRecentData?.data ?? []).length,
                                            page: 1,
                                            pageSize: qrRecentData?.meta.pageSize ?? 10,
                                            onPageChange: ()=>{
                                            // Intentionally fixed to most recent 10 rows.
                                            }
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "logs-filter-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: voteSearch,
                                        onChange: (e)=>{
                                            setVoteSearch(e.target.value);
                                            setVotePage(1);
                                        },
                                        placeholder: "Suche (frei)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: voteResolutionFilter,
                                        onChange: (e)=>{
                                            setVoteResolutionFilter(e.target.value);
                                            setVotePage(1);
                                        },
                                        placeholder: "Beschluss-ID/-Nr."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: voteObjectFilter,
                                        onChange: (e)=>{
                                            setVoteObjectFilter(e.target.value);
                                            setVotePage(1);
                                        },
                                        placeholder: "Objekt"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: voteUnitFilter,
                                        onChange: (e)=>{
                                            setVoteUnitFilter(e.target.value);
                                            setVotePage(1);
                                        },
                                        placeholder: "Einheit"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: voteOwnerFilter,
                                        onChange: (e)=>{
                                            setVoteOwnerFilter(e.target.value);
                                            setVotePage(1);
                                        },
                                        placeholder: "Eigent\xfcmer"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: voteValueFilter,
                                        onChange: (e)=>{
                                            setVoteValueFilter(e.target.value);
                                            setVotePage(1);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "Alle Stimmabgaben"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "ja",
                                                children: "Ja"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "nein",
                                                children: "Nein"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "enthaltung",
                                                children: "Enthaltung"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "offen",
                                                children: "Offen"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: voteSortBy,
                                        onChange: (e)=>{
                                            setVoteSortBy(e.target.value);
                                            setVotePage(1);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "timestamp",
                                                children: "Sortierung: Zeitpunkt"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "beschlussnummer",
                                                children: "Sortierung: Beschluss"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "objektnummer",
                                                children: "Sortierung: Objekt"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "einheit_refs",
                                                children: "Sortierung: Einheit"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "owner_fullname",
                                                children: "Sortierung: Eigent\xfcmer"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "vote_value",
                                                children: "Sortierung: Stimmabgabe"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: voteSortDir,
                                        onChange: (e)=>{
                                            setVoteSortDir(e.target.value);
                                            setVotePage(1);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "desc",
                                                children: "Absteigend"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "asc",
                                                children: "Aufsteigend"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                                columns: [
                                    {
                                        key: "timestamp",
                                        label: "Zeitpunkt"
                                    },
                                    {
                                        key: "beschlussnummer",
                                        label: "Beschluss",
                                        align: "center",
                                        render: (row)=>{
                                            const label = row.beschlussnummer || row.resolution_id || "-";
                                            if (row.resolution_id) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: "badge resolution-number",
                                                to: `/resolutions/${row.resolution_id}`,
                                                title: $aa5cd7096308004a$var$normalizeMojibake(label),
                                                children: $aa5cd7096308004a$var$normalizeMojibake(label)
                                            });
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "badge resolution-number",
                                                children: $aa5cd7096308004a$var$normalizeMojibake(label)
                                            });
                                        }
                                    },
                                    {
                                        key: "objektnummer",
                                        label: "Objekt",
                                        align: "center",
                                        render: (row)=>{
                                            const objectNumber = $aa5cd7096308004a$var$normalizeMojibake(row.objektnummer || "-");
                                            const objectId = String(row.object_id ?? row.objectId ?? "").trim();
                                            if (objectId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: "badge object-number",
                                                to: `/objects/${objectId}`,
                                                title: objectNumber,
                                                children: objectNumber
                                            });
                                            if (objectNumber !== "-") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: "badge object-number",
                                                to: `/objects?search=${encodeURIComponent(objectNumber)}`,
                                                title: objectNumber,
                                                children: objectNumber
                                            });
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "badge object-number",
                                                children: "-"
                                            });
                                        }
                                    },
                                    {
                                        key: "einheit_refs",
                                        label: "Einheit",
                                        align: "center",
                                        render: (row)=>$aa5cd7096308004a$var$extractUnitNumbers(row.einheit_refs)
                                    },
                                    {
                                        key: "owner_fullname",
                                        label: "Eigent\xfcmer",
                                        render: (row)=>$aa5cd7096308004a$var$normalizeMojibake(row.owner_fullname || row.eigentuemer_id || "-")
                                    },
                                    {
                                        key: "vote_value",
                                        label: "Stimmabgabe",
                                        align: "center",
                                        render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: $aa5cd7096308004a$var$voteBadgeClass(row.vote_value),
                                                children: $aa5cd7096308004a$var$voteBadgeLabel(row.vote_value)
                                            })
                                    },
                                    {
                                        key: "vote_event_type",
                                        label: "Ereignis",
                                        render: (row)=>$aa5cd7096308004a$var$formatVoteEventType(row.vote_event_type)
                                    },
                                    {
                                        key: "submission_channel",
                                        label: "Kanal",
                                        render: (row)=>$aa5cd7096308004a$var$normalizeMojibake(row.submission_channel || "-")
                                    },
                                    {
                                        key: "auth_mode",
                                        label: "Authentifizierung",
                                        render: (row)=>$aa5cd7096308004a$var$normalizeMojibake(row.auth_mode || "-")
                                    },
                                    {
                                        key: "auth_user_name",
                                        label: "Benutzer",
                                        render: (row)=>$aa5cd7096308004a$var$normalizeMojibake(row.auth_user_name || "-")
                                    },
                                    {
                                        key: "client_ip",
                                        label: "IP"
                                    }
                                ],
                                rows: voteProtocolData?.data ?? [],
                                total: voteProtocolData?.meta.total ?? 0,
                                page: votePage,
                                pageSize: voteProtocolData?.meta.pageSize ?? 25,
                                onPageChange: setVotePage
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel logs-v2-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "logs-v2-section-head",
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "Manuelle Importe"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>toggleSection("imports"),
                                "aria-expanded": !collapsedSections.imports,
                                children: collapsedSections.imports ? "Ausklappen" : "Einklappen"
                            })
                        ]
                    }),
                    !collapsedSections.imports ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 12
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                            columns: [
                                {
                                    key: "createdAt",
                                    label: "Zeitpunkt"
                                },
                                {
                                    key: "source",
                                    label: "Quelle",
                                    render: (row)=>$aa5cd7096308004a$var$importSourceLabel(row)
                                },
                                {
                                    key: "import_typ",
                                    label: "Typ",
                                    render: (row)=>$aa5cd7096308004a$var$importLabel(row.import_typ)
                                },
                                {
                                    key: "filename",
                                    label: "Datei"
                                },
                                {
                                    key: "status",
                                    label: "Status",
                                    render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: $aa5cd7096308004a$var$statusBadgeClass(row.status),
                                            children: $aa5cd7096308004a$var$statusLabel(row.status)
                                        })
                                },
                                {
                                    key: "valid_rows",
                                    label: "Valide",
                                    align: "center"
                                },
                                {
                                    key: "invalid_rows",
                                    label: "Fehler",
                                    align: "center"
                                }
                            ],
                            rows: importsData?.data ?? [],
                            total: importsData?.meta.total ?? 0,
                            page: importPage,
                            pageSize: importsData?.meta.pageSize ?? 25,
                            onPageChange: setImportPage
                        })
                    }) : null
                ]
            }),
            faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel logs-v2-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "logs-v2-section-head",
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "Facilioo Syncronisationen"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>toggleSection("faciliooSync"),
                                "aria-expanded": !collapsedSections.faciliooSync,
                                children: collapsedSections.faciliooSync ? "Ausklappen" : "Einklappen"
                            })
                        ]
                    }),
                    !collapsedSections.faciliooSync ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginTop: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "logs-filter-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-type-toggle",
                                        role: "tablist",
                                        "aria-label": "Filter Status",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: syncStatusFilter === "all" ? "is-active" : "",
                                                onClick: ()=>{
                                                    setSyncStatusFilter("all");
                                                    setSyncPage(1);
                                                },
                                                children: "Alle Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: syncStatusFilter === "ok" ? "is-active" : "",
                                                onClick: ()=>{
                                                    setSyncStatusFilter("ok");
                                                    setSyncPage(1);
                                                },
                                                children: "OK"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: syncStatusFilter === "error" ? "is-active" : "",
                                                onClick: ()=>{
                                                    setSyncStatusFilter("error");
                                                    setSyncPage(1);
                                                },
                                                children: "Fehler"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-type-toggle",
                                        role: "tablist",
                                        "aria-label": "Filter Ausf\xfchrung",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: syncTriggerFilter === "all" ? "is-active" : "",
                                                onClick: ()=>{
                                                    setSyncTriggerFilter("all");
                                                    setSyncPage(1);
                                                },
                                                children: "Alle L\xe4ufe"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: syncTriggerFilter === "manual" ? "is-active" : "",
                                                onClick: ()=>{
                                                    setSyncTriggerFilter("manual");
                                                    setSyncPage(1);
                                                },
                                                children: "Manuell"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: syncTriggerFilter === "auto" ? "is-active" : "",
                                                onClick: ()=>{
                                                    setSyncTriggerFilter("auto");
                                                    setSyncPage(1);
                                                },
                                                children: "Automatisch"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                                columns: [
                                    {
                                        key: "createdAt",
                                        label: "Zeitpunkt"
                                    },
                                    {
                                        key: "trigger",
                                        label: "Ausf\xfchrung",
                                        render: (row)=>$aa5cd7096308004a$var$faciliooSyncTrigger(row.action)
                                    },
                                    {
                                        key: "status",
                                        label: "Status",
                                        render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: row.action.endsWith("_failed") ? "badge import-failed" : "badge import-imported",
                                                children: $aa5cd7096308004a$var$faciliooSyncStatus(row.action)
                                            })
                                    },
                                    {
                                        key: "actor_name",
                                        label: "Benutzer/System"
                                    },
                                    {
                                        key: "entity_id",
                                        label: "Lauf-ID"
                                    }
                                ],
                                rows: faciliooSyncData?.data ?? [],
                                total: faciliooSyncData?.meta.total ?? 0,
                                page: syncPage,
                                pageSize: faciliooSyncData?.meta.pageSize ?? 25,
                                onPageChange: setSyncPage
                            })
                        ]
                    }) : null
                ]
            }) : null,
            faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel logs-v2-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "logs-v2-section-head",
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "Facilioo Webhook Queue"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>toggleSection("faciliooWebhookQueue"),
                                "aria-expanded": !collapsedSections.faciliooWebhookQueue,
                                children: collapsedSections.faciliooWebhookQueue ? "Ausklappen" : "Einklappen"
                            })
                        ]
                    }),
                    !collapsedSections.faciliooWebhookQueue ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginTop: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "logs-filter-row",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "imports-type-toggle",
                                    role: "tablist",
                                    "aria-label": "Filter Webhook Status",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: webhookStatusFilter === "all" ? "is-active" : "",
                                            onClick: ()=>{
                                                setWebhookStatusFilter("all");
                                                setWebhookPage(1);
                                            },
                                            children: "Alle"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: webhookStatusFilter === "queued" ? "is-active" : "",
                                            onClick: ()=>{
                                                setWebhookStatusFilter("queued");
                                                setWebhookPage(1);
                                            },
                                            children: "Queued"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: webhookStatusFilter === "deduplicated" ? "is-active" : "",
                                            onClick: ()=>{
                                                setWebhookStatusFilter("deduplicated");
                                                setWebhookPage(1);
                                            },
                                            children: "Deduplicated"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                                columns: [
                                    {
                                        key: "createdAt",
                                        label: "Zeitpunkt"
                                    },
                                    {
                                        key: "status",
                                        label: "Status",
                                        render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: $aa5cd7096308004a$var$faciliooWebhookStatusBadgeClass(row),
                                                children: $aa5cd7096308004a$var$faciliooWebhookStatus(row)
                                            })
                                    },
                                    {
                                        key: "dbProcessed",
                                        label: "In DB verarbeitet",
                                        render: (row)=>$aa5cd7096308004a$var$webhookDbStatusLabel(row)
                                    },
                                    {
                                        key: "entityName",
                                        label: "Entity",
                                        render: (row)=>$aa5cd7096308004a$var$readWebhookChange(row, "entityName")
                                    },
                                    {
                                        key: "eventType",
                                        label: "Type",
                                        render: (row)=>$aa5cd7096308004a$var$readWebhookChange(row, "eventType")
                                    },
                                    {
                                        key: "entityId",
                                        label: "Entity-ID",
                                        render: (row)=>$aa5cd7096308004a$var$readWebhookChange(row, "entityId")
                                    },
                                    {
                                        key: "eventId",
                                        label: "Event-ID",
                                        render: (row)=>$aa5cd7096308004a$var$readWebhookChange(row, "eventId")
                                    }
                                ],
                                rows: faciliooWebhookData?.data ?? [],
                                total: faciliooWebhookData?.meta.total ?? 0,
                                page: webhookPage,
                                pageSize: faciliooWebhookData?.meta.pageSize ?? 25,
                                onPageChange: setWebhookPage
                            })
                        ]
                    }) : null
                ]
            }) : null,
            faciliooEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel logs-v2-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "logs-v2-section-head",
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "Facilioo Webhook Rejects"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>toggleSection("faciliooWebhookRejects"),
                                "aria-expanded": !collapsedSections.faciliooWebhookRejects,
                                children: collapsedSections.faciliooWebhookRejects ? "Ausklappen" : "Einklappen"
                            })
                        ]
                    }),
                    !collapsedSections.faciliooWebhookRejects ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginTop: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "logs-filter-row",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "imports-type-toggle",
                                    role: "tablist",
                                    "aria-label": "Filter Webhook Reject Status",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: webhookRejectStatusFilter === "all" ? "is-active" : "",
                                            onClick: ()=>{
                                                setWebhookRejectStatusFilter("all");
                                                setWebhookRejectPage(1);
                                            },
                                            children: "Alle"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: webhookRejectStatusFilter === "401" ? "is-active" : "",
                                            onClick: ()=>{
                                                setWebhookRejectStatusFilter("401");
                                                setWebhookRejectPage(1);
                                            },
                                            children: "401"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: webhookRejectStatusFilter === "400" ? "is-active" : "",
                                            onClick: ()=>{
                                                setWebhookRejectStatusFilter("400");
                                                setWebhookRejectPage(1);
                                            },
                                            children: "400"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: webhookRejectStatusFilter === "500" ? "is-active" : "",
                                            onClick: ()=>{
                                                setWebhookRejectStatusFilter("500");
                                                setWebhookRejectPage(1);
                                            },
                                            children: "500"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: webhookRejectStatusFilter === "503" ? "is-active" : "",
                                            onClick: ()=>{
                                                setWebhookRejectStatusFilter("503");
                                                setWebhookRejectPage(1);
                                            },
                                            children: "503"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                                columns: [
                                    {
                                        key: "createdAt",
                                        label: "Zeitpunkt"
                                    },
                                    {
                                        key: "status",
                                        label: "HTTP",
                                        align: "center",
                                        render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: Number(row.status) >= 500 ? "badge import-failed" : "badge import-validated",
                                                children: String(row.status || "-")
                                            })
                                    },
                                    {
                                        key: "reason",
                                        label: "Reason"
                                    },
                                    {
                                        key: "message",
                                        label: "Message"
                                    },
                                    {
                                        key: "entityName",
                                        label: "Entity",
                                        render: (row)=>row.entityName || "-"
                                    },
                                    {
                                        key: "eventId",
                                        label: "Event-ID",
                                        render: (row)=>row.eventId || "-"
                                    },
                                    {
                                        key: "apiKeyPrefix",
                                        label: "Key-Pr\xe4fix",
                                        render: (row)=>row.apiKeyPrefix || "-"
                                    }
                                ],
                                rows: faciliooWebhookRejectData?.data ?? [],
                                total: faciliooWebhookRejectData?.meta.total ?? 0,
                                page: webhookRejectPage,
                                pageSize: faciliooWebhookRejectData?.meta.pageSize ?? 25,
                                onPageChange: setWebhookRejectPage
                            })
                        ]
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel logs-v2-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "logs-v2-section-head",
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "\xc4nderungsprotokoll"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>toggleSection("audit"),
                                "aria-expanded": !collapsedSections.audit,
                                children: collapsedSections.audit ? "Ausklappen" : "Einklappen"
                            })
                        ]
                    }),
                    !collapsedSections.audit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 12
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                            columns: [
                                {
                                    key: "createdAt",
                                    label: "Zeitpunkt"
                                },
                                {
                                    key: "actor_name",
                                    label: "Benutzer"
                                },
                                {
                                    key: "entity_type",
                                    label: "Datensatztyp"
                                },
                                {
                                    key: "entity_id",
                                    label: "Datensatz-ID"
                                },
                                {
                                    key: "action",
                                    label: "Aktion"
                                },
                                {
                                    key: "object_ref",
                                    label: "Objektbezug",
                                    render: (row)=>{
                                        const ref = $aa5cd7096308004a$var$normalizeMojibake(String(row.object_ref ?? "-"));
                                        const objectId = String(row.object_id ?? row.objectId ?? "").trim();
                                        if (objectId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            className: "badge object-number",
                                            to: `/objects/${objectId}`,
                                            title: ref,
                                            children: ref
                                        });
                                        if (ref !== "-") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            className: "badge object-number",
                                            to: `/objects?search=${encodeURIComponent(ref)}`,
                                            title: ref,
                                            children: ref
                                        });
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "badge object-number",
                                            children: "-"
                                        });
                                    }
                                }
                            ],
                            rows: auditData?.data ?? [],
                            total: auditData?.meta.total ?? 0,
                            page: auditPage,
                            pageSize: auditData?.meta.pageSize ?? 50,
                            onPageChange: setAuditPage
                        })
                    }) : null
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $09f591baab63073a$import_meta = Object.assign(Object.create(null), {
    url: "file:///src/app/tenant-host.ts"
});
const $09f591baab63073a$var$sanitizeTenantSlug = (value)=>value.trim().toLowerCase().replace(/[^a-z0-9-]/g, "");
const $09f591baab63073a$var$normalizeHost = (value)=>{
    const raw = String(value ?? "").trim().toLowerCase();
    if (!raw) return "";
    const withoutProto = raw.replace(/^https?:\/\//, "");
    const withoutPath = withoutProto.split("/")[0] ?? "";
    const withoutPort = withoutPath.split(":")[0] ?? "";
    return withoutPort.trim();
};
const $09f591baab63073a$var$env = $09f591baab63073a$import_meta.env ?? {};
const $09f591baab63073a$var$defaultTenantSlug = String($09f591baab63073a$var$env.VITE_DEFAULT_TENANT_SLUG ?? "default").trim().toLowerCase() || "default";
const $09f591baab63073a$var$defaultTenantAliases = new Set(String($09f591baab63073a$var$env.VITE_DEFAULT_TENANT_ALIASES ?? "").split(",").map((entry)=>entry.trim().toLowerCase()).filter(Boolean));
$09f591baab63073a$var$defaultTenantAliases.add("www");
const $09f591baab63073a$var$appRootDomain = $09f591baab63073a$var$normalizeHost(String($09f591baab63073a$var$env.VITE_APP_ROOT_DOMAIN ?? $09f591baab63073a$var$env.VITE_APP_DOMAIN ?? ""));
const $09f591baab63073a$var$resolveSubdomainTenantSlug = (hostLike)=>{
    const host = $09f591baab63073a$var$normalizeHost(hostLike);
    if (!host) return null;
    if (host === "localhost" || host.endsWith(".localhost")) return null;
    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return null;
    if ($09f591baab63073a$var$appRootDomain) {
        if (host === $09f591baab63073a$var$appRootDomain) return null;
        if (host.endsWith(`.${$09f591baab63073a$var$appRootDomain}`)) {
            const leftPart = host.slice(0, -($09f591baab63073a$var$appRootDomain.length + 1));
            const slug = $09f591baab63073a$var$sanitizeTenantSlug(leftPart.split(".")[0] ?? "");
            return slug || null;
        }
        return null;
    }
    const labels = host.split(".").filter(Boolean);
    if (labels.length < 3) return null;
    const slug = $09f591baab63073a$var$sanitizeTenantSlug(labels[0] ?? "");
    return slug || null;
};
const $09f591baab63073a$var$normalizeTenantSlug = (slug)=>{
    const normalized = $09f591baab63073a$var$sanitizeTenantSlug(String(slug ?? ""));
    if (!normalized) return $09f591baab63073a$var$defaultTenantSlug;
    if (normalized === $09f591baab63073a$var$defaultTenantSlug || $09f591baab63073a$var$defaultTenantAliases.has(normalized)) return $09f591baab63073a$var$defaultTenantSlug;
    return normalized;
};
const $09f591baab63073a$export$9af4e01f9c0573c0 = (hostLike)=>{
    const subdomain = $09f591baab63073a$var$resolveSubdomainTenantSlug(String(hostLike ?? ""));
    return $09f591baab63073a$var$normalizeTenantSlug(subdomain || $09f591baab63073a$var$defaultTenantSlug);
};
const $09f591baab63073a$export$71e583b5d309e488 = (hostLike)=>{
    const subdomain = $09f591baab63073a$var$resolveSubdomainTenantSlug(String(hostLike ?? ""));
    return $09f591baab63073a$var$sanitizeTenantSlug(String(subdomain ?? "")) || $09f591baab63073a$var$defaultTenantSlug;
};




var $cfa3ec47cc17e8e8$import_meta = Object.assign(Object.create(null), {
    url: "file:///src/pages/SettingsPage.tsx"
});
var $1196ecb4a39615f9$exports = {};
$1196ecb4a39615f9$exports = import.meta.resolve("faAWq");


const $cfa3ec47cc17e8e8$var$brevoProviderLogo = new URL($1196ecb4a39615f9$exports).toString();
var $984c85776e12fa10$exports = {};
$984c85776e12fa10$exports = import.meta.resolve("dfQom");


const $cfa3ec47cc17e8e8$var$microsoftProviderLogo = new URL($984c85776e12fa10$exports).toString();
const $cfa3ec47cc17e8e8$var$MailEnvelopeIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.8 6.8h14.4v10.4H4.8z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m5.4 7.4 6.6 5.2 6.6-5.2",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE = "__none__";
const $cfa3ec47cc17e8e8$var$NDR_FOLDER_DEFAULT = "__default__";
const $cfa3ec47cc17e8e8$var$MailProviderIcon = ({ provider: provider })=>{
    if (provider === "microsoft_graph") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "settings-v2-mail-provider-icon",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $cfa3ec47cc17e8e8$var$microsoftProviderLogo,
            alt: ""
        })
    });
    if (provider === "brevo_api") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "settings-v2-mail-provider-icon settings-v2-mail-provider-icon--brevo",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $cfa3ec47cc17e8e8$var$brevoProviderLogo,
            alt: ""
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "settings-v2-mail-provider-icon settings-v2-mail-provider-icon--smtp",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$MailEnvelopeIcon, {})
    });
};
const $cfa3ec47cc17e8e8$var$UploadCardIcon = ({ variant: variant })=>{
    const icon = variant === "user" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 12.1a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.8 20.2c.7-3.5 3.2-5.5 7.2-5.5s6.5 2 7.2 5.5",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    }) : variant === "document" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 3.8h7.3L18 7.5v12.7H7z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 4v4h4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 12h5M10 15.5h5",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.8 6.2h14.4v11.6H4.8z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m8 15 3.1-3.1 2.1 2.1 1.4-1.4L19 17",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 9.4h.1",
                stroke: "currentColor",
                strokeWidth: "2.4",
                strokeLinecap: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `settings-upload-card-icon settings-upload-card-icon--${variant}`,
        "aria-hidden": "true",
        children: icon
    });
};
const $cfa3ec47cc17e8e8$var$UploadActionIcon = ({ kind: kind })=>{
    if (kind === "delete") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.5 6.5h15",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.5 6.5V4.75h5V6.5",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 9l.7 10.25h8.6L17 9",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 11.25v5.75M14 11.25v5.75",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        ]
    });
    if (kind === "open") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 5.6h4.4V10",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m9.8 14.2 8.6-8.6",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.4 13.4v4.8H5.6V5.6h4.8",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    if (kind === "save") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.6 5.6h10.6l2.2 2.2v10.6H5.6z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.4 5.6v5h7.2v-5M9 18.2h6",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 5.2v9.6M8.2 8.8 12 5.2l3.8 3.6",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.8 14.8v3.4h12.4v-3.4",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
const $cfa3ec47cc17e8e8$var$UploadStatusIcon = ({ kind: kind })=>{
    if (kind === "warn") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m12 4.8 8 14H4z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 9.4v5.2M12 17.6h.1",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "8",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m8.8 12.2 2.2 2.2 4.2-4.2",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
const $cfa3ec47cc17e8e8$var$cleanKeyTableRows = (rows, options)=>rows.map((row)=>({
            definition: String(row.definition ?? "").trim(),
            mapping: String(row.mapping ?? "").trim(),
            ...options?.includeBrief ? {
                briefanrede_1: row.briefanrede_1 ? String(row.briefanrede_1 ?? "").trim() : "",
                briefanrede_2: row.briefanrede_2 ? String(row.briefanrede_2 ?? "").trim() : ""
            } : {}
        }));
const $cfa3ec47cc17e8e8$export$8f6dcfe950367406 = ({ settings: settings, onChange: onChange, authUser: authUser, saveStatus: saveStatus })=>{
    const platformPortalAliasesRaw = $cfa3ec47cc17e8e8$import_meta.env?.VITE_PLATFORM_PORTAL_ALIASES ?? "plattform,platform";
    const platformPortalAliases = new Set(String(platformPortalAliasesRaw).split(",").map((entry)=>entry.trim().toLowerCase()).filter(Boolean));
    const host = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
    const hostSlug = (0, $09f591baab63073a$export$71e583b5d309e488)(host);
    const isPlatformSettingsHost = platformPortalAliases.has(hostSlug);
    const [form, setForm] = (0, $acw62.useState)(settings);
    const [showSmtpPassword, setShowSmtpPassword] = (0, $acw62.useState)(false);
    const [showBrevoApiKey, setShowBrevoApiKey] = (0, $acw62.useState)(false);
    const [showFaciliooApiKey, setShowFaciliooApiKey] = (0, $acw62.useState)(false);
    const [showFaciliooWebhookApiKey, setShowFaciliooWebhookApiKey] = (0, $acw62.useState)(false);
    const [showFaciliooKeyTables, setShowFaciliooKeyTables] = (0, $acw62.useState)(false);
    const [showFaciliooApiTokenSection, setShowFaciliooApiTokenSection] = (0, $acw62.useState)(false);
    const [faciliooWebhookStatus, setFaciliooWebhookStatus] = (0, $acw62.useState)(null);
    const [faciliooWebhookGeneratedKey, setFaciliooWebhookGeneratedKey] = (0, $acw62.useState)("");
    const [faciliooWebhookLoading, setFaciliooWebhookLoading] = (0, $acw62.useState)(false);
    const [faciliooWebhookRegenerating, setFaciliooWebhookRegenerating] = (0, $acw62.useState)(false);
    const [faciliooWebhookRegistering, setFaciliooWebhookRegistering] = (0, $acw62.useState)(false);
    const [faciliooWebhookRegisteringUnitOnly, setFaciliooWebhookRegisteringUnitOnly] = (0, $acw62.useState)(false);
    const [faciliooWebhookConnectionTesting, setFaciliooWebhookConnectionTesting] = (0, $acw62.useState)(false);
    const [faciliooWebhookPingTesting, setFaciliooWebhookPingTesting] = (0, $acw62.useState)(false);
    const [faciliooDocumentGroupCreating, setFaciliooDocumentGroupCreating] = (0, $acw62.useState)(false);
    const [faciliooDocumentGroupResetting, setFaciliooDocumentGroupResetting] = (0, $acw62.useState)(false);
    const [faciliooDocumentGroupsLoading, setFaciliooDocumentGroupsLoading] = (0, $acw62.useState)(false);
    const [faciliooDocumentGroups, setFaciliooDocumentGroups] = (0, $acw62.useState)([]);
    const [faciliooCreateGroupName, setFaciliooCreateGroupName] = (0, $acw62.useState)("");
    const [faciliooCreateParentGroupId, setFaciliooCreateParentGroupId] = (0, $acw62.useState)(String(settings.management.faciliooDocumentGroupId ?? "").trim() || $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE);
    const [faciliooWebhookConnectionTest, setFaciliooWebhookConnectionTest] = (0, $acw62.useState)(null);
    const [faciliooWebhookPingResult, setFaciliooWebhookPingResult] = (0, $acw62.useState)(null);
    const [faciliooWebhookFeedback, setFaciliooWebhookFeedback] = (0, $acw62.useState)(null);
    const [mailTestStatus, setMailTestStatus] = (0, $acw62.useState)(null);
    const [mailTestPending, setMailTestPending] = (0, $acw62.useState)(false);
    const [microsoftMailStatus, setMicrosoftMailStatus] = (0, $acw62.useState)(null);
    const [microsoftMailPending, setMicrosoftMailPending] = (0, $acw62.useState)(false);
    const [microsoftNdrFoldersLoading, setMicrosoftNdrFoldersLoading] = (0, $acw62.useState)(false);
    const [microsoftNdrFolders, setMicrosoftNdrFolders] = (0, $acw62.useState)([]);
    const [microsoftNdrFoldersMailbox, setMicrosoftNdrFoldersMailbox] = (0, $acw62.useState)("");
    const [microsoftNdrFoldersError, setMicrosoftNdrFoldersError] = (0, $acw62.useState)("");
    const [mailProviderMenuOpen, setMailProviderMenuOpen] = (0, $acw62.useState)(false);
    const [mailProviderMenuHovered, setMailProviderMenuHovered] = (0, $acw62.useState)(false);
    const [tab, setTab] = (0, $acw62.useState)("allgemein");
    const [dataClearType, setDataClearType] = (0, $acw62.useState)("objects");
    const [dataClearPending, setDataClearPending] = (0, $acw62.useState)(false);
    const [dataClearStatus, setDataClearStatus] = (0, $acw62.useState)(null);
    const [dataClearConfirm, setDataClearConfirm] = (0, $acw62.useState)(null);
    const [saveButtonFlash, setSaveButtonFlash] = (0, $acw62.useState)(false);
    const [settingsActionFeedback, setSettingsActionFeedback] = (0, $acw62.useState)(null);
    const [letterheads, setLetterheads] = (0, $acw62.useState)({});
    const [letterheadPending, setLetterheadPending] = (0, $acw62.useState)(null);
    const [letterheadDeletePending, setLetterheadDeletePending] = (0, $acw62.useState)(null);
    const [letterheadMarginsPending, setLetterheadMarginsPending] = (0, $acw62.useState)(null);
    const [letterheadFirstPageLayoutPending, setLetterheadFirstPageLayoutPending] = (0, $acw62.useState)(null);
    const [uploadDropTarget, setUploadDropTarget] = (0, $acw62.useState)(null);
    const logoInputRef = (0, $acw62.useRef)(null);
    const ownerLogoInputRef = (0, $acw62.useRef)(null);
    const letterheadDigitalInputRef = (0, $acw62.useRef)(null);
    const letterheadAnalogInputRef = (0, $acw62.useRef)(null);
    const letterheadDigitalFollowupInputRef = (0, $acw62.useRef)(null);
    const letterheadAnalogFollowupInputRef = (0, $acw62.useRef)(null);
    const faciliooDocumentGroupOptions = (0, $acw62.useMemo)(()=>{
        const normalizePath = (value)=>value.split("/").map((part)=>part.trim()).filter(Boolean).join(" / ");
        const groups = faciliooDocumentGroups.map((group)=>({
                ...group,
                normalizedName: normalizePath(String(group.groupName ?? "").trim() || `Dokumentgruppe ${group.groupId}`)
            })).sort((a, b)=>a.normalizedName.localeCompare(b.normalizedName, "de", {
                sensitivity: "base"
            }));
        const byParent = new Map();
        const rootKey = "__root__";
        for (const group of groups){
            const parts = group.normalizedName.split(" / ").map((part)=>part.trim()).filter(Boolean);
            const parentPath = parts.length > 1 ? parts.slice(0, -1).join(" / ") : rootKey;
            const bucket = byParent.get(parentPath) ?? [];
            bucket.push(group);
            byParent.set(parentPath, bucket);
        }
        const ordered = [];
        const visited = new Set();
        const walk = (parentPath, level)=>{
            const children = (byParent.get(parentPath) ?? []).sort((a, b)=>a.normalizedName.localeCompare(b.normalizedName, "de", {
                    sensitivity: "base"
                }));
            for (const child of children){
                if (visited.has(child.groupId)) continue;
                visited.add(child.groupId);
                const parts = child.normalizedName.split(" / ").map((part)=>part.trim()).filter(Boolean);
                const title = parts[parts.length - 1] || child.normalizedName;
                const indent = "\u00A0\u00A0".repeat(Math.max(0, level));
                const prefix = level > 0 ? "- " : "";
                ordered.push({
                    groupId: child.groupId,
                    groupName: child.normalizedName,
                    label: `${indent}${prefix}${title} (${child.groupId})`
                });
                walk(child.normalizedName, level + 1);
            }
        };
        walk(rootKey, 0);
        for (const group of groups){
            if (visited.has(group.groupId)) continue;
            ordered.push({
                groupId: group.groupId,
                groupName: group.normalizedName,
                label: `${group.normalizedName} (${group.groupId})`
            });
        }
        return ordered;
    }, [
        faciliooDocumentGroups
    ]);
    const facliooSelectedParentHierarchy = (0, $acw62.useMemo)(()=>{
        const currentId = String(faciliooCreateParentGroupId ?? "").trim();
        if (!currentId || currentId === $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE) return "";
        const selected = faciliooDocumentGroupOptions.find((group)=>group.groupId === currentId);
        return String(selected?.groupName ?? "").trim();
    }, [
        faciliooCreateParentGroupId,
        faciliooDocumentGroupOptions
    ]);
    const microsoftNdrFolderOptions = (0, $acw62.useMemo)(()=>{
        const options = [
            {
                value: $cfa3ec47cc17e8e8$var$NDR_FOLDER_DEFAULT,
                label: "keine (nur Posteingang/Inbox)"
            }
        ];
        const seen = new Set([
            $cfa3ec47cc17e8e8$var$NDR_FOLDER_DEFAULT.toLowerCase()
        ]);
        for (const row of microsoftNdrFolders){
            const value = String(row.name ?? "").trim();
            if (!value) continue;
            const key = value.toLowerCase();
            if (seen.has(key)) continue;
            seen.add(key);
            const label = String(row.path ?? row.name ?? "").trim() || value;
            options.push({
                value: value,
                label: label
            });
        }
        return options;
    }, [
        microsoftNdrFolders
    ]);
    const selectedMicrosoftNdrFolderValue = (0, $acw62.useMemo)(()=>{
        const current = String(form.mail.microsoftNdrFolders ?? "").trim();
        if (!current) return $cfa3ec47cc17e8e8$var$NDR_FOLDER_DEFAULT;
        return microsoftNdrFolderOptions.some((entry)=>entry.value === current) ? current : $cfa3ec47cc17e8e8$var$NDR_FOLDER_DEFAULT;
    }, [
        form.mail.microsoftNdrFolders,
        microsoftNdrFolderOptions
    ]);
    const showSettingsActionFeedback = (feedback)=>{
        setSettingsActionFeedback(feedback);
        window.setTimeout(()=>setSettingsActionFeedback(null), 2500);
    };
    const formatDateTimeDE = (value)=>{
        if (!value) return "-";
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return value;
        return new Intl.DateTimeFormat("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        }).format(d);
    };
    (0, $acw62.useEffect)(()=>{
        setForm(settings);
        setFaciliooCreateParentGroupId(String(settings.management.faciliooDocumentGroupId ?? "").trim() || $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE);
        setFaciliooCreateGroupName("");
    }, [
        settings
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isPlatformSettingsHost) return;
        let cancelled = false;
        const loadFaciliooWebhookStatus = async ()=>{
            setFaciliooWebhookLoading(true);
            try {
                const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getFaciliooWebhookTarget();
                if (!cancelled) {
                    setFaciliooWebhookStatus(result);
                    setFaciliooWebhookFeedback(null);
                }
            } catch  {
                if (!cancelled) {
                    setFaciliooWebhookStatus(null);
                    setFaciliooWebhookFeedback({
                        type: "error",
                        text: "Webhook-Konfiguration konnte nicht geladen werden."
                    });
                }
            } finally{
                if (!cancelled) setFaciliooWebhookLoading(false);
            }
        };
        loadFaciliooWebhookStatus();
        return ()=>{
            cancelled = true;
        };
    }, [
        isPlatformSettingsHost
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isPlatformSettingsHost) return;
        if (form.management.faciliooEnabled === false) return;
        let cancelled = false;
        const loadDocumentGroups = async ()=>{
            setFaciliooDocumentGroupsLoading(true);
            try {
                const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getFaciliooDocumentGroups();
                if (!cancelled) setFaciliooDocumentGroups(result.data ?? []);
            } catch  {
                if (!cancelled) setFaciliooDocumentGroups([]);
            } finally{
                if (!cancelled) setFaciliooDocumentGroupsLoading(false);
            }
        };
        loadDocumentGroups();
        return ()=>{
            cancelled = true;
        };
    }, [
        isPlatformSettingsHost,
        form.management.faciliooEnabled
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        const loadLetterheads = async ()=>{
            try {
                const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).documentTemplates();
                if (!cancelled) setLetterheads(result.letterheads ?? {});
            } catch  {
                if (!cancelled) setLetterheads({});
            }
        };
        loadLetterheads();
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        const loadMicrosoftStatus = async ()=>{
            try {
                const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getMicrosoftMailStatus();
                if (!cancelled) setMicrosoftMailStatus(result);
            } catch  {
                if (!cancelled) setMicrosoftMailStatus(null);
            }
        };
        loadMicrosoftStatus();
        return ()=>{
            cancelled = true;
        };
    }, []);
    const loadMicrosoftNdrFolders = async (options)=>{
        const mailbox = String(options?.mailbox ?? form.mail.microsoftSharedMailboxEmail ?? "").trim();
        if (!options?.silent) setMicrosoftNdrFoldersLoading(true);
        setMicrosoftNdrFoldersError("");
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getMicrosoftMailFolders(mailbox || undefined);
            setMicrosoftNdrFolders(result.data ?? []);
            setMicrosoftNdrFoldersMailbox(String(result.mailbox ?? "").trim());
        } catch (error) {
            const message = error instanceof Error ? error.message : "Microsoft Ordner konnten nicht geladen werden.";
            setMicrosoftNdrFoldersError(message);
            setMicrosoftNdrFolders([]);
            setMicrosoftNdrFoldersMailbox("");
        } finally{
            if (!options?.silent) setMicrosoftNdrFoldersLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (form.mail.provider !== "microsoft_graph") return;
        if (!microsoftMailStatus?.connected) return;
        loadMicrosoftNdrFolders({
            silent: true
        });
    }, [
        form.mail.provider,
        microsoftMailStatus?.connected
    ]);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === "undefined") return;
        const url = new URL(window.location.href);
        const state = url.searchParams.get("m365");
        const msg = url.searchParams.get("m365_msg");
        if (!state) return;
        if (state === "connected") {
            setMailTestStatus({
                type: "ok",
                text: "Microsoft 365 erfolgreich verbunden."
            });
            (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getMicrosoftMailStatus().then((result)=>setMicrosoftMailStatus(result)).catch(()=>undefined);
        } else if (state === "error") setMailTestStatus({
            type: "error",
            text: msg || "Microsoft-Verbindung konnte nicht hergestellt werden."
        });
        url.searchParams.delete("m365");
        url.searchParams.delete("m365_msg");
        window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
    }, []);
    const onLogoFile = (file)=>{
        if (!file) return;
        const reader = new FileReader();
        reader.onload = ()=>{
            const result = typeof reader.result === "string" ? reader.result : "";
            setForm((prev)=>({
                    ...prev,
                    logoDataUrl: result || undefined
                }));
        };
        reader.readAsDataURL(file);
    };
    const onOwnerLogoFile = (file)=>{
        if (!file) return;
        const reader = new FileReader();
        reader.onload = ()=>{
            const result = typeof reader.result === "string" ? reader.result : "";
            setForm((prev)=>({
                    ...prev,
                    ownerLogoDataUrl: result || undefined
                }));
        };
        reader.readAsDataURL(file);
    };
    const onLogoRemove = ()=>{
        setForm((prev)=>({
                ...prev,
                logoDataUrl: undefined
            }));
        if (logoInputRef.current) logoInputRef.current.value = "";
    };
    const onOwnerLogoRemove = ()=>{
        setForm((prev)=>({
                ...prev,
                ownerLogoDataUrl: undefined
            }));
        if (ownerLogoInputRef.current) ownerLogoInputRef.current.value = "";
    };
    const refreshLetterheads = async ()=>{
        const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).documentTemplates();
        setLetterheads(result.letterheads ?? {});
    };
    const getLetterheadSlotLabel = (slot)=>{
        switch(slot){
            case "digital":
                return "Briefpapier digital (Seite 1)";
            case "analog":
                return "Briefpapier analog (Seite 1)";
            case "digital_followup":
                return "Briefpapier digital (ab Seite 2)";
            case "analog_followup":
                return "Briefpapier analog (ab Seite 2)";
            default:
                return "Briefpapier";
        }
    };
    const onLetterheadUpload = async (kanal, file)=>{
        if (!file) return;
        setLetterheadPending(kanal);
        try {
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).uploadDocumentLetterhead(kanal, file);
            await refreshLetterheads();
            showSettingsActionFeedback({
                type: "ok",
                text: `${getLetterheadSlotLabel(kanal)} hochgeladen.`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Upload fehlgeschlagen";
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setLetterheadPending(null);
            if (kanal === "digital" && letterheadDigitalInputRef.current) letterheadDigitalInputRef.current.value = "";
            if (kanal === "analog" && letterheadAnalogInputRef.current) letterheadAnalogInputRef.current.value = "";
            if (kanal === "digital_followup" && letterheadDigitalFollowupInputRef.current) letterheadDigitalFollowupInputRef.current.value = "";
            if (kanal === "analog_followup" && letterheadAnalogFollowupInputRef.current) letterheadAnalogFollowupInputRef.current.value = "";
        }
    };
    const onLetterheadDelete = async (kanal)=>{
        setLetterheadDeletePending(kanal);
        try {
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).deleteDocumentLetterhead(kanal);
            await refreshLetterheads();
            showSettingsActionFeedback({
                type: "ok",
                text: `${getLetterheadSlotLabel(kanal)} gel\xf6scht.`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "L\xf6schen fehlgeschlagen";
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setLetterheadDeletePending(null);
        }
    };
    const getLetterheadMargins = (slot)=>{
        const entry = letterheads[slot];
        return {
            topMarginMm: Number.isFinite(Number(entry?.topMarginMm)) ? Number(entry?.topMarginMm) : 25.4,
            bottomMarginMm: Number.isFinite(Number(entry?.bottomMarginMm)) ? Number(entry?.bottomMarginMm) : 22.6
        };
    };
    const getLetterheadFirstPageLayout = (slot)=>{
        const entry = letterheads[slot];
        const margins = getLetterheadMargins(slot);
        const defaultRecipientTopMm = Number((margins.topMarginMm + 7.1).toFixed(1));
        const defaultBodyStartMm = Number((margins.topMarginMm + 74.1).toFixed(1));
        return {
            firstPageRecipientTopMm: Number.isFinite(Number(entry?.firstPageRecipientTopMm)) ? Number(entry?.firstPageRecipientTopMm) : defaultRecipientTopMm,
            firstPageBodyStartMm: Number.isFinite(Number(entry?.firstPageBodyStartMm)) ? Number(entry?.firstPageBodyStartMm) : defaultBodyStartMm
        };
    };
    const onLetterheadMarginsChange = (slot, field, value)=>{
        const raw = Number(value);
        const nextValue = Number.isFinite(raw) ? Math.max(0, Math.min(60, raw)) : 0;
        setLetterheads((prev)=>{
            const existing = prev[slot];
            const margins = {
                topMarginMm: Number.isFinite(Number(existing?.topMarginMm)) ? Number(existing?.topMarginMm) : 25.4,
                bottomMarginMm: Number.isFinite(Number(existing?.bottomMarginMm)) ? Number(existing?.bottomMarginMm) : 22.6
            };
            return {
                ...prev,
                [slot]: {
                    ...existing,
                    topMarginMm: field === "topMarginMm" ? nextValue : margins.topMarginMm,
                    bottomMarginMm: field === "bottomMarginMm" ? nextValue : margins.bottomMarginMm
                }
            };
        });
    };
    const onLetterheadMarginsSave = async (slot)=>{
        const margins = getLetterheadMargins(slot);
        setLetterheadMarginsPending(slot);
        try {
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateDocumentLetterheadMargins(slot, margins);
            await refreshLetterheads();
            showSettingsActionFeedback({
                type: "ok",
                text: `${getLetterheadSlotLabel(slot)} R\xe4nder gespeichert.`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Speichern fehlgeschlagen";
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setLetterheadMarginsPending(null);
        }
    };
    const onLetterheadFirstPageLayoutChange = (slot, field, value)=>{
        const raw = Number(value);
        const nextValue = Number.isFinite(raw) ? Math.max(0, Math.min(260, raw)) : 0;
        setLetterheads((prev)=>{
            const existing = prev[slot];
            const layout = getLetterheadFirstPageLayout(slot);
            return {
                ...prev,
                [slot]: {
                    ...existing,
                    firstPageRecipientTopMm: field === "firstPageRecipientTopMm" ? nextValue : layout.firstPageRecipientTopMm,
                    firstPageBodyStartMm: field === "firstPageBodyStartMm" ? nextValue : layout.firstPageBodyStartMm
                }
            };
        });
    };
    const onLetterheadFirstPageLayoutSave = async (slot)=>{
        const payload = getLetterheadFirstPageLayout(slot);
        setLetterheadFirstPageLayoutPending(slot);
        try {
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateDocumentLetterheadFirstPageLayout(slot, payload);
            await refreshLetterheads();
            showSettingsActionFeedback({
                type: "ok",
                text: `${getLetterheadSlotLabel(slot)} Erstseiten-Layout gespeichert.`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Speichern fehlgeschlagen";
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setLetterheadFirstPageLayoutPending(null);
        }
    };
    const onReminderDaysChange = (key, value)=>{
        const normalized = Number.isFinite(value) ? Math.max(1, Math.min(365, Math.round(value))) : 1;
        setForm((prev)=>({
                ...prev,
                reminders: {
                    ...prev.reminders,
                    [key]: normalized
                }
            }));
    };
    const onUploadDragOver = (event, target)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = "copy";
        if (uploadDropTarget !== target) setUploadDropTarget(target);
    };
    const onUploadDragLeave = (event)=>{
        event.preventDefault();
        setUploadDropTarget((prev)=>prev ? null : prev);
    };
    const onUploadDrop = (event, target)=>{
        event.preventDefault();
        setUploadDropTarget(null);
        const file = event.dataTransfer.files?.[0] ?? null;
        if (!file) return;
        if (target === "logo-backend") {
            onLogoFile(file);
            return;
        }
        if (target === "logo-owner") {
            onOwnerLogoFile(file);
            return;
        }
        if (target === "letterhead-digital") {
            onLetterheadUpload("digital", file);
            return;
        }
        if (target === "letterhead-analog") {
            onLetterheadUpload("analog", file);
            return;
        }
        if (target === "letterhead-digital-followup") {
            onLetterheadUpload("digital_followup", file);
            return;
        }
        onLetterheadUpload("analog_followup", file);
    };
    const updateFaciliooAnredeKeyTable = (rows)=>{
        setForm((prev)=>({
                ...prev,
                management: {
                    ...prev.management,
                    faciliooAnredeKeyTable: $cfa3ec47cc17e8e8$var$cleanKeyTableRows(rows, {
                        includeBrief: true
                    })
                }
            }));
    };
    const updateFaciliooTitelKeyTable = (rows)=>{
        setForm((prev)=>({
                ...prev,
                management: {
                    ...prev.management,
                    faciliooTitelKeyTable: $cfa3ec47cc17e8e8$var$cleanKeyTableRows(rows)
                }
            }));
    };
    const runMailTest = async ()=>{
        const recipientEmail = (form.mail.testRecipientEmail || "").trim();
        if (!recipientEmail) {
            setMailTestStatus({
                type: "error",
                text: "Bitte Test-E-Mail-Adresse eintragen."
            });
            return;
        }
        if (form.mail.provider === "microsoft_graph" && !microsoftMailStatus?.connected) {
            setMailTestStatus({
                type: "error",
                text: "Microsoft 365 ist noch nicht verbunden. Bitte zuerst verbinden."
            });
            return;
        }
        if (form.mail.provider === "smtp") {
            const port = Number(form.mail.smtpPort);
            const secure = Boolean(form.mail.smtpSecure);
            if (port === 587 && secure || port === 465 && !secure) {
                setMailTestStatus({
                    type: "error",
                    text: "SMTP-Kombination ungueltig. Bitte fuer 587 Secure=Nein oder fuer 465 Secure=Ja einstellen."
                });
                return;
            }
        }
        setMailTestPending(true);
        setMailTestStatus(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).testMailSettings(recipientEmail, form.mail);
            setMailTestStatus({
                type: "ok",
                text: `Testversand erfolgreich \xfcber ${result.provider} (${result.messageId}).`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Testversand fehlgeschlagen";
            setMailTestStatus({
                type: "error",
                text: message
            });
        } finally{
            setMailTestPending(false);
        }
    };
    const regenerateFaciliooWebhookKey = async ()=>{
        setFaciliooWebhookRegenerating(true);
        setFaciliooWebhookGeneratedKey("");
        setShowFaciliooWebhookApiKey(false);
        setFaciliooWebhookFeedback(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).regenerateFaciliooWebhookTargetKey("default");
            setFaciliooWebhookStatus({
                ok: true,
                authorizationType: 4,
                targetUrl: result.targetUrl,
                endpointPath: result.endpointPath,
                hasCredential: true,
                credential: result.credential
            });
            setFaciliooWebhookGeneratedKey(result.apiKey);
            setFaciliooWebhookFeedback({
                type: "ok",
                text: "Webhook-API-Key wurde erfolgreich neu erzeugt."
            });
            showSettingsActionFeedback({
                type: "ok",
                text: "Webhook-API-Key neu erzeugt. Bitte jetzt in Facilioo eintragen."
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Webhook-API-Key konnte nicht erzeugt werden.";
            setFaciliooWebhookFeedback({
                type: "error",
                text: message
            });
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setFaciliooWebhookRegenerating(false);
        }
    };
    const registerFaciliooWebhookAtFacilioo = async ()=>{
        setFaciliooWebhookRegistering(true);
        setFaciliooWebhookGeneratedKey("");
        setShowFaciliooWebhookApiKey(false);
        setFaciliooWebhookFeedback(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).registerFaciliooWebhookTarget({
                replaceExisting: true,
                shouldGroup: false,
                shouldGroupContinueAfterFail: false,
                includePropertyCreated: true
            });
            setFaciliooWebhookStatus({
                ok: true,
                authorizationType: 4,
                targetUrl: result.targetUrl,
                endpointPath: result.endpointPath,
                hasCredential: true,
                credential: result.credential
            });
            setFaciliooWebhookGeneratedKey(result.apiKey);
            setFaciliooWebhookFeedback({
                type: "ok",
                text: `Webhook bei Facilioo registriert (ID: ${result.registration.id || "n/a"}).`
            });
            showSettingsActionFeedback({
                type: "ok",
                text: `Webhook bei Facilioo registriert (ID: ${result.registration.id || "n/a"}). Vorherige Registrierungen ersetzt: ${result.replaced.deletedIds.length}.`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Facilioo-Webhook-Registration fehlgeschlagen.";
            setFaciliooWebhookFeedback({
                type: "error",
                text: message
            });
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setFaciliooWebhookRegistering(false);
        }
    };
    const connectMicrosoftMail = async ()=>{
        setMicrosoftMailPending(true);
        setMailTestStatus(null);
        try {
            const returnPath = typeof window !== "undefined" ? `${window.location.pathname}${window.location.search}` : "/settings";
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).connectMicrosoftMail(returnPath);
            if (typeof window !== "undefined") window.location.href = result.authUrl;
        } catch (error) {
            const message = error instanceof Error ? error.message : "Microsoft-Verbindung konnte nicht gestartet werden.";
            setMailTestStatus({
                type: "error",
                text: message
            });
            setMicrosoftMailPending(false);
        }
    };
    const disconnectMicrosoftMail = async ()=>{
        setMicrosoftMailPending(true);
        setMailTestStatus(null);
        try {
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).disconnectMicrosoftMail();
            const refreshed = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getMicrosoftMailStatus();
            setMicrosoftMailStatus(refreshed);
            setMailTestStatus({
                type: "ok",
                text: "Microsoft 365 Verbindung wurde getrennt."
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Microsoft-Verbindung konnte nicht getrennt werden.";
            setMailTestStatus({
                type: "error",
                text: message
            });
        } finally{
            setMicrosoftMailPending(false);
        }
    };
    const registerFaciliooWebhookUnitOnlyAtFacilioo = async ()=>{
        setFaciliooWebhookRegisteringUnitOnly(true);
        setFaciliooWebhookGeneratedKey("");
        setShowFaciliooWebhookApiKey(false);
        setFaciliooWebhookFeedback(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).registerFaciliooWebhookTarget({
                replaceExisting: true,
                shouldGroup: false,
                shouldGroupContinueAfterFail: false,
                includePropertyCreated: false,
                enabledEvents: [
                    {
                        type: 1,
                        entityName: "Unit"
                    },
                    {
                        type: 2,
                        entityName: "Unit"
                    },
                    {
                        type: 3,
                        entityName: "Unit"
                    }
                ]
            });
            setFaciliooWebhookStatus({
                ok: true,
                authorizationType: 4,
                targetUrl: result.targetUrl,
                endpointPath: result.endpointPath,
                hasCredential: true,
                credential: result.credential
            });
            setFaciliooWebhookGeneratedKey(result.apiKey);
            setFaciliooWebhookFeedback({
                type: "ok",
                text: `Unit-only Webhook bei Facilioo registriert (ID: ${result.registration.id || "n/a"}).`
            });
            showSettingsActionFeedback({
                type: "ok",
                text: `Unit-only Webhook registriert (ID: ${result.registration.id || "n/a"}).`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Facilioo Unit-only Webhook-Registration fehlgeschlagen.";
            setFaciliooWebhookFeedback({
                type: "error",
                text: message
            });
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setFaciliooWebhookRegisteringUnitOnly(false);
        }
    };
    const testFaciliooWebhookConnection = async ()=>{
        setFaciliooWebhookConnectionTesting(true);
        setFaciliooWebhookConnectionTest(null);
        setFaciliooWebhookPingResult(null);
        setFaciliooWebhookFeedback(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).testFaciliooWebhookConnection();
            setFaciliooWebhookConnectionTest(result);
            setFaciliooWebhookFeedback({
                type: result.ok ? "ok" : "error",
                text: result.ok ? "Verbindungstest erfolgreich: Outbound, Inbound und Sync sind plausibel." : "Verbindungstest hat Probleme gefunden. Details siehe Testausgabe unten."
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Facilioo-Verbindungstest fehlgeschlagen.";
            setFaciliooWebhookFeedback({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooWebhookConnectionTesting(false);
        }
    };
    const pingFaciliooWebhookConnection = async ()=>{
        setFaciliooWebhookPingTesting(true);
        setFaciliooWebhookPingResult(null);
        setFaciliooWebhookFeedback(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).pingFaciliooWebhookEndpoint();
            setFaciliooWebhookPingResult(result);
            setFaciliooWebhookFeedback({
                type: result.ok ? "ok" : "error",
                text: result.ok ? "Inbound-Ping erfolgreich: Endpoint, API-Key-Validierung, Parsing und Queue wurden lokal geprueft." : "Inbound-Ping fehlgeschlagen. Details siehe Testausgabe unten."
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Inbound-Ping fehlgeschlagen.";
            setFaciliooWebhookFeedback({
                type: "error",
                text: message
            });
        } finally{
            setFaciliooWebhookPingTesting(false);
        }
    };
    const ensureFaciliooDocumentGroup = async ()=>{
        setFaciliooDocumentGroupCreating(true);
        try {
            const baseGroupName = String(faciliooCreateGroupName ?? "").trim();
            const hasParent = faciliooCreateParentGroupId !== $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE;
            const selectedParent = faciliooDocumentGroups.find((group)=>group.groupId === String(faciliooCreateParentGroupId ?? "").trim());
            const resolvedParentName = String(selectedParent?.groupName ?? "").trim();
            const newLeafName = String(baseGroupName).trim();
            const groupName = hasParent ? resolvedParentName && newLeafName ? `${resolvedParentName} / ${newLeafName}` : newLeafName : newLeafName;
            if (!groupName) {
                showSettingsActionFeedback({
                    type: "info",
                    text: "Bitte einen Namen f\xfcr die neue Gruppe eingeben."
                });
                setFaciliooDocumentGroupCreating(false);
                return;
            }
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).ensureFaciliooDocumentGroup({
                groupName: groupName || undefined,
                forceCreate: true,
                parentGroupId: hasParent ? String(faciliooCreateParentGroupId).trim() : undefined
            });
            setForm((prev)=>({
                    ...prev,
                    management: {
                        ...prev.management,
                        faciliooDocumentGroupId: String(result.groupId ?? "").trim(),
                        faciliooDocumentGroupName: String(result.groupName ?? prev.management.faciliooDocumentGroupName ?? "").trim()
                    }
                }));
            setFaciliooCreateParentGroupId(String(result.groupId ?? "").trim() || $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE);
            showSettingsActionFeedback({
                type: "ok",
                text: result.created ? `Dokumentgruppe "${result.groupName}" angelegt (ID: ${result.groupId}).` : `Dokumentgruppe "${result.groupName}" bereits vorhanden (ID: ${result.groupId}).`
            });
            setFaciliooCreateGroupName("");
        } catch (error) {
            const message = error instanceof Error ? error.message : "Dokumentgruppe konnte nicht angelegt werden.";
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setFaciliooDocumentGroupCreating(false);
        }
    };
    const resetFaciliooDocumentGroup = async ()=>{
        setFaciliooDocumentGroupResetting(true);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).resetFaciliooDocumentGroup();
            setForm((prev)=>({
                    ...prev,
                    management: {
                        ...prev.management,
                        faciliooDocumentGroupId: "",
                        faciliooDocumentGroupName: String(result.groupName ?? prev.management.faciliooDocumentGroupName ?? "").trim()
                    }
                }));
            setFaciliooCreateParentGroupId($cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE);
            setFaciliooCreateGroupName("");
            showSettingsActionFeedback({
                type: "ok",
                text: "Facilioo Dokumentgruppe vollst\xe4ndig zur\xfcckgesetzt."
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Dokumentgruppe konnte nicht zur\xfcckgesetzt werden.";
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setFaciliooDocumentGroupResetting(false);
        }
    };
    const refreshFaciliooDocumentGroups = async ()=>{
        setFaciliooDocumentGroupsLoading(true);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getFaciliooDocumentGroups();
            setFaciliooDocumentGroups(result.data ?? []);
            showSettingsActionFeedback({
                type: "ok",
                text: "Facilioo Dokumentgruppen aktualisiert."
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Dokumentgruppen konnten nicht geladen werden.";
            showSettingsActionFeedback({
                type: "info",
                text: message
            });
        } finally{
            setFaciliooDocumentGroupsLoading(false);
        }
    };
    const dataClearTypeLabel = {
        objects: "Objekte (inkl. abh\xe4ngiger Daten)",
        units: "Einheiten",
        owners: "Eigent\xfcmer",
        assignments: "Zuordnungen",
        resolutions: "Beschl\xfcsse",
        all: "Alles"
    };
    const mailProviderOptions = [
        {
            value: "microsoft_graph",
            label: "Microsoft 365 (OAuth, Standard)",
            description: "OAuth Versand \xfcber Microsoft 365"
        },
        {
            value: "smtp",
            label: "SMTP (Benutzerdefiniert)",
            description: "Eigener SMTP-Server"
        },
        {
            value: "brevo_api",
            label: "Brevo API",
            description: "Versand \xfcber Brevo API"
        }
    ];
    const selectedMailProvider = mailProviderOptions.find((option)=>option.value === form.mail.provider) ?? mailProviderOptions[0];
    const updateMailProvider = (provider)=>{
        setForm((prev)=>({
                ...prev,
                mail: {
                    ...prev.mail,
                    provider: provider
                }
            }));
        setMailProviderMenuOpen(false);
        setMailProviderMenuHovered(false);
    };
    (0, $acw62.useEffect)(()=>{
        if (!mailProviderMenuOpen || mailProviderMenuHovered) return;
        const timeoutId = window.setTimeout(()=>{
            setMailProviderMenuOpen(false);
        }, 3000);
        return ()=>window.clearTimeout(timeoutId);
    }, [
        mailProviderMenuHovered,
        mailProviderMenuOpen
    ]);
    const renderDesignColorField = (label, value, onChange, hint, disabled = false)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "form-field settings-color-field settings-v2-design-color-field",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "settings-color-row settings-v2-design-color-row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "color",
                            value: value,
                            onChange: (e)=>onChange(e.target.value),
                            disabled: disabled
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            value: value,
                            onChange: (e)=>onChange(e.target.value),
                            disabled: disabled
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                    className: "settings-upload-hint",
                    children: hint
                })
            ]
        });
    const renderDesignToggleField = (label, checked, onChange)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "form-field settings-color-field settings-v2-design-color-field",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    className: "settings-toggle",
                    "aria-label": label,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: checked,
                            onChange: (e)=>onChange(e.target.checked)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "settings-toggle-slider"
                        })
                    ]
                })
            ]
        });
    const tabs = [
        {
            key: "allgemein",
            label: "Allgemein"
        },
        {
            key: "facilioo",
            label: "Facilioo"
        },
        {
            key: "mailversand",
            label: "Mailversand"
        },
        {
            key: "design",
            label: "Design"
        },
        {
            key: "uploads",
            label: "Uploads"
        },
        {
            key: "datenbestand",
            label: "Datenbestand"
        }
    ];
    const runClearDataByType = async ()=>{
        setDataClearPending(true);
        setDataClearStatus(null);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).clearDataByType(dataClearType);
            setDataClearStatus({
                type: "ok",
                text: `${result.message} Gel\xf6scht: Objekte ${result.deleted.objects}, Einheiten ${result.deleted.units}, Eigent\xfcmer ${result.deleted.owners}, Zuordnungen ${result.deleted.assignments}, Beschl\xfcsse ${result.deleted.resolutions}.`
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "L\xf6schvorgang fehlgeschlagen";
            setDataClearStatus({
                type: "error",
                text: message
            });
        } finally{
            setDataClearPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "resolutions-v2-page settings-v2-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "page-header panel resolutions-v2-page-header object-detail-v2-header settings-v2-header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "resolutions-v2-title object-detail-v2-title",
                        style: {
                            margin: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-title-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M5 7h14M5 12h14M5 17h14",
                                            stroke: "currentColor",
                                            strokeWidth: "1.9",
                                            strokeLinecap: "round"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: "9",
                                            cy: "7",
                                            r: "2",
                                            fill: "#fff",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: "15",
                                            cy: "12",
                                            r: "2",
                                            fill: "#fff",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: "11",
                                            cy: "17",
                                            r: "2",
                                            fill: "#fff",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "resolutions-v2-title-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-main",
                                        children: "Einstellungen"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-sub",
                                        children: "Mandant, Integrationen, Versand und Darstellung"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions settings-v2-header-actions",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: `settings-save-btn resolutions-v2-create-btn settings-v2-action-btn settings-v2-action-btn--primary${saveButtonFlash ? " is-flash" : ""}`,
                                onClick: ()=>{
                                    const first = Math.max(1, Math.min(365, Math.round(form.reminders.firstReminderDays || 1)));
                                    const secondRaw = Math.max(1, Math.min(365, Math.round(form.reminders.secondReminderDays || 1)));
                                    const second = secondRaw >= first ? Math.max(1, first - 1) : secondRaw;
                                    onChange({
                                        ...form,
                                        reminders: {
                                            firstReminderDays: first,
                                            secondReminderDays: second
                                        }
                                    });
                                    setSaveButtonFlash(true);
                                    window.setTimeout(()=>setSaveButtonFlash(false), 700);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-create-btn-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M4.4 4.4h9.1l2.1 2.1v9.1H4.4z",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.7"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M7 4.4v4h6v-4M7.4 15h5.2",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.7",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Einstellungen speichern"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "settings-v2-action-btn settings-v2-action-btn--secondary",
                                onClick: ()=>{
                                    setForm((0, $5806306cf67ca7cd$export$b22b9e406c4481db));
                                },
                                children: "Zur\xfccksetzen"
                            })
                        ]
                    }),
                    settingsActionFeedback || saveStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                        className: `settings-action-feedback ${(settingsActionFeedback ?? saveStatus)?.type}`,
                        children: (settingsActionFeedback ?? saveStatus)?.text
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel object-tabbar object-tabbar-v2 settings-v2-tabbar",
                children: tabs.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `object-tabbtn object-tabbtn-v2 ${tab === t.key ? "active" : ""}`,
                        onClick: ()=>setTab(t.key),
                        children: t.label
                    }, t.key))
            }),
            tab === "allgemein" && !isPlatformSettingsHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form settings-section settings-v2-section settings-v2-general-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-v2-card-head",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "settings-v2-card-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M6.2 19.2V5.4h8.7v13.8",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M14.9 9.2h3.2v10",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M8.8 8.2h1.1M11.5 8.2h1.1M8.8 11.5h1.1M11.5 11.5h1.1M8.8 14.8h1.1M11.5 14.8h1.1",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M4.7 19.2h14.6",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-card-title",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: "Hausverwaltungsdaten"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Diese Daten werden aus dem Mandantenprofil \xfcbernommen und k\xf6nnen hier nicht bearbeitet werden."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Firmenname"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.management.firmenname,
                                        disabled: true,
                                        readOnly: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stra\xdfe"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.management.strasse,
                                        disabled: true,
                                        readOnly: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "PLZ"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.management.plz,
                                        disabled: true,
                                        readOnly: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Ort"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.management.ort,
                                        disabled: true,
                                        readOnly: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "E-Mail"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.management.email,
                                        disabled: true,
                                        readOnly: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Telefon"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.management.telefon,
                                        disabled: true,
                                        readOnly: true
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            tab === "facilioo" && !isPlatformSettingsHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form settings-section settings-v2-section settings-v2-general-card settings-v2-facilioo-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-v2-card-head settings-v2-facilioo-head",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-facilioo-title-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "settings-v2-card-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M9.8 14.2 14.2 9.8",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M10.8 7.1 12 5.9a4 4 0 0 1 5.7 5.7l-1.2 1.2M13.2 16.9 12 18.1a4 4 0 1 1-5.7-5.7l1.2-1.2",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-card-title",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Facilioo"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Konfigurieren Sie die Facilioo-Integration und die Zuordnung der Datenfelder."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-facilioo-toggle-wrap settings-v2-facilioo-toggle",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "settings-toggle",
                                        "aria-label": "Facilioo aktivieren oder deaktivieren",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: form.management.faciliooEnabled !== false,
                                                onChange: (e)=>setForm((prev)=>({
                                                            ...prev,
                                                            management: {
                                                                ...prev.management,
                                                                faciliooEnabled: e.target.checked
                                                            }
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "settings-toggle-slider"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "settings-facilioo-state",
                                        children: [
                                            "Facilioo-Funktionen ",
                                            form.management.faciliooEnabled !== false ? "aktiv" : "deaktiviert"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "form-grid settings-v2-facilioo-grid",
                        children: form.management.faciliooEnabled !== false ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Verwaltungs-ID Facilioo ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "settings-v2-label-info",
                                                    title: "Mandanten- oder Verwaltungs-ID aus Facilioo",
                                                    children: "i"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "number",
                                            min: "0",
                                            step: "1",
                                            value: form.management.verwaltungsIdFacilioo,
                                            onChange: (e)=>setForm({
                                                    ...form,
                                                    management: {
                                                        ...form.management,
                                                        verwaltungsIdFacilioo: e.target.value
                                                    }
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Trennzeichen Stra\xdfe (f\xfcr Stra\xdfe 2) ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "settings-v2-label-info",
                                                    title: "Trennzeichen zum Aufteilen zus\xe4tzlicher Stra\xdfenangaben",
                                                    children: "i"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            value: form.management.faciliooStrasseTrennzeichen,
                                            placeholder: "|",
                                            onChange: (e)=>setForm({
                                                    ...form,
                                                    management: {
                                                        ...form.management,
                                                        faciliooStrasseTrennzeichen: e.target.value
                                                    }
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "MEA Attributname(n) ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "settings-v2-label-info",
                                                    title: "Facilioo-Attributnamen f\xfcr MEA-Werte",
                                                    children: "i"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            value: form.management.faciliooMeaAttributeNames,
                                            placeholder: "MEA Objekt, MEA",
                                            onChange: (e)=>setForm({
                                                    ...form,
                                                    management: {
                                                        ...form.management,
                                                        faciliooMeaAttributeNames: e.target.value
                                                    }
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Stimmrechte Attributname(n) ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "settings-v2-label-info",
                                                    title: "Facilioo-Attributnamen f\xfcr Stimmrechte",
                                                    children: "i"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            value: form.management.faciliooStimmrechteAttributeNames,
                                            placeholder: "Stimmrechte",
                                            onChange: (e)=>setForm({
                                                    ...form,
                                                    management: {
                                                        ...form.management,
                                                        faciliooStimmrechteAttributeNames: e.target.value
                                                    }
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Eigent\xfcmer-Zuordnungen importieren ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "settings-v2-label-info",
                                                    title: "Umfang der importierten Eigent\xfcmer-Zuordnungen",
                                                    children: "i"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: form.management.faciliooOwnerImportScope === "all" ? "all" : "current",
                                            onChange: (e)=>setForm((prev)=>({
                                                        ...prev,
                                                        management: {
                                                            ...prev.management,
                                                            faciliooOwnerImportScope: e.target.value === "all" ? "all" : "current"
                                                        }
                                                    })),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "current",
                                                    children: "Nur aktuelle (ab heute g\xfcltige)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "all",
                                                    children: "Alle (inkl. Vergangenheit)"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                "Objektfilter (kommagetrennt) ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "settings-v2-label-info",
                                                    title: "Optionale Facilioo-Objekttypen als Filter",
                                                    children: "i"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            value: form.management.faciliooObjectTypeFilter ?? "",
                                            placeholder: "z. B. WEG, GdWE",
                                            onChange: (e)=>setForm((prev)=>({
                                                        ...prev,
                                                        management: {
                                                            ...prev.management,
                                                            faciliooObjectTypeFilter: e.target.value
                                                        }
                                                    }))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            className: "settings-upload-hint",
                                            children: "Leer lassen = Vollimport ohne Objektfilter."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-field form-field-wide",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "settings-collapsible-toggle settings-v2-collapsible-card",
                                        "aria-expanded": showFaciliooKeyTables,
                                        onClick: ()=>setShowFaciliooKeyTables((prev)=>!prev),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "settings-v2-card-icon settings-v2-card-icon--compact",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M5.5 7.2h13M5.5 12h13M5.5 16.8h13",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                            cx: "9",
                                                            cy: "7.2",
                                                            r: "1.9",
                                                            fill: "#fff",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                            cx: "15",
                                                            cy: "12",
                                                            r: "1.9",
                                                            fill: "#fff",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                            cx: "11",
                                                            cy: "16.8",
                                                            r: "1.9",
                                                            fill: "#fff",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "settings-v2-collapsible-copy",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Schl\xfcsseltabellen"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        children: "Verwalten Sie die Zuordnung der Facilioo-Felder zu unseren Systemfeldern."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "settings-v2-collapsible-arrow",
                                                "aria-hidden": "true",
                                                children: showFaciliooKeyTables ? "\u2304" : "\u203A"
                                            })
                                        ]
                                    })
                                }),
                                showFaciliooKeyTables ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field form-field-wide settings-management-box",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-v2-keytable-title-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                    children: "Anrede-Schl\xfcsseltabelle"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                    className: "settings-upload-hint",
                                                                    children: "Spalte Definition = APP-Wert im Dropdown, Spalte Mapping = Facilioo-Suchbegriffe (Komma-getrennt). Briefanrede 1 und 2 werden direkt aus der Schluesseltabelle gezogen."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "settings-keytable-add settings-v2-keytable-add",
                                                            onClick: ()=>updateFaciliooAnredeKeyTable([
                                                                    ...form.management.faciliooAnredeKeyTable,
                                                                    {
                                                                        definition: "",
                                                                        mapping: ""
                                                                    }
                                                                ]),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Zeile hinzuf\xfcgen"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "+"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-keytable settings-keytable-anrede",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "settings-keytable-row settings-keytable-head",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Definition"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Mapping"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Briefanrede 1"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Briefanrede 2"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Aktion"
                                                                })
                                                            ]
                                                        }),
                                                        form.management.faciliooAnredeKeyTable.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "settings-keytable-row",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        value: row.definition,
                                                                        placeholder: "z. B. Frau / Herrn",
                                                                        onChange: (e)=>{
                                                                            const next = [
                                                                                ...form.management.faciliooAnredeKeyTable
                                                                            ];
                                                                            next[index] = {
                                                                                ...next[index],
                                                                                definition: e.target.value
                                                                            };
                                                                            updateFaciliooAnredeKeyTable(next);
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        value: row.mapping,
                                                                        placeholder: "z. B. frau/herr, frau und herr, herr und frau",
                                                                        onChange: (e)=>{
                                                                            const next = [
                                                                                ...form.management.faciliooAnredeKeyTable
                                                                            ];
                                                                            next[index] = {
                                                                                ...next[index],
                                                                                mapping: e.target.value
                                                                            };
                                                                            updateFaciliooAnredeKeyTable(next);
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        value: row.briefanrede_1 ?? "",
                                                                        placeholder: "z. B. Sehr geehrte Frau",
                                                                        onChange: (e)=>{
                                                                            const next = [
                                                                                ...form.management.faciliooAnredeKeyTable
                                                                            ];
                                                                            next[index] = {
                                                                                ...next[index],
                                                                                briefanrede_1: e.target.value
                                                                            };
                                                                            updateFaciliooAnredeKeyTable(next);
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        value: row.briefanrede_2 ?? "",
                                                                        placeholder: "z. B. Sehr geehrter Herr",
                                                                        onChange: (e)=>{
                                                                            const next = [
                                                                                ...form.management.faciliooAnredeKeyTable
                                                                            ];
                                                                            next[index] = {
                                                                                ...next[index],
                                                                                briefanrede_2: e.target.value
                                                                            };
                                                                            updateFaciliooAnredeKeyTable(next);
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "settings-v2-keytable-delete",
                                                                        "aria-label": "Zeile entfernen",
                                                                        title: "Zeile entfernen",
                                                                        onClick: ()=>updateFaciliooAnredeKeyTable(form.management.faciliooAnredeKeyTable.filter((_, rowIndex)=>rowIndex !== index)),
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            "aria-hidden": "true",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M6.5 7.6v7.1M10 7.6v7.1M13.5 7.6v7.1",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.6",
                                                                                    strokeLinecap: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M4.2 5.2h11.6M8 5.2V3.8h4v1.4M5.7 5.2l.7 11h7.2l.7-11",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.6",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }, `anrede-row-${index}`))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field form-field-wide settings-management-box",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-v2-keytable-title-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                    children: "Titel-Schl\xfcsseltabelle"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                    className: "settings-upload-hint",
                                                                    children: "Spalte Definition = Ziel-Titel, Spalte Mapping = Facilioo-Titelbegriffe (Komma-getrennt)."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "settings-keytable-add settings-v2-keytable-add",
                                                            onClick: ()=>updateFaciliooTitelKeyTable([
                                                                    ...form.management.faciliooTitelKeyTable,
                                                                    {
                                                                        definition: "",
                                                                        mapping: ""
                                                                    }
                                                                ]),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Zeile hinzuf\xfcgen"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "+"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-keytable",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "settings-keytable-row settings-keytable-head",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Definition"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Mapping"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Aktion"
                                                                })
                                                            ]
                                                        }),
                                                        form.management.faciliooTitelKeyTable.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "settings-keytable-row",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        value: row.definition,
                                                                        placeholder: "z. B. Dr.",
                                                                        onChange: (e)=>{
                                                                            const next = [
                                                                                ...form.management.faciliooTitelKeyTable
                                                                            ];
                                                                            next[index] = {
                                                                                ...next[index],
                                                                                definition: e.target.value
                                                                            };
                                                                            updateFaciliooTitelKeyTable(next);
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        value: row.mapping,
                                                                        placeholder: "z. B. dr, dr.",
                                                                        onChange: (e)=>{
                                                                            const next = [
                                                                                ...form.management.faciliooTitelKeyTable
                                                                            ];
                                                                            next[index] = {
                                                                                ...next[index],
                                                                                mapping: e.target.value
                                                                            };
                                                                            updateFaciliooTitelKeyTable(next);
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "settings-v2-keytable-delete",
                                                                        "aria-label": "Zeile entfernen",
                                                                        title: "Zeile entfernen",
                                                                        onClick: ()=>updateFaciliooTitelKeyTable(form.management.faciliooTitelKeyTable.filter((_, rowIndex)=>rowIndex !== index)),
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            "aria-hidden": "true",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M6.5 7.6v7.1M10 7.6v7.1M13.5 7.6v7.1",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.6",
                                                                                    strokeLinecap: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M4.2 5.2h11.6M8 5.2V3.8h4v1.4M5.7 5.2l.7 11h7.2l.7-11",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.6",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }, `titel-row-${index}`))
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-field form-field-wide",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "settings-collapsible-toggle settings-v2-collapsible-card",
                                        "aria-expanded": showFaciliooApiTokenSection,
                                        onClick: ()=>setShowFaciliooApiTokenSection((prev)=>!prev),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "settings-v2-card-icon settings-v2-card-icon--compact",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                            x: "5.2",
                                                            y: "4.9",
                                                            width: "13.6",
                                                            height: "14.2",
                                                            rx: "2.2",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M8.5 9.2h7M8.5 12h7M8.5 14.8h4.2",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M15.2 14.4 17 16.2l2.8-3.2",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "settings-v2-collapsible-copy",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "API-Schl\xfcssel"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        children: "Verwalten Sie Ihren Facilioo API-Schl\xfcssel f\xfcr den sicheren Datenaustausch."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "settings-v2-collapsible-arrow",
                                                "aria-hidden": "true",
                                                children: showFaciliooApiTokenSection ? "\u2304" : "\u203A"
                                            })
                                        ]
                                    })
                                }),
                                showFaciliooApiTokenSection ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field form-field-wide",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Facilioo API-Schl\xfcssel / Bearer Token"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "settings-secret-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                    className: `settings-token-textarea settings-token-textarea-compact ${showFaciliooApiKey ? "" : "is-masked"}`.trim(),
                                                    rows: 2,
                                                    autoComplete: "off",
                                                    value: form.management.faciliooApiKey,
                                                    onChange: (e)=>setForm({
                                                            ...form,
                                                            management: {
                                                                ...form.management,
                                                                faciliooApiKey: e.target.value
                                                            }
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "owner-auth-eye-btn",
                                                    onClick: ()=>setShowFaciliooApiKey((v)=>!v),
                                                    "aria-label": showFaciliooApiKey ? "API-Schl\xfcssel verbergen" : "API-Schl\xfcssel anzeigen",
                                                    title: showFaciliooApiKey ? "API-Schl\xfcssel verbergen" : "API-Schl\xfcssel anzeigen",
                                                    children: showFaciliooApiKey ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        "aria-hidden": "true",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "3.2",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M4 4l16 16",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        "aria-hidden": "true",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "3.2",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "settings-facilioo-webhook-card",
                                            style: {
                                                marginTop: 12
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: "Facilioo Dokumentgruppe"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-facilioo-docgroup-section",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Bestehende Dokumentgruppe ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "settings-facilioo-webhook-target-row settings-facilioo-docgroup-picker-row",
                                                            style: {
                                                                gap: 8
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    value: faciliooCreateParentGroupId,
                                                                    onChange: (e)=>{
                                                                        const nextId = String(e.target.value || $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE).trim() || $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE;
                                                                        const selectedGroup = faciliooDocumentGroupOptions.find((group)=>group.groupId === nextId);
                                                                        setFaciliooCreateParentGroupId(nextId);
                                                                        setForm((prev)=>({
                                                                                ...prev,
                                                                                management: {
                                                                                    ...prev.management,
                                                                                    faciliooDocumentGroupId: nextId === $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE ? "" : nextId,
                                                                                    faciliooDocumentGroupName: nextId === $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE ? prev.management.faciliooDocumentGroupName : String(selectedGroup?.groupName ?? prev.management.faciliooDocumentGroupName ?? "").trim()
                                                                                }
                                                                            }));
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE,
                                                                            children: "keine"
                                                                        }),
                                                                        faciliooDocumentGroupOptions.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: group.groupId,
                                                                                children: group.label
                                                                            }, group.groupId))
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "settings-facilioo-docgroup-refresh-btn settings-v2-inline-action",
                                                                    onClick: ()=>void refreshFaciliooDocumentGroups(),
                                                                    disabled: faciliooDocumentGroupsLoading,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "settings-v2-inline-action-icon",
                                                                            "aria-hidden": "true",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                                viewBox: "0 0 20 20",
                                                                                fill: "none",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "M15.2 7.1A5.8 5.8 0 0 0 5 5.8L3.8 7.2M4.8 12.9A5.8 5.8 0 0 0 15 14.2l1.2-1.4",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.7",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "M3.8 3.9v3.3h3.3M16.2 16.1v-3.3h-3.3",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.7",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: faciliooDocumentGroupsLoading ? "Lade..." : "Liste aktualisieren"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "settings-facilioo-webhook-target-row settings-facilioo-docgroup-id-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "settings-facilioo-docgroup-current",
                                                                children: (()=>{
                                                                    const currentId = String(faciliooCreateParentGroupId ?? "").trim();
                                                                    if (!currentId || currentId === $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE) return "keine";
                                                                    const selected = faciliooDocumentGroupOptions.find((group)=>group.groupId === currentId);
                                                                    const currentName = String(selected?.groupName ?? form.management.faciliooDocumentGroupName ?? "").trim();
                                                                    return `${currentName || "Dokumentgruppe"} | ${currentId}`;
                                                                })()
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-facilioo-docgroup-section settings-facilioo-docgroup-create-section",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: facliooSelectedParentHierarchy ? `Neue Untergruppe in der Gruppe ${facliooSelectedParentHierarchy} anlegen` : "Neue Dokumentengruppe anlegen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "settings-facilioo-webhook-target-row settings-facilioo-docgroup-create-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                value: faciliooCreateGroupName,
                                                                onChange: (e)=>setFaciliooCreateGroupName(e.target.value),
                                                                placeholder: faciliooCreateParentGroupId === $cfa3ec47cc17e8e8$var$FACILIOO_GROUP_NONE ? "Neue Gruppe (z.B. Umlaufbeschl\xfcsse)" : "Neue Untergruppe (z.B. 2026)"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            className: "settings-upload-hint",
                                                            children: "Ist oben eine Gruppe ausgew\xe4hlt, wird der eingegebene Name als Untergruppe unter dieser Hauptgruppe angelegt."
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            className: "settings-upload-hint",
                                                            children: 'Auswahl "keine": es wird eine neue Gruppe angelegt. Bei ausgew\xe4hlter Gruppe wird eine Untergruppe angelegt.'
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "settings-logo-actions settings-facilioo-webhook-actions",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "settings-v2-inline-action",
                                                                    onClick: ()=>void ensureFaciliooDocumentGroup(),
                                                                    disabled: faciliooDocumentGroupCreating || faciliooDocumentGroupResetting,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "settings-v2-inline-action-icon",
                                                                            "aria-hidden": "true",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                viewBox: "0 0 20 20",
                                                                                fill: "none",
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M10 4.2v11.6M4.2 10h11.6",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.8",
                                                                                    strokeLinecap: "round"
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: faciliooDocumentGroupCreating ? "Lege an..." : "Dokumentgruppe in Facilioo anlegen"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "settings-v2-inline-action",
                                                                    onClick: ()=>void resetFaciliooDocumentGroup(),
                                                                    disabled: faciliooDocumentGroupCreating || faciliooDocumentGroupResetting,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "settings-v2-inline-action-icon",
                                                                            "aria-hidden": "true",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                                viewBox: "0 0 20 20",
                                                                                fill: "none",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "M6.5 7.6v7.1M10 7.6v7.1M13.5 7.6v7.1",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.6",
                                                                                        strokeLinecap: "round"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                        d: "M4.2 5.2h11.6M8 5.2V3.8h4v1.4M5.7 5.2l.7 11h7.2l.7-11",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "1.6",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: faciliooDocumentGroupResetting ? "Setze zur\xfcck..." : "Dokumentgruppe zur\xfccksetzen"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "settings-facilioo-webhook-card",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: "Facilioo Webhook Ziel (authorizationType 4)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-facilioo-toggle-wrap",
                                                    style: {
                                                        marginBottom: 10
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "settings-toggle",
                                                            "aria-label": "Facilioo Webhook aktivieren oder deaktivieren",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: form.management.faciliooWebhookEnabled !== false,
                                                                    onChange: (e)=>setForm((prev)=>({
                                                                                ...prev,
                                                                                management: {
                                                                                    ...prev.management,
                                                                                    faciliooWebhookEnabled: e.target.checked
                                                                                }
                                                                            }))
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "settings-toggle-slider"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "settings-facilioo-state",
                                                            children: [
                                                                "Webhook-Verarbeitung ",
                                                                form.management.faciliooWebhookEnabled !== false ? "aktiv" : "deaktiviert"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-facilioo-webhook-target-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            readOnly: true,
                                                            value: faciliooWebhookStatus?.targetUrl ?? "",
                                                            placeholder: faciliooWebhookLoading ? "Webhook endpoint wird geladen..." : "Webhook endpoint nicht verfuegbar"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "settings-v2-copy-button",
                                                            "aria-label": "Webhook Endpoint kopieren",
                                                            title: "Webhook Endpoint kopieren",
                                                            disabled: !faciliooWebhookStatus?.targetUrl,
                                                            onClick: ()=>{
                                                                if (!faciliooWebhookStatus?.targetUrl) return;
                                                                navigator.clipboard?.writeText(faciliooWebhookStatus.targetUrl);
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                viewBox: "0 0 20 20",
                                                                fill: "none",
                                                                "aria-hidden": "true",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                        x: "7",
                                                                        y: "5",
                                                                        width: "8.5",
                                                                        height: "10.5",
                                                                        rx: "1.4",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.6"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M5 13V6.8A1.8 1.8 0 0 1 6.8 5H13",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.6",
                                                                        strokeLinecap: "round"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    className: "settings-upload-hint",
                                                    children: "In Facilioo als targetUrl eintragen. Authentifizierung: authorizationType = 4 mit dem unten erzeugten API-Key."
                                                }),
                                                form.management.faciliooWebhookEnabled === false ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    className: "settings-upload-hint",
                                                    style: {
                                                        color: "#b42318",
                                                        fontWeight: 600
                                                    },
                                                    children: "Webhook ist lokal deaktiviert: eingehende Events werden angenommen, aber nicht verarbeitet."
                                                }) : null,
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-facilioo-webhook-prefix",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Aktiver Key:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: faciliooWebhookStatus?.credential?.keyPrefix ? `${faciliooWebhookStatus.credential.keyPrefix}...` : faciliooWebhookStatus?.hasCredential ? "vorhanden" : "noch nicht erstellt"
                                                        })
                                                    ]
                                                }),
                                                faciliooWebhookFeedback ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: `settings-facilioo-webhook-feedback ${faciliooWebhookFeedback.type === "ok" ? "is-ok" : "is-error"}`,
                                                    role: "status",
                                                    children: faciliooWebhookFeedback.text
                                                }) : null,
                                                faciliooWebhookConnectionTest ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: `settings-facilioo-webhook-feedback ${faciliooWebhookConnectionTest.ok ? "is-ok" : "is-error"}`,
                                                    role: "status",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Testzeitpunkt:"
                                                                }),
                                                                " ",
                                                                formatDateTimeDE(faciliooWebhookConnectionTest.checkedAt)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Outbound:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.ok ? "OK" : "Fehler",
                                                                " -",
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.message
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Inbound:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.inbound.ok ? "OK" : "Fehler",
                                                                " -",
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.inbound.message
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Letzter erfolgreicher Inbound (2xx):"
                                                                }),
                                                                " ",
                                                                formatDateTimeDE(faciliooWebhookConnectionTest.checks.inbound.lastSuccessfulInboundAt ?? undefined),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.inbound.lastSuccessfulInboundStatus ? `(HTTP ${faciliooWebhookConnectionTest.checks.inbound.lastSuccessfulInboundStatus})` : ""
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Erfolgreiche Event-ID / Webhook-ID:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.inbound.lastSuccessfulEventId ?? "-",
                                                                " /",
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.inbound.lastSuccessfulWebhookId ?? "-"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Letzter deduplizierter Event:"
                                                                }),
                                                                " ",
                                                                formatDateTimeDE(faciliooWebhookConnectionTest.checks.inbound.lastDeduplicatedAt ?? undefined),
                                                                " ",
                                                                "(",
                                                                faciliooWebhookConnectionTest.checks.inbound.lastDeduplicatedEventId ?? "-",
                                                                " /",
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.inbound.lastDeduplicatedWebhookId ?? "-",
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Letzter Reject (4xx/5xx):"
                                                                }),
                                                                " ",
                                                                formatDateTimeDE(faciliooWebhookConnectionTest.checks.inbound.lastRejectAt ?? undefined),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.inbound.lastRejectStatus ? `(HTTP ${faciliooWebhookConnectionTest.checks.inbound.lastRejectStatus})` : ""
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Reject Event-ID / Webhook-ID:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.inbound.lastEventId ?? "-",
                                                                " /",
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.inbound.lastRejectWebhookId ?? "-"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Webhook-Registration-Events:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.registrationValidation.hasAllExpectedEvents ? "vollstaendig" : "unvollstaendig",
                                                                " ",
                                                                "(registriert: ",
                                                                faciliooWebhookConnectionTest.checks.outbound.registrationValidation.registeredEvents.length,
                                                                ", erwartet:",
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.registrationValidation.expectedEvents.length,
                                                                ")"
                                                            ]
                                                        }),
                                                        faciliooWebhookConnectionTest.checks.outbound.registrationValidation.missingEvents.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Fehlende Events:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.registrationValidation.missingEvents.map((event)=>`${event.entityName}.${event.type}`).join(", ")
                                                            ]
                                                        }) : null,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Facilioo Deep-Check:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.deepCheck.ok ? "OK" : "Hinweis",
                                                                " -",
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.deepCheck.message
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Events erzeugt:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.deepCheck.matchingWebhooksCount,
                                                                " |",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Zustellversuche:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.deepCheck.matchingAttemptsCount
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Letzter Attempt-HTTP-Status:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.deepCheck.latestAttempt?.responseStatusCode ?? "-"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Letzter Attempt Webhook-ID:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.outbound.deepCheck.latestAttempt?.webhookId ?? "-"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Sync:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.sync.ok ? "OK" : "Fehler",
                                                                " -",
                                                                " ",
                                                                faciliooWebhookConnectionTest.checks.sync.message
                                                            ]
                                                        })
                                                    ]
                                                }) : null,
                                                faciliooWebhookPingResult ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: `settings-facilioo-webhook-feedback ${faciliooWebhookPingResult.ok ? "is-ok" : "is-error"}`,
                                                    role: "status",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Inbound-Ping:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookPingResult.ok ? "OK" : "Fehler",
                                                                " -",
                                                                " ",
                                                                faciliooWebhookPingResult.message
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Status:"
                                                                }),
                                                                " HTTP ",
                                                                faciliooWebhookPingResult.statusCode
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Event-ID / Webhook-ID:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookPingResult.eventId,
                                                                " / ",
                                                                faciliooWebhookPingResult.webhookId
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "API-Key Prefix:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookPingResult.apiKeyPrefix ?? "-"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Antwort:"
                                                                }),
                                                                " ",
                                                                faciliooWebhookPingResult.responseBody || "-"
                                                            ]
                                                        })
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-logo-actions settings-facilioo-webhook-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "settings-v2-inline-action",
                                                            onClick: ()=>void regenerateFaciliooWebhookKey(),
                                                            disabled: faciliooWebhookRegenerating,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "settings-v2-inline-action-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M8.4 11.6 11.6 8.4",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7",
                                                                                strokeLinecap: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M8.9 6.2 10 5.1a3.3 3.3 0 0 1 4.7 4.7l-1.1 1.1M11.1 13.8 10 14.9a3.3 3.3 0 0 1-4.7-4.7l1.1-1.1",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: faciliooWebhookRegenerating ? "Erzeuge..." : faciliooWebhookStatus?.hasCredential ? "Webhook-Key neu erzeugen" : "Webhook-Key erzeugen"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "settings-v2-inline-action",
                                                            onClick: ()=>void registerFaciliooWebhookAtFacilioo(),
                                                            disabled: faciliooWebhookRegistering,
                                                            title: "Erzeugt automatisch einen Webhook-Key, ersetzt alte Registrierungen f\xfcr die gleiche targetUrl und legt die neue Registration bei Facilioo an.",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "settings-v2-inline-action-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M6.2 12.2a3.8 3.8 0 1 1 5.8-3.7h1.4a2.8 2.8 0 0 1 .2 5.6H7.1a2.2 2.2 0 0 1-.9-4.2",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.6",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M10 7.6v5M7.8 9.8 10 7.6l2.2 2.2",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.6",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: faciliooWebhookRegistering ? "Registriere..." : "Bei Facilioo registrieren"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "settings-v2-inline-action",
                                                            onClick: ()=>void testFaciliooWebhookConnection(),
                                                            disabled: faciliooWebhookConnectionTesting,
                                                            title: "Pr\xfcft Facilioo-API, vorhandene Webhook-Registration, letzte eingehende Webhooks und Live-Sync-Zeitfenster.",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "settings-v2-inline-action-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M8.4 11.6 11.6 8.4",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7",
                                                                                strokeLinecap: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M8.9 6.2 10 5.1a3.3 3.3 0 0 1 4.7 4.7l-1.1 1.1M11.1 13.8 10 14.9a3.3 3.3 0 0 1-4.7-4.7l1.1-1.1",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: faciliooWebhookConnectionTesting ? "Pr\xfcfe..." : "Verbindung testen"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "settings-v2-inline-action",
                                                            onClick: ()=>void pingFaciliooWebhookConnection(),
                                                            disabled: faciliooWebhookPingTesting,
                                                            title: "Sendet einen lokalen Ping durch denselben Webhook-Endpoint zur Pruefung von Routing, API-Key-Validierung, Parsing und Queue.",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "settings-v2-inline-action-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M4.2 10h2.1m7.4 0h2.1M10 4.2v2.1m0 7.4v2.1M6.9 6.9l1.5 1.5m3.2 3.2 1.5 1.5M13.1 6.9l-1.5 1.5m-3.2 3.2-1.5 1.5",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.6",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: faciliooWebhookPingTesting ? "Pinge..." : "Inbound-Ping testen"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                faciliooWebhookGeneratedKey ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-facilioo-webhook-generated",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Neuer Webhook API-Key (einmalig anzeigen)"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "settings-secret-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                                    className: `settings-token-textarea settings-token-textarea-compact ${showFaciliooWebhookApiKey ? "" : "is-masked"}`.trim(),
                                                                    rows: 2,
                                                                    readOnly: true,
                                                                    value: faciliooWebhookGeneratedKey
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "owner-auth-eye-btn",
                                                                    onClick: ()=>setShowFaciliooWebhookApiKey((v)=>!v),
                                                                    "aria-label": showFaciliooWebhookApiKey ? "Webhook API-Key verbergen" : "Webhook API-Key anzeigen",
                                                                    title: showFaciliooWebhookApiKey ? "Webhook API-Key verbergen" : "Webhook API-Key anzeigen",
                                                                    children: showFaciliooWebhookApiKey ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        width: "18",
                                                                        height: "18",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        "aria-hidden": "true",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                cx: "12",
                                                                                cy: "12",
                                                                                r: "3.2",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M4 4l16 16",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round"
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        width: "18",
                                                                        height: "18",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        "aria-hidden": "true",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                cx: "12",
                                                                                cy: "12",
                                                                                r: "3.2",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-field form-field-wide",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-sync-info-banner v2-info-banner settings-v2-facilioo-info",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "imports-sync-info-icon",
                                                "aria-hidden": "true",
                                                children: "i"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "imports-sync-info-copy",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Hinweis"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "\xc4nderungen an dieser Konfiguration werden erst nach dem Speichern aktiv."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "form-field form-field-wide",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                className: "settings-upload-hint",
                                children: "Facilioo ist deaktiviert. Synchronisierung, Facilioo-Importe und Vorgangsnummern in der Beschlussanlage sind ausgeblendet."
                            })
                        })
                    })
                ]
            }) : null,
            tab === "mailversand" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form settings-section settings-v2-section settings-v2-mail-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-v2-card-head settings-v2-mail-head",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "settings-v2-card-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$MailEnvelopeIcon, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-card-title",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: form.mail.provider === "brevo_api" ? "Mailversand mit Brevo" : "Mailversand"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: form.mail.provider === "brevo_api" ? "Verbinden Sie Ihr Brevo-Konto, um E-Mails \xfcber die Brevo API zu versenden." : form.mail.provider === "smtp" ? "Konfigurieren Sie den SMTP-Server f\xfcr den E-Mail-Versand." : "Konfigurieren Sie den E-Mail Versand und die zugeh\xf6rigen Einstellungen."
                                    })
                                ]
                            }),
                            form.mail.provider === "brevo_api" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "settings-v2-mail-state-badge",
                                children: "Nicht verbunden"
                            }) : null,
                            form.mail.provider === "smtp" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                className: "settings-v2-help-btn",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "?"
                                    }),
                                    "Hilfe zur Einrichtung",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "settings-v2-help-chevron",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "m5.4 7.8 4.6 4.6 4.6-4.6",
                                                stroke: "currentColor",
                                                strokeWidth: "1.7",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-grid settings-v2-mail-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field form-field-wide settings-v2-mail-panel settings-v2-mail-provider-panel",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        children: [
                                            "Provider",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "settings-v2-label-info",
                                                title: "Versanddienst f\xfcr ausgehende E-Mails",
                                                children: "i"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-provider-dropdown",
                                        onMouseEnter: ()=>setMailProviderMenuHovered(true),
                                        onMouseLeave: ()=>setMailProviderMenuHovered(false),
                                        onFocus: ()=>setMailProviderMenuHovered(true),
                                        onBlur: (event)=>{
                                            if (!event.currentTarget.contains(event.relatedTarget)) setMailProviderMenuHovered(false);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                className: "settings-v2-provider-trigger",
                                                onClick: ()=>setMailProviderMenuOpen((open)=>!open),
                                                "aria-haspopup": "listbox",
                                                "aria-expanded": mailProviderMenuOpen,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-provider-logo",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$MailProviderIcon, {
                                                            provider: selectedMailProvider.value
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: selectedMailProvider.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-provider-chevron",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                            viewBox: "0 0 20 20",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "m5.4 7.8 4.6 4.6 4.6-4.6",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.7",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            mailProviderMenuOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "settings-v2-provider-menu",
                                                role: "listbox",
                                                children: mailProviderOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: `settings-v2-provider-option ${option.value === form.mail.provider ? "is-selected" : ""}`,
                                                        onClick: ()=>updateMailProvider(option.value),
                                                        role: "option",
                                                        "aria-selected": option.value === form.mail.provider,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "settings-v2-provider-logo",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$MailProviderIcon, {
                                                                    provider: option.value
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "settings-v2-provider-option-copy",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: option.label
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                        children: option.description
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, option.value))
                                            }) : null
                                        ]
                                    }),
                                    form.mail.provider === "microsoft_graph" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-mail-provider-extra-grid",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field settings-v2-mail-provider-extra-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        children: [
                                                            "Freigegebenes Postfach (optional)",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "settings-v2-label-info",
                                                                title: "Optionales Shared Mailbox Konto",
                                                                children: "i"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        placeholder: "z. B. info@firma.de",
                                                        value: form.mail.microsoftSharedMailboxEmail || "",
                                                        onChange: (e)=>setForm((prev)=>({
                                                                    ...prev,
                                                                    mail: {
                                                                        ...prev.mail,
                                                                        microsoftSharedMailboxEmail: e.target.value
                                                                    }
                                                                }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        className: "settings-upload-hint",
                                                        children: "Wenn gesetzt, sendet Microsoft 365 \xfcber dieses Postfach (Benutzer braucht Send-As/Send-on-behalf Rechte)."
                                                    })
                                                ]
                                            }),
                                            form.management.faciliooEnabled !== false ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field settings-v2-mail-provider-extra-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        children: [
                                                            "R\xfcckl\xe4ufer-Zielordner",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "settings-v2-label-info",
                                                                title: "Ordner f\xfcr NDR- und Bounce-Pr\xfcfungen",
                                                                children: "i"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                        value: selectedMicrosoftNdrFolderValue,
                                                        onChange: (e)=>{
                                                            const selected = String(e.target.value ?? "").trim();
                                                            setForm((prev)=>({
                                                                    ...prev,
                                                                    mail: {
                                                                        ...prev.mail,
                                                                        microsoftNdrFolders: selected === $cfa3ec47cc17e8e8$var$NDR_FOLDER_DEFAULT ? "" : selected
                                                                    }
                                                                }));
                                                        },
                                                        children: microsoftNdrFolderOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: option.value,
                                                                children: option.label
                                                            }, option.value))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "settings-v2-mail-folder-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                type: "button",
                                                                className: "settings-v2-inline-action",
                                                                onClick: ()=>void loadMicrosoftNdrFolders({
                                                                        mailbox: String(form.mail.microsoftSharedMailboxEmail ?? "").trim()
                                                                    }),
                                                                disabled: microsoftNdrFoldersLoading || !microsoftMailStatus?.connected,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "settings-v2-inline-action-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M5.1 6.3A5.6 5.6 0 0 1 15 8.8h-2.2M14.9 13.7A5.6 5.6 0 0 1 5 11.2h2.2",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.6",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M15 5v3.8h-3.8M5 15v-3.8h3.8",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "1.6",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    microsoftNdrFoldersLoading ? "Lade Ordner..." : "Ordner laden"
                                                                ]
                                                            }),
                                                            microsoftNdrFoldersMailbox ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                                className: "settings-upload-hint",
                                                                children: [
                                                                    "Quelle: ",
                                                                    microsoftNdrFoldersMailbox
                                                                ]
                                                            }) : null
                                                        ]
                                                    }),
                                                    microsoftNdrFoldersError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        className: "settings-upload-hint",
                                                        style: {
                                                            color: "#b42318",
                                                            fontWeight: 600
                                                        },
                                                        children: microsoftNdrFoldersError
                                                    }) : null,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        className: "settings-upload-hint",
                                                        children: "Dieser Ordner wird zus\xe4tzlich zum Posteingang f\xfcr NDR/Bounce-Pr\xfcfungen verwendet."
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }) : null
                                ]
                            }),
                            form.mail.provider !== "microsoft_graph" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    "Absendername",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-label-info",
                                                        title: "Angezeigter Name des Absenders",
                                                        children: "i"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: form.mail.fromName,
                                                onChange: (e)=>setForm((prev)=>({
                                                            ...prev,
                                                            mail: {
                                                                ...prev.mail,
                                                                fromName: e.target.value
                                                            }
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Name, der als Absender angezeigt wird."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    "Absender E-Mail",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-label-info",
                                                        title: "Adresse, von der gesendet wird",
                                                        children: "i"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: form.mail.fromEmail,
                                                onChange: (e)=>setForm((prev)=>({
                                                            ...prev,
                                                            mail: {
                                                                ...prev.mail,
                                                                fromEmail: e.target.value
                                                            }
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Die E-Mail-Adresse, von der aus gesendet wird."
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            form.mail.provider !== "microsoft_graph" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        children: [
                                            "Reply-To E-Mail",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "settings-v2-label-info",
                                                title: "Adresse f\xfcr Antworten",
                                                children: "i"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.mail.replyToEmail,
                                        onChange: (e)=>setForm((prev)=>({
                                                    ...prev,
                                                    mail: {
                                                        ...prev.mail,
                                                        replyToEmail: e.target.value
                                                    }
                                                }))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        className: "settings-upload-hint",
                                        children: "E-Mail-Adresse f\xfcr Antworten (Reply-To)."
                                    })
                                ]
                            }) : null,
                            form.mail.provider === "smtp" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    "SMTP Host",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-label-info",
                                                        title: "Hostname des SMTP-Servers",
                                                        children: "i"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: form.mail.smtpHost,
                                                onChange: (e)=>setForm((prev)=>({
                                                            ...prev,
                                                            mail: {
                                                                ...prev.mail,
                                                                smtpHost: e.target.value
                                                            }
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Hostname des SMTP-Servers."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    "SMTP Port",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-label-info",
                                                        title: "Port des SMTP-Servers",
                                                        children: "i"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: "1",
                                                max: "65535",
                                                value: form.mail.smtpPort > 0 ? form.mail.smtpPort : "",
                                                onChange: (e)=>setForm((prev)=>({
                                                            ...prev,
                                                            mail: {
                                                                ...prev.mail,
                                                                smtpPort: Number.isFinite(e.target.valueAsNumber) ? e.target.valueAsNumber : 0
                                                            }
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Port des SMTP-Servers."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    "SMTP Benutzer",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-label-info",
                                                        title: "Benutzername f\xfcr SMTP",
                                                        children: "i"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: form.mail.smtpUser,
                                                onChange: (e)=>setForm((prev)=>({
                                                            ...prev,
                                                            mail: {
                                                                ...prev.mail,
                                                                smtpUser: e.target.value
                                                            }
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Benutzername f\xfcr die SMTP-Authentifizierung."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    "SMTP Passwort",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-label-info",
                                                        title: "Passwort des SMTP-Benutzers",
                                                        children: "i"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-secret-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: showSmtpPassword ? "text" : "password",
                                                        autoComplete: "off",
                                                        value: form.mail.smtpPassword,
                                                        onChange: (e)=>setForm((prev)=>({
                                                                    ...prev,
                                                                    mail: {
                                                                        ...prev.mail,
                                                                        smtpPassword: e.target.value
                                                                    }
                                                                }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "owner-auth-eye-btn",
                                                        onClick: ()=>setShowSmtpPassword((v)=>!v),
                                                        "aria-label": showSmtpPassword ? "SMTP Passwort verbergen" : "SMTP Passwort anzeigen",
                                                        title: showSmtpPassword ? "SMTP Passwort verbergen" : "SMTP Passwort anzeigen",
                                                        children: showSmtpPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            "aria-hidden": "true",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "12",
                                                                    cy: "12",
                                                                    r: "3.2",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M4 4l16 16",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round"
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            "aria-hidden": "true",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "12",
                                                                    cy: "12",
                                                                    r: "3.2",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Passwort des SMTP-Benutzers."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    "SMTP Secure (TLS)",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-label-info",
                                                        title: "Verschl\xfcsselung der SMTP-Verbindung",
                                                        children: "i"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: form.mail.smtpSecure ? "true" : "false",
                                                onChange: (e)=>setForm((prev)=>({
                                                            ...prev,
                                                            mail: {
                                                                ...prev.mail,
                                                                smtpSecure: e.target.value === "true"
                                                            }
                                                        })),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "false",
                                                        children: "Nein"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "true",
                                                        children: "Ja"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Verschl\xfcsselungsmethode f\xfcr die Verbindung."
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            form.mail.provider === "brevo_api" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Brevo API-Key"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-secret-row",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: showBrevoApiKey ? "text" : "password",
                                                autoComplete: "off",
                                                value: form.mail.brevoApiKey,
                                                onChange: (e)=>setForm((prev)=>({
                                                            ...prev,
                                                            mail: {
                                                                ...prev.mail,
                                                                brevoApiKey: e.target.value
                                                            }
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "owner-auth-eye-btn",
                                                onClick: ()=>setShowBrevoApiKey((v)=>!v),
                                                "aria-label": showBrevoApiKey ? "Brevo API-Key verbergen" : "Brevo API-Key anzeigen",
                                                title: showBrevoApiKey ? "Brevo API-Key verbergen" : "Brevo API-Key anzeigen",
                                                children: showBrevoApiKey ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    width: "18",
                                                    height: "18",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    "aria-hidden": "true",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                            cx: "12",
                                                            cy: "12",
                                                            r: "3.2",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M4 4l16 16",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    width: "18",
                                                    height: "18",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    "aria-hidden": "true",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                            cx: "12",
                                                            cy: "12",
                                                            r: "3.2",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        className: "settings-upload-hint",
                                        style: {
                                            display: "block",
                                            marginTop: 8
                                        },
                                        children: "Ihren API-Key finden Sie in Ihrem Brevo-Konto unter Einstellungen > API & Authentifizierung."
                                    })
                                ]
                            }) : null,
                            form.mail.provider === "brevo_api" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        children: [
                                            "Test-Empf\xe4nger",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "settings-v2-label-info",
                                                title: "Adresse f\xfcr den Testversand",
                                                children: "i"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: form.mail.testRecipientEmail,
                                        onChange: (e)=>setForm((prev)=>({
                                                    ...prev,
                                                    mail: {
                                                        ...prev.mail,
                                                        testRecipientEmail: e.target.value
                                                    }
                                                }))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        className: "settings-upload-hint",
                                        style: {
                                            display: "block",
                                            marginTop: 8
                                        },
                                        children: "An diese Adresse wird der Testversand gesendet."
                                    })
                                ]
                            }) : null,
                            form.mail.provider === "microsoft_graph" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-field form-field-wide settings-v2-mail-panel settings-v2-mail-connect-panel",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "settings-v2-mail-connect-content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "settings-v2-mail-service",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "settings-v2-ms-logo",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$MailProviderIcon, {
                                                        provider: "microsoft_graph"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "settings-v2-mail-service-copy",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                            children: "Microsoft 365"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "settings-v2-mail-status-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: `settings-v2-mail-status ${microsoftMailStatus?.connected ? "is-connected" : "is-disconnected"}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            "aria-hidden": "true",
                                                                            children: microsoftMailStatus?.connected ? "\u2713" : "!"
                                                                        }),
                                                                        microsoftMailStatus?.connected ? "verbunden" : "nicht verbunden"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                    children: microsoftMailStatus?.connected ? `Verbunden als ${microsoftMailStatus.accountEmail || "-"}` : "Keine aktive Microsoft 365 Verbindung."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "settings-v2-mail-actions",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: "settings-v2-inline-action",
                                                    onClick: connectMicrosoftMail,
                                                    disabled: microsoftMailPending,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "settings-v2-inline-action-icon",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                viewBox: "0 0 20 20",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M4.5 10h6.9M8.6 6.1 12.5 10l-3.9 3.9",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.7",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M12.8 5.2h2.7A1.5 1.5 0 0 1 17 6.7v6.6a1.5 1.5 0 0 1-1.5 1.5h-2.7",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.7",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        microsoftMailPending ? "Weiterleitung..." : "Mit Microsoft verbinden"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: "settings-v2-inline-action settings-v2-inline-action--danger",
                                                    onClick: disconnectMicrosoftMail,
                                                    disabled: microsoftMailPending || !microsoftMailStatus?.connected,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "settings-v2-inline-action-icon",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                viewBox: "0 0 20 20",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                        cx: "10",
                                                                        cy: "10",
                                                                        r: "6.1",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.7"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "m7.8 7.8 4.4 4.4m0-4.4-4.4 4.4",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "1.7",
                                                                        strokeLinecap: "round"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        "Verbindung trennen"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : null,
                            form.mail.provider === "brevo_api" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-field form-field-wide settings-v2-mail-brevo-test-action",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    className: "settings-v2-inline-action",
                                    onClick: runMailTest,
                                    disabled: mailTestPending,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "settings-v2-inline-action-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                viewBox: "0 0 20 20",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M16.2 4.2 8.8 11.6M16.2 4.2l-4.4 12-3-4.6-4.8-2.4 12.2-5Z",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.6",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        }),
                                        mailTestPending ? "Testversand l\xe4uft..." : "Testversand senden"
                                    ]
                                })
                            }) : null,
                            form.mail.provider !== "brevo_api" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field form-field-wide settings-v2-mail-panel settings-v2-mail-test-panel",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-mail-service settings-v2-mail-service--compact",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "settings-v2-card-icon settings-v2-card-icon--compact",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$MailEnvelopeIcon, {})
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-v2-mail-service-copy",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        children: "Test-Empf\xe4nger"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        children: "Senden Sie eine Test-E-Mail, um die Konfiguration zu pr\xfcfen."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-mail-test-row",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: form.mail.testRecipientEmail,
                                                onChange: (e)=>setForm((prev)=>({
                                                            ...prev,
                                                            mail: {
                                                                ...prev.mail,
                                                                testRecipientEmail: e.target.value
                                                            }
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                className: "settings-v2-inline-action",
                                                onClick: runMailTest,
                                                disabled: mailTestPending,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-v2-inline-action-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                            viewBox: "0 0 20 20",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M16.2 4.2 8.8 11.6M16.2 4.2l-4.4 12-3-4.6-4.8-2.4 12.2-5Z",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.6",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    }),
                                                    mailTestPending ? "Testversand l\xe4uft..." : "Testversand senden"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            mailTestStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-field form-field-wide",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                    style: {
                                        color: mailTestStatus.type === "ok" ? "#0f7b31" : "#b42318",
                                        fontWeight: 600
                                    },
                                    children: mailTestStatus.text
                                })
                            }) : null,
                            form.mail.provider === "smtp" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-field form-field-wide",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "imports-sync-info-banner v2-info-banner settings-v2-mail-info",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "imports-sync-info-icon",
                                            "aria-hidden": "true",
                                            children: "i"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "imports-sync-info-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Hinweis"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Bitte stellen Sie sicher, dass der SMTP-Server ausgehende Verbindungen zul\xe4sst und die Zugangsdaten korrekt sind."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : null,
                            form.mail.provider === "brevo_api" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-field form-field-wide",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "imports-sync-info-banner v2-info-banner settings-v2-mail-info settings-v2-mail-brevo-info",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "imports-sync-info-icon",
                                            "aria-hidden": "true",
                                            children: "i"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "imports-sync-info-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Hinweise zur Einrichtung"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Sie ben\xf6tigen ein aktives Brevo-Konto und einen g\xfcltigen API-Key. Die Absender-E-Mail muss in Brevo als best\xe4tigte Absenderadresse hinterlegt sein."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Die E-Mails werden \xfcber die Brevo API (v3) versendet."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            className: "settings-v2-inline-action",
                                            href: "https://developers.brevo.com/",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: [
                                                "Brevo-Dokumentation",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "settings-v2-inline-action-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                        viewBox: "0 0 20 20",
                                                        fill: "none",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M8 5H5.8A1.8 1.8 0 0 0 4 6.8v7.4A1.8 1.8 0 0 0 5.8 16h7.4a1.8 1.8 0 0 0 1.8-1.8V12M11 4h5v5M9.5 10.5 16 4",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.6",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : null
                        ]
                    })
                ]
            }) : null,
            tab === "allgemein" && !isPlatformSettingsHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form settings-section settings-v2-section settings-v2-general-card settings-v2-reminders-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-v2-card-head",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "settings-v2-card-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M12 5.2a4.4 4.4 0 0 0-4.4 4.4v2.6c0 1-.3 1.9-.9 2.7l-1 1.4h12.6l-1-1.4c-.6-.8-.9-1.7-.9-2.7V9.6A4.4 4.4 0 0 0 12 5.2Z",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M10.4 18.1a1.8 1.8 0 0 0 3.2 0",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-card-title",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: "Erinnerungen Umlaufbeschl\u00FCsse"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Legen Sie fest, wie viele Tage vor dem Enddatum automatisch Erinnerungen an Eigent\xfcmer ohne Stimmabgabe versendet werden sollen."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-grid settings-v2-reminder-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "1. Erinnerung (Tage vor Enddatum)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "1",
                                        max: "365",
                                        step: "1",
                                        value: form.reminders.firstReminderDays,
                                        onChange: (e)=>onReminderDaysChange("firstReminderDays", e.target.valueAsNumber)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "2. Erinnerung (Tage vor Enddatum)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: "1",
                                        max: "365",
                                        step: "1",
                                        value: form.reminders.secondReminderDays,
                                        onChange: (e)=>onReminderDaysChange("secondReminderDays", e.target.valueAsNumber)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-field form-field-wide",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "imports-sync-info-banner v2-info-banner settings-v2-reminder-info",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "imports-sync-info-icon",
                                            "aria-hidden": "true",
                                            children: "i"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "imports-sync-info-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Automatischer Versand nur an Eigent\u00FCmer ohne Stimmabgabe."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Empfehlung: 1. Erinnerung 7 Tage, 2. Erinnerung 3 Tage vor Enddatum."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            tab === "design" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "settings-v2-design-page",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form settings-section settings-v2-section settings-v2-design-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-card-head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "settings-v2-card-icon settings-v2-design-icon settings-v2-design-icon--blue",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "m15.7 4.7 3.6 3.6L9.6 18H6v-3.6l9.7-9.7Z",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "m13.9 6.5 3.6 3.6",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-card-title",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Designfarben Backend"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Definieren Sie die Farben f\xfcr das Backend-Interface."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid settings-v2-design-grid",
                                children: [
                                    renderDesignColorField("Inhaltsseite \u2013 Hintergrund", form.theme.bg, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                bg: value
                                            }
                                        }), "Hintergrundfarbe der Inhaltsseiten"),
                                    renderDesignColorField("Fl\xe4che", form.theme.surface, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                surface: value
                                            }
                                        }), "Hintergrundfarbe f\xfcr Fl\xe4chen und Karten"),
                                    renderDesignColorField("Header \u2013 Hintergrund", form.theme.headerBg, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                headerBg: value
                                            }
                                        }), "Hintergrundfarbe des Headers"),
                                    renderDesignColorField("Linien", form.theme.line, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                line: value
                                            }
                                        }), "Farbe f\xfcr Trennlinien und Umrandungen"),
                                    renderDesignColorField("Text", form.theme.text, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                text: value
                                            }
                                        }), "Prim\xe4re Textfarbe"),
                                    renderDesignColorField("Akzent", form.theme.primary, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                primary: value
                                            }
                                        }), "Akzentfarbe f\xfcr Links und aktive Elemente"),
                                    renderDesignColorField("Listen Spaltenkopf \u2013 Hintergrund", form.theme.listHeaderBg, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                listHeaderBg: value
                                            }
                                        }), "Hintergrundfarbe f\xfcr Tabellen-/Listen Spaltenk\xf6pfe"),
                                    renderDesignColorField("Listen alternierende Zeile", form.theme.listAlternateRowBg, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                listAlternateRowBg: value
                                            }
                                        }), "Hintergrundfarbe f\xfcr alternierende Tabellenzeilen")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form settings-section settings-v2-section settings-v2-design-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-card-head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "settings-v2-card-icon settings-v2-design-icon settings-v2-design-icon--cyan",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                    x: "6",
                                                    y: "5",
                                                    width: "4.8",
                                                    height: "14",
                                                    rx: "1.2",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                    x: "13.2",
                                                    y: "5",
                                                    width: "4.8",
                                                    height: "14",
                                                    rx: "1.2",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-card-title",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Seitenverlauf Backend"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Konfigurieren Sie den Farbverlauf f\xfcr den Seitenhintergrund."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid settings-v2-design-grid",
                                children: [
                                    renderDesignToggleField("Seitenverlauf aktiv", form.theme.gradientEnabled, (checked)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                gradientEnabled: checked
                                            }
                                        })),
                                    renderDesignColorField("Seitenverlauf von", form.theme.gradientFrom, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                gradientFrom: value
                                            }
                                        }), "Startfarbe des Verlaufs", !form.theme.gradientEnabled),
                                    renderDesignColorField("Seitenverlauf bis", form.theme.gradientTo, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                gradientTo: value
                                            }
                                        }), "Endfarbe des Verlaufs", !form.theme.gradientEnabled)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form settings-section settings-v2-section settings-v2-design-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-card-head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "settings-v2-card-icon settings-v2-design-icon settings-v2-design-icon--green",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M6 7h12M6 12h12M6 17h12",
                                                stroke: "currentColor",
                                                strokeWidth: "1.9",
                                                strokeLinecap: "round"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-card-title",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Men\xfc"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Passen Sie Farben und Zust\xe4nde des Men\xfcs an."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid settings-v2-design-grid",
                                children: [
                                    renderDesignColorField("Men\xfc \u2013 Hintergrund", form.theme.navBg, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                navBg: value
                                            }
                                        }), "Hintergrund des Men\xfcs"),
                                    renderDesignColorField("Men\xfc \u2013 Text", form.theme.navText, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                navText: value
                                            }
                                        }), "Textfarbe im Men\xfc"),
                                    renderDesignColorField("Men\xfc \u2013 Aktiv/Hover Hintergrund", form.theme.navActive, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                navActive: value
                                            }
                                        }), "Hintergrundfarbe bei Aktiv oder Hover"),
                                    renderDesignColorField("Men\xfc \u2013 Aktiv/Hover Text", form.theme.navActiveText, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                navActiveText: value
                                            }
                                        }), "Textfarbe bei Aktiv oder Hover"),
                                    renderDesignColorField("Men\xfc \u2013 Rand", form.theme.navBorder, (value)=>setForm({
                                            ...form,
                                            theme: {
                                                ...form.theme,
                                                navBorder: value
                                            }
                                        }), "Randfarbe des Men\xfcs")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form settings-section settings-v2-section settings-v2-design-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-card-head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "settings-v2-card-icon settings-v2-design-icon settings-v2-design-icon--purple",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M12 12.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Z",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M5.2 19.2a6.8 6.8 0 0 1 13.6 0",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-card-title",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Design Owner-Bereich (Login & Abstimmung)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Definieren Sie die Farben f\xfcr den Login- und Abstimmungsbereich."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid settings-v2-design-grid",
                                children: [
                                    renderDesignColorField("Hintergrund", form.ownerTheme.bg, (value)=>setForm({
                                            ...form,
                                            ownerTheme: {
                                                ...form.ownerTheme,
                                                bg: value
                                            }
                                        }), "Hintergrundfarbe des Bereichs"),
                                    renderDesignColorField("Fl\xe4che", form.ownerTheme.surface, (value)=>setForm({
                                            ...form,
                                            ownerTheme: {
                                                ...form.ownerTheme,
                                                surface: value
                                            }
                                        }), "Fl\xe4chenfarbe (z. B. Karten, Boxen)"),
                                    renderDesignColorField("Linien", form.ownerTheme.line, (value)=>setForm({
                                            ...form,
                                            ownerTheme: {
                                                ...form.ownerTheme,
                                                line: value
                                            }
                                        }), "Linienfarbe im Bereich"),
                                    renderDesignColorField("Text", form.ownerTheme.text, (value)=>setForm({
                                            ...form,
                                            ownerTheme: {
                                                ...form.ownerTheme,
                                                text: value
                                            }
                                        }), "Prim\xe4re Textfarbe im Bereich"),
                                    renderDesignColorField("Akzent", form.ownerTheme.primary, (value)=>setForm({
                                            ...form,
                                            ownerTheme: {
                                                ...form.ownerTheme,
                                                primary: value
                                            }
                                        }), "Akzentfarbe im Bereich")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "panel create-form settings-section settings-v2-section settings-v2-design-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-card-head",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "settings-v2-card-icon settings-v2-design-icon settings-v2-design-icon--cyan",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M5.2 17.2c3.4-4 6.8-6 10.2-6h3.4",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M5.2 6.8h13.6",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M5.2 12h5.4",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-v2-card-title",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Seitenverlauf Owner-Bereich"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Konfigurieren Sie den Farbverlauf f\xfcr Login- und Abstimmungsseiten."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid settings-v2-design-grid",
                                children: [
                                    renderDesignToggleField("Seitenverlauf aktiv", form.ownerTheme.gradientEnabled, (checked)=>setForm({
                                            ...form,
                                            ownerTheme: {
                                                ...form.ownerTheme,
                                                gradientEnabled: checked
                                            }
                                        })),
                                    renderDesignColorField("Seitenverlauf von", form.ownerTheme.gradientFrom, (value)=>setForm({
                                            ...form,
                                            ownerTheme: {
                                                ...form.ownerTheme,
                                                gradientFrom: value
                                            }
                                        }), "Startfarbe des Verlaufs", !form.ownerTheme.gradientEnabled),
                                    renderDesignColorField("Seitenverlauf bis", form.ownerTheme.gradientTo, (value)=>setForm({
                                            ...form,
                                            ownerTheme: {
                                                ...form.ownerTheme,
                                                gradientTo: value
                                            }
                                        }), "Endfarbe des Verlaufs", !form.ownerTheme.gradientEnabled)
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            tab === "uploads" && !isPlatformSettingsHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form settings-section settings-v2-section settings-v2-upload-page",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-v2-card-head settings-v2-upload-head",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "settings-v2-card-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M5.2 17.6h13.6V9.4H5.2v8.2Z",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "m7.2 15.8 3.1-3.1 2.1 2.1 2.7-2.7 2.7 3.7",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M8.2 8.1 12 4.4l3.8 3.7M12 4.8v8",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-v2-card-title",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: "Dateiuploads"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Verwalten Sie Logos und Briefpapiere f\xfcr Ihre Kommunikation."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-upload-shell",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "settings-upload-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `settings-upload-card${uploadDropTarget === "logo-backend" ? " is-drag-over" : ""}`,
                                        onDragOver: (e)=>onUploadDragOver(e, "logo-backend"),
                                        onDragLeave: onUploadDragLeave,
                                        onDrop: (e)=>onUploadDrop(e, "logo-backend"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadCardIcon, {
                                                        variant: "image"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Logo Backend"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Empfehlung: 320 x 72 px (Anzeige 160 x 36 px), SVG oder PNG mit transparentem Hintergrund."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Datei per Drag-and-Drop hier ablegen oder \xfcber den Button ausw\xe4hlen."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: logoInputRef,
                                                type: "file",
                                                accept: "image/*",
                                                style: {
                                                    display: "none"
                                                },
                                                onChange: (e)=>onLogoFile(e.target.files?.[0] ?? null)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-logo-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>logoInputRef.current?.click(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "upload"
                                                            }),
                                                            "Datei ausw\xe4hlen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: onLogoRemove,
                                                        disabled: !form.logoDataUrl,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "delete"
                                                            }),
                                                            "Logo l\xf6schen"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            form.logoDataUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: form.logoDataUrl,
                                                alt: "Logo Vorschau",
                                                className: "settings-logo-preview"
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `settings-upload-card${uploadDropTarget === "logo-owner" ? " is-drag-over" : ""}`,
                                        onDragOver: (e)=>onUploadDragOver(e, "logo-owner"),
                                        onDragLeave: onUploadDragLeave,
                                        onDrop: (e)=>onUploadDrop(e, "logo-owner"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadCardIcon, {
                                                        variant: "user"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Logo Owner-Bereich"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Empfehlung: 666 x 200 px (Desktop max. 333 x 100 px), SVG oder PNG mit transparentem Hintergrund."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Datei per Drag-and-Drop hier ablegen oder \xfcber den Button ausw\xe4hlen."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: ownerLogoInputRef,
                                                type: "file",
                                                accept: "image/*",
                                                style: {
                                                    display: "none"
                                                },
                                                onChange: (e)=>onOwnerLogoFile(e.target.files?.[0] ?? null)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-logo-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>ownerLogoInputRef.current?.click(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "upload"
                                                            }),
                                                            "Datei ausw\xe4hlen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: onOwnerLogoRemove,
                                                        disabled: !form.ownerLogoDataUrl,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "delete"
                                                            }),
                                                            "Logo l\xf6schen"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            form.ownerLogoDataUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: form.ownerLogoDataUrl,
                                                alt: "Owner-Logo Vorschau",
                                                className: "settings-logo-preview"
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `settings-upload-card${uploadDropTarget === "letterhead-digital" ? " is-drag-over" : ""}`,
                                        onDragOver: (e)=>onUploadDragOver(e, "letterhead-digital"),
                                        onDragLeave: onUploadDragLeave,
                                        onDrop: (e)=>onUploadDrop(e, "letterhead-digital"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadCardIcon, {
                                                        variant: "document"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Briefpapier digital"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "PDF/PNG/JPG f\xfcr digitale Schreiben."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Datei per Drag-and-Drop hier ablegen oder \xfcber den Button ausw\xe4hlen."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: letterheadDigitalInputRef,
                                                type: "file",
                                                accept: "application/pdf,image/png,image/jpeg,.pdf,.png,.jpg,.jpeg",
                                                style: {
                                                    display: "none"
                                                },
                                                onChange: (e)=>void onLetterheadUpload("digital", e.target.files?.[0] ?? null)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-logo-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>letterheadDigitalInputRef.current?.click(),
                                                        disabled: letterheadPending === "digital",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "upload"
                                                            }),
                                                            letterheadPending === "digital" ? "Upload..." : "Datei ausw\xe4hlen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>{
                                                            if (!letterheads.digital?.fileUrl) return;
                                                            window.open(letterheads.digital.fileUrl, "_blank", "noopener,noreferrer");
                                                        },
                                                        disabled: !letterheads.digital?.fileUrl,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "open"
                                                            }),
                                                            "\xd6ffnen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>void onLetterheadDelete("digital"),
                                                        disabled: !letterheads.digital?.fileUrl || letterheadDeletePending === "digital",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "delete"
                                                            }),
                                                            letterheadDeletePending === "digital" ? "L\xf6schen..." : "Datei l\xf6schen"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-grid-2col",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Oberer Rand (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 60,
                                                                step: 0.1,
                                                                value: getLetterheadMargins("digital").topMarginMm,
                                                                onChange: (e)=>onLetterheadMarginsChange("digital", "topMarginMm", e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Unterer Rand (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 60,
                                                                step: 0.1,
                                                                value: getLetterheadMargins("digital").bottomMarginMm,
                                                                onChange: (e)=>onLetterheadMarginsChange("digital", "bottomMarginMm", e.target.value)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "settings-logo-actions",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>void onLetterheadMarginsSave("digital"),
                                                    disabled: letterheadMarginsPending === "digital",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                            kind: "save"
                                                        }),
                                                        letterheadMarginsPending === "digital" ? "Speichern..." : "R\xe4nder speichern"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-grid-2col",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Adressat von oben (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 260,
                                                                step: 0.1,
                                                                value: getLetterheadFirstPageLayout("digital").firstPageRecipientTopMm,
                                                                onChange: (e)=>onLetterheadFirstPageLayoutChange("digital", "firstPageRecipientTopMm", e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Textstart von oben (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 260,
                                                                step: 0.1,
                                                                value: getLetterheadFirstPageLayout("digital").firstPageBodyStartMm,
                                                                onChange: (e)=>onLetterheadFirstPageLayoutChange("digital", "firstPageBodyStartMm", e.target.value)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "settings-logo-actions",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>void onLetterheadFirstPageLayoutSave("digital"),
                                                    disabled: letterheadFirstPageLayoutPending === "digital",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                            kind: "save"
                                                        }),
                                                        letterheadFirstPageLayoutPending === "digital" ? "Speichern..." : "Erstseite speichern"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                className: `settings-upload-hint settings-upload-state ${letterheads.digital?.fileName ? "is-ok" : "is-warn"}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadStatusIcon, {
                                                        kind: letterheads.digital?.fileName ? "ok" : "warn"
                                                    }),
                                                    letterheads.digital?.fileName ? `Briefpapier hinterlegt | Stand: ${formatDateTimeDE(letterheads.digital.updatedAt)}` : "Kein Briefpapier hinterlegt"
                                                ]
                                            }),
                                            letterheads.digital?.fileName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                className: "settings-upload-hint",
                                                children: [
                                                    "Datei: ",
                                                    letterheads.digital.fileName
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `settings-upload-card${uploadDropTarget === "letterhead-analog" ? " is-drag-over" : ""}`,
                                        onDragOver: (e)=>onUploadDragOver(e, "letterhead-analog"),
                                        onDragLeave: onUploadDragLeave,
                                        onDrop: (e)=>onUploadDrop(e, "letterhead-analog"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadCardIcon, {
                                                        variant: "document"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Briefpapier analog"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "PDF/PNG/JPG f\xfcr analoge Schreiben."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Datei per Drag-and-Drop hier ablegen oder \xfcber den Button ausw\xe4hlen."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: letterheadAnalogInputRef,
                                                type: "file",
                                                accept: "application/pdf,image/png,image/jpeg,.pdf,.png,.jpg,.jpeg",
                                                style: {
                                                    display: "none"
                                                },
                                                onChange: (e)=>void onLetterheadUpload("analog", e.target.files?.[0] ?? null)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-logo-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>letterheadAnalogInputRef.current?.click(),
                                                        disabled: letterheadPending === "analog",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "upload"
                                                            }),
                                                            letterheadPending === "analog" ? "Upload..." : "Datei ausw\xe4hlen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>{
                                                            if (!letterheads.analog?.fileUrl) return;
                                                            window.open(letterheads.analog.fileUrl, "_blank", "noopener,noreferrer");
                                                        },
                                                        disabled: !letterheads.analog?.fileUrl,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "open"
                                                            }),
                                                            "\xd6ffnen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>void onLetterheadDelete("analog"),
                                                        disabled: !letterheads.analog?.fileUrl || letterheadDeletePending === "analog",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "delete"
                                                            }),
                                                            letterheadDeletePending === "analog" ? "L\xf6schen..." : "Datei l\xf6schen"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-grid-2col",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Oberer Rand (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 60,
                                                                step: 0.1,
                                                                value: getLetterheadMargins("analog").topMarginMm,
                                                                onChange: (e)=>onLetterheadMarginsChange("analog", "topMarginMm", e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Unterer Rand (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 60,
                                                                step: 0.1,
                                                                value: getLetterheadMargins("analog").bottomMarginMm,
                                                                onChange: (e)=>onLetterheadMarginsChange("analog", "bottomMarginMm", e.target.value)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "settings-logo-actions",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>void onLetterheadMarginsSave("analog"),
                                                    disabled: letterheadMarginsPending === "analog",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                            kind: "save"
                                                        }),
                                                        letterheadMarginsPending === "analog" ? "Speichern..." : "R\xe4nder speichern"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-grid-2col",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Adressat von oben (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 260,
                                                                step: 0.1,
                                                                value: getLetterheadFirstPageLayout("analog").firstPageRecipientTopMm,
                                                                onChange: (e)=>onLetterheadFirstPageLayoutChange("analog", "firstPageRecipientTopMm", e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Textstart von oben (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 260,
                                                                step: 0.1,
                                                                value: getLetterheadFirstPageLayout("analog").firstPageBodyStartMm,
                                                                onChange: (e)=>onLetterheadFirstPageLayoutChange("analog", "firstPageBodyStartMm", e.target.value)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "settings-logo-actions",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>void onLetterheadFirstPageLayoutSave("analog"),
                                                    disabled: letterheadFirstPageLayoutPending === "analog",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                            kind: "save"
                                                        }),
                                                        letterheadFirstPageLayoutPending === "analog" ? "Speichern..." : "Erstseite speichern"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                className: `settings-upload-hint settings-upload-state ${letterheads.analog?.fileName ? "is-ok" : "is-warn"}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadStatusIcon, {
                                                        kind: letterheads.analog?.fileName ? "ok" : "warn"
                                                    }),
                                                    letterheads.analog?.fileName ? `Briefpapier hinterlegt | Stand: ${formatDateTimeDE(letterheads.analog.updatedAt)}` : "Kein Briefpapier hinterlegt"
                                                ]
                                            }),
                                            letterheads.analog?.fileName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                className: "settings-upload-hint",
                                                children: [
                                                    "Datei: ",
                                                    letterheads.analog.fileName
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `settings-upload-card${uploadDropTarget === "letterhead-digital-followup" ? " is-drag-over" : ""}`,
                                        onDragOver: (e)=>onUploadDragOver(e, "letterhead-digital-followup"),
                                        onDragLeave: onUploadDragLeave,
                                        onDrop: (e)=>onUploadDrop(e, "letterhead-digital-followup"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadCardIcon, {
                                                        variant: "document"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Briefpapier digital (ab Seite 2)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "PDF/PNG/JPG f\xfcr Folgeseiten digitaler Schreiben."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Datei per Drag-and-Drop hier ablegen oder \xfcber den Button ausw\xe4hlen."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: letterheadDigitalFollowupInputRef,
                                                type: "file",
                                                accept: "application/pdf,image/png,image/jpeg,.pdf,.png,.jpg,.jpeg",
                                                style: {
                                                    display: "none"
                                                },
                                                onChange: (e)=>void onLetterheadUpload("digital_followup", e.target.files?.[0] ?? null)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-logo-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>letterheadDigitalFollowupInputRef.current?.click(),
                                                        disabled: letterheadPending === "digital_followup",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "upload"
                                                            }),
                                                            letterheadPending === "digital_followup" ? "Upload..." : "Datei ausw\xe4hlen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>{
                                                            if (!letterheads.digital_followup?.fileUrl) return;
                                                            window.open(letterheads.digital_followup.fileUrl, "_blank", "noopener,noreferrer");
                                                        },
                                                        disabled: !letterheads.digital_followup?.fileUrl,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "open"
                                                            }),
                                                            "\xd6ffnen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>void onLetterheadDelete("digital_followup"),
                                                        disabled: !letterheads.digital_followup?.fileUrl || letterheadDeletePending === "digital_followup",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "delete"
                                                            }),
                                                            letterheadDeletePending === "digital_followup" ? "L\xf6schen..." : "Datei l\xf6schen"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-grid-2col",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Oberer Rand (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 60,
                                                                step: 0.1,
                                                                value: getLetterheadMargins("digital_followup").topMarginMm,
                                                                onChange: (e)=>onLetterheadMarginsChange("digital_followup", "topMarginMm", e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Unterer Rand (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 60,
                                                                step: 0.1,
                                                                value: getLetterheadMargins("digital_followup").bottomMarginMm,
                                                                onChange: (e)=>onLetterheadMarginsChange("digital_followup", "bottomMarginMm", e.target.value)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "settings-logo-actions",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>void onLetterheadMarginsSave("digital_followup"),
                                                    disabled: letterheadMarginsPending === "digital_followup",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                            kind: "save"
                                                        }),
                                                        letterheadMarginsPending === "digital_followup" ? "Speichern..." : "R\xe4nder speichern"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                className: `settings-upload-hint settings-upload-state ${letterheads.digital_followup?.fileName ? "is-ok" : "is-warn"}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadStatusIcon, {
                                                        kind: letterheads.digital_followup?.fileName ? "ok" : "warn"
                                                    }),
                                                    letterheads.digital_followup?.fileName ? `Briefpapier hinterlegt | Stand: ${formatDateTimeDE(letterheads.digital_followup.updatedAt)}` : "Kein Briefpapier hinterlegt"
                                                ]
                                            }),
                                            letterheads.digital_followup?.fileName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                className: "settings-upload-hint",
                                                children: [
                                                    "Datei: ",
                                                    letterheads.digital_followup.fileName
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `settings-upload-card${uploadDropTarget === "letterhead-analog-followup" ? " is-drag-over" : ""}`,
                                        onDragOver: (e)=>onUploadDragOver(e, "letterhead-analog-followup"),
                                        onDragLeave: onUploadDragLeave,
                                        onDrop: (e)=>onUploadDrop(e, "letterhead-analog-followup"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadCardIcon, {
                                                        variant: "document"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Briefpapier analog (ab Seite 2)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "PDF/PNG/JPG f\xfcr Folgeseiten analoger Schreiben."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "settings-upload-hint",
                                                children: "Datei per Drag-and-Drop hier ablegen oder \xfcber den Button ausw\xe4hlen."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: letterheadAnalogFollowupInputRef,
                                                type: "file",
                                                accept: "application/pdf,image/png,image/jpeg,.pdf,.png,.jpg,.jpeg",
                                                style: {
                                                    display: "none"
                                                },
                                                onChange: (e)=>void onLetterheadUpload("analog_followup", e.target.files?.[0] ?? null)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-logo-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>letterheadAnalogFollowupInputRef.current?.click(),
                                                        disabled: letterheadPending === "analog_followup",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "upload"
                                                            }),
                                                            letterheadPending === "analog_followup" ? "Upload..." : "Datei ausw\xe4hlen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>{
                                                            if (!letterheads.analog_followup?.fileUrl) return;
                                                            window.open(letterheads.analog_followup.fileUrl, "_blank", "noopener,noreferrer");
                                                        },
                                                        disabled: !letterheads.analog_followup?.fileUrl,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "open"
                                                            }),
                                                            "\xd6ffnen"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>void onLetterheadDelete("analog_followup"),
                                                        disabled: !letterheads.analog_followup?.fileUrl || letterheadDeletePending === "analog_followup",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                                kind: "delete"
                                                            }),
                                                            letterheadDeletePending === "analog_followup" ? "L\xf6schen..." : "Datei l\xf6schen"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-grid-2col",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Oberer Rand (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 60,
                                                                step: 0.1,
                                                                value: getLetterheadMargins("analog_followup").topMarginMm,
                                                                onChange: (e)=>onLetterheadMarginsChange("analog_followup", "topMarginMm", e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Unterer Rand (mm)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 60,
                                                                step: 0.1,
                                                                value: getLetterheadMargins("analog_followup").bottomMarginMm,
                                                                onChange: (e)=>onLetterheadMarginsChange("analog_followup", "bottomMarginMm", e.target.value)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "settings-logo-actions",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>void onLetterheadMarginsSave("analog_followup"),
                                                    disabled: letterheadMarginsPending === "analog_followup",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                            kind: "save"
                                                        }),
                                                        letterheadMarginsPending === "analog_followup" ? "Speichern..." : "R\xe4nder speichern"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                className: `settings-upload-hint settings-upload-state ${letterheads.analog_followup?.fileName ? "is-ok" : "is-warn"}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadStatusIcon, {
                                                        kind: letterheads.analog_followup?.fileName ? "ok" : "warn"
                                                    }),
                                                    letterheads.analog_followup?.fileName ? `Briefpapier hinterlegt | Stand: ${formatDateTimeDE(letterheads.analog_followup.updatedAt)}` : "Kein Briefpapier hinterlegt"
                                                ]
                                            }),
                                            letterheads.analog_followup?.fileName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                className: "settings-upload-hint",
                                                children: [
                                                    "Datei: ",
                                                    letterheads.analog_followup.fileName
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "imports-sync-info-banner v2-info-banner settings-v2-upload-info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "imports-sync-info-icon",
                                        "aria-hidden": "true",
                                        children: "i"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "imports-sync-info-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Hinweis"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Die hinterlegten Briefpapiere werden f\xfcr die Erstellung von Dokumenten und Schreiben verwendet. Achten Sie auf korrekte R\xe4nder und Abst\xe4nde."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            tab === "datenbestand" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form settings-section settings-section-danger settings-v2-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Datenbest\xe4nde"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "settings-danger-grid",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "settings-danger-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    children: "Datenbestand l\xf6schen"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Datentyp"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: dataClearType,
                                                    onChange: (e)=>setDataClearType(e.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "objects",
                                                            children: "Objekte (inkl. Einheiten, Eigent\xfcmer, Zuordnungen, Beschl\xfcsse)"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "units",
                                                            children: "Einheiten (inkl. Zuordnungen)"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "owners",
                                                            children: "Eigent\xfcmer (inkl. Zuordnungen)"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "assignments",
                                                            children: "Zuordnungen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "resolutions",
                                                            children: "Beschl\xfcsse"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "all",
                                                            children: "Alles (kompletter Bestand)"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "\xa0"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: "settings-danger-action-btn",
                                                    onClick: ()=>{
                                                        const code = String(Math.floor(1000 + Math.random() * 9000));
                                                        setDataClearConfirm({
                                                            code: code,
                                                            input: [
                                                                "",
                                                                "",
                                                                "",
                                                                ""
                                                            ],
                                                            error: ""
                                                        });
                                                    },
                                                    disabled: dataClearPending,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$UploadActionIcon, {
                                                            kind: "delete"
                                                        }),
                                                        dataClearPending ? "L\xf6schen l\xe4uft..." : "Datenbestand l\xf6schen"
                                                    ]
                                                })
                                            ]
                                        }),
                                        dataClearStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "form-field form-field-wide",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                style: {
                                                    color: dataClearStatus.type === "ok" ? "#0f7b31" : "#b42318",
                                                    fontWeight: 600
                                                },
                                                children: dataClearStatus.text
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                open: !!dataClearConfirm,
                title: "Datenbestand l\xf6schen best\xe4tigen",
                message: dataClearConfirm ? `Der Datenbestand "${dataClearTypeLabel[dataClearType]}" wird gel\xf6scht. Dieser Schritt ist endg\xfcltig.` : "",
                code: dataClearConfirm?.code ?? "",
                input: dataClearConfirm?.input ?? [
                    "",
                    "",
                    "",
                    ""
                ],
                error: dataClearConfirm?.error,
                isPending: dataClearPending,
                onClose: ()=>setDataClearConfirm(null),
                onInputChange: (next)=>{
                    if (!dataClearConfirm) return;
                    setDataClearConfirm({
                        ...dataClearConfirm,
                        input: next
                    });
                },
                onErrorReset: ()=>{
                    if (!dataClearConfirm || !dataClearConfirm.error) return;
                    setDataClearConfirm({
                        ...dataClearConfirm,
                        error: ""
                    });
                },
                confirmLabel: "Datenbestand l\xf6schen",
                pendingLabel: "L\xf6schen l\xe4uft...",
                onConfirm: ()=>{
                    if (!dataClearConfirm) return;
                    const enteredCode = dataClearConfirm.input.join("");
                    if (enteredCode !== dataClearConfirm.code) {
                        setDataClearConfirm({
                            ...dataClearConfirm,
                            error: "Sicherheitscode falsch eingegeben."
                        });
                        return;
                    }
                    setDataClearConfirm(null);
                    runClearDataByType();
                }
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");






const $99bbb276306e7658$var$SearchField = ({ placeholder: placeholder, value: value, onChange: onChange })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "templates-v2-search-field admin-users-search-field",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "templates-v2-search-icon",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                            cx: "11.2",
                            cy: "11.2",
                            r: "5.7",
                            stroke: "currentColor",
                            strokeWidth: "1.8"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "m15.4 15.4 3.2 3.2",
                            stroke: "currentColor",
                            strokeWidth: "1.8",
                            strokeLinecap: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                placeholder: placeholder,
                value: value,
                onChange: (e)=>onChange(e.target.value)
            })
        ]
    });
const $99bbb276306e7658$export$ed6b2746b35e124 = ({ authUser: authUser })=>{
    const canCreateUsers = authUser.permissions.admin_users_create !== false;
    const canUpdateUsers = authUser.permissions.admin_users_update !== false;
    const canDeleteUsers = authUser.permissions.admin_users_delete !== false;
    const canEditRoleMatrix = canUpdateUsers;
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [showCreate, setShowCreate] = (0, $acw62.useState)(false);
    const [createError, setCreateError] = (0, $acw62.useState)("");
    const [editError, setEditError] = (0, $acw62.useState)("");
    const [editRow, setEditRow] = (0, $acw62.useState)(null);
    const [createAvatarFile, setCreateAvatarFile] = (0, $acw62.useState)(null);
    const [editAvatarFile, setEditAvatarFile] = (0, $acw62.useState)(null);
    const [editAvatarRemoved, setEditAvatarRemoved] = (0, $acw62.useState)(false);
    const [createAvatarDragOver, setCreateAvatarDragOver] = (0, $acw62.useState)(false);
    const [editAvatarDragOver, setEditAvatarDragOver] = (0, $acw62.useState)(false);
    const [openActionMenuId, setOpenActionMenuId] = (0, $acw62.useState)(null);
    const [actionMenuPosition, setActionMenuPosition] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const createAvatarInputRef = (0, $acw62.useRef)(null);
    const editAvatarInputRef = (0, $acw62.useRef)(null);
    const [createForm, setCreateForm] = (0, $acw62.useState)({
        username: "",
        email: "",
        firstName: "",
        lastName: "",
        phone: "",
        displayName: "",
        groupId: "",
        isPlatformAdmin: false,
        password: ""
    });
    const [editForm, setEditForm] = (0, $acw62.useState)({
        email: "",
        firstName: "",
        lastName: "",
        phone: "",
        displayName: "",
        groupId: "",
        isPlatformAdmin: false,
        status: "aktiv",
        password: ""
    });
    const { data: data, isLoading: isLoading, isError: isError, error: error } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "admin-users"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).adminUsers()
    });
    const { data: permissionGroupsData, isLoading: groupsLoading } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "permission-groups"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).permissionGroups()
    });
    const { data: objectScopeData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "object-scope"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).objectScope()
    });
    const { data: objectsData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "objects-for-scope"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).objects({
                page: 1,
                pageSize: 5000,
                sortBy: "objektnummer",
                sortDir: "asc"
            })
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = (event)=>{
            if (event && (0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            setOpenActionMenuId(null);
        };
        const handleEscape = (event)=>{
            if (event.key === "Escape") closeMenu();
        };
        window.addEventListener("mousedown", closeMenu);
        window.addEventListener("keydown", handleEscape);
        return ()=>{
            window.removeEventListener("mousedown", closeMenu);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = ()=>setOpenActionMenuId(null);
        window.addEventListener("resize", closeMenu);
        window.addEventListener("scroll", closeMenu, true);
        return ()=>{
            window.removeEventListener("resize", closeMenu);
            window.removeEventListener("scroll", closeMenu, true);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!openActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>setOpenActionMenuId(null),
        timeoutMs: 3000
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) {
            setActionMenuPosition(null);
            setIsActionMenuHovered(false);
        }
    }, [
        openActionMenuId
    ]);
    const [groupsDraft, setGroupsDraft] = (0, $acw62.useState)(null);
    const [objectScopeDraft, setObjectScopeDraft] = (0, $acw62.useState)(null);
    const [selectedUserId, setSelectedUserId] = (0, $acw62.useState)("");
    const [selectedGroupId, setSelectedGroupId] = (0, $acw62.useState)("");
    const [newGroupName, setNewGroupName] = (0, $acw62.useState)("");
    const [newGroupDescription, setNewGroupDescription] = (0, $acw62.useState)("");
    const [newGroupActive, setNewGroupActive] = (0, $acw62.useState)(true);
    const [showGroupCreate, setShowGroupCreate] = (0, $acw62.useState)(false);
    const [groupsMessage, setGroupsMessage] = (0, $acw62.useState)("");
    const [groupsError, setGroupsError] = (0, $acw62.useState)("");
    const [scopeMessage, setScopeMessage] = (0, $acw62.useState)("");
    const [scopeError, setScopeError] = (0, $acw62.useState)("");
    const [userSearch, setUserSearch] = (0, $acw62.useState)("");
    const [userGroupFilter, setUserGroupFilter] = (0, $acw62.useState)("");
    const [userStatusFilter, setUserStatusFilter] = (0, $acw62.useState)("");
    const [groupSearch, setGroupSearch] = (0, $acw62.useState)("");
    const [groupStatusFilter, setGroupStatusFilter] = (0, $acw62.useState)("");
    const [groupEditId, setGroupEditId] = (0, $acw62.useState)("");
    const [groupEditName, setGroupEditName] = (0, $acw62.useState)("");
    const [groupEditDescription, setGroupEditDescription] = (0, $acw62.useState)("");
    const [groupEditActive, setGroupEditActive] = (0, $acw62.useState)(true);
    const [groupEditError, setGroupEditError] = (0, $acw62.useState)("");
    const [assignmentSearch, setAssignmentSearch] = (0, $acw62.useState)("");
    const [assignmentPage, setAssignmentPage] = (0, $acw62.useState)(1);
    const [scopeObjectSearch, setScopeObjectSearch] = (0, $acw62.useState)("");
    const [scopeObjectPage, setScopeObjectPage] = (0, $acw62.useState)(1);
    const [userDeleteConfirm, setUserDeleteConfirm] = (0, $acw62.useState)(null);
    const [groupDeleteConfirm, setGroupDeleteConfirm] = (0, $acw62.useState)(null);
    const createSecurityCode = ()=>String(Math.floor(1000 + Math.random() * 9000));
    const openActionMenuAtTrigger = (menuId, trigger)=>{
        const rect = trigger.getBoundingClientRect();
        const menuWidth = 170;
        const menuHeight = 96;
        const margin = 8;
        const left = Math.min(Math.max(margin, rect.right - menuWidth), Math.max(margin, window.innerWidth - menuWidth - margin));
        const belowTop = rect.bottom + 6;
        const aboveTop = rect.top - menuHeight - 6;
        const top = belowTop + menuHeight <= window.innerHeight - margin ? belowTop : Math.max(margin, aboveTop);
        setActionMenuPosition({
            left: left,
            top: top
        });
        setOpenActionMenuId(menuId);
    };
    const normalizeAvatarFile = (file)=>file && String(file.type ?? "").toLowerCase().startsWith("image/") ? file : null;
    const getUserInitials = (r)=>{
        const first = String(r.firstName ?? "").trim();
        const last = String(r.lastName ?? "").trim();
        const fromNames = `${first.slice(0, 1)}${last.slice(0, 1)}`.toUpperCase();
        if (fromNames) return fromNames;
        const fallback = String(r.displayName || r.username || "").trim();
        const parts = fallback.split(/\s+/).filter(Boolean);
        if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
        return fallback.slice(0, 2).toUpperCase() || "--";
    };
    const permissionKeys = permissionGroupsData?.keys ?? [];
    const isPlatformRightsContext = permissionKeys.includes("platform_tenants");
    const supportsObjectScope = permissionKeys.includes("objects");
    const effectiveGroupState = groupsDraft ?? permissionGroupsData?.state ?? {
        groups: [],
        userAssignments: {}
    };
    const effectiveObjectScope = objectScopeDraft ?? objectScopeData?.state ?? {
        userAssignments: {}
    };
    const isFrameworkV2 = typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    const groupsMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (state)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).updatePermissionGroups(state),
        onSuccess: async (next)=>{
            setGroupsError("");
            setGroupsMessage("Benutzergruppe gespeichert.");
            setGroupsDraft(next.state);
            await queryClient.invalidateQueries({
                queryKey: [
                    "permission-groups"
                ]
            });
        },
        onError: (err)=>{
            setGroupsMessage("");
            setGroupsError(err instanceof Error ? err.message : "Usergruppen konnten nicht gespeichert werden");
        }
    });
    const objectScopeMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (state)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateObjectScope(state),
        onSuccess: async (next)=>{
            setScopeError("");
            setScopeMessage("Objektzuordnung gespeichert.");
            setObjectScopeDraft(next.state);
            await queryClient.invalidateQueries({
                queryKey: [
                    "object-scope"
                ]
            });
        },
        onError: (err)=>{
            setScopeMessage("");
            setScopeError(err instanceof Error ? err.message : "Objektzuordnung konnte nicht gespeichert werden");
        }
    });
    const createMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).createAdminUser({
                username: createForm.username.trim(),
                email: createForm.email.trim().toLowerCase(),
                firstName: createForm.firstName.trim(),
                lastName: createForm.lastName.trim(),
                phone: createForm.phone.trim() || undefined,
                displayName: createForm.displayName.trim() || `${createForm.firstName.trim()} ${createForm.lastName.trim()}`.trim(),
                groupId: createForm.isPlatformAdmin ? undefined : createForm.groupId,
                isPlatformAdmin: createForm.isPlatformAdmin,
                password: createForm.password
            }),
        onSuccess: async (createdUser)=>{
            if (createAvatarFile) await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).uploadAdminUserAvatar(createdUser.id, createAvatarFile);
            setCreateError("");
            setShowCreate(false);
            setCreateAvatarFile(null);
            setCreateForm({
                username: "",
                email: "",
                firstName: "",
                lastName: "",
                phone: "",
                displayName: "",
                groupId: "",
                isPlatformAdmin: false,
                password: ""
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "admin-users"
                ]
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "permission-groups"
                ]
            });
        },
        onError: (err)=>setCreateError(err instanceof Error ? err.message : "Anlage fehlgeschlagen")
    });
    const updateMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>{
            if (!editRow) throw new Error("Kein Benutzer ausgew\xe4hlt");
            const payload = {
                email: editForm.email.trim().toLowerCase(),
                firstName: editForm.firstName.trim(),
                lastName: editForm.lastName.trim(),
                phone: editForm.phone.trim() || undefined,
                displayName: editForm.displayName.trim() || `${editForm.firstName.trim()} ${editForm.lastName.trim()}`.trim(),
                status: editForm.status,
                password: editForm.password.trim() || undefined
            };
            if (editRow.role !== "superadmin") {
                payload.groupId = editForm.groupId || null;
                payload.isPlatformAdmin = editForm.isPlatformAdmin;
            }
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateAdminUser(editRow.id, {
                ...payload
            });
        },
        onSuccess: async ()=>{
            if (!editRow) return;
            if (editAvatarFile) await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).uploadAdminUserAvatar(editRow.id, editAvatarFile);
            else if (editAvatarRemoved) await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).deleteAdminUserAvatar(editRow.id);
            setEditError("");
            setEditRow(null);
            setEditAvatarFile(null);
            setEditAvatarRemoved(false);
            setEditForm({
                email: "",
                firstName: "",
                lastName: "",
                phone: "",
                displayName: "",
                groupId: "",
                isPlatformAdmin: false,
                status: "aktiv",
                password: ""
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "admin-users"
                ]
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "permission-groups"
                ]
            });
        },
        onError: (err)=>setEditError(err instanceof Error ? err.message : "Speichern fehlgeschlagen")
    });
    const deleteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (userId)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).deleteAdminUser(userId),
        onSuccess: async (_, userId)=>{
            setEditError("");
            setUserDeleteConfirm(null);
            if (editRow?.id === userId) setEditRow(null);
            await queryClient.invalidateQueries({
                queryKey: [
                    "admin-users"
                ]
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "permission-groups"
                ]
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    "object-scope"
                ]
            });
        },
        onError: (err)=>setEditError(err instanceof Error ? err.message : "L\xf6schen fehlgeschlagen")
    });
    const columns = (0, $acw62.useMemo)(()=>[
            {
                key: "username",
                align: "center",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Benutzername"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                })
            },
            {
                key: "avatar",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                }),
                align: "center",
                width: 90,
                render: (r)=>r.avatarUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: r.avatarUrl,
                        alt: r.displayName,
                        style: {
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "1px solid var(--line)"
                        }
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        title: r.displayName,
                        style: {
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            border: "1px solid var(--line)",
                            background: "color-mix(in srgb, var(--surface-muted) 75%, #fff 25%)",
                            color: "var(--text-soft)",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 12,
                            fontWeight: 700
                        },
                        children: getUserInitials(r)
                    })
            },
            {
                key: "displayName",
                align: "center",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Anzeigename"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                })
            },
            {
                key: "group",
                align: "center",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Benutzergruppe"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                }),
                render: (r)=>{
                    if (r.role === "superadmin") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge",
                        children: "Superadmin (Sicherheitsrolle)"
                    });
                    if (r.role === "platform_admin") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge",
                        children: "Platform Admin (Sicherheitsrolle)"
                    });
                    const assignment = effectiveGroupState.userAssignments[r.id];
                    const groupId = assignment?.groupIds?.[0];
                    const groupName = effectiveGroupState.groups.find((entry)=>entry.id === groupId)?.name;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge",
                        children: groupName || "Keine Gruppe"
                    });
                }
            },
            {
                key: "status",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Status"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                }),
                align: "center",
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge ${r.status === "aktiv" ? "aktiv" : "inaktiv"}`,
                        children: r.status
                    })
            },
            {
                key: "lastLoginAt",
                align: "center",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Letzter Login"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                }),
                render: (r)=>r.lastLoginAt ? new Date(r.lastLoginAt).toLocaleString("de-DE") : "-"
            },
            {
                key: "actions",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Aktionen"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                }),
                align: "center",
                width: 54,
                render: (r)=>{
                    const menuId = `user:${r.id}`;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-action-wrap admin-users-action-wrap",
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "resolutions-v2-action-trigger",
                                "aria-label": `Aktionen fuer ${r.displayName || r.username}`,
                                "aria-expanded": openActionMenuId === menuId,
                                onMouseDown: (e)=>e.stopPropagation(),
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    if (openActionMenuId === menuId) {
                                        setOpenActionMenuId(null);
                                        return;
                                    }
                                    openActionMenuAtTrigger(menuId, e.currentTarget);
                                },
                                children: "\u22EE"
                            }),
                            openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                style: {
                                    left: actionMenuPosition.left,
                                    top: actionMenuPosition.top
                                },
                                onMouseDown: (e)=>e.stopPropagation(),
                                onMouseEnter: ()=>setIsActionMenuHovered(true),
                                onMouseLeave: ()=>setIsActionMenuHovered(false),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: !canUpdateUsers,
                                        onClick: ()=>{
                                            setEditError("");
                                            setShowCreate(false);
                                            setEditRow(r);
                                            setEditAvatarFile(null);
                                            setEditAvatarRemoved(false);
                                            setEditForm({
                                                email: r.email ?? "",
                                                firstName: r.firstName ?? "",
                                                lastName: r.lastName ?? "",
                                                phone: r.phone ?? "",
                                                displayName: r.displayName,
                                                groupId: effectiveGroupState.userAssignments[r.id]?.groupIds?.[0] ?? "",
                                                isPlatformAdmin: r.role === "platform_admin",
                                                status: r.status,
                                                password: ""
                                            });
                                            setOpenActionMenuId(null);
                                        },
                                        children: "Bearbeiten"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: !canDeleteUsers || deleteMutation.isPending || r.id === authUser.id,
                                        onClick: ()=>{
                                            setEditError("");
                                            const label = r.displayName?.trim() || r.username;
                                            setUserDeleteConfirm({
                                                id: r.id,
                                                label: label,
                                                code: createSecurityCode(),
                                                input: [
                                                    "",
                                                    "",
                                                    "",
                                                    ""
                                                ],
                                                error: ""
                                            });
                                            setOpenActionMenuId(null);
                                        },
                                        children: "L\u00f6schen"
                                    })
                                ]
                            }), document.body) : null
                        ]
                    });
                }
            }
        ], [
        actionMenuPosition,
        authUser.id,
        canDeleteUsers,
        canUpdateUsers,
        deleteMutation.isPending,
        effectiveGroupState,
        openActionMenuId
    ]);
    const groupColumns = (0, $acw62.useMemo)(()=>[
            {
                key: "name",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Gruppenname"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                })
            },
            {
                key: "description",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Beschreibung"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                }),
                render: (r)=>r.description?.trim() || "-"
            },
            {
                key: "status",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Status"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                }),
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge ${r.active ? "aktiv" : "inaktiv"}`,
                        children: r.active ? "aktiv" : "inaktiv"
                    })
            },
            {
                key: "actions",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "table-head-two-line",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Aktionen"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "\xa0"
                        })
                    ]
                }),
                align: "center",
                width: 54,
                render: (r)=>{
                    const menuId = `group:${r.id}`;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-action-wrap admin-users-action-wrap",
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "resolutions-v2-action-trigger",
                                "aria-label": `Aktionen fuer ${r.name}`,
                                "aria-expanded": openActionMenuId === menuId,
                                onMouseDown: (e)=>e.stopPropagation(),
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    if (openActionMenuId === menuId) {
                                        setOpenActionMenuId(null);
                                        return;
                                    }
                                    openActionMenuAtTrigger(menuId, e.currentTarget);
                                },
                                children: "\u22EE"
                            }),
                            openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                style: {
                                    left: actionMenuPosition.left,
                                    top: actionMenuPosition.top
                                },
                                onMouseDown: (e)=>e.stopPropagation(),
                                onMouseEnter: ()=>setIsActionMenuHovered(true),
                                onMouseLeave: ()=>setIsActionMenuHovered(false),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                        onClick: ()=>{
                                            setSelectedGroupId(r.id);
                                            setGroupEditId(r.id);
                                            setGroupEditName(r.name);
                                            setGroupEditDescription(r.description ?? "");
                                            setGroupEditActive(r.active);
                                            setGroupEditError("");
                                            setOpenActionMenuId(null);
                                        },
                                        children: "Bearbeiten"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                        onClick: ()=>{
                                            setGroupDeleteConfirm({
                                                id: r.id,
                                                label: r.name,
                                                code: createSecurityCode(),
                                                input: [
                                                    "",
                                                    "",
                                                    "",
                                                    ""
                                                ],
                                                error: ""
                                            });
                                            setOpenActionMenuId(null);
                                        },
                                        children: "L\u00f6schen"
                                    })
                                ]
                            }), document.body) : null
                        ]
                    });
                }
            }
        ], [
        actionMenuPosition,
        canEditRoleMatrix,
        groupsMutation.isPending,
        openActionMenuId
    ]);
    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
    const createEmail = createForm.email.trim().toLowerCase();
    const editEmail = editForm.email.trim().toLowerCase();
    const canCreate = createForm.username.trim() && EMAIL_REGEX.test(createEmail) && createForm.firstName.trim() && createForm.lastName.trim() && (isPlatformRightsContext && createForm.isPlatformAdmin || createForm.groupId) && createForm.password.trim().length >= 8;
    const canEdit = !!editRow && EMAIL_REGEX.test(editEmail) && !!editForm.firstName.trim() && !!editForm.lastName.trim();
    const permissionLabels = {
        dashboard: "Dashboard",
        qr_scan: "QR Erfassung",
        resolutions: "Umlaufbeschl\xfcsse",
        resolutions_create: "Umlaufbeschl\xfcsse anlegen",
        resolutions_update: "Umlaufbeschl\xfcsse bearbeiten",
        resolutions_delete: "Umlaufbeschl\xfcsse l\xf6schen",
        resolutions_delete_completed: "Abgeschlossene Beschl\u00FCsse l\u00F6schen",
        objects: "Objekte",
        objects_create: "Objekte anlegen",
        objects_update: "Objekte bearbeiten",
        objects_delete: "Objekte l\xf6schen",
        units: "Einheiten",
        units_create: "Einheiten anlegen",
        units_update: "Einheiten bearbeiten",
        units_delete: "Einheiten l\xf6schen",
        units_view_technical: "Technische Einheiten (000) anzeigen",
        owners: "Eigent\xfcmer",
        owners_create: "Eigent\xfcmer anlegen",
        owners_update: "Eigent\xfcmer bearbeiten",
        owners_delete: "Eigent\xfcmer l\xf6schen",
        assignments: "Zuordnungen",
        assignments_create: "Zuordnungen anlegen",
        assignments_update: "Zuordnungen bearbeiten",
        assignments_delete: "Zuordnungen l\xf6schen",
        imports: "Importe",
        imports_create: "Importe starten",
        imports_update: "Importe bearbeiten",
        imports_delete: "Importe l\xf6schen",
        templates: "Vorlagen",
        templates_create: "Vorlagen anlegen",
        templates_update: "Vorlagen bearbeiten",
        templates_delete: "Vorlagen l\xf6schen",
        settings: "Einstellungen",
        settings_create: "Einstellungen anlegen",
        settings_update: "Einstellungen bearbeiten",
        settings_delete: "Einstellungen l\xf6schen",
        admin_users: "Benutzer & Rechte",
        admin_users_create: "Benutzer & Rechte anlegen",
        admin_users_update: "Benutzer & Rechte bearbeiten",
        admin_users_delete: "Benutzer & Rechte l\xf6schen",
        platform_tenants: "SaaS-Mandanten",
        platform_tenants_create: "SaaS-Mandanten anlegen",
        platform_tenants_update: "SaaS-Mandanten bearbeiten",
        platform_tenants_delete: "SaaS-Mandanten l\xf6schen",
        platform_services_notify: "Dienste: St\xf6rungsmeldung per Mail",
        audit: "Protokolle",
        debug: "Debug"
    };
    const permissionModules = (0, $acw62.useMemo)(()=>{
        const defs = [
            {
                id: "dashboard",
                label: "Dashboard",
                visibility: "dashboard",
                actions: []
            },
            {
                id: "resolutions",
                label: "Umlaufbeschl\xfcsse",
                visibility: "resolutions",
                actions: [
                    {
                        id: "create",
                        key: "resolutions_create",
                        label: "Anlegen"
                    },
                    {
                        id: "update",
                        key: "resolutions_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "resolutions_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "qr_scan",
                label: "QR Erfassung",
                visibility: "qr_scan",
                actions: []
            },
            {
                id: "resolutions_delete_completed",
                label: "Abgeschlossene Beschl\u00FCsse l\u00F6schen",
                visibility: "resolutions_delete_completed",
                actions: []
            },
            {
                id: "objects",
                label: "Objekte",
                visibility: "objects",
                actions: [
                    {
                        id: "create",
                        key: "objects_create",
                        label: "Anlegen"
                    },
                    {
                        id: "update",
                        key: "objects_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "objects_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "units",
                label: "Einheiten",
                visibility: "units",
                actions: [
                    {
                        id: "create",
                        key: "units_create",
                        label: "Anlegen"
                    },
                    {
                        id: "update",
                        key: "units_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "units_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "units_view_technical",
                label: "Technische Einheiten (000) anzeigen",
                visibility: "units_view_technical",
                actions: []
            },
            {
                id: "owners",
                label: "Eigent\xfcmer",
                visibility: "owners",
                actions: [
                    {
                        id: "create",
                        key: "owners_create",
                        label: "Anlegen"
                    },
                    {
                        id: "update",
                        key: "owners_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "owners_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "assignments",
                label: "Zuordnungen",
                visibility: "assignments",
                actions: [
                    {
                        id: "create",
                        key: "assignments_create",
                        label: "Anlegen"
                    },
                    {
                        id: "update",
                        key: "assignments_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "assignments_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "imports",
                label: "Importe",
                visibility: "imports",
                actions: [
                    {
                        id: "create",
                        key: "imports_create",
                        label: "Anlegen/Starten"
                    },
                    {
                        id: "update",
                        key: "imports_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "imports_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "templates",
                label: "Vorlagen",
                visibility: "templates",
                actions: [
                    {
                        id: "create",
                        key: "templates_create",
                        label: "Anlegen"
                    },
                    {
                        id: "update",
                        key: "templates_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "templates_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "settings",
                label: "Einstellungen",
                visibility: "settings",
                actions: [
                    {
                        id: "create",
                        key: "settings_create",
                        label: "Anlegen"
                    },
                    {
                        id: "update",
                        key: "settings_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "settings_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "admin_users",
                label: "Benutzer & Rechte",
                visibility: "admin_users",
                actions: [
                    {
                        id: "create",
                        key: "admin_users_create",
                        label: "Anlegen"
                    },
                    {
                        id: "update",
                        key: "admin_users_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "admin_users_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "platform_tenants",
                label: "SaaS-Mandanten",
                visibility: "platform_tenants",
                actions: [
                    {
                        id: "create",
                        key: "platform_tenants_create",
                        label: "Anlegen"
                    },
                    {
                        id: "update",
                        key: "platform_tenants_update",
                        label: "Bearbeiten"
                    },
                    {
                        id: "delete",
                        key: "platform_tenants_delete",
                        label: "L\xf6schen"
                    }
                ]
            },
            {
                id: "platform_services_notify",
                label: "Dienste-Benachrichtigung",
                visibility: "platform_services_notify",
                actions: []
            },
            {
                id: "audit",
                label: "Protokolle",
                visibility: "audit",
                actions: []
            },
            {
                id: "debug",
                label: "Debug",
                visibility: "debug",
                actions: []
            }
        ];
        const available = new Set(permissionKeys);
        return defs.filter((module)=>available.has(module.visibility)).map((module)=>({
                ...module,
                actions: module.actions.filter((action)=>available.has(action.key))
            }));
    }, [
        permissionKeys
    ]);
    const ensureAssignment = (state, userId)=>{
        const current = state.userAssignments[userId];
        if (current) return current;
        return {
            groupIds: [],
            overrides: Object.fromEntries(permissionKeys.map((key)=>[
                    key,
                    "inherit"
                ]))
        };
    };
    const users = data?.data ?? [];
    const availableGroupFilterOptions = (0, $acw62.useMemo)(()=>{
        const base = effectiveGroupState.groups.filter((group)=>group.active).map((group)=>({
                id: group.id,
                name: group.name
            }));
        return [
            {
                id: "__superadmin__",
                name: "Superadmin (Sicherheitsrolle)"
            },
            {
                id: "__none__",
                name: "Keine Gruppe"
            },
            ...base
        ];
    }, [
        effectiveGroupState.groups
    ]);
    const filteredUsers = (0, $acw62.useMemo)(()=>{
        const q = userSearch.trim().toLowerCase();
        return users.filter((user)=>{
            const assignment = effectiveGroupState.userAssignments[user.id];
            const groupId = assignment?.groupIds?.[0] ?? "";
            const groupName = effectiveGroupState.groups.find((entry)=>entry.id === groupId)?.name ?? "";
            const matchesSearch = !q || user.username.toLowerCase().includes(q) || String(user.firstName ?? "").toLowerCase().includes(q) || String(user.lastName ?? "").toLowerCase().includes(q) || user.displayName.toLowerCase().includes(q) || String(user.email ?? "").toLowerCase().includes(q) || String(user.phone ?? "").toLowerCase().includes(q) || groupName.toLowerCase().includes(q);
            if (!matchesSearch) return false;
            if (userStatusFilter && user.status !== userStatusFilter) return false;
            if (userGroupFilter) {
                if (userGroupFilter === "__superadmin__") return user.role === "superadmin";
                if (userGroupFilter === "__none__") return !groupId;
                return groupId === userGroupFilter;
            }
            return true;
        });
    }, [
        effectiveGroupState.groups,
        effectiveGroupState.userAssignments,
        userGroupFilter,
        userSearch,
        userStatusFilter,
        users
    ]);
    const filteredGroups = (0, $acw62.useMemo)(()=>{
        const q = groupSearch.trim().toLowerCase();
        return effectiveGroupState.groups.filter((group)=>{
            const matchesSearch = !q || group.name.toLowerCase().includes(q) || String(group.description ?? "").toLowerCase().includes(q);
            if (!matchesSearch) return false;
            if (groupStatusFilter) return groupStatusFilter === (group.active ? "aktiv" : "inaktiv");
            return true;
        });
    }, [
        effectiveGroupState.groups,
        groupSearch,
        groupStatusFilter
    ]);
    const hasDuplicateGroupNames = (0, $acw62.useMemo)(()=>{
        const seen = new Set();
        for (const group of effectiveGroupState.groups){
            const key = group.name.trim().toLocaleLowerCase("de-DE");
            if (!key) continue;
            if (seen.has(key)) return true;
            seen.add(key);
        }
        return false;
    }, [
        effectiveGroupState.groups
    ]);
    const filteredAssignmentUsers = (0, $acw62.useMemo)(()=>{
        const q = assignmentSearch.trim().toLowerCase();
        if (!q) return users;
        return users.filter((user)=>{
            const assignment = effectiveGroupState.userAssignments[user.id];
            const groupId = assignment?.groupIds?.[0] ?? "";
            const groupName = effectiveGroupState.groups.find((entry)=>entry.id === groupId)?.name ?? "";
            return user.username.toLowerCase().includes(q) || String(user.firstName ?? "").toLowerCase().includes(q) || String(user.lastName ?? "").toLowerCase().includes(q) || user.displayName.toLowerCase().includes(q) || String(user.email ?? "").toLowerCase().includes(q) || String(user.phone ?? "").toLowerCase().includes(q) || groupName.toLowerCase().includes(q);
        });
    }, [
        assignmentSearch,
        effectiveGroupState.groups,
        effectiveGroupState.userAssignments,
        users
    ]);
    const assignmentPageSize = 10;
    const assignmentTotalPages = Math.max(1, Math.ceil(filteredAssignmentUsers.length / assignmentPageSize));
    const assignmentCurrentPage = Math.min(assignmentPage, assignmentTotalPages);
    const pagedAssignmentUsers = (0, $acw62.useMemo)(()=>{
        const start = (assignmentCurrentPage - 1) * assignmentPageSize;
        return filteredAssignmentUsers.slice(start, start + assignmentPageSize);
    }, [
        assignmentCurrentPage,
        filteredAssignmentUsers
    ]);
    const newGroupNameExists = (0, $acw62.useMemo)(()=>{
        const key = newGroupName.trim().toLocaleLowerCase("de-DE");
        if (!key) return false;
        return effectiveGroupState.groups.some((group)=>group.name.trim().toLocaleLowerCase("de-DE") === key);
    }, [
        effectiveGroupState.groups,
        newGroupName
    ]);
    const activeSelectedGroupId = selectedGroupId && effectiveGroupState.groups.some((group)=>group.id === selectedGroupId) ? selectedGroupId : effectiveGroupState.groups[0]?.id ?? "";
    const selectedGroup = effectiveGroupState.groups.find((group)=>group.id === activeSelectedGroupId) ?? null;
    const activeSelectedUserId = selectedUserId && users.some((row)=>row.id === selectedUserId) ? selectedUserId : users[0]?.id ?? "";
    const selectedUserRow = users.find((row)=>row.id === activeSelectedUserId);
    const selectedUserIsSystemRole = selectedUserRow?.role === "superadmin" || selectedUserRow?.role === "platform_admin";
    const selectedUserSystemRoleLabel = selectedUserRow?.role === "superadmin" ? "Superadmin (Sicherheitsrolle)" : selectedUserRow?.role === "platform_admin" ? "Platform Admin (Sicherheitsrolle)" : null;
    const selectedUserAssignment = activeSelectedUserId ? ensureAssignment(effectiveGroupState, activeSelectedUserId) : null;
    const activeGroupIdsForSelectedUser = selectedUserAssignment ? selectedUserAssignment.groupIds.filter((groupId)=>effectiveGroupState.groups.some((group)=>group.id === groupId && group.active)) : [];
    const allObjects = objectsData?.data ?? [];
    const filteredScopeObjects = (0, $acw62.useMemo)(()=>{
        const q = scopeObjectSearch.trim().toLowerCase();
        if (!q) return allObjects;
        return allObjects.filter((object)=>{
            const no = String(object.objektnummer ?? "").toLowerCase();
            const name = String(object.objektname ?? "").toLowerCase();
            return no.includes(q) || name.includes(q);
        });
    }, [
        allObjects,
        scopeObjectSearch
    ]);
    const scopeObjectPageSize = 10;
    const scopeObjectTotalPages = Math.max(1, Math.ceil(filteredScopeObjects.length / scopeObjectPageSize));
    const scopeObjectCurrentPage = Math.min(scopeObjectPage, scopeObjectTotalPages);
    const pagedScopeObjects = (0, $acw62.useMemo)(()=>{
        const start = (scopeObjectCurrentPage - 1) * scopeObjectPageSize;
        return filteredScopeObjects.slice(start, start + scopeObjectPageSize);
    }, [
        filteredScopeObjects,
        scopeObjectCurrentPage
    ]);
    const selectedUserScope = activeSelectedUserId && effectiveObjectScope.userAssignments[activeSelectedUserId] ? effectiveObjectScope.userAssignments[activeSelectedUserId] : {
        mode: "all",
        objectIds: []
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "admin-users-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: `page-header panel ${isFrameworkV2 ? "resolutions-v2-page-header" : "admin-users-page-header"}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    className: isFrameworkV2 ? "resolutions-v2-title" : "",
                    style: {
                        margin: 0
                    },
                    children: [
                        isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "resolutions-v2-title-icon",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "5.2",
                                        y: "4.8",
                                        width: "13.6",
                                        height: "14.4",
                                        rx: "1.9",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M8.2 9.4h7.6M8.2 13h7.6M8.2 16.6h4.8",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round"
                                    })
                                ]
                            })
                        }) : null,
                        isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "resolutions-v2-title-copy",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-main",
                                    children: "Benutzer & Rechte"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-sub",
                                    children: "Benutzer, Gruppen und Objektzugriffe verwalten"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Benutzer & Rechte"
                        })
                    ]
                })
            }),
            isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel error-text",
                children: error instanceof Error ? error.message : "Fehler beim Laden"
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel admin-rights-guide",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0,
                            marginBottom: 8
                        },
                        children: "Rechteverwaltung in 3 Schritten"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "admin-rights-guide-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-rights-guide-item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "admin-rights-guide-step",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "admin-rights-guide-bullet",
                                            children: "1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-rights-guide-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Benutzeranlage"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "Benutzer anlegen, bearbeiten, aktivieren oder sperren."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-rights-guide-item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "admin-rights-guide-step",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "admin-rights-guide-bullet",
                                            children: "2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-rights-guide-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Gruppenanlage | Zuordnung"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "Benutzergruppen definieren und Benutzer einer Gruppe zuordnen."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-rights-guide-item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "admin-rights-guide-step",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "admin-rights-guide-bullet",
                                            children: "3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-rights-guide-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Einzelrechtevergabe | Objektzuweisung"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                children: "Einzelrechte vergeben und Objektzugriff pro Benutzer steuern."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form admin-rights-userlist",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "page-header",
                        style: {
                            marginBottom: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-rights-step-like-header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "admin-rights-guide-bullet",
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        style: {
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        children: "Benutzeranlage"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: isFrameworkV2 ? "resolutions-v2-create-btn" : "",
                                disabled: !canCreateUsers,
                                onClick: ()=>setShowCreate((v)=>!v),
                                children: [
                                    isFrameworkV2 && !showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-create-btn-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M10 4.2v11.6M4.2 10h11.6",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round"
                                            })
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: showCreate ? "Schlie\xdfen" : "Neuer Benutzer"
                                    })
                                ]
                            })
                        ]
                    }),
                    showCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "admin-rights-nested-box",
                        style: {
                            marginBottom: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                style: {
                                    marginTop: 0
                                },
                                children: "Benutzer anlegen"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Benutzername*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: createForm.username,
                                                onChange: (e)=>setCreateForm({
                                                        ...createForm,
                                                        username: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "E-Mail*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "email",
                                                value: createForm.email,
                                                onChange: (e)=>setCreateForm({
                                                        ...createForm,
                                                        email: e.target.value
                                                    }),
                                                placeholder: "name@beispiel.de",
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Vorname*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: createForm.firstName,
                                                onChange: (e)=>setCreateForm({
                                                        ...createForm,
                                                        firstName: e.target.value
                                                    }),
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Nachname*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: createForm.lastName,
                                                onChange: (e)=>setCreateForm({
                                                        ...createForm,
                                                        lastName: e.target.value
                                                    }),
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Telefon"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: createForm.phone,
                                                onChange: (e)=>setCreateForm({
                                                        ...createForm,
                                                        phone: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Anzeigename (optional)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: createForm.displayName,
                                                onChange: (e)=>setCreateForm({
                                                        ...createForm,
                                                        displayName: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Gruppe*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: createForm.groupId,
                                                disabled: isPlatformRightsContext && createForm.isPlatformAdmin,
                                                onChange: (e)=>setCreateForm({
                                                        ...createForm,
                                                        groupId: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Bitte Gruppe w\xe4hlen"
                                                    }),
                                                    effectiveGroupState.groups.filter((group)=>group.active).map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: group.id,
                                                            children: group.name
                                                        }, `create-group-${group.id}`))
                                                ]
                                            })
                                        ]
                                    }),
                                    isPlatformRightsContext ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Systemrolle"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "admin-rights-inline-check",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: createForm.isPlatformAdmin,
                                                        disabled: authUser.role !== "superadmin",
                                                        onChange: (e)=>setCreateForm({
                                                                ...createForm,
                                                                isPlatformAdmin: e.target.checked,
                                                                groupId: e.target.checked ? "" : createForm.groupId
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Als Platform Admin anlegen"
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Initialpasswort* (min. 8 Zeichen)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "password",
                                                value: createForm.password,
                                                onChange: (e)=>setCreateForm({
                                                        ...createForm,
                                                        password: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Profilbild"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: createAvatarInputRef,
                                                type: "file",
                                                accept: "image/*",
                                                style: {
                                                    display: "none"
                                                },
                                                onChange: (e)=>setCreateAvatarFile(normalizeAvatarFile(e.target.files?.[0] ?? null))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `resolution-document-dropzone${createAvatarDragOver ? " is-drag-over" : ""}`,
                                                onDragOver: (e)=>{
                                                    e.preventDefault();
                                                    setCreateAvatarDragOver(true);
                                                },
                                                onDragLeave: ()=>setCreateAvatarDragOver(false),
                                                onDrop: (e)=>{
                                                    e.preventDefault();
                                                    setCreateAvatarDragOver(false);
                                                    const file = normalizeAvatarFile(e.dataTransfer.files?.[0] ?? null);
                                                    if (file) setCreateAvatarFile(file);
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: "grid",
                                                        gap: 8,
                                                        justifyItems: "center",
                                                        width: "100%"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>createAvatarInputRef.current?.click(),
                                                            children: "Datei ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            className: "resolution-document-dropzone-text",
                                                            children: "Drag & Drop oder Klick zum Ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            style: {
                                                                color: "var(--text-soft)"
                                                            },
                                                            children: createAvatarFile ? `Ausgew\xe4hlt: ${createAvatarFile.name}` : "Keine Datei ausgew\xe4hlt"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: !canCreateUsers || !canCreate || createMutation.isPending,
                                        onClick: ()=>createMutation.mutate(),
                                        children: createMutation.isPending ? "Speichere..." : "Benutzer speichern"
                                    }),
                                    createError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "error-text",
                                        children: createError
                                    }) : null
                                ]
                            })
                        ]
                    }) : null,
                    editRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "admin-rights-nested-box",
                        style: {
                            marginBottom: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                style: {
                                    marginTop: 0
                                },
                                children: "Benutzer bearbeiten"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Benutzername"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editRow.username,
                                                disabled: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "E-Mail*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "email",
                                                value: editForm.email,
                                                onChange: (e)=>setEditForm({
                                                        ...editForm,
                                                        email: e.target.value
                                                    }),
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Vorname*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editForm.firstName,
                                                onChange: (e)=>setEditForm({
                                                        ...editForm,
                                                        firstName: e.target.value
                                                    }),
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Nachname*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editForm.lastName,
                                                onChange: (e)=>setEditForm({
                                                        ...editForm,
                                                        lastName: e.target.value
                                                    }),
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Telefon"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editForm.phone,
                                                onChange: (e)=>setEditForm({
                                                        ...editForm,
                                                        phone: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Anzeigename (optional)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: editForm.displayName,
                                                onChange: (e)=>setEditForm({
                                                        ...editForm,
                                                        displayName: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Gruppe"
                                            }),
                                            editRow.role === "superadmin" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                value: "Superadmin (Sicherheitsrolle)",
                                                disabled: true
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: editForm.groupId,
                                                disabled: isPlatformRightsContext && editForm.isPlatformAdmin,
                                                onChange: (e)=>setEditForm({
                                                        ...editForm,
                                                        groupId: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Keine Gruppe"
                                                    }),
                                                    effectiveGroupState.groups.filter((group)=>group.active).map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: group.id,
                                                            children: group.name
                                                        }, `edit-group-${group.id}`))
                                                ]
                                            })
                                        ]
                                    }),
                                    isPlatformRightsContext && editRow.role !== "superadmin" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Systemrolle"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "admin-rights-inline-check",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: editForm.isPlatformAdmin,
                                                        disabled: authUser.role !== "superadmin",
                                                        onChange: (e)=>setEditForm({
                                                                ...editForm,
                                                                isPlatformAdmin: e.target.checked,
                                                                groupId: e.target.checked ? "" : editForm.groupId
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Platform Admin"
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Status*"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: editForm.status,
                                                onChange: (e)=>setEditForm({
                                                        ...editForm,
                                                        status: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "aktiv",
                                                        children: "aktiv"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "inaktiv",
                                                        children: "inaktiv"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Neues Passwort (optional)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "password",
                                                value: editForm.password,
                                                onChange: (e)=>setEditForm({
                                                        ...editForm,
                                                        password: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Profilbild"
                                            }),
                                            editRow?.avatarUrl && !editAvatarRemoved && !editAvatarFile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    marginBottom: 8
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: editRow.avatarUrl,
                                                    alt: editRow.displayName,
                                                    style: {
                                                        width: 52,
                                                        height: 52,
                                                        borderRadius: "50%",
                                                        objectFit: "cover",
                                                        border: "1px solid var(--line)"
                                                    }
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: editAvatarInputRef,
                                                type: "file",
                                                accept: "image/*",
                                                style: {
                                                    display: "none"
                                                },
                                                onChange: (e)=>{
                                                    setEditAvatarFile(normalizeAvatarFile(e.target.files?.[0] ?? null));
                                                    setEditAvatarRemoved(false);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `resolution-document-dropzone${editAvatarDragOver ? " is-drag-over" : ""}`,
                                                onDragOver: (e)=>{
                                                    e.preventDefault();
                                                    setEditAvatarDragOver(true);
                                                },
                                                onDragLeave: ()=>setEditAvatarDragOver(false),
                                                onDrop: (e)=>{
                                                    e.preventDefault();
                                                    setEditAvatarDragOver(false);
                                                    const file = normalizeAvatarFile(e.dataTransfer.files?.[0] ?? null);
                                                    if (!file) return;
                                                    setEditAvatarFile(file);
                                                    setEditAvatarRemoved(false);
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: "grid",
                                                        gap: 8,
                                                        justifyItems: "center",
                                                        width: "100%"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>editAvatarInputRef.current?.click(),
                                                            children: "Datei ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            className: "resolution-document-dropzone-text",
                                                            children: "Drag & Drop oder Klick zum Ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                            style: {
                                                                color: "var(--text-soft)"
                                                            },
                                                            children: editAvatarFile ? `Ausgew\xe4hlt: ${editAvatarFile.name}` : editAvatarRemoved ? "Bild wird beim Speichern entfernt" : "Keine neue Datei ausgew\xe4hlt"
                                                        })
                                                    ]
                                                })
                                            }),
                                            editRow?.avatarUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                style: {
                                                    marginTop: 8
                                                },
                                                onClick: ()=>{
                                                    setEditAvatarFile(null);
                                                    setEditAvatarRemoved(true);
                                                },
                                                children: "Bild entfernen"
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: !canUpdateUsers || !canEdit || updateMutation.isPending,
                                        onClick: ()=>updateMutation.mutate(),
                                        children: updateMutation.isPending ? "Speichere..." : "\xc4nderungen speichern"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>setEditRow(null),
                                        children: "Abbrechen"
                                    }),
                                    editError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "error-text",
                                        children: editError
                                    }) : null
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                        style: {
                            color: "var(--text-soft)"
                        },
                        children: "Benutzer anlegen, bearbeiten, aktivieren oder sperren."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "admin-users-v2-table",
                        style: {
                            marginTop: 10
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                            columns: columns,
                            rows: filteredUsers,
                            total: filteredUsers.length,
                            page: 1,
                            pageSize: 50,
                            onPageChange: ()=>undefined,
                            topContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "filterbar",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99bbb276306e7658$var$SearchField, {
                                        placeholder: "Suche Benutzer/Name/Gruppe",
                                        value: userSearch,
                                        onChange: setUserSearch
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: userGroupFilter,
                                        onChange: (e)=>setUserGroupFilter(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Gruppen"
                                            }),
                                            availableGroupFilterOptions.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: entry.id,
                                                    children: entry.name
                                                }, `user-group-filter-${entry.id}`))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: userStatusFilter,
                                        onChange: (e)=>setUserStatusFilter(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Alle Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel",
                children: "Lade Benutzer..."
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form admin-rights-section-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "admin-rights-step-like-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "admin-rights-guide-bullet",
                                children: "2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "Gruppenanlage | Zuordnung"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                        style: {
                            color: "var(--text-soft)"
                        },
                        children: "Benutzergruppen definieren, Rechte je Gruppe pflegen und Benutzer einer Gruppe zuordnen."
                    }),
                    groupsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Lade Usergruppen..."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "admin-permission-group-card",
                                style: {
                                    marginTop: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "page-header",
                                        style: {
                                            marginBottom: 6
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "admin-permission-group-title",
                                                children: "Benutzergruppen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                className: isFrameworkV2 ? "resolutions-v2-create-btn" : "",
                                                onClick: ()=>setShowGroupCreate((prev)=>!prev),
                                                children: [
                                                    isFrameworkV2 && !showGroupCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "resolutions-v2-create-btn-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                            viewBox: "0 0 20 20",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M10 4.2v11.6M4.2 10h11.6",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round"
                                                            })
                                                        })
                                                    }) : null,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: showGroupCreate ? "Schlie\xdfen" : "Gruppenanlage"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        style: {
                                            color: "var(--text-soft)"
                                        },
                                        children: "\xdcbersicht aller Gruppen mit Gruppenname, Beschreibung und Status."
                                    }),
                                    showGroupCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-rights-nested-subbox",
                                        style: {
                                            marginTop: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-grid",
                                                style: {
                                                    marginTop: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Gruppenname*"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                placeholder: "Neue Benutzergruppe",
                                                                value: newGroupName,
                                                                disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                                                onChange: (e)=>setNewGroupName(e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Beschreibung (optional)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                placeholder: "Kurze Beschreibung der Gruppe",
                                                                value: newGroupDescription,
                                                                disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                                                onChange: (e)=>setNewGroupDescription(e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Status"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                className: "settings-switch-row admin-rights-group-switch-small",
                                                                style: {
                                                                    margin: "0"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "settings-toggle admin-rights-group-toggle-small",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                type: "checkbox",
                                                                                checked: newGroupActive,
                                                                                disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                                                                onChange: (e)=>setNewGroupActive(e.target.checked)
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "settings-toggle-slider"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        style: {
                                                                            fontSize: 12,
                                                                            color: "var(--text-soft)"
                                                                        },
                                                                        children: newGroupActive ? "aktiv" : "inaktiv"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "form-actions",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    disabled: !canEditRoleMatrix || groupsMutation.isPending || !newGroupName.trim() || newGroupNameExists,
                                                    onClick: ()=>{
                                                        const newKey = newGroupName.trim().toLocaleLowerCase("de-DE");
                                                        const exists = effectiveGroupState.groups.some((group)=>group.name.trim().toLocaleLowerCase("de-DE") === newKey);
                                                        if (exists) {
                                                            setGroupsMessage("");
                                                            setGroupsError("Benutzergruppenname bereits vorhanden.");
                                                            return;
                                                        }
                                                        const basePermissions = Object.fromEntries(permissionKeys.map((key)=>[
                                                                key,
                                                                false
                                                            ]));
                                                        const nextGroup = {
                                                            id: `grp_${Date.now().toString(36)}`,
                                                            name: newGroupName.trim(),
                                                            description: newGroupDescription.trim() || undefined,
                                                            active: newGroupActive,
                                                            permissions: basePermissions
                                                        };
                                                        setGroupsMessage("");
                                                        setGroupsError("");
                                                        setGroupsDraft({
                                                            ...effectiveGroupState,
                                                            groups: [
                                                                ...effectiveGroupState.groups,
                                                                nextGroup
                                                            ]
                                                        });
                                                        setSelectedGroupId(nextGroup.id);
                                                        setNewGroupName("");
                                                        setNewGroupDescription("");
                                                        setNewGroupActive(true);
                                                        setShowGroupCreate(false);
                                                    },
                                                    children: "Anlegen"
                                                })
                                            }),
                                            newGroupNameExists ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "error-text",
                                                children: "Benutzergruppenname bereits vorhanden."
                                            }) : null
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "admin-users-v2-table",
                                        style: {
                                            marginTop: 8
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                                            columns: groupColumns,
                                            rows: filteredGroups,
                                            total: filteredGroups.length,
                                            page: 1,
                                            pageSize: 50,
                                            onPageChange: ()=>undefined,
                                            topContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "filterbar",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99bbb276306e7658$var$SearchField, {
                                                        placeholder: "Suche Gruppenname/Beschreibung",
                                                        value: groupSearch,
                                                        onChange: setGroupSearch
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: groupStatusFilter,
                                                        onChange: (e)=>setGroupStatusFilter(e.target.value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "Alle Status"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "aktiv",
                                                                children: "aktiv"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "inaktiv",
                                                                children: "inaktiv"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    groupEditId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-rights-nested-subbox",
                                        style: {
                                            marginTop: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "admin-permission-group-title",
                                                style: {
                                                    fontSize: 16
                                                },
                                                children: "Gruppe bearbeiten"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-grid",
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Gruppenname*"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                value: groupEditName,
                                                                disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                                                onChange: (e)=>{
                                                                    setGroupEditName(e.target.value);
                                                                    setGroupEditError("");
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Beschreibung (optional)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                value: groupEditDescription,
                                                                disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                                                onChange: (e)=>setGroupEditDescription(e.target.value)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Status"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                className: "settings-switch-row admin-rights-group-switch-small",
                                                                style: {
                                                                    margin: "0"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "settings-toggle admin-rights-group-toggle-small",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                type: "checkbox",
                                                                                checked: groupEditActive,
                                                                                disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                                                                onChange: (e)=>setGroupEditActive(e.target.checked)
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "settings-toggle-slider"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        style: {
                                                                            fontSize: 12,
                                                                            color: "var(--text-soft)"
                                                                        },
                                                                        children: groupEditActive ? "aktiv" : "inaktiv"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        disabled: !canEditRoleMatrix || groupsMutation.isPending || !groupEditName.trim(),
                                                        onClick: ()=>{
                                                            const key = groupEditName.trim().toLocaleLowerCase("de-DE");
                                                            const duplicate = effectiveGroupState.groups.some((group)=>group.id !== groupEditId && group.name.trim().toLocaleLowerCase("de-DE") === key);
                                                            if (duplicate) {
                                                                setGroupEditError("Benutzergruppenname bereits vorhanden.");
                                                                return;
                                                            }
                                                            const nextGroups = effectiveGroupState.groups.map((group)=>group.id === groupEditId ? {
                                                                    ...group,
                                                                    name: groupEditName.trim(),
                                                                    description: groupEditDescription.trim() || undefined,
                                                                    active: groupEditActive
                                                                } : group);
                                                            setGroupsMessage("");
                                                            setGroupsError("");
                                                            setGroupsDraft({
                                                                ...effectiveGroupState,
                                                                groups: nextGroups
                                                            });
                                                            setGroupEditId("");
                                                            setGroupEditName("");
                                                            setGroupEditDescription("");
                                                            setGroupEditActive(true);
                                                            setGroupEditError("");
                                                        },
                                                        children: "Gruppe \xfcbernehmen"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>{
                                                            setGroupEditId("");
                                                            setGroupEditName("");
                                                            setGroupEditDescription("");
                                                            setGroupEditActive(true);
                                                            setGroupEditError("");
                                                        },
                                                        children: "Abbrechen"
                                                    }),
                                                    groupEditError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "error-text",
                                                        children: groupEditError
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    }) : null
                                ]
                            }),
                            selectedGroup ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "admin-permission-group-card",
                                style: {
                                    marginTop: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "admin-permission-group-title",
                                        children: "Rechtezuordnung zur Gruppe"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        style: {
                                            color: "var(--text-soft)"
                                        },
                                        children: "Rechte der ausgew\xe4hlten Gruppe konfigurieren."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-rights-nested-subbox",
                                        style: {
                                            marginTop: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "admin-group-rights-select-row",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "admin-group-rights-select-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            className: "field-label",
                                                            htmlFor: "group-rights-select",
                                                            children: "Benutzergruppe ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                            id: "group-rights-select",
                                                            value: activeSelectedGroupId,
                                                            disabled: groupsMutation.isPending,
                                                            onChange: (e)=>{
                                                                setSelectedGroupId(e.target.value);
                                                            },
                                                            children: effectiveGroupState.groups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: group.id,
                                                                    children: group.name
                                                                }, group.id))
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "admin-permission-table-wrap",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                    className: "data-table admin-rights-table",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "table-head-two-line",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "Bereich"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "\xa0"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "table-head-two-line",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "Sichtbar"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "\xa0"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "table-head-two-line",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "Anlegen"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "\xa0"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "table-head-two-line",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "Bearbeiten"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "\xa0"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "table-head-two-line",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "L\xf6schen"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    children: "\xa0"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                            children: permissionModules.map((module)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            children: module.label
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            style: {
                                                                                textAlign: "center"
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                type: "checkbox",
                                                                                checked: Boolean(selectedGroup.permissions[module.visibility]),
                                                                                disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                                                                onChange: (e)=>{
                                                                                    const nextGroups = effectiveGroupState.groups.map((entry)=>entry.id === selectedGroup.id ? {
                                                                                            ...entry,
                                                                                            permissions: {
                                                                                                ...entry.permissions,
                                                                                                [module.visibility]: e.target.checked
                                                                                            }
                                                                                        } : entry);
                                                                                    setGroupsMessage("");
                                                                                    setGroupsError("");
                                                                                    setGroupsDraft({
                                                                                        ...effectiveGroupState,
                                                                                        groups: nextGroups
                                                                                    });
                                                                                }
                                                                            })
                                                                        }),
                                                                        [
                                                                            "create",
                                                                            "update",
                                                                            "delete"
                                                                        ].map((actionId)=>{
                                                                            const action = module.actions.find((entry)=>entry.id === actionId);
                                                                            if (!action) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                style: {
                                                                                    textAlign: "center"
                                                                                },
                                                                                children: "-"
                                                                            }, `group-module-${selectedGroup.id}-${module.id}-${actionId}`);
                                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                style: {
                                                                                    textAlign: "center"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: Boolean(selectedGroup.permissions[action.key]),
                                                                                    disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                                                                    onChange: (e)=>{
                                                                                        const nextGroups = effectiveGroupState.groups.map((entry)=>entry.id === selectedGroup.id ? {
                                                                                                ...entry,
                                                                                                permissions: {
                                                                                                    ...entry.permissions,
                                                                                                    [action.key]: e.target.checked
                                                                                                }
                                                                                            } : entry);
                                                                                        setGroupsMessage("");
                                                                                        setGroupsError("");
                                                                                        setGroupsDraft({
                                                                                            ...effectiveGroupState,
                                                                                            groups: nextGroups
                                                                                        });
                                                                                    }
                                                                                })
                                                                            }, `group-module-${selectedGroup.id}-${module.id}-${actionId}`);
                                                                        })
                                                                    ]
                                                                }, `group-module-${selectedGroup.id}-${module.id}`))
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        disabled: !canEditRoleMatrix || !groupsDraft || groupsMutation.isPending,
                                                        onClick: ()=>{
                                                            if (!groupsDraft) return;
                                                            if (hasDuplicateGroupNames) {
                                                                setGroupsMessage("");
                                                                setGroupsError("Es darf keine doppelten Benutzergruppennamen geben.");
                                                                return;
                                                            }
                                                            groupsMutation.mutate(groupsDraft);
                                                        },
                                                        children: groupsMutation.isPending ? "Speichere..." : "Benutzergruppe speichern"
                                                    }),
                                                    groupsError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "error-text",
                                                        children: groupsError
                                                    }) : null,
                                                    groupsMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: groupsMessage
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "admin-rights-user-override-note",
                                style: {
                                    marginTop: 8
                                },
                                children: "Es gibt noch keine Gruppen. Bitte zuerst eine neue Benutzergruppe anlegen oder in der Gruppenliste ausw\xe4hlen."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "admin-permission-group-card",
                                style: {
                                    marginTop: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "admin-permission-group-title",
                                        children: "Benutzer-Gruppenzuordnung"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        style: {
                                            color: "var(--text-soft)"
                                        },
                                        children: "Hier wird direkt festgelegt, welche Benutzer zu welcher Gruppe geh\xf6ren."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "filterbar",
                                        style: {
                                            marginTop: 8
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99bbb276306e7658$var$SearchField, {
                                            placeholder: "Suche Benutzer/Gruppe",
                                            value: assignmentSearch,
                                            onChange: (value)=>{
                                                setAssignmentSearch(value);
                                                setAssignmentPage(1);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                        style: {
                                            color: "var(--text-soft)"
                                        },
                                        children: [
                                            "Zeilen: ",
                                            pagedAssignmentUsers.length,
                                            " / Gesamt: ",
                                            filteredAssignmentUsers.length
                                        ]
                                    }),
                                    !effectiveGroupState.groups.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "admin-rights-user-override-note",
                                        style: {
                                            marginTop: 8
                                        },
                                        children: "Es gibt noch keine Gruppen. Bitte zuerst oben eine Gruppe anlegen."
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "admin-permission-table-wrap",
                                        style: {
                                            marginTop: 8
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "data-table admin-rights-table",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: "Benutzer"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center",
                                                                    whiteSpace: "nowrap"
                                                                },
                                                                children: "Keine Gruppe"
                                                            }),
                                                            effectiveGroupState.groups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    style: {
                                                                        textAlign: "center",
                                                                        whiteSpace: "nowrap"
                                                                    },
                                                                    children: group.name
                                                                }, `assign-head-${group.id}`))
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        pagedAssignmentUsers.map((user)=>{
                                                            const assignment = ensureAssignment(effectiveGroupState, user.id);
                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                children: user.displayName
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                style: {
                                                                                    fontSize: 12,
                                                                                    color: "var(--text-soft)"
                                                                                },
                                                                                children: user.username
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "radio",
                                                                            name: `user-group-${user.id}`,
                                                                            checked: !assignment.groupIds[0],
                                                                            disabled: !canEditRoleMatrix || groupsMutation.isPending || user.role === "superadmin" || user.role === "platform_admin",
                                                                            onChange: ()=>{
                                                                                const current = ensureAssignment(effectiveGroupState, user.id);
                                                                                setGroupsMessage("");
                                                                                setGroupsError("");
                                                                                setGroupsDraft({
                                                                                    ...effectiveGroupState,
                                                                                    userAssignments: {
                                                                                        ...effectiveGroupState.userAssignments,
                                                                                        [user.id]: {
                                                                                            ...current,
                                                                                            groupIds: []
                                                                                        }
                                                                                    }
                                                                                });
                                                                            }
                                                                        })
                                                                    }),
                                                                    effectiveGroupState.groups.map((group)=>{
                                                                        const checked = assignment.groupIds[0] === group.id;
                                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            style: {
                                                                                textAlign: "center"
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                type: "radio",
                                                                                name: `user-group-${user.id}`,
                                                                                checked: checked,
                                                                                disabled: !canEditRoleMatrix || groupsMutation.isPending || user.role === "superadmin" || user.role === "platform_admin",
                                                                                onChange: ()=>{
                                                                                    const current = ensureAssignment(effectiveGroupState, user.id);
                                                                                    const nextGroupIds = [
                                                                                        group.id
                                                                                    ];
                                                                                    setGroupsMessage("");
                                                                                    setGroupsError("");
                                                                                    setGroupsDraft({
                                                                                        ...effectiveGroupState,
                                                                                        userAssignments: {
                                                                                            ...effectiveGroupState.userAssignments,
                                                                                            [user.id]: {
                                                                                                ...current,
                                                                                                groupIds: nextGroupIds
                                                                                            }
                                                                                        }
                                                                                    });
                                                                                }
                                                                            })
                                                                        }, `assign-cell-${user.id}-${group.id}`);
                                                                    })
                                                                ]
                                                            }, `assign-row-${user.id}`);
                                                        }),
                                                        !pagedAssignmentUsers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: 2 + effectiveGroupState.groups.length,
                                                                children: "Keine Benutzer gefunden."
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "pagination",
                                        style: {
                                            marginTop: 8,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: assignmentCurrentPage <= 1,
                                                onClick: ()=>setAssignmentPage((p)=>Math.max(1, p - 1)),
                                                children: "Zur\xfcck"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                style: {
                                                    fontSize: 13
                                                },
                                                children: [
                                                    "Seite ",
                                                    assignmentCurrentPage,
                                                    " / ",
                                                    assignmentTotalPages
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: assignmentCurrentPage >= assignmentTotalPages,
                                                onClick: ()=>setAssignmentPage((p)=>Math.min(assignmentTotalPages, p + 1)),
                                                children: "Weiter"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel create-form admin-rights-section-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "admin-rights-step-like-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "admin-rights-guide-bullet",
                                children: "3"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "Einzelrechtevergabe | Objektzuweisung"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                        style: {
                            color: "var(--text-soft)"
                        },
                        children: "Einzelrechte vergeben und Objektzugriff pro Benutzer steuern."
                    }),
                    activeSelectedUserId && selectedUserAssignment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "admin-rights-nested-box",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-rights-section-intro",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        style: {
                                            margin: 0
                                        },
                                        children: "Einzelrechte pro Benutzer"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        children: "In diesem Bereich werden benutzerbezogene Einzelrechte und die Objektzuordnung gepflegt. Gruppenrechte bleiben f\xfchrend."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "form-grid",
                                style: {
                                    marginTop: 0
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Benutzer ausw\xe4hlen (Einzelrechte)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                            value: activeSelectedUserId,
                                            onChange: (e)=>setSelectedUserId(e.target.value),
                                            disabled: !users.length,
                                            children: users.map((user)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: user.id,
                                                    children: `${user.displayName} (${user.username})`
                                                }, user.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-rights-nested-subbox admin-group-assignment-info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginBottom: 8,
                                            fontWeight: 600
                                        },
                                        children: "Gruppenzuweisung (informativ)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-group-assignment-info-row",
                                        children: [
                                            selectedUserSystemRoleLabel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 6,
                                                    opacity: 0.85,
                                                    cursor: "not-allowed"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "radio",
                                                        checked: true,
                                                        disabled: true
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "badge",
                                                        children: selectedUserSystemRoleLabel
                                                    })
                                                ]
                                            }) : null,
                                            effectiveGroupState.groups.map((group)=>{
                                                const checked = selectedUserAssignment.groupIds[0] === group.id;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 6
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "radio",
                                                            name: `selected-user-group-${activeSelectedUserId}`,
                                                            checked: checked,
                                                            disabled: true
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "badge",
                                                            children: group.name
                                                        })
                                                    ]
                                                }, `assign-${group.id}`);
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 6
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "radio",
                                                        name: `selected-user-group-${activeSelectedUserId}`,
                                                        checked: !selectedUserAssignment.groupIds[0],
                                                        disabled: true
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "badge",
                                                        children: "Keine Gruppe"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginTop: 8,
                                            color: "var(--text-soft)",
                                            fontSize: 12
                                        },
                                        children: "Die Gruppenzuordnung wird im Bereich \u201E2 Gruppenanlage | Zuordnung\u201C gepflegt."
                                    })
                                ]
                            }),
                            selectedUserIsSystemRole ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "admin-rights-user-override-note",
                                children: "F\xfcr Systemrollen (Superadmin / Platform Admin) sind Gruppen und Einzelrechte nicht bearbeitbar."
                            }) : activeGroupIdsForSelectedUser.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "admin-rights-user-override-note",
                                children: "Gruppe zugewiesen: Benutzer-Einzelrechte sind ausgeblendet."
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "admin-rights-user-override-note",
                                children: "Keine Gruppe zugewiesen. Benutzer-Einzelrechte greifen direkt."
                            }),
                            !selectedUserIsSystemRole && !activeGroupIdsForSelectedUser.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-rights-nested-subbox",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginTop: 4,
                                            marginBottom: 8,
                                            fontWeight: 600
                                        },
                                        children: "Benutzer-Einzelrechte (nachrangig)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            overflowX: "auto"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "data-table admin-rights-table",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: "Bereich"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: "Sichtbar"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: "Anlegen"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: "Bearbeiten"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: "L\xf6schen"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                    children: permissionModules.map((module)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: module.label
                                                                }),
                                                                [
                                                                    module.visibility,
                                                                    ...module.actions.map((action)=>action.key)
                                                                ].map((key, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: index > 0 && !module.actions[index - 1] ? "-" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "checkbox",
                                                                            checked: selectedUserAssignment.overrides[key] === "allow",
                                                                            disabled: !canEditRoleMatrix || groupsMutation.isPending,
                                                                            onChange: (e)=>{
                                                                                const current = ensureAssignment(effectiveGroupState, activeSelectedUserId);
                                                                                setGroupsMessage("");
                                                                                setGroupsError("");
                                                                                setGroupsDraft({
                                                                                    ...effectiveGroupState,
                                                                                    userAssignments: {
                                                                                        ...effectiveGroupState.userAssignments,
                                                                                        [activeSelectedUserId]: {
                                                                                            ...current,
                                                                                            overrides: {
                                                                                                ...current.overrides,
                                                                                                [key]: e.target.checked ? "allow" : "inherit"
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                });
                                                                            }
                                                                        })
                                                                    }, `override-module-${module.id}-${key}`)),
                                                                module.actions.length < 3 ? Array.from({
                                                                    length: 3 - module.actions.length
                                                                }).map((_, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: "-"
                                                                    }, `override-module-pad-${module.id}-${idx}`)) : null
                                                            ]
                                                        }, `override-module-${module.id}`))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-actions",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: !canEditRoleMatrix || !groupsDraft || groupsMutation.isPending,
                                                onClick: ()=>{
                                                    if (!groupsDraft) return;
                                                    if (hasDuplicateGroupNames) {
                                                        setGroupsMessage("");
                                                        setGroupsError("Es darf keine doppelten Benutzergruppennamen geben.");
                                                        return;
                                                    }
                                                    groupsMutation.mutate(groupsDraft);
                                                },
                                                children: groupsMutation.isPending ? "Speichere..." : "Einzelrechte speichern"
                                            }),
                                            groupsError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "error-text",
                                                children: groupsError
                                            }) : null,
                                            groupsMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: groupsMessage
                                            }) : null
                                        ]
                                    })
                                ]
                            }) : null,
                            supportsObjectScope ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-rights-nested-subbox",
                                style: {
                                    marginTop: 20
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginTop: 4,
                                            marginBottom: 8,
                                            fontWeight: 600
                                        },
                                        children: "Objektzuordnungen des Benutzers"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        style: {
                                            color: "var(--text-soft)"
                                        },
                                        children: "Mit \u201EAlle Objekte\u201C hat der Benutzer Vollzugriff im Mandanten. Mit \u201ENur ausgew\xe4hlte Objekte\u201C wird der Zugriff begrenzt."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "form-grid",
                                        style: {
                                            marginTop: 8
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field admin-object-scope-mode-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Modus"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: selectedUserScope.mode,
                                                    disabled: !canEditRoleMatrix || objectScopeMutation.isPending,
                                                    onChange: (e)=>{
                                                        const nextMode = e.target.value === "include" ? "include" : "all";
                                                        setScopeMessage("");
                                                        setScopeError("");
                                                        setObjectScopeDraft({
                                                            ...effectiveObjectScope,
                                                            userAssignments: {
                                                                ...effectiveObjectScope.userAssignments,
                                                                [activeSelectedUserId]: {
                                                                    ...selectedUserScope,
                                                                    mode: nextMode
                                                                }
                                                            }
                                                        });
                                                        if (nextMode === "include") setScopeObjectPage(1);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "all",
                                                            children: "Alle Objekte"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "include",
                                                            children: "Ausgew\xe4hlte Objekte"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    selectedUserScope.mode === "include" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            marginTop: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "filterbar",
                                                style: {
                                                    marginBottom: 8
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99bbb276306e7658$var$SearchField, {
                                                    placeholder: "Suche Objekt-Nr/Objektname",
                                                    value: scopeObjectSearch,
                                                    onChange: (value)=>{
                                                        setScopeObjectSearch(value);
                                                        setScopeObjectPage(1);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                style: {
                                                    color: "var(--text-soft)"
                                                },
                                                children: [
                                                    "Zeilen: ",
                                                    pagedScopeObjects.length,
                                                    " / Gesamt: ",
                                                    filteredScopeObjects.length
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    marginTop: 8,
                                                    overflowX: "auto"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                    className: "data-table admin-rights-table",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        style: {
                                                                            width: 48,
                                                                            textAlign: "center"
                                                                        },
                                                                        children: "Auswahl"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        children: "Objekt-Nr"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        children: "Objektname"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                            children: [
                                                                pagedScopeObjects.map((object)=>{
                                                                    const checked = selectedUserScope.objectIds.includes(object.id);
                                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                style: {
                                                                                    textAlign: "center"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: checked,
                                                                                    disabled: !canEditRoleMatrix || objectScopeMutation.isPending,
                                                                                    onChange: (e)=>{
                                                                                        const nextObjectIds = e.target.checked ? Array.from(new Set([
                                                                                            ...selectedUserScope.objectIds,
                                                                                            object.id
                                                                                        ])) : selectedUserScope.objectIds.filter((id)=>id !== object.id);
                                                                                        setScopeMessage("");
                                                                                        setScopeError("");
                                                                                        setObjectScopeDraft({
                                                                                            ...effectiveObjectScope,
                                                                                            userAssignments: {
                                                                                                ...effectiveObjectScope.userAssignments,
                                                                                                [activeSelectedUserId]: {
                                                                                                    ...selectedUserScope,
                                                                                                    objectIds: nextObjectIds
                                                                                                }
                                                                                            }
                                                                                        });
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                children: object.objektnummer
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                children: object.objektname
                                                                            })
                                                                        ]
                                                                    }, `scope-object-${object.id}`);
                                                                }),
                                                                !pagedScopeObjects.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        colSpan: 3,
                                                                        children: "Keine Objekte gefunden."
                                                                    })
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "pagination",
                                                style: {
                                                    marginTop: 8,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    gap: 10
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        disabled: scopeObjectCurrentPage <= 1,
                                                        onClick: ()=>setScopeObjectPage((p)=>Math.max(1, p - 1)),
                                                        children: "Zur\xfcck"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        style: {
                                                            fontSize: 13
                                                        },
                                                        children: [
                                                            "Seite ",
                                                            scopeObjectCurrentPage,
                                                            " / ",
                                                            scopeObjectTotalPages
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        disabled: scopeObjectCurrentPage >= scopeObjectTotalPages,
                                                        onClick: ()=>setScopeObjectPage((p)=>Math.min(scopeObjectTotalPages, p + 1)),
                                                        children: "Weiter"
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-actions",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: !canEditRoleMatrix || !objectScopeDraft || objectScopeMutation.isPending,
                                                onClick: ()=>{
                                                    if (!objectScopeDraft) return;
                                                    objectScopeMutation.mutate(objectScopeDraft);
                                                },
                                                children: objectScopeMutation.isPending ? "Speichere..." : "Objektzuordnung speichern"
                                            }),
                                            scopeError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "error-text",
                                                children: scopeError
                                            }) : null,
                                            scopeMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: scopeMessage
                                            }) : null
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "admin-rights-user-override-note",
                        children: "Bitte zuerst einen Benutzer ausw\xe4hlen."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                open: Boolean(userDeleteConfirm),
                title: "Benutzer l\xf6schen",
                message: userDeleteConfirm ? `Soll der Benutzer "${userDeleteConfirm.label}" wirklich gel\xf6scht werden?` : "",
                code: userDeleteConfirm?.code ?? "0000",
                input: userDeleteConfirm?.input ?? [
                    "",
                    "",
                    "",
                    ""
                ],
                error: userDeleteConfirm?.error,
                isPending: deleteMutation.isPending,
                onClose: ()=>{
                    if (deleteMutation.isPending) return;
                    setUserDeleteConfirm(null);
                },
                onInputChange: (next)=>setUserDeleteConfirm((prev)=>prev ? {
                            ...prev,
                            input: next,
                            error: ""
                        } : prev),
                onErrorReset: ()=>setUserDeleteConfirm((prev)=>prev ? {
                            ...prev,
                            error: ""
                        } : prev),
                onConfirm: ()=>{
                    if (!userDeleteConfirm) return;
                    const entered = userDeleteConfirm.input.join("");
                    if (entered !== userDeleteConfirm.code) {
                        setUserDeleteConfirm((prev)=>prev ? {
                                ...prev,
                                error: "Sicherheitszahl stimmt nicht."
                            } : prev);
                        return;
                    }
                    deleteMutation.mutate(userDeleteConfirm.id);
                },
                confirmLabel: "Benutzer l\xf6schen",
                pendingLabel: "L\xf6sche Benutzer..."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04ee75005957cfa3$export$f820a1ce9bd6ce21), {
                open: Boolean(groupDeleteConfirm),
                title: "Benutzergruppe l\xf6schen",
                message: groupDeleteConfirm ? `Soll die Benutzergruppe "${groupDeleteConfirm.label}" wirklich gel\xf6scht werden?` : "",
                code: groupDeleteConfirm?.code ?? "0000",
                input: groupDeleteConfirm?.input ?? [
                    "",
                    "",
                    "",
                    ""
                ],
                error: groupDeleteConfirm?.error,
                onClose: ()=>setGroupDeleteConfirm(null),
                onInputChange: (next)=>setGroupDeleteConfirm((prev)=>prev ? {
                            ...prev,
                            input: next,
                            error: ""
                        } : prev),
                onErrorReset: ()=>setGroupDeleteConfirm((prev)=>prev ? {
                            ...prev,
                            error: ""
                        } : prev),
                onConfirm: ()=>{
                    if (!groupDeleteConfirm) return;
                    const entered = groupDeleteConfirm.input.join("");
                    if (entered !== groupDeleteConfirm.code) {
                        setGroupDeleteConfirm((prev)=>prev ? {
                                ...prev,
                                error: "Sicherheitszahl stimmt nicht."
                            } : prev);
                        return;
                    }
                    const nextGroups = effectiveGroupState.groups.filter((entry)=>entry.id !== groupDeleteConfirm.id);
                    const nextAssignments = Object.fromEntries(Object.entries(effectiveGroupState.userAssignments).map(([userId, assignment])=>[
                            userId,
                            {
                                ...assignment,
                                groupIds: assignment.groupIds.filter((id)=>id !== groupDeleteConfirm.id)
                            }
                        ]));
                    setGroupsMessage("");
                    setGroupsError("");
                    setGroupsDraft({
                        groups: nextGroups,
                        userAssignments: nextAssignments
                    });
                    setSelectedGroupId(nextGroups[0]?.id ?? "");
                    setGroupDeleteConfirm(null);
                },
                confirmLabel: "Benutzergruppe l\xf6schen"
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");






const $fab90a5e7e3c87fa$var$mapTenantToEditForm = (row)=>{
    const profile = row.profile;
    const startsAt = profile?.trial?.startsAt ? Date.parse(profile.trial.startsAt) : NaN;
    const endsAt = profile?.trial?.endsAt ? Date.parse(profile.trial.endsAt) : NaN;
    const computedTrialDays = Number.isFinite(startsAt) && Number.isFinite(endsAt) && endsAt > startsAt ? Math.max(1, Math.ceil((endsAt - startsAt) / 86400000)) : 14;
    return {
        name: row.name,
        status: row.status,
        legalForm: profile?.legalForm ?? "",
        website: profile?.website ?? "",
        contactEmail: profile?.contactEmail ?? "",
        contactPhone: profile?.contactPhone ?? "",
        addressStreet: profile?.address?.street ?? "",
        addressPostalCode: profile?.address?.postalCode ?? "",
        addressCity: profile?.address?.city ?? "",
        addressCountry: profile?.address?.country ?? "DE",
        contactSalutation: profile?.primaryContact?.salutation ?? "",
        contactTitle: profile?.primaryContact?.title ?? "",
        contactFirstName: profile?.primaryContact?.firstName ?? "",
        contactLastName: profile?.primaryContact?.lastName ?? "",
        contactPersonEmail: profile?.primaryContact?.email ?? "",
        contactPersonPhone: profile?.primaryContact?.phone ?? "",
        technicalTimezone: profile?.technical?.timezone ?? "Europe/Berlin",
        technicalLocale: profile?.technical?.locale ?? "de-DE",
        technicalCurrency: profile?.technical?.currency ?? "EUR",
        technicalUiFramework: profile?.technical?.uiFramework === "mockup_v2" ? "mockup_v2" : "classic",
        defaultStimmrechtsart: profile?.defaults?.stimmrechtsart ?? "kopf",
        defaultQuorum: profile?.defaults?.quorum ?? "allstimmig",
        defaultFaciliooEnabled: profile?.defaults?.faciliooEnabled ?? false,
        trialEnabled: Boolean(profile?.trial?.startsAt && profile?.trial?.endsAt),
        trialDays: computedTrialDays,
        adminUsername: row.primaryAdmin?.username ?? "",
        adminDisplayName: row.primaryAdmin?.displayName ?? "",
        adminPassword: ""
    };
};
const $fab90a5e7e3c87fa$var$formatDateTime = (value)=>{
    if (!value) return "-";
    const parsed = Date.parse(value);
    if (!Number.isFinite(parsed)) return "-";
    return new Intl.DateTimeFormat("de-DE", {
        timeZone: "Europe/Berlin",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    }).format(new Date(parsed));
};
const $fab90a5e7e3c87fa$var$renderTenantServiceStateBadge = (statusText)=>{
    if (statusText === "ok") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge aktiv",
        children: "aktiv"
    });
    if (statusText === "nicht_ok") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge inaktiv",
        style: {
            borderColor: "#dc2626",
            color: "#dc2626"
        },
        children: "st\xf6rung"
    });
    if (statusText === "nicht_konfiguriert") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge inaktiv",
        style: {
            borderColor: "#f59e0b",
            color: "#b45309"
        },
        children: "nicht konfiguriert"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge inaktiv",
        children: "inaktiv"
    });
};
const $fab90a5e7e3c87fa$var$billingTierLabel = (tier)=>{
    if (tier === "tier_a") return "1-500 Einheiten";
    if (tier === "tier_b") return "501-1000 Einheiten";
    if (tier === "tier_c") return "1001-2500 Einheiten";
    if (tier === "variable") return "ab 2501 variabel";
    return "-";
};
const $fab90a5e7e3c87fa$var$billingStatusBadge = (status)=>{
    const normalized = String(status ?? "not_started").trim().toLowerCase();
    if (normalized === "active" || normalized === "trialing") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge aktiv",
        children: normalized
    });
    if (normalized === "not_started" || normalized === "customer_created" || normalized === "checkout_created" || normalized === "snapshot_created") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge inaktiv",
        style: {
            borderColor: "#f59e0b",
            color: "#b45309"
        },
        children: normalized
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "badge inaktiv",
        children: normalized
    });
};
const $fab90a5e7e3c87fa$var$isSystemTenantSlug = (slug)=>{
    const value = String(slug || "").trim().toLowerCase();
    return value === "default" || value === "plattform" || value === "platform";
};
const $fab90a5e7e3c87fa$var$PasswordVisibilityIcon = ({ hidden: hidden })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3.2",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            hidden ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 4l16 16",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            }) : null
        ]
    });
const $fab90a5e7e3c87fa$var$MEMORY_RANGE_OPTIONS = [
    {
        key: "1m",
        label: "1 Min",
        minutes: 1
    },
    {
        key: "2m",
        label: "2 Min",
        minutes: 2
    },
    {
        key: "5m",
        label: "5 Min",
        minutes: 5
    },
    {
        key: "10m",
        label: "10 Min",
        minutes: 10
    },
    {
        key: "30m",
        label: "30 Min",
        minutes: 30
    },
    {
        key: "60m",
        label: "60 Min",
        minutes: 60
    },
    {
        key: "1d",
        label: "1 Tag",
        minutes: 1440
    }
];
const $fab90a5e7e3c87fa$var$MEMORY_RANGE_STORAGE_KEY = "platform_ram_debug_range";
const $fab90a5e7e3c87fa$var$MEMORY_DEBUG_ENABLED_STORAGE_KEY = "platform_ram_debug_enabled";
const $fab90a5e7e3c87fa$var$resolveMemoryRefetchIntervalMs = (rangeKey)=>{
    if (rangeKey === "1m") return 5000;
    if (rangeKey === "2m") return 10000;
    if (rangeKey === "5m") return 15000;
    if (rangeKey === "10m") return 20000;
    if (rangeKey === "30m") return 30000;
    if (rangeKey === "60m") return 60000;
    return 300000;
};
const $fab90a5e7e3c87fa$var$emptyTenantFaciliooDebugState = {
    tenantSlug: "",
    debugModeEnabled: false,
    debugModeExpiresAt: "",
    deepProbeEnabled: false,
    deepProbeExpiresAt: ""
};
const $fab90a5e7e3c87fa$export$67ded7da315e2d87 = ()=>{
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [createOpen, setCreateOpen] = (0, $acw62.useState)(false);
    const [createError, setCreateError] = (0, $acw62.useState)("");
    const [createInfo, setCreateInfo] = (0, $acw62.useState)("");
    const [editError, setEditError] = (0, $acw62.useState)("");
    const [editInfo, setEditInfo] = (0, $acw62.useState)("");
    const [editFaciliooDebugError, setEditFaciliooDebugError] = (0, $acw62.useState)("");
    const [editFaciliooDebugInfo, setEditFaciliooDebugInfo] = (0, $acw62.useState)("");
    const [editingSlug, setEditingSlug] = (0, $acw62.useState)(null);
    const [editFaciliooDebug, setEditFaciliooDebug] = (0, $acw62.useState)($fab90a5e7e3c87fa$var$emptyTenantFaciliooDebugState);
    const [editFaciliooDebugLoading, setEditFaciliooDebugLoading] = (0, $acw62.useState)(false);
    const [editForm, setEditForm] = (0, $acw62.useState)({
        name: "",
        status: "aktiv",
        legalForm: "",
        website: "",
        contactEmail: "",
        contactPhone: "",
        addressStreet: "",
        addressPostalCode: "",
        addressCity: "",
        addressCountry: "DE",
        contactSalutation: "",
        contactTitle: "",
        contactFirstName: "",
        contactLastName: "",
        contactPersonEmail: "",
        contactPersonPhone: "",
        technicalTimezone: "Europe/Berlin",
        technicalLocale: "de-DE",
        technicalCurrency: "EUR",
        technicalUiFramework: "classic",
        defaultStimmrechtsart: "kopf",
        defaultQuorum: "allstimmig",
        defaultFaciliooEnabled: false,
        trialEnabled: false,
        trialDays: 14,
        adminUsername: "",
        adminDisplayName: "",
        adminPassword: ""
    });
    const [lastAccessUrl, setLastAccessUrl] = (0, $acw62.useState)("");
    const [showAdminPassword, setShowAdminPassword] = (0, $acw62.useState)(false);
    const [showEditAdminPassword, setShowEditAdminPassword] = (0, $acw62.useState)(false);
    const [serviceActionInfo, setServiceActionInfo] = (0, $acw62.useState)("");
    const [serviceActionError, setServiceActionError] = (0, $acw62.useState)("");
    const [tenantProvisioningInfo, setTenantProvisioningInfo] = (0, $acw62.useState)("");
    const [tenantProvisioningError, setTenantProvisioningError] = (0, $acw62.useState)("");
    const [openActionMenuId, setOpenActionMenuId] = (0, $acw62.useState)(null);
    const [actionMenuPosition, setActionMenuPosition] = (0, $acw62.useState)(null);
    const [isActionMenuHovered, setIsActionMenuHovered] = (0, $acw62.useState)(false);
    const [memoryRange, setMemoryRange] = (0, $acw62.useState)(()=>{
        if (typeof window === "undefined") return "10m";
        const raw = window.localStorage.getItem($fab90a5e7e3c87fa$var$MEMORY_RANGE_STORAGE_KEY);
        const allowed = new Set($fab90a5e7e3c87fa$var$MEMORY_RANGE_OPTIONS.map((entry)=>entry.key));
        return raw && allowed.has(raw) ? raw : "10m";
    });
    const [memoryDebugEnabled, setMemoryDebugEnabled] = (0, $acw62.useState)(()=>{
        if (typeof window === "undefined") return true;
        const raw = String(window.localStorage.getItem($fab90a5e7e3c87fa$var$MEMORY_DEBUG_ENABLED_STORAGE_KEY) ?? "").trim().toLowerCase();
        return ![
            "0",
            "false",
            "no",
            "off"
        ].includes(raw);
    });
    const [memoryHoverIndex, setMemoryHoverIndex] = (0, $acw62.useState)(null);
    const [form, setForm] = (0, $acw62.useState)({
        slug: "",
        name: "",
        legalForm: "",
        website: "",
        contactEmail: "",
        contactPhone: "",
        addressStreet: "",
        addressPostalCode: "",
        addressCity: "",
        addressCountry: "DE",
        contactSalutation: "",
        contactTitle: "",
        contactFirstName: "",
        contactLastName: "",
        contactPersonEmail: "",
        contactPersonPhone: "",
        technicalTimezone: "Europe/Berlin",
        technicalLocale: "de-DE",
        technicalCurrency: "EUR",
        technicalUiFramework: "classic",
        defaultStimmrechtsart: "kopf",
        defaultQuorum: "allstimmig",
        defaultFaciliooEnabled: false,
        trialEnabled: false,
        trialDays: 14,
        adminUsername: "",
        adminDisplayName: "",
        adminPassword: ""
    });
    const memoryHistoryMinutesForFetch = (0, $acw62.useMemo)(()=>$fab90a5e7e3c87fa$var$MEMORY_RANGE_OPTIONS.find((option)=>option.key === memoryRange)?.minutes ?? 10, [
        memoryRange
    ]);
    const { data: data, isLoading: isLoading, isError: isError, error: error } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "tenants"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).tenants()
    });
    const { data: servicesStatus, isLoading: servicesLoading, isError: servicesIsError, error: servicesError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "platform-services-status",
            memoryDebugEnabled ? "memory-on" : "memory-off",
            memoryRange,
            memoryHistoryMinutesForFetch
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).getPlatformServicesStatus({
                includeMemoryDebug: memoryDebugEnabled,
                historyMinutes: memoryHistoryMinutesForFetch
            }),
        refetchInterval: memoryDebugEnabled ? $fab90a5e7e3c87fa$var$resolveMemoryRefetchIntervalMs(memoryRange) : false,
        refetchIntervalInBackground: false
    });
    const { data: billingStatus, isLoading: billingLoading, isError: billingIsError, error: billingError } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "tenant-billing",
            editingSlug
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).getTenantBilling(editingSlug || ""),
        enabled: Boolean(editingSlug)
    });
    const checkServiceMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (service)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).checkPlatformServiceStatus(service),
        onSuccess: async (result)=>{
            setServiceActionError("");
            setServiceActionInfo(`Dienst gepr\xfcft: ${result.service.service} (${result.service.statusText})`);
            await queryClient.invalidateQueries({
                queryKey: [
                    "platform-services-status"
                ]
            });
        },
        onError: (err)=>{
            const message = err instanceof Error ? err.message : "Dienstpr\xfcfung fehlgeschlagen.";
            setServiceActionInfo("");
            setServiceActionError(message);
        }
    });
    const notifyServiceMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ service: service })=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).notifyPlatformServiceStatus(service),
        onSuccess: (result)=>{
            setServiceActionError("");
            const skippedMissingEmail = result.skipped.filter((row)=>row.reason === "missing_or_invalid_email").length;
            setServiceActionInfo(`St\xf6rungsmeldung gesendet (${result.sentCount} Empf\xe4nger, Dienst: ${result.service.service})${skippedMissingEmail > 0 ? ` | ohne g\xfcltige Benutzer-E-Mail: ${skippedMissingEmail}` : ""}.`);
        },
        onError: (err)=>{
            const message = err instanceof Error ? err.message : "Benachrichtigung fehlgeschlagen.";
            setServiceActionInfo("");
            setServiceActionError(message);
        }
    });
    const createMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).createTenant({
                slug: form.slug.trim(),
                name: form.name.trim(),
                onboarding: {
                    legalForm: form.legalForm.trim() || undefined,
                    website: form.website.trim() || undefined,
                    contactEmail: form.contactEmail.trim(),
                    contactPhone: form.contactPhone.trim() || undefined,
                    address: form.addressStreet.trim() || form.addressPostalCode.trim() || form.addressCity.trim() || form.addressCountry.trim() ? {
                        street: form.addressStreet.trim() || undefined,
                        postalCode: form.addressPostalCode.trim() || undefined,
                        city: form.addressCity.trim() || undefined,
                        country: form.addressCountry.trim() || undefined
                    } : undefined,
                    primaryContact: form.contactSalutation.trim() || form.contactTitle.trim() || form.contactFirstName.trim() || form.contactLastName.trim() || form.contactPersonEmail.trim() || form.contactPersonPhone.trim() ? {
                        salutation: form.contactSalutation.trim() || undefined,
                        title: form.contactTitle.trim() || undefined,
                        firstName: form.contactFirstName.trim() || undefined,
                        lastName: form.contactLastName.trim() || undefined,
                        email: form.contactPersonEmail.trim() || undefined,
                        phone: form.contactPersonPhone.trim() || undefined
                    } : undefined,
                    technical: {
                        timezone: form.technicalTimezone.trim() || "Europe/Berlin",
                        locale: form.technicalLocale.trim() || "de-DE",
                        currency: form.technicalCurrency.trim() || "EUR",
                        uiFramework: form.technicalUiFramework
                    },
                    defaults: {
                        faciliooEnabled: form.defaultFaciliooEnabled,
                        stimmrechtsart: form.defaultStimmrechtsart,
                        quorum: form.defaultQuorum
                    },
                    trialDays: form.trialEnabled ? form.trialDays : undefined
                },
                admin: {
                    username: form.adminUsername.trim(),
                    displayName: form.adminDisplayName.trim(),
                    password: form.adminPassword
                }
            }),
        onSuccess: async (result)=>{
            setCreateError("");
            setCreateInfo(result.provisioning?.message ?? "");
            setLastAccessUrl(result.accessUrl ?? "");
            setForm({
                slug: "",
                name: "",
                legalForm: "",
                website: "",
                contactEmail: "",
                contactPhone: "",
                addressStreet: "",
                addressPostalCode: "",
                addressCity: "",
                addressCountry: "DE",
                contactSalutation: "",
                contactTitle: "",
                contactFirstName: "",
                contactLastName: "",
                contactPersonEmail: "",
                contactPersonPhone: "",
                technicalTimezone: "Europe/Berlin",
                technicalLocale: "de-DE",
                technicalCurrency: "EUR",
                technicalUiFramework: "classic",
                defaultStimmrechtsart: "kopf",
                defaultQuorum: "allstimmig",
                defaultFaciliooEnabled: false,
                trialEnabled: false,
                trialDays: 14,
                adminUsername: "",
                adminDisplayName: "",
                adminPassword: ""
            });
            setCreateOpen(false);
            await queryClient.invalidateQueries({
                queryKey: [
                    "tenants"
                ]
            });
        },
        onError: (err)=>setCreateError(err instanceof Error ? err.message : "Mandant konnte nicht angelegt werden")
    });
    const updateMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (payload)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateTenant(payload.slug, {
                name: payload.form.name.trim(),
                status: payload.form.status,
                admin: {
                    username: payload.form.adminUsername.trim(),
                    displayName: payload.form.adminDisplayName.trim(),
                    ...payload.form.adminPassword.trim() ? {
                        password: payload.form.adminPassword.trim()
                    } : {}
                },
                onboarding: {
                    legalForm: payload.form.legalForm.trim() || undefined,
                    website: payload.form.website.trim() || undefined,
                    contactEmail: payload.form.contactEmail.trim() || undefined,
                    contactPhone: payload.form.contactPhone.trim() || undefined,
                    address: payload.form.addressStreet.trim() || payload.form.addressPostalCode.trim() || payload.form.addressCity.trim() || payload.form.addressCountry.trim() ? {
                        street: payload.form.addressStreet.trim() || undefined,
                        postalCode: payload.form.addressPostalCode.trim() || undefined,
                        city: payload.form.addressCity.trim() || undefined,
                        country: payload.form.addressCountry.trim() || undefined
                    } : undefined,
                    primaryContact: payload.form.contactSalutation.trim() || payload.form.contactTitle.trim() || payload.form.contactFirstName.trim() || payload.form.contactLastName.trim() || payload.form.contactPersonEmail.trim() || payload.form.contactPersonPhone.trim() ? {
                        salutation: payload.form.contactSalutation.trim() || undefined,
                        title: payload.form.contactTitle.trim() || undefined,
                        firstName: payload.form.contactFirstName.trim() || undefined,
                        lastName: payload.form.contactLastName.trim() || undefined,
                        email: payload.form.contactPersonEmail.trim() || undefined,
                        phone: payload.form.contactPersonPhone.trim() || undefined
                    } : undefined,
                    technical: {
                        timezone: payload.form.technicalTimezone.trim() || "Europe/Berlin",
                        locale: payload.form.technicalLocale.trim() || "de-DE",
                        currency: payload.form.technicalCurrency.trim() || "EUR",
                        uiFramework: payload.form.technicalUiFramework
                    },
                    defaults: {
                        faciliooEnabled: payload.form.defaultFaciliooEnabled,
                        stimmrechtsart: payload.form.defaultStimmrechtsart,
                        quorum: payload.form.defaultQuorum
                    },
                    trialDays: payload.form.trialEnabled ? payload.form.trialDays : null
                }
            }),
        onSuccess: async ()=>{
            setEditError("");
            setEditInfo("Mandant wurde aktualisiert.");
            setEditingSlug(null);
            setShowEditAdminPassword(false);
            await queryClient.invalidateQueries({
                queryKey: [
                    "tenants"
                ]
            });
        },
        onError: (err)=>setEditError(err instanceof Error ? err.message : "Mandant konnte nicht aktualisiert werden")
    });
    (0, $acw62.useEffect)(()=>{
        if (!editingSlug) {
            setEditFaciliooDebug($fab90a5e7e3c87fa$var$emptyTenantFaciliooDebugState);
            setEditFaciliooDebugLoading(false);
            setEditFaciliooDebugError("");
            setEditFaciliooDebugInfo("");
            return;
        }
        let cancelled = false;
        const loadFaciliooDebugState = async ()=>{
            setEditFaciliooDebugLoading(true);
            setEditFaciliooDebugError("");
            try {
                const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getTenantFaciliooDebug(editingSlug);
                if (cancelled) return;
                setEditFaciliooDebug(result);
            } catch (error) {
                if (cancelled) return;
                setEditFaciliooDebug($fab90a5e7e3c87fa$var$emptyTenantFaciliooDebugState);
                setEditFaciliooDebugError(error instanceof Error ? error.message : "Facilioo-Debugstatus konnte nicht geladen werden.");
            } finally{
                if (!cancelled) setEditFaciliooDebugLoading(false);
            }
        };
        loadFaciliooDebugState();
        return ()=>{
            cancelled = true;
        };
    }, [
        editingSlug
    ]);
    const updateFaciliooDebugMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (payload)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateTenantFaciliooDebug(payload.slug, {
                debugModeEnabled: payload.debugModeEnabled,
                deepProbeEnabled: payload.deepProbeEnabled
            }),
        onSuccess: (result)=>{
            setEditFaciliooDebug(result);
            setEditFaciliooDebugError("");
            setEditFaciliooDebugInfo("Facilioo-Debugsteuerung wurde aktualisiert (24h).");
        },
        onError: (error)=>{
            setEditFaciliooDebugInfo("");
            setEditFaciliooDebugError(error instanceof Error ? error.message : "Facilioo-Debugsteuerung konnte nicht gespeichert werden.");
        }
    });
    const checkoutBillingMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (slug)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).createTenantBillingCheckout(slug),
        onSuccess: async (result)=>{
            setEditError("");
            setEditInfo("Stripe Checkout wurde erstellt.");
            await queryClient.invalidateQueries({
                queryKey: [
                    "tenant-billing",
                    editingSlug
                ]
            });
            if (result.url) window.location.assign(result.url);
        },
        onError: (error)=>{
            setEditInfo("");
            setEditError(error instanceof Error ? error.message : "Stripe Checkout konnte nicht erstellt werden.");
        }
    });
    const portalBillingMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (slug)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).createTenantBillingPortal(slug),
        onSuccess: (result)=>{
            setEditError("");
            setEditInfo("Stripe Portal wurde ge\xf6ffnet.");
            window.open(result.url, "_blank", "noopener,noreferrer");
        },
        onError: (error)=>{
            setEditInfo("");
            setEditError(error instanceof Error ? error.message : "Stripe Portal konnte nicht ge\xf6ffnet werden.");
        }
    });
    const syncBillingMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (slug)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).syncTenantBilling(slug),
        onSuccess: async ()=>{
            setEditError("");
            setEditInfo("Billing-Snapshot wurde synchronisiert.");
            await queryClient.invalidateQueries({
                queryKey: [
                    "tenant-billing",
                    editingSlug
                ]
            });
        },
        onError: (error)=>{
            setEditInfo("");
            setEditError(error instanceof Error ? error.message : "Billing-Sync fehlgeschlagen.");
        }
    });
    const retryProvisioningMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (slug)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).retryTenantProvisioning(slug),
        onMutate: (slug)=>{
            setTenantProvisioningError("");
            setTenantProvisioningInfo(`Provisioning fuer ${slug} laeuft...`);
        },
        onSuccess: async (result)=>{
            setTenantProvisioningError("");
            setTenantProvisioningInfo(`Provisioning fuer ${result.tenant.slug}: ${result.provisioning.message} Livecheck: ${result.tenant.liveStatus?.details ?? "noch nicht geprueft"}`);
            await queryClient.invalidateQueries({
                queryKey: [
                    "tenants"
                ]
            });
        },
        onError: (error)=>{
            setTenantProvisioningInfo("");
            setTenantProvisioningError(error instanceof Error ? error.message : "Provisioning konnte nicht erneut gestartet werden.");
        }
    });
    const deleteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (slug)=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).deleteTenant(slug),
        onSuccess: async ()=>{
            setEditError("");
            setEditInfo("Mandant wurde geloescht.");
            if (editingSlug) setEditingSlug(null);
            await queryClient.invalidateQueries({
                queryKey: [
                    "tenants"
                ]
            });
        },
        onError: (err)=>setEditError(err instanceof Error ? err.message : "Mandant konnte nicht geloescht werden")
    });
    const isFrameworkV2 = typeof document !== "undefined" && document.body.classList.contains("framework-v2");
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = (event)=>{
            if (event && (0, $acf0971746b2c487$export$e623be24f54873a1)(event.target)) return;
            setOpenActionMenuId(null);
        };
        const handleEscape = (event)=>{
            if (event.key === "Escape") closeMenu();
        };
        window.addEventListener("mousedown", closeMenu);
        window.addEventListener("keydown", handleEscape);
        return ()=>{
            window.removeEventListener("mousedown", closeMenu);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) return;
        const closeMenu = ()=>setOpenActionMenuId(null);
        window.addEventListener("resize", closeMenu);
        window.addEventListener("scroll", closeMenu, true);
        return ()=>{
            window.removeEventListener("resize", closeMenu);
            window.removeEventListener("scroll", closeMenu, true);
        };
    }, [
        openActionMenuId
    ]);
    (0, $acf0971746b2c487$export$ee4849fd8b850061)({
        isOpen: !!openActionMenuId,
        isHovered: isActionMenuHovered,
        closeMenu: ()=>setOpenActionMenuId(null),
        timeoutMs: 3000
    });
    (0, $acw62.useEffect)(()=>{
        if (!openActionMenuId) {
            setActionMenuPosition(null);
            setIsActionMenuHovered(false);
        }
    }, [
        openActionMenuId
    ]);
    const openActionMenuAtTrigger = (menuId, trigger)=>{
        const rect = trigger.getBoundingClientRect();
        const menuWidth = 170;
        const menuHeight = 96;
        const margin = 8;
        const left = Math.min(Math.max(margin, rect.right - menuWidth), Math.max(margin, window.innerWidth - menuWidth - margin));
        const belowTop = rect.bottom + 6;
        const aboveTop = rect.top - menuHeight - 6;
        const top = belowTop + menuHeight <= window.innerHeight - margin ? belowTop : Math.max(margin, aboveTop);
        setActionMenuPosition({
            left: left,
            top: top
        });
        setOpenActionMenuId(menuId);
    };
    const openTenantEditForm = (row)=>{
        setEditError("");
        setEditInfo("");
        setEditFaciliooDebugError("");
        setEditFaciliooDebugInfo("");
        setShowEditAdminPassword(false);
        setEditingSlug(row.slug);
        setEditForm($fab90a5e7e3c87fa$var$mapTenantToEditForm(row));
    };
    const deleteTenantWithConfirmation = (row)=>{
        if (row.slug === "default" || $fab90a5e7e3c87fa$var$isSystemTenantSlug(row.slug)) return;
        const ok = window.confirm(`Mandant '${row.name}' (${row.slug}) wirklich loeschen? Dieser Vorgang entfernt auch alle zugehoerigen Daten.`);
        if (!ok) return;
        deleteMutation.mutate(row.slug);
    };
    const columns = (0, $acw62.useMemo)(()=>[
            {
                key: "slug",
                label: "Slug"
            },
            {
                key: "name",
                label: "Mandant"
            },
            {
                key: "contactEmail",
                label: "Kontakt",
                render: (r)=>r.profile?.contactEmail ?? "-"
            },
            {
                key: "status",
                label: "Status",
                render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `badge ${r.status === "aktiv" ? "aktiv" : "inaktiv"}`,
                        children: r.status
                    })
            },
            {
                key: "trial",
                label: "Demozeitraum",
                render: (r)=>{
                    if (!r.trial?.enabled) return "-";
                    if (r.trial.expired) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge inaktiv",
                        children: "abgelaufen"
                    });
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge aktiv",
                        children: `aktiv (${r.trial.remainingDays ?? 0} Tage)`
                    });
                }
            },
            {
                key: "liveStatus",
                label: "Live-Status",
                render: (r)=>{
                    const ls = r.liveStatus;
                    if (!ls) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge inaktiv",
                        children: "unbekannt"
                    });
                    if (ls.live) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge aktiv",
                        title: ls.details,
                        children: "live"
                    });
                    const partial = ls.dnsOk || ls.tlsOk || ls.httpOk;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge inaktiv",
                        style: partial ? {
                            borderColor: "#f59e0b",
                            color: "#b45309"
                        } : undefined,
                        title: ls.details,
                        children: partial ? "teilweise" : "offline"
                    });
                }
            },
            {
                key: "checks",
                label: "Checks",
                render: (r)=>{
                    const ls = r.liveStatus;
                    if (!ls) return "-";
                    return `DNS ${ls.dnsOk ? "ok" : "x"} | TLS ${ls.tlsOk ? "ok" : "x"} | HTTP ${ls.httpOk ? "ok" : "x"}`;
                }
            },
            {
                key: "webhookService",
                label: "Webhook-Verarbeitung",
                render: (r)=>{
                    const ws = r.webhookService;
                    if (!ws) return "-";
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: $fab90a5e7e3c87fa$var$renderTenantServiceStateBadge(ws.statusText)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                style: {
                                    color: "var(--text-soft)"
                                },
                                children: `Q:${ws.queueQueued} | P:${ws.queueProcessing} | Done:${ws.queueProcessed}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                style: {
                                    color: "var(--text-soft)"
                                },
                                children: `Letzter Done: ${$fab90a5e7e3c87fa$var$formatDateTime(ws.lastProcessedAt ?? undefined)}`
                            })
                        ]
                    });
                }
            },
            {
                key: "faciliooLiveSyncService",
                label: "Facilioo Live-Sync",
                render: (r)=>{
                    const ls = r.faciliooLiveSyncService;
                    if (!ls) return "-";
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: $fab90a5e7e3c87fa$var$renderTenantServiceStateBadge(ls.statusText)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                style: {
                                    color: "var(--text-soft)"
                                },
                                children: "Intervall: taeglich 02:00"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                style: {
                                    color: "var(--text-soft)"
                                },
                                children: `Letzter Lauf: ${$fab90a5e7e3c87fa$var$formatDateTime(ls.lastFinishedAt ?? undefined)}`
                            })
                        ]
                    });
                }
            },
            {
                key: "createdAt",
                label: "Angelegt",
                render: (r)=>$fab90a5e7e3c87fa$var$formatDateTime(r.createdAt)
            },
            {
                key: "onlineNow",
                label: "Online jetzt",
                width: 140,
                render: (r)=>{
                    const users = r.onlineUsers ?? 0;
                    const sessions = r.onlineSessions ?? 0;
                    if (users <= 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge inaktiv",
                        style: {
                            whiteSpace: "nowrap"
                        },
                        children: "offline"
                    });
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "badge aktiv",
                        style: {
                            whiteSpace: "nowrap"
                        },
                        title: `${sessions} aktive Session${sessions === 1 ? "" : "s"}`,
                        children: `online (${users})`
                    });
                }
            },
            {
                key: "lastLoginAt",
                label: "Letzter Login",
                render: (r)=>$fab90a5e7e3c87fa$var$formatDateTime(r.lastLoginAt)
            },
            {
                key: "actions",
                label: "Aktionen",
                render: (r)=>{
                    const provisioningPendingForRow = retryProvisioningMutation.isPending && retryProvisioningMutation.variables === r.slug;
                    if (!isFrameworkV2) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>openTenantEditForm(r),
                                children: "Bearbeiten"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                disabled: r.slug === "default" || $fab90a5e7e3c87fa$var$isSystemTenantSlug(r.slug) || retryProvisioningMutation.isPending,
                                onClick: ()=>retryProvisioningMutation.mutate(r.slug),
                                children: provisioningPendingForRow ? "Provisioning laeuft..." : "Provisioning erneut starten"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                disabled: r.slug === "default" || $fab90a5e7e3c87fa$var$isSystemTenantSlug(r.slug) || deleteMutation.isPending,
                                onClick: ()=>deleteTenantWithConfirmation(r),
                                children: "Loeschen"
                            })
                        ]
                    });
                    const menuId = `tenant:${r.slug}`;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "resolutions-v2-action-wrap platform-v2-action-wrap",
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "resolutions-v2-action-trigger",
                                "aria-label": `Aktionen fuer ${r.name}`,
                                "aria-expanded": openActionMenuId === menuId,
                                onMouseDown: (e)=>e.stopPropagation(),
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    if (openActionMenuId === menuId) {
                                        setOpenActionMenuId(null);
                                        return;
                                    }
                                    openActionMenuAtTrigger(menuId, e.currentTarget);
                                },
                                children: "\u22EE"
                            }),
                            openActionMenuId === menuId && actionMenuPosition && typeof document !== "undefined" ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "resolutions-v2-action-menu resolutions-v2-action-menu--fixed",
                                style: {
                                    left: actionMenuPosition.left,
                                    top: actionMenuPosition.top
                                },
                                onMouseDown: (e)=>e.stopPropagation(),
                                onMouseEnter: ()=>setIsActionMenuHovered(true),
                                onMouseLeave: ()=>setIsActionMenuHovered(false),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            openTenantEditForm(r);
                                            setOpenActionMenuId(null);
                                        },
                                        children: "Bearbeiten"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: r.slug === "default" || $fab90a5e7e3c87fa$var$isSystemTenantSlug(r.slug) || retryProvisioningMutation.isPending,
                                        onClick: ()=>{
                                            retryProvisioningMutation.mutate(r.slug);
                                            setOpenActionMenuId(null);
                                        },
                                        children: provisioningPendingForRow ? "Provisioning laeuft..." : "Provisioning erneut starten"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: r.slug === "default" || $fab90a5e7e3c87fa$var$isSystemTenantSlug(r.slug) || deleteMutation.isPending,
                                        onClick: ()=>{
                                            deleteTenantWithConfirmation(r);
                                            setOpenActionMenuId(null);
                                        },
                                        children: "Loeschen"
                                    })
                                ]
                            }), document.body) : null
                        ]
                    });
                }
            }
        ], [
        actionMenuPosition,
        deleteMutation.isPending,
        isFrameworkV2,
        openActionMenuId,
        retryProvisioningMutation.isPending
    ]);
    const systemColumns = (0, $acw62.useMemo)(()=>columns.filter((col)=>col.key !== "webhookService" && col.key !== "faciliooLiveSyncService"), [
        columns
    ]);
    const canCreate = form.slug.trim().length >= 3 && form.name.trim().length > 0 && /\S+@\S+\.\S+/.test(form.contactEmail.trim()) && form.adminUsername.trim().length >= 3 && form.adminDisplayName.trim().length > 0 && form.adminPassword.trim().length >= 8;
    const allTenants = data?.data ?? [];
    const systemRows = (0, $acw62.useMemo)(()=>allTenants.filter((row)=>$fab90a5e7e3c87fa$var$isSystemTenantSlug(row.slug)), [
        allTenants
    ]);
    const tenantRows = (0, $acw62.useMemo)(()=>allTenants.filter((row)=>!$fab90a5e7e3c87fa$var$isSystemTenantSlug(row.slug)), [
        allTenants
    ]);
    (0, $acw62.useEffect)(()=>{
        const billingTenant = String(searchParams.get("billingTenant") ?? "").trim().toLowerCase();
        const billingReturn = String(searchParams.get("billingReturn") ?? "").trim().toLowerCase();
        if (!billingTenant || allTenants.length === 0) return;
        const tenant = allTenants.find((row)=>row.slug === billingTenant);
        if (!tenant) return;
        setCreateOpen(false);
        setEditingSlug(tenant.slug);
        setShowEditAdminPassword(false);
        setEditForm($fab90a5e7e3c87fa$var$mapTenantToEditForm(tenant));
        setEditError("");
        setEditInfo(billingReturn === "success" ? "Stripe Checkout abgeschlossen. Bitte Billing neu synchronisieren." : "Stripe Checkout abgebrochen.");
        const next = new URLSearchParams(searchParams);
        next.delete("billingTenant");
        next.delete("billingReturn");
        setSearchParams(next, {
            replace: true
        });
    }, [
        allTenants,
        searchParams,
        setSearchParams
    ]);
    const resolveServiceLabel = (key)=>key === "facilioo_live_sync" ? "Facilioo Live-Sync" : key === "generated_dispatch_auto_retry" ? "Versand-Retry" : key === "dispatch_deadline_scheduler" ? "Fristen-/Dispatch-Scheduler" : key === "platform_health_monitor" ? "Health-Monitor" : key;
    const formatServiceInterval = (intervalMs)=>{
        if (!intervalMs || intervalMs <= 0) return "-";
        if (intervalMs % 60000 === 0) return `${Math.round(intervalMs / 60000)} min`;
        if (intervalMs % 1000 === 0) return `${Math.round(intervalMs / 1000)} s`;
        return `${intervalMs} ms`;
    };
    const formatServiceCheckedAt = (value)=>{
        if (!value) return "-";
        const parsed = Date.parse(value);
        if (!Number.isFinite(parsed)) return "-";
        return new Intl.DateTimeFormat("de-DE", {
            timeZone: "Europe/Berlin",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date(parsed));
    };
    const formatMemoryMb = (value)=>{
        if (!Number.isFinite(Number(value))) return "-";
        return `${Number(value).toLocaleString("de-DE", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        })} MB`;
    };
    const formatUptime = (value)=>{
        const totalSeconds = Math.max(0, Math.floor(Number(value) || 0));
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor(totalSeconds % 3600 / 60);
        const seconds = totalSeconds % 60;
        if (hours > 0) return `${hours} h ${minutes} min`;
        if (minutes > 0) return `${minutes} min ${seconds} s`;
        return `${seconds} s`;
    };
    const memoryDebug = servicesStatus?.memoryDebug;
    const memoryHistoryAll = memoryDebug?.history ?? [];
    const selectedMemoryRange = $fab90a5e7e3c87fa$var$MEMORY_RANGE_OPTIONS.find((option)=>option.key === memoryRange) ?? $fab90a5e7e3c87fa$var$MEMORY_RANGE_OPTIONS[2];
    const memoryWindowMs = selectedMemoryRange.minutes * 60000;
    const memoryWindowStartMs = Date.now() - memoryWindowMs;
    const memoryHistory = memoryHistoryAll.filter((row)=>{
        const capturedAtMs = Date.parse(String(row?.capturedAt ?? ""));
        return Number.isFinite(capturedAtMs) && capturedAtMs >= memoryWindowStartMs;
    });
    const memoryHistoryForChart = memoryHistory.length >= 2 ? memoryHistory : memoryHistoryAll;
    const memoryChartWidth = 920;
    const memoryChartHeight = 166;
    const memoryChartPadding = {
        top: 12,
        right: 14,
        bottom: 24,
        left: 14
    };
    const memoryChartInnerWidth = memoryChartWidth - memoryChartPadding.left - memoryChartPadding.right;
    const memoryChartInnerHeight = memoryChartHeight - memoryChartPadding.top - memoryChartPadding.bottom;
    const memoryRssSeries = memoryHistoryForChart.map((row)=>Number(row.rssMb || 0));
    const memoryHeapSeries = memoryHistoryForChart.map((row)=>Number(row.heapUsedMb || 0));
    const cpuSeries = memoryHistoryForChart.map((row)=>Number(row.cpuPercent || 0));
    const memoryCapacityForChart = Math.max(1, Number(memoryDebug?.thresholdConfig?.capacityMb ?? 0), Number(memoryDebug?.systemMemoryMb?.total ?? 0));
    const memoryChartYMax = Math.max(1, memoryCapacityForChart, ...memoryRssSeries.length > 0 ? memoryRssSeries : [
        1
    ], ...memoryHeapSeries.length > 0 ? memoryHeapSeries : [
        1
    ], Number(memoryDebug?.thresholdMb.warn ?? 0), Number(memoryDebug?.thresholdMb.critical ?? 0));
    const memoryXByIndex = (index)=>{
        if (memoryHistoryForChart.length <= 1) return memoryChartPadding.left;
        const ratio = index / (memoryHistoryForChart.length - 1);
        return memoryChartPadding.left + ratio * memoryChartInnerWidth;
    };
    const memoryYByValue = (value)=>memoryChartPadding.top + (memoryChartYMax - Math.max(0, value)) / memoryChartYMax * memoryChartInnerHeight;
    const buildMemoryLinePoints = (values)=>values.map((value, index)=>`${memoryXByIndex(index)},${memoryYByValue(value)}`).join(" ");
    const buildMemoryAreaPath = (values)=>{
        if (values.length < 2) return "";
        const firstX = memoryXByIndex(0);
        const lastX = memoryXByIndex(values.length - 1);
        const baselineY = memoryChartPadding.top + memoryChartInnerHeight;
        const segments = values.map((value, index)=>`${memoryXByIndex(index)} ${memoryYByValue(value)}`).join(" L ");
        return `M ${firstX} ${baselineY} L ${segments} L ${lastX} ${baselineY} Z`;
    };
    const memoryRssPoints = memoryHistoryForChart.length >= 2 ? buildMemoryLinePoints(memoryRssSeries) : "";
    const memoryHeapPoints = memoryHistoryForChart.length >= 2 ? buildMemoryLinePoints(memoryHeapSeries) : "";
    const memoryRssAreaPath = memoryHistoryForChart.length >= 2 ? buildMemoryAreaPath(memoryRssSeries) : "";
    const memoryHeapAreaPath = memoryHistoryForChart.length >= 2 ? buildMemoryAreaPath(memoryHeapSeries) : "";
    const memoryWarnY = memoryDebug ? memoryYByValue(Number(memoryDebug.thresholdMb.warn ?? 0)) : 0;
    const memoryCriticalY = memoryDebug ? memoryYByValue(Number(memoryDebug.thresholdMb.critical ?? 0)) : 0;
    const memoryGridHorizontalCount = 6;
    const memoryGridVerticalCount = 12;
    const memoryGridHorizontalY = Array.from({
        length: memoryGridHorizontalCount + 1
    }, (_entry, idx)=>{
        const ratio = idx / memoryGridHorizontalCount;
        return memoryChartPadding.top + ratio * memoryChartInnerHeight;
    });
    const memoryGridVerticalX = Array.from({
        length: memoryGridVerticalCount + 1
    }, (_entry, idx)=>{
        const ratio = idx / memoryGridVerticalCount;
        return memoryChartPadding.left + ratio * memoryChartInnerWidth;
    });
    const memoryYAxisTicks = Array.from({
        length: 5
    }, (_entry, idx)=>{
        const ratio = idx / 4;
        const value = memoryChartYMax * (1 - ratio);
        return {
            y: memoryChartPadding.top + ratio * memoryChartInnerHeight,
            label: `${Math.round(value)}`
        };
    });
    const memorySpikeCallouts = memoryHistoryForChart.map((row, index)=>({
            index: index,
            value: Number(row.rssMb || 0)
        })).sort((a, b)=>b.value - a.value).slice(0, 2).sort((a, b)=>a.index - b.index);
    const memoryTickIndexesRaw = [
        0,
        memoryHistoryForChart.length - 1
    ].filter((value)=>value >= 0);
    const memoryTickIndexes = Array.from(new Set(memoryTickIndexesRaw));
    const cpuChartHeight = 72;
    const cpuChartYMax = Math.max(10, ...cpuSeries, 100);
    const cpuChartInnerHeight = cpuChartHeight - memoryChartPadding.top - 12;
    const cpuGridHorizontalCount = 4;
    const cpuGridVerticalCount = 12;
    const cpuGridHorizontalY = Array.from({
        length: cpuGridHorizontalCount + 1
    }, (_entry, idx)=>{
        const ratio = idx / cpuGridHorizontalCount;
        return memoryChartPadding.top + ratio * cpuChartInnerHeight;
    });
    const cpuGridVerticalX = Array.from({
        length: cpuGridVerticalCount + 1
    }, (_entry, idx)=>{
        const ratio = idx / cpuGridVerticalCount;
        return memoryChartPadding.left + ratio * memoryChartInnerWidth;
    });
    const cpuYByValue = (value)=>memoryChartPadding.top + (cpuChartYMax - Math.max(0, value)) / cpuChartYMax * cpuChartInnerHeight;
    const cpuPoints = memoryHistoryForChart.length >= 2 ? cpuSeries.map((value, index)=>`${memoryXByIndex(index)},${cpuYByValue(value)}`).join(" ") : "";
    const formatMemoryTimeTick = (value)=>{
        if (!value) return "-";
        const parsed = Date.parse(value);
        if (!Number.isFinite(parsed)) return "-";
        return new Intl.DateTimeFormat("de-DE", {
            timeZone: "Europe/Berlin",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date(parsed));
    };
    const formatMemoryDateTimeBerlin = (value)=>{
        if (!value) return "-";
        const parsed = Date.parse(value);
        if (!Number.isFinite(parsed)) return "-";
        return new Intl.DateTimeFormat("de-DE", {
            timeZone: "Europe/Berlin",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date(parsed));
    };
    const resolveMemoryHoverIndex = (event)=>{
        if (memoryHistoryForChart.length < 2) {
            setMemoryHoverIndex(null);
            return;
        }
        const rect = event.currentTarget.getBoundingClientRect();
        if (!Number.isFinite(rect.width) || rect.width <= 0) {
            setMemoryHoverIndex(null);
            return;
        }
        const relativeClientX = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
        const chartX = relativeClientX / rect.width * memoryChartWidth;
        const clampedX = Math.max(memoryChartPadding.left, Math.min(memoryChartPadding.left + memoryChartInnerWidth, chartX));
        const ratio = (clampedX - memoryChartPadding.left) / Math.max(1, memoryChartInnerWidth);
        const index = Math.round(ratio * (memoryHistoryForChart.length - 1));
        setMemoryHoverIndex(Math.max(0, Math.min(memoryHistoryForChart.length - 1, index)));
    };
    const hoveredMemoryRow = memoryHoverIndex !== null && memoryHoverIndex >= 0 && memoryHoverIndex < memoryHistoryForChart.length ? memoryHistoryForChart[memoryHoverIndex] : null;
    const hoveredMemoryX = memoryHoverIndex !== null ? memoryXByIndex(memoryHoverIndex) : null;
    const hoveredMemoryRss = hoveredMemoryRow ? Number(hoveredMemoryRow.rssMb || 0) : null;
    const hoveredMemoryHeap = hoveredMemoryRow ? Number(hoveredMemoryRow.heapUsedMb || 0) : null;
    const hoveredMemoryCpu = hoveredMemoryRow ? Number(hoveredMemoryRow.cpuPercent || 0) : null;
    const memoryTooltipWidth = 242;
    const memoryTooltipHeight = 58;
    const memoryTooltipX = hoveredMemoryX === null ? memoryChartPadding.left + 8 : Math.max(memoryChartPadding.left + 8, Math.min(memoryChartPadding.left + memoryChartInnerWidth - memoryTooltipWidth - 8, hoveredMemoryX - memoryTooltipWidth / 2));
    const memoryHistoryPeakRss = memoryHistoryForChart.length ? Math.max(...memoryHistoryForChart.map((row)=>Number(row.rssMb || 0))) : null;
    const memoryHistoryMinRss = memoryHistoryForChart.length ? Math.min(...memoryHistoryForChart.map((row)=>Number(row.rssMb || 0))) : null;
    const cpuPeak = memoryHistoryForChart.length ? Math.max(...memoryHistoryForChart.map((row)=>Number(row.cpuPercent || 0))) : null;
    const visibleServices = (0, $acw62.useMemo)(()=>(servicesStatus?.services ?? []).filter((service)=>service.service !== "facilioo_live_sync"), [
        servicesStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === "undefined") return;
        window.localStorage.setItem($fab90a5e7e3c87fa$var$MEMORY_RANGE_STORAGE_KEY, memoryRange);
    }, [
        memoryRange
    ]);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === "undefined") return;
        window.localStorage.setItem($fab90a5e7e3c87fa$var$MEMORY_DEBUG_ENABLED_STORAGE_KEY, memoryDebugEnabled ? "true" : "false");
    }, [
        memoryDebugEnabled
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: isFrameworkV2 ? "platform-v2-page resolutions-v2-page" : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `page-header panel ${isFrameworkV2 ? "resolutions-v2-page-header platform-v2-page-header" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: isFrameworkV2 ? "resolutions-v2-title" : "",
                        style: {
                            margin: 0
                        },
                        children: [
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "resolutions-v2-title-icon",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M4.8 7.6h14.4v11H4.8z",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M8 4.9h8v2.7H8zM8.1 11h2.5M13.4 11h2.5M8.1 14.4h2.5M13.4 14.4h2.5",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round"
                                        })
                                    ]
                                })
                            }) : null,
                            isFrameworkV2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "resolutions-v2-title-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-main",
                                        children: "SaaS-Mandanten"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "resolutions-v2-title-sub",
                                        children: "Plattformverwaltung, Dienste und Mandanten-Onboarding"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "SaaS-Mandanten (Plattform)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: isFrameworkV2 ? "resolutions-v2-create-btn" : "",
                        onClick: ()=>{
                            setEditingSlug(null);
                            setCreateOpen((prev)=>!prev);
                            setCreateError("");
                            setEditError("");
                            setEditInfo("");
                        },
                        children: createOpen ? "Schlie\xdfen" : "Neuer Mandant"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `panel ${isFrameworkV2 ? "platform-v2-services-panel" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: isFrameworkV2 ? "platform-v2-section-head" : "",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            style: {
                                marginTop: 0
                            },
                            children: "Dienste"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: isFrameworkV2 ? "platform-v2-message-row" : "",
                        style: {
                            display: "flex",
                            gap: 10,
                            alignItems: "flex-end",
                            flexWrap: "wrap",
                            marginBottom: 10
                        },
                        children: [
                            serviceActionInfo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "info-text",
                                children: serviceActionInfo
                            }) : null,
                            serviceActionError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: serviceActionError
                            }) : null
                        ]
                    }),
                    servicesIsError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "error-text",
                        children: servicesError instanceof Error ? servicesError.message : "Service-Status konnte nicht geladen werden."
                    }) : servicesLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Lade Service-Status..."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: isFrameworkV2 ? "platform-v2-service-grid" : "",
                        style: {
                            display: "flex",
                            gap: 10,
                            flexWrap: "wrap"
                        },
                        children: [
                            visibleServices.map((service)=>{
                                const label = resolveServiceLabel(service.service);
                                const badgeClass = service.statusText === "ok" ? "aktiv" : service.statusText === "nicht_ok" ? "inaktiv" : "";
                                const badgeStyle = service.statusText === "inaktiv" ? {
                                    borderColor: "#94a3b8",
                                    color: "#64748b"
                                } : undefined;
                                const statusLabel = service.statusText === "ok" ? "ok" : service.statusText === "nicht_ok" ? "nicht ok" : "inaktiv";
                                const monitorIssues = service.service === "platform_health_monitor" ? service.issues ?? [] : [];
                                const monitorIssueCount = service.service === "platform_health_monitor" ? service.issueCount ?? monitorIssues.length : 0;
                                const showMonitorDetails = service.service === "platform_health_monitor" && service.statusText === "nicht_ok";
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `panel ${isFrameworkV2 ? "platform-v2-service-card" : ""}`,
                                    style: {
                                        minWidth: 240,
                                        padding: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: isFrameworkV2 ? "platform-v2-card-title" : "",
                                            style: {
                                                fontWeight: 700,
                                                marginBottom: 6
                                            },
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: `badge ${badgeClass}`,
                                            style: {
                                                ...badgeStyle,
                                                whiteSpace: "nowrap"
                                            },
                                            children: statusLabel
                                        }),
                                        showMonitorDetails ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                marginTop: 8,
                                                display: "grid",
                                                gap: 4
                                            },
                                            children: [
                                                service.lastError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "#b42318",
                                                        display: "block"
                                                    },
                                                    children: `Fehler: ${service.lastError}`
                                                }) : null,
                                                service.lastNotifyError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "#b54708",
                                                        display: "block"
                                                    },
                                                    children: `Benachrichtigung: ${service.lastNotifyError}`
                                                }) : null,
                                                monitorIssues.map((issue, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                        style: {
                                                            color: "var(--text-soft)",
                                                            display: "block"
                                                        },
                                                        children: issue
                                                    }, `${service.service}-issue-${index}`)),
                                                service.hasMoreIssues ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "var(--text-soft)",
                                                        display: "block"
                                                    },
                                                    children: `Weitere ${Math.max(0, monitorIssueCount - monitorIssues.length)} Issue(s) vorhanden.`
                                                }) : null,
                                                !service.lastError && !service.lastNotifyError && monitorIssues.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                    style: {
                                                        color: "var(--text-soft)",
                                                        display: "block"
                                                    },
                                                    children: 'Ursache wird ermittelt. Bitte "Jetzt pr\xfcfen" ausf\xfchren.'
                                                }) : null
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: isFrameworkV2 ? "platform-v2-card-actions" : "",
                                            style: {
                                                display: "flex",
                                                gap: 8,
                                                marginTop: 10,
                                                flexWrap: "wrap"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>{
                                                        setServiceActionInfo("");
                                                        setServiceActionError("");
                                                        checkServiceMutation.mutate(service.service);
                                                    },
                                                    disabled: checkServiceMutation.isPending || notifyServiceMutation.isPending,
                                                    children: "Jetzt pr\xfcfen"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>{
                                                        setServiceActionInfo("");
                                                        setServiceActionError("");
                                                        notifyServiceMutation.mutate({
                                                            service: service.service
                                                        });
                                                    },
                                                    disabled: checkServiceMutation.isPending || notifyServiceMutation.isPending,
                                                    children: "St\xf6rungsmeldung senden"
                                                })
                                            ]
                                        })
                                    ]
                                }, service.service);
                            }),
                            servicesStatus && visibleServices.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "Keine Dienste konfiguriert."
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `panel ${isFrameworkV2 ? "platform-v2-debug-card" : ""}`,
                        style: {
                            marginTop: 12,
                            padding: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    flexWrap: "wrap",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "RAM/CPU-Log"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setMemoryDebugEnabled((prev)=>!prev),
                                        "aria-pressed": memoryDebugEnabled,
                                        "aria-label": `RAM/CPU-Log ${memoryDebugEnabled ? "deaktivieren" : "aktivieren"}`,
                                        title: `RAM/CPU-Log ist ${memoryDebugEnabled ? "aktiv" : "aus"}`,
                                        style: {
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 8,
                                            border: "none",
                                            background: "transparent",
                                            cursor: "pointer",
                                            padding: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    position: "relative",
                                                    width: 54,
                                                    height: 30,
                                                    borderRadius: 999,
                                                    background: memoryDebugEnabled ? "#16a34a" : "#94a3b8",
                                                    transition: "background 0.2s ease"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        position: "absolute",
                                                        top: 3,
                                                        left: memoryDebugEnabled ? 27 : 3,
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: "50%",
                                                        background: "#ffffff",
                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
                                                        transition: "left 0.2s ease"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `badge ${memoryDebugEnabled ? "aktiv" : "inaktiv"}`,
                                                children: memoryDebugEnabled ? "aktiv" : "aus"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 6,
                                    color: "var(--text-soft)"
                                },
                                children: memoryDebugEnabled ? "RAM/CPU-Log aktiv: Verlauf wird live aktualisiert." : "RAM/CPU-Log aus: keine Live-Aktualisierung und keine RAM/CPU-Sammlung \xfcber den Status-Endpunkt."
                            })
                        ]
                    }),
                    memoryDebugEnabled && memoryDebug ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `panel ${isFrameworkV2 ? "platform-v2-debug-card platform-v2-memory-card" : ""}`,
                        style: {
                            marginTop: 12,
                            padding: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    flexWrap: "wrap"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "RAM-Debug"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `badge ${memoryDebug.statusText === "ok" ? "aktiv" : "inaktiv"}`,
                                        style: memoryDebug.statusText === "warnung" ? {
                                            borderColor: "#f59e0b",
                                            color: "#b45309"
                                        } : memoryDebug.statusText === "kritisch" ? {
                                            borderColor: "#dc2626",
                                            color: "#dc2626"
                                        } : undefined,
                                        children: memoryDebug.statusText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 8,
                                    color: "var(--text-soft)"
                                },
                                children: `RSS ${formatMemoryMb(memoryDebug.current.rssMb)} | Heap ${formatMemoryMb(memoryDebug.current.heapUsedMb)} / ${formatMemoryMb(memoryDebug.current.heapTotalMb)} | CPU ${Number(memoryDebug.current.cpuPercent ?? 0).toLocaleString("de-DE", {
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1
                                })}% (gesamt ${Number(memoryDebug.current.cpuPercentTotal ?? 0).toLocaleString("de-DE", {
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1
                                })}% | system-normalisiert ${(Number(memoryDebug.current.cpuPercentTotal ?? 0) / Math.max(1, Number(memoryDebug.cpuConfig?.systemCores ?? memoryDebug.cpuCores ?? 1))).toLocaleString("de-DE", {
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1
                                })}%) | Kerne effektiv ${memoryDebug.cpuConfig?.effectiveCores ?? memoryDebug.cpuCores} / System ${memoryDebug.cpuConfig?.systemCores ?? memoryDebug.cpuCores} | Uptime ${formatUptime(memoryDebug.uptimeSeconds)}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 4,
                                    color: "var(--text-soft)"
                                },
                                children: `Server-RAM: Gesamt ${formatMemoryMb(memoryDebug.systemMemoryMb?.total)}, frei ${formatMemoryMb(memoryDebug.systemMemoryMb?.free)}, belegt ${formatMemoryMb(memoryDebug.systemMemoryMb?.used)} | Prozessanteil RSS ${Number(memoryDebug.processShareOfSystemPercent ?? 0).toLocaleString("de-DE", {
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1
                                })}%`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 4,
                                    color: "var(--text-soft)"
                                },
                                children: `Grenzen: Warnung ab ${formatMemoryMb(memoryDebug.thresholdMb.warn)}, kritisch ab ${formatMemoryMb(memoryDebug.thresholdMb.critical)}.`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 4,
                                    color: "var(--text-soft)"
                                },
                                children: `Basis: ${memoryDebug.thresholdConfig?.capacitySource === "env_override" ? "ENV-Kapazit\xe4t" : memoryDebug.thresholdConfig?.capacitySource === "cgroup" ? "cgroup-Limit" : "System-RAM"} ${formatMemoryMb(memoryDebug.thresholdConfig?.capacityMb)} | System ${formatMemoryMb(memoryDebug.thresholdConfig?.systemCapacityMb)}${memoryDebug.thresholdConfig?.cgroupCapacityMb ? ` | cgroup roh ${formatMemoryMb(memoryDebug.thresholdConfig?.cgroupCapacityMb)}` : ""} | Reserve ${formatMemoryMb(memoryDebug.thresholdConfig?.reservedMb)} | Budget ${formatMemoryMb(memoryDebug.thresholdConfig?.budgetMb)} | Modus ${memoryDebug.thresholdConfig?.source === "env_override" ? "ENV Override" : "dynamisch"}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 2,
                                    color: "var(--text-soft)"
                                },
                                children: `CPU-Basis: ${memoryDebug.cpuConfig?.source === "env_override" ? "ENV-Kerne" : memoryDebug.cpuConfig?.source === "cgroup" ? "cgroup-Limit" : "System-Kerne"} | effektiv ${memoryDebug.cpuConfig?.effectiveCores ?? memoryDebug.cpuCores} | System ${memoryDebug.cpuConfig?.systemCores ?? memoryDebug.cpuCores}${memoryDebug.cpuConfig?.availableParallelismCores ? ` | availableParallelism ${memoryDebug.cpuConfig.availableParallelismCores}` : ""}${memoryDebug.cpuConfig?.cgroupQuotaCores ? ` | cgroup quota ${memoryDebug.cpuConfig.cgroupQuotaCores}` : ""}${memoryDebug.cpuConfig?.cgroupCpusetCores ? ` | cgroup cpuset ${memoryDebug.cpuConfig.cgroupCpusetCores}` : ""}`
                            }),
                            memoryDebug.thresholdConfig?.source === "dynamic" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 2,
                                    color: "var(--text-soft)"
                                },
                                children: `Dynamik: Reserve ${(Number(memoryDebug.thresholdConfig?.reserveFraction ?? 0) * 100).toLocaleString("de-DE", {
                                    maximumFractionDigits: 0
                                })}% | Warnung ${(Number(memoryDebug.thresholdConfig?.warnFractionOfBudget ?? 0) * 100).toLocaleString("de-DE", {
                                    maximumFractionDigits: 0
                                })}% vom Budget | Kritisch ${(Number(memoryDebug.thresholdConfig?.criticalFractionOfBudget ?? 0) * 100).toLocaleString("de-DE", {
                                    maximumFractionDigits: 0
                                })}% vom Budget`
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 8,
                                    display: "flex",
                                    gap: 8,
                                    flexWrap: "wrap"
                                },
                                children: $fab90a5e7e3c87fa$var$MEMORY_RANGE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: `badge ${memoryRange === option.key ? "aktiv" : "inaktiv"}`,
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>setMemoryRange(option.key),
                                        children: option.label
                                    }, option.key))
                            }),
                            memoryHistoryForChart.length >= 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 6,
                                            flexWrap: "wrap",
                                            marginBottom: 6
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "badge inaktiv",
                                                style: {
                                                    borderColor: "#99f6e4",
                                                    color: "#0f766e",
                                                    background: "#f0fdfa"
                                                },
                                                children: `Min RSS ${formatMemoryMb(memoryHistoryMinRss ?? undefined)}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "badge inaktiv",
                                                style: {
                                                    borderColor: "#bfdbfe",
                                                    color: "#1d4ed8",
                                                    background: "#eff6ff"
                                                },
                                                children: `Max RSS ${formatMemoryMb(memoryHistoryPeakRss ?? undefined)}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "badge inaktiv",
                                                style: {
                                                    borderColor: "#ddd6fe",
                                                    color: "#6d28d9",
                                                    background: "#f5f3ff"
                                                },
                                                children: `CPU-Peak ${Number(cpuPeak ?? 0).toLocaleString("de-DE", {
                                                    minimumFractionDigits: 1,
                                                    maximumFractionDigits: 1
                                                })}%`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "badge inaktiv",
                                                style: {
                                                    borderColor: "#e2e8f0",
                                                    color: "#334155",
                                                    background: "#f8fafc"
                                                },
                                                children: `Letzte Messung ${formatServiceCheckedAt(memoryDebug.current.capturedAt)}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        viewBox: `0 0 ${memoryChartWidth} ${memoryChartHeight}`,
                                        style: {
                                            width: "100%",
                                            height: "auto",
                                            display: "block"
                                        },
                                        onMouseMove: resolveMemoryHoverIndex,
                                        onMouseLeave: ()=>setMemoryHoverIndex(null),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                                        id: "memoryChartBg",
                                                        x1: "0",
                                                        y1: "0",
                                                        x2: "1",
                                                        y2: "1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                                offset: "0%",
                                                                stopColor: "#f8fbff"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                                offset: "100%",
                                                                stopColor: "#f1f5f9"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                                                        id: "memoryChartGlow",
                                                        cx: "50%",
                                                        cy: "0%",
                                                        r: "80%",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                                offset: "0%",
                                                                stopColor: "#93c5fd",
                                                                stopOpacity: "0.22"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                                offset: "100%",
                                                                stopColor: "#93c5fd",
                                                                stopOpacity: "0"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                                        id: "memoryRssFill",
                                                        x1: "0",
                                                        y1: "0",
                                                        x2: "0",
                                                        y2: "1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                                offset: "0%",
                                                                stopColor: "#0f766e",
                                                                stopOpacity: "0.28"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                                offset: "100%",
                                                                stopColor: "#0f766e",
                                                                stopOpacity: "0.02"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                                        id: "memoryHeapFill",
                                                        x1: "0",
                                                        y1: "0",
                                                        x2: "0",
                                                        y2: "1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                                offset: "0%",
                                                                stopColor: "#2563eb",
                                                                stopOpacity: "0.18"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                                offset: "100%",
                                                                stopColor: "#2563eb",
                                                                stopOpacity: "0.02"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                                                        id: "memoryRssGlow",
                                                        x: "-20%",
                                                        y: "-30%",
                                                        width: "140%",
                                                        height: "160%",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                                                stdDeviation: "1.15",
                                                                result: "blur"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("feMerge", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feMergeNode", {
                                                                        in: "blur"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feMergeNode", {
                                                                        in: "SourceGraphic"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                x: memoryChartPadding.left,
                                                y: memoryChartPadding.top,
                                                width: memoryChartInnerWidth,
                                                height: memoryChartInnerHeight,
                                                fill: "url(#memoryChartBg)",
                                                stroke: "#cbd5e1",
                                                rx: "8"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                x: memoryChartPadding.left,
                                                y: memoryChartPadding.top,
                                                width: memoryChartInnerWidth,
                                                height: memoryChartInnerHeight,
                                                fill: "url(#memoryChartGlow)",
                                                rx: "8"
                                            }),
                                            memoryGridHorizontalY.map((y, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                    x1: memoryChartPadding.left,
                                                    x2: memoryChartPadding.left + memoryChartInnerWidth,
                                                    y1: y,
                                                    y2: y,
                                                    stroke: index === memoryGridHorizontalY.length - 1 ? "#cbd5e1" : "#dbeafe",
                                                    strokeDasharray: index % 2 === 0 ? "2 4" : "0",
                                                    strokeWidth: "0.8"
                                                }, `memory-grid-h-${index}`)),
                                            memoryGridVerticalX.map((x, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                    x1: x,
                                                    x2: x,
                                                    y1: memoryChartPadding.top,
                                                    y2: memoryChartPadding.top + memoryChartInnerHeight,
                                                    stroke: "#e2e8f0",
                                                    strokeDasharray: "2 4",
                                                    strokeWidth: "0.8",
                                                    opacity: index % 2 === 0 ? 0.9 : 0.55
                                                }, `memory-grid-v-${index}`)),
                                            memoryYAxisTicks.map((tick, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                    x: memoryChartPadding.left + 6,
                                                    y: tick.y - 2,
                                                    fontSize: "8.5",
                                                    fill: "#64748b",
                                                    children: `${tick.label} MB`
                                                }, `memory-y-tick-${index}`)),
                                            memoryHistoryForChart.length >= 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: memoryRssAreaPath,
                                                fill: "url(#memoryRssFill)"
                                            }) : null,
                                            memoryHistoryForChart.length >= 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: memoryHeapAreaPath,
                                                fill: "url(#memoryHeapFill)"
                                            }) : null,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                x1: memoryChartPadding.left,
                                                x2: memoryChartPadding.left + memoryChartInnerWidth,
                                                y1: memoryWarnY,
                                                y2: memoryWarnY,
                                                stroke: "#f59e0b",
                                                strokeDasharray: "4 4",
                                                strokeWidth: "0.9"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                x1: memoryChartPadding.left,
                                                x2: memoryChartPadding.left + memoryChartInnerWidth,
                                                y1: memoryCriticalY,
                                                y2: memoryCriticalY,
                                                stroke: "#dc2626",
                                                strokeDasharray: "5 4",
                                                strokeWidth: "0.9"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                                points: memoryHeapPoints,
                                                fill: "none",
                                                stroke: "#2563eb",
                                                strokeWidth: "1.15",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                                points: memoryRssPoints,
                                                fill: "none",
                                                stroke: "#0f766e",
                                                strokeWidth: "1.1",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                filter: "url(#memoryRssGlow)"
                                            }),
                                            hoveredMemoryRow && hoveredMemoryX !== null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                pointerEvents: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                        x1: hoveredMemoryX,
                                                        x2: hoveredMemoryX,
                                                        y1: memoryChartPadding.top,
                                                        y2: memoryChartPadding.top + memoryChartInnerHeight,
                                                        stroke: "#0f172a",
                                                        strokeOpacity: "0.22",
                                                        strokeDasharray: "3 4",
                                                        strokeWidth: "0.85"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        cx: hoveredMemoryX,
                                                        cy: memoryYByValue(hoveredMemoryRss ?? 0),
                                                        r: "2.6",
                                                        fill: "#0f766e",
                                                        stroke: "#ffffff",
                                                        strokeWidth: "1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        cx: hoveredMemoryX,
                                                        cy: memoryYByValue(hoveredMemoryHeap ?? 0),
                                                        r: "2.5",
                                                        fill: "#2563eb",
                                                        stroke: "#ffffff",
                                                        strokeWidth: "1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                        x: memoryTooltipX,
                                                        y: memoryChartPadding.top + 6,
                                                        width: memoryTooltipWidth,
                                                        height: memoryTooltipHeight,
                                                        rx: "8",
                                                        fill: "#ffffff",
                                                        stroke: "#cbd5e1",
                                                        strokeWidth: "0.9",
                                                        opacity: "0.98"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                        x: memoryTooltipX + 8,
                                                        y: memoryChartPadding.top + 19,
                                                        fontSize: "8.8",
                                                        fill: "#0f172a",
                                                        fontWeight: 700,
                                                        children: formatMemoryDateTimeBerlin(hoveredMemoryRow.capturedAt)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                        x: memoryTooltipX + 8,
                                                        y: memoryChartPadding.top + 33,
                                                        fontSize: "8.5",
                                                        fill: "#0f766e",
                                                        children: `RSS ${formatMemoryMb(hoveredMemoryRss ?? undefined)}`
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                        x: memoryTooltipX + 95,
                                                        y: memoryChartPadding.top + 33,
                                                        fontSize: "8.5",
                                                        fill: "#2563eb",
                                                        children: `Heap ${formatMemoryMb(hoveredMemoryHeap ?? undefined)}`
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                        x: memoryTooltipX + 8,
                                                        y: memoryChartPadding.top + 47,
                                                        fontSize: "8.5",
                                                        fill: "#6d28d9",
                                                        children: `CPU ${Number(hoveredMemoryCpu ?? 0).toLocaleString("de-DE", {
                                                            minimumFractionDigits: 1,
                                                            maximumFractionDigits: 1
                                                        })}%`
                                                    })
                                                ]
                                            }) : null,
                                            memorySpikeCallouts.map((spike, index)=>{
                                                const x = memoryXByIndex(spike.index);
                                                const y = memoryYByValue(spike.value);
                                                const labelY = Math.max(memoryChartPadding.top + 20, y - 12 - index * 16);
                                                const labelX = Math.max(memoryChartPadding.left + 34, Math.min(memoryChartPadding.left + memoryChartInnerWidth - 34, x));
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                            cx: x,
                                                            cy: y,
                                                            r: "3.5",
                                                            fill: "#0f766e",
                                                            stroke: "#ffffff",
                                                            strokeWidth: "1.4"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                            x1: x,
                                                            x2: labelX,
                                                            y1: y,
                                                            y2: labelY - 8,
                                                            stroke: "#0f766e",
                                                            strokeDasharray: "2 3",
                                                            strokeWidth: "1"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                            x: labelX - 33,
                                                            y: labelY - 18,
                                                            width: "66",
                                                            height: "14",
                                                            rx: "5",
                                                            fill: "#ecfeff",
                                                            opacity: "0.95"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                            x: labelX,
                                                            y: labelY - 8,
                                                            textAnchor: "middle",
                                                            fontSize: "8.5",
                                                            fill: "#0f766e",
                                                            fontWeight: 600,
                                                            children: `Spike ${Math.round(spike.value)} MB`
                                                        })
                                                    ]
                                                }, `memory-spike-${spike.index}`);
                                            }),
                                            memoryTickIndexes.map((index)=>{
                                                const x = memoryXByIndex(index);
                                                const label = formatMemoryTimeTick(memoryHistoryForChart[index]?.capturedAt);
                                                const isFirst = index === 0;
                                                const isLast = index === memoryHistoryForChart.length - 1;
                                                const textAnchor = isFirst ? "start" : isLast ? "end" : "middle";
                                                const labelX = isFirst ? x + 1 : isLast ? x - 1 : x;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                            x1: x,
                                                            x2: x,
                                                            y1: memoryChartPadding.top + memoryChartInnerHeight,
                                                            y2: memoryChartPadding.top + memoryChartInnerHeight + 5,
                                                            stroke: "#64748b"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                            x: labelX,
                                                            y: memoryChartPadding.top + memoryChartInnerHeight + 16,
                                                            textAnchor: textAnchor,
                                                            fontSize: "9",
                                                            fill: "#64748b",
                                                            children: label
                                                        })
                                                    ]
                                                }, `memory-tick-${index}`);
                                            })
                                        ]
                                    }),
                                    memoryHistoryForChart.length >= 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        viewBox: `0 0 ${memoryChartWidth} ${cpuChartHeight}`,
                                        style: {
                                            width: "100%",
                                            height: "auto",
                                            display: "block",
                                            marginTop: 4
                                        },
                                        onMouseMove: resolveMemoryHoverIndex,
                                        onMouseLeave: ()=>setMemoryHoverIndex(null),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                x: memoryChartPadding.left,
                                                y: memoryChartPadding.top,
                                                width: memoryChartInnerWidth,
                                                height: cpuChartInnerHeight,
                                                fill: "url(#memoryChartBg)",
                                                stroke: "#cbd5e1",
                                                rx: "8"
                                            }),
                                            cpuGridHorizontalY.map((y, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                    x1: memoryChartPadding.left,
                                                    x2: memoryChartPadding.left + memoryChartInnerWidth,
                                                    y1: y,
                                                    y2: y,
                                                    stroke: "#ede9fe",
                                                    strokeDasharray: "2 4",
                                                    strokeWidth: "0.8"
                                                }, `cpu-grid-h-${index}`)),
                                            cpuGridVerticalX.map((x, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                    x1: x,
                                                    x2: x,
                                                    y1: memoryChartPadding.top,
                                                    y2: memoryChartPadding.top + cpuChartInnerHeight,
                                                    stroke: "#e2e8f0",
                                                    strokeDasharray: "2 4",
                                                    strokeWidth: "0.8",
                                                    opacity: index % 2 === 0 ? 0.85 : 0.5
                                                }, `cpu-grid-v-${index}`)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                                points: cpuPoints,
                                                fill: "none",
                                                stroke: "#7c3aed",
                                                strokeWidth: "1.1",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                x: memoryChartPadding.left + 8,
                                                y: memoryChartPadding.top + 10,
                                                textAnchor: "start",
                                                fontSize: "9",
                                                fill: "#6d28d9",
                                                children: `CPU ${Math.round(cpuChartYMax)}% max`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                x: memoryChartPadding.left + memoryChartInnerWidth - 8,
                                                y: memoryChartPadding.top + 10,
                                                textAnchor: "end",
                                                fontSize: "8.5",
                                                fill: "#7c3aed",
                                                children: "100%"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                x: memoryChartPadding.left + memoryChartInnerWidth - 8,
                                                y: memoryChartPadding.top + cpuChartInnerHeight - 2,
                                                textAnchor: "end",
                                                fontSize: "8.5",
                                                fill: "#7c3aed",
                                                children: "0%"
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 12,
                                            color: "var(--text-soft)",
                                            fontSize: 12,
                                            marginTop: 4,
                                            flexWrap: "wrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                style: {
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 6
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            width: 10,
                                                            height: 10,
                                                            borderRadius: 99,
                                                            background: "#0f766e",
                                                            display: "inline-block"
                                                        }
                                                    }),
                                                    "RSS"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                style: {
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 6
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            width: 10,
                                                            height: 10,
                                                            borderRadius: 99,
                                                            background: "#2563eb",
                                                            display: "inline-block"
                                                        }
                                                    }),
                                                    "Heap genutzt"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    color: "#b45309"
                                                },
                                                children: `Warnung ab ${formatMemoryMb(memoryDebug.thresholdMb.warn)}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    color: "#b91c1c"
                                                },
                                                children: `Kritisch ab ${formatMemoryMb(memoryDebug.thresholdMb.critical)}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                style: {
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 6
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            width: 10,
                                                            height: 10,
                                                            borderRadius: 99,
                                                            background: "#7c3aed",
                                                            display: "inline-block"
                                                        }
                                                    }),
                                                    "CPU"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 4,
                                    color: "var(--text-soft)"
                                },
                                children: `Verlauf (${selectedMemoryRange.label}, ${memoryHistoryForChart.length} Messungen): Min RSS ${formatMemoryMb(memoryHistoryMinRss ?? undefined)}, Max RSS ${formatMemoryMb(memoryHistoryPeakRss ?? undefined)}, CPU-Peak ${Number(cpuPeak ?? 0).toLocaleString("de-DE", {
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1
                                })}%, letzte Messung ${formatServiceCheckedAt(memoryDebug.current.capturedAt)}.`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 2,
                                    color: "var(--text-soft)"
                                },
                                children: `Skalierung: 100% = ${formatMemoryMb(memoryChartYMax)}.`
                            })
                        ]
                    }) : null,
                    visibleServices.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `table-wrap ${isFrameworkV2 ? "platform-v2-interval-table" : ""}`,
                        style: {
                            marginTop: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                style: {
                                    marginTop: 0
                                },
                                children: "Pr\xfcfintervalle"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Dienst"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Intervall"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Letzter Test"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: visibleServices.map((service)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: resolveServiceLabel(service.service)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: formatServiceInterval(service.intervalMs)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        children: formatServiceCheckedAt(service.checkedAt ?? undefined)
                                                    })
                                                ]
                                            }, `${service.service}-interval`))
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            createOpen && !editingSlug ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `panel create-form ${isFrameworkV2 ? "platform-v2-form-panel" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "Mandant onboarden"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tenant-onboarding-intro",
                        children: "Dieser Bereich ist von der normalen Mandantenverwaltung getrennt und nur f\xfcr Plattform-Admins gedacht."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tenant-onboarding-sections",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tenant-onboarding-section",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        children: "Mandant"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tenant-onboarding-grid",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Mandanten-Slug* (Subdomain)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        placeholder: "z. B. hausverwaltung-muster",
                                                        value: form.slug,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                slug: e.target.value.toLowerCase()
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Mandantenname*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.name,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                name: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Rechtsform"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.legalForm,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                legalForm: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Website"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.website,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                website: e.target.value
                                                            })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tenant-onboarding-section",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        children: "Kontakt und Adresse"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tenant-onboarding-grid",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Kontakt-E-Mail*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.contactEmail,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                contactEmail: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Kontakt-Telefon"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.contactPhone,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                contactPhone: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Stra\xdfe"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.addressStreet,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                addressStreet: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "PLZ"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.addressPostalCode,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                addressPostalCode: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Ort"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.addressCity,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                addressCity: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Land"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.addressCountry,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                addressCountry: e.target.value
                                                            })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tenant-onboarding-section",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        children: "Ansprechpartner"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tenant-onboarding-grid",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Anrede"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.contactSalutation,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                contactSalutation: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Titel"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.contactTitle,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                contactTitle: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Vorname"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.contactFirstName,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                contactFirstName: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Nachname"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.contactLastName,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                contactLastName: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "E-Mail"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.contactPersonEmail,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                contactPersonEmail: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Telefon"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.contactPersonPhone,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                contactPersonPhone: e.target.value
                                                            })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tenant-onboarding-section",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        children: "Standards und Technik"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tenant-onboarding-grid",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Zeitzone"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.technicalTimezone,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                technicalTimezone: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Locale"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.technicalLocale,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                technicalLocale: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "W\xe4hrung"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.technicalCurrency,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                technicalCurrency: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "UI-Framework"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: form.technicalUiFramework,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                technicalUiFramework: e.target.value === "mockup_v2" ? "mockup_v2" : "classic"
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "classic",
                                                                children: "Classic (bisherig)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "mockup_v2",
                                                                children: "Mockup V2 (neu)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Standard Stimmrechtsart"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: form.defaultStimmrechtsart,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                defaultStimmrechtsart: e.target.value
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "kopf",
                                                                children: "K\xf6pfe"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "stimmrecht",
                                                                children: "Stimmrecht"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "mea",
                                                                children: "MEA"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Standard Quorum"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: form.defaultQuorum,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                defaultQuorum: e.target.value
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "allstimmig",
                                                                children: "Allstimmig"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "einfache_mehrheit",
                                                                children: "Einfache Mehrheit"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "qualifizierte_mehrheit",
                                                                children: "Qualifizierte Mehrheit"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Facilioo-Nutzung"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "settings-switch-row tenant-onboarding-switch-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                className: "settings-toggle",
                                                                htmlFor: "tenant-facilioo-default",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        id: "tenant-facilioo-default",
                                                                        type: "checkbox",
                                                                        checked: form.defaultFaciliooEnabled,
                                                                        onChange: (e)=>setForm({
                                                                                ...form,
                                                                                defaultFaciliooEnabled: e.target.checked
                                                                            })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "settings-toggle-slider"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: form.defaultFaciliooEnabled ? "Facilioo standardm\xe4\xdfig aktiv" : "Facilioo standardm\xe4\xdfig inaktiv"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Demozeitraum"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "settings-switch-row tenant-onboarding-switch-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                className: "settings-toggle",
                                                                htmlFor: "tenant-trial-enabled",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        id: "tenant-trial-enabled",
                                                                        type: "checkbox",
                                                                        checked: form.trialEnabled,
                                                                        onChange: (e)=>setForm({
                                                                                ...form,
                                                                                trialEnabled: e.target.checked
                                                                            })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "settings-toggle-slider"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: form.trialEnabled ? "Kostenlosen Demozeitraum aktivieren" : "Kein Demozeitraum"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            form.trialEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Dauer (Tage)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "number",
                                                        min: 1,
                                                        max: 365,
                                                        value: form.trialDays,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                trialDays: Math.max(1, Math.min(365, Number(e.target.value || 1)))
                                                            })
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tenant-onboarding-section",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        children: "Erster Admin"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tenant-onboarding-grid",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Benutzername*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.adminUsername,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                adminUsername: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Anzeigename*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: form.adminDisplayName,
                                                        onChange: (e)=>setForm({
                                                                ...form,
                                                                adminDisplayName: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Passwort* (min. 8 Zeichen)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "owner-auth-password-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: showAdminPassword ? "text" : "password",
                                                                value: form.adminPassword,
                                                                onChange: (e)=>setForm({
                                                                        ...form,
                                                                        adminPassword: e.target.value
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "owner-auth-eye-btn",
                                                                onClick: ()=>setShowAdminPassword((value)=>!value),
                                                                "aria-label": showAdminPassword ? "Passwort verbergen" : "Passwort anzeigen",
                                                                title: showAdminPassword ? "Passwort verbergen" : "Passwort anzeigen",
                                                                children: showAdminPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    width: "18",
                                                                    height: "18",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    "aria-hidden": "true",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                            cx: "12",
                                                                            cy: "12",
                                                                            r: "3.2",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M4 4l16 16",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round"
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    width: "18",
                                                                    height: "18",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    "aria-hidden": "true",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                            cx: "12",
                                                                            cy: "12",
                                                                            r: "3.2",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.8"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !canCreate || createMutation.isPending,
                                onClick: ()=>createMutation.mutate(),
                                children: createMutation.isPending ? "Onboarding l\xe4uft..." : "Mandant anlegen"
                            }),
                            createError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: createError
                            }) : null
                        ]
                    }),
                    createInfo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 8,
                            color: "var(--text-soft)"
                        },
                        children: createInfo
                    }) : null,
                    lastAccessUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 8,
                            color: "var(--text-soft)"
                        },
                        children: `Mandant erreichbar unter: ${lastAccessUrl}`
                    }) : null
                ]
            }) : null,
            editingSlug ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `panel create-form ${isFrameworkV2 ? "platform-v2-form-panel" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: `Mandant bearbeiten: ${editingSlug}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tenant-onboarding-section",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                children: "Stripe-Abrechnung"
                            }),
                            billingLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    color: "var(--text-soft)"
                                },
                                children: "Lade Billing-Status..."
                            }) : billingIsError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "error-text",
                                children: billingError instanceof Error ? billingError.message : "Billing-Status konnte nicht geladen werden."
                            }) : billingStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tenant-onboarding-grid",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: $fab90a5e7e3c87fa$var$billingStatusBadge(billingStatus.status)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Aktive Einheiten"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: billingStatus.activeUnitCount.toLocaleString("de-DE")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Aktueller Tarif"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: $fab90a5e7e3c87fa$var$billingTierLabel(billingStatus.resolvedTier?.tier ?? billingStatus.currentTier)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Letzter Snapshot"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: billingStatus.lastSnapshot ? $fab90a5e7e3c87fa$var$formatDateTime(billingStatus.lastSnapshot.snapshotDate) : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Stripe Customer"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            wordBreak: "break-word"
                                                        },
                                                        children: billingStatus.stripeCustomerId ?? "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Stripe Subscription"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            wordBreak: "break-word"
                                                        },
                                                        children: billingStatus.stripeSubscriptionId ?? "-"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !billingStatus.configured ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "error-text",
                                        style: {
                                            marginTop: 8
                                        },
                                        children: "Stripe Billing ist noch nicht vollst\xe4ndig konfiguriert. Bitte Secret Key und Price-IDs in der Backend-Umgebung setzen."
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-actions",
                                        style: {
                                            marginTop: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: !billingStatus.configured || checkoutBillingMutation.isPending || portalBillingMutation.isPending || syncBillingMutation.isPending,
                                                onClick: ()=>{
                                                    if (!editingSlug) return;
                                                    checkoutBillingMutation.mutate(editingSlug);
                                                },
                                                children: checkoutBillingMutation.isPending ? "Erstellt..." : "Checkout-Link erstellen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: !billingStatus.configured || portalBillingMutation.isPending || checkoutBillingMutation.isPending || syncBillingMutation.isPending,
                                                onClick: ()=>{
                                                    if (!editingSlug) return;
                                                    portalBillingMutation.mutate(editingSlug);
                                                },
                                                children: portalBillingMutation.isPending ? "\xd6ffnet..." : "Stripe Portal \xf6ffnen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: !billingStatus.configured || syncBillingMutation.isPending || checkoutBillingMutation.isPending || portalBillingMutation.isPending,
                                                onClick: ()=>{
                                                    if (!editingSlug) return;
                                                    syncBillingMutation.mutate(editingSlug);
                                                },
                                                children: syncBillingMutation.isPending ? "Synchronisiert..." : "Billing neu synchronisieren"
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tenant-onboarding-grid",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Mandantenname*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.name,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    name: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.status,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    status: e.target.value
                                                })),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "aktiv",
                                                children: "aktiv"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "inaktiv",
                                                children: "inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Rechtsform"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.legalForm,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    legalForm: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Website"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.website,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    website: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Kontakt-E-Mail*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.contactEmail,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    contactEmail: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Kontakt-Telefon"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.contactPhone,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    contactPhone: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stra\xdfe"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.addressStreet,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    addressStreet: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "PLZ"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.addressPostalCode,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    addressPostalCode: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Ort"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.addressCity,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    addressCity: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Land"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.addressCountry,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    addressCountry: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Anrede Ansprechpartner"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.contactSalutation,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    contactSalutation: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Titel Ansprechpartner"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.contactTitle,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    contactTitle: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Vorname Ansprechpartner"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.contactFirstName,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    contactFirstName: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Nachname Ansprechpartner"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.contactLastName,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    contactLastName: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "E-Mail Ansprechpartner"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.contactPersonEmail,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    contactPersonEmail: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Telefon Ansprechpartner"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.contactPersonPhone,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    contactPersonPhone: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Zeitzone"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.technicalTimezone,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    technicalTimezone: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Locale"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.technicalLocale,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    technicalLocale: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "W\xe4hrung"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: editForm.technicalCurrency,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    technicalCurrency: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "UI-Framework"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.technicalUiFramework,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    technicalUiFramework: e.target.value === "mockup_v2" ? "mockup_v2" : "classic"
                                                })),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "classic",
                                                children: "Classic (bisherig)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "mockup_v2",
                                                children: "Mockup V2 (neu)"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Standard Stimmrechtsart"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.defaultStimmrechtsart,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    defaultStimmrechtsart: e.target.value
                                                })),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "kopf",
                                                children: "K\xf6pfe"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "stimmrecht",
                                                children: "Stimmrecht"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "mea",
                                                children: "MEA"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Standard Quorum"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: editForm.defaultQuorum,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    defaultQuorum: e.target.value
                                                })),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "allstimmig",
                                                children: "Allstimmig"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "einfache_mehrheit",
                                                children: "Einfache Mehrheit"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "qualifizierte_mehrheit",
                                                children: "Qualifizierte Mehrheit"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Facilioo-Nutzung"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-switch-row tenant-onboarding-switch-row",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "settings-toggle",
                                                htmlFor: "tenant-edit-facilioo-default",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        id: "tenant-edit-facilioo-default",
                                                        type: "checkbox",
                                                        checked: editForm.defaultFaciliooEnabled,
                                                        onChange: (e)=>setEditForm((prev)=>({
                                                                    ...prev,
                                                                    defaultFaciliooEnabled: e.target.checked
                                                                }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-toggle-slider"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: editForm.defaultFaciliooEnabled ? "Facilioo standardm\xe4\xdfig aktiv" : "Facilioo standardm\xe4\xdfig inaktiv"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Demozeitraum"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "settings-switch-row tenant-onboarding-switch-row",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "settings-toggle",
                                                htmlFor: "tenant-edit-trial-enabled",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        id: "tenant-edit-trial-enabled",
                                                        type: "checkbox",
                                                        checked: editForm.trialEnabled,
                                                        onChange: (e)=>setEditForm((prev)=>({
                                                                    ...prev,
                                                                    trialEnabled: e.target.checked
                                                                }))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "settings-toggle-slider"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: editForm.trialEnabled ? "Kostenlosen Demozeitraum aktivieren" : "Kein Demozeitraum"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            editForm.trialEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Dauer (Tage)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: 1,
                                        max: 365,
                                        value: editForm.trialDays,
                                        onChange: (e)=>setEditForm((prev)=>({
                                                    ...prev,
                                                    trialDays: Math.max(1, Math.min(365, Number(e.target.value || 1)))
                                                }))
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tenant-onboarding-section",
                                style: {
                                    gridColumn: "1 / -1"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        children: "Erster Admin"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tenant-onboarding-grid",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Benutzername*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: editForm.adminUsername,
                                                        onChange: (e)=>setEditForm((prev)=>({
                                                                    ...prev,
                                                                    adminUsername: e.target.value
                                                                }))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Anzeigename*"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: editForm.adminDisplayName,
                                                        onChange: (e)=>setEditForm((prev)=>({
                                                                    ...prev,
                                                                    adminDisplayName: e.target.value
                                                                }))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Neues Passwort (optional, min. 8 Zeichen)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "owner-auth-password-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: showEditAdminPassword ? "text" : "password",
                                                                value: editForm.adminPassword,
                                                                autoComplete: "new-password",
                                                                placeholder: "Leer lassen, um es nicht zu \xe4ndern",
                                                                onChange: (e)=>setEditForm((prev)=>({
                                                                            ...prev,
                                                                            adminPassword: e.target.value
                                                                        }))
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "owner-auth-eye-btn",
                                                                onClick: ()=>setShowEditAdminPassword((value)=>!value),
                                                                "aria-label": showEditAdminPassword ? "Passwort verbergen" : "Passwort anzeigen",
                                                                title: showEditAdminPassword ? "Passwort verbergen" : "Passwort anzeigen",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fab90a5e7e3c87fa$var$PasswordVisibilityIcon, {
                                                                    hidden: showEditAdminPassword
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-field",
                                style: {
                                    gridColumn: "1 / -1"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Facilioo Debugsteuerung (nur Plattform)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-switch-row tenant-onboarding-switch-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        className: "settings-toggle",
                                                        htmlFor: "tenant-edit-facilioo-debug-mode",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                id: "tenant-edit-facilioo-debug-mode",
                                                                type: "checkbox",
                                                                checked: editFaciliooDebug.debugModeEnabled === true,
                                                                onChange: (e)=>setEditFaciliooDebug((prev)=>({
                                                                            ...prev,
                                                                            debugModeEnabled: e.target.checked
                                                                        })),
                                                                disabled: editFaciliooDebugLoading || updateFaciliooDebugMutation.isPending
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "settings-toggle-slider"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: editFaciliooDebug.debugModeEnabled ? "Debug-Modus aktiv (24h)" : "Debug-Modus inaktiv"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                style: {
                                                    color: "var(--text-soft)"
                                                },
                                                children: [
                                                    "Ablauf Debug-Modus: ",
                                                    editFaciliooDebug.debugModeEnabled ? $fab90a5e7e3c87fa$var$formatDateTime(editFaciliooDebug.debugModeExpiresAt) : "-"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "settings-switch-row tenant-onboarding-switch-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        className: "settings-toggle",
                                                        htmlFor: "tenant-edit-facilioo-deep-probe",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                id: "tenant-edit-facilioo-deep-probe",
                                                                type: "checkbox",
                                                                checked: editFaciliooDebug.deepProbeEnabled === true,
                                                                onChange: (e)=>setEditFaciliooDebug((prev)=>({
                                                                            ...prev,
                                                                            deepProbeEnabled: e.target.checked
                                                                        })),
                                                                disabled: editFaciliooDebugLoading || updateFaciliooDebugMutation.isPending
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "settings-toggle-slider"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: editFaciliooDebug.deepProbeEnabled ? "Deep-Probe aktiv (24h)" : "Deep-Probe inaktiv"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                style: {
                                                    color: "var(--text-soft)"
                                                },
                                                children: [
                                                    "Ablauf Deep-Probe: ",
                                                    editFaciliooDebug.deepProbeEnabled ? $fab90a5e7e3c87fa$var$formatDateTime(editFaciliooDebug.deepProbeExpiresAt) : "-"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 8,
                                                    alignItems: "center",
                                                    flexWrap: "wrap"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        disabled: Boolean(!editingSlug) || editFaciliooDebugLoading || updateFaciliooDebugMutation.isPending,
                                                        onClick: ()=>{
                                                            if (!editingSlug) return;
                                                            updateFaciliooDebugMutation.mutate({
                                                                slug: editingSlug,
                                                                debugModeEnabled: editFaciliooDebug.debugModeEnabled,
                                                                deepProbeEnabled: editFaciliooDebug.deepProbeEnabled
                                                            });
                                                        },
                                                        children: editFaciliooDebugLoading ? "Lade..." : updateFaciliooDebugMutation.isPending ? "Speichert..." : "Debugsteuerung 24h anwenden"
                                                    }),
                                                    editFaciliooDebugError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "error-text",
                                                        children: editFaciliooDebugError
                                                    }) : null,
                                                    editFaciliooDebugInfo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            color: "var(--text-soft)"
                                                        },
                                                        children: editFaciliooDebugInfo
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                disabled: !editForm.name.trim() || editForm.adminUsername.trim().length < 3 || editForm.adminDisplayName.trim().length === 0 || editForm.adminPassword.trim().length > 0 && editForm.adminPassword.trim().length < 8 || editForm.contactEmail.trim().length > 0 && !/\S+@\S+\.\S+/.test(editForm.contactEmail.trim()) || updateMutation.isPending,
                                onClick: ()=>{
                                    if (!editingSlug) return;
                                    updateMutation.mutate({
                                        slug: editingSlug,
                                        form: editForm
                                    });
                                },
                                children: updateMutation.isPending ? "Speichert..." : "\xc4nderungen speichern"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setEditingSlug(null);
                                    setEditError("");
                                    setEditFaciliooDebugError("");
                                    setEditFaciliooDebugInfo("");
                                    setShowEditAdminPassword(false);
                                },
                                children: "Abbrechen"
                            }),
                            editError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "error-text",
                                children: editError
                            }) : null,
                            editInfo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    color: "var(--text-soft)"
                                },
                                children: editInfo
                            }) : null
                        ]
                    })
                ]
            }) : null,
            isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel error-text",
                children: error instanceof Error ? error.message : "Fehler beim Laden der Mandanten"
            }) : null,
            tenantProvisioningInfo || tenantProvisioningError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: `panel ${tenantProvisioningError ? "error-text" : ""}`,
                children: tenantProvisioningError || tenantProvisioningInfo
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: isFrameworkV2 ? "platform-v2-table-section" : undefined,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                    columns: columns,
                    rows: tenantRows,
                    total: tenantRows.length,
                    page: 1,
                    pageSize: 50,
                    onPageChange: ()=>undefined
                })
            }),
            systemRows.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `panel ${isFrameworkV2 ? "platform-v2-system-panel" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: "System"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: isFrameworkV2 ? "platform-v2-table-section" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8c699f3967537fe$export$26c4b03ab5e2b7eb), {
                            columns: systemColumns,
                            rows: systemRows,
                            total: systemRows.length,
                            page: 1,
                            pageSize: 50,
                            onPageChange: ()=>undefined
                        })
                    })
                ]
            }) : null,
            isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "panel",
                children: "Lade Mandanten..."
            }) : null
        ]
    });
};




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $3dd354b20d6de309$var$TOKEN_REGEX = /(\{\{[^{}]+\}\})/g;
const $3dd354b20d6de309$var$TOKEN_PART_REGEX = /^\{\{[^{}]+\}\}$/;
const $3dd354b20d6de309$var$createTokenBadge = (token)=>{
    const span = document.createElement("span");
    span.className = "template-token-badge";
    span.setAttribute("data-token", token);
    span.setAttribute("data-token-id", globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`);
    span.setAttribute("contenteditable", "false");
    span.setAttribute("spellcheck", "false");
    span.setAttribute("draggable", "true");
    span.textContent = token;
    return span;
};
const $3dd354b20d6de309$var$escapeHtml = (value)=>value.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll("\"", "&quot;");
const $3dd354b20d6de309$var$replaceTokenTextNodes = (node)=>{
    Array.from(node.childNodes).forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) {
            const text = child.textContent ?? "";
            if (!text.includes("{{")) return;
            const chunks = text.split($3dd354b20d6de309$var$TOKEN_REGEX).filter((chunk)=>chunk.length > 0);
            if (!chunks.some((part)=>$3dd354b20d6de309$var$TOKEN_PART_REGEX.test(part))) return;
            const fragment = document.createDocumentFragment();
            chunks.forEach((part)=>{
                if ($3dd354b20d6de309$var$TOKEN_PART_REGEX.test(part)) fragment.appendChild($3dd354b20d6de309$var$createTokenBadge(part));
                else fragment.appendChild(document.createTextNode(part));
            });
            child.parentNode?.replaceChild(fragment, child);
            return;
        }
        if (child.nodeType === Node.ELEMENT_NODE) {
            const element = child;
            if (element.dataset.token) return;
            $3dd354b20d6de309$var$replaceTokenTextNodes(element);
        }
    });
};
const $3dd354b20d6de309$var$renderTemplateValue = (root, value, singleLine)=>{
    const hasMarkup = /<[^>]+>/.test(value);
    const html = hasMarkup ? value : $3dd354b20d6de309$var$escapeHtml(value).replace(/\r?\n/g, "<br>");
    root.innerHTML = html;
    $3dd354b20d6de309$var$replaceTokenTextNodes(root);
    if (!root.innerHTML.trim() && !singleLine) root.innerHTML = "<br>";
};
const $3dd354b20d6de309$var$serializeTemplateValue = (root, singleLine)=>{
    const pickSerializableTypographyStyle = (element)=>{
        const style = element.style;
        const pairs = [];
        const push = (prop, value)=>{
            const clean = String(value ?? "").trim();
            if (!clean) return;
            pairs.push(`${prop}:${clean}`);
        };
        push("font-weight", style.fontWeight);
        push("font-style", style.fontStyle);
        push("text-decoration", style.textDecoration);
        push("font-family", style.fontFamily);
        push("font-size", style.fontSize);
        push("line-height", style.lineHeight);
        push("color", style.color);
        return pairs.join(";");
    };
    const copy = root.cloneNode(true);
    copy.querySelectorAll("[data-token]").forEach((element)=>{
        const next = element.nextSibling;
        if (next && next.nodeType === Node.TEXT_NODE && /^\s+$/.test(next.textContent ?? "")) next.textContent = "";
        const tokenValue = element.getAttribute("data-token") ?? element.textContent ?? "";
        const styleValue = pickSerializableTypographyStyle(element);
        if (styleValue) {
            const span = document.createElement("span");
            span.setAttribute("style", styleValue);
            span.textContent = tokenValue;
            element.replaceWith(span);
        } else element.replaceWith(document.createTextNode(tokenValue));
    });
    if (singleLine) copy.innerHTML = copy.innerHTML.replace(/<br\s*\/?>/gi, " ").replace(/\r?\n/g, " ");
    return copy.innerHTML.trim();
};
const $3dd354b20d6de309$var$isTokenAllowed = (token, placeholders)=>placeholders.includes(token);
const $3dd354b20d6de309$export$b7837206f6fd7929 = ({ value: value, onChange: onChange, placeholders: placeholders, placeholder: placeholder, singleLine: singleLine = false, showPlaceholderPalette: showPlaceholderPalette = true, showToolbar: showToolbar = true, onFocus: onFocus, isActive: isActive = false, insertTokenSignal: insertTokenSignal = null, commandSignal: commandSignal = null, showModeToggle: showModeToggle = true, viewMode: controlledViewMode, onViewModeChange: onViewModeChange })=>{
    const editorRef = (0, $acw62.useRef)(null);
    const htmlRef = (0, $acw62.useRef)(null);
    const syncingRef = (0, $acw62.useRef)(false);
    const handledInsertNonceRef = (0, $acw62.useRef)(null);
    const handledCommandNonceRef = (0, $acw62.useRef)(null);
    const draggingTokenIdRef = (0, $acw62.useRef)(null);
    const draggingBadgeRef = (0, $acw62.useRef)(null);
    const droppedInsideEditorRef = (0, $acw62.useRef)(false);
    const [internalViewMode, setInternalViewMode] = (0, $acw62.useState)("rich");
    const viewMode = controlledViewMode ?? internalViewMode;
    const setViewMode = (mode)=>{
        if (controlledViewMode !== undefined) {
            onViewModeChange?.(mode);
            return;
        }
        setInternalViewMode(mode);
    };
    const [dragOver, setDragOver] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (viewMode !== "rich") return;
        const editor = editorRef.current;
        if (!editor) return;
        const current = $3dd354b20d6de309$var$serializeTemplateValue(editor, singleLine);
        if (current === value) return;
        syncingRef.current = true;
        $3dd354b20d6de309$var$renderTemplateValue(editor, value, singleLine);
        syncingRef.current = false;
    }, [
        singleLine,
        value,
        viewMode
    ]);
    const emitChange = (0, $acw62.useCallback)(()=>{
        const editor = editorRef.current;
        if (!editor || syncingRef.current) return;
        onChange($3dd354b20d6de309$var$serializeTemplateValue(editor, singleLine));
    }, [
        onChange,
        singleLine
    ]);
    const insertTokenIntoHtml = (0, $acw62.useCallback)((token)=>{
        const textarea = htmlRef.current;
        if (!textarea || !$3dd354b20d6de309$var$isTokenAllowed(token, placeholders)) return;
        const start = textarea.selectionStart ?? textarea.value.length;
        const end = textarea.selectionEnd ?? textarea.value.length;
        const current = value ?? "";
        const next = `${current.slice(0, start)}${token}${current.slice(end)}`;
        onChange(next);
        requestAnimationFrame(()=>{
            textarea.focus();
            const cursor = start + token.length;
            textarea.setSelectionRange(cursor, cursor);
        });
    }, [
        onChange,
        placeholders,
        value
    ]);
    const applyCommandToSelectedBadges = (0, $acw62.useCallback)((command, valueArg)=>{
        const editor = editorRef.current;
        if (!editor) return false;
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) return false;
        const range = selection.getRangeAt(0);
        const badges = Array.from(editor.querySelectorAll("[data-token]"));
        const selectedBadges = badges.filter((badge)=>{
            try {
                return range.intersectsNode(badge);
            } catch  {
                return false;
            }
        });
        if (!selectedBadges.length) return false;
        selectedBadges.forEach((badge)=>{
            const computed = window.getComputedStyle(badge);
            if (command === "bold") {
                const isBold = Number.parseInt(computed.fontWeight || "400", 10) >= 600;
                badge.style.fontWeight = isBold ? "400" : "700";
                return;
            }
            if (command === "italic") {
                const isItalic = computed.fontStyle === "italic";
                badge.style.fontStyle = isItalic ? "normal" : "italic";
                return;
            }
            if (command === "underline") {
                const hasUnderline = (computed.textDecorationLine || "").includes("underline");
                badge.style.textDecoration = hasUnderline ? "none" : "underline";
                return;
            }
            if (command === "strikeThrough") {
                const hasStrike = (computed.textDecorationLine || "").includes("line-through");
                badge.style.textDecoration = hasStrike ? "none" : "line-through";
                return;
            }
            if (command === "fontName") {
                if (valueArg) badge.style.fontFamily = valueArg;
                return;
            }
            if (command === "fontSize") {
                const map = {
                    "1": "10px",
                    "2": "12px",
                    "3": "14px",
                    "4": "16px",
                    "5": "18px",
                    "6": "22px",
                    "7": "28px"
                };
                if (valueArg && map[valueArg]) badge.style.fontSize = map[valueArg];
                return;
            }
            if (command === "removeFormat") {
                badge.style.fontWeight = "";
                badge.style.fontStyle = "";
                badge.style.textDecoration = "";
                badge.style.fontFamily = "";
                badge.style.fontSize = "";
            }
        });
        return true;
    }, []);
    const insertToken = (0, $acw62.useCallback)((token, targetRange)=>{
        const editor = editorRef.current;
        if (!editor || !$3dd354b20d6de309$var$isTokenAllowed(token, placeholders)) return;
        editor.focus();
        const selection = window.getSelection();
        const range = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
        const requestedRange = targetRange && editor.contains(targetRange.commonAncestorContainer) ? targetRange : null;
        const safeRange = requestedRange ?? (range && editor.contains(range.commonAncestorContainer) ? range : null);
        const badgeNode = $3dd354b20d6de309$var$createTokenBadge(token);
        const fragment = document.createDocumentFragment();
        fragment.appendChild(badgeNode);
        if (!safeRange) editor.appendChild(fragment);
        else {
            safeRange.deleteContents();
            safeRange.insertNode(fragment);
            safeRange.collapse(false);
        }
        if (selection) {
            const cursorRange = document.createRange();
            cursorRange.setStartAfter(badgeNode);
            cursorRange.collapse(true);
            selection.removeAllRanges();
            selection.addRange(cursorRange);
        }
        emitChange();
    }, [
        emitChange,
        placeholders
    ]);
    const createDropRange = (0, $acw62.useCallback)((event)=>{
        const doc = document;
        if (doc.caretRangeFromPoint) return doc.caretRangeFromPoint(event.clientX, event.clientY);
        if (doc.caretPositionFromPoint) {
            const pos = doc.caretPositionFromPoint(event.clientX, event.clientY);
            if (!pos) return null;
            const range = document.createRange();
            range.setStart(pos.offsetNode, pos.offset);
            range.collapse(true);
            return range;
        }
        return null;
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!insertTokenSignal || !isActive) return;
        if (handledInsertNonceRef.current === insertTokenSignal.nonce) return;
        handledInsertNonceRef.current = insertTokenSignal.nonce;
        if (viewMode === "html") {
            insertTokenIntoHtml(insertTokenSignal.token);
            return;
        }
        insertToken(insertTokenSignal.token);
    }, [
        insertToken,
        insertTokenIntoHtml,
        insertTokenSignal,
        isActive,
        viewMode
    ]);
    const applyCommand = (0, $acw62.useCallback)((command, valueArg)=>{
        if (viewMode === "html") {
            if (command === "clear") onChange("");
            return;
        }
        const editor = editorRef.current;
        if (!editor) return;
        if (command === "clear") {
            editor.focus();
            editor.innerHTML = "";
            emitChange();
            return;
        }
        if (command === "createLink") {
            editor.focus();
            const raw = String(valueArg ?? "").trim();
            if (!raw) return;
            const normalized = /^(https?:|mailto:|tel:)/i.test(raw) ? raw : `https://${raw}`;
            document.execCommand("createLink", false, normalized);
            const selection = window.getSelection();
            if (selection && selection.rangeCount > 0) {
                const anchor = selection.anchorNode?.parentElement?.closest("a") ?? selection.focusNode?.parentElement?.closest("a");
                if (anchor) {
                    anchor.setAttribute("target", "_blank");
                    anchor.setAttribute("rel", "noopener noreferrer");
                }
            }
            emitChange();
            return;
        }
        if (command === "bold" || command === "italic" || command === "underline" || command === "strikeThrough" || command === "removeFormat" || command === "fontName" || command === "fontSize") {
            const changedBadgeStyles = applyCommandToSelectedBadges(command, valueArg);
            if (changedBadgeStyles) {
                emitChange();
                return;
            }
        }
        editor.focus();
        document.execCommand(command, false, valueArg);
        const focused = editorRef.current;
        if (focused) $3dd354b20d6de309$var$replaceTokenTextNodes(focused);
        emitChange();
    }, [
        applyCommandToSelectedBadges,
        emitChange,
        onChange,
        viewMode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!commandSignal || !isActive) return;
        if (handledCommandNonceRef.current === commandSignal.nonce) return;
        handledCommandNonceRef.current = commandSignal.nonce;
        applyCommand(commandSignal.command, commandSignal.value);
    }, [
        applyCommand,
        commandSignal,
        isActive
    ]);
    const onDrop = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        setDragOver(false);
        const editor = editorRef.current;
        if (!editor) return;
        const token = event.dataTransfer.getData("text/template-placeholder") || event.dataTransfer.getData("text/plain");
        if (!token || !$3dd354b20d6de309$var$isTokenAllowed(token, placeholders)) return;
        droppedInsideEditorRef.current = true;
        const sourceTokenId = event.dataTransfer.getData("text/template-token-id") || draggingTokenIdRef.current;
        const sourceBadge = sourceTokenId ? editor.querySelector(`[data-token-id="${sourceTokenId}"]`) : null;
        const dropRange = createDropRange(event);
        if (sourceBadge) {
            const sourceRange = document.createRange();
            sourceRange.selectNode(sourceBadge);
            if (dropRange && sourceRange.compareBoundaryPoints(Range.START_TO_END, dropRange) <= 0 && sourceRange.compareBoundaryPoints(Range.END_TO_START, dropRange) >= 0) {
                draggingTokenIdRef.current = null;
                return;
            }
            sourceBadge.remove();
        }
        insertToken(token, dropRange);
        draggingTokenIdRef.current = null;
    }, [
        createDropRange,
        insertToken,
        placeholders
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "template-wysiwyg",
        children: [
            showModeToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "template-wysiwyg-mode-toggle",
                role: "group",
                "aria-label": "Editor-Ansicht",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `template-toolbar-btn${viewMode === "rich" ? " is-active" : ""}`,
                        onClick: ()=>setViewMode("rich"),
                        children: "Editor"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: `template-toolbar-btn${viewMode === "html" ? " is-active" : ""}`,
                        onClick: ()=>setViewMode("html"),
                        children: "HTML"
                    })
                ]
            }) : null,
            showToolbar ? null : null,
            viewMode === "html" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                ref: htmlRef,
                className: `template-wysiwyg-html${singleLine ? " is-single-line" : ""}`,
                value: value,
                placeholder: placeholder ?? "",
                onFocus: onFocus,
                onClick: onFocus,
                onChange: (event)=>onChange(event.target.value),
                onDrop: (event)=>{
                    event.preventDefault();
                    const token = event.dataTransfer.getData("text/template-placeholder") || event.dataTransfer.getData("text/plain");
                    if (!token || !$3dd354b20d6de309$var$isTokenAllowed(token, placeholders)) return;
                    insertTokenIntoHtml(token);
                }
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: editorRef,
                className: `template-wysiwyg-editor${singleLine ? " is-single-line" : ""}${dragOver ? " is-drag-over" : ""}`,
                contentEditable: true,
                suppressContentEditableWarning: true,
                "data-placeholder": placeholder ?? "",
                onFocus: onFocus,
                onClick: onFocus,
                onInput: ()=>{
                    const editor = editorRef.current;
                    if (editor) $3dd354b20d6de309$var$replaceTokenTextNodes(editor);
                    emitChange();
                },
                onBlur: emitChange,
                onPaste: (event)=>{
                    event.preventDefault();
                    const text = event.clipboardData.getData("text/plain");
                    document.execCommand("insertText", false, singleLine ? text.replace(/\r?\n/g, " ") : text);
                },
                onKeyDown: (event)=>{
                    if (singleLine && event.key === "Enter") {
                        event.preventDefault();
                        return;
                    }
                    if (!singleLine && event.key === "Enter") {
                        event.preventDefault();
                        document.execCommand("insertLineBreak");
                    }
                },
                onDragOver: (event)=>{
                    event.preventDefault();
                    setDragOver(true);
                    event.dataTransfer.dropEffect = draggingTokenIdRef.current ? "move" : "copy";
                },
                onDragStart: (event)=>{
                    droppedInsideEditorRef.current = false;
                    draggingBadgeRef.current = null;
                    const target = event.target;
                    let badge = target?.closest("[data-token]");
                    if (!badge) {
                        const selection = window.getSelection();
                        const selectedElement = selection?.anchorNode instanceof Element ? selection.anchorNode : selection?.anchorNode?.parentElement ?? null;
                        badge = selectedElement?.closest?.("[data-token]");
                    }
                    if (!badge) return;
                    const token = badge.getAttribute("data-token") ?? badge.textContent ?? "";
                    const tokenId = badge.getAttribute("data-token-id") ?? "";
                    if (!token) return;
                    event.dataTransfer.setData("text/template-placeholder", token);
                    event.dataTransfer.setData("text/plain", token);
                    if (tokenId) event.dataTransfer.setData("text/template-token-id", tokenId);
                    event.dataTransfer.effectAllowed = "move";
                    draggingTokenIdRef.current = tokenId || null;
                    draggingBadgeRef.current = badge;
                },
                onDragEnd: (event)=>{
                    const sourceBadge = draggingBadgeRef.current;
                    const droppedInsideEditor = droppedInsideEditorRef.current;
                    if (sourceBadge && !droppedInsideEditor && event.dataTransfer.dropEffect === "none" && sourceBadge.isConnected) {
                        sourceBadge.remove();
                        emitChange();
                    }
                    draggingTokenIdRef.current = null;
                    draggingBadgeRef.current = null;
                    droppedInsideEditorRef.current = false;
                    setDragOver(false);
                },
                onDragLeave: ()=>setDragOver(false),
                onDrop: onDrop
            }),
            showPlaceholderPalette ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "template-wysiwyg-placeholder-palette",
                "aria-label": "Platzhalter",
                children: placeholders.map((token)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "template-wysiwyg-placeholder-chip",
                        draggable: true,
                        onDragStart: (event)=>{
                            event.dataTransfer.setData("text/template-placeholder", token);
                            event.dataTransfer.setData("text/plain", token);
                            event.dataTransfer.effectAllowed = "copy";
                        },
                        onClick: ()=>insertToken(token),
                        title: "Per Klick einfuegen oder per Drag-and-Drop in das Textfeld ziehen",
                        children: token
                    }, token))
            }) : null
        ]
    });
};


const $d1021dcf01c81de6$export$f79f9e578a3122a7 = ()=>{
    const qc = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [selectedTemplateKey, setSelectedTemplateKey] = (0, $acw62.useState)("invitation_digital");
    const [templateLane, setTemplateLane] = (0, $acw62.useState)("digital");
    const [subject, setSubject] = (0, $acw62.useState)("");
    const [body, setBody] = (0, $acw62.useState)("");
    const [activeEditor, setActiveEditor] = (0, $acw62.useState)("body");
    const [editorViewMode, setEditorViewMode] = (0, $acw62.useState)({
        subject: "rich",
        body: "rich"
    });
    const [insertSignal, setInsertSignal] = (0, $acw62.useState)(null);
    const [commandSignal, setCommandSignal] = (0, $acw62.useState)(null);
    const [placeholderQuery, setPlaceholderQuery] = (0, $acw62.useState)("");
    const [openPlaceholderGroupKey, setOpenPlaceholderGroupKey] = (0, $acw62.useState)(null);
    const [previewVisible, setPreviewVisible] = (0, $acw62.useState)(false);
    const [pdfPreviewUrl, setPdfPreviewUrl] = (0, $acw62.useState)(null);
    const [testRecipientEmail, setTestRecipientEmail] = (0, $acw62.useState)("");
    const [testMailStatus, setTestMailStatus] = (0, $acw62.useState)(null);
    const [saveStatus, setSaveStatus] = (0, $acw62.useState)(null);
    const getSubjectLineCount = (value)=>{
        const normalized = String(value ?? "").replace(/<br\s*\/?\s*>/gi, "\n").replace(/<\/p>/gi, "\n").replace(/<\/div>/gi, "\n").replace(/<\/li>/gi, "\n").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/\r\n/g, "\n").trim();
        if (!normalized) return 1;
        return normalized.split("\n").length;
    };
    const [subjectLineError, setSubjectLineError] = (0, $acw62.useState)(null);
    const [subjectLengthError, setSubjectLengthError] = (0, $acw62.useState)(null);
    const [bodyLengthError, setBodyLengthError] = (0, $acw62.useState)(null);
    const templatesQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "document-templates"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).documentTemplates()
    });
    const visibleTemplates = (0, $acw62.useMemo)(()=>(templatesQuery.data?.templates ?? []).filter((row)=>row.key !== "ballot_analog"), [
        templatesQuery.data?.templates
    ]);
    const resolveTemplateLane = (row)=>{
        if (row.key.startsWith("trigger_")) return "trigger";
        return row.kanal;
    };
    const templatesInLane = (0, $acw62.useMemo)(()=>visibleTemplates.filter((row)=>resolveTemplateLane(row) === templateLane), [
        visibleTemplates,
        templateLane
    ]);
    const selectedTemplate = templatesInLane.find((row)=>row.key === selectedTemplateKey) ?? templatesInLane[0] ?? visibleTemplates[0];
    (0, $acw62.useEffect)(()=>{
        if (!selectedTemplate) return;
        const lane = resolveTemplateLane(selectedTemplate);
        if (lane !== templateLane) setTemplateLane(lane);
    }, [
        selectedTemplate,
        templateLane
    ]);
    (0, $acw62.useEffect)(()=>{
        const rows = templatesInLane.length > 0 ? templatesInLane : visibleTemplates;
        if (!rows.length) return;
        const selected = rows.find((row)=>row.key === selectedTemplateKey) ?? rows[0];
        if (selected.key !== selectedTemplateKey) {
            setSelectedTemplateKey(selected.key);
            return;
        }
        setSubject(selected.subject);
        setBody(selected.body);
        setSaveStatus(null);
        setSubjectLineError(null);
        setSubjectLengthError(null);
        setBodyLengthError(null);
        setTestMailStatus(null);
    }, [
        templatesInLane,
        visibleTemplates,
        selectedTemplateKey
    ]);
    const saveMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).updateDocumentTemplate(selectedTemplateKey, {
                subject: subject,
                body: body,
                expectedUpdatedAt: selectedTemplate?.updatedAt
            });
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).documentTemplates();
        },
        onSuccess: (nextTemplates)=>{
            qc.setQueryData([
                "document-templates"
            ], nextTemplates);
            setSaveStatus({
                type: "ok",
                text: "Vorlage wurde gespeichert."
            });
        },
        onError: (error)=>{
            setSaveStatus({
                type: "error",
                text: error instanceof Error ? error.message : "Vorlage konnte nicht gespeichert werden."
            });
        }
    });
    const mailPreviewMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (!selectedTemplate) throw new Error("Keine Vorlage ausgew\xe4hlt.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).previewDocumentTemplateMail({
                templateKey: selectedTemplate.key,
                eventType: selectedTemplate.eventType
            });
        }
    });
    const pdfPreviewMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (!selectedTemplate) throw new Error("Keine Vorlage ausgew\xe4hlt.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).previewDocumentTemplatePdf({
                templateKey: selectedTemplate.key,
                eventType: selectedTemplate.eventType
            });
        },
        onSuccess: (blob)=>{
            const nextUrl = URL.createObjectURL(blob);
            setPdfPreviewUrl((prev)=>{
                if (prev) URL.revokeObjectURL(prev);
                return nextUrl;
            });
        },
        onError: ()=>{
            setPdfPreviewUrl((prev)=>{
                if (prev) URL.revokeObjectURL(prev);
                return null;
            });
        }
    });
    const sendTestMailMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            if (!selectedTemplate) throw new Error("Keine Vorlage ausgew\xe4hlt.");
            const recipientEmail = testRecipientEmail.trim();
            if (!recipientEmail) throw new Error("Bitte Empf\xe4nger-E-Mail f\xfcr die Testmail eingeben.");
            return (0, $11320eb8d5d066e4$export$644d8ea042df96a6).sendDocumentTemplatePreviewMailTest({
                templateKey: selectedTemplate.key,
                eventType: selectedTemplate.eventType,
                recipientEmail: recipientEmail
            });
        },
        onSuccess: (result)=>{
            setTestMailStatus({
                type: "ok",
                text: `Testmail an ${result.recipientEmail} versendet${result.messageId ? ` (Message-ID: ${result.messageId})` : ""}.`
            });
        },
        onError: (error)=>{
            setTestMailStatus({
                type: "error",
                text: error instanceof Error ? error.message : "Testmail konnte nicht versendet werden."
            });
        }
    });
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (pdfPreviewUrl) URL.revokeObjectURL(pdfPreviewUrl);
        };
    }, [
        pdfPreviewUrl
    ]);
    const onSubjectChange = (next)=>{
        setSaveStatus(null);
        if (next.length > 400) {
            setSubjectLengthError("Betreff darf maximal 400 Zeichen haben.");
            return;
        }
        setSubjectLengthError(null);
        const lineCount = getSubjectLineCount(next);
        if (lineCount > 3) {
            setSubjectLineError("Betreff darf maximal 3 Zeilen haben.");
            return;
        }
        setSubjectLineError(null);
        setSubject(next);
    };
    const onBodyChange = (next)=>{
        setSaveStatus(null);
        if (next.length > 20000) {
            setBodyLengthError("Textvorlage darf maximal 20000 Zeichen haben.");
            return;
        }
        setBodyLengthError(null);
        setBody(next);
    };
    const placeholders = templatesQuery.data?.placeholders ?? [];
    const apiGroups = templatesQuery.data?.placeholderGroups ?? [];
    const isAnalogTemplate = selectedTemplate?.kanal === "analog";
    const groups = (0, $acw62.useMemo)(()=>{
        if (apiGroups.length > 0) return apiGroups;
        return [
            {
                key: "sonstige",
                label: "Sonstige",
                tokens: placeholders
            }
        ];
    }, [
        apiGroups,
        placeholders
    ]);
    const filteredGroups = (0, $acw62.useMemo)(()=>{
        const query = placeholderQuery.trim().toLowerCase();
        return groups.map((group)=>({
                ...group,
                tokens: group.tokens.filter((token)=>query ? token.toLowerCase().includes(query) : true)
            })).filter((group)=>group.tokens.length > 0);
    }, [
        groups,
        placeholderQuery
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!openPlaceholderGroupKey) return;
        const stillExists = filteredGroups.some((group)=>group.key === openPlaceholderGroupKey);
        if (!stillExists) setOpenPlaceholderGroupKey(null);
    }, [
        filteredGroups,
        openPlaceholderGroupKey
    ]);
    const fireCommand = (command, value)=>{
        setCommandSignal({
            nonce: Date.now(),
            command: command,
            value: value
        });
    };
    const plainBodyText = (0, $acw62.useMemo)(()=>{
        const text = String(body ?? "").replace(/<br\s*\/?\s*>/gi, "\n").replace(/<\/p>/gi, "\n").replace(/<\/div>/gi, "\n").replace(/<\/li>/gi, "\n").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/\r\n/g, "\n");
        return text.trim();
    }, [
        body
    ]);
    const plainSubjectText = (0, $acw62.useMemo)(()=>{
        const text = String(subject ?? "").replace(/<br\s*\/?\s*>/gi, "\n").replace(/<\/p>/gi, "\n").replace(/<\/div>/gi, "\n").replace(/<\/li>/gi, "\n").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/\r\n/g, "\n");
        return text.trim();
    }, [
        subject
    ]);
    const wordCount = (0, $acw62.useMemo)(()=>{
        if (!plainBodyText) return 0;
        return plainBodyText.split(/\s+/).filter(Boolean).length;
    }, [
        plainBodyText
    ]);
    const characterCount = (0, $acw62.useMemo)(()=>plainBodyText.length, [
        plainBodyText
    ]);
    const formatDraftStatus = (value)=>{
        if (!value) return "Letzte Speicherung: vor kurzem";
        const stamp = new Date(value);
        if (Number.isNaN(stamp.getTime())) return "Letzte Speicherung: vor kurzem";
        const diffMs = Date.now() - stamp.getTime();
        const diffMin = Math.max(1, Math.floor(diffMs / 60000));
        if (diffMin < 60) return `Letzte Speicherung: vor ${diffMin} Minute${diffMin === 1 ? "" : "n"}`;
        const diffHours = Math.floor(diffMin / 60);
        if (diffHours < 24) return `Letzte Speicherung: vor ${diffHours} Stunde${diffHours === 1 ? "" : "n"}`;
        return `Letzte Speicherung: ${stamp.toLocaleDateString("de-DE")} ${stamp.toLocaleTimeString("de-DE", {
            hour: "2-digit",
            minute: "2-digit"
        })}`;
    };
    const normalizeTemplateLabel = (label)=>label.replace(/^Trigger:\s*/i, "").trim();
    const normalizePreviewHtml = (html)=>{
        const baseStyle = "<style>html,body{background:#fff!important;}</style>";
        if (/<head[^>]*>/i.test(html)) return html.replace(/<head([^>]*)>/i, `<head$1>${baseStyle}`);
        return `${baseStyle}${html}`;
    };
    const openPreviewPanel = ()=>{
        setPreviewVisible(true);
        setTestMailStatus(null);
        refreshPreview();
    };
    const renderPlaceholderGroupIcon = (groupKey)=>{
        const key = groupKey.toLowerCase();
        if (key.includes("verwaltung")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M4.5 10.5 12 4.8l7.5 5.7v8.2H4.5z",
                    stroke: "currentColor",
                    strokeWidth: "1.6"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M9.2 18.7v-4.3h5.6v4.3",
                    stroke: "currentColor",
                    strokeWidth: "1.6"
                })
            ]
        });
        if (key.includes("objekt")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M4.9 8.2h14.2v10.9H4.9z",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round"
                })
            ]
        });
        if (key.includes("eigent")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "9.1",
                    cy: "9.1",
                    r: "2.5",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "15.8",
                    cy: "8.4",
                    r: "2.1",
                    stroke: "currentColor",
                    strokeWidth: "1.8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round"
                })
            ]
        });
        if (key.includes("einheit")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "5.1",
                    y: "4.8",
                    width: "13.8",
                    height: "14.8",
                    rx: "2.1",
                    stroke: "currentColor",
                    strokeWidth: "1.85"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6",
                    stroke: "currentColor",
                    strokeWidth: "1.85",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M9.2 19.6v-2.9h5.6v2.9",
                    stroke: "currentColor",
                    strokeWidth: "1.85",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
        if (key.includes("beschluss")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 64 64",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M14 49h36",
                    stroke: "currentColor",
                    strokeWidth: "2.4",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "18",
                    y: "38",
                    width: "5",
                    height: "8",
                    rx: "1.2",
                    stroke: "currentColor",
                    strokeWidth: "2.4"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "29",
                    y: "32",
                    width: "5",
                    height: "14",
                    rx: "1.2",
                    stroke: "currentColor",
                    strokeWidth: "2.4"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "40",
                    y: "24",
                    width: "5",
                    height: "22",
                    rx: "1.2",
                    stroke: "currentColor",
                    strokeWidth: "2.4"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M18 30 28.5 20.5 36 26l12-12",
                    stroke: "currentColor",
                    strokeWidth: "2.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M44.5 14H48v3.5",
                    stroke: "currentColor",
                    strokeWidth: "2.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
        if (key.includes("ergebnis")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "7.2",
                    stroke: "currentColor",
                    strokeWidth: "1.6"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m9.2 12.3 1.9 2 3.7-4.1",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
        if (key.includes("zugang")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "5.3",
                    y: "11.1",
                    width: "13.4",
                    height: "8",
                    rx: "2.1",
                    stroke: "currentColor",
                    strokeWidth: "1.6"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M8.7 11V8.7a3.3 3.3 0 1 1 6.6 0V11",
                    stroke: "currentColor",
                    strokeWidth: "1.6"
                })
            ]
        });
        if (key.includes("email")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "4.8",
                    y: "7.1",
                    width: "14.4",
                    height: "9.8",
                    rx: "1.8",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m5.8 8.2 6.2 4.6 6.2-4.6",
                    stroke: "currentColor",
                    strokeWidth: "1.7",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
        if (key.includes("datum")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "4.8",
                    y: "6.1",
                    width: "14.4",
                    height: "13",
                    rx: "2",
                    stroke: "currentColor",
                    strokeWidth: "1.6"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M8.2 4.8v2.6M15.8 4.8v2.6M4.8 9.4h14.4",
                    stroke: "currentColor",
                    strokeWidth: "1.6",
                    strokeLinecap: "round"
                })
            ]
        });
        if (key.includes("layout")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M4.7 19.3h3.6l9.7-9.7a1.8 1.8 0 0 0 0-2.6l-1-1a1.8 1.8 0 0 0-2.6 0L4.7 15.7v3.6Z",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m12.9 7.5 3.6 3.6",
                    stroke: "currentColor",
                    strokeWidth: "1.7"
                })
            ]
        });
        if (key.includes("stimme")) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "13.8",
                    y: "4.8",
                    width: "5.2",
                    height: "3.8",
                    rx: "0.8",
                    stroke: "currentColor",
                    strokeWidth: "1.6"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M10.4 19.2v-6.9a1.3 1.3 0 1 0-2.6 0V16l-1.5-1.2a1.2 1.2 0 0 0-1.6 1.8l3.3 3.1c.5.4 1 .7 1.6.7h2.4c1.5 0 2.8-1.2 2.8-2.8v-3.5a1.2 1.2 0 1 0-2.4 0v1.4",
                    stroke: "currentColor",
                    strokeWidth: "1.6",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "7.2",
                stroke: "currentColor",
                strokeWidth: "1.6"
            })
        });
    };
    const refreshPreview = ()=>{
        if (!selectedTemplate) return;
        if (selectedTemplate.kanal === "analog") {
            pdfPreviewMutation.mutate();
            return;
        }
        mailPreviewMutation.mutate();
    };
    (0, $acw62.useEffect)(()=>{
        if (!selectedTemplate) return;
        refreshPreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedTemplate?.key
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "templates-v2-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "page-header panel resolutions-v2-page-header imports-v2-page-header templates-v2-page-header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "resolutions-v2-title",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "resolutions-v2-title-icon",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M4.8 8a1.8 1.8 0 0 1 1.8-1.8h4.2l1.5 1.7h5.1A1.8 1.8 0 0 1 19.2 9v8.2a1.8 1.8 0 0 1-1.8 1.8H6.6a1.8 1.8 0 0 1-1.8-1.8V8Z",
                                    stroke: "currentColor",
                                    strokeWidth: "1.8",
                                    strokeLinejoin: "round"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "resolutions-v2-title-copy",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-main",
                                    children: "Vorlagen"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-sub",
                                    children: "Gestalten Sie Vorlagen mit Platzhaltern."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "templates-v2-lane-grid",
                "aria-label": "Vorlagentyp w\xe4hlen",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: `templates-v2-lane-card${templateLane === "digital" ? " is-active" : ""}`,
                        onClick: ()=>setTemplateLane("digital"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "templates-v2-lane-dot is-digital",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M7 3.8h7.2l2.8 2.8v13.6H7z",
                                            stroke: "currentColor",
                                            strokeWidth: "1.7"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M14.2 3.8v2.9h2.8M9.6 10.2h4.9M9.6 13h5.9M9.6 15.8h4.1",
                                            stroke: "currentColor",
                                            strokeWidth: "1.7",
                                            strokeLinecap: "round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "templates-v2-lane-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Digitale Dokumente"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        children: "Einladung, Erinnerung, Ergebnis"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: `templates-v2-lane-card${templateLane === "analog" ? " is-active" : ""}`,
                        onClick: ()=>setTemplateLane("analog"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "templates-v2-lane-dot is-analog",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            x: "7.2",
                                            y: "4.8",
                                            width: "9.6",
                                            height: "4.2",
                                            rx: "0.8",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            x: "5.2",
                                            y: "9.4",
                                            width: "13.6",
                                            height: "7.2",
                                            rx: "1.8",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            x: "7.4",
                                            y: "14.6",
                                            width: "9.2",
                                            height: "4.6",
                                            rx: "0.9",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: "15.9",
                                            cy: "12.9",
                                            r: "0.9",
                                            fill: "currentColor"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "templates-v2-lane-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Analoge Dokumente"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        children: "Einladung, Erinnerung, Ergebnis"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: `templates-v2-lane-card${templateLane === "trigger" ? " is-active" : ""}`,
                        onClick: ()=>setTemplateLane("trigger"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "templates-v2-lane-dot is-trigger",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M4.8 7.1h14.4v9.8H4.8z",
                                            stroke: "currentColor",
                                            strokeWidth: "1.7"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "m5.8 8.2 6.2 4.6 6.2-4.6",
                                            stroke: "currentColor",
                                            strokeWidth: "1.7",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "templates-v2-lane-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Trigger Nachrichten"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        children: "Benarichtungstexte an Verwaltung"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "templates-main-section templates-v2-main-grid",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "templates-v2-column templates-v2-column--left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "templates-v2-pane templates-v2-unified-editor-pane",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "templates-v2-step-head templates-v2-step-head--with-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "templates-v2-step-icon is-step-1",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M7 3.8h7.2l2.8 2.8v13.6H7z",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.7"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M14.2 3.8v2.9h2.8M9.6 10.2h4.9M9.6 13h5.9M9.6 15.8h4.1",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.7",
                                                        strokeLinecap: "round"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "templates-v2-step-title",
                                            children: "Vorlage w\xe4hlen"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                            className: "templates-v2-template-select",
                                            value: selectedTemplate?.key ?? selectedTemplateKey,
                                            onChange: (e)=>setSelectedTemplateKey(e.target.value),
                                            children: (templatesInLane.length > 0 ? templatesInLane : visibleTemplates).map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: row.key,
                                                    children: normalizeTemplateLabel(row.name)
                                                }, row.key))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "templates-v2-pane templates-v2-placeholders-pane",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "template-collapsible-header",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "templates-v2-step-head",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "templates-v2-step-icon is-step-2",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M9.1 7.2 5.8 12l3.3 4.8M14.9 7.2l3.3 4.8-3.3 4.8",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M12.9 6.8 11.1 17.2",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.6",
                                                                    strokeLinecap: "round"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "templates-v2-step-title",
                                                        children: "Platzhalter"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "templates-v2-search-field templates-v2-placeholder-head-search",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "templates-v2-search-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "11.2",
                                                                    cy: "11.2",
                                                                    r: "5.7",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "m15.4 15.4 3.2 3.2",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: placeholderQuery,
                                                        onChange: (e)=>setPlaceholderQuery(e.target.value),
                                                        placeholder: "Platzhalter suchen..."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "template-placeholder-shared-box",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `template-placeholder-groups${openPlaceholderGroupKey ? "" : " is-collapsed-view"}`,
                                            children: (openPlaceholderGroupKey ? filteredGroups.filter((group)=>group.key === openPlaceholderGroupKey) : filteredGroups).map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "template-placeholder-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "template-placeholder-group-title template-placeholder-group-trigger",
                                                            onClick: ()=>setOpenPlaceholderGroupKey((prev)=>prev === group.key ? null : group.key),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "template-placeholder-group-label",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "template-placeholder-group-icon",
                                                                            "aria-hidden": "true",
                                                                            children: renderPlaceholderGroupIcon(group.key)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: group.label
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "template-placeholder-group-count",
                                                                            children: group.tokens.length
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "template-placeholder-group-arrow",
                                                                    children: openPlaceholderGroupKey === group.key ? "\u2304" : "\u203A"
                                                                })
                                                            ]
                                                        }),
                                                        openPlaceholderGroupKey === group.key ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "template-wysiwyg-placeholder-palette",
                                                            "aria-label": `Platzhalter ${group.label}`,
                                                            children: group.tokens.map((token)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "template-wysiwyg-placeholder-chip",
                                                                    draggable: true,
                                                                    onDragStart: (event)=>{
                                                                        event.dataTransfer.setData("text/template-placeholder", token);
                                                                        event.dataTransfer.setData("text/plain", token);
                                                                        event.dataTransfer.effectAllowed = "copy";
                                                                    },
                                                                    onClick: ()=>setInsertSignal({
                                                                            nonce: Date.now(),
                                                                            token: token
                                                                        }),
                                                                    children: token
                                                                }, `${group.key}-${token}`))
                                                        }) : null
                                                    ]
                                                }, group.key))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "templates-v2-placeholder-footer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "templates-v2-placeholder-footer-icon",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M12 3.8v16.4M3.8 12h16.4",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "m12 3.8 2.1 2.1M12 3.8 9.9 5.9M12 20.2l2.1-2.1M12 20.2l-2.1-2.1M3.8 12l2.1 2.1M3.8 12l2.1-2.1M20.2 12l-2.1 2.1M20.2 12l-2.1-2.1",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                            x: "9.2",
                                                            y: "9.2",
                                                            width: "5.6",
                                                            height: "5.6",
                                                            rx: "1.2",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.6"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "templates-v2-placeholder-footer-copy",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Platzhalter per Klick einf\xfcgen"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "oder per Drag & Drop in den Editor ziehen."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "templates-v2-column templates-v2-column--center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "templates-v2-editor-shell",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "templates-v2-pane",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "templates-v2-editor-header",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "templates-v2-step-head templates-v2-step-head--editor",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "templates-v2-step-icon is-step-3",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M4 20h4l10.5-10.5a1.9 1.9 0 0 0 0-2.7l-1.3-1.3a1.9 1.9 0 0 0-2.7 0L4 16v4Z",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "m13 6 5 5",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "1.7"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "templates-v2-editor-head-copy",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                        className: "templates-v2-step-title",
                                                                        children: "Vorlage gestalten"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "templates-v2-help-text templates-v2-editor-subtitle",
                                                                        children: "F\xfcgen Sie Platzhalter in den Text ein und gestalten Sie Ihre Vorlage."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "templates-v2-editor-header-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "templates-v2-editor-tabs templates-v2-editor-tabs--header",
                                                            role: "tablist",
                                                            "aria-label": "Editor-Bereich",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    role: "tab",
                                                                    "aria-selected": activeEditor === "subject",
                                                                    className: `templates-v2-editor-tab${activeEditor === "subject" ? " is-active" : ""}`,
                                                                    onClick: ()=>setActiveEditor("subject"),
                                                                    children: "Betreff"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    role: "tab",
                                                                    "aria-selected": activeEditor === "body",
                                                                    className: `templates-v2-editor-tab${activeEditor === "body" ? " is-active" : ""}`,
                                                                    onClick: ()=>setActiveEditor("body"),
                                                                    children: "Textvorlage"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "templates-v2-open-preview-bottom",
                                                            onClick: ()=>openPreviewPanel(),
                                                            disabled: !selectedTemplate,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "templates-v2-open-preview-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M2.9 12c1.9-3.6 5.4-5.6 9.1-5.6s7.2 2 9.1 5.6c-1.9 3.6-5.4 5.6-9.1 5.6s-7.2-2-9.1-5.6Z",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                cx: "12",
                                                                                cy: "12",
                                                                                r: "2.8",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                "Vorschau \xf6ffnen"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            className: "templates-v2-save-button",
                                                            onClick: ()=>saveMutation.mutate(),
                                                            disabled: saveMutation.isPending || !subject.trim() || !body.trim() || !selectedTemplate || Boolean(subjectLineError) || Boolean(subjectLengthError) || Boolean(bodyLengthError),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "resolutions-v2-create-btn-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M4.4 4.4h9.1l2.1 2.1v9.1H4.4z",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "M7 4.4v4h6v-4M7.4 15h5.2",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.7",
                                                                                strokeLinecap: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: saveMutation.isPending ? "Speichere..." : "Vorlage speichern"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "templates-v2-pane templates-v2-pane--editor",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "templates-v2-editor-inner-box",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "template-shared-toolbar-wrap",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "template-wysiwyg-toolbar template-wysiwyg-toolbar--shared",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("undo"),
                                                                title: "R\xfcckg\xe4ngig",
                                                                children: "\u21B6"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("redo"),
                                                                title: "Wiederholen",
                                                                children: "\u21B7"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "templates-v2-toolbar-divider"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                className: "template-toolbar-select",
                                                                defaultValue: "absatz",
                                                                "aria-label": "Format",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "absatz",
                                                                        children: "Absatz"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "ueberschrift",
                                                                        children: "\xdcberschrift"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                className: "template-toolbar-select",
                                                                onChange: (e)=>fireCommand("fontName", e.target.value),
                                                                defaultValue: "Arial",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "Arial",
                                                                        children: "Arial"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "Calibri",
                                                                        children: "Calibri"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "Helvetica",
                                                                        children: "Helvetica"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "Georgia",
                                                                        children: "Georgia"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "Courier New",
                                                                        children: "Monospace"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                className: "template-toolbar-select",
                                                                onChange: (e)=>fireCommand("fontSize", e.target.value),
                                                                defaultValue: "2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "1",
                                                                        children: "10"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "2",
                                                                        children: "11"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "3",
                                                                        children: "12"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "4",
                                                                        children: "14"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "5",
                                                                        children: "16"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "templates-v2-toolbar-divider"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("bold"),
                                                                title: "Fett",
                                                                children: "B"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("italic"),
                                                                title: "Kursiv",
                                                                children: "I"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("underline"),
                                                                title: "Unterstrichen",
                                                                children: "U"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("strikeThrough"),
                                                                title: "Durchgestrichen",
                                                                children: "S"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "templates-v2-toolbar-divider"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("justifyLeft"),
                                                                title: "Linksb\xfcndig",
                                                                children: "\u21E4"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("justifyCenter"),
                                                                title: "Zentriert",
                                                                children: "\u21C6"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("justifyRight"),
                                                                title: "Rechtsb\xfcndig",
                                                                children: "\u21E5"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "templates-v2-toolbar-divider"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("insertUnorderedList"),
                                                                title: "Aufz\xe4hlung",
                                                                children: "\u2022"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("insertOrderedList"),
                                                                title: "Nummerierte Liste",
                                                                children: "1."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "templates-v2-toolbar-divider"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: `template-toolbar-btn template-toolbar-btn--label${editorViewMode[activeEditor] === "rich" ? " is-active" : ""}`,
                                                                onClick: ()=>setEditorViewMode((prev)=>({
                                                                            ...prev,
                                                                            [activeEditor]: "rich"
                                                                        })),
                                                                children: "Editor"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: `template-toolbar-btn template-toolbar-btn--label${editorViewMode[activeEditor] === "html" ? " is-active" : ""}`,
                                                                onClick: ()=>setEditorViewMode((prev)=>({
                                                                            ...prev,
                                                                            [activeEditor]: "html"
                                                                        })),
                                                                children: "HTML"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>{
                                                                    const url = window.prompt("Link-URL eingeben");
                                                                    if (url) fireCommand("createLink", url);
                                                                },
                                                                title: "Link einf\xfcgen",
                                                                children: "\uD83D\uDD17"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--icon",
                                                                onClick: ()=>fireCommand("unlink"),
                                                                title: "Link entfernen",
                                                                children: "\u26D3"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--label",
                                                                onClick: ()=>fireCommand("removeFormat"),
                                                                children: "Format l\xf6schen"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "template-toolbar-btn template-toolbar-btn--label",
                                                                onClick: ()=>fireCommand("clear"),
                                                                children: "Alles l\xf6schen"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3dd354b20d6de309$export$b7837206f6fd7929), {
                                                    value: activeEditor === "subject" ? subject : body,
                                                    onChange: (next)=>{
                                                        if (activeEditor === "subject") onSubjectChange(next);
                                                        else onBodyChange(next);
                                                    },
                                                    placeholders: placeholders,
                                                    placeholder: activeEditor === "subject" ? "Betreff eingeben ..." : "Textvorlage eingeben ...",
                                                    showToolbar: false,
                                                    showPlaceholderPalette: false,
                                                    onFocus: ()=>setActiveEditor(activeEditor),
                                                    isActive: true,
                                                    insertTokenSignal: insertSignal,
                                                    commandSignal: commandSignal,
                                                    showModeToggle: false,
                                                    viewMode: activeEditor === "subject" ? editorViewMode.subject : editorViewMode.body,
                                                    onViewModeChange: (mode)=>setEditorViewMode((prev)=>({
                                                                ...prev,
                                                                [activeEditor]: mode
                                                            }))
                                                }),
                                                activeEditor === "subject" && subjectLineError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "error-text",
                                                    style: {
                                                        marginTop: 6
                                                    },
                                                    children: subjectLineError
                                                }) : null,
                                                activeEditor === "subject" && subjectLengthError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "error-text",
                                                    style: {
                                                        marginTop: 6
                                                    },
                                                    children: subjectLengthError
                                                }) : null,
                                                activeEditor === "body" && bodyLengthError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "error-text",
                                                    style: {
                                                        marginTop: 6
                                                    },
                                                    children: bodyLengthError
                                                }) : null,
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "templates-v2-editor-meta",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                "W\xf6rter: ",
                                                                activeEditor === "subject" ? plainSubjectText ? plainSubjectText.split(/\s+/).filter(Boolean).length : 0 : wordCount
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                "Zeichen: ",
                                                                activeEditor === "subject" ? plainSubjectText.length : characterCount
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "templates-v2-draft-state",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "templates-v2-draft-state-icon",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                                cx: "10",
                                                                                cy: "10",
                                                                                r: "7",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                d: "m7.2 10.1 1.9 2 3.8-4.1",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: formatDraftStatus(selectedTemplate?.updatedAt)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            saveStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "templates-v2-help-text",
                                children: saveStatus.text
                            }) : null
                        ]
                    })
                ]
            }),
            previewVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "templates-v2-preview-overlay",
                role: "dialog",
                "aria-modal": "true",
                "aria-label": "Vorschau",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "templates-v2-preview-overlay-card",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "templates-v2-preview-overlay-head",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Vorschau"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setPreviewVisible(false),
                                    children: "Schlie\xdfen"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "templates-v2-preview-overlay-body",
                            children: isAnalogTemplate ? pdfPreviewMutation.isPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "templates-v2-inline-preview-state",
                                children: "Lade Vorschau..."
                            }) : pdfPreviewMutation.isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "error-text",
                                children: pdfPreviewMutation.error instanceof Error ? pdfPreviewMutation.error.message : "PDF-Vorschau konnte nicht geladen werden."
                            }) : pdfPreviewUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                title: "PDF-Vorschau",
                                src: `${pdfPreviewUrl}#zoom=100`,
                                className: "templates-v2-inline-preview-frame"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "templates-v2-inline-preview-state",
                                children: "Keine PDF-Vorschau verf\xfcgbar."
                            }) : mailPreviewMutation.isPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "templates-v2-inline-preview-state",
                                children: "Lade Vorschau..."
                            }) : mailPreviewMutation.isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "error-text",
                                children: mailPreviewMutation.error instanceof Error ? mailPreviewMutation.error.message : "Vorschau konnte nicht geladen werden."
                            }) : mailPreviewMutation.data ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                title: "Mail-Vorschau",
                                srcDoc: normalizePreviewHtml(mailPreviewMutation.data.html),
                                className: "templates-v2-inline-preview-frame"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "templates-v2-inline-preview-state",
                                children: "Keine Vorschau verf\xfcgbar."
                            })
                        }),
                        !isAnalogTemplate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "templates-v2-preview-overlay-testmail",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Testmail senden"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "templates-v2-preview-overlay-testmail-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "email",
                                            value: testRecipientEmail,
                                            onChange: (e)=>setTestRecipientEmail(e.target.value),
                                            placeholder: "empfaenger@beispiel.de"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>{
                                                setTestMailStatus(null);
                                                sendTestMailMutation.mutate();
                                            },
                                            disabled: sendTestMailMutation.isPending || !selectedTemplate || !mailPreviewMutation.data,
                                            children: sendTestMailMutation.isPending ? "Sende..." : "Testmail senden"
                                        })
                                    ]
                                }),
                                testMailStatus ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: `templates-v2-preview-overlay-testmail-status ${testMailStatus.type === "ok" ? "is-ok" : "is-error"}`,
                                    children: testMailStatus.text
                                }) : null
                            ]
                        }) : null
                    ]
                })
            }) : null
        ]
    });
};




var $acw62 = parcelRequire("acw62");



var $7da634ecebe13da7$import_meta = Object.assign(Object.create(null), {
    url: "file:///src/app/ui-framework.ts"
});
const $7da634ecebe13da7$var$UI_FRAMEWORK_STORAGE_KEY = "umlauf-ui-framework";
const $7da634ecebe13da7$var$UI_FRAMEWORK_QUERY_KEY = "uiFramework";
const $7da634ecebe13da7$var$UI_FRAMEWORK_V2_CLASS = "framework-v2";
const $7da634ecebe13da7$var$normalizeMode = (value)=>{
    const normalized = String(value ?? "").trim().toLowerCase();
    if (!normalized) return null;
    if (normalized === "classic" || normalized === "v1" || normalized === "legacy") return "classic";
    if (normalized === "mockup_v2" || normalized === "v2" || normalized === "mockup" || normalized === "neu") return "mockup_v2";
    return null;
};
const $7da634ecebe13da7$var$readModeFromQuery = ()=>{
    if (typeof window === "undefined") return null;
    const params = new URLSearchParams(window.location.search);
    return $7da634ecebe13da7$var$normalizeMode(params.get($7da634ecebe13da7$var$UI_FRAMEWORK_QUERY_KEY));
};
const $7da634ecebe13da7$var$readModeFromStorage = ()=>{
    if (typeof window === "undefined") return null;
    try {
        return $7da634ecebe13da7$var$normalizeMode(window.localStorage.getItem($7da634ecebe13da7$var$UI_FRAMEWORK_STORAGE_KEY));
    } catch  {
        return null;
    }
};
const $7da634ecebe13da7$var$persistMode = (mode)=>{
    if (typeof window === "undefined") return;
    try {
        window.localStorage.setItem($7da634ecebe13da7$var$UI_FRAMEWORK_STORAGE_KEY, mode);
    } catch  {
    // ignore persistence errors in private mode or restricted contexts
    }
};
const $7da634ecebe13da7$var$readModeFromEnv = ()=>{
    const envValue = $7da634ecebe13da7$import_meta.env?.VITE_UI_FRAMEWORK;
    return $7da634ecebe13da7$var$normalizeMode(envValue) ?? "classic";
};
const $7da634ecebe13da7$export$e29bc38eca71b17d = ()=>{
    const queryMode = $7da634ecebe13da7$var$readModeFromQuery();
    if (queryMode) {
        $7da634ecebe13da7$var$persistMode(queryMode);
        return queryMode;
    }
    return $7da634ecebe13da7$var$readModeFromStorage() ?? $7da634ecebe13da7$var$readModeFromEnv();
};
const $7da634ecebe13da7$export$88022c82616459fa = (mode)=>{
    const isV2 = mode === "mockup_v2";
    if (typeof document !== "undefined") {
        document.documentElement.classList.toggle($7da634ecebe13da7$var$UI_FRAMEWORK_V2_CLASS, isV2);
        document.body.classList.toggle($7da634ecebe13da7$var$UI_FRAMEWORK_V2_CLASS, isV2);
    }
    $7da634ecebe13da7$var$persistMode(mode);
    return mode;
};
const $7da634ecebe13da7$export$9ef08184088ccf85 = ()=>$7da634ecebe13da7$export$88022c82616459fa($7da634ecebe13da7$export$e29bc38eca71b17d());



var $fb8ca5e1e5184a90$exports = {};
$fb8ca5e1e5184a90$exports = import.meta.resolve("5Wcg0");


const $38498fd0c4d2b7b0$var$ownerLoginBackgroundUrl = new URL($fb8ca5e1e5184a90$exports).toString();
var $430b6c9b15862611$exports = {};
$430b6c9b15862611$exports = import.meta.resolve("c319f");


const $38498fd0c4d2b7b0$var$ownerLoginVisualUrl = new URL($430b6c9b15862611$exports).toString();
const $38498fd0c4d2b7b0$var$loadOwnerBranding = ()=>{
    const ui = (0, $5806306cf67ca7cd$export$cc8e577c185b57cb)();
    return {
        firmenname: ui.management.firmenname,
        email: ui.management.email,
        logoDataUrl: ui.ownerLogoDataUrl,
        uiFramework: ui.management.uiFramework,
        theme: ui.ownerTheme
    };
};
const $38498fd0c4d2b7b0$var$ownerThemeVars = (theme)=>({
        "--bg": theme.bg,
        "--surface": theme.surface,
        "--line": theme.line,
        "--text": theme.text,
        "--primary": theme.primary,
        "--owner-gradient-from": theme.gradientFrom,
        "--owner-gradient-to": theme.gradientTo,
        "--owner-gradient-enabled": theme.gradientEnabled ? "1" : "0",
        "--owner-gradient-strength": theme.gradientEnabled ? "100%" : "0%",
        "--owner-login-bg-image-enabled": theme.ownerLoginBackgroundImageEnabled ? "1" : "0",
        "--owner-login-bg-image": `url("${$38498fd0c4d2b7b0$var$ownerLoginBackgroundUrl}")`,
        "--owner-login-visual-image": `url("${$38498fd0c4d2b7b0$var$ownerLoginVisualUrl}")`
    });
const $38498fd0c4d2b7b0$export$50ac8e7e243eb1ae = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [beschlussId, setBeschlussId] = (0, $acw62.useState)("");
    const [zugangspasswort, setZugangspasswort] = (0, $acw62.useState)("");
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)("");
    const localBranding = (0, $acw62.useMemo)(()=>$38498fd0c4d2b7b0$var$loadOwnerBranding(), []);
    const brandingQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-public"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiBranding(),
        retry: 1,
        staleTime: 60000
    });
    const branding = (0, $acw62.useMemo)(()=>{
        const ui = brandingQuery.data;
        if (!ui) return localBranding;
        return {
            firmenname: ui.management.firmenname,
            email: ui.management.email,
            logoDataUrl: ui.ownerLogoDataUrl,
            uiFramework: ui.management.uiFramework,
            theme: ui.ownerTheme
        };
    }, [
        brandingQuery.data,
        localBranding
    ]);
    const companyName = String(branding.firmenname || "ObjektVote").trim();
    (0, $acw62.useEffect)(()=>{
        (0, $7da634ecebe13da7$export$88022c82616459fa)(branding.uiFramework === "mockup_v2" ? "mockup_v2" : "classic");
    }, [
        branding.uiFramework
    ]);
    (0, $acw62.useEffect)(()=>{
        document.title = "ObjektVote | Login";
    }, []);
    const loginMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).ownerVotingLogin({
                beschluss_id: beschlussId.trim(),
                zugangspasswort: zugangspasswort.trim()
            }),
        onSuccess: (data)=>{
            setError("");
            navigate(`${data.redirect_path}?mode=login`);
        },
        onError: (e)=>{
            const raw = e instanceof Error ? e.message : "Login fehlgeschlagen";
            if (raw.includes("401")) {
                setError("Zugangspasswort ung\xfcltig.");
                return;
            }
            if (raw.includes("404")) {
                setError("Beschluss wurde nicht gefunden.");
                return;
            }
            setError("Anmeldung fehlgeschlagen. Bitte Eingaben pr\xfcfen und erneut versuchen.");
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: `owner-auth-shell owner-auth-shell-centered owner-login-shell${branding.theme.ownerLoginBackgroundImageEnabled ? " owner-login-shell--bg-on" : ""}`,
        style: $38498fd0c4d2b7b0$var$ownerThemeVars(branding.theme),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "panel owner-login-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "owner-auth-head owner-login-head",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-auth-kicker owner-login-kicker",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            "aria-hidden": "true",
                                            className: "owner-login-kicker-icon",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M12 3.5 5 6v5.4c0 4.3 2.7 8.2 7 9.8 4.3-1.6 7-5.5 7-9.8V6l-7-2.5Z",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "m9.3 12 1.8 1.9 3.6-3.9",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Digitale Abstimmung"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "owner-auth-title owner-login-title",
                                    children: "ObjektVote"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "owner-auth-subtitle owner-login-subtitle",
                                    children: "Ihre Stimme sicher online abgeben."
                                })
                            ]
                        }),
                        branding.logoDataUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: branding.logoDataUrl,
                            alt: "Firmenlogo",
                            className: "owner-auth-logo owner-auth-logo-right owner-login-logo"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "owner-auth-divider owner-login-divider"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "owner-login-main-grid",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "owner-login-form-col",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "owner-login-section-title",
                                    children: "Anmeldung"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field owner-login-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Beschluss-ID"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "owner-login-input-wrap",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "owner-login-input-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                x: "5",
                                                                y: "3.8",
                                                                width: "14",
                                                                height: "16.4",
                                                                rx: "2",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.7"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M9 8.2h6M9 12h6M9 15.8h4.5",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.7",
                                                                strokeLinecap: "round"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "table-field owner-login-input",
                                                    value: beschlussId,
                                                    onChange: (e)=>setBeschlussId(e.target.value.slice(0, 10)),
                                                    placeholder: "z.B. B-2026-001",
                                                    autoComplete: "off",
                                                    maxLength: 10
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field owner-login-field owner-auth-password-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Zugangspasswort"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "owner-login-input-wrap owner-login-password-wrap",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "owner-login-input-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                x: "4.2",
                                                                y: "10.5",
                                                                width: "15.6",
                                                                height: "10.5",
                                                                rx: "2",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M8.4 10.5V7.8a3.6 3.6 0 1 1 7.2 0v2.7",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "table-field owner-login-input",
                                                    type: showPassword ? "text" : "password",
                                                    value: zugangspasswort,
                                                    onChange: (e)=>setZugangspasswort(e.target.value.replace(/\s+/g, "").slice(0, 6)),
                                                    placeholder: "6-stelliges Passwort",
                                                    autoComplete: "current-password",
                                                    maxLength: 6
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "owner-login-eye-btn",
                                                    onClick: ()=>setShowPassword((v)=>!v),
                                                    "aria-label": showPassword ? "Passwort verbergen" : "Passwort anzeigen",
                                                    title: showPassword ? "Passwort verbergen" : "Passwort anzeigen",
                                                    children: showPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        "aria-hidden": "true",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "3.2",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M4 4l16 16",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        "aria-hidden": "true",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "3.2",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "error-text",
                                    children: error
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-actions owner-login-actions",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "owner-login-submit",
                                        disabled: loginMutation.isPending || !beschlussId.trim() || !zugangspasswort.trim(),
                                        onClick: ()=>loginMutation.mutate(),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                "aria-hidden": "true",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                        x: "4.2",
                                                        y: "10.5",
                                                        width: "15.6",
                                                        height: "10.5",
                                                        rx: "2",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M8.4 10.5V7.8a3.6 3.6 0 1 1 7.2 0v2.7",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: loginMutation.isPending ? "Anmeldung l\xe4uft..." : "Zur Abstimmung"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "owner-login-visual-col",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: $38498fd0c4d2b7b0$var$ownerLoginVisualUrl,
                                alt: "",
                                className: "owner-login-visual-image"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "owner-login-footer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "owner-login-footer-block",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "owner-login-footer-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                x: "3.6",
                                                y: "5.2",
                                                width: "16.8",
                                                height: "13.6",
                                                rx: "2.4",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "m5.6 7 6.4 5 6.4-5",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-login-footer-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: companyName
                                        }),
                                        branding.email ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: `mailto:${branding.email}`,
                                            children: branding.email
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "owner-login-footer-block",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "owner-login-footer-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M12 3.5 5 6v5.4c0 4.3 2.7 8.2 7 9.8 4.3-1.6 7-5.5 7-9.8V6l-7-2.5Z",
                                            stroke: "currentColor",
                                            strokeWidth: "1.8",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-login-footer-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Sichere & verschl\xfcsselte Verbindung"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Ihre Daten sind bei uns sicher."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");







const $d728b52521bfced6$var$ownerPageBackgroundUrl = new URL($fb8ca5e1e5184a90$exports).toString();
const $d728b52521bfced6$var$formatDateTimeDE = (value)=>{
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return new Intl.DateTimeFormat("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    }).format(d);
};
const $d728b52521bfced6$var$formatDateDE = (value)=>{
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return new Intl.DateTimeFormat("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    }).format(d);
};
const $d728b52521bfced6$var$formatUnitNumber4Digits = (value)=>{
    const raw = String(value ?? "").trim();
    if (!raw) return "-";
    if (/^\d+$/.test(raw)) return raw.padStart(4, "0");
    return raw;
};
const $d728b52521bfced6$var$formatStatus = (status)=>{
    if (status === "aktiv") return "l\u00e4uft";
    if (status === "abgeschlossen") return "beendet";
    return "Entwurf";
};
const $d728b52521bfced6$var$formatQuorum = (quorum)=>{
    if (quorum === "qualifizierte_mehrheit") return "Qualifizierte Mehrheit";
    if (quorum === "allstimmig") return "Allstimmig";
    return "Einfache Mehrheit";
};
const $d728b52521bfced6$var$formatPower = (value)=>{
    if (!Number.isFinite(value)) return "0";
    if (Math.abs(value % 1) < 0.00001) return String(Math.round(value));
    return value.toFixed(2).replace(".", ",");
};
const $d728b52521bfced6$var$voteLabel = (value)=>{
    if (value === "ja") return "Ja";
    if (value === "nein") return "Nein";
    if (value === "enthaltung") return "Enthaltung";
    return "Offen";
};
const $d728b52521bfced6$var$voteBadgeClass = (value)=>{
    if (value === "ja") return "vote-ja";
    if (value === "nein") return "vote-nein";
    if (value === "enthaltung") return "vote-enthaltung";
    return "vote-offen";
};
const $d728b52521bfced6$var$OwnerResultDonut = ({ ja: ja, nein: nein, enthaltung: enthaltung })=>{
    const bewerteteSumme = Math.max(ja + nein, 0);
    const gesamtMitEnthaltung = Math.max(ja + nein + enthaltung, 0);
    const jaPct = bewerteteSumme > 0 ? ja / bewerteteSumme * 100 : 0;
    const neinPct = bewerteteSumme > 0 ? nein / bewerteteSumme * 100 : 0;
    const jaSegment = gesamtMitEnthaltung > 0 ? ja / gesamtMitEnthaltung * 100 : 0;
    const neinSegment = gesamtMitEnthaltung > 0 ? nein / gesamtMitEnthaltung * 100 : 0;
    const p1 = jaSegment;
    const p2 = jaSegment + neinSegment;
    const gradient = gesamtMitEnthaltung > 0 ? `conic-gradient(#2f7d32 0% ${p1}%, #a12b2b ${p1}% ${p2}%, #e0b000 ${p2}% 100%)` : "conic-gradient(#e5e9ee 0% 100%)";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: "flex",
            gap: 14,
            alignItems: "center",
            flexWrap: "wrap",
            marginTop: 10
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "aria-label": "Stimmen Kreisdiagramm",
                title: "Stimmenverteilung",
                style: {
                    width: 156,
                    height: 156,
                    borderRadius: "50%",
                    background: gradient,
                    position: "relative",
                    border: "1px solid var(--line)"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        inset: 38,
                        borderRadius: "50%",
                        background: "var(--surface)",
                        border: "1px solid var(--line)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        color: "var(--text-soft)",
                        textAlign: "center",
                        padding: 6,
                        whiteSpace: "pre-line"
                    },
                    children: gesamtMitEnthaltung > 0 ? `${gesamtMitEnthaltung}` + "\nStimmen" : "Keine\nStimmen"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "grid",
                    gap: 6,
                    minWidth: 190
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "120px auto",
                            alignItems: "center",
                            columnGap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            background: "#2f7d32"
                                        }
                                    }),
                                    "Ja"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    ja.toFixed(2),
                                    " (",
                                    jaPct.toFixed(1),
                                    " %)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "120px auto",
                            alignItems: "center",
                            columnGap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            background: "#a12b2b"
                                        }
                                    }),
                                    "Nein"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    nein.toFixed(2),
                                    " (",
                                    neinPct.toFixed(1),
                                    " %)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "120px auto",
                            alignItems: "center",
                            columnGap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            background: "#e0b000"
                                        }
                                    }),
                                    "Enthaltung"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    enthaltung.toFixed(2),
                                    " (ohne Bewertung)"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $d728b52521bfced6$var$isPreviewableOwnerDocument = (doc)=>{
    const mime = (doc.mimeType ?? "").toLowerCase();
    if (mime === "application/pdf" || mime.startsWith("image/")) return true;
    const name = String(doc.originalName ?? "").trim().toLowerCase();
    if (name.endsWith(".pdf")) return true;
    if (name.endsWith(".png") || name.endsWith(".jpg") || name.endsWith(".jpeg") || name.endsWith(".gif") || name.endsWith(".webp") || name.endsWith(".svg")) return true;
    const fileUrl = String(doc.fileUrl ?? "").toLowerCase();
    if (fileUrl.includes(".pdf")) return true;
    return false;
};
const $d728b52521bfced6$var$loadOwnerBranding = ()=>{
    const ui = (0, $5806306cf67ca7cd$export$cc8e577c185b57cb)();
    return {
        firmenname: ui.management.firmenname,
        logoDataUrl: ui.ownerLogoDataUrl,
        uiFramework: ui.management.uiFramework,
        theme: ui.ownerTheme
    };
};
const $d728b52521bfced6$var$ownerThemeVars = (theme)=>({
        "--bg": theme.bg,
        "--surface": theme.surface,
        "--line": theme.line,
        "--text": theme.text,
        "--primary": theme.primary,
        "--owner-gradient-from": theme.gradientFrom,
        "--owner-gradient-to": theme.gradientTo,
        "--owner-gradient-enabled": theme.gradientEnabled ? "1" : "0",
        "--owner-gradient-strength": theme.gradientEnabled ? "100%" : "0%",
        "--owner-page-bg-image-enabled": theme.ownerPageBackgroundImageEnabled ? "1" : "0",
        "--owner-page-bg-image": `url("${$d728b52521bfced6$var$ownerPageBackgroundUrl}")`
    });
const $d728b52521bfced6$export$546d357990387156 = ()=>{
    const { token: token } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const isLoginMode = searchParams.get("mode") === "login";
    const localBranding = (0, $acw62.useMemo)(()=>$d728b52521bfced6$var$loadOwnerBranding(), []);
    const brandingQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-public"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiBranding(),
        retry: 1,
        staleTime: 60000
    });
    const branding = (0, $acw62.useMemo)(()=>{
        const ui = brandingQuery.data;
        if (!ui) return localBranding;
        return {
            firmenname: ui.management.firmenname,
            logoDataUrl: ui.ownerLogoDataUrl,
            uiFramework: ui.management.uiFramework,
            theme: ui.ownerTheme
        };
    }, [
        brandingQuery.data,
        localBranding
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $7da634ecebe13da7$export$88022c82616459fa)(branding.uiFramework === "mockup_v2" ? "mockup_v2" : "classic");
    }, [
        branding.uiFramework
    ]);
    (0, $acw62.useEffect)(()=>{
        document.title = "ObjektVote | Abstimmen";
    }, []);
    const [voteValue, setVoteValue] = (0, $acw62.useState)("ja");
    const [comment, setComment] = (0, $acw62.useState)("");
    const [submitError, setSubmitError] = (0, $acw62.useState)("");
    const [previewDocument, setPreviewDocument] = (0, $acw62.useState)(null);
    const [suppressClosedResultUntilReload, setSuppressClosedResultUntilReload] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setSuppressClosedResultUntilReload(false);
    }, [
        token
    ]);
    const accessQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "owner-voting-access",
            token
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).ownerVotingAccess(token),
        enabled: !!token
    });
    const resultQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "owner-voting-result",
            token
        ],
        enabled: !!token,
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).ownerVotingResult(token)
    });
    const votingPowerSummary = (0, $acw62.useMemo)(()=>{
        const access = accessQuery.data;
        if (!access) return null;
        const art = access.resolution.stimmrechtsart;
        const accessAssignments = access.assignments ?? [];
        const resultTotal = Number(resultQuery.data?.stimmen?.gesamt ?? 0);
        const unitsByNumber = new Map(accessAssignments.map((assignment)=>[
                String(assignment.einheitsnummer ?? "").trim(),
                assignment
            ]).filter(([nr])=>Boolean(nr)));
        const ownerUnitNumbers = Array.from(new Set([
            ...accessAssignments.map((a)=>String(a.einheitsnummer ?? "").trim()).filter(Boolean)
        ]));
        const accessStimmrechtForOwner = accessAssignments.reduce((sum, a)=>sum + (a.stimmrecht ?? 0), 0);
        const formatEinheitTyp = (raw)=>{
            const label = (0, $f336a13bdd60accb$export$a10aac408d86876b)(raw);
            return label && label !== "-" ? label : "Einheit";
        };
        const accessMeaForOwner = accessAssignments.reduce((sum, a)=>sum + (a.mea ?? 0), 0);
        const unitsStimmrechtForOwner = ownerUnitNumbers.reduce((sum, nr)=>sum + (unitsByNumber.get(nr)?.stimmrecht ?? 0), 0);
        const unitsMeaForOwner = ownerUnitNumbers.reduce((sum, nr)=>sum + (unitsByNumber.get(nr)?.mea ?? 0), 0);
        if (art === "kopf") {
            const own = ownerUnitNumbers.length > 0 ? 1 : 0;
            const total = resultTotal || own;
            return {
                title: "Stimmanteile: Kopfprinzip",
                text: "1 Stimme pro Kopf (auch bei mehreren Wohnungen/Einheiten).",
                own: own,
                total: total,
                unitLabel: "K\u00f6pfe",
                lines: ownerUnitNumbers.map((nr)=>{
                    const unit = unitsByNumber.get(nr);
                    return `${formatEinheitTyp(unit?.einheitstyp)} Nr. ${nr}`;
                })
            };
        }
        if (art === "stimmrecht") {
            const own = accessStimmrechtForOwner || unitsStimmrechtForOwner;
            const total = resultTotal || own;
            return {
                title: "Stimmanteile: Stimmen pro Einheit",
                text: "Die Stimmanteile ergeben sich aus den stimmberechtigten Einheiten und deren Stimmrechten.",
                own: own,
                total: total,
                unitLabel: "Stimmen",
                lines: ownerUnitNumbers.map((nr)=>{
                    const unit = unitsByNumber.get(nr);
                    const fromAssignment = accessAssignments.find((a)=>a.einheitsnummer === nr)?.stimmrecht ?? 0;
                    const stimm = unit?.stimmrecht ?? fromAssignment;
                    return `${formatEinheitTyp(unit?.einheitstyp)} Nr. ${nr}: ${$d728b52521bfced6$var$formatPower(stimm)} Stimme(n)`;
                })
            };
        }
        const own = accessMeaForOwner || unitsMeaForOwner;
        const total = resultTotal || own;
        return {
            title: "Stimmanteile: Miteigentumsanteile (MEA)",
            text: "Die Stimmanteile ergibt sich aus den stimmberechtigten Einheiten und deren MEA.",
            own: own,
            total: total,
            unitLabel: "MEA",
            lines: ownerUnitNumbers.map((nr)=>{
                const unit = unitsByNumber.get(nr);
                const fromAssignment = accessAssignments.find((a)=>a.einheitsnummer === nr)?.mea ?? 0;
                const mea = unit?.mea ?? fromAssignment;
                return `${formatEinheitTyp(unit?.einheitstyp)} Nr. ${nr}: ${$d728b52521bfced6$var$formatPower(mea)} MEA`;
            })
        };
    }, [
        accessQuery.data,
        resultQuery.data?.stimmen?.gesamt
    ]);
    const currentVote = accessQuery.data?.current_vote;
    const voteReceiptMessage = currentVote ? currentVote.voteValue === "ja" ? "Ihre JA-Stimme wurde am " + $d728b52521bfced6$var$formatDateTimeDE(currentVote.voteReceivedAt) + " verbindlich erfasst." : currentVote.voteValue === "nein" ? "Ihre NEIN-Stimme wurde am " + $d728b52521bfced6$var$formatDateTimeDE(currentVote.voteReceivedAt) + " verbindlich erfasst." : "Ihre Enthaltung wurde am " + $d728b52521bfced6$var$formatDateTimeDE(currentVote.voteReceivedAt) + " verbindlich erfasst." : "";
    const voteReceiptClassName = currentVote ? currentVote.voteValue === "ja" ? "owner-vote-success-notice owner-vote-success-notice--ja" : currentVote.voteValue === "nein" ? "owner-vote-success-notice owner-vote-success-notice--nein" : "owner-vote-success-notice owner-vote-success-notice--enthaltung" : "owner-vote-success-notice";
    const voteReceiptIconClassName = currentVote ? currentVote.voteValue === "ja" ? "owner-vote-success-icon owner-vote-success-icon--ja" : currentVote.voteValue === "nein" ? "owner-vote-success-icon owner-vote-success-icon--nein" : "owner-vote-success-icon owner-vote-success-icon--enthaltung" : "owner-vote-success-icon";
    const currentReturnRateText = (()=>{
        const abgegeben = Number(resultQuery.data?.stimmen.abgegeben ?? 0);
        const gesamt = Number(resultQuery.data?.stimmen.gesamt ?? 0);
        if (gesamt <= 0) return "Derzeitige R\xfccklaufquote: -";
        const quote = abgegeben / gesamt * 100;
        return `Derzeitige R\xfccklaufquote: ${quote.toFixed(2).replace(".", ",")} % (${$d728b52521bfced6$var$formatPower(abgegeben)} von ${$d728b52521bfced6$var$formatPower(gesamt)} Stimmen).`;
    })();
    const documentsQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "owner-voting-documents",
            token
        ],
        enabled: !!token,
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).ownerVotingDocuments(token)
    });
    const submitMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).ownerVotingSubmit(token, {
                voteValue: voteValue,
                comment: comment.trim() ? comment.trim() : undefined,
                auth_mode: isLoginMode ? "beschluss_id_passwort" : "beschluss_link"
            }),
        onSuccess: async ()=>{
            setSubmitError("");
            setSuppressClosedResultUntilReload(true);
            await Promise.all([
                accessQuery.refetch(),
                resultQuery.refetch()
            ]);
        },
        onError: async (e)=>{
            const message = e instanceof Error ? e.message : "Stimme konnte nicht gespeichert werden";
            const normalized = message.toLowerCase();
            if (normalized.includes("bereits") && normalized.includes("stimm")) {
                setSubmitError("");
                await Promise.all([
                    accessQuery.refetch(),
                    resultQuery.refetch()
                ]);
                return;
            }
            setSubmitError(message);
        }
    });
    const canVote = accessQuery.data?.access.can_vote ?? false;
    const isDraft = accessQuery.data?.resolution.status === "entwurf";
    const isClosed = accessQuery.data?.resolution.status === "abgeschlossen";
    const ownerResultVisible = Boolean(resultQuery.data?.owner_einzelstimmabgabe_sichtbar ?? accessQuery.data?.resolution.owner_einzelstimmabgabe_sichtbar);
    const ownerResultRows = resultQuery.data?.einzelstimmabgaben ?? [];
    const quorumHinweis = resultQuery.data?.quorum_hinweis?.trim() ?? "";
    const resultLabel = resultQuery.data?.ergebnis ?? "-";
    const resultLabelLower = resultLabel.toLowerCase();
    const isResultAccepted = resultLabelLower.includes("angenommen");
    const isResultRejected = resultLabelLower.includes("abgelehnt");
    const resultOutcomeText = resultLabelLower.includes("angenommen") ? "Beschluss wurde angenommen" : resultLabelLower.includes("abgelehnt") ? "Beschluss wurde abgelehnt" : `Ergebnis: ${resultLabel}`;
    const resultOutcomeClass = isResultAccepted ? "owner-vote-result-outcome--ok" : isResultRejected ? "owner-vote-result-outcome--fail" : "owner-vote-result-outcome--neutral";
    const resultOutcomeCardClass = isResultAccepted ? "owner-vote-result-status-card--ok" : isResultRejected ? "owner-vote-result-status-card--fail" : "owner-vote-result-status-card--neutral";
    const ownerDocumentRows = documentsQuery.data?.data ?? [];
    const submitLabel = voteValue === "ja" ? "Ja - Stimme verbindlich abgeben" : voteValue === "nein" ? "Nein - Stimme verbindlich abgeben" : "Enthaltung verbindlich abgeben";
    const submitVariantClass = voteValue === "ja" ? "owner-vote-submit-ja" : voteValue === "nein" ? "owner-vote-submit-nein" : "owner-vote-submit-enthaltung";
    const statusBadgeClass = (0, $acw62.useMemo)(()=>{
        const status = accessQuery.data?.resolution.status;
        if (status === "aktiv") return "badge aktiv";
        if (status === "abgeschlossen") return "badge inaktiv";
        return "badge ergebnis-neutral";
    }, [
        accessQuery.data?.resolution.status
    ]);
    if (!token) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: `owner-vote-shell${branding.theme.ownerPageBackgroundImageEnabled ? " owner-vote-shell--bg-on" : ""}`,
        style: $d728b52521bfced6$var$ownerThemeVars(branding.theme),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
            className: "panel owner-vote-card",
            children: "Ung\u00fcltiger Zugangslink."
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: `owner-vote-shell${branding.theme.ownerPageBackgroundImageEnabled ? " owner-vote-shell--bg-on" : ""}`,
        style: $d728b52521bfced6$var$ownerThemeVars(branding.theme),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "panel owner-vote-card owner-vote-card--mockup",
            children: [
                accessQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: "Daten werden geladen..."
                }) : null,
                accessQuery.isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "error-text",
                    children: accessQuery.error instanceof Error ? accessQuery.error.message : "Fehler"
                }) : null,
                accessQuery.data ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "owner-vote-toprow",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                                    className: "owner-vote-header",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "owner-auth-kicker owner-vote-kicker",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    "aria-hidden": "true",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M6 3.8h8.8l3.2 3.2V20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4.8a1 1 0 0 1 1-1Z",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M14.8 3.8v3.2H18",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "m8.3 13.4 2.2 2.2 4.2-4.4",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.8",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Digitale Abstimmung"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "owner-vote-title",
                                            children: accessQuery.data.resolution.titel
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "owner-vote-subline",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "owner-vote-number",
                                                    children: accessQuery.data.resolution.beschlussnummer
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: statusBadgeClass,
                                                    children: $d728b52521bfced6$var$formatStatus(accessQuery.data.resolution.status)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                branding.logoDataUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "owner-vote-logo-wrap",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: branding.logoDataUrl,
                                        alt: branding.firmenname ? `${branding.firmenname} Logo` : "Firmenlogo",
                                        className: "owner-auth-logo owner-vote-logo"
                                    })
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "owner-vote-meta-grid",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-vote-meta-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "owner-vote-meta-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M12 21s6-5.7 6-10a6 6 0 1 0-12 0c0 4.3 6 10 6 10Z",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "11",
                                                        r: "2.2",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "owner-vote-meta-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Objekt"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                    children: [
                                                        accessQuery.data.resolution.objektnummer,
                                                        " | ",
                                                        accessQuery.data.resolution.objektname
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-vote-meta-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "owner-vote-meta-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "8.3",
                                                        r: "3.2",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M5.5 19.5a6.5 6.5 0 0 1 13 0",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "owner-vote-meta-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Eigent\u00fcmer"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: accessQuery.data.owner.name
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-vote-meta-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "owner-vote-meta-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                        x: "4",
                                                        y: "5.4",
                                                        width: "16",
                                                        height: "14.6",
                                                        rx: "2",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M8 3.8v3.2M16 3.8v3.2M4 9.6h16",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "owner-vote-meta-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Abstimmungsende"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: $d728b52521bfced6$var$formatDateDE(accessQuery.data.resolution.endedatum)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-vote-meta-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "owner-vote-meta-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M12 3.5 5 6v5.4c0 4.3 2.7 8.2 7 9.8 4.3-1.6 7-5.5 7-9.8V6l-7-2.5Z",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "m9.2 12.2 1.8 1.8 3.6-3.8",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "owner-vote-meta-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Quorum"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: $d728b52521bfced6$var$formatQuorum(accessQuery.data.resolution.quorum)
                                                }),
                                                quorumHinweis ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "owner-vote-meta-note",
                                                    children: quorumHinweis
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        votingPowerSummary ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            className: "owner-vote-power",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "owner-vote-power-card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "owner-vote-section-title owner-vote-power-title",
                                        children: votingPowerSummary.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "owner-vote-power-text",
                                        children: votingPowerSummary.text
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "owner-vote-power-metrics",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "owner-vote-power-metric",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "owner-vote-power-metric-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "8.2",
                                                                    cy: "8.5",
                                                                    r: "2.7",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "15.8",
                                                                    cy: "9.1",
                                                                    r: "2.3",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M3.8 18a4.6 4.6 0 0 1 8.8 0M12 18a3.8 3.8 0 0 1 7.2 0",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "owner-vote-power-metric-copy",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Ihre Stimmanteile"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    $d728b52521bfced6$var$formatPower(votingPowerSummary.own),
                                                                    " ",
                                                                    votingPowerSummary.unitLabel === "K\u00f6pfe" ? "Kopf" : votingPowerSummary.unitLabel
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    votingPowerSummary.lines.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "owner-vote-power-inline-list",
                                                        children: votingPowerSummary.lines.map((line)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "owner-vote-power-inline-item",
                                                                children: line
                                                            }, line))
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "owner-vote-power-metric",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "owner-vote-power-metric-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M12 4v5.8h5.8",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M12 4a8 8 0 0 1 8 8h-8V4Z",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M12 4a8 8 0 0 0-5.7 13.6",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "6.7",
                                                                    cy: "16.6",
                                                                    r: "1.8",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "12",
                                                                    cy: "16.1",
                                                                    r: "2.1",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                    cx: "17.3",
                                                                    cy: "16.6",
                                                                    r: "1.8",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M3.9 21v-1a3 3 0 0 1 5.8 0v1M9.1 21v-1.1a3.4 3.4 0 0 1 5.8 0V21M14.3 21v-1a3 3 0 0 1 5.8 0v1",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "owner-vote-power-metric-copy",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Gesamtstimmanteile"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    $d728b52521bfced6$var$formatPower(votingPowerSummary.total),
                                                                    " ",
                                                                    votingPowerSummary.unitLabel
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "owner-vote-power-metric",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "owner-vote-power-metric-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M12 4.2a7.8 7.8 0 1 0 7.8 7.8H12V4.2Z",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M14.2 3.5a7.9 7.9 0 0 1 6.3 6.3h-6.3V3.5Z",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "1.8"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "owner-vote-power-metric-copy",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Ihre Stimmmacht"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    $d728b52521bfced6$var$formatPower(votingPowerSummary.own),
                                                                    " / ",
                                                                    $d728b52521bfced6$var$formatPower(votingPowerSummary.total),
                                                                    " ",
                                                                    votingPowerSummary.unitLabel
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "owner-vote-proposal",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "owner-vote-proposal-title",
                                    children: accessQuery.data.resolution.titel
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "owner-vote-proposal-request",
                                    children: "Beschlussantrag:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "owner-vote-proposal-text",
                                    children: accessQuery.data.resolution.beschlusstext
                                })
                            ]
                        }),
                        ownerDocumentRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            className: "owner-vote-proposal owner-vote-documents",
                            style: {
                                marginTop: 10
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                className: "owner-vote-documents-details",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                                        className: "owner-vote-documents-summary",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "owner-vote-documents-bullet",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M6 4.4h8.6L18 7.8V19a1 1 0 0 1-1 1H6.9a1 1 0 0 1-1-1V5.4a1 1 0 0 1 1-1Z",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M14.6 4.4v3.4H18",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M8.6 11h6.8M8.6 14.2h6.8M8.6 17.4h4.4",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.7",
                                                            strokeLinecap: "round"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "owner-vote-documents-label",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Dokumente zum Beschluss"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "owner-vote-documents-body",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                overflowX: "auto"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Datei"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: "Aktion"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                        children: ownerDocumentRows.map((doc)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: doc.originalName
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>setPreviewDocument(doc),
                                                                            children: "\xd6ffnen"
                                                                        })
                                                                    })
                                                                ]
                                                            }, doc.id))
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }) : null,
                        previewDocument ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "modal-backdrop",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "panel modal-card",
                                style: {
                                    width: $d728b52521bfced6$var$isPreviewableOwnerDocument(previewDocument) ? "min(1400px, 98vw)" : "min(620px, 92vw)",
                                    maxWidth: $d728b52521bfced6$var$isPreviewableOwnerDocument(previewDocument) ? 1400 : 620,
                                    maxHeight: "94vh",
                                    overflow: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        style: {
                                            marginTop: 0,
                                            marginBottom: 8
                                        },
                                        children: previewDocument.originalName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginBottom: 10
                                        },
                                        children: $d728b52521bfced6$var$isPreviewableOwnerDocument(previewDocument) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                            title: previewDocument.originalName,
                                            src: previewDocument.fileUrl,
                                            style: {
                                                width: "100%",
                                                height: "80vh",
                                                border: "1px solid var(--line)",
                                                borderRadius: 6
                                            }
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                color: "var(--text-soft)"
                                            },
                                            children: "F\xfcr diesen Dateityp ist keine Browser-Vorschau verf\xfcgbar."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-actions owner-vote-actions",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: previewDocument.fileUrl,
                                                download: previewDocument.originalName,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    children: "Download"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setPreviewDocument(null),
                                                children: "Schlie\xdfen"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : null,
                        !isDraft && !isClosed && !currentVote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "owner-vote-action-box",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "owner-vote-section-title",
                                    children: "Ihre Stimmauswahl"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-vote-options",
                                    role: "radiogroup",
                                    "aria-label": "Stimmabgabe",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: `owner-vote-option owner-vote-option-ja ${voteValue === "ja" ? "is-active" : ""}`,
                                            onClick: ()=>setVoteValue("ja"),
                                            disabled: !canVote || submitMutation.isPending,
                                            children: "Ja"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: `owner-vote-option owner-vote-option-nein ${voteValue === "nein" ? "is-active" : ""}`,
                                            onClick: ()=>setVoteValue("nein"),
                                            disabled: !canVote || submitMutation.isPending,
                                            children: "Nein"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: `owner-vote-option owner-vote-option-enthaltung ${voteValue === "enthaltung" ? "is-active" : ""}`,
                                            onClick: ()=>setVoteValue("enthaltung"),
                                            disabled: !canVote || submitMutation.isPending,
                                            children: "Enthaltung"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "form-field owner-vote-comment-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Kommentar (optional)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                            className: "table-field",
                                            value: comment,
                                            onChange: (e)=>setComment(e.target.value),
                                            disabled: !canVote || submitMutation.isPending,
                                            rows: 4
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "owner-vote-action-submit",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: `owner-vote-submit-btn ${submitVariantClass}`,
                                        disabled: !canVote || submitMutation.isPending,
                                        onClick: ()=>submitMutation.mutate(),
                                        children: submitMutation.isPending ? "Speichere..." : submitLabel
                                    })
                                })
                            ]
                        }) : null,
                        voteReceiptMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: voteReceiptClassName,
                            role: "status",
                            "aria-live": "polite",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: voteReceiptIconClassName,
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: currentVote?.voteValue === "nein" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M7 7 17 17M17 7 7 17",
                                            stroke: "currentColor",
                                            strokeWidth: "2.2",
                                            strokeLinecap: "round"
                                        }) : currentVote?.voteValue === "enthaltung" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M6.5 12h11",
                                            stroke: "currentColor",
                                            strokeWidth: "2.2",
                                            strokeLinecap: "round"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "m5 12 4.2 4.2L19 6.6",
                                            stroke: "currentColor",
                                            strokeWidth: "2.2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "owner-vote-success-notice-title",
                                            children: "Stimmabgabe erfolgreich"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "owner-vote-success-notice-text",
                                            children: voteReceiptMessage
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "owner-vote-success-notice-text",
                                            children: currentReturnRateText
                                        })
                                    ]
                                })
                            ]
                        }) : null,
                        isClosed && !suppressClosedResultUntilReload ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "owner-vote-result-box",
                            style: {
                                marginTop: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "owner-vote-result-heading",
                                    children: "Abstimmungsergebnis"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-vote-result-layout",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "owner-vote-result-card owner-vote-result-chart-card",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d728b52521bfced6$var$OwnerResultDonut, {
                                                ja: Number(resultQuery.data?.stimmen.ja ?? 0),
                                                nein: Number(resultQuery.data?.stimmen.nein ?? 0),
                                                enthaltung: Number(resultQuery.data?.stimmen.enthaltung ?? 0)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: `owner-vote-result-card owner-vote-result-status-card ${resultOutcomeCardClass}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "owner-vote-result-status-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        children: isResultRejected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M7 7 17 17M17 7 7 17",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2.2",
                                                            strokeLinecap: "round"
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "m5 12 4.2 4.2L19 6.6",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2.2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: `owner-vote-result-outcome ${resultOutcomeClass}`,
                                                    children: resultOutcomeText
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                ownerResultVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "owner-vote-result-card owner-vote-result-list-card",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            overflowX: "auto"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: "Eigent\xfcmer"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: "Einheit"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: "Stimmverhalten"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: "Erfasst am"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        ownerResultRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: row.ownerLabel
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: (row.einheiten ?? []).map((value)=>$d728b52521bfced6$var$formatUnitNumber4Digits(value)).join(" | ") || "-"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: `badge ${$d728b52521bfced6$var$voteBadgeClass(row.voteValue)}`,
                                                                            children: $d728b52521bfced6$var$voteLabel(row.voteValue)
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        style: {
                                                                            textAlign: "center"
                                                                        },
                                                                        children: $d728b52521bfced6$var$formatDateDE(row.voteReceivedAt)
                                                                    })
                                                                ]
                                                            }, row.ownerId)),
                                                        !ownerResultRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: 4,
                                                                children: "Keine Einzelstimmabgaben vorhanden."
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }) : null
                            ]
                        }) : null,
                        isDraft ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "owner-vote-draft-notice",
                            role: "status",
                            "aria-live": "polite",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "owner-vote-draft-notice-title",
                                    children: "Umlaufbeschluss noch nicht gestartet"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "owner-vote-draft-notice-text",
                                    children: "Der Umlaufbeschluss befindet sich aktuell im Entwurf. Eine Stimmabgabe ist erst nach dem Start m\xf6glich."
                                })
                            ]
                        }) : null,
                        !isDraft && !isClosed && !canVote && !currentVote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "error-text",
                            children: "Abstimmung ist f\u00fcr diesen Zugang nicht mehr m\u00f6glich."
                        }) : null,
                        submitError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "error-text",
                            children: submitError
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "form-actions owner-vote-actions",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/owner-login",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    className: "owner-vote-back-btn",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M14.8 6.2 9 12l5.8 5.8M9.2 12h9.8",
                                                stroke: "currentColor",
                                                strokeWidth: "1.9",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Zur Loginseite"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }) : null
            ]
        })
    });
};
var $d728b52521bfced6$export$2e2bcd8739ae039 = $d728b52521bfced6$export$546d357990387156;




var $acw62 = parcelRequire("acw62");







var $848792da5fb8ad08$import_meta = Object.assign(Object.create(null), {
    url: "file:///src/pages/AdminLoginPage.tsx"
});

const $848792da5fb8ad08$var$adminLoginBackgroundUrl = new URL($fb8ca5e1e5184a90$exports).toString();
const $848792da5fb8ad08$var$loadAdminBranding = ()=>{
    const ui = (0, $5806306cf67ca7cd$export$cc8e577c185b57cb)();
    return {
        firmenname: ui.management.firmenname,
        email: ui.management.email,
        logoDataUrl: ui.ownerLogoDataUrl,
        uiFramework: ui.management.uiFramework,
        theme: ui.ownerTheme
    };
};
const $848792da5fb8ad08$var$themeVars = (theme)=>({
        "--bg": theme.bg,
        "--surface": theme.surface,
        "--line": theme.line,
        "--text": theme.text,
        "--primary": theme.primary,
        "--owner-gradient-from": theme.gradientFrom,
        "--owner-gradient-to": theme.gradientTo,
        "--owner-gradient-enabled": theme.gradientEnabled ? "1" : "0",
        "--owner-gradient-strength": theme.gradientEnabled ? "100%" : "0%",
        "--admin-login-bg-image-enabled": theme.adminLoginBackgroundImageEnabled !== false ? "1" : "0",
        "--admin-login-bg-image": `url("${$848792da5fb8ad08$var$adminLoginBackgroundUrl}")`
    });
const $848792da5fb8ad08$export$482fd5473c8a16ac = ({ onAuthenticated: onAuthenticated })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [username, setUsername] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [rememberMe, setRememberMe] = (0, $acw62.useState)(false);
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const currentYear = new Date().getFullYear();
    const sessionExpired = Boolean(location.state?.sessionExpired);
    const localBranding = (0, $acw62.useMemo)(()=>$848792da5fb8ad08$var$loadAdminBranding(), []);
    const brandingQuery = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "ui-settings-admin-login"
        ],
        queryFn: ()=>(0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiBranding(),
        retry: 1,
        staleTime: 60000
    });
    const branding = (0, $acw62.useMemo)(()=>{
        const ui = brandingQuery.data;
        if (!ui) return localBranding;
        return {
            firmenname: ui.management.firmenname,
            email: ui.management.email,
            logoDataUrl: ui.ownerLogoDataUrl,
            uiFramework: ui.management.uiFramework,
            theme: ui.ownerTheme
        };
    }, [
        brandingQuery.data,
        localBranding
    ]);
    const companyName = String(branding.firmenname || "ObjektVote").trim();
    (0, $acw62.useEffect)(()=>{
        (0, $7da634ecebe13da7$export$88022c82616459fa)(branding.uiFramework === "mockup_v2" ? "mockup_v2" : "classic");
    }, [
        branding.uiFramework
    ]);
    (0, $acw62.useEffect)(()=>{
        const host = window.location.hostname.toLowerCase();
        const hostSlug = (0, $09f591baab63073a$export$71e583b5d309e488)(host);
        const platformAliases = $848792da5fb8ad08$import_meta.env?.VITE_PLATFORM_PORTAL_ALIASES ?? "plattform,platform";
        const isPlatformHost = String(platformAliases).split(",").map((entry)=>entry.trim().toLowerCase()).filter(Boolean).includes(hostSlug);
        if (isPlatformHost) {
            document.title = "ObjektVote | Plattform";
            return;
        }
        const tenantLabel = String(branding.firmenname || "Mandant").trim();
        document.title = `ObjektVote | ${tenantLabel}`;
    }, [
        branding.firmenname
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!sessionExpired) return;
        setError("Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.");
        navigate(location.pathname, {
            replace: true,
            state: null
        });
    }, [
        location.pathname,
        navigate,
        sessionExpired
    ]);
    if ((0, $401da7136ebd564e$export$38e1f53b76ec7fed)()) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    const submit = async (event)=>{
        event.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const result = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).adminLogin({
                username: username.trim(),
                password: password,
                rememberMe: rememberMe
            });
            (0, $401da7136ebd564e$export$3c4602e16d9ace38)(result.token);
            onAuthenticated(result.user);
            const next = location.state?.from || "/";
            navigate(next, {
                replace: true
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "";
            const normalized = message.trim().toLowerCase();
            if (normalized.includes("api 401") || normalized.includes("ung\xfcltig") || normalized.includes("ungueltig") || normalized.includes("invalid")) setError("Benutzername oder Passwort ist ung\xfcltig.");
            else if (normalized.includes("api 503") || normalized.includes("server nicht verf\xfcgbar")) setError("Server aktuell nicht verf\xfcgbar. Bitte in wenigen Minuten erneut versuchen.");
            else if (message.trim()) setError(message.trim());
            else setError("Anmeldung derzeit nicht m\xf6glich. Bitte Serververbindung pr\xfcfen.");
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: `owner-auth-shell owner-auth-shell-centered admin-login-shell${branding.theme.adminLoginBackgroundImageEnabled !== false ? " admin-login-shell--bg-on" : ""}`,
        style: $848792da5fb8ad08$var$themeVars(branding.theme),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "panel owner-auth-combined-card admin-login-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "owner-auth-head",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "owner-auth-kicker admin-login-kicker",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            "aria-hidden": "true",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M12 3.5 5 6v5.4c0 4.3 2.7 8.2 7 9.8 4.3-1.6 7-5.5 7-9.8V6l-7-2.5Z",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M9.6 11.6v-1.1a2.4 2.4 0 1 1 4.8 0v1.1",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                    x: "8.8",
                                                    y: "11.6",
                                                    width: "6.4",
                                                    height: "5.2",
                                                    rx: "1.2",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Verwaltungsportal"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "owner-auth-title admin-login-title",
                                    children: "ObjektVote"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "owner-auth-subtitle",
                                    children: "Bitte mit Ihrem Benutzerkonto anmelden."
                                })
                            ]
                        }),
                        branding.logoDataUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: branding.logoDataUrl,
                            alt: "Firmenlogo",
                            className: "owner-auth-logo owner-auth-logo-right admin-login-logo"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "owner-auth-divider"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: submit,
                    className: "owner-auth-body admin-login-body",
                    style: {
                        gap: 16
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-field admin-login-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "admin-login-label",
                                    children: "Benutzername"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "admin-login-input-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "admin-login-input-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M12 12.4a4.4 4.4 0 1 0 0-8.8 4.4 4.4 0 0 0 0 8.8Z",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M4 20.2a8 8 0 0 1 16 0",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            className: "table-field admin-login-input",
                                            value: username,
                                            onChange: (e)=>setUsername(e.target.value),
                                            placeholder: "Benutzername eingeben",
                                            autoComplete: "username",
                                            required: true,
                                            autoFocus: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-field owner-auth-password-field admin-login-field",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "admin-login-label",
                                    children: "Passwort"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "admin-login-input-wrap admin-login-password-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "admin-login-input-icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                        x: "4.2",
                                                        y: "10.5",
                                                        width: "15.6",
                                                        height: "10.5",
                                                        rx: "2",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M8.4 10.5V7.8a3.6 3.6 0 1 1 7.2 0v2.7",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "15.9",
                                                        r: "1",
                                                        fill: "currentColor"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            className: "table-field admin-login-input",
                                            type: showPassword ? "text" : "password",
                                            value: password,
                                            onChange: (e)=>setPassword(e.target.value),
                                            placeholder: "Passwort eingeben",
                                            autoComplete: "current-password",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "owner-auth-eye-btn admin-login-eye-btn",
                                            onClick: ()=>setShowPassword((v)=>!v),
                                            "aria-label": showPassword ? "Passwort verbergen" : "Passwort anzeigen",
                                            title: showPassword ? "Passwort verbergen" : "Passwort anzeigen",
                                            children: showPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                "aria-hidden": "true",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "3.2",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M4 4l16 16",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                "aria-hidden": "true",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M2 12C3.8 7.8 7.5 5 12 5c4.5 0 8.2 2.8 10 7-1.8 4.2-5.5 7-10 7-4.5 0-8.2-2.8-10-7Z",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "3.2",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "error-text",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "admin-login-remember",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: rememberMe,
                                    onChange: (e)=>setRememberMe(e.target.checked)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Angemeldet bleiben"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "form-actions admin-login-actions",
                            style: {
                                justifyContent: "flex-start"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "submit",
                                className: "admin-login-submit",
                                disabled: loading || !username.trim() || !password.trim(),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        "aria-hidden": "true",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                x: "4.2",
                                                y: "10.5",
                                                width: "15.6",
                                                height: "10.5",
                                                rx: "2",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M8.4 10.5V7.8a3.6 3.6 0 1 1 7.2 0v2.7",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                cx: "12",
                                                cy: "15.9",
                                                r: "1",
                                                fill: "currentColor"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: loading ? "Anmeldung l\xe4uft..." : "Anmelden"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "owner-auth-footer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "owner-auth-footer-row admin-login-footer-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-login-contact",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "admin-login-contact-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                    x: "3.6",
                                                    y: "5.2",
                                                    width: "16.8",
                                                    height: "13.6",
                                                    rx: "2.4",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "m5.6 7 6.4 5 6.4-5",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-login-contact-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: companyName
                                            }),
                                            branding.email ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: `mailto:${branding.email}`,
                                                children: branding.email
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "owner-auth-copyright admin-login-copyright",
                                children: `\xa9 ${currentYear} Emig Immobilien`
                            })
                        ]
                    })
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");


const $f216bfa0510b464b$var$benefits = [
    {
        icon: "efficiency",
        title: "Weniger manueller Aufwand",
        text: "Automatisieren Sie bis zu 100 % den Versand und die Erfassung von Stimmen. Sparen Sie wertvolle Stunden pro Beschluss."
    },
    {
        icon: "owners",
        title: "Digitale + analoge Eigent\xfcmer",
        text: "Ein nahtloser Prozess f\xfcr alle. Analoge Stimmen werden via QR-Scan einfach in das digitale System \xfcberf\xfchrt."
    },
    {
        icon: "compliance",
        title: "Nachvollziehbarkeit & Rechtssicherheit",
        text: "L\xfcckenlose Protokollierung inklusive Zustellnachweisen f\xfcr jeden einzelnen Eigent\xfcmer."
    },
    {
        icon: "integration",
        title: "Facilioo-Integration",
        text: "Vermeiden Sie Medienbr\xfcche. Alle Daten werden in Echtzeit aus Facilioo geladen und Ergebnisse flie\xdfen direkt in Ihr bestehendes Facilioo-Vorgangssystem."
    }
];
const $f216bfa0510b464b$var$features = [
    {
        icon: "manage",
        title: "Beschl\xfcsse managen",
        text: "Anlegen, starten, stoppen und abschlie\xdfen mit nur einem Klick - volle Kontrolle \xfcber den Zeitplan."
    },
    {
        icon: "quorum",
        title: "Quoren & Stimmrechte",
        text: "Unterst\xfctzung f\xfcr Kopf-Prinzip, Stimmrecht nach MEA oder Einheiten - flexibel konfigurierbar."
    },
    {
        icon: "portal",
        title: "Eigent\xfcmer-Portal",
        text: "Sicherer Login f\xfcr Eigent\xfcmer zur digitalen Stimmabgabe von \xfcberall und jedem Endger\xe4t."
    },
    {
        icon: "hybrid",
        title: "Hybride Stimmabgabe",
        text: "Analoge Stimmen einfach per QR-/Token-Scan digitalisieren - kein manuelles Abtippen mehr."
    },
    {
        icon: "mail",
        title: "Auto-Versand & Erinnerung",
        text: "Automatischer Versand der Unterlagen und intelligente Erinnerungen f\xfcr noch offene Stimmen."
    },
    {
        icon: "editor",
        title: "Vorlagen-Editor",
        text: "Einfache Anpassung von Einladungen, Erinnerungen und Ergebnissen mit Ihrem CI."
    },
    {
        icon: "pdf",
        title: "PDF-Erzeugung",
        text: "Vollautomatische Generierung von personalisierten Dokumenten und Protokollen."
    },
    {
        icon: "audit",
        title: "Audit-Protokolle",
        text: "L\xfcckenlose Dokumentation aller Aktionen f\xfcr maximale Revisionssicherheit."
    },
    {
        icon: "attachments",
        title: "Unterlagen zu Beschl\xfcssen",
        text: "F\xfcgen Sie Dateien direkt zum Beschluss hinzu und stellen Sie alle relevanten Unterlagen zentral bereit."
    }
];
const $f216bfa0510b464b$var$BenefitIcon = ({ name: name })=>{
    if (name === "efficiency") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 3v3M12 18v3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M3 12h3M18 12h3M4.9 19.1 7 17M17 7l2.1-2.1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "4.5"
            })
        ]
    });
    if (name === "owners") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "8",
                cy: "9",
                r: "3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "16.5",
                cy: "8.5",
                r: "2.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.5 18.5c.8-2.6 2.8-4 5.5-4s4.8 1.4 5.5 4M14.5 18.5c.5-1.8 1.8-3 3.8-3 1 0 2 .3 2.8 1"
            })
        ]
    });
    if (name === "compliance") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 3 5 6v5c0 4.6 2.7 7.6 7 10 4.3-2.4 7-5.4 7-10V6l-7-3Z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m9.5 12.5 2 2 3.5-4"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 7h9a3 3 0 0 1 0 6h-1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 17H7a3 3 0 0 1 0-6h1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 9h4v6h-4z"
            })
        ]
    });
};
const $f216bfa0510b464b$var$FeatureIcon = ({ name: name })=>{
    if (name === "manage") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 6h16M4 12h16M4 18h10"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m16 16 2 2 3-4"
            })
        ]
    });
    if (name === "quorum") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 19h14"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 19V8M12 19V5M17 19v-9"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "7",
                cy: "8",
                r: "1.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "5",
                r: "1.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "17",
                cy: "10",
                r: "1.5"
            })
        ]
    });
    if (name === "portal") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13 4h6v16h-6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 12h9"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m8 9 3 3-3 3"
            })
        ]
    });
    if (name === "hybrid") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4",
                y: "3.5",
                width: "10",
                height: "17",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 6.5h2M17 10h3M17 14h3M17 18h3"
            })
        ]
    });
    if (name === "mail") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "3",
                y: "6",
                width: "18",
                height: "12",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m4 8 8 6 8-6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 4v4M17 6h4"
            })
        ]
    });
    if (name === "editor") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 20h16"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m7 15.5 7.8-7.8 2.5 2.5-7.8 7.8L6 19z"
            })
        ]
    });
    if (name === "pdf") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 3h7l4 4v14H7z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 3v5h4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 16h6M9 13h6"
            })
        ]
    });
    if (name === "audit") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 3 5 6v5c0 4.6 2.7 7.6 7 10 4.3-2.4 7-5.4 7-10V6l-7-3Z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m9.5 12.5 2 2 3.5-4"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4",
                y: "6",
                width: "9",
                height: "12",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 9h5M15 13h5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m14 17 2 2 4-5"
            })
        ]
    });
};
const $f216bfa0510b464b$export$355f3d6a1f8b250c = ()=>{
    const currentYear = new Date().getFullYear();
    const [captchaSiteKey, setCaptchaSiteKey] = (0, $acw62.useState)("");
    const [captchaToken, setCaptchaToken] = (0, $acw62.useState)("");
    const [targetEmail, setTargetEmail] = (0, $acw62.useState)("demo@derumlaufbeschluss.de");
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [formStatus, setFormStatus] = (0, $acw62.useState)({
        type: "idle",
        message: ""
    });
    const captchaContainerRef = (0, $acw62.useRef)(null);
    const captchaWidgetIdRef = (0, $acw62.useRef)(null);
    const formRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        document.title = "WEG-Verwaltung Digital | Digitale Umlaufbeschl\xfcsse";
    }, []);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getDemoRequestConfig().then((config)=>{
            if (cancelled) return;
            setCaptchaSiteKey(String(config.captchaSiteKey ?? "").trim());
            setTargetEmail(String(config.targetEmail ?? "demo@derumlaufbeschluss.de").trim() || "demo@derumlaufbeschluss.de");
        }).catch(()=>{
            if (cancelled) return;
            setCaptchaSiteKey("");
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!captchaSiteKey || !captchaContainerRef.current || typeof window === "undefined") return;
        const win = window;
        const renderWidget = ()=>{
            if (!captchaContainerRef.current || !win.turnstile?.render) return;
            captchaContainerRef.current.innerHTML = "";
            captchaWidgetIdRef.current = win.turnstile.render(captchaContainerRef.current, {
                sitekey: captchaSiteKey,
                callback: (token)=>setCaptchaToken(token),
                "expired-callback": ()=>setCaptchaToken(""),
                "error-callback": ()=>setCaptchaToken("")
            });
        };
        if (win.turnstile?.render) {
            renderWidget();
            return;
        }
        const existingScript = document.querySelector('script[data-turnstile="1"]');
        if (existingScript) {
            existingScript.addEventListener("load", renderWidget, {
                once: true
            });
            return ()=>existingScript.removeEventListener("load", renderWidget);
        }
        const script = document.createElement("script");
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        script.async = true;
        script.defer = true;
        script.dataset.turnstile = "1";
        script.addEventListener("load", renderWidget, {
            once: true
        });
        document.head.appendChild(script);
        return ()=>script.removeEventListener("load", renderWidget);
    }, [
        captchaSiteKey
    ]);
    const submitRequest = async (requestType)=>{
        if (submitting) return;
        if (!formRef.current) return;
        if (!captchaSiteKey) {
            setFormStatus({
                type: "error",
                message: "Captcha ist aktuell nicht verf\xfcgbar. Bitte schreiben Sie direkt an demo@derumlaufbeschluss.de."
            });
            return;
        }
        if (!captchaToken) {
            setFormStatus({
                type: "error",
                message: "Bitte best\xe4tigen Sie zuerst das Captcha."
            });
            return;
        }
        const data = new FormData(formRef.current);
        const fullName = String(data.get("fullName") ?? "").trim();
        const company = String(data.get("company") ?? "").trim();
        const email = String(data.get("email") ?? "").trim();
        const phone = String(data.get("phone") ?? "").trim();
        const managedUnits = String(data.get("managedUnits") ?? "").trim();
        const message = String(data.get("message") ?? "").trim();
        if (!fullName || !company || !email || !phone) {
            setFormStatus({
                type: "error",
                message: "Bitte f\xfcllen Sie Name, Firma, E-Mail und Telefonnummer aus."
            });
            return;
        }
        setSubmitting(true);
        setFormStatus({
            type: "idle",
            message: ""
        });
        try {
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).submitDemoRequest({
                fullName: fullName,
                company: company,
                email: email,
                phone: phone,
                managedUnits: managedUnits,
                message: message,
                requestType: requestType,
                captchaToken: captchaToken
            });
            setFormStatus({
                type: "success",
                message: "Vielen Dank. Ihre Anfrage wurde erfolgreich versendet."
            });
            formRef.current.reset();
            setCaptchaToken("");
            const win = window;
            if (win.turnstile?.reset) win.turnstile.reset(captchaWidgetIdRef.current ?? undefined);
        } catch (error) {
            setFormStatus({
                type: "error",
                message: error instanceof Error ? error.message : "Anfrage konnte nicht versendet werden."
            });
        } finally{
            setSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "lp-page-v2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                className: "lpv2-nav-wrap",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "lpv2-nav",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "lpv2-brand",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: "/header-logo.png",
                                alt: "Der Umlaufbeschluss"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#vorteile",
                                    children: "Vorteile"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#funktionen",
                                    children: "Funktionen"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#integration",
                                    children: "Integrationen"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#preise",
                                    children: "Preise"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "#demo",
                            className: "lpv2-btn lpv2-btn-dark lpv2-nav-cta",
                            children: "Demo anfragen"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "lpv2-hero",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "lpv2-hero-copy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        children: "Digitale Umlaufbeschl\xfcsse f\xfcr die WEG-Verwaltung."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "Einfach erstellen, sicher abstimmen, automatisiert versenden und nahtlos mit Facilioo verbinden.",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                children: [
                                                    " ",
                                                    "F\xfcr Umlaufbeschl\xfcsse, die endlich Freude machen \u2013 selbst in gro\xdfen WEGs schnell, einfach und effizient umgesetzt."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lpv2-actions",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "#demo",
                                                className: "lpv2-btn lpv2-btn-dark",
                                                children: "Demozugang anfragen"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "#demo",
                                                className: "lpv2-btn lpv2-btn-light",
                                                children: "Live-Demo vereinbaren"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "lpv2-hero-visual",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lpv2-dashboard",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "lpv2-dashboard-head",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Umlaufbeschl\xfcsse"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        children: "Neuer Umlaufbeschluss"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "lpv2-dashboard-toolbar",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Suche"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Alle Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Alle Ergebnisse"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "lpv2-dashboard-table",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-dashboard-row lpv2-dashboard-row-head",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Beschluss-ID"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Objekt"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Titel"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Status"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "R\xfccklauf"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Ergebnis"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-dashboard-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "B-2026-D001"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "WEG Rheinufer"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Erneuerung Treppenhausbeleuchtung"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "ok",
                                                                children: "l\xe4uft"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "83.50 %"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "result-none",
                                                                children: "-"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-dashboard-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "B-2026-A001"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "WEG Sonnenblick"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Sanierung Kellerdecke"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "stop",
                                                                children: "beendet"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "100.00 %"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "result-badge result-no",
                                                                children: "Abgelehnt"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-dashboard-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "B-2026-E001"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "WEG Gutenberg"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Anpassung Hausgeldvorauszahlung"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "stop",
                                                                children: "beendet"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "96.20 %"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "result-badge result-yes",
                                                                children: "Angenommen"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-dashboard-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "B-2026-F004"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "WEG Lindenhof"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Austausch Briefkastenanlage"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "ok",
                                                                children: "l\xe4uft"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "61.80 %"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "result-none",
                                                                children: "-"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-dashboard-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "B-2026-G007"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "WEG Parkresidenz"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Einf\xfchrung digitale Zutrittskontrolle"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "stop",
                                                                children: "beendet"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "98.70 %"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "result-badge result-yes",
                                                                children: "Angenommen"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-dashboard-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "B-2026-H002"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "WEG Rosenquartier"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Neugestaltung Innenhof"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "stop",
                                                                children: "beendet"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "94.10 %"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "result-badge result-no",
                                                                children: "Abgelehnt"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lpv2-phone",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "lpv2-notch"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "lpv2-phone-screen",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "lpv2-phone-headline",
                                                        children: "Digitale Abstimmung"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "lpv2-phone-title-row",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                            children: "Beratung und Genehmigung der Jahresabrechnung 2025 samt F\xe4lligstellung"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-phone-meta",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "B-2026-011"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "l\xe4uft"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-phone-info",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                children: "Objekt"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "9994 | WEG Elsa-Br\xe4ndstr\xf6m-Stra\xdfe 29-37"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-phone-info",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                children: "Eigent\xfcmer"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Herrn Max Mustermann"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-phone-info",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                children: "Abstimmungsende"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "30.04.2026"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-phone-info",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                children: "Quorum"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Allstimmig"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-phone-panel",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                                children: "Stimmanteile: Miteigentumsanteile (MEA)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Die Stimmanteile ergibt sich aus den stimmberechtigten Einheiten und deren MEA."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "lpv2-phone-metrics",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "lpv2-phone-info lpv2-phone-info-compact",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                                children: "Ihre Stimmrecht"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                children: "152,36"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "lpv2-phone-info lpv2-phone-info-compact",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                                children: "Gesamtanateile"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                children: "1000"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "lpv2-phone-info lpv2-phone-info-compact",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                                children: "Ihre Stimmmacht"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                children: "152,36/1000"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-phone-panel",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                                children: "Beratung und Genehmigung der Jahresabrechnung 2025 samt F\xe4lligstellung"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Die vom Verwalter vorgelegte Jahresabrechnung wird beschlossen. Die Abrechnungsspitzen der Einzelabrechnungen sind damit zur Zahlung f\xe4llig."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Eigent\xfcmer mit Einzugserm\xe4chtigung zahlen automatisch, sonst ist ein Ausgleich bis zum Monatsende durchzuf\xfchren."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "lpv2-phone-panel",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                                children: "Ihre Stimmauswahl"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "lpv2-phone-votes",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "yes",
                                                                        children: "Ja"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "no",
                                                                        children: "Nein"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "neutral",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "lpv2-vote-label-full",
                                                                                children: "Enthaltung"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "lpv2-vote-label-short",
                                                                                children: "Enth."
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "lpv2-phone-note",
                                                                children: "Kommentar (optional)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "lpv2-phone-textbox"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "lpv2-phone-submit",
                                                                children: "Ja - Stimme verbindlich abgeben"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: "vorteile",
                        className: "lpv2-section lpv2-surface-2 lpv2-net-bg lpv2-net-left",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "lpv2-container",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Effizienzsteigerung in der Verwaltung"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "lpv2-benefit-grid",
                                    children: $f216bfa0510b464b$var$benefits.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "lpv2-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f216bfa0510b464b$var$BenefitIcon, {
                                                        name: item.icon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: item.text
                                                })
                                            ]
                                        }, item.title))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: "funktionen",
                        className: "lpv2-section lpv2-surface-1 lpv2-net-bg lpv2-net-right",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "lpv2-container",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "lpv2-headline-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "Umfassende Funktionen"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Alles, was Sie f\xfcr eine moderne, rechtssichere Beschlussfassung ben\xf6tigen."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "lpv2-feature-grid",
                                    children: $f216bfa0510b464b$var$features.map((feature)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "lpv2-feature-icon",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f216bfa0510b464b$var$FeatureIcon, {
                                                        name: feature.icon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: feature.title
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: feature.text
                                                })
                                            ]
                                        }, feature.title))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: "integration",
                        className: "lpv2-integration lpv2-net-bg-dark lpv2-net-left",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "lpv2-container lpv2-integration-grid",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "lpv2-overline lpv2-overline-dark",
                                            children: "Echtzeit Syncronisation"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "Facilioo-Integration ohne Kompromisse"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "Objektbasierte Pr\xfcfung: Beschl\xfcsse werden direkt den Vorg\xe4ngen in Facilioo zugeordnet."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "Dokumententransfer: Alle Dokumente sind sofort Bidirektional im Facilioo-Vorgang und umgekehrt in der Beschluss-APP verf\xfcgbar."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "Facilioo-Verlauf: Ergebnisse und Statusupdates flie\xdfen, auf Wunsch, automatisch in den Vorgangsverlauf und l\xf6sen Meldungen f\xfcr den Objektbetreuer aus."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "lpv2-eval-mock",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lpv2-eval-top",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: "Beschlussauswertung"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    children: "Logdatei \xf6ffnen"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lpv2-eval-summary",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "lpv2-eval-chart",
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "lpv2-eval-stats",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Abgegebene Stimmen"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "16"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Gesamte Stimmzahl"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "16"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Quorum erf\xfcllt"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Ja"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Endergebnis"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Angenommen"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lpv2-eval-table",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "lpv2-eval-row lpv2-eval-head",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Einheit"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Eigent\xfcmer"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Stimmverhalten"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "lpv2-eval-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "0001"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Miriam Peters"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "badge neutral",
                                                            children: "Enthaltung"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "lpv2-eval-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "0002"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Sophie Sch\xe4fer"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "badge yes",
                                                            children: "Ja"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "lpv2-eval-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "0005"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Katja Seidel"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "badge no",
                                                            children: "Nein"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: "demo",
                        className: "lpv2-section lpv2-surface-2 lpv2-net-bg lpv2-net-right",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "lpv2-container lpv2-demo-grid",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                                    className: "lpv2-demo-aside",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: "F\xfcr wen wir da sind."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Speziell aus der Praxis entwickelt f\xfcr moderne WEG- & Hausverwaltungen, die sowohl digitale als auch analoge Eigent\xfcmer professionell bedienen m\xf6chten."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lpv2-pricing-note",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: "Faire Preise f\xfcr echte Herausforderungen in der Hausverwaltung"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        "Wir wissen, wie unterschiedlich die wirtschaftlichen Rahmenbedingungen in der Hausverwaltung sein k\xf6nnen. Genau deshalb entwickeln wir derzeit ein Pricing-Modell, das sich nicht nur an Funktionen orientiert, sondern an der Realit\xe4t Ihres Gesch\xe4fts. Unser Ziel ist es, eine L\xf6sung zu schaffen, die fair, nachvollziehbar und an Ihre Einnahmesituation angepasst ist.",
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Wir nehmen uns bewusst die Zeit, um ein Modell zu gestalten, das Sie langfristig unterst\xfctzt und nicht belastet."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    id: "preise",
                                    className: "lpv2-demo-form-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: "Demozugang anfragen"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                            ref: formRef,
                                            onSubmit: (event)=>{
                                                event.preventDefault();
                                                submitRequest("demo_access");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "lpv2-form-grid",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            children: [
                                                                "Vollst\xe4ndiger Name",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    name: "fullName",
                                                                    placeholder: "Vorname Nachname",
                                                                    required: true
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            children: [
                                                                "Firma / Verwaltung",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    name: "company",
                                                                    placeholder: "Ihre Verwaltung",
                                                                    required: true
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            children: [
                                                                "E-Mail Adresse",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    name: "email",
                                                                    type: "email",
                                                                    placeholder: "name@verwaltung.de",
                                                                    required: true
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            children: [
                                                                "Telefon",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    name: "phone",
                                                                    placeholder: "+49 ...",
                                                                    required: true
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "span2",
                                                            children: [
                                                                "Anzahl verwalteter Einheiten (Optional)",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    name: "managedUnits",
                                                                    defaultValue: "Bis 500 Einheiten",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            children: "Bis 500 Einheiten"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            children: "500 - 2.000 Einheiten"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            children: "\xdcber 2.000 Einheiten"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "span2",
                                                            children: [
                                                                "Ihre Nachricht (Optional)",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                                    name: "message",
                                                                    rows: 4,
                                                                    placeholder: "Wie k\xf6nnen wir Ihnen helfen?"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "lpv2-captcha-wrap",
                                                    children: captchaSiteKey ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        ref: captchaContainerRef
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "lpv2-captcha-missing",
                                                        children: [
                                                            "Captcha ist aktuell nicht konfiguriert. Direkter Kontakt: ",
                                                            targetEmail
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "lpv2-demo-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "submit",
                                                            className: "primary",
                                                            disabled: submitting,
                                                            children: submitting ? "Wird gesendet..." : "Demozugang anfragen"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            disabled: submitting,
                                                            onClick: ()=>{
                                                                submitRequest("personal_demo");
                                                            },
                                                            children: "Termin f\xfcr pers\xf6nliche Produktdemo"
                                                        })
                                                    ]
                                                }),
                                                formStatus.type !== "idle" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: `lpv2-demo-form-status ${formStatus.type}`,
                                                    children: formStatus.message
                                                }) : null,
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "Wir melden uns kurzfristig mit Testzugang und kurzer Einf\xfchrung."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
                className: "lpv2-footer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "lpv2-container lpv2-footer-inner",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                            className: "lpv2-footer-links",
                            "aria-label": "Rechtliche Links",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/impressum",
                                    children: "Impressum"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/datenschutz",
                                    children: "Datenschutz"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "lpv2-footer-copy",
                            children: [
                                "\xa9 ",
                                currentYear,
                                " Emig Immobilien"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};




const $d5b636cb7415b06d$export$8253a76bdc5f8ef6 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "lpv2-legal-wrap",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "lpv2-legal-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: "Impressum"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "lpv2-legal-lead",
                    children: "Anbieter dieser Website und der Beschluss-APP f\xfcr digitale Umlaufbeschl\xfcsse in WEG- und Hausverwaltungen."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Angaben gem\xe4\xdf \xa7 5 TMG"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "Emig Immobilien",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "An der Fahrt 13 | 55124 Mainz",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Deutschland"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Kontakt"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "E-Mail: ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "mailto:mail@derumlaufbeschluss.de",
                            children: "mail@derumlaufbeschluss.de"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Website: ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://www.derumlaufbeschluss.de",
                            children: "www.derumlaufbeschluss.de"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Inhalte des Angebots"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Die Website informiert \xfcber die Softwarel\xf6sung \u201EDer Umlaufbeschluss\u201C mit Funktionen f\xfcr Beschlusserstellung, Abstimmung, Auswertung, Dokumententransfer und Integrationen (u. a. Facilioo). \xdcber das Demoformular k\xf6nnen Interessenten Testzug\xe4nge oder eine pers\xf6nliche Produktdemo anfragen."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Haftung f\xfcr Inhalte"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Die Inhalte dieser Seiten werden mit gr\xf6\xdfter Sorgfalt erstellt. F\xfcr die Richtigkeit, Vollst\xe4ndigkeit und Aktualit\xe4t der Inhalte kann jedoch keine Gew\xe4hr \xfcbernommen werden."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Haftung f\xfcr Links"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Diese Website kann Links zu externen Websites Dritter enthalten. Auf deren Inhalte haben wir keinen Einfluss. F\xfcr die Inhalte verlinkter Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Urheberrecht"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Die auf dieser Website ver\xf6ffentlichten Inhalte, Grafiken und Werke unterliegen dem deutschen Urheberrecht. Vervielf\xe4ltigung, Bearbeitung oder Verbreitung bed\xfcrfen der vorherigen schriftlichen Zustimmung des Rechteinhabers."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "lpv2-legal-back",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: "Zur\xfcck zur Startseite"
                    })
                })
            ]
        })
    });
};




const $81931061bac6d688$export$797ef983e477b27f = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        className: "lpv2-legal-wrap",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "lpv2-legal-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: "Datenschutzerkl\xe4rung"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "lpv2-legal-lead",
                    children: "Diese Hinweise informieren \xfcber die Verarbeitung personenbezogener Daten auf der Website und im Demoanfrageprozess der Beschluss-APP."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "1. Verantwortlicher"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "Emig Immobilien",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "An der Fahrt 13 | 55124 Mainz",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "E-Mail: ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "mailto:mail@derumlaufbeschluss.de",
                            children: "mail@derumlaufbeschluss.de"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "2. Verarbeitete Daten bei Website-Nutzung"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Beim Aufruf der Website werden technisch erforderliche Zugriffsdaten verarbeitet (z. B. IP-Adresse, Datum und Uhrzeit, angefragte URL, Browser-Informationen), um die Website sicher und stabil bereitzustellen."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "3. Demoformular"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Bei Nutzung des Demoformulars verarbeiten wir die von Ihnen eingegebenen Daten (Name, Firma/Verwaltung, E-Mail, Telefonnummer, optionale Angaben und Nachricht), um Ihre Anfrage zu bearbeiten und mit Ihnen Kontakt aufzunehmen."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "4. Captcha-Schutz (Cloudflare Turnstile)"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Zum Schutz vor Spam und Missbrauch ist das Formular mit Cloudflare Turnstile abgesichert. Dabei k\xf6nnen personenbezogene Daten (u. a. IP-Adresse und technische Nutzungsdaten) an Cloudflare \xfcbermittelt werden. Rechtsgrundlage ist unser berechtigtes Interesse an der Absicherung des Formulars."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "5. E-Mail-Kommunikation"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "Demoanfragen werden an ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "mailto:mail@derumlaufbeschluss.de",
                            children: "mail@derumlaufbeschluss.de"
                        }),
                        " ",
                        "\xfcbermittelt und zur Bearbeitung der Anfrage genutzt."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "6. Speicherdauer"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Personenbezogene Daten werden nur so lange gespeichert, wie dies f\xfcr die Bearbeitung der Anfrage oder zur Erf\xfcllung gesetzlicher Aufbewahrungspflichten erforderlich ist."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "7. Ihre Rechte"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Sie haben das Recht auf Auskunft, Berichtigung, L\xf6schung, Einschr\xe4nkung der Verarbeitung, Daten\xfcbertragbarkeit sowie Widerspruch gegen die Verarbeitung. Zudem besteht ein Beschwerderecht bei einer Datenschutzaufsichtsbeh\xf6rde."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "8. Stand"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Stand: April 2026"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "lpv2-legal-back",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: "Zur\xfcck zur Startseite"
                    })
                })
            ]
        })
    });
};






const $170ec65a3e8911f8$var$areaTitle = (area)=>{
    if (area === "resolutions") return "Beschl\xfcsse";
    if (area === "objects") return "Objekte";
    if (area === "units") return "Einheiten";
    return "Eigent\xfcmer";
};
const $170ec65a3e8911f8$var$AreaIcon = ({ area: area })=>{
    if (area === "resolutions") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5",
                y: "4",
                width: "14",
                height: "16",
                rx: "2",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 9h8M8 13h8M8 17h5",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
    if (area === "objects") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 10 12 4l9 6v10H3z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 20v-6h6v6",
                stroke: "currentColor",
                strokeWidth: "1.8"
            })
        ]
    });
    if (area === "units") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 4h16v16H4z",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 4v16M4 12h16",
                stroke: "currentColor",
                strokeWidth: "1.8"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "8",
                r: "3.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 20a7 7 0 0 1 14 0",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
};
const $170ec65a3e8911f8$var$SearchTitleIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10.5",
                cy: "10.5",
                r: "5.7",
                stroke: "currentColor",
                strokeWidth: "1.9"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m15 15 4.2 4.2",
                stroke: "currentColor",
                strokeWidth: "1.9",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.1 10.5h4.8M10.5 8.1v4.8",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
const $170ec65a3e8911f8$export$3fd0742aeb2a9785 = ()=>{
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const query = String(searchParams.get("q") ?? "").trim();
    const { data: data, isFetching: isFetching } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            "global-search",
            query
        ],
        enabled: query.length >= 2,
        queryFn: async ()=>{
            const safe = async (promise)=>{
                try {
                    return await promise;
                } catch  {
                    return null;
                }
            };
            const [resolutionsRes, objectsRes, unitsRes, ownersRes] = await Promise.all([
                safe((0, $11320eb8d5d066e4$export$644d8ea042df96a6).resolutions({
                    page: 1,
                    pageSize: 50,
                    search: query
                })),
                safe((0, $11320eb8d5d066e4$export$644d8ea042df96a6).objects({
                    page: 1,
                    pageSize: 50,
                    search: query
                })),
                safe((0, $11320eb8d5d066e4$export$644d8ea042df96a6).units({
                    page: 1,
                    pageSize: 50,
                    search: query
                })),
                safe((0, $11320eb8d5d066e4$export$644d8ea042df96a6).owners({
                    page: 1,
                    pageSize: 50,
                    search: query
                }))
            ]);
            return {
                resolutions: resolutionsRes?.data ?? [],
                objects: objectsRes?.data ?? [],
                units: unitsRes?.data ?? [],
                owners: ownersRes?.data ?? [],
                totals: {
                    resolutions: Number(resolutionsRes?.meta?.total ?? 0),
                    objects: Number(objectsRes?.meta?.total ?? 0),
                    units: Number(unitsRes?.meta?.total ?? 0),
                    owners: Number(ownersRes?.meta?.total ?? 0)
                }
            };
        }
    });
    const sections = [
        {
            area: "resolutions",
            total: Number(data?.totals.resolutions ?? 0),
            rows: (data?.resolutions ?? []).map((row)=>({
                    id: row.id,
                    title: row.titel,
                    subtitle: `${row.beschlussnummer} \xb7 ${row.objektnummer}`,
                    href: `/resolutions/${row.id}`
                }))
        },
        {
            area: "objects",
            total: Number(data?.totals.objects ?? 0),
            rows: (data?.objects ?? []).map((row)=>({
                    id: row.id,
                    title: row.objektname,
                    subtitle: `${row.objektnummer} \xb7 ${row.strasse} ${row.plz} ${row.ort}`.trim(),
                    href: `/objects/${row.id}`
                }))
        },
        {
            area: "units",
            total: Number(data?.totals.units ?? 0),
            rows: (data?.units ?? []).map((row)=>({
                    id: row.id,
                    title: `${row.einheitsnummer} \xb7 ${row.bezeichnung}`,
                    subtitle: `${row.objektnummer} \xb7 ${row.einheitstyp}`,
                    href: `/units?search=${encodeURIComponent(row.einheitsnummer || row.bezeichnung)}`
                }))
        },
        {
            area: "owners",
            total: Number(data?.totals.owners ?? 0),
            rows: (data?.owners ?? []).map((row)=>({
                    id: row.id,
                    title: row.vollname || row.eigentuemer_id,
                    subtitle: `${row.eigentuemer_id} \xb7 ${row.objektnummer}`,
                    href: `/owners?search=${encodeURIComponent(row.eigentuemer_id || row.vollname)}`
                }))
        }
    ];
    const totalHits = sections.reduce((sum, section)=>sum + section.total, 0);
    const hasSearchTerm = query.length >= 2;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "global-search-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "page-header panel resolutions-v2-page-header global-search-v2-header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    className: "resolutions-v2-title",
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "resolutions-v2-title-icon",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($170ec65a3e8911f8$var$SearchTitleIcon, {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "resolutions-v2-title-copy",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-main",
                                    children: "Suchergebnisse"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "resolutions-v2-title-sub",
                                    children: "Globale Suche \xfcber Beschl\xfcsse, Objekte, Einheiten und Eigent\xfcmer"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "panel global-search-results-panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "global-search-summary",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "global-search-eyebrow",
                                        children: "Suche"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: hasSearchTerm ? `"${query}"` : "Mindestens 2 Zeichen eingeben"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `global-search-status${isFetching ? " is-loading" : ""}`,
                                children: isFetching ? "Suche l\xe4uft..." : hasSearchTerm ? `${totalHits} Treffer gesamt` : "Bereit"
                            })
                        ]
                    }),
                    hasSearchTerm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "global-search-section-grid",
                        children: sections.map((section)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "global-search-section",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "global-search-section-title",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "global-search-section-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($170ec65a3e8911f8$var$AreaIcon, {
                                                            area: section.area
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: $170ec65a3e8911f8$var$areaTitle(section.area)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "global-search-section-count",
                                                children: section.total
                                            })
                                        ]
                                    }),
                                    section.rows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "global-search-empty",
                                        children: "Keine Treffer in diesem Bereich."
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "global-search-list",
                                        children: section.rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: row.href,
                                                className: "global-search-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: row.title
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: row.subtitle
                                                    })
                                                ]
                                            }, `${section.area}-${row.id}`))
                                    })
                                ]
                            }, section.area))
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "global-search-empty-state",
                        children: "Bitte geben Sie oben in der Suche mindestens 2 Zeichen ein."
                    })
                ]
            })
        ]
    });
};








var $d13d68576b159df9$import_meta = Object.assign(Object.create(null), {
    url: "file:///src/app/App.tsx"
});
const $d13d68576b159df9$var$persistedSettingsFingerprint = (value)=>{
    const { settingsUpdatedAt: _settingsUpdatedAt, ...settingsWithoutRevision } = value;
    return JSON.stringify(settingsWithoutRevision);
};
const $d13d68576b159df9$export$86fbec116b87613f = ()=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [settings, setSettings] = (0, $acw62.useState)(()=>(0, $5806306cf67ca7cd$export$cc8e577c185b57cb)());
    const [settingsHydrated, setSettingsHydrated] = (0, $acw62.useState)(false);
    const [settingsSaveStatus, setSettingsSaveStatus] = (0, $acw62.useState)(null);
    const lastPersistedSettingsRef = (0, $acw62.useRef)(null);
    const [authLoading, setAuthLoading] = (0, $acw62.useState)(true);
    const [authUser, setAuthUser] = (0, $acw62.useState)(null);
    const [authServerError, setAuthServerError] = (0, $acw62.useState)(null);
    const [authRetryNonce, setAuthRetryNonce] = (0, $acw62.useState)(0);
    const [mobileNavOpen, setMobileNavOpen] = (0, $acw62.useState)(false);
    const [faciliooSyncBadge, setFaciliooSyncBadge] = (0, $acw62.useState)(null);
    const [tenantTrialStatus, setTenantTrialStatus] = (0, $acw62.useState)(null);
    const [tenantSlug, setTenantSlug] = (0, $acw62.useState)("default");
    const [hostSlug, setHostSlug] = (0, $acw62.useState)("default");
    const isFetchingCount = (0, $f78c06b0b10efbae$export$625b2ff71316bcd3)({
        predicate: (query)=>query.isActive()
    });
    const [globalFetchLoaderVisible, setGlobalFetchLoaderVisible] = (0, $acw62.useState)(false);
    const vitePlatformAliases = $d13d68576b159df9$import_meta.env?.VITE_PLATFORM_TENANT_ALIASES ?? "plattform,platform";
    const platformTenantAliases = new Set(String(vitePlatformAliases).split(",").map((entry)=>entry.trim().toLowerCase()).filter(Boolean));
    (0, $acw62.useEffect)(()=>{
        (0, $5806306cf67ca7cd$export$4a377ad1c9fa8e6a)(settings);
    }, [
        settings
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleUiSettingsUpdated = ()=>{
            setSettings((0, $5806306cf67ca7cd$export$cc8e577c185b57cb)());
        };
        window.addEventListener("ui-settings-updated", handleUiSettingsUpdated);
        return ()=>{
            window.removeEventListener("ui-settings-updated", handleUiSettingsUpdated);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const host = window.location.hostname.toLowerCase();
        setTenantSlug((0, $09f591baab63073a$export$9af4e01f9c0573c0)(host));
        setHostSlug((0, $09f591baab63073a$export$71e583b5d309e488)(host));
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $7da634ecebe13da7$export$88022c82616459fa)(settings.management.uiFramework === "mockup_v2" ? "mockup_v2" : "classic");
    }, [
        settings.management.uiFramework
    ]);
    (0, $acw62.useEffect)(()=>{
        let showTimer = null;
        let hideTimer = null;
        if (isFetchingCount > 0) showTimer = window.setTimeout(()=>{
            setGlobalFetchLoaderVisible(true);
        }, 120);
        else hideTimer = window.setTimeout(()=>{
            setGlobalFetchLoaderVisible(false);
        }, 80);
        return ()=>{
            if (showTimer) window.clearTimeout(showTimer);
            if (hideTimer) window.clearTimeout(hideTimer);
        };
    }, [
        isFetchingCount
    ]);
    const platformPortalAliasesRaw = $d13d68576b159df9$import_meta.env?.VITE_PLATFORM_PORTAL_ALIASES ?? "plattform,platform";
    const platformPortalAliases = new Set(String(platformPortalAliasesRaw).split(",").map((entry)=>entry.trim().toLowerCase()).filter(Boolean));
    const landingHostsRaw = $d13d68576b159df9$import_meta.env?.VITE_PUBLIC_LANDING_HOSTS ?? "www.derumlaufbeschluss.de,localhost,127.0.0.1";
    const landingHosts = new Set(String(landingHostsRaw).split(",").map((entry)=>entry.trim().toLowerCase()).filter(Boolean));
    const currentHost = window.location.hostname.toLowerCase();
    const isLandingHost = landingHosts.has(currentHost);
    const isPlatformPortalHost = platformPortalAliases.has(hostSlug);
    const isOwnerArea = location.pathname.startsWith("/owner-login") || location.pathname.startsWith("/owner-vote/");
    (0, $acw62.useEffect)(()=>{
        if (!authUser || isOwnerArea) return;
        if (isPlatformPortalHost) {
            document.title = "ObjektVote | Plattform";
            return;
        }
        const tenantLabel = String(settings.management.firmenname || tenantSlug || "Mandant").trim();
        document.title = `ObjektVote | ${tenantLabel}`;
    }, [
        authUser,
        isOwnerArea,
        isPlatformPortalHost,
        settings.management.firmenname,
        tenantSlug
    ]);
    (0, $acw62.useEffect)(()=>{
        let active = true;
        const token = (0, $401da7136ebd564e$export$38e1f53b76ec7fed)();
        if (!token || isOwnerArea) {
            setSettingsHydrated(false);
            return;
        }
        setSettingsHydrated(false);
        (0, $11320eb8d5d066e4$export$644d8ea042df96a6).uiSettings().then((remote)=>{
            if (!active) return;
            const next = {
                ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db),
                ...remote,
                management: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).management,
                    ...remote.management ?? {}
                },
                mail: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).mail,
                    ...remote.mail ?? {}
                },
                reminders: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).reminders,
                    ...remote.reminders ?? {}
                },
                theme: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).theme,
                    ...remote.theme ?? {}
                },
                ownerTheme: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).ownerTheme,
                    ...remote.ownerTheme ?? {}
                }
            };
            lastPersistedSettingsRef.current = $d13d68576b159df9$var$persistedSettingsFingerprint(next);
            setSettings(next);
            (0, $5806306cf67ca7cd$export$4a377ad1c9fa8e6a)(next);
        }).catch(()=>undefined).finally(()=>{
            if (active) setSettingsHydrated(true);
        });
        return ()=>{
            active = false;
        };
    }, [
        authUser?.id,
        isOwnerArea,
        tenantSlug
    ]);
    (0, $acw62.useEffect)(()=>{
        setMobileNavOpen(false);
    }, [
        location.pathname
    ]);
    (0, $acw62.useEffect)(()=>{
        let active = true;
        let timer = null;
        const loadSyncBadge = async ()=>{
            if (typeof document !== "undefined" && document.visibilityState !== "visible") return;
            if (settings.management.faciliooEnabled === false || !settings.management.faciliooLiveSyncEnabled) {
                if (active) setFaciliooSyncBadge(null);
                return;
            }
            try {
                const status = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getFaciliooSyncStatus();
                if (!active) return;
                if (!status.enabled) {
                    setFaciliooSyncBadge(null);
                    return;
                }
                if (status.running) {
                    setFaciliooSyncBadge({
                        tone: "ok",
                        label: "live"
                    });
                    return;
                }
                const hasError = status.lastRun?.ok === false;
                setFaciliooSyncBadge({
                    tone: hasError ? "error" : "ok",
                    label: hasError ? "Live-Sync Fehler" : "live"
                });
            } catch  {
                if (!active) return;
                setFaciliooSyncBadge({
                    tone: "error",
                    label: "Live-Sync Fehler"
                });
            }
        };
        loadSyncBadge();
        timer = window.setInterval(()=>{
            loadSyncBadge();
        }, 120000);
        const onVisible = ()=>{
            if (document.visibilityState === "visible") loadSyncBadge();
        };
        document.addEventListener("visibilitychange", onVisible);
        return ()=>{
            active = false;
            if (timer) window.clearInterval(timer);
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, [
        settings.management.faciliooEnabled,
        settings.management.faciliooLiveSyncEnabled
    ]);
    (0, $acw62.useEffect)(()=>{
        let active = true;
        const token = (0, $401da7136ebd564e$export$38e1f53b76ec7fed)();
        if (!token) {
            setTenantTrialStatus(null);
            return;
        }
        const loadTenantTrial = async ()=>{
            try {
                const trial = await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).getTenantTrialStatus();
                if (!active) return;
                setTenantTrialStatus(trial);
            } catch  {
                if (!active) return;
                setTenantTrialStatus(null);
            }
        };
        loadTenantTrial();
        return ()=>{
            active = false;
        };
    }, [
        authUser?.id,
        tenantSlug
    ]);
    (0, $acw62.useEffect)(()=>{
        let active = true;
        let timer = null;
        const token = (0, $401da7136ebd564e$export$38e1f53b76ec7fed)();
        if (!token || !authUser || isOwnerArea) return;
        const sendHeartbeat = async ()=>{
            try {
                await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).adminHeartbeat();
            } catch (error) {
                if (!active) return;
                const message = error instanceof Error ? error.message : "";
                const isAuthError = /\bAPI (401|403)\b/.test(message);
                if (isAuthError) {
                    (0, $401da7136ebd564e$export$df5ba283a82ad80a)();
                    setAuthUser(null);
                    navigate("/admin-login", {
                        replace: true,
                        state: {
                            sessionExpired: true
                        }
                    });
                }
            }
        };
        sendHeartbeat();
        timer = window.setInterval(()=>{
            sendHeartbeat();
        }, 60000);
        const onVisible = ()=>{
            if (document.visibilityState === "visible") sendHeartbeat();
        };
        document.addEventListener("visibilitychange", onVisible);
        return ()=>{
            active = false;
            if (timer) window.clearInterval(timer);
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, [
        authUser?.id,
        isOwnerArea,
        navigate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!settingsHydrated) return;
        if (!(0, $401da7136ebd564e$export$38e1f53b76ec7fed)()) return;
        const fingerprint = $d13d68576b159df9$var$persistedSettingsFingerprint(settings);
        if (lastPersistedSettingsRef.current === fingerprint) return;
        (0, $11320eb8d5d066e4$export$644d8ea042df96a6).saveUiSettings(settings).then((saved)=>{
            const next = {
                ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db),
                ...saved,
                management: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).management,
                    ...saved.management ?? {}
                },
                mail: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).mail,
                    ...saved.mail ?? {}
                },
                reminders: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).reminders,
                    ...saved.reminders ?? {}
                },
                theme: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).theme,
                    ...saved.theme ?? {}
                },
                ownerTheme: {
                    ...(0, $5806306cf67ca7cd$export$b22b9e406c4481db).ownerTheme,
                    ...saved.ownerTheme ?? {}
                }
            };
            lastPersistedSettingsRef.current = $d13d68576b159df9$var$persistedSettingsFingerprint(next);
            setSettings(next);
            setSettingsSaveStatus({
                type: "ok",
                text: "Einstellungen gespeichert."
            });
            window.setTimeout(()=>setSettingsSaveStatus(null), 2500);
        }).catch((error)=>{
            const message = error instanceof Error ? error.message : "Einstellungen konnten nicht gespeichert werden.";
            setSettingsSaveStatus({
                type: "info",
                text: message
            });
        });
    }, [
        settings,
        settingsHydrated
    ]);
    (0, $acw62.useEffect)(()=>{
        const root = document.documentElement;
        root.style.setProperty("--bg", settings.theme.bg);
        root.style.setProperty("--surface", settings.theme.surface);
        root.style.setProperty("--header-bg", settings.theme.headerBg);
        root.style.setProperty("--line", settings.theme.line);
        root.style.setProperty("--text", settings.theme.text);
        root.style.setProperty("--primary", settings.theme.primary);
        root.style.setProperty("--list-header-bg", settings.theme.listHeaderBg);
        root.style.setProperty("--list-alternate-row-bg", settings.theme.listAlternateRowBg);
        root.style.setProperty("--page-gradient-from", settings.theme.gradientFrom);
        root.style.setProperty("--page-gradient-to", settings.theme.gradientTo);
        root.style.setProperty("--page-gradient-enabled", settings.theme.gradientEnabled ? "1" : "0");
        root.style.setProperty("--page-gradient-strength", settings.theme.gradientEnabled ? "100%" : "0%");
        root.style.setProperty("--nav-bg", settings.theme.navBg);
        root.style.setProperty("--nav-text", settings.theme.navText);
        root.style.setProperty("--nav-active", settings.theme.navActive);
        root.style.setProperty("--nav-active-text", settings.theme.navActiveText);
        root.style.setProperty("--nav-border", settings.theme.navBorder);
    }, [
        settings.theme
    ]);
    (0, $acw62.useEffect)(()=>{
        let active = true;
        const token = (0, $401da7136ebd564e$export$38e1f53b76ec7fed)();
        if (!token) {
            setAuthLoading(false);
            setAuthUser(null);
            setAuthServerError(null);
            return;
        }
        setAuthLoading(true);
        setAuthServerError(null);
        (0, $11320eb8d5d066e4$export$644d8ea042df96a6).adminMe().then((res)=>{
            if (!active) return;
            setAuthUser(res.user ?? null);
            setAuthServerError(null);
        }).catch((error)=>{
            if (!active) return;
            const message = error instanceof Error ? error.message : "";
            const isAuthError = /\bAPI (401|403)\b/.test(message);
            if (isAuthError) {
                (0, $401da7136ebd564e$export$df5ba283a82ad80a)();
                setAuthUser(null);
                setAuthServerError(null);
                navigate("/admin-login", {
                    replace: true,
                    state: {
                        sessionExpired: true
                    }
                });
                return;
            }
            // Bei 5xx / Netzwerkproblemen Session behalten und Retry anbieten.
            setAuthUser(null);
            setAuthServerError("Server aktuell nicht erreichbar. Bitte erneut versuchen.");
        }).finally(()=>{
            if (active) setAuthLoading(false);
        });
        return ()=>{
            active = false;
        };
    }, [
        authRetryNonce,
        navigate
    ]);
    const demoTrialBadgeLabel = tenantTrialStatus?.enabled && tenantTrialStatus.running ? `Demo: noch ${Math.max(0, Number(tenantTrialStatus.remainingDays ?? 0))} Tag${Math.max(0, Number(tenantTrialStatus.remainingDays ?? 0)) === 1 ? "" : "e"}` : null;
    const hasPermission = (key)=>authUser?.permissions?.[key] !== false;
    const firstAllowedPath = (()=>{
        const candidates = [
            {
                path: "/",
                key: "dashboard"
            },
            {
                path: "/resolutions",
                key: "resolutions"
            },
            {
                path: "/objects",
                key: "objects"
            },
            {
                path: "/units",
                key: "units"
            },
            {
                path: "/owners",
                key: "owners"
            },
            {
                path: "/assignments",
                key: "assignments"
            },
            {
                path: "/imports",
                key: "imports"
            },
            {
                path: "/templates",
                key: "templates"
            },
            {
                path: "/settings",
                key: "settings"
            },
            {
                path: "/admin-users",
                key: "admin_users"
            },
            {
                path: "/platform-tenants",
                key: "platform_tenants"
            },
            {
                path: "/audit",
                key: "audit"
            },
            {
                path: "/debug",
                key: "debug"
            }
        ];
        const first = candidates.find((entry)=>hasPermission(entry.key));
        return first?.path ?? "/settings";
    })();
    const showPlatformMenu = hasPermission("platform_tenants") && (isPlatformPortalHost || platformTenantAliases.has(tenantSlug));
    const isFrameworkV2 = settings.management.uiFramework === "mockup_v2";
    const showGlobalFetchLoader = !!authUser && !authLoading && globalFetchLoaderVisible && isFrameworkV2;
    const guardPlatformOnly = (element)=>isPlatformPortalHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
            to: "/platform-tenants",
            replace: true
        }) : element;
    const guardPermission = (permissionKey, element)=>hasPermission(permissionKey) ? element : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
            to: firstAllowedPath,
            replace: true
        });
    if (isOwnerArea) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/owner-login",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38498fd0c4d2b7b0$export$50ac8e7e243eb1ae), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/owner-vote/:token",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d728b52521bfced6$export$546d357990387156), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                    to: "/owner-login",
                    replace: true
                })
            })
        ]
    });
    if (authLoading) {
        if (settings.management.uiFramework === "mockup_v2") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "v2-global-fetch-loader v2-global-fetch-loader-auth",
            "aria-live": "polite",
            "aria-label": "Seite l\xe4dt",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v2-global-fetch-loader-ring",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "v2-global-fetch-loader-dot",
                        style: {
                            "--i": 0
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "v2-global-fetch-loader-dot",
                        style: {
                            "--i": 1
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "v2-global-fetch-loader-dot",
                        style: {
                            "--i": 2
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "v2-global-fetch-loader-dot",
                        style: {
                            "--i": 3
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "v2-global-fetch-loader-dot",
                        style: {
                            "--i": 4
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "v2-global-fetch-loader-dot",
                        style: {
                            "--i": 5
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "v2-global-fetch-loader-dot",
                        style: {
                            "--i": 6
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "v2-global-fetch-loader-dot",
                        style: {
                            "--i": 7
                        }
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                minHeight: "100vh",
                display: "grid",
                placeItems: "center"
            },
            children: "Lade Anmeldung..."
        });
    }
    if (!authUser) {
        if ((0, $401da7136ebd564e$export$38e1f53b76ec7fed)()) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "backend-check-page",
            style: {
                "--backend-check-bg": `url(${(0, {})})`
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "backend-check-card",
                    "aria-live": "polite",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "backend-check-icon",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                viewBox: "0 0 64 64",
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M21.5 45.5H20a11 11 0 1 1 2.6-21.7 14.5 14.5 0 0 1 27.9 5.5A8.8 8.8 0 0 1 49 46h-3.5",
                                        stroke: "currentColor",
                                        strokeWidth: "4",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M32 27v12",
                                        stroke: "currentColor",
                                        strokeWidth: "4",
                                        strokeLinecap: "round"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: "32",
                                        cy: "48",
                                        r: "2.6",
                                        fill: "currentColor"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "Verbindung zum Backend pr\xfcfen"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Der Server ist derzeit nicht erreichbar."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Bitte versuchen Sie es in wenigen Momenten erneut."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "backend-check-divider",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "backend-check-actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    className: "backend-check-primary",
                                    onClick: ()=>setAuthRetryNonce((v)=>v + 1),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M15.4 7.2A5.8 5.8 0 1 0 16 10M15.4 4.5v2.7h-2.7",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        "Erneut versuchen"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    className: "backend-check-secondary",
                                    onClick: ()=>{
                                        (0, $401da7136ebd564e$export$df5ba283a82ad80a)();
                                        setAuthServerError(null);
                                        setAuthUser(null);
                                        navigate("/admin-login", {
                                            replace: true
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M8 4.5H5.8A1.8 1.8 0 0 0 4 6.3v7.4a1.8 1.8 0 0 0 1.8 1.8H8M12 6.5l3.5 3.5-3.5 3.5M15 10H8",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        "Abmelden"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "backend-check-support",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                            viewBox: "0 0 20 20",
                            fill: "none",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M4 11.5V9.7a6 6 0 0 1 12 0v1.8M4 11.5h2.4v4H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1ZM16 11.5h-2.4v4H16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM13.6 15.5c-.6 1-1.7 1.5-3.6 1.5",
                                stroke: "currentColor",
                                strokeWidth: "1.7",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Bei anhaltenden Problemen kontaktieren Sie bitte den ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "mailto:support@derumlaufbeschluss.de",
                                    children: "Support"
                                }),
                                "."
                            ]
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: isLandingHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f216bfa0510b464b$export$355f3d6a1f8b250c), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                        to: "/admin-login",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/landing",
                    element: isLandingHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f216bfa0510b464b$export$355f3d6a1f8b250c), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                        to: "/admin-login",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/impressum",
                    element: isLandingHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d5b636cb7415b06d$export$8253a76bdc5f8ef6), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                        to: "/admin-login",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/datenschutz",
                    element: isLandingHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81931061bac6d688$export$797ef983e477b27f), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                        to: "/admin-login",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/admin-login",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $848792da5fb8ad08$export$482fd5473c8a16ac), {
                        onAuthenticated: setAuthUser
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                        to: location.pathname.startsWith("/admin-login") || !isLandingHost ? "/admin-login" : "/",
                        state: {
                            from: location.pathname
                        },
                        replace: true
                    })
                })
            ]
        });
    }
    const handleLogout = async ()=>{
        try {
            await (0, $11320eb8d5d066e4$export$644d8ea042df96a6).adminLogout();
        } catch  {
        // ignore
        }
        (0, $401da7136ebd564e$export$df5ba283a82ad80a)();
        setAuthUser(null);
        navigate("/admin-login", {
            replace: true
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-shell",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b44d252db018a0f5$export$1ba59dacbcbf90fe), {
                mode: "desktop",
                navBg: settings.theme.navBg,
                frameworkMode: settings.management.uiFramework,
                authUser: authUser,
                onLogout: handleLogout,
                showPlatformMenu: showPlatformMenu,
                platformOnlyMode: isPlatformPortalHost,
                permissions: authUser.permissions
            }),
            mobileNavOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mobile-nav-overlay open",
                onClick: ()=>setMobileNavOpen(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mobile-nav-panel",
                    onClick: (e)=>e.stopPropagation(),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b44d252db018a0f5$export$1ba59dacbcbf90fe), {
                        mode: "mobile",
                        navBg: settings.theme.navBg,
                        frameworkMode: settings.management.uiFramework,
                        authUser: authUser,
                        onLogout: handleLogout,
                        showPlatformMenu: showPlatformMenu,
                        platformOnlyMode: isPlatformPortalHost,
                        permissions: authUser.permissions,
                        onNavigate: ()=>setMobileNavOpen(false),
                        onClose: ()=>setMobileNavOpen(false)
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "main-area",
                children: [
                    showGlobalFetchLoader ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "v2-global-fetch-loader",
                        "aria-live": "polite",
                        "aria-label": "Seite l\xe4dt",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "v2-global-fetch-loader-ring",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "v2-global-fetch-loader-dot",
                                    style: {
                                        "--i": 0
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "v2-global-fetch-loader-dot",
                                    style: {
                                        "--i": 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "v2-global-fetch-loader-dot",
                                    style: {
                                        "--i": 2
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "v2-global-fetch-loader-dot",
                                    style: {
                                        "--i": 3
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "v2-global-fetch-loader-dot",
                                    style: {
                                        "--i": 4
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "v2-global-fetch-loader-dot",
                                    style: {
                                        "--i": 5
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "v2-global-fetch-loader-dot",
                                    style: {
                                        "--i": 6
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "v2-global-fetch-loader-dot",
                                    style: {
                                        "--i": 7
                                    }
                                })
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ac43062ea7242e7$export$1ca1e38143dcc152), {
                        settings: settings,
                        authUser: authUser,
                        faciliooSyncBadge: isPlatformPortalHost ? null : settings.management.faciliooEnabled !== false && settings.management.faciliooLiveSyncEnabled ? faciliooSyncBadge : null,
                        demoTrialBadgeLabel: demoTrialBadgeLabel,
                        onLogout: handleLogout,
                        onOpenMenu: ()=>setMobileNavOpen(true)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "content",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/",
                                    element: hasPermission("dashboard") ? isPlatformPortalHost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                        to: "/platform-tenants",
                                        replace: true
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $848f7c387707f0c9$export$fedd53519a0e2bce), {
                                        authUser: authUser
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                        to: firstAllowedPath,
                                        replace: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/objects",
                                    element: guardPermission("objects", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58e497c17bb81d81$export$d0dbe21c1273a9ae), {
                                        canCreate: hasPermission("objects_create"),
                                        canUpdate: hasPermission("objects_update"),
                                        canDelete: hasPermission("objects_delete")
                                    })))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/objects/:id",
                                    element: guardPermission("objects", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d54f4a7473082e4a$export$de94004b3a43d77c), {
                                        canManageMasterDataActions: hasPermission("objects_create") || hasPermission("objects_update") || hasPermission("objects_delete") || hasPermission("units_create") || hasPermission("units_update") || hasPermission("units_delete") || hasPermission("owners_create") || hasPermission("owners_update") || hasPermission("owners_delete") || hasPermission("assignments_create") || hasPermission("assignments_update") || hasPermission("assignments_delete") || hasPermission("resolutions_update") || hasPermission("resolutions_delete"),
                                        canCreateResolutions: hasPermission("resolutions_create")
                                    })))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/units",
                                    element: guardPermission("units", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $811a329b29e8a5d6$export$d00028a8a5a54d8b), {
                                        canCreate: hasPermission("units_create"),
                                        canUpdate: hasPermission("units_update"),
                                        canDelete: hasPermission("units_delete")
                                    })))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/owners",
                                    element: guardPermission("owners", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f252d990203a12d3$export$230e90f41af31f4f), {
                                        canCreate: hasPermission("owners_create"),
                                        canUpdate: hasPermission("owners_update"),
                                        canDelete: hasPermission("owners_delete")
                                    })))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/assignments",
                                    element: guardPermission("assignments", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dea51850bf332cc$export$3d409ad957894c8e), {
                                        canCreate: hasPermission("assignments_create"),
                                        canUpdate: hasPermission("assignments_update"),
                                        canDelete: hasPermission("assignments_delete")
                                    })))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/imports",
                                    element: guardPermission("imports", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bf5538ea9b06aa2$export$f02d1ece1b89c647), {})))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/resolutions",
                                    element: guardPermission("resolutions", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca55c84b1bbe2a8d$export$db608687e7fe74cc), {
                                        canManageMasterDataActions: hasPermission("resolutions_create") || hasPermission("resolutions_update") || hasPermission("resolutions_delete"),
                                        canCreateResolutions: hasPermission("resolutions_create"),
                                        canEditResolutions: hasPermission("resolutions_update"),
                                        canDeleteResolutions: hasPermission("resolutions_delete"),
                                        canDeleteCompletedResolutions: hasPermission("resolutions_delete_completed")
                                    })))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/resolutions/:id",
                                    element: guardPermission("resolutions", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $845661e1cd923dd3$export$e24676f9cd8ae6eb), {
                                        canManageMasterDataActions: hasPermission("resolutions_update") || hasPermission("resolutions_delete")
                                    })))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/analog-scan",
                                    element: guardPermission("qr_scan", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1acc214bd4b3153$export$8774c44f3870fe7b), {})))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/analog-scan/:token",
                                    element: guardPermission("qr_scan", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1acc214bd4b3153$export$8774c44f3870fe7b), {})))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/audit",
                                    element: guardPermission("audit", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa5cd7096308004a$export$85b22fb52492fe14), {})))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/debug",
                                    element: guardPermission("debug", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35849a2ba082badf$export$a85d3c0b6e100dd4), {})))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/templates",
                                    element: guardPermission("templates", guardPlatformOnly(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d1021dcf01c81de6$export$f79f9e578a3122a7), {})))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/search",
                                    element: guardPlatformOnly(hasPermission("resolutions") || hasPermission("objects") || hasPermission("units") || hasPermission("owners") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $170ec65a3e8911f8$export$3fd0742aeb2a9785), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                        to: firstAllowedPath,
                                        replace: true
                                    }))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/settings",
                                    element: isPlatformPortalHost && !showPlatformMenu ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                        to: "/admin-login",
                                        replace: true
                                    }) : guardPermission("settings", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfa3ec47cc17e8e8$export$8f6dcfe950367406), {
                                        settings: settings,
                                        onChange: setSettings,
                                        authUser: authUser,
                                        saveStatus: settingsSaveStatus
                                    }))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/admin-users",
                                    element: isPlatformPortalHost && !showPlatformMenu ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                        to: "/admin-login",
                                        replace: true
                                    }) : guardPermission("admin_users", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99bbb276306e7658$export$ed6b2746b35e124), {
                                        authUser: authUser
                                    }))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/platform-tenants",
                                    element: showPlatformMenu ? guardPermission("platform_tenants", /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fab90a5e7e3c87fa$export$67ded7da315e2d87), {})) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                        to: isPlatformPortalHost ? "/settings" : "/",
                                        replace: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/landing",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                        to: "/",
                                        replace: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                        to: "/",
                                        replace: true
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};




const $a88ea9323d3a23c8$var$queryClient = new (0, $f71a9ec256bb1e8c$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            staleTime: 60000,
            gcTime: 1800000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: 1
        }
    }
});
const $a88ea9323d3a23c8$var$rootEl = document.getElementById("root");
if (!$a88ea9323d3a23c8$var$rootEl) throw new Error("Root-Element #root nicht gefunden");
(0, $7e96a608cb33bf79$export$882461b6382ed46c)($a88ea9323d3a23c8$var$rootEl).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aeeeb04cd6721116$export$45604f0cc8ae667b), {
        client: $a88ea9323d3a23c8$var$queryClient,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d13d68576b159df9$export$86fbec116b87613f), {})
        })
    })
}));


//# sourceMappingURL=frontend.988d906c.js.map
